export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  Decimal: { input: number; output: number; }
  Flags: { input: Record<string, boolean>; output: Record<string, boolean>; }
  JSON: { input: Json; output: Json; }
  Text: { input: string; output: string; }
  Time: { input: number; output: number; }
};

/** Autogenerated input type of AcceptClientTerms */
export type AcceptClientTermsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type ActionInputType = {
  actionType: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['Int']['input']>;
  tagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ActionPaginationHandler = {
  __typename?: 'ActionPaginationHandler';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  offset: Scalars['Int']['output'];
  records: Array<RootTaskAction>;
};

/** Autogenerated input type of AddRestaurantToGroup */
export type AddRestaurantToGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantGroupId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of AddStagedRecord */
export type AddStagedRecordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  liveDomainId: Scalars['Int']['input'];
  stagedRecordInput: LiveDomainStagedRecordInput;
};

export type AddonCheckoutAddonInput = {
  billingPlanId: Scalars['Int']['input'];
  locationId?: InputMaybe<Array<Scalars['Int']['input']>>;
  quantity: Scalars['Int']['input'];
};

export type AddonCheckoutLocationPurchase = {
  __typename?: 'AddonCheckoutLocationPurchase';
  billingCustomerId?: Maybe<Scalars['Int']['output']>;
  billingSubscriptionId?: Maybe<Scalars['Int']['output']>;
  locationId?: Maybe<Scalars['Int']['output']>;
  locationSlug?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  reviewState?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type AddonCheckoutLocationPurchaseLocationInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  streetAddress: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};

export type AddonCheckoutLocationPurchasePaymentInput = {
  gocardlessCustomerId?: InputMaybe<Scalars['String']['input']>;
  gocardlessMandateId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodType?: InputMaybe<Scalars['String']['input']>;
  stripeToken?: InputMaybe<Scalars['String']['input']>;
};

export type Address = {
  __typename?: 'Address';
  address: LocationAddress;
  business?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  expectedDeliveryDaysRegion?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  mailerContactName?: InputMaybe<Scalars['String']['input']>;
};

export type AdvancedFormEntry = {
  __typename?: 'AdvancedFormEntry';
  advancedForm?: Maybe<CustomPageAdvancedForm>;
  answers?: Maybe<Array<AdvancedFormEntryAnswer>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  formData?: Maybe<Array<Scalars['String']['output']>>;
  formName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isBlocked?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type AdvancedFormEntryAnswer = {
  __typename?: 'AdvancedFormEntryAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  fieldType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

export type AdvancedFormEntryInput = {
  /** Advanced Form Entry - notes Type */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Advanced Form Entry - status Type */
  status: Scalars['String']['input'];
};

export type AdvisorCardTracker = {
  __typename?: 'AdvisorCardTracker';
  descriptionContent: Scalars['String']['output'];
  headingContent: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isCompleted: Scalars['Boolean']['output'];
  isDelayed: Scalars['Boolean']['output'];
  link: Scalars['String']['output'];
  rootAdvisorCard: RootAdvisorCard;
};

export type AgentChat = {
  __typename?: 'AgentChat';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isProcessing: Scalars['Boolean']['output'];
  lastMessageAt?: Maybe<Scalars['DateTime']['output']>;
  messages: Array<AgentChatMessage>;
  restaurant: Restaurant;
  slug: Scalars['String']['output'];
};

export type AgentChatMessage = {
  __typename?: 'AgentChatMessage';
  agentChat: AgentChat;
  content?: Maybe<Scalars['String']['output']>;
  friendlyToolDescription?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  messageAt: Scalars['DateTime']['output'];
  role: Scalars['String']['output'];
};

export type AggregateCommunicationReport = {
  __typename?: 'AggregateCommunicationReport';
  conciergeGoal?: Maybe<RestaurantConciergeGoal>;
  firstGoogleAnalyticsReportDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  lastGooglePostAt?: Maybe<Scalars['DateTime']['output']>;
  lastMessageAt?: Maybe<Scalars['DateTime']['output']>;
  lastSocialPostAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  socialAccounts?: Maybe<Array<SocialAccount>>;
  status: Scalars['String']['output'];
  totalGooglePosts?: Maybe<Scalars['Int']['output']>;
  totalMessages?: Maybe<Scalars['Int']['output']>;
  totalSocialPosts?: Maybe<Scalars['Int']['output']>;
};

export type AggregateMessageCampaign = {
  __typename?: 'AggregateMessageCampaign';
  clickedMessagesCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  messagesCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  openedMessagesCount: Scalars['Int']['output'];
};

export type AggregateReport = {
  __typename?: 'AggregateReport';
  aggregateCityReport: Array<AggregateReportDay>;
  aggregateCommunicationReports: Array<AggregateCommunicationReport>;
  aggregateMessageCampaigns: Array<AggregateMessageCampaign>;
  aggregateReportDays: Array<AggregateReportDay>;
  id: Scalars['String']['output'];
  messageGroups: Array<MessageGroup>;
};

export type AggregateReportDay = {
  __typename?: 'AggregateReportDay';
  reportDate: Scalars['DateTime']['output'];
  restaurantsCount: Scalars['Int']['output'];
  subject: Scalars['String']['output'];
  totalNewUsers: Scalars['Int']['output'];
  totalPageViews: Scalars['Int']['output'];
  totalSessions: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
};

/** Content types for AI marketing */
export type AiMarketable = CalendarEvent | Dish | MenuItem | OrderingEvent | OrderingOffer | Review | RootMessagePack;

export type AiMarketingCampaignContentInput = {
  contentTypes: Array<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['Int']['input']>;
  followerSegmentId?: InputMaybe<Scalars['Int']['input']>;
  menuItemId?: InputMaybe<Scalars['Int']['input']>;
  orderingOfferId?: InputMaybe<Scalars['Int']['input']>;
  promptInstruction?: InputMaybe<Scalars['String']['input']>;
  remarketedAction?: InputMaybe<Scalars['String']['input']>;
  remarketedCampaignItemId?: InputMaybe<Scalars['Int']['input']>;
  remarketedLocationId?: InputMaybe<Scalars['Int']['input']>;
  remarketedTagId?: InputMaybe<Scalars['Int']['input']>;
};

export type AiMarketingContent = {
  __typename?: 'AiMarketingContent';
  aiMarketable?: Maybe<AiMarketable>;
  aiMarketableType?: Maybe<Scalars['String']['output']>;
  approvedByUser?: Maybe<User>;
  content: Content;
  contentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  location?: Maybe<RestaurantLocation>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  promptInstructionId?: Maybe<Scalars['Int']['output']>;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  scheduledAt: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  subjectType?: Maybe<Scalars['String']['output']>;
};

export type AiMarketingContentEvaluationResult = {
  __typename?: 'AiMarketingContentEvaluationResult';
  adherence: Scalars['Int']['output'];
  factuality: Scalars['Int']['output'];
  formatCompliance: Scalars['Int']['output'];
  originality: Scalars['Int']['output'];
  persuasiveness: Scalars['Int']['output'];
  relevance: Scalars['Int']['output'];
};

export type AiMarketingContentExampleContentResponse = {
  __typename?: 'AiMarketingContentExampleContentResponse';
  aimContentEvaluationId?: Maybe<Scalars['Int']['output']>;
  content: Scalars['String']['output'];
};

export type AiMarketingContentInput = {
  content?: InputMaybe<UpdateContentInput>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type AiMarketingContentMonthlyWrapper = {
  __typename?: 'AiMarketingContentMonthlyWrapper';
  messageGroupsCount: Scalars['Int']['output'];
  messagesSentCount: Scalars['Int']['output'];
  monthSlug: Scalars['String']['output'];
  needsApprovalCount: Scalars['Int']['output'];
  photoUrl?: Maybe<Scalars['String']['output']>;
  processedCount: Scalars['Int']['output'];
  referenceDate: Scalars['DateTime']['output'];
  rejectedCount: Scalars['Int']['output'];
  socialPostsCount: Scalars['Int']['output'];
  socialPostsPublishedCount: Scalars['Int']['output'];
  textMessageGroupsCount: Scalars['Int']['output'];
};

export type AiMarketingContentPrompt = {
  __typename?: 'AiMarketingContentPrompt';
  prompt: Scalars['String']['output'];
};

export type AiMarketingDefaultOption = {
  __typename?: 'AiMarketingDefaultOption';
  aiAdditionalContexts: Array<AiMarketingDefaultOptionAdditionalContext>;
  autoApproveContent: Scalars['Boolean']['output'];
  campaignGoals: Array<AiMarketingDefaultOptionCampaignGoal>;
  contentTone: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customPrompt?: Maybe<Scalars['String']['output']>;
  excludeUnknownLocationsMessageGroups: Scalars['Boolean']['output'];
  excludeUnknownLocationsTextMessages: Scalars['Boolean']['output'];
  hasAimCustomTone: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  lastAutoApproveToggledAt?: Maybe<Scalars['DateTime']['output']>;
  lastAutoApproveToggledByName?: Maybe<Scalars['String']['output']>;
  messageGroupExcludedLocations: Array<AiMarketingDefaultOptionMessageGroupExcludedLocation>;
  messageGroupExcludedTags: Array<AiMarketingDefaultOptionMessageGroupExcludedTag>;
  messageGroupSegmentationMatcher: Scalars['String']['output'];
  messageGroupSelectedFollowerSegments: Array<AiMarketingDefaultOptionMessageGroupSelectedFollowerSegment>;
  messageGroupSelectedLocations: Array<AiMarketingDefaultOptionMessageGroupSelectedLocation>;
  messageGroupSelectedTags: Array<AiMarketingDefaultOptionMessageGroupSelectedTag>;
  selectedSocialAccounts: Array<AiMarketingDefaultOptionSelectedSocialAccount>;
  sendToUnknownLocationsMessageGroups: Scalars['Boolean']['output'];
  sendToUnknownLocationsTextMessages: Scalars['Boolean']['output'];
  temperature: Scalars['Decimal']['output'];
  textMessageGroupExcludedLocations: Array<AiMarketingDefaultOptionTextMessageGroupExcludedLocation>;
  textMessageGroupExcludedTags: Array<AiMarketingDefaultOptionTextMessageGroupExcludedTag>;
  textMessageGroupSegmentationMatcher: Scalars['String']['output'];
  textMessageGroupSelectedLocations: Array<AiMarketingDefaultOptionTextMessageGroupSelectedLocation>;
  textMessageGroupSelectedTags: Array<AiMarketingDefaultOptionTextMessageGroupSelectedTag>;
  textMessageSelectedSegments: Array<AiMarketingDefaultOptionTextMessageSelectedSegment>;
  updatedAt: Scalars['DateTime']['output'];
  yourToneAdjectives: Array<Scalars['String']['output']>;
};

export type AiMarketingDefaultOptionAdditionalContext = {
  __typename?: 'AiMarketingDefaultOptionAdditionalContext';
  context: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type AiMarketingDefaultOptionAdditionalContextInput = {
  context: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type AiMarketingDefaultOptionCampaignGoal = {
  __typename?: 'AiMarketingDefaultOptionCampaignGoal';
  enabled: Scalars['Boolean']['output'];
  goal: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export enum AiMarketingDefaultOptionCampaignGoalEnum {
  BuildCustomerLoyalty = 'build_customer_loyalty',
  DriveFootTraffic = 'drive_foot_traffic',
  DriveOnlineOrders = 'drive_online_orders',
  IncreaseReservations = 'increase_reservations',
  PrivateEvents = 'private_events',
  PromoteCatering = 'promote_catering'
}

export type AiMarketingDefaultOptionCampaignGoalInput = {
  enabled: Scalars['Boolean']['input'];
  goal: AiMarketingDefaultOptionCampaignGoalEnum;
};

export type AiMarketingDefaultOptionInput = {
  aiAdditionalContexts?: InputMaybe<Array<AiMarketingDefaultOptionAdditionalContextInput>>;
  autoApproveContent?: InputMaybe<Scalars['Boolean']['input']>;
  campaignGoals?: InputMaybe<Array<AiMarketingDefaultOptionCampaignGoalInput>>;
  contentTone?: InputMaybe<Scalars['String']['input']>;
  customPrompt?: InputMaybe<Scalars['String']['input']>;
  excludeUnknownLocationsMessageGroups?: InputMaybe<Scalars['Boolean']['input']>;
  excludeUnknownLocationsTextMessages?: InputMaybe<Scalars['Boolean']['input']>;
  messageGroupExcludedLocations?: InputMaybe<Array<MessageGroupExcludedLocationInput>>;
  messageGroupExcludedTags?: InputMaybe<Array<MessageGroupExcludedTagInput>>;
  messageGroupSegmentationMatcher?: InputMaybe<Scalars['String']['input']>;
  messageGroupSelectedFollowerSegments?: InputMaybe<Array<AiMarketingDefaultOptionMessageGroupSelectedFollowerSegmentInput>>;
  messageGroupSelectedLocations?: InputMaybe<Array<MessageGroupSelectedLocationInput>>;
  messageGroupSelectedTags?: InputMaybe<Array<MessageGroupSelectedTagInput>>;
  selectedSocialAccounts?: InputMaybe<Array<SocialPostSelectedAccountInput>>;
  sendToUnknownLocationsMessageGroups?: InputMaybe<Scalars['Boolean']['input']>;
  sendToUnknownLocationsTextMessages?: InputMaybe<Scalars['Boolean']['input']>;
  temperature?: InputMaybe<Scalars['Decimal']['input']>;
  textMessageGroupExcludedLocations?: InputMaybe<Array<TextMessageGroupExcludedLocationInput>>;
  textMessageGroupExcludedTags?: InputMaybe<Array<TextMessageGroupExcludedTagInput>>;
  textMessageGroupSegmentationMatcher?: InputMaybe<Scalars['String']['input']>;
  textMessageGroupSelectedLocations?: InputMaybe<Array<TextMessageGroupSelectedLocationInput>>;
  textMessageGroupSelectedTags?: InputMaybe<Array<TextMessageGroupSelectedTagInput>>;
  textMessageSelectedSegments?: InputMaybe<Array<AiMarketingDefaultOptionTextMessageSelectedSegmentInput>>;
  yourToneAdjectives?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AiMarketingDefaultOptionMessageGroupExcludedLocation = {
  __typename?: 'AiMarketingDefaultOptionMessageGroupExcludedLocation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  location: RestaurantLocation;
  updatedAt: Scalars['DateTime']['output'];
};

export type AiMarketingDefaultOptionMessageGroupExcludedTag = {
  __typename?: 'AiMarketingDefaultOptionMessageGroupExcludedTag';
  createdAt: Scalars['DateTime']['output'];
  followerTag: FollowerTag;
  id: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AiMarketingDefaultOptionMessageGroupSelectedFollowerSegment = {
  __typename?: 'AiMarketingDefaultOptionMessageGroupSelectedFollowerSegment';
  id: Scalars['Int']['output'];
  restaurantFollowerSegment: RestaurantFollowerSegment;
  restaurantFollowerSegmentId: Scalars['Int']['output'];
};

export type AiMarketingDefaultOptionMessageGroupSelectedFollowerSegmentInput = {
  restaurantFollowerSegmentId: Scalars['Int']['input'];
};

export type AiMarketingDefaultOptionMessageGroupSelectedLocation = {
  __typename?: 'AiMarketingDefaultOptionMessageGroupSelectedLocation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  location: RestaurantLocation;
  updatedAt: Scalars['DateTime']['output'];
};

export type AiMarketingDefaultOptionMessageGroupSelectedTag = {
  __typename?: 'AiMarketingDefaultOptionMessageGroupSelectedTag';
  createdAt: Scalars['DateTime']['output'];
  followerTag: FollowerTag;
  id: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AiMarketingDefaultOptionSelectedSocialAccount = {
  __typename?: 'AiMarketingDefaultOptionSelectedSocialAccount';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  publishInstagram: Scalars['Boolean']['output'];
  socialAccount: SocialAccount;
  updatedAt: Scalars['DateTime']['output'];
};

export type AiMarketingDefaultOptionTextMessageGroupExcludedLocation = {
  __typename?: 'AiMarketingDefaultOptionTextMessageGroupExcludedLocation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  location: RestaurantLocation;
  updatedAt: Scalars['DateTime']['output'];
};

export type AiMarketingDefaultOptionTextMessageGroupExcludedTag = {
  __typename?: 'AiMarketingDefaultOptionTextMessageGroupExcludedTag';
  createdAt: Scalars['DateTime']['output'];
  followerTag: FollowerTag;
  id: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AiMarketingDefaultOptionTextMessageGroupSelectedLocation = {
  __typename?: 'AiMarketingDefaultOptionTextMessageGroupSelectedLocation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  location: RestaurantLocation;
  updatedAt: Scalars['DateTime']['output'];
};

export type AiMarketingDefaultOptionTextMessageGroupSelectedTag = {
  __typename?: 'AiMarketingDefaultOptionTextMessageGroupSelectedTag';
  createdAt: Scalars['DateTime']['output'];
  followerTag: FollowerTag;
  id: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AiMarketingDefaultOptionTextMessageSelectedSegment = {
  __typename?: 'AiMarketingDefaultOptionTextMessageSelectedSegment';
  id: Scalars['Int']['output'];
  restaurantFollowerSegment: RestaurantFollowerSegment;
  restaurantFollowerSegmentId: Scalars['Int']['output'];
};

export type AiMarketingDefaultOptionTextMessageSelectedSegmentInput = {
  restaurantFollowerSegmentId: Scalars['Int']['input'];
};

export type AiMarketingGenerateContentReturn = {
  __typename?: 'AiMarketingGenerateContentReturn';
  jobId?: Maybe<Scalars['String']['output']>;
};

export type AiReviewResponseAutoResponseRule = {
  __typename?: 'AiReviewResponseAutoResponseRule';
  autoResponseMaxDelay: Scalars['Int']['output'];
  autoResponseMinDelay: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  instruction: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type AiReviewResponseAutoResponseRuleInput = {
  autoResponseMaxDelay: Scalars['Int']['input'];
  autoResponseMinDelay: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  instruction: Scalars['String']['input'];
  source: Scalars['String']['input'];
};

export type AiReviewResponseDefaultSetting = {
  __typename?: 'AiReviewResponseDefaultSetting';
  autoRespondEnabled: Scalars['Boolean']['output'];
  autoResponseRules: Array<AiReviewResponseAutoResponseRule>;
  contentTone: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  location?: Maybe<RestaurantLocation>;
  restaurant: Restaurant;
  signature?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AiReviewResponseDefaultSettingInput = {
  autoRespondEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoResponseRules?: InputMaybe<Array<AiReviewResponseAutoResponseRuleInput>>;
  contentTone?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
};

export type AimContentEvaluationBatch = {
  __typename?: 'AimContentEvaluationBatch';
  briefFindings?: Maybe<Scalars['String']['output']>;
  contentType: Scalars['String']['output'];
  contentVariation?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isGraded: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  recurringElements: Scalars['JSON']['output'];
  subjectType: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
};

export type AimContentEvaluationComparison = {
  __typename?: 'AimContentEvaluationComparison';
  controlBatchId: Scalars['Int']['output'];
  summary: Scalars['String']['output'];
  treatmentBatchId: Scalars['Int']['output'];
};

export type AimDefaultPhotoPaginationHandler = {
  __typename?: 'AimDefaultPhotoPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<UploadedPhoto>;
};

export type AimPromptConfig = {
  __typename?: 'AimPromptConfig';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  features: Scalars['JSON']['output'];
  id: Scalars['Int']['output'];
  isArchived: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  prompt?: Maybe<Scalars['String']['output']>;
  restaurantIds: Array<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AimPromptConfigInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  prompt?: InputMaybe<Scalars['String']['input']>;
};

export type AimPromptConfigUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type AlertPaginationHandler = {
  __typename?: 'AlertPaginationHandler';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  offset: Scalars['Int']['output'];
  records: Array<RestaurantMemberAlert>;
};

export enum AllergenEnum {
  Celery = 'CELERY',
  CerealsContainingGluten = 'CEREALS_CONTAINING_GLUTEN',
  CrustaceanShellfish = 'CRUSTACEAN_SHELLFISH',
  Eggs = 'EGGS',
  Fish = 'FISH',
  Lupin = 'LUPIN',
  Milk = 'MILK',
  Mollusks = 'MOLLUSKS',
  Mustard = 'MUSTARD',
  Peanuts = 'PEANUTS',
  Sesame = 'SESAME',
  Soybeans = 'SOYBEANS',
  Sulfites = 'SULFITES',
  TreeNuts = 'TREE_NUTS',
  Wheat = 'WHEAT'
}

export type AlohaAccount = RestaurantPaymentAccountInterface & {
  __typename?: 'AlohaAccount';
  accountSlug: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  accountUrl: Scalars['String']['output'];
  alohaSites: Array<AlohaSite>;
  canDisconnectPos: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isDeleting: Scalars['Boolean']['output'];
  isMenuSyncing: Scalars['Boolean']['output'];
  isShopSupported: Scalars['Boolean']['output'];
  isSyncing?: Maybe<Scalars['Boolean']['output']>;
  menuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  organizationId: Scalars['String']['output'];
  restaurants?: Maybe<Array<Restaurant>>;
  shouldReauthenticate: Scalars['Boolean']['output'];
};

export type AlohaAccountPaginationHandler = {
  __typename?: 'AlohaAccountPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<AlohaAccount>;
};

export type AlohaSite = {
  __typename?: 'AlohaSite';
  fullAddress: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAlohaMenusPresent: Scalars['Boolean']['output'];
  siteName: Scalars['String']['output'];
};

export type AlohaSiteSettingInput = {
  alohaOfferReferenceId?: InputMaybe<Scalars['Int']['input']>;
  ncrPaymentAccountId?: InputMaybe<Scalars['Int']['input']>;
  ncrPaymentStoreNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum Amount {
  DollarAmountType = 'dollar_amount_type',
  PercentageAmountType = 'percentage_amount_type'
}

export type Announcement = {
  __typename?: 'Announcement';
  allLocations: Scalars['Boolean']['output'];
  announcementLocations: Array<AnnouncementLocation>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayType: Scalars['String']['output'];
  endAt?: Maybe<Scalars['DateTime']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isFriday?: Maybe<Scalars['Boolean']['output']>;
  isMessageCampaignEnabled?: Maybe<Scalars['Boolean']['output']>;
  isMonday?: Maybe<Scalars['Boolean']['output']>;
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  isSaturday?: Maybe<Scalars['Boolean']['output']>;
  isSunday?: Maybe<Scalars['Boolean']['output']>;
  isThursday?: Maybe<Scalars['Boolean']['output']>;
  isTuesday?: Maybe<Scalars['Boolean']['output']>;
  isWednesday?: Maybe<Scalars['Boolean']['output']>;
  linkName?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  locations: Array<RestaurantLocation>;
  marketingOffer?: Maybe<MarketingOffer>;
  modalDisplayType?: Maybe<Scalars['String']['output']>;
  photoAlt?: Maybe<Scalars['String']['output']>;
  photoHeight?: Maybe<Scalars['Int']['output']>;
  photoUploadedPhoto?: Maybe<UploadedPhoto>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  photoWidth?: Maybe<Scalars['Int']['output']>;
  restaurant?: Maybe<Restaurant>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AnnouncementInput = {
  announcementLocations?: InputMaybe<Array<AnnouncementLocationInput>>;
  content?: InputMaybe<Scalars['String']['input']>;
  displayType?: InputMaybe<Scalars['String']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  featured: Scalars['Boolean']['input'];
  heading?: InputMaybe<Scalars['String']['input']>;
  isFriday?: InputMaybe<Scalars['Boolean']['input']>;
  isMessageCampaignEnabled: Scalars['Boolean']['input'];
  isMonday?: InputMaybe<Scalars['Boolean']['input']>;
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  isSaturday?: InputMaybe<Scalars['Boolean']['input']>;
  isSunday?: InputMaybe<Scalars['Boolean']['input']>;
  isThursday?: InputMaybe<Scalars['Boolean']['input']>;
  isTuesday?: InputMaybe<Scalars['Boolean']['input']>;
  isWednesday?: InputMaybe<Scalars['Boolean']['input']>;
  linkName?: InputMaybe<Scalars['String']['input']>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  modalDisplayType?: InputMaybe<Scalars['String']['input']>;
  photoAlt?: InputMaybe<Scalars['String']['input']>;
  photoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnnouncementLocation = {
  __typename?: 'AnnouncementLocation';
  id: Scalars['Int']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  location: RestaurantLocation;
  locationId?: Maybe<Scalars['Int']['output']>;
};

export type AnnouncementLocationInput = {
  isEnabled: Scalars['Boolean']['input'];
  locationId: Scalars['Int']['input'];
};

export type AnnouncementPaginationHandler = {
  __typename?: 'AnnouncementPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<Announcement>;
};

export type AnsweringOverview = {
  __typename?: 'AnsweringOverview';
  answeringTimeSaved?: Maybe<Scalars['Int']['output']>;
  answeringTimeSavedPercentage?: Maybe<Scalars['Float']['output']>;
  averageCallDuration?: Maybe<Scalars['Float']['output']>;
  averageCallDurationPercentage?: Maybe<Scalars['Float']['output']>;
  callOutcomes?: Maybe<AnsweringOverviewCallOutcomes>;
  callsByDayOfWeek?: Maybe<Array<AnsweringOverviewCallsByDayOfWeek>>;
  lastUpdatedAt?: Maybe<Scalars['String']['output']>;
  resolutionRate?: Maybe<Scalars['Float']['output']>;
  resolutionRatePercentage?: Maybe<Scalars['Float']['output']>;
  topTopics?: Maybe<Array<AnsweringOverviewTopTopics>>;
  totalCurrentCalls?: Maybe<Scalars['Int']['output']>;
  totalCurrentCallsPercentage?: Maybe<Scalars['Float']['output']>;
  totalWeeklyCalls?: Maybe<Scalars['Int']['output']>;
  totalWeeklyCallsPercentage?: Maybe<Scalars['Float']['output']>;
};

export type AnsweringOverviewCallOutcomes = {
  __typename?: 'AnsweringOverviewCallOutcomes';
  aiAnsweringResolved?: Maybe<Scalars['Int']['output']>;
  customForwarded?: Maybe<Scalars['Int']['output']>;
  defaultForwarded?: Maybe<Scalars['Int']['output']>;
  restaurantNoAnswer?: Maybe<Scalars['Int']['output']>;
  spamBlocked?: Maybe<Scalars['Int']['output']>;
  voicemail?: Maybe<Scalars['Int']['output']>;
};

export type AnsweringOverviewCallsByDayOfWeek = {
  __typename?: 'AnsweringOverviewCallsByDayOfWeek';
  date: Scalars['DateTime']['output'];
  dayOfWeek: Scalars['String']['output'];
  volume: Scalars['Int']['output'];
};

export type AnsweringOverviewCallsByHour = {
  __typename?: 'AnsweringOverviewCallsByHour';
  hour?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Int']['output']>;
};

export type AnsweringOverviewTopTopics = {
  __typename?: 'AnsweringOverviewTopTopics';
  percentage?: Maybe<Scalars['Float']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
};

export type AnsweringUsageLimits = {
  __typename?: 'AnsweringUsageLimits';
  billingEndDate?: Maybe<Scalars['DateTime']['output']>;
  billingStartDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  /** @deprecated This field is deprecated. Use total_difference instead. */
  percentage: Scalars['Int']['output'];
  totalDifference?: Maybe<Scalars['Int']['output']>;
  totalLimit?: Maybe<Scalars['Int']['output']>;
  totalUsed?: Maybe<Scalars['Int']['output']>;
};

export type ApiTokenPaginationHandler = {
  __typename?: 'ApiTokenPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<UserApiToken>;
};

export type ApplicableAddonJoin = {
  __typename?: 'ApplicableAddonJoin';
  applicableCoupons: Array<BillingCoupon>;
  billingPlanId: Scalars['Int']['output'];
};

export type ApplicableCustomFees = {
  __typename?: 'ApplicableCustomFees';
  finalAmount: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
  revenueShared: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ApplyLoyaltyReward */
export type ApplyLoyaltyRewardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuItemCartId: Scalars['Int']['input'];
  rewardTierId: Scalars['Int']['input'];
};

/** Autogenerated input type of ApplyMenuItemModifierGroup */
export type ApplyMenuItemModifierGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuItemId: Scalars['Int']['input'];
  modifierGroupIds: Array<Scalars['Int']['input']>;
};

/** Autogenerated input type of ApplyOrderingOfferOrGiftCard */
export type ApplyOrderingOfferOrGiftCardInput = {
  checkActiveOffersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  menuItemCartId: Scalars['Int']['input'];
  profileEventTracking?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated input type of ApplyPendingOffer */
export type ApplyPendingOfferInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuItemCartId?: InputMaybe<Scalars['Int']['input']>;
  offerCode: Scalars['String']['input'];
};

/** Autogenerated input type of ApplyPendingReward */
export type ApplyPendingRewardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuItemCartId?: InputMaybe<Scalars['Int']['input']>;
  rewardTierId: Scalars['Int']['input'];
};

/** Autogenerated input type of ApplyTemplateToMessageGroup */
export type ApplyTemplateToMessageGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageGroupId: Scalars['Int']['input'];
  rootMessagePackId: Scalars['Int']['input'];
};

/** Autogenerated input type of ApproveMultipleAiContentsType */
export type ApproveMultipleAiContentsTypeInput = {
  aiMarketingContentIds: Array<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of ApproveRestaurantMessagePack */
export type ApproveRestaurantMessagePackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  communicationId: Scalars['Int']['input'];
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  messageInput?: InputMaybe<RootMessagePackMessageInput>;
  restaurantInput?: InputMaybe<RestaurantMessageInput>;
  socialPostInput?: InputMaybe<SocialPostInput>;
};

/** Autogenerated input type of ArchiveAgentChat */
export type ArchiveAgentChatInput = {
  agentChatId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of ArchiveAimPromptConfig */
export type ArchiveAimPromptConfigInput = {
  aimPromptConfigId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of AssignAimPromptConfigToRestaurants */
export type AssignAimPromptConfigToRestaurantsInput = {
  aimPromptConfigId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantIds: Array<Scalars['Int']['input']>;
};

/** Autogenerated input type of AttachCloverOrderTypes */
export type AttachCloverOrderTypesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cloverAccountId: Scalars['Int']['input'];
  cloverOrderTypesInput: CloverOrderTypesInput;
};

/** Autogenerated input type of AttachHeartlandPosLocation */
export type AttachHeartlandPosLocationInput = {
  apiKey: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
};

/** Autogenerated input type of AttachSpotonLocation */
export type AttachSpotonLocationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  spotonLocationId: Scalars['String']['input'];
  spotonLocationName: Scalars['String']['input'];
};

export type AuthorizeAccount = RestaurantPaymentAccountInterface & {
  __typename?: 'AuthorizeAccount';
  accountSlug: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  accountUrl: Scalars['String']['output'];
  canDisconnectPos: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isDeleting: Scalars['Boolean']['output'];
  isMenuSyncing: Scalars['Boolean']['output'];
  isShopSupported: Scalars['Boolean']['output'];
  isSyncing?: Maybe<Scalars['Boolean']['output']>;
  menuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  merchantName: Scalars['String']['output'];
  shouldReauthenticate: Scalars['Boolean']['output'];
};

export type AuthorizeRefund = MenuItemCartRefundable & {
  __typename?: 'AuthorizeRefund';
  amount: Scalars['Decimal']['output'];
  id: Scalars['Int']['output'];
  refundedAt: Scalars['DateTime']['output'];
  refundedByUserEmail?: Maybe<Scalars['String']['output']>;
};

export type AutomatedEmailPaginationHandle = {
  __typename?: 'AutomatedEmailPaginationHandle';
  count: Scalars['Int']['output'];
  records: Array<MessageCampaign>;
};

export type AvailableReservationTime = {
  __typename?: 'AvailableReservationTime';
  time?: Maybe<Scalars['Time']['output']>;
};

export type AverageRate = {
  __typename?: 'AverageRate';
  averageClickedRate: Scalars['Float']['output'];
  averageDeliveredRate: Scalars['Float']['output'];
  averageOpenedRate: Scalars['Float']['output'];
};

export type AverageSessionTimeInMinutes = {
  __typename?: 'AverageSessionTimeInMinutes';
  currentAverageSessionTimeInMinutes: Scalars['Float']['output'];
  previousAverageSessionTimeInMinutes?: Maybe<Scalars['Float']['output']>;
};

export type AwsSignature = {
  __typename?: 'AwsSignature';
  format: Scalars['String']['output'];
  id: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type AwsSignatureInput = {
  fileName: Scalars['String']['input'];
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
  uploadId?: InputMaybe<Scalars['Int']['input']>;
  uploadType?: InputMaybe<Scalars['String']['input']>;
};

export type BillingBankAccount = {
  __typename?: 'BillingBankAccount';
  accountHolderName?: Maybe<Scalars['String']['output']>;
  accountHolderType?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  billingCustomer?: Maybe<BillingCustomer>;
  billingSubscriptions: Array<BillingSubscription>;
  chargebeePaymentMethodId?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  hasOrderingBillingConfigs: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isDefaultPayment?: Maybe<Scalars['Boolean']['output']>;
  isGocardless?: Maybe<Scalars['Boolean']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
  nickName?: Maybe<Scalars['String']['output']>;
  restaurant?: Maybe<Restaurant>;
  status?: Maybe<Scalars['String']['output']>;
  stripeId?: Maybe<Scalars['String']['output']>;
};

export type BillingBankAccountInput = {
  id: Scalars['Int']['input'];
  isPrimaryPayment?: InputMaybe<Scalars['Boolean']['input']>;
  nickName?: InputMaybe<Scalars['String']['input']>;
};

export type BillingCoupon = {
  __typename?: 'BillingCoupon';
  amountOff?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  discountType?: Maybe<Scalars['String']['output']>;
  durationInMonths?: Maybe<Scalars['Int']['output']>;
  durationType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isOnetimeCharge?: Maybe<Scalars['Boolean']['output']>;
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentOff?: Maybe<Scalars['Int']['output']>;
  stripeId?: Maybe<Scalars['String']['output']>;
  stripeUrl?: Maybe<Scalars['String']['output']>;
};

export type BillingCouponInput = {
  amountOff?: InputMaybe<Scalars['Int']['input']>;
  discountType: Scalars['String']['input'];
  durationInMonths?: InputMaybe<Scalars['Int']['input']>;
  durationType: Scalars['String']['input'];
  isOnetimeCharge: Scalars['Boolean']['input'];
  isRestricted: Scalars['Boolean']['input'];
  isValid: Scalars['Boolean']['input'];
  percentOff?: InputMaybe<Scalars['Int']['input']>;
  stripeId: Scalars['String']['input'];
};

export type BillingCouponPaginationHandler = {
  __typename?: 'BillingCouponPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<BillingCoupon>;
};

export type BillingCreditCard = {
  __typename?: 'BillingCreditCard';
  billingCustomer?: Maybe<BillingCustomer>;
  billingSubscriptions: Array<BillingSubscription>;
  brand?: Maybe<Scalars['String']['output']>;
  chargebeePaymentMethodId?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
  funding?: Maybe<Scalars['String']['output']>;
  hasOrderingBillingConfigs: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isDefaultPayment?: Maybe<Scalars['Boolean']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
  lastErrorCode?: Maybe<Scalars['String']['output']>;
  lastErrorMessage?: Maybe<Scalars['String']['output']>;
  nickName?: Maybe<Scalars['String']['output']>;
  restaurant?: Maybe<Restaurant>;
  stripeId?: Maybe<Scalars['String']['output']>;
};

export type BillingCreditCardInput = {
  expMonth: Scalars['Int']['input'];
  expYear: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  isPrimaryPayment?: InputMaybe<Scalars['Boolean']['input']>;
  nickName?: InputMaybe<Scalars['String']['input']>;
};

export type BillingCustomer = {
  __typename?: 'BillingCustomer';
  applicableCharges: Array<BillingPlan>;
  billingBankAccounts?: Maybe<Array<BillingBankAccount>>;
  billingCity: Scalars['String']['output'];
  billingCountry: Scalars['String']['output'];
  billingCreditCards?: Maybe<Array<BillingCreditCard>>;
  billingEmail: Scalars['String']['output'];
  billingPhone: Scalars['String']['output'];
  billingPostalCode: Scalars['String']['output'];
  billingState?: Maybe<Scalars['String']['output']>;
  billingStreetAddress: Scalars['String']['output'];
  billingSubscription?: Maybe<BillingSubscription>;
  billingSubscriptions?: Maybe<Array<BillingSubscription>>;
  chargebeeCustomerId?: Maybe<Scalars['String']['output']>;
  chargebeeDomain: Scalars['String']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  creditCardSurchargeEligible: Scalars['Boolean']['output'];
  currency: Scalars['String']['output'];
  defaultPayment?: Maybe<Scalars['String']['output']>;
  delinquent?: Maybe<Scalars['Boolean']['output']>;
  failedSubscriptionInvoices?: Maybe<Array<BillingInvoice>>;
  firstInvoiceDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isChargebeeParentCustomer: Scalars['Boolean']['output'];
  locationId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  orderingFeeSubscription?: Maybe<BillingSubscription>;
  parentCustomerEmail?: Maybe<Scalars['String']['output']>;
  parentCustomerName?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<Scalars['String']['output']>;
  policy: BillingCustomerPolicy;
  restaurant?: Maybe<Restaurant>;
  slug: Scalars['String']['output'];
  stripeId?: Maybe<Scalars['String']['output']>;
  stripeUrl: Scalars['String']['output'];
  trialPeriodDays?: Maybe<Scalars['Int']['output']>;
  unpaidInvoiceBalance?: Maybe<Scalars['Int']['output']>;
  upcomingBillingInvoice?: Maybe<BillingInvoice>;
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export type BillingCustomerInput = {
  billingCity: Scalars['String']['input'];
  billingCountry: Scalars['String']['input'];
  billingEmail: Scalars['String']['input'];
  billingPhone: Scalars['String']['input'];
  billingPostalCode: Scalars['String']['input'];
  billingState?: InputMaybe<Scalars['String']['input']>;
  billingStreetAddress: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type BillingCustomerPolicy = {
  __typename?: 'BillingCustomerPolicy';
  id: Scalars['String']['output'];
  manageBilling: Scalars['Boolean']['output'];
};

export type BillingEntitlement = {
  __typename?: 'BillingEntitlement';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  entityType: Scalars['String']['output'];
  featureId: Scalars['String']['output'];
  featureName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BillingEntitlementFeatureFlag = {
  __typename?: 'BillingEntitlementFeatureFlag';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  featureFlag: Scalars['String']['output'];
  featureId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  platformBrand: Scalars['String']['output'];
  platformBrandName: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BillingEntitlementFeatureFlagInput = {
  featureFlag: Scalars['String']['input'];
  featureId: Scalars['String']['input'];
  platformBrand?: InputMaybe<Scalars['String']['input']>;
};

export type BillingInvoice = {
  __typename?: 'BillingInvoice';
  amountDue?: Maybe<Scalars['Int']['output']>;
  amountPaid?: Maybe<Scalars['Int']['output']>;
  amountRefunded?: Maybe<Scalars['Int']['output']>;
  billingCoupons?: Maybe<Array<BillingCoupon>>;
  billingReason?: Maybe<Scalars['String']['output']>;
  billingSubscriptionId?: Maybe<Scalars['Int']['output']>;
  cbInvoiceId?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  discountPercentage?: Maybe<Scalars['Decimal']['output']>;
  disputed?: Maybe<Scalars['Boolean']['output']>;
  hasDispute?: Maybe<Scalars['Boolean']['output']>;
  hasTax?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoiceStatus?: Maybe<Scalars['String']['output']>;
  items: Array<BillingInvoiceItem>;
  lineItemsDescription?: Maybe<Array<Scalars['String']['output']>>;
  orderingBillingInvoice?: Maybe<OrderingBillingInvoice>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paymentOwnerBillingCustomer?: Maybe<BillingCustomer>;
  receiptNumber?: Maybe<Scalars['String']['output']>;
  stripeId?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  taxAmount?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BillingInvoiceInput = {
  billingCouponId?: InputMaybe<Scalars['Int']['input']>;
  billingCustomerId: Scalars['Int']['input'];
  billingProductPriceStripeId: Scalars['String']['input'];
  paymentStripeId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type BillingInvoiceItem = {
  __typename?: 'BillingInvoiceItem';
  amount?: Maybe<Scalars['Int']['output']>;
  billingInvoice: BillingInvoice;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  periodStart?: Maybe<Scalars['DateTime']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type BillingInvoicePaginationHandler = {
  __typename?: 'BillingInvoicePaginationHandler';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  offset: Scalars['Int']['output'];
  records: Array<BillingInvoice>;
};

export type BillingInvoiceReturn = {
  __typename?: 'BillingInvoiceReturn';
  billingInvoice: BillingInvoice;
};

export type BillingPlan = {
  __typename?: 'BillingPlan';
  amount: Scalars['Int']['output'];
  assistanceRequired: Scalars['Boolean']['output'];
  chargebeeItemId?: Maybe<Scalars['String']['output']>;
  chargebeePlanId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enabledInPortal: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  intervalCount?: Maybe<Scalars['Int']['output']>;
  intervalType?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isIndie?: Maybe<Scalars['Boolean']['output']>;
  isLocationProduct: Scalars['Boolean']['output'];
  isMonthly: Scalars['Boolean']['output'];
  isOnetimeCharge?: Maybe<Scalars['Boolean']['output']>;
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  itemGroup?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  statementDescriptor?: Maybe<Scalars['String']['output']>;
  stripeId?: Maybe<Scalars['String']['output']>;
  stripeProductId?: Maybe<Scalars['String']['output']>;
  stripeUrl?: Maybe<Scalars['String']['output']>;
};

export type BillingPlanInput = {
  currency: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  intervalCount: Scalars['Int']['input'];
  intervalType: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  isRestricted: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Int']['input'];
  statementDescriptor?: InputMaybe<Scalars['String']['input']>;
};

export type BillingPlanPaginationHandler = {
  __typename?: 'BillingPlanPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<BillingPlan>;
};

export type BillingProduct = {
  __typename?: 'BillingProduct';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  prices: Array<BillingProductPrice>;
  statementDescriptor?: Maybe<Scalars['String']['output']>;
  stripeId?: Maybe<Scalars['String']['output']>;
  stripeUrl?: Maybe<Scalars['String']['output']>;
};

export type BillingProductInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  isRestricted: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  statementDescriptor?: InputMaybe<Scalars['String']['input']>;
};

export type BillingProductPaginationHandler = {
  __typename?: 'BillingProductPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<BillingProduct>;
};

export type BillingProductPrice = {
  __typename?: 'BillingProductPrice';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  productName: Scalars['String']['output'];
  stripeId?: Maybe<Scalars['String']['output']>;
  stripeUrl?: Maybe<Scalars['String']['output']>;
  unitAmount?: Maybe<Scalars['Int']['output']>;
};

export type BillingProductPriceInput = {
  currency: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  isRestricted: Scalars['Boolean']['input'];
  nickname?: InputMaybe<Scalars['String']['input']>;
  unitAmount: Scalars['Int']['input'];
};

export type BillingProductPricePaginationHandler = {
  __typename?: 'BillingProductPricePaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<BillingProductPrice>;
};

export type BillingProductReturn = {
  __typename?: 'BillingProductReturn';
  billingProduct?: Maybe<BillingProduct>;
};

export type BillingSubscription = {
  __typename?: 'BillingSubscription';
  amountPaidOnLastInvoice?: Maybe<Scalars['Int']['output']>;
  applicableAddonJoins: Array<ApplicableAddonJoin>;
  applicableAddons: Array<BillingPlan>;
  billingBankAccount?: Maybe<BillingBankAccount>;
  billingCoupon?: Maybe<BillingCoupon>;
  billingCouponId?: Maybe<Scalars['Int']['output']>;
  billingCoupons?: Maybe<Array<BillingCoupon>>;
  billingCreditCard?: Maybe<BillingCreditCard>;
  billingPlan?: Maybe<BillingPlan>;
  billingSubscriptionItems: Array<BillingSubscriptionItem>;
  chargebeePaymentMethodId?: Maybe<Scalars['String']['output']>;
  chargebeeSubscriptionId?: Maybe<Scalars['String']['output']>;
  collectionMethod?: Maybe<Scalars['String']['output']>;
  couponAmountOff?: Maybe<Scalars['Int']['output']>;
  couponCurrency?: Maybe<Scalars['String']['output']>;
  couponDiscountType?: Maybe<Scalars['String']['output']>;
  couponPercentOff?: Maybe<Scalars['Int']['output']>;
  couponStripeId?: Maybe<Scalars['String']['output']>;
  creditCardSurchargeActive?: Maybe<Scalars['Boolean']['output']>;
  creditCardSurchargeCents: Scalars['Int']['output'];
  creditCardSurchargeInactiveReason?: Maybe<Scalars['String']['output']>;
  creditCardSurchargeRate: Scalars['Float']['output'];
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  hasMeteredBillingPlan: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isIndie: Scalars['Boolean']['output'];
  isPaidByConceptGroup?: Maybe<Scalars['Boolean']['output']>;
  isPaidByParent?: Maybe<Scalars['Boolean']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  lastBillingInvoice?: Maybe<BillingInvoice>;
  offlinePaymentMethod?: Maybe<Scalars['String']['output']>;
  paymentOwnerBillingCustomer?: Maybe<BillingCustomer>;
  paymentStripeId?: Maybe<Scalars['String']['output']>;
  restaurant?: Maybe<Restaurant>;
  status?: Maybe<Scalars['String']['output']>;
  stripeId?: Maybe<Scalars['String']['output']>;
  stripeUrl?: Maybe<Scalars['String']['output']>;
  trialEnd?: Maybe<Scalars['DateTime']['output']>;
  trialPeriodDays?: Maybe<Scalars['Int']['output']>;
  upcomingInvoiceTotal?: Maybe<Scalars['Int']['output']>;
};

export type BillingSubscriptionInput = {
  chargebeePaymentMethodId: Scalars['String']['input'];
  id: Scalars['Int']['input'];
};

export type BillingSubscriptionItem = {
  __typename?: 'BillingSubscriptionItem';
  amount: Scalars['Int']['output'];
  billingPlanId?: Maybe<Scalars['Int']['output']>;
  currency: Scalars['String']['output'];
  externalName?: Maybe<Scalars['String']['output']>;
  hasMeteredAiAnsweringPlan: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  stripeId?: Maybe<Scalars['String']['output']>;
  totalPrice: Scalars['Int']['output'];
};

export type BillingUkCustomer = {
  __typename?: 'BillingUkCustomer';
  billingCity: Scalars['String']['output'];
  billingEmail: Scalars['String']['output'];
  billingPhone: Scalars['String']['output'];
  billingPostalCode: Scalars['String']['output'];
  billingStreetAddress: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  paymentMethodType?: Maybe<Scalars['String']['output']>;
  stripeUrl: Scalars['String']['output'];
};

export type BlockedTerm = {
  __typename?: 'BlockedTerm';
  id: Scalars['Int']['output'];
  term?: Maybe<Scalars['String']['output']>;
};

export type BlockedTermInput = {
  term?: InputMaybe<Scalars['String']['input']>;
};

export type BlockedTermPaginationHandler = {
  __typename?: 'BlockedTermPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<BlockedTerm>;
};

export type BlogImport = {
  __typename?: 'BlogImport';
  blogPostsCount?: Maybe<Scalars['Int']['output']>;
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  importFileUrl: Scalars['String']['output'];
  importedAt?: Maybe<Scalars['DateTime']['output']>;
  restaurant?: Maybe<Restaurant>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type BlogPost = Eventable & NavLinkable & {
  __typename?: 'BlogPost';
  createdAt: Scalars['DateTime']['output'];
  eventableName: Scalars['String']['output'];
  heroImage?: Maybe<Scalars['String']['output']>;
  heroImageAlt?: Maybe<Scalars['String']['output']>;
  heroImageDescription?: Maybe<Scalars['String']['output']>;
  heroImageUploadedPhoto?: Maybe<UploadedPhoto>;
  id: Scalars['Int']['output'];
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  postContent?: Maybe<Scalars['String']['output']>;
  postTitle: Scalars['String']['output'];
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  restaurant: Restaurant;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  visitsCount?: Maybe<Scalars['Int']['output']>;
};

export type BlogPostInput = {
  heroImageAlt?: InputMaybe<Scalars['String']['input']>;
  heroImageDescription?: InputMaybe<Scalars['String']['input']>;
  heroImageUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  postContent?: InputMaybe<Scalars['String']['input']>;
  postTitle: Scalars['String']['input'];
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type BlogPostPaginationHandler = {
  __typename?: 'BlogPostPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<BlogPost>;
};

export type BuilderContentInput = {
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  buttonName?: InputMaybe<Scalars['String']['input']>;
  buttonType?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  customPageId?: InputMaybe<Scalars['Int']['input']>;
  dishReviewInput?: InputMaybe<BuilderDishReviewContentInput>;
  dividerInput?: InputMaybe<BuilderDividerContentInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imageInput?: InputMaybe<BuilderImageContentInput>;
};

export type BuilderContentable = {
  contentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type BuilderDishReviewContentInput = {
  reviewId?: InputMaybe<Scalars['Int']['input']>;
  textContent?: InputMaybe<Scalars['String']['input']>;
  uploadedPhotoId?: InputMaybe<Scalars['Int']['input']>;
};

export type BuilderDividerContentInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  spacing?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
};

export type BuilderImageContentInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  uploadedPhotoId?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of BulkDestroyAiMarketingContentForRestaurants */
export type BulkDestroyAiMarketingContentForRestaurantsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  monthScope: Scalars['String']['input'];
  restaurantIds: Array<Scalars['Int']['input']>;
};

/** Autogenerated input type of BulkMoveUploadFolder */
export type BulkMoveUploadFolderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  selectedIds: Array<Scalars['Int']['input']>;
  targetFolderId?: InputMaybe<Scalars['Int']['input']>;
  uploadType: Scalars['String']['input'];
};

/** Autogenerated input type of BulkUpdateAimAvailableUploadFolder */
export type BulkUpdateAimAvailableUploadFolderInput = {
  aimAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['Int']['input']>;
};

export type BusinessRegistrationPolicy = {
  __typename?: 'BusinessRegistrationPolicy';
  id: Scalars['String']['output'];
  update: Scalars['Boolean']['output'];
};

/** Computed CSS styles for button sizing */
export type ButtonStyles = {
  __typename?: 'ButtonStyles';
  /** CSS font-size value, example: "0.875rem !important" */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** CSS min-height value, example: "36px !important" */
  minHeight?: Maybe<Scalars['String']['output']>;
  /** CSS padding value, example: "6px 16px !important" */
  padding?: Maybe<Scalars['String']['output']>;
};

export type CalendarEvent = Eventable & {
  __typename?: 'CalendarEvent';
  aiMarketablePhoto?: Maybe<UploadedPhoto>;
  calendarEventPageUrl?: Maybe<Scalars['String']['output']>;
  calendarEventRecurringExceptions: Array<CalendarEventRecurringException>;
  calendarEventSelectedLocations: Array<CalendarEventSelectedLocation>;
  calendarEventTicketGroups: Array<CalendarEventTicketGroup>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dayOfWeek?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dislikedItPopsCount?: Maybe<Scalars['Int']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  endTime?: Maybe<Scalars['Time']['output']>;
  eventTimeDescription?: Maybe<Scalars['String']['output']>;
  eventableName: Scalars['String']['output'];
  externalLinkText?: Maybe<Scalars['String']['output']>;
  externalLinkUrl?: Maybe<Scalars['String']['output']>;
  hideStartEndDate: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isAllDay?: Maybe<Scalars['Boolean']['output']>;
  isFreeTicketed: Scalars['Boolean']['output'];
  isFriday?: Maybe<Scalars['Boolean']['output']>;
  isMonday?: Maybe<Scalars['Boolean']['output']>;
  isPaidTicketed: Scalars['Boolean']['output'];
  isPastEvent: Scalars['Boolean']['output'];
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  isSaturday?: Maybe<Scalars['Boolean']['output']>;
  isSecret?: Maybe<Scalars['Boolean']['output']>;
  isSunday?: Maybe<Scalars['Boolean']['output']>;
  isThursday?: Maybe<Scalars['Boolean']['output']>;
  isTuesday?: Maybe<Scalars['Boolean']['output']>;
  isWednesday?: Maybe<Scalars['Boolean']['output']>;
  likedItPopsCount?: Maybe<Scalars['Int']['output']>;
  lovedItPopsCount?: Maybe<Scalars['Int']['output']>;
  maxCapacity?: Maybe<Scalars['Int']['output']>;
  maxTicketQuantity?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  photoAlt?: Maybe<Scalars['String']['output']>;
  photoHeight?: Maybe<Scalars['Int']['output']>;
  photoUploadedPhoto?: Maybe<UploadedPhoto>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  photoWidth?: Maybe<Scalars['Int']['output']>;
  pops?: Maybe<Array<CalendarEventPop>>;
  popsCount?: Maybe<Scalars['Int']['output']>;
  publishGmb?: Maybe<Scalars['Boolean']['output']>;
  recurringType: Scalars['String']['output'];
  restaurant?: Maybe<Restaurant>;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  selectedTags: Array<CalendarEventSelectedTag>;
  slug: Scalars['String']['output'];
  soldTicketQuantity?: Maybe<Scalars['Int']['output']>;
  startAt: Scalars['DateTime']['output'];
  startTime?: Maybe<Scalars['Time']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  ticketGroups: Array<CalendarEventTicketGroup>;
  ticketSaleEndDatetime?: Maybe<Scalars['DateTime']['output']>;
  ticketedEventLocation?: Maybe<RestaurantLocation>;
  totalRevenue?: Maybe<Scalars['Decimal']['output']>;
  wannaTryPopsCount?: Maybe<Scalars['Int']['output']>;
};


export type CalendarEventAiMarketablePhotoArgs = {
  withGenericPhoto?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CalendarEventInput = {
  calendarEventRecurringExceptions?: InputMaybe<Array<CalendarEventRecurringExceptionInput>>;
  calendarEventSelectedLocations?: InputMaybe<Array<CalendarEventSelectedLocationInput>>;
  calendarEventTicketGroups?: InputMaybe<Array<CalendarEventTicketGroupInput>>;
  dayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['Time']['input']>;
  eventTagId?: InputMaybe<Scalars['Int']['input']>;
  externalLinkText?: InputMaybe<Scalars['String']['input']>;
  externalLinkUrl?: InputMaybe<Scalars['String']['input']>;
  hideStartEndDate?: InputMaybe<Scalars['Boolean']['input']>;
  isAllDay: Scalars['Boolean']['input'];
  isFriday?: InputMaybe<Scalars['Boolean']['input']>;
  isMonday?: InputMaybe<Scalars['Boolean']['input']>;
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  isSaturday?: InputMaybe<Scalars['Boolean']['input']>;
  isSecret?: InputMaybe<Scalars['Boolean']['input']>;
  isSunday?: InputMaybe<Scalars['Boolean']['input']>;
  isThursday?: InputMaybe<Scalars['Boolean']['input']>;
  isTuesday?: InputMaybe<Scalars['Boolean']['input']>;
  isWednesday?: InputMaybe<Scalars['Boolean']['input']>;
  maxCapacity?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photoAlt?: InputMaybe<Scalars['String']['input']>;
  photoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  publishGmb: Scalars['Boolean']['input'];
  recurringType?: InputMaybe<Scalars['String']['input']>;
  selectedTags?: InputMaybe<Array<CalendarEventSelectedTagInput>>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['Time']['input']>;
  status: Scalars['String']['input'];
  ticketSaleEndDatetime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CalendarEventPaginationHandler = {
  __typename?: 'CalendarEventPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<CalendarEvent>;
};

export type CalendarEventPop = {
  __typename?: 'CalendarEventPop';
  calendarEvent?: Maybe<CalendarEvent>;
  calendarEventId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  popType?: Maybe<Scalars['String']['output']>;
  session?: Maybe<Session>;
  sessionId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type CalendarEventRecurringException = {
  __typename?: 'CalendarEventRecurringException';
  calendarEventId?: Maybe<Scalars['Int']['output']>;
  exceptionAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
};

export type CalendarEventRecurringExceptionInput = {
  exceptionAt: Scalars['DateTime']['input'];
};

export type CalendarEventSelectedLocation = {
  __typename?: 'CalendarEventSelectedLocation';
  id: Scalars['Int']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  location: RestaurantLocation;
  locationId?: Maybe<Scalars['Int']['output']>;
};

export type CalendarEventSelectedLocationInput = {
  isEnabled: Scalars['Boolean']['input'];
  locationId: Scalars['Int']['input'];
};

export type CalendarEventSelectedTag = {
  __typename?: 'CalendarEventSelectedTag';
  eventTag?: Maybe<EventTag>;
  eventTagId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
};

export type CalendarEventSelectedTagInput = {
  eventTagId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type CalendarEventTicket = {
  __typename?: 'CalendarEventTicket';
  calendarEventTicketGroup: CalendarEventTicketGroup;
  id: Scalars['Int']['output'];
  originalName?: Maybe<Scalars['String']['output']>;
  originalPrice?: Maybe<Scalars['Decimal']['output']>;
  status: Scalars['String']['output'];
};

export type CalendarEventTicketCart = {
  __typename?: 'CalendarEventTicketCart';
  calendarEvent: CalendarEvent;
  calendarEventTickets: Array<CalendarEventTicket>;
  clearAt?: Maybe<Scalars['DateTime']['output']>;
  clientPlatformFeeAmount: Scalars['Decimal']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  currency: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  location: RestaurantLocation;
  name?: Maybe<Scalars['String']['output']>;
  originalPlatformFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  originalSubtotal?: Maybe<Scalars['Decimal']['output']>;
  originalTaxAmount?: Maybe<Scalars['Decimal']['output']>;
  originalTotal?: Maybe<Scalars['Decimal']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  refundedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Seconds remaining until cart is automatically cleared */
  secondsUntilClear?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  status: Scalars['String']['output'];
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  taxAmount: Scalars['Decimal']['output'];
  ticketCount: Scalars['Int']['output'];
  ticketSelections: Array<CalendarEventTicketSelection>;
  ticketsTotal: Scalars['Decimal']['output'];
  total: Scalars['Decimal']['output'];
};

export type CalendarEventTicketCartPaginationHandler = {
  __typename?: 'CalendarEventTicketCartPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<CalendarEventTicketCart>;
};

export type CalendarEventTicketGroup = {
  __typename?: 'CalendarEventTicketGroup';
  availableCount?: Maybe<Scalars['Int']['output']>;
  committedCount?: Maybe<Scalars['Int']['output']>;
  heldCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Decimal']['output'];
  soldCount?: Maybe<Scalars['Int']['output']>;
  totalQuantity?: Maybe<Scalars['Int']['output']>;
};

export type CalendarEventTicketGroupInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
};

export type CalendarEventTicketSelection = {
  __typename?: 'CalendarEventTicketSelection';
  lineTotal: Scalars['Decimal']['output'];
  quantity: Scalars['Int']['output'];
  ticketGroup: CalendarEventTicketGroup;
};

export type CalendarEventTicketSelectionInput = {
  /** Desired total quantity for this ticket group, not a delta */
  quantity: Scalars['Int']['input'];
  ticketGroupId: Scalars['Int']['input'];
};

export type CallsByHourByDate = {
  __typename?: 'CallsByHourByDate';
  callsByHour?: Maybe<Array<AnsweringOverviewCallsByHour>>;
};

export type Campaign = {
  __typename?: 'Campaign';
  id: Scalars['Int']['output'];
};

export type CampaignItem = {
  __typename?: 'CampaignItem';
  aiMarketingContentId?: Maybe<Scalars['Int']['output']>;
  campaignId: Scalars['Int']['output'];
  campaignName: Scalars['String']['output'];
  channel: Channel;
  channelDisplayType: Array<Scalars['String']['output']>;
  channelId: Scalars['Int']['output'];
  channelType: Scalars['String']['output'];
  channelUpdatedAt: Scalars['DateTime']['output'];
  clickRate?: Maybe<Scalars['Float']['output']>;
  communicationType?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deliveredMessagesCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  instagramLivePosts: Array<SocialPostInstagramLivePost>;
  isCreatedByAi: Scalars['Boolean']['output'];
  livePosts: Array<SocialPostLivePost>;
  locationIds: Array<Scalars['Int']['output']>;
  locationNames: Array<Scalars['String']['output']>;
  openRate?: Maybe<Scalars['Float']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  statusAt: Scalars['DateTime']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type CampaignItemInput = {
  status?: InputMaybe<Scalars['String']['input']>;
  statusAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CampaignItemPaginationHandler = {
  __typename?: 'CampaignItemPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<CampaignItem>;
};

/** Autogenerated input type of CancelCampaign */
export type CancelCampaignInput = {
  campaignId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CancelMessageGroup */
export type CancelMessageGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageGroupId: Scalars['Int']['input'];
};

/** Autogenerated input type of CancelTextMessageGroup */
export type CancelTextMessageGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  textMessageGroupId: Scalars['Int']['input'];
};

export enum Cart {
  CateringCartType = 'catering_cart_type',
  DefaultCartType = 'default_cart_type'
}

export type CartPaymentInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  authorization?: InputMaybe<Scalars['String']['input']>;
  cardBrand?: InputMaybe<Scalars['String']['input']>;
  cardLast4?: InputMaybe<Scalars['String']['input']>;
  cloverToken?: InputMaybe<Scalars['String']['input']>;
  cloverWalletType?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  externalReferenceId?: InputMaybe<Scalars['String']['input']>;
  fingerprint?: InputMaybe<Scalars['String']['input']>;
  firstSixDigits?: InputMaybe<Scalars['String']['input']>;
  heartlandToken?: InputMaybe<Scalars['String']['input']>;
  lastFourDigits?: InputMaybe<Scalars['String']['input']>;
  ncrSilverToken?: InputMaybe<Scalars['String']['input']>;
  nmiToken?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  squareBuyerVerificationToken?: InputMaybe<Scalars['String']['input']>;
  squareNonce?: InputMaybe<Scalars['String']['input']>;
  squareWalletType?: InputMaybe<Scalars['String']['input']>;
  stripePaymentIntentId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentTokenId?: InputMaybe<Scalars['String']['input']>;
  stripePublishableKey?: InputMaybe<Scalars['String']['input']>;
  toastExpirationDate?: InputMaybe<Scalars['String']['input']>;
  toastFingerprint?: InputMaybe<Scalars['String']['input']>;
  toastFirstSixDigits?: InputMaybe<Scalars['String']['input']>;
  toastLastFourDigits?: InputMaybe<Scalars['String']['input']>;
  toastPostalCode?: InputMaybe<Scalars['String']['input']>;
  toastTipAmount?: InputMaybe<Scalars['Decimal']['input']>;
  toastToken?: InputMaybe<Scalars['String']['input']>;
  toastWalletType?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type CasePaginationHandler = {
  __typename?: 'CasePaginationHandler';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  offset: Scalars['Int']['output'];
  records: Array<SalesforceCase>;
};

export type CategoryPaginationHandler = {
  __typename?: 'CategoryPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<GoogleMyBusinessCategory>;
};

export type CcpaRequest = {
  __typename?: 'CcpaRequest';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isCaliforniaResident?: Maybe<Scalars['Boolean']['output']>;
  isDeleteDataRequest?: Maybe<Scalars['Boolean']['output']>;
  isLearnHowDataIsUsedRequest?: Maybe<Scalars['Boolean']['output']>;
  isLearnHowDataWasObtainedRequest?: Maybe<Scalars['Boolean']['output']>;
  isLearnIfDataWasSharedRequest?: Maybe<Scalars['Boolean']['output']>;
  isLearnWhatDataWeHaveRequest?: Maybe<Scalars['Boolean']['output']>;
  isResolved?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CcpaRequestInput = {
  email: Scalars['String']['input'];
  isCaliforniaResident: Scalars['Boolean']['input'];
  isDeleteDataRequest: Scalars['Boolean']['input'];
  isLearnHowDataIsUsedRequest: Scalars['Boolean']['input'];
  isLearnHowDataWasObtainedRequest: Scalars['Boolean']['input'];
  isLearnIfDataWasSharedRequest: Scalars['Boolean']['input'];
  isLearnWhatCategoriesWeHaveRequest: Scalars['Boolean']['input'];
  isLearnWhatCategoryThirdPartiesRequest: Scalars['Boolean']['input'];
  isLearnWhatDataWeHaveRequest: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type CcpaRequestPaginationHandler = {
  __typename?: 'CcpaRequestPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<CcpaRequest>;
};

/** Autogenerated input type of ChangeStatusOrderingOffer */
export type ChangeStatusOrderingOfferInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  offerStatus: Scalars['String']['input'];
  orderingOfferId: Scalars['Int']['input'];
};

/** Autogenerated input type of ChangeStatusUpsellCampaign */
export type ChangeStatusUpsellCampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  upsellCampaignId: Scalars['Int']['input'];
};

/** Channels for campaign items */
export type Channel = GooglePost | MessageGroup | PushMessageGroup | RestaurantMessagePackCommunication | SocialPost | TextMessageGroup;

export type ChargebeeEstimate = {
  __typename?: 'ChargebeeEstimate';
  chargeDiscount?: Maybe<Scalars['Int']['output']>;
  chargeTax?: Maybe<Scalars['Int']['output']>;
  chargeTotal?: Maybe<Scalars['Int']['output']>;
  charges?: Maybe<Array<ChargebeeEstimateItem>>;
  creditCardSurchargeCents: Scalars['Int']['output'];
  creditCardSurchargeRate: Scalars['Float']['output'];
  items?: Maybe<Array<ChargebeeEstimateItem>>;
  proratedDiscount?: Maybe<Scalars['Int']['output']>;
  proratedFrom?: Maybe<Scalars['Int']['output']>;
  proratedSubtotal?: Maybe<Scalars['Int']['output']>;
  proratedTax?: Maybe<Scalars['Int']['output']>;
  proratedTo?: Maybe<Scalars['Int']['output']>;
  proratedTotal?: Maybe<Scalars['Int']['output']>;
  renewalDiscount?: Maybe<Scalars['Int']['output']>;
  renewalSubtotal?: Maybe<Scalars['Int']['output']>;
  renewalTax?: Maybe<Scalars['Int']['output']>;
  renewalTotal?: Maybe<Scalars['Int']['output']>;
};

export type ChargebeeEstimateItem = {
  __typename?: 'ChargebeeEstimateItem';
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  subTotal: Scalars['Int']['output'];
};

export type ChatBotCoreCategory = {
  __typename?: 'ChatBotCoreCategory';
  description?: Maybe<Scalars['String']['output']>;
  hasCustomResponses?: Maybe<Scalars['Boolean']['output']>;
  hasNewIntents?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  intents?: Maybe<Array<ChatBotCoreIntent>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ChatBotCoreCopyIntent = {
  __typename?: 'ChatBotCoreCopyIntent';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type ChatBotCoreIntent = {
  __typename?: 'ChatBotCoreIntent';
  action?: Maybe<Scalars['Int']['output']>;
  categoryDescription?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customResponse?: Maybe<Scalars['String']['output']>;
  defaultResponse?: Maybe<Scalars['String']['output']>;
  fallbackPhoneId?: Maybe<Scalars['Int']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  intentType?: Maybe<Scalars['Int']['output']>;
  isCustomizable?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  needReview?: Maybe<Scalars['Boolean']['output']>;
  popDisplayName?: Maybe<Scalars['String']['output']>;
  popGroupName?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Array<Scalars['String']['output']>>;
  shouldDisplay?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ChatBotCoreIntentCustomResponse = {
  __typename?: 'ChatBotCoreIntentCustomResponse';
  action?: Maybe<Scalars['Int']['output']>;
  fallbackPhoneId?: Maybe<Scalars['Int']['output']>;
  intentName?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['Int']['output']>;
  needReview?: Maybe<Scalars['Boolean']['output']>;
  response?: Maybe<Scalars['String']['output']>;
};

export type ChatbotResponse = {
  __typename?: 'ChatbotResponse';
  response: Scalars['String']['output'];
};

export type ChatbotSession = {
  __typename?: 'ChatbotSession';
  chatbotSessionId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CheckPhoneVerification */
export type CheckPhoneVerificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

/** Autogenerated input type of ClearAllRestaurantOpenCarts */
export type ClearAllRestaurantOpenCartsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

export type CloneMenuItemCartReturn = {
  __typename?: 'CloneMenuItemCartReturn';
  menuItemCart: MenuItemCart;
  rejectedSelectedMenuItems?: Maybe<Array<Scalars['Int']['output']>>;
};

/** Autogenerated input type of CloneMenuItemCartSelectedMenuItemV2 */
export type CloneMenuItemCartSelectedMenuItemV2Input = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuItemCartId?: InputMaybe<Scalars['Int']['input']>;
  selectedMenuItemId: Scalars['Int']['input'];
};

/** Autogenerated input type of CloneMenuItemCartV2 */
export type CloneMenuItemCartV2Input = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuItemCartId: Scalars['Int']['input'];
  pendingMenuItemCartId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of CloseMenuItemCartV2 */
export type CloseMenuItemCartV2Input = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  didAdminCloseCart?: InputMaybe<Scalars['Boolean']['input']>;
  expectedTabTotal?: InputMaybe<Scalars['Decimal']['input']>;
  menuItemCartId: Scalars['Int']['input'];
  menuItemCartInput: MenuItemCartInput;
  paymentInput?: InputMaybe<CartPaymentInput>;
};

export type CloudflareTrafficReport = {
  __typename?: 'CloudflareTrafficReport';
  aiCrawlerOperatorsCount: Scalars['Int']['output'];
  aiCrawlerRequests?: Maybe<Scalars['Int']['output']>;
  aiCrawlerStats: Array<CloudflareTrafficReportCrawlerStat>;
  aiReferralStats: Array<CloudflareTrafficReportReferralStat>;
  aiReferralVisits?: Maybe<Scalars['Int']['output']>;
  domain: Scalars['String']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  humanRequests?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  searchEngineRequests?: Maybe<Scalars['Int']['output']>;
  totalRequests?: Maybe<Scalars['Int']['output']>;
  totalVisits?: Maybe<Scalars['Int']['output']>;
  year: Scalars['Int']['output'];
};

export type CloudflareTrafficReportCrawlerStat = {
  __typename?: 'CloudflareTrafficReportCrawlerStat';
  bytes?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  crawler: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  operator?: Maybe<Scalars['String']['output']>;
  requests?: Maybe<Scalars['Int']['output']>;
};

export type CloudflareTrafficReportReferralStat = {
  __typename?: 'CloudflareTrafficReportReferralStat';
  id: Scalars['Int']['output'];
  source: Scalars['String']['output'];
  visits?: Maybe<Scalars['Int']['output']>;
};

export type CloverAccount = RestaurantPaymentAccountInterface & {
  __typename?: 'CloverAccount';
  accountSlug: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  accountUrl: Scalars['String']['output'];
  address: Scalars['String']['output'];
  canDisconnectPos: Scalars['Boolean']['output'];
  city: Scalars['String']['output'];
  cloverDefaultTaxRates?: Maybe<Array<CloverTaxRate>>;
  cloverOrderTypes?: Maybe<Array<CloverOrderType>>;
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  hasInvalidRefreshToken?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isAppConnected?: Maybe<Scalars['Boolean']['output']>;
  isAvailable: Scalars['Boolean']['output'];
  isDeleting: Scalars['Boolean']['output'];
  isGiftCardTenderEnabled?: Maybe<Scalars['Boolean']['output']>;
  isMenuSyncing: Scalars['Boolean']['output'];
  isOrderTypeSelected?: Maybe<Scalars['Boolean']['output']>;
  isPrintingOrderReceiptsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isShopSupported: Scalars['Boolean']['output'];
  isSyncing?: Maybe<Scalars['Boolean']['output']>;
  lastSyncStartedAt?: Maybe<Scalars['DateTime']['output']>;
  menuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  merchantId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orderTypeCurbside?: Maybe<CloverOrderType>;
  orderTypeDelivery?: Maybe<CloverOrderType>;
  orderTypeDineIn?: Maybe<CloverOrderType>;
  orderTypeTakeOut?: Maybe<CloverOrderType>;
  ownerEmail: Scalars['String']['output'];
  ownerName: Scalars['String']['output'];
  restaurant?: Maybe<Restaurant>;
  shouldReauthenticate: Scalars['Boolean']['output'];
  state: Scalars['String']['output'];
  url: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type CloverAccountInput = {
  isPrintingOrderReceiptsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CloverOrderType = {
  __typename?: 'CloverOrderType';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type CloverOrderTypesInput = {
  orderTypeCurbsideId?: InputMaybe<Scalars['Int']['input']>;
  orderTypeDeliveryId?: InputMaybe<Scalars['Int']['input']>;
  orderTypeDineInId?: InputMaybe<Scalars['Int']['input']>;
  orderTypeTakeOutId?: InputMaybe<Scalars['Int']['input']>;
};

export type CloverTaxRate = {
  __typename?: 'CloverTaxRate';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  rate: Scalars['Int']['output'];
};

export type CombinedContentAudits = {
  __typename?: 'CombinedContentAudits';
  /** Flagged automated email content audits for the restaurant */
  automatedEmailAudits: Array<MessageCampaignContentAudit>;
  /** Flagged email content audits for the restaurant */
  emailAudits: Array<MessageGroupContentAudit>;
  /** Flagged SMS content audits for the restaurant */
  smsAudits: Array<TextMessageGroupContentAudit>;
  /** Total count of flagged content audits (SMS + Email) */
  totalCount: Scalars['Int']['output'];
};

export type CombinedLocationOptions = {
  __typename?: 'CombinedLocationOptions';
  excludeOptions: Array<MessageLocationOption>;
  selectOptions: Array<MessageLocationOption>;
};

export type CombinedMessageTagOptions = {
  __typename?: 'CombinedMessageTagOptions';
  followerTotal: Scalars['Int']['output'];
  tagOptions: Array<MessageTagOption>;
};

/** Autogenerated input type of CompareAimPlaygroundEvaluationSets */
export type CompareAimPlaygroundEvaluationSetsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  controlBatchId: Scalars['Int']['input'];
  treatmentBatchId: Scalars['Int']['input'];
};

/** Autogenerated input type of CompleteLocationPurchase */
export type CompleteLocationPurchaseInput = {
  billingCustomerId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  location: AddonCheckoutLocationPurchaseLocationInput;
  payment: AddonCheckoutLocationPurchasePaymentInput;
  productBillingPlanIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  salesforceContactSfid?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CompletePushMfaEnrollment */
export type CompletePushMfaEnrollmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  providerFactorSid: Scalars['String']['input'];
  userMfaFactorId: Scalars['Int']['input'];
};

/** Autogenerated input type of ConfirmMenuUpload */
export type ConfirmMenuUploadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: ConfirmUploadInput;
};

export type ConfirmUploadInput = {
  contentType: Scalars['String']['input'];
  menuProcessingResultId: Scalars['ID']['input'];
};

/** Autogenerated input type of ConnectHungrrrPayAccount */
export type ConnectHungrrrPayAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
  stripeAccountId: Scalars['String']['input'];
};

/** Autogenerated input type of ConnectRestaurantEcardAccountType */
export type ConnectRestaurantEcardAccountTypeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ecardAccountInput: EcardAccountInputType;
  restaurantId: Scalars['ID']['input'];
};

/** Autogenerated input type of ConnectRestaurantLocationAlohaSite */
export type ConnectRestaurantLocationAlohaSiteInput = {
  alohaAccountId: Scalars['Int']['input'];
  alohaSiteId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
};

/** Autogenerated input type of ConnectRestaurantLocationMicrosRvc */
export type ConnectRestaurantLocationMicrosRvcInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  microsMenuId: Scalars['String']['input'];
  microsOrgId: Scalars['Int']['input'];
};

/** Autogenerated input type of ConnectSalesforceAccount */
export type ConnectSalesforceAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
  salesforceAccountSfid: Scalars['String']['input'];
};

export type ConsentManagerConfigInput = {
  acceptButtonText?: InputMaybe<Scalars['String']['input']>;
  bannerDescription?: InputMaybe<Scalars['String']['input']>;
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  closeButtonAction?: InputMaybe<Scalars['String']['input']>;
  declineButtonText?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isScriptConsentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  privacyPolicyLinkText?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  showAcceptButton?: InputMaybe<Scalars['Boolean']['input']>;
  showCloseButton?: InputMaybe<Scalars['Boolean']['input']>;
  showCookieBadge?: InputMaybe<Scalars['Boolean']['input']>;
  showCookieCategories?: InputMaybe<Scalars['Boolean']['input']>;
  showDeclineButton?: InputMaybe<Scalars['Boolean']['input']>;
  showPrivacyPolicyLink?: InputMaybe<Scalars['Boolean']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
};

/** Content items for AI marketing */
export type Content = MessageGroup | SocialPost | TextMessageGroup;

export type ContentBuilderPreview = {
  __typename?: 'ContentBuilderPreview';
  errorMessage?: Maybe<Scalars['String']['output']>;
  hasError?: Maybe<Scalars['Boolean']['output']>;
  previewHtml: Scalars['String']['output'];
};

export type Coordinates = {
  __typename?: 'Coordinates';
  lat: Scalars['Decimal']['output'];
  lng: Scalars['Decimal']['output'];
};

/** Autogenerated input type of CopyAllCustomResponses */
export type CopyAllCustomResponsesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fromLocationId: Scalars['Int']['input'];
  isForwardingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isVoicemailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  primaryFallbackPhoneId?: InputMaybe<Scalars['Int']['input']>;
  toLocationId: Scalars['Int']['input'];
};

/** Autogenerated input type of CopyCategoryCustomResponses */
export type CopyCategoryCustomResponsesInput = {
  category: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fromLocationId: Scalars['Int']['input'];
  isForwardingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isVoicemailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  primaryFallbackPhoneId?: InputMaybe<Scalars['Int']['input']>;
  toLocationId: Scalars['Int']['input'];
};

/** Autogenerated input type of CopyMessageGroup */
export type CopyMessageGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageGroupId: Scalars['Int']['input'];
};

/** Autogenerated input type of CopySyncedMenu */
export type CopySyncedMenuInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuId: Scalars['Int']['input'];
  menusInput: Array<MenuInput>;
};

/** Autogenerated input type of CreateAgentChat */
export type CreateAgentChatInput = {
  agentType: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateAgentChatMessage */
export type CreateAgentChatMessageInput = {
  agentChatId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
};

/** Autogenerated input type of CreateAimPromptConfig */
export type CreateAimPromptConfigInput = {
  aimPromptConfigInput: AimPromptConfigInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CreateAlohaAccount */
export type CreateAlohaAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};

/** Autogenerated input type of CreateAuthorizeAccount */
export type CreateAuthorizeAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  loginId: Scalars['String']['input'];
  merchantName: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
  transactionKey: Scalars['String']['input'];
};

/** Autogenerated input type of CreateAuthorizeAccountPaymentPageToken */
export type CreateAuthorizeAccountPaymentPageTokenInput = {
  amount: Scalars['Decimal']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateBillingEntitlementFeatureFlag */
export type CreateBillingEntitlementFeatureFlagInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  featureManagementInput: BillingEntitlementFeatureFlagInput;
};

/** Autogenerated input type of CreateBillingInvoice */
export type CreateBillingInvoiceInput = {
  billingInvoiceInput: BillingInvoiceInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CreateBillingProduct */
export type CreateBillingProductInput = {
  billingProductInput: BillingProductInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CreateBillingProductPrice */
export type CreateBillingProductPriceInput = {
  billingProductId: Scalars['Int']['input'];
  billingProductPriceInput: BillingProductPriceInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CreateCalendarEvent */
export type CreateCalendarEventInput = {
  calendarEventInput: CalendarEventInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateCloverAccount */
export type CreateCloverAccountInput = {
  clientId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cloverCode: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateConsumerUserByPhone */
export type CreateConsumerUserByPhoneInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  followerInput?: InputMaybe<FollowerInput>;
  userInput?: InputMaybe<UserInput>;
};

/** Autogenerated input type of CreateCustomResponseExport */
export type CreateCustomResponseExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateCustomTaxRate */
export type CreateCustomTaxRateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: CustomTaxRateInput;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateDeliverectChannel */
export type CreateDeliverectChannelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateDemoSiteReviews */
export type CreateDemoSiteReviewsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateDineInQrCard */
export type CreateDineInQrCardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  qrCardInput: DineInQrCardInput;
};

/** Autogenerated input type of CreateEngagementOfferPreview */
export type CreateEngagementOfferPreviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageCampaignId: Scalars['Int']['input'];
  messageCampaignInput: MessageCampaignInput;
  orderingOfferInput: OrderingOfferInput;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateFacebookCampaign */
export type CreateFacebookCampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facebookCampaignInput: FacebookCampaignInput;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateFollower */
export type CreateFollowerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  favoriteLocationId?: InputMaybe<Scalars['Int']['input']>;
  isWelcomeMessageEnabled: Scalars['Boolean']['input'];
  restaurantId: Scalars['Int']['input'];
  userInput: UserInput;
};

/** Autogenerated input type of CreateFollowerQrCard */
export type CreateFollowerQrCardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateHeartlandAccount */
export type CreateHeartlandAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  publicKey: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
  secretKey: Scalars['String']['input'];
};

/** Autogenerated input type of CreateMenuExport */
export type CreateMenuExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  menuId?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateMenuFromWoflowImport */
export type CreateMenuFromWoflowImportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  jsonFileUrl: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateMenuItemCartDeliveryV2 */
export type CreateMenuItemCartDeliveryV2Input = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuItemCartId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateMessageCampaignPreview */
export type CreateMessageCampaignPreviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  messageCampaignInput: MessageCampaignInput;
};

/** Autogenerated input type of CreateMessageCampaignTextMessagePreview */
export type CreateMessageCampaignTextMessagePreviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  messageCampaignInput: MessageCampaignInput;
};

/** Autogenerated input type of CreateMessageGroupContent */
export type CreateMessageGroupContentInput = {
  builderContentInput: BuilderContentInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentOrder?: InputMaybe<Scalars['Int']['input']>;
  messageGroupId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateMessageGroupFromTemplate */
export type CreateMessageGroupFromTemplateInput = {
  allSelected?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  excludedFollowerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  followerSegmentId?: InputMaybe<Scalars['Int']['input']>;
  remarketedAction?: InputMaybe<Scalars['String']['input']>;
  remarketedCampaignItemId?: InputMaybe<Scalars['Int']['input']>;
  remarketedLocationId?: InputMaybe<Scalars['Int']['input']>;
  remarketedTagId?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
  rootMessagePackId?: InputMaybe<Scalars['Int']['input']>;
  selectedFollowerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  selectedLocationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Autogenerated input type of CreateMessageGroup */
export type CreateMessageGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageGroupInput: MessageGroupInput;
};

/** Autogenerated input type of CreateMessageGroupPreview */
export type CreateMessageGroupPreviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messagePreviewInput: MessagePreviewInput;
};

/** Autogenerated input type of CreateMicrosOrg */
export type CreateMicrosOrgInput = {
  authUrl: Scalars['String']['input'];
  baseUrl: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orgShortName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

/** Autogenerated input type of CreateNcrPaymentAccount */
export type CreateNcrPaymentAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ncrPaymentAccountInput: NcrPaymentAccountCreateInput;
};

/** Autogenerated input type of CreateNcrSilverAccount */
export type CreateNcrSilverAccountInput = {
  clientId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientSecret: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateNmiAccount */
export type CreateNmiAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
  securityKey: Scalars['String']['input'];
  tokenizationKey: Scalars['String']['input'];
};

/** Autogenerated input type of CreateOAuthIntegration */
export type CreateOAuthIntegrationInput = {
  accountType: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  params: OauthIntegrationParamsInput;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateOrUpdateHighlight */
export type CreateOrUpdateHighlightInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ctaButtonType?: InputMaybe<Scalars['String']['input']>;
  ctaCustomLinkText?: InputMaybe<Scalars['String']['input']>;
  ctaCustomLinkUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  highlightId?: InputMaybe<Scalars['ID']['input']>;
  highlightReelId?: InputMaybe<Scalars['ID']['input']>;
  highlightableId?: InputMaybe<Scalars['ID']['input']>;
  highlightableType?: InputMaybe<Scalars['String']['input']>;
  isShowCtaButton?: InputMaybe<Scalars['Boolean']['input']>;
  position: Scalars['Int']['input'];
  restaurantId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  uploadedPhotoId?: InputMaybe<Scalars['ID']['input']>;
  uploadedVideoId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated input type of CreateOrUpdateHighlightReel */
export type CreateOrUpdateHighlightReelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  highlightInput?: InputMaybe<CreateOrUpdateHighlightInput>;
  highlightReelId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['ID']['input'];
};

/** Autogenerated input type of CreateOrUpdateLoyaltyProgramPromotion */
export type CreateOrUpdateLoyaltyProgramPromotionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  loyaltyProgramId: Scalars['Int']['input'];
  loyaltyProgramPromotionId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  points: Scalars['Int']['input'];
  promotionType: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
  status: Scalars['String']['input'];
};

/** Autogenerated input type of CreateOrUpdateMenuSectionHighlightReviews */
export type CreateOrUpdateMenuSectionHighlightReviewsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuId: Scalars['ID']['input'];
};

/** Autogenerated input type of CreateOrUpdatePopmenuLoyaltyAccount */
export type CreateOrUpdatePopmenuLoyaltyAccountInput = {
  balanceChange?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  followerId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of CreateOrUpdatePopmenuLoyaltyProgram */
export type CreateOrUpdatePopmenuLoyaltyProgramInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateOrUpdateReviewReply */
export type CreateOrUpdateReviewReplyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Message Reply Content */
  content: Scalars['String']['input'];
  /** Publish Review */
  isPublic: Scalars['Boolean']['input'];
  /** Offer ID */
  offerId?: InputMaybe<Scalars['Int']['input']>;
  /** Ordering Offer ID */
  orderingOfferId?: InputMaybe<Scalars['Int']['input']>;
  /** Review ID */
  reviewId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateOrUpdateRewardTiers */
export type CreateOrUpdateRewardTiersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  loyaltyProgramId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
  rewardTierInput: RewardTierInput;
};

/** Autogenerated input type of CreateOrderExport */
export type CreateOrderExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: OrderExportInput;
  locationId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateOrderingBlackout */
export type CreateOrderingBlackoutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  orderingBlackoutInput: OrderingBlackoutCreateInput;
};

/** Autogenerated input type of CreateOrderingEvent */
export type CreateOrderingEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: OrderingEventInput;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateOrderingOffer */
export type CreateOrderingOfferInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderingOfferInput: OrderingOfferInput;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateOrderingReportExport */
export type CreateOrderingReportExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: OrderingReportExportInput;
  restaurantId: Scalars['ID']['input'];
};

/** Autogenerated input type of CreateOverviewExport */
export type CreateOverviewExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  overviewExportInput: OverviewExportInput;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreatePhoneVerification */
export type CreatePhoneVerificationInput = {
  channel: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
};

export type CreatePostInput = {
  actionType?: InputMaybe<Scalars['String']['input']>;
  actionUrl?: InputMaybe<Scalars['String']['input']>;
  alertType?: InputMaybe<Scalars['String']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['Time']['input']>;
  isScheduled: Scalars['Boolean']['input'];
  photoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  redeemOnlineUrl?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['Time']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  termsConditions?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topicType: Scalars['String']['input'];
};

/** Autogenerated input type of CreatePreviewFromTemplate */
export type CreatePreviewFromTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
  rootMessagePackId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of CreatePushMessageGroup */
export type CreatePushMessageGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  pushMessageGroupInput: PushMessageGroupInput;
};

/** Autogenerated input type of CreatePushMfaEnrollmentAccessToken */
export type CreatePushMfaEnrollmentAccessTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userMfaFactorId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateQrCard */
export type CreateQrCardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  qrCardInput: QrCardInput;
};

/** Autogenerated input type of CreateResellerSignUpSurvey */
export type CreateResellerSignUpSurveyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  resellerEmail: Scalars['String']['input'];
  resellerSurveyInput: ResellerSignUpSurveyInput;
};

/** Autogenerated input type of CreateRestaurantCustomScript */
export type CreateRestaurantCustomScriptInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customScriptInput: RestaurantCustomScriptInput;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateRestaurantCustomTracking */
export type CreateRestaurantCustomTrackingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customTrackingInput: RestaurantCustomTrackingInput;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateRestaurantGroup */
export type CreateRestaurantGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Autogenerated input type of CreateRestaurantMessagePack */
export type CreateRestaurantMessagePackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
  rootMessagePackId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateRestaurantScriptDomain */
export type CreateRestaurantScriptDomainInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
  scriptDomainInput: RestaurantScriptDomainInput;
};

/** Autogenerated input type of CreateRestaurantWebhook */
export type CreateRestaurantWebhookInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
  webhookInput: RestaurantWebhookInput;
};

export type CreateRootDishTagReturn = {
  __typename?: 'CreateRootDishTagReturn';
  popmenuConfig: PopmenuConfig;
  rootDishTag: RootDishTag;
};

/** Autogenerated input type of CreateRootMessagePack */
export type CreateRootMessagePackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messagePackInput: RootMessagePackInput;
};

/** Autogenerated input type of CreateRootMessagePackMessage */
export type CreateRootMessagePackMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageInput: RootMessagePackMessageInput;
  restaurantId: Scalars['Int']['input'];
  rootMessagePackId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateRootMessagePackSocialPost */
export type CreateRootMessagePackSocialPostInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
  rootMessagePackId: Scalars['Int']['input'];
  socialPostInput: RootMessagePackSocialPostInput;
};

/** Autogenerated input type of CreateSocialPost */
export type CreateSocialPostInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  socialPostInput: SocialPostInput;
};

/** Autogenerated input type of CreateTableTop */
export type CreateTableTopInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: TableTopInput;
  locationId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateTextMessageGroup */
export type CreateTextMessageGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  textMessageGroupInput: TextMessageGroupInput;
};

/** Autogenerated input type of CreateTextMessageGroupMessagePreview */
export type CreateTextMessageGroupMessagePreviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  textMessageGroupInput: TextMessageGroupInput;
};

/** Autogenerated input type of CreateTextMessageGroupPreview */
export type CreateTextMessageGroupPreviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  textMessageGroupInput: TextMessageGroupInput;
};

/** Autogenerated input type of CreateTwilioBannedWord */
export type CreateTwilioBannedWordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  word: Scalars['String']['input'];
};

/** Autogenerated input type of CreateTwilioVerifyPushChallenge */
export type CreateTwilioVerifyPushChallengeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  factorSid: Scalars['String']['input'];
};

/** Autogenerated input type of CreateTwilioVerifyTotpChallenge */
export type CreateTwilioVerifyTotpChallengeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  factorSid: Scalars['String']['input'];
};

/** Autogenerated input type of CreateTwilioVerifyTotpFactor */
export type CreateTwilioVerifyTotpFactorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CreateUploadFolder */
export type CreateUploadFolderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentFolderId?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
  uploadType: Scalars['String']['input'];
};

/** Autogenerated input type of CreateUpsellCampaign */
export type CreateUpsellCampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: UpsellCampaignInput;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateUserApiToken */
export type CreateUserApiTokenInput = {
  apiTokenInput: UserApiTokenInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

export type CuisineType = {
  __typename?: 'CuisineType';
  googleMyBusinessCategory?: Maybe<GoogleMyBusinessCategory>;
  googleMyBusinessCategoryId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  yextCategory?: Maybe<YextCategory>;
  yextCategoryId?: Maybe<Scalars['Int']['output']>;
};

export type CuisineTypePaginationHandler = {
  __typename?: 'CuisineTypePaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<CuisineType>;
};

export type CustomFee = {
  __typename?: 'CustomFee';
  amount?: Maybe<Scalars['Decimal']['output']>;
  amountType?: Maybe<Scalars['String']['output']>;
  cateringDeliveryFulfillmentType?: Maybe<Scalars['Boolean']['output']>;
  cateringPayAtPickupFulfillmentType?: Maybe<Scalars['Boolean']['output']>;
  cateringPickupFulfillmentType?: Maybe<Scalars['Boolean']['output']>;
  deliveryFulfillmentType?: Maybe<Scalars['Boolean']['output']>;
  dineInFulfillmentType?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  location?: Maybe<RestaurantLocation>;
  name?: Maybe<Scalars['String']['output']>;
  orderingEventsPickupFulfillmentType?: Maybe<Scalars['Boolean']['output']>;
  payAtPickupFulfillmentType: Scalars['Boolean']['output'];
  pickupFulfillmentType?: Maybe<Scalars['Boolean']['output']>;
  revenueShared: Scalars['Boolean']['output'];
  taxable?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomFeeInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  amountType?: InputMaybe<Scalars['Int']['input']>;
  cateringDeliveryFulfillmentType?: InputMaybe<Scalars['Boolean']['input']>;
  cateringPayAtPickupFulfillmentType?: InputMaybe<Scalars['Boolean']['input']>;
  cateringPickupFulfillmentType?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryFulfillmentType?: InputMaybe<Scalars['Boolean']['input']>;
  dineInFulfillmentType?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderingEventsPickupFulfillmentType?: InputMaybe<Scalars['Boolean']['input']>;
  payAtPickupFulfillmentType?: InputMaybe<Scalars['Boolean']['input']>;
  pickupFulfillmentType?: InputMaybe<Scalars['Boolean']['input']>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomFeePaginationHandler = {
  __typename?: 'CustomFeePaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<CustomFee>;
};

export type CustomFile = Eventable & {
  __typename?: 'CustomFile';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  eventableName: Scalars['String']['output'];
  fileContentType: Scalars['String']['output'];
  fileExtension: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  fileUrl: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isOloMenu?: Maybe<Scalars['Boolean']['output']>;
  menuCategoryName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  publicFileUrl: Scalars['String']['output'];
  restaurant: Restaurant;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  uploadedFile?: Maybe<UploadedFile>;
};

export type CustomFilePaginationHandler = {
  __typename?: 'CustomFilePaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<CustomFile>;
};

export type CustomForm = {
  __typename?: 'CustomForm';
  allowAttachments?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customPageSection?: Maybe<CustomPageSection>;
  description?: Maybe<Scalars['String']['output']>;
  displayGeneralFeedback?: Maybe<Scalars['Boolean']['output']>;
  emailCsv?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isPhoneRequired?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  restaurant?: Maybe<Restaurant>;
  restaurantId: Scalars['Int']['output'];
  sectionId?: Maybe<Scalars['Int']['output']>;
  showDateField?: Maybe<Scalars['Boolean']['output']>;
  showLocationDropdown?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomFormDraft = {
  __typename?: 'CustomFormDraft';
  allowAttachments?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customPageSection?: Maybe<CustomPageSectionDraft>;
  description?: Maybe<Scalars['String']['output']>;
  displayGeneralFeedback?: Maybe<Scalars['Boolean']['output']>;
  emailCsv?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isPhoneRequired?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  restaurant?: Maybe<Restaurant>;
  restaurantId: Scalars['Int']['output'];
  sectionId?: Maybe<Scalars['Int']['output']>;
  showDateField?: Maybe<Scalars['Boolean']['output']>;
  showLocationDropdown?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomFormInput = {
  allowAttachments?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayGeneralFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  emailCsv?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  isPhoneRequired?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  showDateField?: InputMaybe<Scalars['Boolean']['input']>;
  showLocationDropdown?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomFormPaginationHandler = {
  __typename?: 'CustomFormPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<CustomForm>;
};

export type CustomImage = {
  __typename?: 'CustomImage';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imageHeight?: Maybe<Scalars['Int']['output']>;
  imageSize?: Maybe<Scalars['String']['output']>;
  imageUrl: Scalars['String']['output'];
  imageWidth?: Maybe<Scalars['Int']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
};

export type CustomPage = Eventable & NavLinkable & PageContentable & {
  __typename?: 'CustomPage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customCanonicalUrl?: Maybe<Scalars['String']['output']>;
  customHref?: Maybe<Scalars['String']['output']>;
  customMetaDescription?: Maybe<Scalars['String']['output']>;
  customMetaImageUploadedPhoto?: Maybe<UploadedPhoto>;
  customMetaImageUrl?: Maybe<Scalars['String']['output']>;
  customMetaKeywords?: Maybe<Scalars['String']['output']>;
  customMetaTitle: Scalars['String']['output'];
  defaultMetaDescription?: Maybe<Scalars['String']['output']>;
  defaultMetaKeywords?: Maybe<Scalars['String']['output']>;
  disableAjaxLoad?: Maybe<Scalars['Boolean']['output']>;
  draftId?: Maybe<Scalars['Int']['output']>;
  eventableName: Scalars['String']['output'];
  firstMenuId?: Maybe<Scalars['Int']['output']>;
  hasCateringSection: Scalars['Boolean']['output'];
  hasOnlineOrderingSection: Scalars['Boolean']['output'];
  hasQrCard: Scalars['Boolean']['output'];
  headerBgFullHeight?: Maybe<Scalars['Boolean']['output']>;
  headerFontCase?: Maybe<Scalars['String']['output']>;
  headerImageSetting?: Maybe<Scalars['String']['output']>;
  headerLinkCustomPageId?: Maybe<Scalars['Int']['output']>;
  headerLinkText?: Maybe<Scalars['String']['output']>;
  headerLinkUrl?: Maybe<Scalars['String']['output']>;
  headerTransitionTiming?: Maybe<Scalars['Int']['output']>;
  headerTransitionType: Scalars['String']['output'];
  heroBackgroundColor?: Maybe<Scalars['String']['output']>;
  heroImages: Array<CustomPageHeroImage>;
  heroLogoAlt?: Maybe<Scalars['String']['output']>;
  heroLogoUploadedPhoto?: Maybe<UploadedPhoto>;
  heroLogoUrl?: Maybe<Scalars['String']['output']>;
  heroVideoCloudflareId?: Maybe<Scalars['String']['output']>;
  heroVideoHeight?: Maybe<Scalars['Int']['output']>;
  heroVideoThumbnailUrl?: Maybe<Scalars['String']['output']>;
  heroVideoUploadedVideo?: Maybe<UploadedVideo>;
  heroVideoUrl?: Maybe<Scalars['String']['output']>;
  heroVideoWidth?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isExternal?: Maybe<Scalars['Boolean']['output']>;
  isHeaderEnabled?: Maybe<Scalars['Boolean']['output']>;
  isHomePage?: Maybe<Scalars['Boolean']['output']>;
  isMemberOnly?: Maybe<Scalars['Boolean']['output']>;
  isNavEnabled?: Maybe<Scalars['Boolean']['output']>;
  lighthouseReportPageReports: Array<LighthouseReportPageReport>;
  linkType?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaImageType?: Maybe<Scalars['String']['output']>;
  metaImageUrl?: Maybe<Scalars['String']['output']>;
  metaKeywords?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  navbarLogoToggle?: Maybe<Scalars['Boolean']['output']>;
  performanceMetadata?: Maybe<CustomPagePerformanceMetadata>;
  recentVisitsCount?: Maybe<Scalars['Int']['output']>;
  restaurant: Restaurant;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  screenshotAt?: Maybe<Scalars['DateTime']['output']>;
  screenshotUrl?: Maybe<Scalars['String']['output']>;
  sections: Array<CustomPageSection>;
  slug: Scalars['String']['output'];
  subheading?: Maybe<Scalars['String']['output']>;
  tabName?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  visitsCount?: Maybe<Scalars['Int']['output']>;
};

export type CustomPageAdvancedForm = {
  __typename?: 'CustomPageAdvancedForm';
  becomeFollowerEnabled: Scalars['Boolean']['output'];
  blockedCount: Scalars['Int']['output'];
  customPage?: Maybe<CustomPage>;
  draftSectionId?: Maybe<Scalars['Int']['output']>;
  emailResponsesTo?: Maybe<Scalars['String']['output']>;
  emailSubjectLine?: Maybe<Scalars['String']['output']>;
  emailThankYouContent?: Maybe<Scalars['String']['output']>;
  entries?: Maybe<Array<CustomPageAdvancedFormEntry>>;
  entryCount: Scalars['Int']['output'];
  fields?: Maybe<Array<CustomPageAdvancedFormField>>;
  followerTag?: Maybe<Scalars['String']['output']>;
  formName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isDisabled: Scalars['Boolean']['output'];
  location?: Maybe<RestaurantLocation>;
  locationId?: Maybe<Scalars['Int']['output']>;
  paginatedEntries: CustomPageAdvancedFormEntryPaginationHandler;
  unreadCount: Scalars['Int']['output'];
};


export type CustomPageAdvancedFormPaginatedEntriesArgs = {
  isBlocked: Scalars['Boolean']['input'];
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomPageAdvancedFormDraft = {
  __typename?: 'CustomPageAdvancedFormDraft';
  becomeFollowerEnabled: Scalars['Boolean']['output'];
  emailResponsesTo?: Maybe<Scalars['String']['output']>;
  emailSubjectLine?: Maybe<Scalars['String']['output']>;
  emailThankYouContent?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<CustomPageAdvancedFormFieldDraft>>;
  followerTag?: Maybe<Scalars['String']['output']>;
  formName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isDisabled: Scalars['Boolean']['output'];
  locationId?: Maybe<Scalars['Int']['output']>;
};

export type CustomPageAdvancedFormEntry = {
  __typename?: 'CustomPageAdvancedFormEntry';
  advancedForm?: Maybe<CustomPageAdvancedForm>;
  answers?: Maybe<Array<CustomPageAdvancedFormEntryAnswer>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isBlocked?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  sender?: Maybe<Scalars['String']['output']>;
  senderInfo?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type CustomPageAdvancedFormEntryAnswer = {
  __typename?: 'CustomPageAdvancedFormEntryAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  fieldType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

export type CustomPageAdvancedFormEntryAnswerInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  fieldType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  position: Scalars['Int']['input'];
};

export type CustomPageAdvancedFormEntryPaginationHandler = {
  __typename?: 'CustomPageAdvancedFormEntryPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<CustomPageAdvancedFormEntry>;
};

export type CustomPageAdvancedFormField = {
  __typename?: 'CustomPageAdvancedFormField';
  addressPlaceholders?: Maybe<Array<Scalars['String']['output']>>;
  fieldType: Scalars['String']['output'];
  helperText?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Scalars['String']['output']>>;
  placeholder?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
};

export type CustomPageAdvancedFormFieldDraft = {
  __typename?: 'CustomPageAdvancedFormFieldDraft';
  addressPlaceholders?: Maybe<Array<Scalars['String']['output']>>;
  fieldType: Scalars['String']['output'];
  helperText?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Scalars['String']['output']>>;
  placeholder?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
};

export type CustomPageAdvancedFormFieldInput = {
  addressPlaceholders?: InputMaybe<Array<Scalars['String']['input']>>;
  fieldType?: InputMaybe<Scalars['String']['input']>;
  helperText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomPageAdvancedFormInput = {
  becomeFollowerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  emailResponsesTo?: InputMaybe<Scalars['String']['input']>;
  emailSubjectLine?: InputMaybe<Scalars['String']['input']>;
  emailThankYouContent?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<CustomPageAdvancedFormFieldInput>>;
  followerTag?: InputMaybe<Scalars['String']['input']>;
  formName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomPageAdvancedFormNotificationRecipient = {
  __typename?: 'CustomPageAdvancedFormNotificationRecipient';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CustomPageAdvancedFormNotificationRecipientPaginationHandler = {
  __typename?: 'CustomPageAdvancedFormNotificationRecipientPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<CustomPageAdvancedFormNotificationRecipient>;
};

export type CustomPageAdvancedFormPaginationHandler = {
  __typename?: 'CustomPageAdvancedFormPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<CustomPageAdvancedForm>;
};

export type CustomPageArticle = {
  __typename?: 'CustomPageArticle';
  articleTitle: Scalars['String']['output'];
  articleUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  logoAltText?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publisherLogoUploadedPhoto?: Maybe<UploadedPhoto>;
  publisherLogoUrl?: Maybe<Scalars['String']['output']>;
  publisherThumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type CustomPageArticleDraft = {
  __typename?: 'CustomPageArticleDraft';
  articleTitle: Scalars['String']['output'];
  articleUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  logoAltText?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publisherLogoUploadedPhoto?: Maybe<UploadedPhoto>;
  publisherLogoUrl?: Maybe<Scalars['String']['output']>;
  publisherThumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type CustomPageArticleInput = {
  articleTitle: Scalars['String']['input'];
  articleUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  logoAltText?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publisherLogoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
};

export type CustomPageDraft = Eventable & NavLinkable & PageContentable & {
  __typename?: 'CustomPageDraft';
  canRedo: Scalars['Boolean']['output'];
  canUndo: Scalars['Boolean']['output'];
  contentPublished: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customCanonicalUrl?: Maybe<Scalars['String']['output']>;
  customHref?: Maybe<Scalars['String']['output']>;
  customMetaDescription?: Maybe<Scalars['String']['output']>;
  customMetaImageUploadedPhoto?: Maybe<UploadedPhoto>;
  customMetaImageUrl?: Maybe<Scalars['String']['output']>;
  customMetaKeywords?: Maybe<Scalars['String']['output']>;
  customMetaTitle: Scalars['String']['output'];
  defaultMetaDescription?: Maybe<Scalars['String']['output']>;
  defaultMetaKeywords?: Maybe<Scalars['String']['output']>;
  disableAjaxLoad?: Maybe<Scalars['Boolean']['output']>;
  eventableName: Scalars['String']['output'];
  firstMenuId?: Maybe<Scalars['Int']['output']>;
  hasCateringSection: Scalars['Boolean']['output'];
  hasLegacyOrderingSection: Scalars['Boolean']['output'];
  hasOnlineOrderingSection: Scalars['Boolean']['output'];
  hasQrCard: Scalars['Boolean']['output'];
  headerBgFullHeight?: Maybe<Scalars['Boolean']['output']>;
  headerFontCase?: Maybe<Scalars['String']['output']>;
  headerImageSetting?: Maybe<Scalars['String']['output']>;
  headerLinkCustomPageId?: Maybe<Scalars['Int']['output']>;
  headerLinkText?: Maybe<Scalars['String']['output']>;
  headerLinkUrl?: Maybe<Scalars['String']['output']>;
  headerTransitionTiming?: Maybe<Scalars['Int']['output']>;
  headerTransitionType: Scalars['String']['output'];
  heroBackgroundColor?: Maybe<Scalars['String']['output']>;
  heroImages: Array<CustomPageHeroImageDraft>;
  heroLogoAlt?: Maybe<Scalars['String']['output']>;
  heroLogoUploadedPhoto?: Maybe<UploadedPhoto>;
  heroLogoUrl?: Maybe<Scalars['String']['output']>;
  heroVideoCloudflareId?: Maybe<Scalars['String']['output']>;
  heroVideoHeight?: Maybe<Scalars['Int']['output']>;
  heroVideoThumbnailUrl?: Maybe<Scalars['String']['output']>;
  heroVideoUploadedVideo?: Maybe<UploadedVideo>;
  heroVideoUrl?: Maybe<Scalars['String']['output']>;
  heroVideoWidth?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isExternal?: Maybe<Scalars['Boolean']['output']>;
  isHeaderEnabled?: Maybe<Scalars['Boolean']['output']>;
  isHomePage?: Maybe<Scalars['Boolean']['output']>;
  isMemberOnly?: Maybe<Scalars['Boolean']['output']>;
  isNavEnabled?: Maybe<Scalars['Boolean']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  lighthouseReportPageReports: Array<LighthouseReportPageReport>;
  linkType?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaImageType?: Maybe<Scalars['String']['output']>;
  metaImageUrl?: Maybe<Scalars['String']['output']>;
  metaKeywords?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  navbarLogoToggle?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  restaurant: Restaurant;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  screenshotAt?: Maybe<Scalars['DateTime']['output']>;
  screenshotUrl?: Maybe<Scalars['String']['output']>;
  sections: Array<CustomPageSectionDraft>;
  slug: Scalars['String']['output'];
  subheading?: Maybe<Scalars['String']['output']>;
  tabName?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  visitsCount?: Maybe<Scalars['Int']['output']>;
};

export type CustomPageDraftWasUpdatedReturn = {
  __typename?: 'CustomPageDraftWasUpdatedReturn';
  customPageDraft: CustomPageDraft;
};

export type CustomPageGalleryImage = {
  __typename?: 'CustomPageGalleryImage';
  caption?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imageUploadedPhoto?: Maybe<UploadedPhoto>;
  imageUploadedPhotoId?: Maybe<Scalars['Int']['output']>;
  imageUrl: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl: Scalars['String']['output'];
};

export type CustomPageGalleryImageDraft = {
  __typename?: 'CustomPageGalleryImageDraft';
  caption?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imageUploadedPhoto?: Maybe<UploadedPhoto>;
  imageUploadedPhotoId: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl: Scalars['String']['output'];
};

export type CustomPageGalleryImageInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imageUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  imageUploadedPhotoId?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomPageGiftCardImage = {
  __typename?: 'CustomPageGiftCardImage';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  imageUploadedPhoto?: Maybe<UploadedPhoto>;
  imageUploadedPhotoId?: Maybe<Scalars['Int']['output']>;
  imageUrl: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl: Scalars['String']['output'];
};

export type CustomPageGiftCardImageDraft = {
  __typename?: 'CustomPageGiftCardImageDraft';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  imageUploadedPhoto?: Maybe<UploadedPhoto>;
  imageUploadedPhotoId?: Maybe<Scalars['Int']['output']>;
  imageUrl: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl: Scalars['String']['output'];
};

export type CustomPageGiftCardImageInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imageUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  imageUploadedPhotoId?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomPageHeroImage = {
  __typename?: 'CustomPageHeroImage';
  headerImageAlt?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imageUploadedPhoto?: Maybe<UploadedPhoto>;
  imageUrl: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  shareUrl: Scalars['String']['output'];
  thumbnailUrl: Scalars['String']['output'];
};

export type CustomPageHeroImageDraft = {
  __typename?: 'CustomPageHeroImageDraft';
  headerImageAlt?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imageUploadedPhoto?: Maybe<UploadedPhoto>;
  imageUrl: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  shareUrl: Scalars['String']['output'];
  thumbnailUrl: Scalars['String']['output'];
};

export type CustomPageHeroImageInput = {
  headerImageAlt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imageUploadedPhoto?: InputMaybe<SelectedUploadInput>;
};

export type CustomPageInput = {
  customCanonicalUrl?: InputMaybe<Scalars['String']['input']>;
  customHref?: InputMaybe<Scalars['String']['input']>;
  customMetaDescription?: InputMaybe<Scalars['String']['input']>;
  customMetaImageUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  customMetaKeywords?: InputMaybe<Scalars['String']['input']>;
  customMetaTitle?: InputMaybe<Scalars['String']['input']>;
  disableAjaxLoad?: InputMaybe<Scalars['Boolean']['input']>;
  headerBgFullHeight?: InputMaybe<Scalars['Boolean']['input']>;
  headerFontCase?: InputMaybe<Scalars['String']['input']>;
  headerImageSetting?: InputMaybe<Scalars['String']['input']>;
  headerLinkCustomPageId?: InputMaybe<Scalars['Int']['input']>;
  headerLinkText?: InputMaybe<Scalars['String']['input']>;
  headerTransitionTiming?: InputMaybe<Scalars['Int']['input']>;
  headerTransitionType?: InputMaybe<Scalars['String']['input']>;
  heroBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  heroImages?: InputMaybe<Array<CustomPageHeroImageInput>>;
  heroLogoAlt?: InputMaybe<Scalars['String']['input']>;
  heroLogoDataUrl?: InputMaybe<Scalars['String']['input']>;
  heroLogoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  heroVideoDataUrl?: InputMaybe<Scalars['String']['input']>;
  heroVideoUploadedVideo?: InputMaybe<SelectedVideoInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  isHeaderEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isHomePage?: InputMaybe<Scalars['Boolean']['input']>;
  isMemberOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isNavEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  linkType?: InputMaybe<Scalars['String']['input']>;
  metaImageType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  navbarLogoToggle?: InputMaybe<Scalars['Boolean']['input']>;
  removeHeroVideo?: InputMaybe<Scalars['Boolean']['input']>;
  sections?: InputMaybe<Array<CustomPageSectionInput>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subheading?: InputMaybe<Scalars['String']['input']>;
};

export type CustomPagePaginationHandler = {
  __typename?: 'CustomPagePaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<CustomPage>;
};

export type CustomPagePerformanceMetadata = {
  __typename?: 'CustomPagePerformanceMetadata';
  id: Scalars['Int']['output'];
  visibleSections?: Maybe<Array<Scalars['String']['output']>>;
};

export type CustomPagePublishPreview = {
  __typename?: 'CustomPagePublishPreview';
  deletedCustomPages: Array<CustomPage>;
  unpublishedCustomPageDrafts: Array<CustomPageDraft>;
};

export type CustomPageSection = {
  __typename?: 'CustomPageSection';
  aboutContent?: Maybe<Scalars['String']['output']>;
  aboutContentMaxWidth?: Maybe<Scalars['String']['output']>;
  aboutFontAlignment?: Maybe<Scalars['String']['output']>;
  aboutFontColor?: Maybe<Scalars['String']['output']>;
  aboutHeading?: Maybe<Scalars['String']['output']>;
  aboutLinkText?: Maybe<Scalars['String']['output']>;
  aboutLinkUrl?: Maybe<Scalars['String']['output']>;
  aboutPadding?: Maybe<Scalars['String']['output']>;
  aboutPhotoAlt?: Maybe<Scalars['String']['output']>;
  aboutPhotoPosition?: Maybe<Scalars['String']['output']>;
  aboutPhotoUploadedPhoto?: Maybe<UploadedPhoto>;
  aboutPhotoUrl?: Maybe<Scalars['String']['output']>;
  accessibleAltContent?: Maybe<Scalars['String']['output']>;
  advancedForm?: Maybe<CustomPageAdvancedForm>;
  announcementFontAlignment?: Maybe<Scalars['String']['output']>;
  articles: Array<CustomPageArticle>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  backgroundEffect?: Maybe<Scalars['String']['output']>;
  backgroundImageSetting?: Maybe<Scalars['String']['output']>;
  backgroundImageUploadedPhoto?: Maybe<UploadedPhoto>;
  backgroundImageUrl?: Maybe<Scalars['String']['output']>;
  buttonColor: Scalars['String']['output'];
  buttonTextColor: Scalars['String']['output'];
  calendarEventView?: Maybe<Scalars['String']['output']>;
  cartType?: Maybe<Scalars['String']['output']>;
  customEmbedHtml?: Maybe<Scalars['String']['output']>;
  customForm?: Maybe<CustomForm>;
  customHtml?: Maybe<Scalars['String']['output']>;
  customPage?: Maybe<CustomPage>;
  customPageId?: Maybe<Scalars['Int']['output']>;
  customVideoCloudflareId?: Maybe<Scalars['String']['output']>;
  customVideoContent?: Maybe<Scalars['String']['output']>;
  customVideoHeading?: Maybe<Scalars['String']['output']>;
  customVideoPreviewThumbnail?: Maybe<Scalars['String']['output']>;
  customVideoTranscriptionUrl?: Maybe<Scalars['String']['output']>;
  customVideoUploadedVideo?: Maybe<UploadedVideo>;
  customVideoUrl?: Maybe<Scalars['String']['output']>;
  defaultZoomLevel?: Maybe<Scalars['Int']['output']>;
  disableAjaxLoad?: Maybe<Scalars['Boolean']['output']>;
  displayLocationStateHeading?: Maybe<Scalars['Boolean']['output']>;
  ecwidShopId?: Maybe<Scalars['String']['output']>;
  facebookPageId?: Maybe<Scalars['String']['output']>;
  featuredItemLayout: Scalars['String']['output'];
  featuredItems: Array<CustomPageSectionFeaturedItem>;
  fontColor?: Maybe<Scalars['String']['output']>;
  foodtecApiToken?: Maybe<Scalars['String']['output']>;
  formsiteKeyUrl?: Maybe<Scalars['String']['output']>;
  galleryColumn?: Maybe<Scalars['Int']['output']>;
  galleryImages: Array<CustomPageGalleryImage>;
  galleryPadding?: Maybe<Scalars['String']['output']>;
  galleryType?: Maybe<Scalars['String']['output']>;
  giftCardImages: Array<CustomPageGiftCardImage>;
  giftCardShopItem?: Maybe<ShopItem>;
  hasDynamicHeight?: Maybe<Scalars['Boolean']['output']>;
  highlightReelId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['Int']['output'];
  instagramFeedPhotos: Array<SocialAccountFacebookPageInstagramPhoto>;
  instagramFeedSocialAccountId?: Maybe<Scalars['Int']['output']>;
  instagramUserId?: Maybe<Scalars['String']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isFullWidth?: Maybe<Scalars['Boolean']['output']>;
  linkTargetId?: Maybe<Scalars['Int']['output']>;
  linkType?: Maybe<Scalars['String']['output']>;
  locationContent?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  locationSectionLayout?: Maybe<Scalars['String']['output']>;
  locations: Array<RestaurantLocation>;
  mapTheme?: Maybe<Scalars['String']['output']>;
  maxCalendarEventsDisplayed?: Maybe<Scalars['Int']['output']>;
  menus: Array<Menu>;
  multiColumnDisplayType?: Maybe<Scalars['String']['output']>;
  multiColumnImgObjectFit?: Maybe<Scalars['String']['output']>;
  multiColumnSectionCount?: Maybe<Scalars['Int']['output']>;
  pageTitle: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  powrInstagramFeedId?: Maybe<Scalars['String']['output']>;
  restaurant?: Maybe<Restaurant>;
  reviewSectionHasDisplayableConsumerReviews: Scalars['Boolean']['output'];
  rootSectionType?: Maybe<RootSectionType>;
  sectionColumns: Array<CustomPageSectionColumn>;
  sectionHeading?: Maybe<Scalars['String']['output']>;
  sectionPadding?: Maybe<Scalars['String']['output']>;
  sectionSubheading?: Maybe<Scalars['String']['output']>;
  sectionType?: Maybe<Scalars['String']['output']>;
  selectedEventTags: Array<CustomPageSelectedLEventTag>;
  selectedLocations: Array<CustomPageSelectedLocation>;
  selectedMenus: Array<CustomPageSelectedMenu>;
  showAnnouncement?: Maybe<Scalars['Boolean']['output']>;
  showDirectionsButton: Scalars['Boolean']['output'];
  showLocationCustomButtons: Scalars['Boolean']['output'];
  showTextBoxLink?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  transitionTiming?: Maybe<Scalars['Int']['output']>;
  transitionType?: Maybe<Scalars['String']['output']>;
  tripleseatFormId?: Maybe<Scalars['Int']['output']>;
  tripleseatFormKey?: Maybe<Scalars['String']['output']>;
  tripleseatFormType?: Maybe<Scalars['String']['output']>;
  upcomingCalendarEvents: Array<CalendarEvent>;
  youtubeVideoUrl?: Maybe<Scalars['String']['output']>;
};


export type CustomPageSectionUpcomingCalendarEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  rangeEndAt?: InputMaybe<Scalars['DateTime']['input']>;
  rangeStartAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CustomPageSectionColumn = {
  __typename?: 'CustomPageSectionColumn';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  columnContent?: Maybe<Scalars['String']['output']>;
  columnContentHtml?: Maybe<Scalars['String']['output']>;
  columnHeading?: Maybe<Scalars['String']['output']>;
  columnLinkTargetId?: Maybe<Scalars['String']['output']>;
  columnLinkText?: Maybe<Scalars['String']['output']>;
  columnLinkUrl?: Maybe<Scalars['String']['output']>;
  columnPhoto?: Maybe<Scalars['String']['output']>;
  columnPhotoAlt?: Maybe<Scalars['String']['output']>;
  columnPhotoOverlayText?: Maybe<Scalars['String']['output']>;
  columnPhotoOverlayTextAlt?: Maybe<Scalars['String']['output']>;
  columnPhotoUploadedPhoto?: Maybe<UploadedPhoto>;
  columnPhotoUrl?: Maybe<Scalars['String']['output']>;
  columnSecondLinkTargetId?: Maybe<Scalars['String']['output']>;
  columnSecondLinkText?: Maybe<Scalars['String']['output']>;
  columnSecondLinkUrl?: Maybe<Scalars['String']['output']>;
  columnThumbnailUrl?: Maybe<Scalars['String']['output']>;
  columnVideoCloudflareId?: Maybe<Scalars['String']['output']>;
  columnVideoThumbnailUrl?: Maybe<Scalars['String']['output']>;
  columnVideoUploadedVideo?: Maybe<UploadedVideo>;
  columnVideoUrl?: Maybe<Scalars['String']['output']>;
  disableAjaxLink: Scalars['Boolean']['output'];
  disableAjaxSecondLink: Scalars['Boolean']['output'];
  elementId?: Maybe<Scalars['String']['output']>;
  fontColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isHtmlContent: Scalars['Boolean']['output'];
  position?: Maybe<Scalars['Int']['output']>;
};

export type CustomPageSectionColumnDraft = {
  __typename?: 'CustomPageSectionColumnDraft';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  columnContent?: Maybe<Scalars['String']['output']>;
  columnContentHtml?: Maybe<Scalars['String']['output']>;
  columnHeading?: Maybe<Scalars['String']['output']>;
  columnLinkTargetId?: Maybe<Scalars['String']['output']>;
  columnLinkText?: Maybe<Scalars['String']['output']>;
  columnLinkUrl?: Maybe<Scalars['String']['output']>;
  columnPhoto?: Maybe<Scalars['String']['output']>;
  columnPhotoAlt?: Maybe<Scalars['String']['output']>;
  columnPhotoOverlayText?: Maybe<Scalars['String']['output']>;
  columnPhotoOverlayTextAlt?: Maybe<Scalars['String']['output']>;
  columnPhotoUploadedPhoto?: Maybe<UploadedPhoto>;
  columnPhotoUrl?: Maybe<Scalars['String']['output']>;
  columnSecondLinkTargetId?: Maybe<Scalars['String']['output']>;
  columnSecondLinkText?: Maybe<Scalars['String']['output']>;
  columnSecondLinkUrl?: Maybe<Scalars['String']['output']>;
  columnThumbnailUrl?: Maybe<Scalars['String']['output']>;
  columnVideoCloudflareId?: Maybe<Scalars['String']['output']>;
  columnVideoThumbnailUrl?: Maybe<Scalars['String']['output']>;
  columnVideoUploadedVideo?: Maybe<UploadedVideo>;
  columnVideoUrl?: Maybe<Scalars['String']['output']>;
  disableAjaxLink: Scalars['Boolean']['output'];
  disableAjaxSecondLink: Scalars['Boolean']['output'];
  elementId?: Maybe<Scalars['String']['output']>;
  fontColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isHtmlContent: Scalars['Boolean']['output'];
  position?: Maybe<Scalars['Int']['output']>;
};

export type CustomPageSectionColumnInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  columnContent?: InputMaybe<Scalars['String']['input']>;
  columnContentHtml?: InputMaybe<Scalars['String']['input']>;
  columnHeading?: InputMaybe<Scalars['String']['input']>;
  columnLinkTargetId?: InputMaybe<Scalars['String']['input']>;
  columnLinkText?: InputMaybe<Scalars['String']['input']>;
  columnLinkUrl?: InputMaybe<Scalars['String']['input']>;
  columnPhotoAlt?: InputMaybe<Scalars['String']['input']>;
  columnPhotoOverlayText?: InputMaybe<Scalars['String']['input']>;
  columnPhotoOverlayTextAlt?: InputMaybe<Scalars['String']['input']>;
  columnPhotoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  columnSecondLinkTargetId?: InputMaybe<Scalars['String']['input']>;
  columnSecondLinkText?: InputMaybe<Scalars['String']['input']>;
  columnSecondLinkUrl?: InputMaybe<Scalars['String']['input']>;
  columnVideoUploadedVideo?: InputMaybe<SelectedVideoInput>;
  elementId?: InputMaybe<Scalars['String']['input']>;
  fontColor?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isHtmlContent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomPageSectionDraft = {
  __typename?: 'CustomPageSectionDraft';
  aboutContent?: Maybe<Scalars['String']['output']>;
  aboutContentMaxWidth?: Maybe<Scalars['String']['output']>;
  aboutFontAlignment?: Maybe<Scalars['String']['output']>;
  aboutFontColor?: Maybe<Scalars['String']['output']>;
  aboutHeading?: Maybe<Scalars['String']['output']>;
  aboutLinkText?: Maybe<Scalars['String']['output']>;
  aboutLinkUrl?: Maybe<Scalars['String']['output']>;
  aboutPadding?: Maybe<Scalars['String']['output']>;
  aboutPhotoAlt?: Maybe<Scalars['String']['output']>;
  aboutPhotoPosition?: Maybe<Scalars['String']['output']>;
  aboutPhotoUploadedPhoto?: Maybe<UploadedPhoto>;
  aboutPhotoUrl?: Maybe<Scalars['String']['output']>;
  accessibleAltContent?: Maybe<Scalars['String']['output']>;
  advancedForm?: Maybe<CustomPageAdvancedFormDraft>;
  announcementFontAlignment?: Maybe<Scalars['String']['output']>;
  articles: Array<CustomPageArticleDraft>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  backgroundEffect?: Maybe<Scalars['String']['output']>;
  backgroundImageSetting?: Maybe<Scalars['String']['output']>;
  backgroundImageUploadedPhoto?: Maybe<UploadedPhoto>;
  backgroundImageUrl?: Maybe<Scalars['String']['output']>;
  buttonColor: Scalars['String']['output'];
  buttonTextColor: Scalars['String']['output'];
  calendarEventView?: Maybe<Scalars['String']['output']>;
  cartType?: Maybe<Scalars['String']['output']>;
  customEmbedHtml?: Maybe<Scalars['String']['output']>;
  customForm?: Maybe<CustomFormDraft>;
  customHtml?: Maybe<Scalars['String']['output']>;
  customPage?: Maybe<CustomPageDraft>;
  customPageId?: Maybe<Scalars['Int']['output']>;
  customVideoCloudflareId?: Maybe<Scalars['String']['output']>;
  customVideoContent?: Maybe<Scalars['String']['output']>;
  customVideoHeading?: Maybe<Scalars['String']['output']>;
  customVideoPreviewThumbnail?: Maybe<Scalars['String']['output']>;
  customVideoTranscriptionUrl?: Maybe<Scalars['String']['output']>;
  customVideoUploadedVideo?: Maybe<UploadedVideo>;
  customVideoUrl?: Maybe<Scalars['String']['output']>;
  defaultZoomLevel?: Maybe<Scalars['Int']['output']>;
  disableAjaxLoad?: Maybe<Scalars['Boolean']['output']>;
  displayLocationStateHeading?: Maybe<Scalars['Boolean']['output']>;
  ecwidShopId?: Maybe<Scalars['String']['output']>;
  facebookPageId?: Maybe<Scalars['String']['output']>;
  featuredItemLayout: Scalars['String']['output'];
  featuredItems: Array<CustomPageSectionFeaturedItemDraft>;
  fontColor?: Maybe<Scalars['String']['output']>;
  foodtecApiToken?: Maybe<Scalars['String']['output']>;
  formsiteKeyUrl?: Maybe<Scalars['String']['output']>;
  galleryColumn?: Maybe<Scalars['Int']['output']>;
  galleryImages: Array<CustomPageGalleryImageDraft>;
  galleryPadding?: Maybe<Scalars['String']['output']>;
  galleryType?: Maybe<Scalars['String']['output']>;
  giftCardImages: Array<CustomPageGiftCardImageDraft>;
  giftCardShopItem?: Maybe<ShopItem>;
  hasDynamicHeight?: Maybe<Scalars['Boolean']['output']>;
  highlightReelId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['Int']['output'];
  instagramFeedPhotos: Array<SocialAccountFacebookPageInstagramPhoto>;
  instagramFeedSocialAccountId?: Maybe<Scalars['Int']['output']>;
  instagramUserId?: Maybe<Scalars['String']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isFullWidth?: Maybe<Scalars['Boolean']['output']>;
  linkTargetId?: Maybe<Scalars['Int']['output']>;
  linkType?: Maybe<Scalars['String']['output']>;
  locationContent?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  locationSectionLayout?: Maybe<Scalars['String']['output']>;
  locations: Array<RestaurantLocation>;
  mapTheme?: Maybe<Scalars['String']['output']>;
  maxCalendarEventsDisplayed?: Maybe<Scalars['Int']['output']>;
  menus: Array<Menu>;
  multiColumnDisplayType?: Maybe<Scalars['String']['output']>;
  multiColumnImgObjectFit?: Maybe<Scalars['String']['output']>;
  multiColumnSectionCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pageTitle: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  powrInstagramFeedId?: Maybe<Scalars['String']['output']>;
  restaurant?: Maybe<Restaurant>;
  reviewSectionHasDisplayableConsumerReviews: Scalars['Boolean']['output'];
  rootSectionType?: Maybe<RootSectionType>;
  sectionColumns: Array<CustomPageSectionColumnDraft>;
  sectionHeading?: Maybe<Scalars['String']['output']>;
  sectionPadding?: Maybe<Scalars['String']['output']>;
  sectionSubheading?: Maybe<Scalars['String']['output']>;
  sectionType?: Maybe<Scalars['String']['output']>;
  selectedEventTags: Array<CustomPageSelectedLEventTagDraft>;
  selectedLocations: Array<CustomPageSelectedLocationDraft>;
  selectedMenus: Array<CustomPageSelectedMenuDraft>;
  showAnnouncement?: Maybe<Scalars['Boolean']['output']>;
  showDirectionsButton: Scalars['Boolean']['output'];
  showLocationCustomButtons: Scalars['Boolean']['output'];
  showTextBoxLink?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  transitionTiming?: Maybe<Scalars['Int']['output']>;
  transitionType?: Maybe<Scalars['String']['output']>;
  tripleseatFormId?: Maybe<Scalars['Int']['output']>;
  tripleseatFormKey?: Maybe<Scalars['String']['output']>;
  tripleseatFormType?: Maybe<Scalars['String']['output']>;
  upcomingCalendarEvents: Array<CalendarEvent>;
  youtubeVideoUrl?: Maybe<Scalars['String']['output']>;
};


export type CustomPageSectionDraftUpcomingCalendarEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  rangeEndAt?: InputMaybe<Scalars['DateTime']['input']>;
  rangeStartAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CustomPageSectionFeaturedItem = {
  __typename?: 'CustomPageSectionFeaturedItem';
  id: Scalars['Int']['output'];
  menuItem: MenuItem;
  menuItemName: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  review?: Maybe<Review>;
};

export type CustomPageSectionFeaturedItemDraft = {
  __typename?: 'CustomPageSectionFeaturedItemDraft';
  id: Scalars['Int']['output'];
  menuItem: MenuItem;
  menuItemName: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  review?: Maybe<Review>;
};

export type CustomPageSectionInput = {
  accessibleAltContent?: InputMaybe<Scalars['String']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundEffect: Scalars['String']['input'];
  backgroundImageSetting?: InputMaybe<Scalars['String']['input']>;
  backgroundImageUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  highlightReelId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  isFullWidth: Scalars['Boolean']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  sectionHeading?: InputMaybe<Scalars['String']['input']>;
  sectionPadding?: InputMaybe<Scalars['String']['input']>;
  sectionSubheading?: InputMaybe<Scalars['String']['input']>;
  showTextBoxLink?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  transitionType?: InputMaybe<Scalars['String']['input']>;
};

export type CustomPageSectionNestedFieldsInput = {
  aboutContent?: InputMaybe<Scalars['String']['input']>;
  aboutContentMaxWidth: Scalars['String']['input'];
  aboutFontAlignment: Scalars['String']['input'];
  aboutFontColor?: InputMaybe<Scalars['String']['input']>;
  aboutHeading?: InputMaybe<Scalars['String']['input']>;
  aboutLinkText?: InputMaybe<Scalars['String']['input']>;
  aboutLinkUrl?: InputMaybe<Scalars['String']['input']>;
  aboutPadding?: InputMaybe<Scalars['String']['input']>;
  aboutPhotoAlt?: InputMaybe<Scalars['String']['input']>;
  aboutPhotoPosition: Scalars['String']['input'];
  aboutPhotoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  accessibleAltContent?: InputMaybe<Scalars['String']['input']>;
  advancedForm?: InputMaybe<CustomPageAdvancedFormInput>;
  announcementFontAlignment: Scalars['String']['input'];
  articles?: InputMaybe<Array<CustomPageArticleInput>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundEffect?: InputMaybe<Scalars['String']['input']>;
  backgroundImageSetting?: InputMaybe<Scalars['String']['input']>;
  backgroundImageUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  buttonColor?: InputMaybe<Scalars['String']['input']>;
  buttonTextColor?: InputMaybe<Scalars['String']['input']>;
  calendarEventView?: InputMaybe<Scalars['String']['input']>;
  cartType?: InputMaybe<Scalars['String']['input']>;
  customEmbedHtml?: InputMaybe<Scalars['String']['input']>;
  customForm?: InputMaybe<CustomFormInput>;
  customHtml?: InputMaybe<Scalars['String']['input']>;
  customVideoContent?: InputMaybe<Scalars['String']['input']>;
  customVideoHeading?: InputMaybe<Scalars['String']['input']>;
  customVideoUploadedVideo?: InputMaybe<SelectedVideoInput>;
  defaultZoomLevel?: InputMaybe<Scalars['Int']['input']>;
  displayLocationStateHeading?: InputMaybe<Scalars['Boolean']['input']>;
  ecwidShopId?: InputMaybe<Scalars['String']['input']>;
  facebookPageId?: InputMaybe<Scalars['String']['input']>;
  featuredItemLayout?: InputMaybe<Scalars['String']['input']>;
  fontColor?: InputMaybe<Scalars['String']['input']>;
  foodtecApiToken?: InputMaybe<Scalars['String']['input']>;
  formsiteKeyUrl?: InputMaybe<Scalars['String']['input']>;
  galleryColumn?: InputMaybe<Scalars['Int']['input']>;
  galleryImages?: InputMaybe<Array<CustomPageGalleryImageInput>>;
  galleryPadding?: InputMaybe<Scalars['String']['input']>;
  galleryType?: InputMaybe<Scalars['String']['input']>;
  giftCardImages?: InputMaybe<Array<CustomPageGiftCardImageInput>>;
  giftCardShopItem?: InputMaybe<ShopItemInput>;
  hasDynamicHeight?: InputMaybe<Scalars['Boolean']['input']>;
  highlightReelId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  instagramFeedSocialAccountId?: InputMaybe<Scalars['Int']['input']>;
  instagramUserId?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  linkTargetId?: InputMaybe<Scalars['Int']['input']>;
  linkType?: InputMaybe<Scalars['String']['input']>;
  locationContent?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  locationSectionLayout: Scalars['String']['input'];
  mapTheme?: InputMaybe<Scalars['String']['input']>;
  maxCalendarEventsDisplayed?: InputMaybe<Scalars['Int']['input']>;
  multiColumnDisplayType?: InputMaybe<Scalars['String']['input']>;
  multiColumnImgObjectFit?: InputMaybe<Scalars['String']['input']>;
  multiColumnSectionCount?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  powrInstagramFeedId?: InputMaybe<Scalars['String']['input']>;
  removeCustomVideo?: InputMaybe<Scalars['Boolean']['input']>;
  sectionColumns?: InputMaybe<Array<CustomPageSectionColumnInput>>;
  sectionHeading?: InputMaybe<Scalars['String']['input']>;
  sectionPadding?: InputMaybe<Scalars['String']['input']>;
  sectionSubheading?: InputMaybe<Scalars['String']['input']>;
  selectedEventTags?: InputMaybe<Array<CustomPageSelectedEventTagInput>>;
  selectedLocations?: InputMaybe<Array<CustomPageSelectedLocationInput>>;
  selectedMenus?: InputMaybe<Array<CustomPageSelectedMenuInput>>;
  showDirectionsButton?: InputMaybe<Scalars['Boolean']['input']>;
  showLocationCustomButtons?: InputMaybe<Scalars['Boolean']['input']>;
  showTextBoxLink?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  transitionTiming?: InputMaybe<Scalars['Int']['input']>;
  transitionType?: InputMaybe<Scalars['String']['input']>;
  tripleseatFormId?: InputMaybe<Scalars['Int']['input']>;
  tripleseatFormKey?: InputMaybe<Scalars['String']['input']>;
  tripleseatFormType?: InputMaybe<Scalars['String']['input']>;
  youtubeVideoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CustomPageSectionVersion = Versionable & {
  __typename?: 'CustomPageSectionVersion';
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  locationMenuName?: Maybe<Scalars['String']['output']>;
  objectChanges: Array<VersionDiff>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

export type CustomPageSelectedEventTagInput = {
  eventTagId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomPageSelectedLEventTag = {
  __typename?: 'CustomPageSelectedLEventTag';
  eventTagId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
};

export type CustomPageSelectedLEventTagDraft = {
  __typename?: 'CustomPageSelectedLEventTagDraft';
  eventTagId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
};

export type CustomPageSelectedLocation = {
  __typename?: 'CustomPageSelectedLocation';
  id: Scalars['Int']['output'];
  location?: Maybe<RestaurantLocation>;
  locationId?: Maybe<Scalars['Int']['output']>;
};

export type CustomPageSelectedLocationDraft = {
  __typename?: 'CustomPageSelectedLocationDraft';
  id: Scalars['Int']['output'];
  location?: Maybe<RestaurantLocation>;
  locationId?: Maybe<Scalars['Int']['output']>;
};

export type CustomPageSelectedLocationInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
};

export type CustomPageSelectedMenu = {
  __typename?: 'CustomPageSelectedMenu';
  customPage?: Maybe<CustomPage>;
  id: Scalars['Int']['output'];
  menu: Menu;
  menuId?: Maybe<Scalars['Int']['output']>;
  sectionId?: Maybe<Scalars['Int']['output']>;
};

export type CustomPageSelectedMenuDraft = {
  __typename?: 'CustomPageSelectedMenuDraft';
  customPage?: Maybe<CustomPageDraft>;
  id: Scalars['Int']['output'];
  menu: Menu;
  menuId?: Maybe<Scalars['Int']['output']>;
  sectionId?: Maybe<Scalars['Int']['output']>;
};

export type CustomPageSelectedMenuInput = {
  menuId: Scalars['Int']['input'];
};

export type CustomPhoto = Eventable & {
  __typename?: 'CustomPhoto';
  approved?: Maybe<Scalars['Boolean']['output']>;
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedBy?: Maybe<User>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dishable: Dishable;
  dishableId?: Maybe<Scalars['Int']['output']>;
  dishableType?: Maybe<Scalars['String']['output']>;
  eventableName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  item?: Maybe<MenuItem>;
  name: Scalars['String']['output'];
  photoHeight?: Maybe<Scalars['Int']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  photoWidth?: Maybe<Scalars['Int']['output']>;
  shareUrl?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type CustomRedirectPaginationHandler = {
  __typename?: 'CustomRedirectPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<RestaurantCustomRedirect>;
};

/** spacing above and below custom sections */
export enum CustomSectionSpacing {
  Airy = 'airy',
  Condensed = 'condensed',
  Standard = 'standard'
}

export type CustomTaxRate = {
  __typename?: 'CustomTaxRate';
  dishesCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  locationTaxRates: Array<CustomTaxRateLocationTaxRate>;
  name: Scalars['String']['output'];
  restaurant?: Maybe<Restaurant>;
};

export type CustomTaxRateAmount = {
  __typename?: 'CustomTaxRateAmount';
  amount: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
};

export type CustomTaxRateInput = {
  locationTaxRates?: InputMaybe<Array<CustomTaxRateLocationTaxRateInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CustomTaxRateLocationTaxRate = {
  __typename?: 'CustomTaxRateLocationTaxRate';
  id: Scalars['Int']['output'];
  locationId?: Maybe<Scalars['Int']['output']>;
  taxPercent: Scalars['Decimal']['output'];
};

export type CustomTaxRateLocationTaxRateInput = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
  taxPercent?: InputMaybe<Scalars['Decimal']['input']>;
};

export type Data = {
  __typename?: 'Data';
  currentValue?: Maybe<Scalars['String']['output']>;
  dataKey: Scalars['String']['output'];
  groupDisplayName?: Maybe<Scalars['String']['output']>;
  newValue?: Maybe<Scalars['String']['output']>;
};

export type DateRangeDataAnsweringOverviewInput = {
  callsByHourByDateDay?: InputMaybe<Scalars['String']['input']>;
};

export type DateRangeDataInput = {
  answeringOverviewInput?: InputMaybe<DateRangeDataAnsweringOverviewInput>;
  marketingOverviewInput?: InputMaybe<DateRangeDataMarketingOverviewInput>;
  orderingOverviewInput?: InputMaybe<DateRangeDataOrderingOverviewInput>;
};

export type DateRangeDataMarketingOverviewInput = {
  impressionRevenueGraphVariables?: InputMaybe<ImpressionRevenueGraphVariablesInput>;
  topMassMessagesStartRange?: InputMaybe<Scalars['DateTime']['input']>;
  topSocialPostsStartRange?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateRangeDataOrderingOverviewInput = {
  ordersByHourByDateDay?: InputMaybe<Scalars['String']['input']>;
  reportEndAt?: InputMaybe<Scalars['DateTime']['input']>;
  reportStartAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Autogenerated input type of DeleteMessageGroupContent */
export type DeleteMessageGroupContentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageGroupContentId: Scalars['Int']['input'];
};

/** Autogenerated input type of DeleteMyFollowerAccount */
export type DeleteMyFollowerAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of DeleteMyUserAccount */
export type DeleteMyUserAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

export type DeleteSelectedEmailFromBounceAndSpamList = {
  __typename?: 'DeleteSelectedEmailFromBounceAndSpamList';
  lastBounceClassification?: Maybe<Scalars['String']['output']>;
  lastBounceReason?: Maybe<Scalars['String']['output']>;
  removedFromBounceList: Scalars['Boolean']['output'];
  userEmailDeliveryStatusHasBounced?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of DeleteSelectedEmailFromBounceAndSpamList */
export type DeleteSelectedEmailFromBounceAndSpamListInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emailToRemove: Scalars['String']['input'];
};

/** Autogenerated input type of DeleteTableTop */
export type DeleteTableTopInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  tableTopId: Scalars['Int']['input'];
};

export type DeliverectAmountProduct = ProviderItem & {
  __typename?: 'DeliverectAmountProduct';
  availableVariations: Array<ProviderVariation>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  plu: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DeliverectChannel = RestaurantPaymentAccountInterface & {
  __typename?: 'DeliverectChannel';
  accountSlug: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  accountUrl: Scalars['String']['output'];
  canDisconnectPos: Scalars['Boolean']['output'];
  channelLinkId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  externalLocationId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isDeleting: Scalars['Boolean']['output'];
  isMenuSyncing: Scalars['Boolean']['output'];
  isShopSupported: Scalars['Boolean']['output'];
  isSyncing?: Maybe<Scalars['Boolean']['output']>;
  locationId: Scalars['String']['output'];
  menuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  shouldReauthenticate: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
};

export type DeliveryAddress = {
  __typename?: 'DeliveryAddress';
  city?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  fullAddress?: Maybe<Scalars['String']['output']>;
  isValid: Scalars['Boolean']['output'];
  locations?: Maybe<Array<DeliveryLocation>>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
};

export type DeliveryFeeInput = {
  distance?: InputMaybe<Scalars['Decimal']['input']>;
  feeAmount?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type DeliveryLocation = {
  __typename?: 'DeliveryLocation';
  deliveryEstimateMinutes?: Maybe<Scalars['Int']['output']>;
  distance: Scalars['Decimal']['output'];
  id: Scalars['Int']['output'];
};

/** Autogenerated input type of DemoteRootUser */
export type DemoteRootUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyAllFollowerImports */
export type DestroyAllFollowerImportsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyAllModifierGroups */
export type DestroyAllModifierGroupsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyAllSquareSyncedMenus */
export type DestroyAllSquareSyncedMenusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyBillingEntitlementFeatureFlag */
export type DestroyBillingEntitlementFeatureFlagInput = {
  billingEntitlementFeatureFlagId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of DestroyCampaignItem */
export type DestroyCampaignItemInput = {
  campaignItemId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of DestroyCustomTaxRate */
export type DestroyCustomTaxRateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customTaxRateId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyDeliverectChannel */
export type DestroyDeliverectChannelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyFollowerImport */
export type DestroyFollowerImportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  followerImportId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyHighlight */
export type DestroyHighlightInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  highlightId: Scalars['ID']['input'];
};

/** Autogenerated input type of DestroyHighlightReel */
export type DestroyHighlightReelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  highlightReelId: Scalars['ID']['input'];
};

/** Autogenerated input type of DestroyInstagramPublishedSocialPost */
export type DestroyInstagramPublishedSocialPostInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  instagramLivePostId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyLargeMenu */
export type DestroyLargeMenuInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyMenuHighlightSection */
export type DestroyMenuHighlightSectionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuHighlightSectionId: Scalars['ID']['input'];
};

/** Autogenerated input type of DestroyMessageGroup */
export type DestroyMessageGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageGroupId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyOrderingBlackout */
export type DestroyOrderingBlackoutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderingBlackoutId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyOrderingEvent */
export type DestroyOrderingEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderingEventId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyOrderingOffer */
export type DestroyOrderingOfferInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderingOfferId: Scalars['Int']['input'];
};

export type DestroyPopReturn = {
  __typename?: 'DestroyPopReturn';
  menuItem: MenuItem;
  user: User;
};

/** Autogenerated input type of DestroyPublishedSocialPost */
export type DestroyPublishedSocialPostInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  livePostId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyPushMessageGroup */
export type DestroyPushMessageGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  pushMessageGroupId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyRestaurantCustomScript */
export type DestroyRestaurantCustomScriptInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customScriptId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyRestaurantCustomTracking */
export type DestroyRestaurantCustomTrackingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customTrackingId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyRestaurantDetectedCookie */
export type DestroyRestaurantDetectedCookieInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  detectedCookieId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyRestaurantGroup */
export type DestroyRestaurantGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantGroupId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyRestaurantMessagePackCommunication */
export type DestroyRestaurantMessagePackCommunicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  communicationId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyRestaurantMobileAppAsset */
export type DestroyRestaurantMobileAppAssetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of DestroyRestaurantPaymentAccount */
export type DestroyRestaurantPaymentAccountInput = {
  accountId: Scalars['Int']['input'];
  accountType: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyRestaurantScriptDomain */
export type DestroyRestaurantScriptDomainInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  scriptDomainId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyRestaurantWebhook */
export type DestroyRestaurantWebhookInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  webhookId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyRewardTier */
export type DestroyRewardTierInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
  rewardTierId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyRootMessagePackCommunication */
export type DestroyRootMessagePackCommunicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  communicationId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyRootMessagePack */
export type DestroyRootMessagePackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  rootMessagePackId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroySelectedUploads */
export type DestroySelectedUploadsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  selectedIds: Array<Scalars['Int']['input']>;
  uploadType: Scalars['String']['input'];
};

/** Autogenerated input type of DestroySocialPost */
export type DestroySocialPostInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  socialPostId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyStagedRecord */
export type DestroyStagedRecordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  stagedRecordId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyTextMessageGroup */
export type DestroyTextMessageGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  textMessageGroupId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyTwilioPhoneCall */
export type DestroyTwilioPhoneCallInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  twilioPhoneCallId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyUploadFolder */
export type DestroyUploadFolderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  selectedIds: Array<Scalars['Int']['input']>;
  uploadType: Scalars['String']['input'];
};

/** Autogenerated input type of DestroyUpsellCampaign */
export type DestroyUpsellCampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  upsellCampaignId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyUserApiToken */
export type DestroyUserApiTokenInput = {
  apiTokenId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of DestroyYextMenu */
export type DestroyYextMenuInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuId: Scalars['Int']['input'];
};

/** Autogenerated input type of DestroyYextMenus */
export type DestroyYextMenusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

export type DineInQrCardInput = {
  locationId: Scalars['Int']['input'];
};

/** Autogenerated input type of DisableAdvancedForm */
export type DisableAdvancedFormInput = {
  advancedFormId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of DisconnectRestaurantEcardAccountType */
export type DisconnectRestaurantEcardAccountTypeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of DisconnectRestaurantLocationHeartlandPosLocation */
export type DisconnectRestaurantLocationHeartlandPosLocationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
};

/** Autogenerated input type of DisconnectRestaurantLocationMicrosRvc */
export type DisconnectRestaurantLocationMicrosRvcInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
};

/** Autogenerated input type of DisconnectRestaurantLocationPaymentAccounts */
export type DisconnectRestaurantLocationPaymentAccountsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
};

/** Autogenerated input type of DisconnectRestaurantLocationSpotonLocation */
export type DisconnectRestaurantLocationSpotonLocationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
};

/** Autogenerated input type of DisconnectSalesforceAccount */
export type DisconnectSalesforceAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

export type Dish = Dishable & Eventable & SocialPostSuggestionContentable & {
  __typename?: 'Dish';
  aiMarketablePhoto?: Maybe<UploadedPhoto>;
  aimWeight: Scalars['Decimal']['output'];
  allSelectedDishTags: Array<DishTagObject>;
  allergens: Array<AllergenEnum>;
  /** Editable, authoritative calorie value at the dish level. */
  calories?: Maybe<Scalars['Int']['output']>;
  chefRecommended: Scalars['Boolean']['output'];
  containsAlcohol: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency: Scalars['String']['output'];
  customPhotos: Array<CustomPhoto>;
  customTaxRateId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dishTags: Array<RestaurantDishTag>;
  dislikedItPopsCount: Scalars['Int']['output'];
  enabledItems: Array<MenuItem>;
  eventableName: Scalars['String']['output'];
  /** @deprecated Old menu extras system is deprecated. Use modifier groups instead. */
  extras: Array<DishExtra>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  featuredPhoto?: Maybe<PhotoInterface>;
  featuredPhotoUrl?: Maybe<Scalars['String']['output']>;
  fromOurTeamMemberName?: Maybe<Scalars['String']['output']>;
  fromOurTeamMemberRole?: Maybe<Scalars['String']['output']>;
  fromOurTeamNote?: Maybe<Scalars['String']['output']>;
  htmlContent?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  ignoredIntegrations?: Maybe<Array<Scalars['String']['output']>>;
  inventoryLocations?: Maybe<Array<DishInventoryLocation>>;
  isCreatedByMenuSync?: Maybe<Scalars['Boolean']['output']>;
  isCrossSellingEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingEnabled?: Maybe<Scalars['Boolean']['output']>;
  isPoppable?: Maybe<Scalars['Boolean']['output']>;
  isSingleMasterItem: Scalars['Boolean']['output'];
  isTaxable?: Maybe<Scalars['Boolean']['output']>;
  items: Array<MenuItem>;
  itemsCount: Scalars['Int']['output'];
  likedItPopsCount: Scalars['Int']['output'];
  locationsCount: Scalars['Int']['output'];
  lovedItPopsCount: Scalars['Int']['output'];
  masterMenusCount: Scalars['Int']['output'];
  modifierGroups: Array<ModifierGroup>;
  name: Scalars['String']['output'];
  orderVolumeCount: Scalars['Int']['output'];
  orderingEnabledIntegrations?: Maybe<Array<Scalars['String']['output']>>;
  orderingOffers: Array<OrderingOffer>;
  outOfStock?: Maybe<Scalars['Boolean']['output']>;
  outOfStockUntil?: Maybe<Scalars['DateTime']['output']>;
  photos: Array<PhotoInterface>;
  photosCount?: Maybe<Scalars['Int']['output']>;
  policy: DishPolicy;
  pops: Array<Pop>;
  popsCount: Scalars['Int']['output'];
  posPhotos: Array<MenuItemPosPhoto>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceCustomText?: Maybe<Scalars['String']['output']>;
  priceType: Scalars['String']['output'];
  restaurant: Restaurant;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  reviews: Array<Review>;
  reviewsCount: Scalars['Int']['output'];
  reviewsPopsCount: Scalars['Int']['output'];
  rootDishTags: Array<RootDishTag>;
  selectedMenuItem?: Maybe<MenuItem>;
  shortLinkUrl?: Maybe<Scalars['String']['output']>;
  showDisclaimer?: Maybe<Scalars['Boolean']['output']>;
  showFeaturedPhoto?: Maybe<Scalars['Boolean']['output']>;
  sizes: Array<DishSize>;
  uiDish?: Maybe<UiDishInterface>;
  updatableItems: Array<MenuItem>;
  updateInProgress?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userDefinedAimWeight?: Maybe<Scalars['Decimal']['output']>;
  visitsCount?: Maybe<Scalars['Int']['output']>;
  wannaTryPopsCount: Scalars['Int']['output'];
};


export type DishAiMarketablePhotoArgs = {
  withGenericPhoto?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DishSelectedMenuItemArgs = {
  menuItemId?: InputMaybe<Scalars['Int']['input']>;
};

export type DishExtra = {
  __typename?: 'DishExtra';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  outOfStock?: Maybe<Scalars['Boolean']['output']>;
  outOfStockUntil?: Maybe<Scalars['DateTime']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
};

export type DishExtraInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  outOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  outOfStockUntil?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
};

export type DishExtraVersion = Versionable & {
  __typename?: 'DishExtraVersion';
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  locationMenuName?: Maybe<Scalars['String']['output']>;
  objectChanges: Array<VersionDiff>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

export type DishHistoryPaginationHandler = {
  __typename?: 'DishHistoryPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<Versionable>;
};

export type DishInput = {
  allSelectedDishTags?: InputMaybe<Array<Scalars['String']['input']>>;
  allergens?: InputMaybe<Array<AllergenEnum>>;
  calories?: InputMaybe<Scalars['Int']['input']>;
  chefRecommended?: InputMaybe<Scalars['Boolean']['input']>;
  containsAlcohol?: InputMaybe<Scalars['Boolean']['input']>;
  customTaxRateId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dishModifierGroups?: InputMaybe<Array<DishModifierGroupInput>>;
  /** @deprecated Old menu extras system is deprecated. Use modifier groups instead. */
  extras?: InputMaybe<Array<DishExtraInput>>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  fromOurTeamMemberName?: InputMaybe<Scalars['String']['input']>;
  fromOurTeamMemberRole?: InputMaybe<Scalars['String']['input']>;
  fromOurTeamNote?: InputMaybe<Scalars['String']['input']>;
  htmlContent?: InputMaybe<Scalars['String']['input']>;
  ignoredIntegrations?: InputMaybe<Array<Scalars['String']['input']>>;
  inventoryLocations?: InputMaybe<Array<InventoryLocationInput>>;
  isCrossSellingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPoppable?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderingEnabledIntegrations?: InputMaybe<Array<Scalars['String']['input']>>;
  outOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  outOfStockUntil?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  priceCustomText?: InputMaybe<Scalars['String']['input']>;
  priceType?: InputMaybe<Scalars['String']['input']>;
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
  showFeaturedPhoto?: InputMaybe<Scalars['Boolean']['input']>;
  sizes?: InputMaybe<Array<DishSizeInput>>;
};

export type DishInteractionsPopCount = {
  __typename?: 'DishInteractionsPopCount';
  dishInteraction: Scalars['String']['output'];
  dishInteractionCount: Scalars['Int']['output'];
};

export type DishInventoryLocation = {
  __typename?: 'DishInventoryLocation';
  id: Scalars['Int']['output'];
  location: RestaurantLocation;
  outOfStock: Scalars['Boolean']['output'];
  outOfStockUntil?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
};

/** Autogenerated input type of DishInventoryLocationUpdate */
export type DishInventoryLocationUpdateInput = {
  autoRestock: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dishId: Scalars['Int']['input'];
  locationId: Scalars['Int']['input'];
  outOfStock: Scalars['Boolean']['input'];
};

export type DishList = {
  __typename?: 'DishList';
  categoryName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  friendlySlug: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isFeatured: Scalars['Boolean']['output'];
  menuItem?: Maybe<MenuItem>;
  menuItems: MenuItemPaginationHandler;
  name: Scalars['String']['output'];
  photoUrl?: Maybe<Scalars['String']['output']>;
  popsCount: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  userAvatarUrl: Scalars['String']['output'];
  userDisplayName: Scalars['String']['output'];
};


export type DishListMenuItemArgs = {
  id: Scalars['Int']['input'];
};


export type DishListMenuItemsArgs = {
  pagination: PaginationInput;
};

export type DishListPaginationHandler = {
  __typename?: 'DishListPaginationHandler';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  offset: Scalars['Int']['output'];
  records: Array<DishList>;
};

export type DishMergeInput = {
  mergingDishId: Scalars['Int']['input'];
  sourceDishId: Scalars['Int']['input'];
};

export type DishModifierGroupInput = {
  dishId?: InputMaybe<Scalars['Int']['input']>;
  modifierGroupId?: InputMaybe<Scalars['Int']['input']>;
};

export type DishPaginationHandler = {
  __typename?: 'DishPaginationHandler';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  offset: Scalars['Int']['output'];
  records: Array<Dish>;
};

export type DishPolicy = {
  __typename?: 'DishPolicy';
  canMerge: Scalars['Boolean']['output'];
  create: Scalars['Boolean']['output'];
  destroy: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  update: Scalars['Boolean']['output'];
};

export type DishSharedExtraGroupVersion = Versionable & {
  __typename?: 'DishSharedExtraGroupVersion';
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  locationMenuName?: Maybe<Scalars['String']['output']>;
  objectChanges: Array<VersionDiff>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

export type DishSize = {
  __typename?: 'DishSize';
  /** Editable, authoritative calorie value at the dish-size level. */
  calories?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
};

export type DishSizeInput = {
  calories?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  squareVariationId?: InputMaybe<Scalars['Int']['input']>;
  toastModifierOptionId?: InputMaybe<Scalars['Int']['input']>;
};

export type DishSizeVersion = Versionable & {
  __typename?: 'DishSizeVersion';
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  locationMenuName?: Maybe<Scalars['String']['output']>;
  objectChanges: Array<VersionDiff>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

export type DishTagObject = {
  __typename?: 'DishTagObject';
  abbr: Scalars['String']['output'];
  color: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imageIconUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type DishTagPaginationHandler = {
  __typename?: 'DishTagPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<RestaurantDishTag>;
};

/** Autogenerated input type of DishUpdateAllergens */
export type DishUpdateAllergensInput = {
  allergens: Array<AllergenEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dishId: Scalars['Int']['input'];
};

export type DishVersion = Versionable & {
  __typename?: 'DishVersion';
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  locationMenuName?: Maybe<Scalars['String']['output']>;
  objectChanges: Array<VersionDiff>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

/** Dish types */
export type Dishable = {
  customPhotos: Array<CustomPhoto>;
  description?: Maybe<Scalars['String']['output']>;
  dislikedItPopsCount: Scalars['Int']['output'];
  featuredPhotoUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  likedItPopsCount: Scalars['Int']['output'];
  lovedItPopsCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pops: Array<Pop>;
  popsCount: Scalars['Int']['output'];
  restaurant: Restaurant;
  reviews: Array<Review>;
  reviewsCount: Scalars['Int']['output'];
  wannaTryPopsCount: Scalars['Int']['output'];
};

/** Autogenerated input type of DismissFailedMessageGroup */
export type DismissFailedMessageGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageGroupId: Scalars['Int']['input'];
};

/** Autogenerated input type of DismissFailedPosts */
export type DismissFailedPostsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  socialPostId: Scalars['Int']['input'];
};

/** Autogenerated input type of DismissFailedTextMessageGroup */
export type DismissFailedTextMessageGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  textMessageGroupId: Scalars['Int']['input'];
};

/** Autogenerated input type of DismissSocialPostFailureIndicators */
export type DismissSocialPostFailureIndicatorsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  socialPostId: Scalars['Int']['input'];
};

/** Autogenerated input type of DismissSuggestedPosts */
export type DismissSuggestedPostsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

export type DncList = {
  __typename?: 'DncList';
  createdAt: Scalars['DateTime']['output'];
  dncInfo?: Maybe<Scalars['JSON']['output']>;
  dncListType: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  fileS3Key?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  splitFileTally?: Maybe<Scalars['JSON']['output']>;
  status: Scalars['String']['output'];
  statusAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DncListPaginationHandler = {
  __typename?: 'DncListPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<DncList>;
};

export type DoorDashDelivery = {
  __typename?: 'DoorDashDelivery';
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dasherFirstName?: Maybe<Scalars['String']['output']>;
  dasherFullName?: Maybe<Scalars['String']['output']>;
  dasherLastName?: Maybe<Scalars['String']['output']>;
  dasherPhoneNumber?: Maybe<Scalars['String']['output']>;
  dasherStatus?: Maybe<Scalars['String']['output']>;
  deliveryId: Scalars['ID']['output'];
  deliveryTrackingUrl?: Maybe<Scalars['String']['output']>;
  estimatedDeliveryTime?: Maybe<Scalars['DateTime']['output']>;
  estimatedPickupTime?: Maybe<Scalars['DateTime']['output']>;
  events: Array<DoorDashDeliveryEvent>;
  id: Scalars['Int']['output'];
  quotedPickupTime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusDescription?: Maybe<Scalars['String']['output']>;
  statusReason?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DoorDashDeliveryEvent = {
  __typename?: 'DoorDashDeliveryEvent';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dasherStatus?: Maybe<Scalars['String']['output']>;
  deliveryStatus?: Maybe<Scalars['String']['output']>;
  eventCategory?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DraftPaginationHandler = {
  __typename?: 'DraftPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<CustomPageDraft>;
};

/** Autogenerated input type of EarnLoyaltyProgramPromotionPoints */
export type EarnLoyaltyProgramPromotionPointsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  loyaltyProgramAccountId: Scalars['Int']['input'];
  loyaltyProgramPromotionId: Scalars['Int']['input'];
};

export type EcardAccount = {
  __typename?: 'EcardAccount';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isCredentialVerificationRequired?: Maybe<Scalars['Boolean']['output']>;
  lastSuccessfulCredentialVerificationAt?: Maybe<Scalars['DateTime']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type EcardAccountInputType = {
  locationId: Scalars['Int']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

/** Autogenerated input type of EditTableTop */
export type EditTableTopInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: TableTopInput;
  tableTopId: Scalars['Int']['input'];
};

export type Email = {
  __typename?: 'Email';
  domain?: Maybe<Scalars['String']['output']>;
  domainName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isUserNameEditable?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type EmailInput = {
  emailAddress: Scalars['String']['input'];
};

export type EmailMetrics = {
  __typename?: 'EmailMetrics';
  currentWeekOpenRateAverage: Scalars['Float']['output'];
  currentWeekOpenedCount: Scalars['Int']['output'];
  previousWeekOpenRateAverage: Scalars['Float']['output'];
};

export type EnabledOffersReturn = {
  __typename?: 'EnabledOffersReturn';
  offers?: Maybe<Array<Offer>>;
  orderingOffers?: Maybe<Array<OrderingOffer>>;
};

/** Autogenerated input type of EvaluateAiMarketingContent */
export type EvaluateAiMarketingContentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  response: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
};

export type Event = SocialPostSuggestionContentable & {
  __typename?: 'Event';
  eventType?: Maybe<Scalars['String']['output']>;
  eventable?: Maybe<Eventable>;
  eventableId?: Maybe<Scalars['Int']['output']>;
  eventableParent?: Maybe<Eventable>;
  eventableType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  occurredAt?: Maybe<Scalars['DateTime']['output']>;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  session?: Maybe<Session>;
  sessionId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type EventTag = {
  __typename?: 'EventTag';
  color: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  restaurant?: Maybe<Restaurant>;
  restaurantId?: Maybe<Scalars['Int']['output']>;
};

export type EventTagInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type EventTagPaginationHandler = {
  __typename?: 'EventTagPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<EventTag>;
};

/** Event subjects */
export type Eventable = {
  eventableName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type EverywareAccount = RestaurantPaymentAccountInterface & {
  __typename?: 'EverywareAccount';
  accountSlug: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  accountUrl: Scalars['String']['output'];
  canDisconnectPos: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isAvailable: Scalars['Boolean']['output'];
  isDeleting: Scalars['Boolean']['output'];
  isMenuSyncing: Scalars['Boolean']['output'];
  isShopSupported: Scalars['Boolean']['output'];
  isSyncing?: Maybe<Scalars['Boolean']['output']>;
  menuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  shouldReauthenticate: Scalars['Boolean']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type EverywareRefund = MenuItemCartRefundable & {
  __typename?: 'EverywareRefund';
  amount: Scalars['Decimal']['output'];
  id: Scalars['Int']['output'];
  refundedAt: Scalars['DateTime']['output'];
  refundedByUserEmail?: Maybe<Scalars['String']['output']>;
};

export enum Export {
  OrderDetails = 'order_details',
  PrepSheet = 'prep_sheet'
}

/** Autogenerated input type of ExportOrderingEvent */
export type ExportOrderingEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  exportType: Scalars['String']['input'];
  orderingEventId: Scalars['Int']['input'];
};

/** Autogenerated input type of ExportReservations */
export type ExportReservationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  locationId: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
};

/** Autogenerated input type of ExportSelectedUploads */
export type ExportSelectedUploadsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
  selectedFolderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  selectedIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  uploadType: Scalars['String']['input'];
};

export type ExternalIntegration = {
  __typename?: 'ExternalIntegration';
  canAdjustOrder: Scalars['Boolean']['output'];
  canMarkOutOfStock: Scalars['Boolean']['output'];
  canPause: Scalars['Boolean']['output'];
  canPublishMenu: Scalars['Boolean']['output'];
  canRejectOrder: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  integrationType: Scalars['String']['output'];
  isMenuSyncing: Scalars['Boolean']['output'];
  locationId: Scalars['String']['output'];
  menuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  open: Scalars['Boolean']['output'];
  pauseUntil?: Maybe<Scalars['DateTime']['output']>;
  paused: Scalars['Boolean']['output'];
};

export type FacbeookCampaignPaginationHandler = {
  __typename?: 'FacbeookCampaignPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<FacebookCampaign>;
};

export type FacebookCampaign = {
  __typename?: 'FacebookCampaign';
  ageMax?: Maybe<Scalars['Int']['output']>;
  ageMin?: Maybe<Scalars['Int']['output']>;
  budget?: Maybe<Scalars['Int']['output']>;
  callToActionTitle?: Maybe<Scalars['String']['output']>;
  callToActionUrl?: Maybe<Scalars['String']['output']>;
  customPageId?: Maybe<Scalars['Int']['output']>;
  dish?: Maybe<Dish>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  isFacebookAd?: Maybe<Scalars['Boolean']['output']>;
  isInstagramAd?: Maybe<Scalars['Boolean']['output']>;
  keyword?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  objective?: Maybe<Scalars['String']['output']>;
  offer?: Maybe<Offer>;
  orderingOffer?: Maybe<OrderingOffer>;
  restaurant?: Maybe<Restaurant>;
  runForDays?: Maybe<Scalars['Int']['output']>;
  selectedGenders: Array<FacebookCampaignSelectedGender>;
  selectedSocialAccounts: Array<FacebookCampaignSelectedSocialAccount>;
  shortMessage?: Maybe<Scalars['String']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FacebookCampaignInput = {
  ageMax: Scalars['Int']['input'];
  ageMin: Scalars['Int']['input'];
  billingCreditCardId?: InputMaybe<Scalars['Int']['input']>;
  budget: Scalars['Int']['input'];
  callToActionTitle?: InputMaybe<Scalars['String']['input']>;
  customPageId?: InputMaybe<Scalars['Int']['input']>;
  dishId: Scalars['Int']['input'];
  headline: Scalars['String']['input'];
  isDraft: Scalars['Boolean']['input'];
  isFacebookAd?: InputMaybe<Scalars['Boolean']['input']>;
  isInstagramAd?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  offerId?: InputMaybe<Scalars['Int']['input']>;
  orderingOfferId?: InputMaybe<Scalars['Int']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  runForDays: Scalars['Int']['input'];
  selectedGenders: Array<FacebookCampaignSelectedGenderInput>;
  selectedSocialAccounts: Array<FacebookCampaignSelectedSocialAccountInput>;
  shortMessage: Scalars['String']['input'];
  startAt: Scalars['DateTime']['input'];
};

export type FacebookCampaignSelectedGender = {
  __typename?: 'FacebookCampaignSelectedGender';
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type FacebookCampaignSelectedGenderInput = {
  gender: Scalars['String']['input'];
};

export type FacebookCampaignSelectedSocialAccount = {
  __typename?: 'FacebookCampaignSelectedSocialAccount';
  id: Scalars['Int']['output'];
  socialAccount?: Maybe<SocialAccount>;
};

export type FacebookCampaignSelectedSocialAccountInput = {
  socialAccountId: Scalars['Int']['input'];
};

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  /** List of available location feature flags */
  locationFeatures: Array<Scalars['String']['output']>;
  /** List of available restaurant feature flags */
  restaurantFeatures: Array<Scalars['String']['output']>;
};

export type Feedback = {
  __typename?: 'Feedback';
  comment?: Maybe<Scalars['String']['output']>;
  feedbackableId: Scalars['Int']['output'];
  feedbackableType: Scalars['String']['output'];
  guestName?: Maybe<Scalars['String']['output']>;
  guestPhone?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isRead: Scalars['Boolean']['output'];
  isSubmitted: Scalars['Boolean']['output'];
  location: RestaurantLocation;
  locationId: Scalars['Int']['output'];
  offerCode?: Maybe<OfferCode>;
  sentiment?: Maybe<Scalars['Int']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  token: Scalars['String']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
};

export type FeedbackInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  isSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  sentiment?: InputMaybe<Scalars['Int']['input']>;
};

export type FeedbackPaginationHandler = {
  __typename?: 'FeedbackPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<Feedback>;
};

export type FeedbackSetting = {
  __typename?: 'FeedbackSetting';
  id?: Maybe<Scalars['Int']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  isOfferEnabled: Scalars['Boolean']['output'];
  locationId: Scalars['Int']['output'];
  offer?: Maybe<Offer>;
};

export type FeedbackSettingInput = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOfferEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  offer?: InputMaybe<OfferInput>;
};

/** Autogenerated input type of FeedbackSettingUpdate */
export type FeedbackSettingUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  feedbackSettingInput: FeedbackSettingInput;
  locationId: Scalars['Int']['input'];
};

export type FeedbackSummary = {
  __typename?: 'FeedbackSummary';
  averageSatisfactionScore?: Maybe<Scalars['Decimal']['output']>;
  thirtyDaySatisfactionScore?: Maybe<Scalars['Decimal']['output']>;
  totalFeedback: Scalars['Int']['output'];
};

export type FeedbackWasSubmittedReturn = {
  __typename?: 'FeedbackWasSubmittedReturn';
  id: Scalars['Int']['output'];
};

/** Autogenerated input type of FindOrCreateStubUser */
export type FindOrCreateStubUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emailOrPhone: Scalars['String']['input'];
};

export type Follower = Eventable & {
  __typename?: 'Follower';
  avatarUrl: Scalars['String']['output'];
  birthDate?: Maybe<Scalars['String']['output']>;
  blockedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  eventableName: Scalars['String']['output'];
  favoriteLocation?: Maybe<RestaurantLocation>;
  firstName?: Maybe<Scalars['String']['output']>;
  followerSelectedTags: Array<FollowerSelectedTag>;
  id: Scalars['Int']['output'];
  isBlocked?: Maybe<Scalars['Boolean']['output']>;
  isImported: Scalars['Boolean']['output'];
  isMarketingPushUnsubscribed?: Maybe<Scalars['Boolean']['output']>;
  isOnDncList?: Maybe<Scalars['Boolean']['output']>;
  isOrderingPushUnsubscribed?: Maybe<Scalars['Boolean']['output']>;
  isSmsUnsubscribed?: Maybe<Scalars['Boolean']['output']>;
  isUnsubscribed?: Maybe<Scalars['Boolean']['output']>;
  isWelcomeMessageEnabled?: Maybe<Scalars['Boolean']['output']>;
  lastBouncedAt?: Maybe<Scalars['DateTime']['output']>;
  lastClickedAt?: Maybe<Scalars['DateTime']['output']>;
  lastLocation?: Maybe<RestaurantLocation>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastOpenedAt?: Maybe<Scalars['DateTime']['output']>;
  location?: Maybe<RestaurantLocation>;
  menuItemCarts: Array<MenuItemCart>;
  menuItemCartsCount: Scalars['Int']['output'];
  messages: Array<Messageable>;
  openTableLastReservationAt?: Maybe<Scalars['DateTime']['output']>;
  openTableReservationCount: Scalars['Int']['output'];
  paginatedParties: PartyPaginationHandler;
  paginatedPops: PopPaginationHandler;
  paginatedReviews: ReviewPaginationHandler;
  paginatedTrys: PopPaginationHandler;
  parties: Array<Party>;
  phone?: Maybe<Scalars['String']['output']>;
  pops: Array<Pop>;
  popsCount: Scalars['Int']['output'];
  restaurant?: Maybe<Restaurant>;
  restaurantId: Scalars['Int']['output'];
  reviews: Array<Review>;
  reviewsCount: Scalars['Int']['output'];
  smsUnsubscribedAt?: Maybe<Scalars['DateTime']['output']>;
  source: Scalars['String']['output'];
  submittedMenuItemCartsCount: Scalars['Int']['output'];
  unsubscribedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  visitMenuItems: Array<Visit>;
  visitsCount: Scalars['Int']['output'];
};


export type FollowerPaginatedPartiesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type FollowerPaginatedPopsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type FollowerPaginatedReviewsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type FollowerPaginatedTrysArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type FollowerByRestaurantInput = {
  followerId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of FollowerDismissMassActionNotifications */
export type FollowerDismissMassActionNotificationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  massActionNotificationIds: Array<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};

export type FollowerExport = {
  __typename?: 'FollowerExport';
  exportFileUrl?: Maybe<Scalars['String']['output']>;
  exportedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  restaurant: Restaurant;
  user: User;
  userDisplayName: Scalars['String']['output'];
};

export type FollowerFilterInputType = {
  allSelected?: InputMaybe<Scalars['Boolean']['input']>;
  excludedFollowerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  selectedFollowerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sources?: InputMaybe<Array<Scalars['String']['input']>>;
  tagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FollowerFlow = {
  __typename?: 'FollowerFlow';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enableLink: Scalars['Boolean']['output'];
  followedRestaurantName?: Maybe<Scalars['String']['output']>;
  isFollower?: Maybe<Scalars['Boolean']['output']>;
  isTextValidated: Scalars['Boolean']['output'];
  lastFourDigitsPhoneNumber?: Maybe<Scalars['String']['output']>;
  maskedEmail?: Maybe<Scalars['String']['output']>;
  orderingOfferCodesCount?: Maybe<Scalars['Int']['output']>;
  usePassword?: Maybe<Scalars['Boolean']['output']>;
};


export type FollowerFlowIsFollowerArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type FollowerFlowOrderingOfferCodesCountArgs = {
  restaurantId: Scalars['Int']['input'];
};

export type FollowerImport = {
  __typename?: 'FollowerImport';
  activeFollowersCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  detailedErrorMessage?: Maybe<Scalars['String']['output']>;
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  failureDismissedAt?: Maybe<Scalars['DateTime']['output']>;
  followersCount: Scalars['Int']['output'];
  friendlyErrorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  importFileUrl?: Maybe<Scalars['String']['output']>;
  importedAt?: Maybe<Scalars['DateTime']['output']>;
  lastRetryAt?: Maybe<Scalars['DateTime']['output']>;
  retryCount: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  usersCount: Scalars['Int']['output'];
};

/** Autogenerated input type of FollowerImportDismissFailure */
export type FollowerImportDismissFailureInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  followerImportId: Scalars['Int']['input'];
};

export type FollowerImportInput = {
  birthdayField?: InputMaybe<Scalars['String']['input']>;
  emailField?: InputMaybe<Scalars['String']['input']>;
  favoriteLocationField?: InputMaybe<Scalars['String']['input']>;
  firstNameField?: InputMaybe<Scalars['String']['input']>;
  fullNameField?: InputMaybe<Scalars['String']['input']>;
  importFileDataUrl?: InputMaybe<Scalars['String']['input']>;
  isWelcomeMessageEnabled: Scalars['Boolean']['input'];
  lastNameField?: InputMaybe<Scalars['String']['input']>;
  loyaltyBalanceField?: InputMaybe<Scalars['String']['input']>;
  phoneField?: InputMaybe<Scalars['String']['input']>;
  tagField?: InputMaybe<Scalars['String']['input']>;
  uploadedImportId: Scalars['Int']['input'];
};

/** Autogenerated input type of FollowerImportRetry */
export type FollowerImportRetryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  followerImportId: Scalars['Int']['input'];
};

export type FollowerInput = {
  isMarketingPushUnsubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingPushUnsubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  isSmsUnsubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  isUnsubscribed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FollowerKpiCounts = {
  __typename?: 'FollowerKpiCounts';
  emailSubscribedFollowers: Scalars['Int']['output'];
  textMessageSubscribedFollowers: Scalars['Int']['output'];
  totalFollowers: Scalars['Int']['output'];
};

/** Autogenerated input type of FollowerMassAction */
export type FollowerMassActionInput = {
  action: ActionInputType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  filtersInput?: InputMaybe<FollowerFilterInputType>;
  restaurantId: Scalars['Int']['input'];
};

export type FollowerMassActionNotification = {
  __typename?: 'FollowerMassActionNotification';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserId: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  detailedErrorMessage?: Maybe<Scalars['String']['output']>;
  dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  lastFailedAt?: Maybe<Scalars['DateTime']['output']>;
  massActionType: Scalars['String']['output'];
  restaurantId: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type FollowerMetrics = {
  __typename?: 'FollowerMetrics';
  currentWeekFollowersCount: Scalars['Int']['output'];
  previousWeekFollowersCount: Scalars['Int']['output'];
};

export type FollowerPaginationHandler = {
  __typename?: 'FollowerPaginationHandler';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  records: Array<Follower>;
};

export type FollowerSegmentEstimatedAudience = {
  __typename?: 'FollowerSegmentEstimatedAudience';
  estimatedAudience: Scalars['Int']['output'];
  estimatedEmailAudience: Scalars['Int']['output'];
  estimatedSmsAudience: Scalars['Int']['output'];
};

export type FollowerSegmentation = {
  __typename?: 'FollowerSegmentation';
  follower: Follower;
  followerCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  followerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastCateringOrderSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  lastEmailOpenedAt?: Maybe<Scalars['DateTime']['output']>;
  lastMenuItemCartSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  lastTextAt?: Maybe<Scalars['DateTime']['output']>;
  location?: Maybe<RestaurantLocation>;
  locationId?: Maybe<Scalars['Int']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  moneySpent: Scalars['Float']['output'];
  ordersCount: Scalars['Int']['output'];
  source: Scalars['String']['output'];
  user?: Maybe<User>;
};

export type FollowerSegmentationPaginationHandler = {
  __typename?: 'FollowerSegmentationPaginationHandler';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  records: Array<FollowerSegmentation>;
};

export type FollowerSelectedTag = {
  __typename?: 'FollowerSelectedTag';
  followerTagId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type FollowerSelectedTagInput = {
  followerTagId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type FollowerTableFilterOptions = {
  __typename?: 'FollowerTableFilterOptions';
  followerSources: Array<Scalars['String']['output']>;
  followerTags: Array<FollowerTag>;
  locations: Array<RestaurantLocation>;
};

export type FollowerTag = {
  __typename?: 'FollowerTag';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  followersCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  restaurant?: Maybe<Restaurant>;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  tagType?: Maybe<Scalars['String']['output']>;
};

export type FollowerTagInput = {
  name: Scalars['String']['input'];
};

export type FollowerTagPaginationHandler = {
  __typename?: 'FollowerTagPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<FollowerTag>;
};

export type FollowerUserInput = {
  birthDay?: InputMaybe<Scalars['Int']['input']>;
  birthMonth?: InputMaybe<Scalars['Int']['input']>;
  favoriteLocationId?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  weddingDay?: InputMaybe<Scalars['Int']['input']>;
  weddingMonth?: InputMaybe<Scalars['Int']['input']>;
};

export type FollowersForMessages = {
  __typename?: 'FollowersForMessages';
  count: Scalars['Int']['output'];
  invalidEmailsCount: Scalars['Int']['output'];
  smsUnsubscribedCount: Scalars['Int']['output'];
  unsubscribedCount: Scalars['Int']['output'];
};

export enum FontCase {
  Capitalize = 'capitalize',
  Lowercase = 'lowercase',
  None = 'none',
  Uppercase = 'uppercase'
}

export type FontSelection = {
  __typename?: 'FontSelection';
  case: Scalars['String']['output'];
  caseNoFallback?: Maybe<FontCase>;
  color?: Maybe<Scalars['String']['output']>;
  customFontUrls: Array<Scalars['String']['output']>;
  family?: Maybe<Scalars['String']['output']>;
  fontId?: Maybe<Scalars['Int']['output']>;
  googleFontId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  themeFont?: Maybe<ThemeFont>;
  themeFontId?: Maybe<Scalars['Int']['output']>;
  weight: Scalars['String']['output'];
  weightNoFallback?: Maybe<FontWeight>;
};

export enum FontSize {
  Large = 'large',
  Medium = 'medium',
  Small = 'small'
}

export enum FontWeight {
  Bold = 'bold',
  Light = 'light',
  Normal = 'normal'
}

/** Autogenerated input type of ForceSignOutUsers */
export type ForceSignOutUsersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userIds: Array<Scalars['Int']['input']>;
};

export enum FulfillmentTypesEnum {
  DeliveryOnly = 'delivery_only',
  OrderingUnavailable = 'ordering_unavailable',
  PickupAndDelivery = 'pickup_and_delivery',
  PickupOnly = 'pickup_only'
}

/** Autogenerated input type of GenerateAiMarketingCampaignContent */
export type GenerateAiMarketingCampaignContentInput = {
  aiMarketingCampaignContentInput: AiMarketingCampaignContentInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of GenerateAiMarketingGenerateExampleContentResponse */
export type GenerateAiMarketingGenerateExampleContentResponseInput = {
  aiModel: Scalars['String']['input'];
  aimPromptConfigId?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
  subjectType?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of GenerateAiMarketingPrompt */
export type GenerateAiMarketingPromptInput = {
  aiMarketableId?: InputMaybe<Scalars['Int']['input']>;
  aiMarketableType?: InputMaybe<Scalars['String']['input']>;
  aimPromptConfigId?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  customPrompt?: InputMaybe<Scalars['String']['input']>;
  draftFeatures?: InputMaybe<Scalars['JSON']['input']>;
  draftPrompt?: InputMaybe<Scalars['String']['input']>;
  holiday?: InputMaybe<Scalars['String']['input']>;
  postDate?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
  subjectType: Scalars['String']['input'];
  wday?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of GenerateAiResponse */
export type GenerateAiResponseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
  reviewId: Scalars['Int']['input'];
  reviewType: Scalars['String']['input'];
};

/** Autogenerated input type of GenerateAiText */
export type GenerateAiTextInput = {
  aiMarketingContentId?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  descriptor?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['Int']['input']>;
  isMultiCampaign?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['Int']['input']>;
  orderingEventId?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
  tone?: InputMaybe<Scalars['String']['input']>;
  useAimFineTuning?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of GenerateMessageGroupAiText */
export type GenerateMessageGroupAiTextInput = {
  aiMarketingContentId?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  descriptor?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['Int']['input']>;
  isMultiCampaign?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['Int']['input']>;
  orderingEventId?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
  tone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of GenerateRestaurantContentType */
export type GenerateRestaurantContentTypeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of GenerateTextMessageGroupAiText */
export type GenerateTextMessageGroupAiTextInput = {
  aiMarketingContentId?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  descriptor?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['Int']['input']>;
  isMultiCampaign?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['Int']['input']>;
  orderingEventId?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
  tone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of GenerateYourToneSampleType */
export type GenerateYourToneSampleTypeInput = {
  aiMarketingDefaultOptionId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentTone?: InputMaybe<Scalars['String']['input']>;
  yourToneAdjectives: Array<Scalars['String']['input']>;
};

export type GiftCard = {
  __typename?: 'GiftCard';
  amount: Scalars['Decimal']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  imageUploadedPhoto?: Maybe<UploadedPhoto>;
  lastFour?: Maybe<Scalars['String']['output']>;
  messages: Array<GiftCardMessage>;
  name: Scalars['String']['output'];
  originalAmount: Scalars['Decimal']['output'];
  restaurant?: Maybe<Restaurant>;
  selectedShopItem?: Maybe<ShopItemCartSelectedShopItem>;
  selectedShopItemId?: Maybe<Scalars['Int']['output']>;
  sentStatus?: Maybe<Scalars['String']['output']>;
};

export type GiftCardInput = {
  email: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type GiftCardMessage = {
  __typename?: 'GiftCardMessage';
  id: Scalars['Int']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentStatus?: Maybe<Scalars['String']['output']>;
};

export type GiftCardPaginationHandler = {
  __typename?: 'GiftCardPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<GiftCard>;
};

export type GocardlessBillingRequestFlow = {
  __typename?: 'GocardlessBillingRequestFlow';
  billingCustomerId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  restaurant?: Maybe<Restaurant>;
};

export type GoogleLocationReviewPaginationType = {
  __typename?: 'GoogleLocationReviewPaginationType';
  count: Scalars['Int']['output'];
  records: Array<GoogleMyBusinessLocationReview>;
};

export type GoogleMyBusinessAccount = {
  __typename?: 'GoogleMyBusinessAccount';
  accountName: Scalars['String']['output'];
  accountNumber?: Maybe<Scalars['String']['output']>;
  accountType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  permissionLevel?: Maybe<Scalars['String']['output']>;
  profilePhotoUrl?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type GoogleMyBusinessAvailableAttribute = {
  __typename?: 'GoogleMyBusinessAvailableAttribute';
  attributeId?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  groupDisplayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isDeprecated?: Maybe<Scalars['Boolean']['output']>;
  isRepeatable?: Maybe<Scalars['Boolean']['output']>;
  valueType?: Maybe<Scalars['String']['output']>;
  values: Array<GoogleMyBusinessAvailableAttributeValue>;
};

export type GoogleMyBusinessAvailableAttributeValue = {
  __typename?: 'GoogleMyBusinessAvailableAttributeValue';
  availableAttributeId?: Maybe<Scalars['Int']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type GoogleMyBusinessCategory = {
  __typename?: 'GoogleMyBusinessCategory';
  categoryId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type GoogleMyBusinessLocation = {
  __typename?: 'GoogleMyBusinessLocation';
  accountId?: Maybe<Scalars['Int']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  administrativeArea?: Maybe<Scalars['String']['output']>;
  hasPendingEdits?: Maybe<Scalars['Boolean']['output']>;
  hasPendingVerification?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  isDisconnected?: Maybe<Scalars['Boolean']['output']>;
  isDuplicate?: Maybe<Scalars['Boolean']['output']>;
  isPendingPublish?: Maybe<Scalars['Boolean']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  isSuspended?: Maybe<Scalars['Boolean']['output']>;
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  lastMenuUpdateAt?: Maybe<Scalars['DateTime']['output']>;
  lastUpdateAt?: Maybe<Scalars['DateTime']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  location?: Maybe<RestaurantLocation>;
  locationAttributes: Array<GoogleMyBusinessLocationAttribute>;
  locationId?: Maybe<Scalars['Int']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  locationPlaceActionLinks: Array<GoogleMyBusinessPlaceActionLinkType>;
  name?: Maybe<Scalars['String']['output']>;
  needsReverification?: Maybe<Scalars['Boolean']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  restaurantId?: Maybe<Scalars['Int']['output']>;
};

export type GoogleMyBusinessLocationAttribute = {
  __typename?: 'GoogleMyBusinessLocationAttribute';
  attributeId?: Maybe<Scalars['Int']['output']>;
  availableAttribute?: Maybe<GoogleMyBusinessAvailableAttribute>;
  availableAttributeId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type GoogleMyBusinessLocationReview = {
  __typename?: 'GoogleMyBusinessLocationReview';
  comment?: Maybe<Scalars['String']['output']>;
  createTime?: Maybe<Scalars['DateTime']['output']>;
  generatedResponse?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  location?: Maybe<GoogleMyBusinessLocation>;
  name?: Maybe<Scalars['String']['output']>;
  reply?: Maybe<GoogleMyBusinessLocationReviewReply>;
  restaurantLocationName?: Maybe<Scalars['String']['output']>;
  reviewerDisplayName?: Maybe<Scalars['String']['output']>;
  reviewerIsAnonymous?: Maybe<Scalars['Boolean']['output']>;
  reviewerProfilePhotoUrl?: Maybe<Scalars['String']['output']>;
  sentiment: Scalars['String']['output'];
  starRating?: Maybe<Scalars['String']['output']>;
  stars: Scalars['Int']['output'];
};

export type GoogleMyBusinessLocationReviewReply = {
  __typename?: 'GoogleMyBusinessLocationReviewReply';
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  updateTime?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export type GoogleMyBusinessPlaceActionLinkType = {
  __typename?: 'GoogleMyBusinessPlaceActionLinkType';
  id: Scalars['Int']['output'];
  isEditable: Scalars['Boolean']['output'];
  isPreferred: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  placeActionType: Scalars['String']['output'];
  providerType: Scalars['String']['output'];
  uri: Scalars['String']['output'];
};

export type GooglePost = {
  __typename?: 'GooglePost';
  actionType?: Maybe<Scalars['String']['output']>;
  actionUrl?: Maybe<Scalars['String']['output']>;
  calendarEventId?: Maybe<Scalars['Int']['output']>;
  campaignItemId?: Maybe<Scalars['Int']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  endTime?: Maybe<Scalars['Time']['output']>;
  googlePostLocations: Array<GooglePostLocation>;
  id: Scalars['Int']['output'];
  isProcessed?: Maybe<Scalars['Boolean']['output']>;
  isScheduled?: Maybe<Scalars['Boolean']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  photoUploadedPhoto?: Maybe<UploadedPhoto>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  redeemOnlineUrl?: Maybe<Scalars['String']['output']>;
  restaurant?: Maybe<Restaurant>;
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  startTime?: Maybe<Scalars['Time']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  termsConditions?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  topicType: Scalars['String']['output'];
  user?: Maybe<User>;
};

export type GooglePostLocation = {
  __typename?: 'GooglePostLocation';
  displayName?: Maybe<Scalars['String']['output']>;
  googleMyBusinessLocation?: Maybe<GoogleMyBusinessLocation>;
  googlePost?: Maybe<GooglePost>;
  id: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type GooglePostPaginationHandler = {
  __typename?: 'GooglePostPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<GooglePost>;
};

/** Autogenerated input type of GradeAimPlaygroundEvaluationSet */
export type GradeAimPlaygroundEvaluationSetInput = {
  aimContentEvaluationIds: Array<Scalars['Int']['input']>;
  aimPromptConfigId: Scalars['Int']['input'];
  brief?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GroupPaginationHandler = {
  __typename?: 'GroupPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<SproutSocialGroup>;
};

export type GuestProfile = {
  __typename?: 'GuestProfile';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  orderHistory?: Maybe<Array<MenuItemCart>>;
  orderingOfferCodes?: Maybe<Array<OrderingOfferCode>>;
  userGiftCards?: Maybe<Array<GiftCard>>;
};


export type GuestProfileOrderHistoryArgs = {
  cartType?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type GuestProfileOrderingOfferCodesArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type GuestProfileUserGiftCardsArgs = {
  restaurantId: Scalars['Int']['input'];
};

export type HeartlandAccount = RestaurantPaymentAccountInterface & {
  __typename?: 'HeartlandAccount';
  accountSlug: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  accountUrl: Scalars['String']['output'];
  canDisconnectPos: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isDeleting: Scalars['Boolean']['output'];
  isMenuSyncing: Scalars['Boolean']['output'];
  isShopSupported: Scalars['Boolean']['output'];
  isSyncing?: Maybe<Scalars['Boolean']['output']>;
  menuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  publicKey: Scalars['String']['output'];
  restaurant: Restaurant;
  shouldReauthenticate: Scalars['Boolean']['output'];
};

export type HeartlandPosLocation = {
  __typename?: 'HeartlandPosLocation';
  heartlandPosRoot: HeartlandPosRoot;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type HeartlandPosRoom = {
  __typename?: 'HeartlandPosRoom';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type HeartlandPosRoot = RestaurantPaymentAccountInterface & {
  __typename?: 'HeartlandPosRoot';
  accountSlug: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  accountUrl: Scalars['String']['output'];
  canDisconnectPos: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isDeleting: Scalars['Boolean']['output'];
  isMenuSyncing: Scalars['Boolean']['output'];
  isShopSupported: Scalars['Boolean']['output'];
  isSyncing: Scalars['Boolean']['output'];
  lastSyncStartedAt?: Maybe<Scalars['DateTime']['output']>;
  menuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  shouldReauthenticate: Scalars['Boolean']['output'];
};

export type HeartlandPosSetting = {
  __typename?: 'HeartlandPosSetting';
  heartlandCreditCardPaymentId?: Maybe<Scalars['String']['output']>;
  heartlandCurbsideRoomId?: Maybe<Scalars['String']['output']>;
  heartlandDeliveryRoomId?: Maybe<Scalars['String']['output']>;
  heartlandDeliveryServiceChargeId?: Maybe<Scalars['String']['output']>;
  heartlandDiscountId?: Maybe<Scalars['String']['output']>;
  heartlandFeeServiceChargeId?: Maybe<Scalars['String']['output']>;
  heartlandPickupRoomId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type HeartlandPosSettingInput = {
  heartlandCurbsideRoomId?: InputMaybe<Scalars['String']['input']>;
  heartlandDeliveryRoomId?: InputMaybe<Scalars['String']['input']>;
  heartlandPickupRoomId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of HeartlandPosSettingUpdate */
export type HeartlandPosSettingUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  heartlandPosSettingInput: HeartlandPosSettingInput;
  locationId: Scalars['Int']['input'];
};

export type HeartlandRefund = MenuItemCartRefundable & {
  __typename?: 'HeartlandRefund';
  amount: Scalars['Decimal']['output'];
  id: Scalars['Int']['output'];
  refundedAt: Scalars['DateTime']['output'];
  refundedByUserEmail?: Maybe<Scalars['String']['output']>;
};

export type Highlight = {
  __typename?: 'Highlight';
  cloudflareId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  ctaButtonType: Scalars['String']['output'];
  ctaCustomLinkText?: Maybe<Scalars['String']['output']>;
  ctaCustomLinkUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  highlightReelId: Scalars['ID']['output'];
  highlightable?: Maybe<HighlightableUnion>;
  highlightableId?: Maybe<Scalars['ID']['output']>;
  highlightableType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isShowCtaButton: Scalars['Boolean']['output'];
  mediaType?: Maybe<Scalars['String']['output']>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  restaurantId: Scalars['ID']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uploadedPhoto?: Maybe<UploadedPhoto>;
  uploadedPhotoId?: Maybe<Scalars['ID']['output']>;
  uploadedVideo?: Maybe<UploadedVideo>;
  uploadedVideoId?: Maybe<Scalars['ID']['output']>;
};

export type HighlightReel = {
  __typename?: 'HighlightReel';
  createdAt: Scalars['DateTime']['output'];
  highlights: Array<Highlight>;
  highlightsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  restaurantId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usedInCustomPage: Scalars['Boolean']['output'];
};

export type HighlightReview = {
  __typename?: 'HighlightReview';
  authorName?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  itemId?: Maybe<Scalars['Int']['output']>;
  itemName: Scalars['String']['output'];
  menuId: Scalars['ID']['output'];
  photoUrl?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  reviewId: Scalars['ID']['output'];
};

/** Models that can be featured by a Highlight */
export type HighlightableUnion = Dish;

export type Holiday = {
  __typename?: 'Holiday';
  date: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum HorizontalAlignment {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

export enum HostingType {
  HostingDomain = 'hosting_domain',
  HostingSubdomain = 'hosting_subdomain',
  HostingWidget = 'hosting_widget'
}

export type HungrrrPayPreflightResult = {
  __typename?: 'HungrrrPayPreflightResult';
  accountType?: Maybe<Scalars['String']['output']>;
  businessIdentityPresent: Scalars['Boolean']['output'];
  businessName?: Maybe<Scalars['String']['output']>;
  businessUrl?: Maybe<Scalars['String']['output']>;
  canConnect: Scalars['Boolean']['output'];
  cardPaymentsActive: Scalars['Boolean']['output'];
  chargesEnabled: Scalars['Boolean']['output'];
  currencyMatches: Scalars['Boolean']['output'];
  defaultCurrency?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  express: Scalars['Boolean']['output'];
  messages: Array<Scalars['String']['output']>;
  noConnectionConflicts: Scalars['Boolean']['output'];
  pendingCartsCount: Scalars['Int']['output'];
};

/** Autogenerated input type of ImpersonateUser */
export type ImpersonateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

export type ImpressionRevenueGraphVariablesInput = {
  startDate: Scalars['DateTime']['input'];
  type: Scalars['String']['input'];
};

/** Autogenerated input type of InitializeChannel */
export type InitializeChannelInput = {
  campaignId?: InputMaybe<Scalars['Int']['input']>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
  channelType: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageGroupInput?: InputMaybe<MessageGroupInput>;
  pushMessageGroupInput?: InputMaybe<PushMessageGroupInput>;
  restaurantId: Scalars['Int']['input'];
  socialPostInput?: InputMaybe<SocialPostInput>;
  textMessageGroupInput?: InputMaybe<TextMessageGroupInput>;
};

export type InitializedChannel = {
  __typename?: 'InitializedChannel';
  campaignId: Scalars['Int']['output'];
  channelId: Scalars['Int']['output'];
};

export type InitiateInput = {
  fileBytes?: InputMaybe<Scalars['Int']['input']>;
  fileHash: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  restaurantId: Scalars['ID']['input'];
};

/** Autogenerated input type of InitiateMenuProcessing */
export type InitiateMenuProcessingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: InitiateInput;
};

export type InitiateResponse = {
  __typename?: 'InitiateResponse';
  menuProcessingResult?: Maybe<MenuProcessingResult>;
  uploadId?: Maybe<Scalars['String']['output']>;
  uploadUrl?: Maybe<Scalars['String']['output']>;
};

export type InstagramLivePostPaginationHandler = {
  __typename?: 'InstagramLivePostPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<SocialPostInstagramLivePost>;
};

/** Autogenerated input type of InvalidateGiftCard */
export type InvalidateGiftCardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** gift card ID */
  giftCardId: Scalars['Int']['input'];
  /** restaurant ID */
  restaurantId: Scalars['Int']['input'];
};

export type InventoryLocationInput = {
  id: Scalars['Int']['input'];
  outOfStock: Scalars['Boolean']['input'];
  outOfStockUntil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LeadInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['String']['input'];
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street?: InputMaybe<Scalars['String']['input']>;
};

export type LighthouseReport = {
  __typename?: 'LighthouseReport';
  avgAccessibilityScoreDesktop?: Maybe<Scalars['Decimal']['output']>;
  avgAccessibilityScoreMobile?: Maybe<Scalars['Decimal']['output']>;
  avgBestPracticesScoreDesktop?: Maybe<Scalars['Decimal']['output']>;
  avgBestPracticesScoreMobile?: Maybe<Scalars['Decimal']['output']>;
  avgCumulativeLayoutShiftScoreDesktop?: Maybe<Scalars['Decimal']['output']>;
  avgCumulativeLayoutShiftScoreMobile?: Maybe<Scalars['Decimal']['output']>;
  avgLargestContentfulPaintScoreDesktop?: Maybe<Scalars['Decimal']['output']>;
  avgLargestContentfulPaintScoreMobile?: Maybe<Scalars['Decimal']['output']>;
  avgPerformanceScoreDesktop?: Maybe<Scalars['Decimal']['output']>;
  avgPerformanceScoreMobile?: Maybe<Scalars['Decimal']['output']>;
  avgSeoScoreDesktop?: Maybe<Scalars['Decimal']['output']>;
  avgSeoScoreMobile?: Maybe<Scalars['Decimal']['output']>;
  avgTotalBlockingTimeScoreDesktop?: Maybe<Scalars['Decimal']['output']>;
  avgTotalBlockingTimeScoreMobile?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['Int']['output'];
  minAccessibilityScoreDesktop?: Maybe<Scalars['Decimal']['output']>;
  minAccessibilityScoreMobile?: Maybe<Scalars['Decimal']['output']>;
  minBestPracticesScoreDesktop?: Maybe<Scalars['Decimal']['output']>;
  minBestPracticesScoreMobile?: Maybe<Scalars['Decimal']['output']>;
  minCumulativeLayoutShiftScoreDesktop?: Maybe<Scalars['Decimal']['output']>;
  minCumulativeLayoutShiftScoreMobile?: Maybe<Scalars['Decimal']['output']>;
  minLargestContentfulPaintScoreDesktop?: Maybe<Scalars['Decimal']['output']>;
  minLargestContentfulPaintScoreMobile?: Maybe<Scalars['Decimal']['output']>;
  minPerformanceScoreDesktop?: Maybe<Scalars['Decimal']['output']>;
  minPerformanceScoreMobile?: Maybe<Scalars['Decimal']['output']>;
  minPwaScoreDesktop?: Maybe<Scalars['Decimal']['output']>;
  minPwaScoreMobile?: Maybe<Scalars['Decimal']['output']>;
  minSeoScoreDesktop?: Maybe<Scalars['Decimal']['output']>;
  minSeoScoreMobile?: Maybe<Scalars['Decimal']['output']>;
  minTotalBlockingTimeScoreDesktop?: Maybe<Scalars['Decimal']['output']>;
  minTotalBlockingTimeScoreMobile?: Maybe<Scalars['Decimal']['output']>;
  originCoreWebVitalsCategoryDesktop?: Maybe<Scalars['String']['output']>;
  originCoreWebVitalsCategoryMobile?: Maybe<Scalars['String']['output']>;
  originWebVitalsDesktop: Array<LighthouseReportOriginWebVital>;
  originWebVitalsMobile: Array<LighthouseReportOriginWebVital>;
  pageReports: Array<LighthouseReportPageReport>;
  pageReportsCount?: Maybe<Scalars['Int']['output']>;
  pageReportsDesktop: Array<LighthouseReportPageReport>;
  pageReportsMobile: Array<LighthouseReportPageReport>;
  reportAt: Scalars['DateTime']['output'];
  restaurant: Restaurant;
  restaurantUrl: Scalars['String']['output'];
  zipUrl?: Maybe<Scalars['String']['output']>;
};

export type LighthouseReportOriginWebVital = {
  __typename?: 'LighthouseReportOriginWebVital';
  category?: Maybe<Scalars['String']['output']>;
  goodProportion?: Maybe<Scalars['Decimal']['output']>;
  metric: Scalars['String']['output'];
  needsImprovementProportion?: Maybe<Scalars['Decimal']['output']>;
  poorProportion?: Maybe<Scalars['Decimal']['output']>;
  value?: Maybe<Scalars['Decimal']['output']>;
};

export type LighthouseReportPageReport = {
  __typename?: 'LighthouseReportPageReport';
  accessibilityScore?: Maybe<Scalars['Decimal']['output']>;
  bestPracticesScore?: Maybe<Scalars['Decimal']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cumulativeLayoutShiftScore?: Maybe<Scalars['Decimal']['output']>;
  finalScreenshotThumbnailUrl?: Maybe<Scalars['String']['output']>;
  finalScreenshotUrl?: Maybe<Scalars['String']['output']>;
  htmlReportName?: Maybe<Scalars['String']['output']>;
  htmlReportUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isHomePage?: Maybe<Scalars['Boolean']['output']>;
  largestContentfulPaintScore?: Maybe<Scalars['Decimal']['output']>;
  lighthouseReport: LighthouseReport;
  pageUrl: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  performanceScore?: Maybe<Scalars['Decimal']['output']>;
  pwaScore?: Maybe<Scalars['Decimal']['output']>;
  reportType?: Maybe<Scalars['String']['output']>;
  seoScore?: Maybe<Scalars['Decimal']['output']>;
  totalBlockingTimeScore?: Maybe<Scalars['Decimal']['output']>;
};

export type LighthouseReportPaginationHandler = {
  __typename?: 'LighthouseReportPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<LighthouseReport>;
};

export type LiveDomain = {
  __typename?: 'LiveDomain';
  apexIpAddresses?: Maybe<Scalars['String']['output']>;
  awsHostedZoneId?: Maybe<Scalars['String']['output']>;
  awsHostedZoneNs?: Maybe<Scalars['String']['output']>;
  awsSubdomainRefreshAt?: Maybe<Scalars['DateTime']['output']>;
  awsSubdomainStatus?: Maybe<Scalars['String']['output']>;
  awsWwwRefreshAt?: Maybe<Scalars['DateTime']['output']>;
  awsWwwStatus?: Maybe<Scalars['String']['output']>;
  cloudflareApexHostnameSslStatus?: Maybe<Scalars['String']['output']>;
  cloudflareApexHostnameStatus?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUser?: Maybe<User>;
  domain: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  hasMxRecord: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isPrimaryDomain?: Maybe<Scalars['Boolean']['output']>;
  isPublished: Scalars['Boolean']['output'];
  isPublishing: Scalars['Boolean']['output'];
  lastAwsPublishAt?: Maybe<Scalars['DateTime']['output']>;
  lastDnsSnapshot?: Maybe<LiveDomainDnsSnapshot>;
  lastPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  lastSnapshotAt?: Maybe<Scalars['DateTime']['output']>;
  nameServers?: Maybe<Array<Scalars['String']['output']>>;
  nsProvider: Scalars['String']['output'];
  nsProviderNameServers?: Maybe<Scalars['String']['output']>;
  ownerContactEmail?: Maybe<Scalars['String']['output']>;
  ownerContactName?: Maybe<Scalars['String']['output']>;
  ownerContactOrganization?: Maybe<Scalars['String']['output']>;
  publishErrorMessage?: Maybe<Scalars['String']['output']>;
  registrarName?: Maybe<Scalars['String']['output']>;
  restaurant?: Maybe<Restaurant>;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  stagedRecords: Array<LiveDomainStagedRecord>;
  status?: Maybe<Scalars['String']['output']>;
  subdomainCname?: Maybe<Scalars['String']['output']>;
  wwwCname?: Maybe<Scalars['String']['output']>;
};

export type LiveDomainDnsSnapshot = {
  __typename?: 'LiveDomainDnsSnapshot';
  dnsRecords: Array<LiveDomainDnsSnapshotDnsRecord>;
  id: Scalars['Int']['output'];
  snapshotAt: Scalars['DateTime']['output'];
};

export type LiveDomainDnsSnapshotDnsRecord = {
  __typename?: 'LiveDomainDnsSnapshotDnsRecord';
  id: Scalars['Int']['output'];
  recordName?: Maybe<Scalars['String']['output']>;
  recordType: Scalars['String']['output'];
  recordValue?: Maybe<Scalars['String']['output']>;
};

export type LiveDomainInput = {
  stagedRecords?: InputMaybe<Array<LiveDomainStagedRecordInput>>;
};

export type LiveDomainPaginationHandler = {
  __typename?: 'LiveDomainPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<LiveDomain>;
};

export type LiveDomainStagedRecord = {
  __typename?: 'LiveDomainStagedRecord';
  id: Scalars['Int']['output'];
  recordName?: Maybe<Scalars['String']['output']>;
  recordType: Scalars['String']['output'];
  recordValue: Scalars['String']['output'];
};

export type LiveDomainStagedRecordInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  recordName?: InputMaybe<Scalars['String']['input']>;
  recordType: Scalars['String']['input'];
  recordValue: Scalars['String']['input'];
};

export type LiveDomainStagedRecordPaginationHandler = {
  __typename?: 'LiveDomainStagedRecordPaginationHandler';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  offset: Scalars['Int']['output'];
  records: Array<LiveDomainStagedRecord>;
};

export type LivePostPaginationHandler = {
  __typename?: 'LivePostPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<SocialPostLivePost>;
};

export type LocationAddress = {
  __typename?: 'LocationAddress';
  addressLines: Array<Scalars['String']['output']>;
  administrativeArea: Scalars['String']['output'];
  locality: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
};

export type LocationAttributeInput = {
  actionType?: InputMaybe<Scalars['String']['input']>;
  attributeId: Scalars['Int']['input'];
  isPlaceActionLink?: InputMaybe<Scalars['Boolean']['input']>;
  value: Scalars['String']['input'];
};

export type LocationCustomContentLink = {
  __typename?: 'LocationCustomContentLink';
  customHref?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isExternal: Scalars['Boolean']['output'];
  linkType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  targetId?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
};

export type LocationPolicy = {
  __typename?: 'LocationPolicy';
  canEnableDelivery: Scalars['Boolean']['output'];
  canEnableGoogleOrdering: Scalars['Boolean']['output'];
  canEnablePickup: Scalars['Boolean']['output'];
  canManageFeedback: Scalars['Boolean']['output'];
  canManageMessages: Scalars['Boolean']['output'];
  canManageOrders: Scalars['Boolean']['output'];
  canManageRefunds: Scalars['Boolean']['output'];
  canManageReservations: Scalars['Boolean']['output'];
  canManageReviewSettings: Scalars['Boolean']['output'];
  canManageSettings: Scalars['Boolean']['output'];
  canManageTwilioBusinessRegistration: Scalars['Boolean']['output'];
  canManageWaitlistSettings: Scalars['Boolean']['output'];
  canManageWaitlists: Scalars['Boolean']['output'];
  destroy: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  manageOrderPayments: Scalars['Boolean']['output'];
  publish: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
};

export type LoginCarouselSlide = {
  __typename?: 'LoginCarouselSlide';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imageUploadedPhoto?: Maybe<UploadedPhoto>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type LoginCarouselSlideInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LoginCarouselSlidePaginationHandler = {
  __typename?: 'LoginCarouselSlidePaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<LoginCarouselSlide>;
};

/** Loyalty Account based on Loyalty Program type */
export type LoyaltyAccount = LoyaltyProgramAccount | SquareLoyaltyAccount;

/** Loyalty Program based on Loyalty type */
export type LoyaltyProgram = PopmenuLoyaltyProgram | SquareLoyaltyProgram;

export type LoyaltyProgramAccount = {
  __typename?: 'LoyaltyProgramAccount';
  balance?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isFacebookFollowPromotionEarned: Scalars['Boolean']['output'];
  isInstagramFollowPromotionEarned: Scalars['Boolean']['output'];
  rewardTiers?: Maybe<Array<LoyaltyProgramRewardTier>>;
  transactions?: Maybe<Array<LoyaltyProgramAccountTransactionHistory>>;
};

export type LoyaltyProgramAccountTransactionHistory = {
  __typename?: 'LoyaltyProgramAccountTransactionHistory';
  balanceChange: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  menuItemCartId?: Maybe<Scalars['Int']['output']>;
  transactionType: Scalars['String']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
};

export type LoyaltyProgramPromotion = {
  __typename?: 'LoyaltyProgramPromotion';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  loyaltyProgramId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  points: Scalars['Int']['output'];
  promotionType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LoyaltyProgramRewardTier = {
  __typename?: 'LoyaltyProgramRewardTier';
  amountDiscount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  discountType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  points: Scalars['Int']['output'];
};

/** Autogenerated input type of MarkAsReviewed */
export type MarkAsReviewedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  intentName: Scalars['String']['input'];
  locationId: Scalars['Int']['input'];
};

/** Autogenerated input type of MarkMenuItemCartIssueSeen */
export type MarkMenuItemCartIssueSeenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuItemCartId: Scalars['Int']['input'];
};

/** Autogenerated input type of MarkTaskActionsRead */
export type MarkTaskActionsReadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['Int']['input'];
  taskTypes: Array<Scalars['String']['input']>;
};

export type MarketingMessages = {
  __typename?: 'MarketingMessages';
  contentType: Scalars['String']['output'];
  gmbPostType?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isProcessed: Scalars['Boolean']['output'];
  locationNames?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
  messagePackCommunicationId?: Maybe<Scalars['Int']['output']>;
  processedAt: Scalars['DateTime']['output'];
  socialTypes?: Maybe<Array<Scalars['String']['output']>>;
  weekDateRef: Scalars['String']['output'];
};

export type MarketingOffer = {
  __typename?: 'MarketingOffer';
  announcements?: Maybe<Array<Announcement>>;
  description?: Maybe<Scalars['String']['output']>;
  emailEntryCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  marketingType: Scalars['String']['output'];
  messageCampaignId?: Maybe<Scalars['Int']['output']>;
  orderingAppMessage?: Maybe<Scalars['String']['output']>;
  orderingOffer: OrderingOffer;
  orderingOfferId: Scalars['Int']['output'];
  restaurant: Restaurant;
  smartMessageName?: Maybe<Scalars['String']['output']>;
  status: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type MarketingOfferInput = {
  announcementTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  marketingType: Scalars['String']['input'];
  messageCampaignId?: InputMaybe<Scalars['Int']['input']>;
  orderingOfferId: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MarketingOfferPaginationHandler = {
  __typename?: 'MarketingOfferPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<MarketingOffer>;
};

export type MassAction = {
  __typename?: 'MassAction';
  processedImmediately: Scalars['Boolean']['output'];
};

export type MasterMessageCampaign = {
  __typename?: 'MasterMessageCampaign';
  canIgnoreLimit?: Maybe<Scalars['Boolean']['output']>;
  clickedMessagesCount: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imageUploadedPhoto?: Maybe<UploadedPhoto>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isDefaultEnabled?: Maybe<Scalars['Boolean']['output']>;
  isDefaultIncludeFeaturedContent?: Maybe<Scalars['Boolean']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  messageContent?: Maybe<Scalars['String']['output']>;
  messageSubject?: Maybe<Scalars['String']['output']>;
  messageTeaser?: Maybe<Scalars['String']['output']>;
  messagesCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  openedMessagesCount: Scalars['Int']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  triggerAmountSpent?: Maybe<Scalars['Int']['output']>;
  triggerDelayMinutes?: Maybe<Scalars['Int']['output']>;
  triggerExpirationDays?: Maybe<Scalars['Int']['output']>;
  triggerNumberOfDays?: Maybe<Scalars['Int']['output']>;
  triggerNumberOfOrders?: Maybe<Scalars['Int']['output']>;
  triggerType?: Maybe<Scalars['String']['output']>;
};

export type MasterMessageCampaignInput = {
  canIgnoreLimit?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  isDefaultEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultIncludeFeaturedContent?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageContent?: InputMaybe<Scalars['String']['input']>;
  messageSubject?: InputMaybe<Scalars['String']['input']>;
  messageTeaser?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  triggerAmountSpent?: InputMaybe<Scalars['Int']['input']>;
  triggerDelayMinutes: Scalars['Int']['input'];
  triggerExpirationDays?: InputMaybe<Scalars['Int']['input']>;
  triggerNumberOfDays?: InputMaybe<Scalars['Int']['input']>;
  triggerNumberOfOrders?: InputMaybe<Scalars['Int']['input']>;
  triggerType?: InputMaybe<Scalars['String']['input']>;
};

export type MasterMessageCampaignPaginationHandler = {
  __typename?: 'MasterMessageCampaignPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<MasterMessageCampaign>;
};

/** Medium types for social posts */
export type Medium = UploadedPhoto | UploadedVideo;

export type MemberInvitePaginationHandler = {
  __typename?: 'MemberInvitePaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<RestaurantMemberInvite>;
};

export type MemberPaginationHandler = {
  __typename?: 'MemberPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<RestaurantMember>;
};

export type Menu = Eventable & NavLinkable & {
  __typename?: 'Menu';
  allowReservation?: Maybe<Scalars['Boolean']['output']>;
  availableMenuOrderDates: Array<Scalars['DateTime']['output']>;
  availableMenuOrderTimes: Array<Scalars['Time']['output']>;
  availableProviderMenus: Array<ProviderMenu>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  backgroundEffect?: Maybe<Scalars['String']['output']>;
  backgroundImageUploadedPhoto?: Maybe<UploadedPhoto>;
  backgroundImageUrl?: Maybe<Scalars['String']['output']>;
  cateringLeadTimeMinutes: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customPageDrafts?: Maybe<Array<CustomPageDraft>>;
  customPageSelectedMenus: Array<CustomPageSelectedMenu>;
  customPages: Array<CustomPage>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  dishTags?: Maybe<Array<RestaurantDishTag>>;
  displayName?: Maybe<Scalars['String']['output']>;
  displayPdfType?: Maybe<Scalars['String']['output']>;
  enabledFeaturedSection?: Maybe<MenuFeaturedSection>;
  enabledHighlightSection?: Maybe<MenuHighlightSection>;
  enabledItemsCount?: Maybe<Scalars['Int']['output']>;
  enabledOoSections: Array<MenuSection>;
  enabledSections: Array<MenuSection>;
  enabledSectionsCount?: Maybe<Scalars['Int']['output']>;
  eventableName: Scalars['String']['output'];
  featuredAnnouncement?: Maybe<Announcement>;
  featuredSection?: Maybe<MenuFeaturedSection>;
  highlightSection?: Maybe<MenuHighlightSection>;
  id: Scalars['Int']['output'];
  ignoredIntegrations?: Maybe<Array<Scalars['String']['output']>>;
  isCateringMenu: Scalars['Boolean']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isFromNcrSilver: Scalars['Boolean']['output'];
  isFromSquare: Scalars['Boolean']['output'];
  isMenuHours?: Maybe<Scalars['Boolean']['output']>;
  isMenuHoursDelivery?: Maybe<Scalars['Boolean']['output']>;
  isMenuHoursDineIn?: Maybe<Scalars['Boolean']['output']>;
  isMenuSyncEnabled: Scalars['Boolean']['output'];
  isModifiersPublishEnabled: Scalars['Boolean']['output'];
  isOrderingAppOrderingAvailable: Scalars['Boolean']['output'];
  isOrderingAvailable: Scalars['Boolean']['output'];
  isOrderingDeliveryEnableable: Scalars['Boolean']['output'];
  isOrderingDeliveryEnabled: Scalars['Boolean']['output'];
  isOrderingDineInEnableable?: Maybe<Scalars['Boolean']['output']>;
  isOrderingDineInEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingEnableable: Scalars['Boolean']['output'];
  isOrderingEnabled: Scalars['Boolean']['output'];
  isOrderingMenuHours: Scalars['Boolean']['output'];
  isPosAutoHideItems: Scalars['Boolean']['output'];
  isWoflowQaComplete?: Maybe<Scalars['Boolean']['output']>;
  itemBackgroundColor?: Maybe<Scalars['String']['output']>;
  lastSyncHistory?: Maybe<MenuSyncHistory>;
  location?: Maybe<RestaurantLocation>;
  locationId?: Maybe<Scalars['Int']['output']>;
  masterMenuId?: Maybe<Scalars['Int']['output']>;
  menuColumnCount?: Maybe<Scalars['Int']['output']>;
  menuDeliveryOpeningRanges: Array<MenuDeliveryOpeningRange>;
  menuDineInOpeningRanges: Array<MenuDineInOpeningRange>;
  /** @deprecated Always empty; the server-rendered page @graph carries the Menu node. Remove once no deployed client requests it. */
  menuJsonLd: Scalars['JSON']['output'];
  menuLayout?: Maybe<Scalars['String']['output']>;
  menuOrderingAppDishTags?: Maybe<Array<MenuOrderingAppDishTag>>;
  menuOrderingOpeningRanges: Array<MenuOrderingOpeningRange>;
  menuOrderingUrl?: Maybe<Scalars['String']['output']>;
  menuPageUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Always empty; the server-rendered page @graph carries the Menu node. Remove once no deployed client bundle requests it. */
  menuSchemaMarkup: Scalars['String']['output'];
  menuSyncHistories: Array<MenuSyncHistory>;
  menuType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pdfLinkUrl?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  photoUploadedPhoto?: Maybe<UploadedPhoto>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  policy: MenuPolicy;
  popularMenuItems?: Maybe<Array<MenuItem>>;
  position?: Maybe<Scalars['Int']['output']>;
  preferredMenuRangeCloseTime?: Maybe<Scalars['DateTime']['output']>;
  preferredMenuRangeTime?: Maybe<Scalars['DateTime']['output']>;
  printLayouts: Array<PrintLayout>;
  providerMenuId?: Maybe<Scalars['Int']['output']>;
  providerMenuPosId?: Maybe<Scalars['String']['output']>;
  recentlyUpdated?: Maybe<Scalars['Boolean']['output']>;
  relatedMenus: Array<Menu>;
  restaurant?: Maybe<Restaurant>;
  restaurantEmbeds: Array<RestaurantEmbed>;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  rootDishTags: Array<RootDishTag>;
  sections: Array<MenuSection>;
  selectedPrintLayout?: Maybe<PrintLayout>;
  shortLinkUrl?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  spotonMenuId?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  uiMenu: UiMenuInterface;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  yextSync?: Maybe<MenuYextSync>;
};


export type MenuAvailableMenuOrderDatesArgs = {
  cartType: Scalars['String']['input'];
  fulfillmentType: Scalars['String']['input'];
};


export type MenuAvailableMenuOrderTimesArgs = {
  cartType: Scalars['String']['input'];
  fulfillmentType: Scalars['String']['input'];
  requestedDate: Scalars['DateTime']['input'];
};


export type MenuEnabledSectionsArgs = {
  filterCustomHtmlSections?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MenuIsOrderingAppOrderingAvailableArgs = {
  cartType?: InputMaybe<Scalars['String']['input']>;
  fulfillmentType?: InputMaybe<Scalars['String']['input']>;
};


export type MenuIsOrderingAvailableArgs = {
  cartType?: InputMaybe<Scalars['String']['input']>;
  fulfillmentType?: InputMaybe<Scalars['String']['input']>;
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  requestedDatetime?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MenuIsOrderingMenuHoursArgs = {
  cartType?: InputMaybe<Scalars['String']['input']>;
  fulfillmentType?: InputMaybe<Scalars['String']['input']>;
};


export type MenuMenuOrderingUrlArgs = {
  requestedDatetime?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MenuPreferredMenuRangeCloseTimeArgs = {
  cartType?: InputMaybe<Scalars['String']['input']>;
  fulfillmentType?: InputMaybe<Scalars['String']['input']>;
};


export type MenuPreferredMenuRangeTimeArgs = {
  cartType?: InputMaybe<Scalars['String']['input']>;
  fulfillmentType?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of MenuCopy */
export type MenuCopyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuId: Scalars['Int']['input'];
};

/** Autogenerated input type of MenuCreate */
export type MenuCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuInput: MenuInput;
  restaurantId: Scalars['Int']['input'];
};

export type MenuDeliveryOpeningRange = OrderingRangeable & {
  __typename?: 'MenuDeliveryOpeningRange';
  closeTime?: Maybe<Scalars['Time']['output']>;
  dayFriday?: Maybe<Scalars['Boolean']['output']>;
  dayMonday?: Maybe<Scalars['Boolean']['output']>;
  daySaturday?: Maybe<Scalars['Boolean']['output']>;
  daySunday?: Maybe<Scalars['Boolean']['output']>;
  dayThursday?: Maybe<Scalars['Boolean']['output']>;
  dayTuesday?: Maybe<Scalars['Boolean']['output']>;
  dayWednesday?: Maybe<Scalars['Boolean']['output']>;
  days: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  openAllDay?: Maybe<Scalars['Boolean']['output']>;
  openTime?: Maybe<Scalars['Time']['output']>;
};

export type MenuDeliveryOpeningRangeInput = {
  closeTime?: InputMaybe<Scalars['Time']['input']>;
  dayFriday?: InputMaybe<Scalars['Boolean']['input']>;
  dayMonday?: InputMaybe<Scalars['Boolean']['input']>;
  daySaturday?: InputMaybe<Scalars['Boolean']['input']>;
  daySunday?: InputMaybe<Scalars['Boolean']['input']>;
  dayThursday?: InputMaybe<Scalars['Boolean']['input']>;
  dayTuesday?: InputMaybe<Scalars['Boolean']['input']>;
  dayWednesday?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  openAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  openTime?: InputMaybe<Scalars['Time']['input']>;
};

/** Autogenerated input type of MenuDestroy */
export type MenuDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuId: Scalars['Int']['input'];
};

export type MenuDineInOpeningRange = OrderingRangeable & {
  __typename?: 'MenuDineInOpeningRange';
  closeTime?: Maybe<Scalars['Time']['output']>;
  dayFriday?: Maybe<Scalars['Boolean']['output']>;
  dayMonday?: Maybe<Scalars['Boolean']['output']>;
  daySaturday?: Maybe<Scalars['Boolean']['output']>;
  daySunday?: Maybe<Scalars['Boolean']['output']>;
  dayThursday?: Maybe<Scalars['Boolean']['output']>;
  dayTuesday?: Maybe<Scalars['Boolean']['output']>;
  dayWednesday?: Maybe<Scalars['Boolean']['output']>;
  days: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  openAllDay?: Maybe<Scalars['Boolean']['output']>;
  openTime?: Maybe<Scalars['Time']['output']>;
};

export type MenuDineInOpeningRangeInput = {
  closeTime?: InputMaybe<Scalars['Time']['input']>;
  dayFriday?: InputMaybe<Scalars['Boolean']['input']>;
  dayMonday?: InputMaybe<Scalars['Boolean']['input']>;
  daySaturday?: InputMaybe<Scalars['Boolean']['input']>;
  daySunday?: InputMaybe<Scalars['Boolean']['input']>;
  dayThursday?: InputMaybe<Scalars['Boolean']['input']>;
  dayTuesday?: InputMaybe<Scalars['Boolean']['input']>;
  dayWednesday?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  openAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  openTime?: InputMaybe<Scalars['Time']['input']>;
};

export type MenuFeaturedSection = {
  __typename?: 'MenuFeaturedSection';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabledItems: Array<MenuItem>;
  id: Scalars['Int']['output'];
  isAccented: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  itemGenerationTriggered?: Maybe<Scalars['String']['output']>;
  itemSource: Scalars['String']['output'];
  items: Array<MenuItem>;
  layout?: Maybe<Scalars['String']['output']>;
  menu?: Maybe<Menu>;
  menuId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

export type MenuFeaturedSectionInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isAccented?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  itemSource?: InputMaybe<Scalars['String']['input']>;
  layout?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MenuFeaturedSectionItemPositionInput = {
  dishId: Scalars['Int']['input'];
  featuredPosition: Scalars['Int']['input'];
};

/** Autogenerated input type of MenuForceSyncMaster */
export type MenuForceSyncMasterInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuId: Scalars['Int']['input'];
};

export type MenuHighlightSection = {
  __typename?: 'MenuHighlightSection';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  highlightReviews: Array<HighlightReview>;
  highlightType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isFullWidth: Scalars['Boolean']['output'];
  isHeaderEnabled: Scalars['Boolean']['output'];
  locationId: Scalars['ID']['output'];
  menuId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  restaurantId: Scalars['ID']['output'];
};

export type MenuHighlightSectionInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  isHeaderEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of MenuHighlightSectionUpdate */
export type MenuHighlightSectionUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuHighlightSectionId: Scalars['ID']['input'];
  menuHighlightSectionInput: MenuHighlightSectionInput;
};

/** Autogenerated input type of MenuHighlightSectionUpdatePositions */
export type MenuHighlightSectionUpdatePositionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuHighlightSectionInputs: Array<MenuHighlightSectionInput>;
  menuId: Scalars['Int']['input'];
};

export type MenuImport = {
  __typename?: 'MenuImport';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  menuItemsCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

export type MenuImportPaginationHandler = {
  __typename?: 'MenuImportPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<MenuImport>;
};

export type MenuInput = {
  allowReservation?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundEffect?: InputMaybe<Scalars['String']['input']>;
  backgroundImageUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  cateringLeadTimeMinutes?: InputMaybe<Scalars['Int']['input']>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPdfType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isCateringMenu?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMenuHours?: InputMaybe<Scalars['Boolean']['input']>;
  isMenuHoursDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isMenuHoursDineIn?: InputMaybe<Scalars['Boolean']['input']>;
  isModifiersPublishEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingDeliveryEnableable?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingDeliveryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingDineInEnableable?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingDineInEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingEnableable?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPosAutoHideItems?: InputMaybe<Scalars['Boolean']['input']>;
  itemBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  menuColumnCount?: InputMaybe<Scalars['Int']['input']>;
  menuDeliveryOpeningRanges?: InputMaybe<Array<MenuDeliveryOpeningRangeInput>>;
  menuDineInOpeningRanges?: InputMaybe<Array<MenuDineInOpeningRangeInput>>;
  menuLayout?: InputMaybe<Scalars['String']['input']>;
  menuOrderingOpeningRanges?: InputMaybe<Array<MenuOrderingOpeningRangeInput>>;
  menuType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pdfLinkUrl?: InputMaybe<Scalars['String']['input']>;
  photoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  providerMenuId?: InputMaybe<Scalars['Int']['input']>;
  selectedPrintLayoutId?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuItem = Eventable & {
  __typename?: 'MenuItem';
  adminPhotos: Array<PhotoInterface>;
  allSelectedDishTags: Array<DishTagObject>;
  allergens: Array<AllergenEnum>;
  anyLocationOutOfStock: Scalars['Boolean']['output'];
  approvedReviews: Array<Review>;
  availableProviderItems: Array<ProviderItem>;
  /** Read-only; edit at the dish level. */
  calories?: Maybe<Scalars['Int']['output']>;
  cateringOrderMax?: Maybe<Scalars['Int']['output']>;
  cateringOrderMin?: Maybe<Scalars['Int']['output']>;
  chefRecommended: Scalars['Boolean']['output'];
  containsAlcohol: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency: Scalars['String']['output'];
  customPhotos: Array<CustomPhoto>;
  customTaxRateId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dish?: Maybe<Dish>;
  dishId?: Maybe<Scalars['Int']['output']>;
  dislikedItPopsCount: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  eligibleForUpsell: Scalars['Boolean']['output'];
  enabledModifierGroups: Array<MenuItemModifierGroup>;
  eventableName: Scalars['String']['output'];
  /** @deprecated Old menu extras system is deprecated. Use modifier groups instead. */
  extras: Array<MenuItemExtra>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  featuredPhoto?: Maybe<PhotoInterface>;
  featuredPosition?: Maybe<Scalars['Int']['output']>;
  featuredSection?: Maybe<MenuFeaturedSection>;
  fromOurTeamMemberName?: Maybe<Scalars['String']['output']>;
  fromOurTeamMemberRole?: Maybe<Scalars['String']['output']>;
  fromOurTeamNote?: Maybe<Scalars['String']['output']>;
  generatedCategoryName?: Maybe<Scalars['String']['output']>;
  generatedDescription?: Maybe<Scalars['String']['output']>;
  generatedReviewsSummary?: Maybe<Scalars['String']['output']>;
  hasBlockingMenuSyncWarning?: Maybe<Scalars['Boolean']['output']>;
  hasMenuSyncWarning?: Maybe<Scalars['Boolean']['output']>;
  hasModifiers: Scalars['Boolean']['output'];
  htmlContent?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  idAsSlug: Scalars['String']['output'];
  ignoredIntegrations?: Maybe<Array<Scalars['String']['output']>>;
  isBestSeller: Scalars['Boolean']['output'];
  isCreatedByMenuSync?: Maybe<Scalars['Boolean']['output']>;
  isDisabled: Scalars['Boolean']['output'];
  isDoordashDelivery?: Maybe<Scalars['Boolean']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isFeatured: Scalars['Boolean']['output'];
  isMenuSyncEnabled?: Maybe<Scalars['Boolean']['output']>;
  isMenuSyncFromProviderBlocked: Scalars['Boolean']['output'];
  isOrderingEnabled?: Maybe<Scalars['Boolean']['output']>;
  isPoppable?: Maybe<Scalars['Boolean']['output']>;
  isPopular: Scalars['Boolean']['output'];
  isProviderSyncInProgress: Scalars['Boolean']['output'];
  isTaxable?: Maybe<Scalars['Boolean']['output']>;
  isToastProvider?: Maybe<Scalars['Boolean']['output']>;
  lastVersion?: Maybe<MenuItemVersion>;
  likedItPopsCount: Scalars['Int']['output'];
  location?: Maybe<RestaurantLocation>;
  locationId?: Maybe<Scalars['Int']['output']>;
  locationInventory?: Maybe<DishInventoryLocation>;
  lovedItPopsCount: Scalars['Int']['output'];
  masterItem?: Maybe<MenuItem>;
  masterItemId?: Maybe<Scalars['Int']['output']>;
  menu: Menu;
  menuName: Scalars['String']['output'];
  menuSyncWarnings: Array<ProviderWarning>;
  modifierGroups: Array<MenuItemModifierGroup>;
  name: Scalars['String']['output'];
  nextItem?: Maybe<MenuItem>;
  orderingEnabledIntegrations?: Maybe<Array<Scalars['String']['output']>>;
  orderingEventItemLimit?: Maybe<OrderingEventItemLimit>;
  orderingEventMaxAvailable?: Maybe<Scalars['Int']['output']>;
  outOfStock?: Maybe<Scalars['Boolean']['output']>;
  outOfStockUntil?: Maybe<Scalars['DateTime']['output']>;
  paginatedReviews: ReviewPaginationHandler;
  photos: Array<PhotoInterface>;
  photosCount?: Maybe<Scalars['Int']['output']>;
  pops: Array<Pop>;
  popsCount: Scalars['Int']['output'];
  posPhotos: Array<MenuItemPosPhoto>;
  position: Scalars['Int']['output'];
  previousItem?: Maybe<MenuItem>;
  price?: Maybe<Scalars['Decimal']['output']>;
  /** Custom text displayed with `priceType.custom_price_type`, e.x. "Market Price" */
  priceCustomText?: Maybe<Scalars['String']['output']>;
  /** Specifies the pricing strategy: `amount_price_type` displays the `price` decimal field, `custom_price_type` displays the string `priceCustomText` field, or `sizes_price_type` displays any associated `sizes` */
  priceType?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['Int']['output']>;
  providerItem?: Maybe<ProviderItem>;
  providerItemId?: Maybe<Scalars['Int']['output']>;
  providerItemPosId?: Maybe<Scalars['String']['output']>;
  providerType?: Maybe<Scalars['String']['output']>;
  providerVariationId?: Maybe<Scalars['Int']['output']>;
  recentUserAvatars: Array<UserAvatar>;
  restaurant: Restaurant;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  reviews: Array<Review>;
  reviewsCount: Scalars['Int']['output'];
  rootDishCategorySlug?: Maybe<Scalars['String']['output']>;
  section?: Maybe<MenuSection>;
  shortLinkUrl?: Maybe<Scalars['String']['output']>;
  showDisclaimer?: Maybe<Scalars['Boolean']['output']>;
  showFeaturedPhoto?: Maybe<Scalars['Boolean']['output']>;
  /** Multiple selections with varying prices displayed with `priceType.sizes_price_type` */
  sizes: Array<MenuItemSize>;
  slug: Scalars['String']['output'];
  subsection?: Maybe<MenuSubsection>;
  suggestedDishPosition?: Maybe<Scalars['Int']['output']>;
  temporalPrice?: Maybe<Scalars['Decimal']['output']>;
  temporalPrices?: Maybe<Array<MenuItemTemporalPrice>>;
  uiItem?: Maybe<UiMenuItemInterface>;
  updateInProgress?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  visitsCount?: Maybe<Scalars['Int']['output']>;
  wannaTryPopsCount: Scalars['Int']['output'];
};


export type MenuItemApprovedReviewsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuItemLocationInventoryArgs = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuItemOrderingEventItemLimitArgs = {
  orderingEventId: Scalars['Int']['input'];
};


export type MenuItemOrderingEventMaxAvailableArgs = {
  orderingEventId: Scalars['Int']['input'];
};


export type MenuItemPaginatedReviewsArgs = {
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};

export type MenuItemCart = {
  __typename?: 'MenuItemCart';
  acceptedStatusAt?: Maybe<Scalars['DateTime']['output']>;
  addUtensils?: Maybe<Scalars['Boolean']['output']>;
  adminOrderPath: Scalars['String']['output'];
  applicableCustomFees: Array<ApplicableCustomFees>;
  appliedGiftCard?: Maybe<UiMenuItemCartAppliedGiftCardInterface>;
  appliedReward?: Maybe<MenuItemCartAppliedRewardsType>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  billedCart?: Maybe<OrderingBillingInvoiceBilledCart>;
  canBalanceBeFullyPaidByThirdPartyGiftCard: Scalars['Boolean']['output'];
  canMarkOutOfStock: Scalars['Boolean']['output'];
  canPriceAdjust: Scalars['Boolean']['output'];
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  canceledByUserEmail?: Maybe<Scalars['String']['output']>;
  capturedAmount?: Maybe<Scalars['Decimal']['output']>;
  capturedAt?: Maybe<Scalars['DateTime']['output']>;
  cartBucket: Scalars['String']['output'];
  cartSummary?: Maybe<Scalars['String']['output']>;
  cartType?: Maybe<Scalars['String']['output']>;
  cloverApiKey?: Maybe<Scalars['String']['output']>;
  cloverTipAmount?: Maybe<Scalars['Decimal']['output']>;
  containsAlcohol?: Maybe<Scalars['Boolean']['output']>;
  currency: Scalars['String']['output'];
  customTaxRateAmounts: Array<CustomTaxRateAmount>;
  deliveryAddressNumber?: Maybe<Scalars['String']['output']>;
  deliveryAddressWithoutNumber?: Maybe<Scalars['String']['output']>;
  deliveryCity?: Maybe<Scalars['String']['output']>;
  deliveryCountry?: Maybe<Scalars['String']['output']>;
  deliveryDirectionsUrl?: Maybe<Scalars['String']['output']>;
  deliveryDistance?: Maybe<Scalars['Decimal']['output']>;
  deliveryDriver?: Maybe<MenuItemCartDeliveryDriver>;
  deliveryFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  deliveryFullAddress?: Maybe<Scalars['String']['output']>;
  deliveryIssueSeen?: Maybe<Scalars['Boolean']['output']>;
  deliveryLat?: Maybe<Scalars['Decimal']['output']>;
  deliveryLng?: Maybe<Scalars['Decimal']['output']>;
  deliveryMessage?: Maybe<Scalars['String']['output']>;
  deliveryPostalCode?: Maybe<Scalars['String']['output']>;
  deliveryState?: Maybe<Scalars['String']['output']>;
  deliveryStreetAddress?: Maybe<Scalars['String']['output']>;
  deliveryType?: Maybe<Scalars['String']['output']>;
  dineInBucket: Scalars['String']['output'];
  dineInTableLabel: Scalars['String']['output'];
  dineInTableNumber?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Decimal']['output']>;
  doorDashDelivery?: Maybe<DoorDashDelivery>;
  doorDashDeliveryFee: Scalars['Int']['output'];
  doordashNameMaxLength?: Maybe<Scalars['Int']['output']>;
  dropoffType?: Maybe<Scalars['String']['output']>;
  dueAt?: Maybe<Scalars['DateTime']['output']>;
  dueInFuture: Scalars['Boolean']['output'];
  dueMinutes?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enableEmailNotifications?: Maybe<Scalars['Boolean']['output']>;
  enableTextMessageNotifications?: Maybe<Scalars['Boolean']['output']>;
  externalIntegrationType?: Maybe<Scalars['String']['output']>;
  fulfillmentType: Scalars['String']['output'];
  giftCardDiscountAmount?: Maybe<Scalars['Decimal']['output']>;
  giftCardRefundAmount: Scalars['Decimal']['output'];
  giftCardRefundedAt?: Maybe<Scalars['DateTime']['output']>;
  hasAppliedGiftCard: Scalars['Boolean']['output'];
  hasDeliveryIssue?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Renamed for clarity. Use hasAppliedGiftCard instead. */
  hasGiftCard: Scalars['Boolean']['output'];
  hasPayment?: Maybe<Scalars['Boolean']['output']>;
  hasTextMessageReplies?: Maybe<Scalars['Boolean']['output']>;
  heartlandTipAmount?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['Int']['output'];
  incomingTextMessages?: Maybe<Array<TwilioIncomingMessage>>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  isAutoAccepted: Scalars['Boolean']['output'];
  isCaptured?: Maybe<Scalars['Boolean']['output']>;
  isCateringDoordashLargeOrderFulfillment: Scalars['Boolean']['output'];
  isDoordashDelivery: Scalars['Boolean']['output'];
  isFutureOrder: Scalars['Boolean']['output'];
  isGiftCardRefunded: Scalars['Boolean']['output'];
  isLastSubcartSubmitted?: Maybe<Scalars['Boolean']['output']>;
  isPosFeeAmountOverride: Scalars['Boolean']['output'];
  isPosOfferFailed?: Maybe<Scalars['Boolean']['output']>;
  isPosOrderConfirmed?: Maybe<Scalars['Boolean']['output']>;
  isPosOrderFailed?: Maybe<Scalars['Boolean']['output']>;
  isPosOrderValidated?: Maybe<Scalars['Boolean']['output']>;
  isPosSubmitConfirmationRequired?: Maybe<Scalars['Boolean']['output']>;
  isPosValidationConfirmationRequired?: Maybe<Scalars['Boolean']['output']>;
  isScheduled?: Maybe<Scalars['Boolean']['output']>;
  isSubmitted?: Maybe<Scalars['Boolean']['output']>;
  isTabClosedConsumer?: Maybe<Scalars['Boolean']['output']>;
  isTabOpened?: Maybe<Scalars['Boolean']['output']>;
  isTabOrder?: Maybe<Scalars['Boolean']['output']>;
  isWaitingCurbside?: Maybe<Scalars['Boolean']['output']>;
  kitchenTicketPdfUrl?: Maybe<Scalars['String']['output']>;
  kitchenTicketPngUrl?: Maybe<Scalars['String']['output']>;
  lastSubcartSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  location?: Maybe<RestaurantLocation>;
  loyaltyDiscountAmount?: Maybe<Scalars['Decimal']['output']>;
  loyaltyPointsAccumulated?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  messages: Array<MenuItemCartMessage>;
  name?: Maybe<Scalars['String']['output']>;
  ncrSilverTipAmount?: Maybe<Scalars['Decimal']['output']>;
  netOriginalTotal?: Maybe<Scalars['Decimal']['output']>;
  onlineBagFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  onlinePayment: Scalars['Boolean']['output'];
  onlineTaxAmount?: Maybe<Scalars['Decimal']['output']>;
  onlineTipAmount?: Maybe<Scalars['Decimal']['output']>;
  orderTypeTipsEnabled?: Maybe<Scalars['Boolean']['output']>;
  orderingEvent?: Maybe<OrderingEvent>;
  ordernerdDspType?: Maybe<Scalars['String']['output']>;
  ordernerdOrderExternalLabel?: Maybe<Scalars['String']['output']>;
  ordernerdOrderId?: Maybe<Scalars['Int']['output']>;
  originalBagFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  originalCustomFees: Array<MenuItemCartOriginalCustomFee>;
  originalDeliveryFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  originalDiscountAmount?: Maybe<Scalars['Decimal']['output']>;
  originalFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  originalGiftCardDiscountAmount?: Maybe<Scalars['Decimal']['output']>;
  originalPlatformFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  originalSubtotal?: Maybe<Scalars['Decimal']['output']>;
  originalTaxAmount?: Maybe<Scalars['Decimal']['output']>;
  originalTaxAmounts: Array<MenuItemCartOriginalTaxAmount>;
  originalTipAmount?: Maybe<Scalars['Decimal']['output']>;
  originalTipAmountDelivery?: Maybe<Scalars['Decimal']['output']>;
  originalTipAmountRestaurant?: Maybe<Scalars['Decimal']['output']>;
  originalTotal?: Maybe<Scalars['Decimal']['output']>;
  pastDue: Scalars['Boolean']['output'];
  paymentAmount?: Maybe<Scalars['Decimal']['output']>;
  paymentCapturedAt?: Maybe<Scalars['DateTime']['output']>;
  paymentDescription?: Maybe<Scalars['String']['output']>;
  paymentDetailsUrl?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentMethodDisplay?: Maybe<Scalars['String']['output']>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  pfoPrintedAt?: Maybe<Scalars['DateTime']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phonePinCode?: Maybe<Scalars['String']['output']>;
  pickupType?: Maybe<Scalars['String']['output']>;
  pickupVehicleColor?: Maybe<Scalars['String']['output']>;
  pickupVehicleMakeModel?: Maybe<Scalars['String']['output']>;
  platformFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  pops?: Maybe<Array<Pop>>;
  posFeeAmountOverride?: Maybe<Scalars['Decimal']['output']>;
  posOrderStatus?: Maybe<Scalars['String']['output']>;
  preferredMenuRangeTime?: Maybe<Scalars['DateTime']['output']>;
  preferredMenuSlug?: Maybe<Scalars['String']['output']>;
  printTicketPdfUrl?: Maybe<Scalars['String']['output']>;
  printTicketPngUrl?: Maybe<Scalars['String']['output']>;
  profileEventTracking?: Maybe<Array<Scalars['String']['output']>>;
  rawDeliveryAddress?: Maybe<Scalars['String']['output']>;
  readyForCapture?: Maybe<Scalars['Boolean']['output']>;
  readyForRefund?: Maybe<Scalars['Boolean']['output']>;
  refundAmount?: Maybe<Scalars['Decimal']['output']>;
  refunds?: Maybe<Array<MenuItemCartRefundable>>;
  reportAt?: Maybe<Scalars['DateTime']['output']>;
  restaurantDueAt?: Maybe<Scalars['DateTime']['output']>;
  revenueSharedFeeAmount: Scalars['Decimal']['output'];
  reviews?: Maybe<Array<Review>>;
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  selectedEcard?: Maybe<MenuItemCartSelectedEcard>;
  selectedGiftCard?: Maybe<MenuItemCartSelectedGiftCard>;
  selectedMenuItems: Array<MenuItemCartSelectedMenuItem>;
  selectedMenuItemsPersistStatus?: Maybe<SelectedMenuItemsPersistStatusEnum>;
  selectedMenuItemsTotalCount: Scalars['Int']['output'];
  selectedOrderingOfferCode?: Maybe<MenuItemCartSelectedOrderingOfferCode>;
  selectedSquareGiftCard?: Maybe<MenuItemCartSelectedSquareGiftCard>;
  session?: Maybe<Session>;
  showNotificationSettings: Scalars['Boolean']['output'];
  showUtensilsCheck: Scalars['Boolean']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  squareTipAmount?: Maybe<Scalars['Decimal']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusGroup?: Maybe<Scalars['String']['output']>;
  statusSortValue: Scalars['String']['output'];
  stripeCapturedAmount?: Maybe<Scalars['Decimal']['output']>;
  stripeConnectPayment?: Maybe<StripeConnectPayment>;
  stripeFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  stripeTaxAmount?: Maybe<Scalars['Decimal']['output']>;
  stripeTipAmount?: Maybe<Scalars['Decimal']['output']>;
  subcarts: Array<MenuItemCartSubcart>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  submittedMenuItemCartsCount?: Maybe<Scalars['Decimal']['output']>;
  subtotal?: Maybe<Scalars['Decimal']['output']>;
  subtotalForOffer?: Maybe<Scalars['Decimal']['output']>;
  subtotalMax?: Maybe<Scalars['Decimal']['output']>;
  subtotalMin?: Maybe<Scalars['Decimal']['output']>;
  tabInactiveAt?: Maybe<Scalars['DateTime']['output']>;
  tabName?: Maybe<Scalars['String']['output']>;
  textMessages?: Maybe<Array<TwilioMessage>>;
  thirdPartyDeliveryDataDeletedAt?: Maybe<Scalars['DateTime']['output']>;
  toastTipAmount?: Maybe<Scalars['Decimal']['output']>;
  uberDirectDelivery?: Maybe<UberDirectDelivery>;
  uiMenuItemCart: UiMenuItemCartInterface;
  uncoveredDeliveryFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  viewedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MenuItemCartAppliedRewardsType = {
  __typename?: 'MenuItemCartAppliedRewardsType';
  appliedRewardPosId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  rewardTierId?: Maybe<Scalars['Int']['output']>;
};

export type MenuItemCartContainsAlcohol = {
  __typename?: 'MenuItemCartContainsAlcohol';
  containsAlcohol: Scalars['Boolean']['output'];
  locationId: Scalars['Int']['output'];
};

export type MenuItemCartDeliveryDriver = {
  __typename?: 'MenuItemCartDeliveryDriver';
  estimatedPickupTime?: Maybe<Scalars['DateTime']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
};

export type MenuItemCartHistoryPaginationHandler = {
  __typename?: 'MenuItemCartHistoryPaginationHandler';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  offset: Scalars['Int']['output'];
  records: Array<Versionable>;
};

export type MenuItemCartInput = {
  addUtensils?: InputMaybe<Scalars['Boolean']['input']>;
  arrivalTextReceived?: InputMaybe<Scalars['Boolean']['input']>;
  cloverTipAmount?: InputMaybe<Scalars['Decimal']['input']>;
  deliveryAddressNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryCity?: InputMaybe<Scalars['String']['input']>;
  deliveryDistance?: InputMaybe<Scalars['Float']['input']>;
  deliveryFormattedAddress?: InputMaybe<Scalars['String']['input']>;
  deliveryMessage?: InputMaybe<Scalars['String']['input']>;
  deliveryPostalCode?: InputMaybe<Scalars['String']['input']>;
  deliveryState?: InputMaybe<Scalars['String']['input']>;
  deliveryStreetAddress?: InputMaybe<Scalars['String']['input']>;
  dineInTableNumber?: InputMaybe<Scalars['String']['input']>;
  dropoffType?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enableEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  enableTextMessageNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  fulfillmentType?: InputMaybe<Scalars['String']['input']>;
  heartlandTipAmount?: InputMaybe<Scalars['Decimal']['input']>;
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  isTabClosedConsumer?: InputMaybe<Scalars['Boolean']['input']>;
  isTabOpened?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ncrSilverTipAmount?: InputMaybe<Scalars['Decimal']['input']>;
  onlineTipAmount?: InputMaybe<Scalars['Decimal']['input']>;
  orderingEventId?: InputMaybe<Scalars['Int']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  pfoPrintedAt?: InputMaybe<Scalars['DateTime']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pickupType?: InputMaybe<Scalars['String']['input']>;
  pickupVehicleColor?: InputMaybe<Scalars['String']['input']>;
  pickupVehicleMakeModel?: InputMaybe<Scalars['String']['input']>;
  rawDeliveryAddress?: InputMaybe<Scalars['String']['input']>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  selectedMenuItems?: InputMaybe<Array<MenuItemCartSelectedMenuItemInput>>;
  squareTipAmount?: InputMaybe<Scalars['Decimal']['input']>;
  stripeTipAmount?: InputMaybe<Scalars['Decimal']['input']>;
  toastTipAmount?: InputMaybe<Scalars['Decimal']['input']>;
};

export type MenuItemCartMessage = {
  __typename?: 'MenuItemCartMessage';
  id: Scalars['Int']['output'];
  messageHtmlUrl?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
};

export type MenuItemCartOriginalCustomFee = {
  __typename?: 'MenuItemCartOriginalCustomFee';
  id: Scalars['Int']['output'];
  originalFeeFinalAmount: Scalars['Decimal']['output'];
  originalFeeName: Scalars['String']['output'];
  revenueShared: Scalars['Boolean']['output'];
};

export type MenuItemCartOriginalTaxAmount = {
  __typename?: 'MenuItemCartOriginalTaxAmount';
  id: Scalars['Int']['output'];
  originalTaxAmount?: Maybe<Scalars['Decimal']['output']>;
  originalTaxName: Scalars['String']['output'];
};

export type MenuItemCartPaginationHandler = {
  __typename?: 'MenuItemCartPaginationHandler';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  offset: Scalars['Int']['output'];
  records: Array<MenuItemCart>;
};

/** Online payment refunds */
export type MenuItemCartRefundable = {
  amount: Scalars['Decimal']['output'];
  id: Scalars['Int']['output'];
  refundedAt: Scalars['DateTime']['output'];
  refundedByUserEmail?: Maybe<Scalars['String']['output']>;
};

export type MenuItemCartReport = {
  __typename?: 'MenuItemCartReport';
  capturedAmountTotal: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  customTaxRates: Array<MenuItemCartReportCustomTaxRate>;
  discountAmountTotal?: Maybe<Scalars['Decimal']['output']>;
  doorDashDeliveryFee: Scalars['Decimal']['output'];
  feeAmountTotal: Scalars['Decimal']['output'];
  giftCardDiscountAmountTotal?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['String']['output'];
  loyaltyDiscountAmountTotal?: Maybe<Scalars['Decimal']['output']>;
  menuItemCarts: Array<MenuItemCart>;
  menuItemCartsCount: Scalars['Int']['output'];
  originalDeliveryFeeTotal?: Maybe<Scalars['Decimal']['output']>;
  originalPlatformFeeTotal?: Maybe<Scalars['Decimal']['output']>;
  paymentCapturedAt?: Maybe<Scalars['Decimal']['output']>;
  refundAmountTotal: Scalars['Decimal']['output'];
  reportAt: Scalars['DateTime']['output'];
  revenueSharedFeeTotal: Scalars['Decimal']['output'];
  subtotalTotal: Scalars['Decimal']['output'];
  taxAmountTotal: Scalars['Decimal']['output'];
  tipAmountTotal: Scalars['Decimal']['output'];
  tipAmountTotalDelivery: Scalars['Decimal']['output'];
  tipAmountTotalRestaurant: Scalars['Decimal']['output'];
  totalTotal: Scalars['Decimal']['output'];
};

export type MenuItemCartReportCustomTaxRate = {
  __typename?: 'MenuItemCartReportCustomTaxRate';
  amountTotal: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
};

export type MenuItemCartSelectedEcard = {
  __typename?: 'MenuItemCartSelectedEcard';
  amount: Scalars['Decimal']['output'];
  endingBalance?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isCaptured?: Maybe<Scalars['Boolean']['output']>;
  isRefunded?: Maybe<Scalars['Boolean']['output']>;
  lastFour: Scalars['String']['output'];
  menuItemCart?: Maybe<MenuItemCart>;
  menuItemCartId: Scalars['Int']['output'];
  originalAmount: Scalars['Decimal']['output'];
  refundReferenceNumber?: Maybe<Scalars['String']['output']>;
  refundedAt?: Maybe<Scalars['DateTime']['output']>;
  refunds: Array<MenuItemCartSelectedEcardRefund>;
  saleReferenceNumber?: Maybe<Scalars['String']['output']>;
};

export type MenuItemCartSelectedEcardRefund = {
  __typename?: 'MenuItemCartSelectedEcardRefund';
  amount: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  refundedByUserEmail?: Maybe<Scalars['String']['output']>;
};

export type MenuItemCartSelectedGiftCard = {
  __typename?: 'MenuItemCartSelectedGiftCard';
  amount?: Maybe<Scalars['Decimal']['output']>;
  giftCard?: Maybe<GiftCard>;
  giftCardId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isRefunded?: Maybe<Scalars['Boolean']['output']>;
  menuItemCart?: Maybe<MenuItemCart>;
  menuItemCartId: Scalars['Int']['output'];
  refundedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MenuItemCartSelectedMenuItem = {
  __typename?: 'MenuItemCartSelectedMenuItem';
  adjustedMenuItemPrice?: Maybe<Scalars['Decimal']['output']>;
  discountAmount?: Maybe<Scalars['Decimal']['output']>;
  excludedModifiers: Array<MenuItemCartSelectedMenuItemExcludedModifier>;
  id: Scalars['Int']['output'];
  invalidFlatSelectedModifiers: Array<MenuItemCartSelectedMenuItemSelectedModifierGroupSelectedModifier>;
  isAdjusted: Scalars['Boolean']['output'];
  isValid?: Maybe<Scalars['Boolean']['output']>;
  isVoid?: Maybe<Scalars['Boolean']['output']>;
  lastOrderedAt?: Maybe<Scalars['DateTime']['output']>;
  menuItem?: Maybe<MenuItem>;
  menuItemId?: Maybe<Scalars['Int']['output']>;
  menuItemName?: Maybe<Scalars['String']['output']>;
  menuItemPrice?: Maybe<Scalars['Decimal']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  modifiersSummary?: Maybe<Scalars['String']['output']>;
  offerId?: Maybe<Scalars['Int']['output']>;
  posMenuItemPriceOverride?: Maybe<Scalars['Decimal']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  printModifiersSummary?: Maybe<Scalars['String']['output']>;
  profileEventTracking?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  quotedMenuItemPrice?: Maybe<Scalars['Decimal']['output']>;
  quotedPrice?: Maybe<Scalars['Decimal']['output']>;
  /** @deprecated Old menu extras system is deprecated. Use selected_modifiers instead. */
  selectedExtras: Array<MenuItemCartSelectedMenuItemSelectedExtra>;
  selectedMenuItemSizeId?: Maybe<Scalars['Int']['output']>;
  selectedMenuItemSizeName?: Maybe<Scalars['String']['output']>;
  selectedModifierGroups: Array<MenuItemCartSelectedMenuItemSelectedModifierGroup>;
  selectedModifiers: Array<MenuItemCartSelectedMenuItemSelectedModifierGroupSelectedModifier>;
  subtotal?: Maybe<Scalars['Decimal']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use modifiers_summary instead which separates the message, a.k.a. the special request, from this field */
  summaryExtended?: Maybe<Scalars['String']['output']>;
  uiSelectedMenuItem: UiSelectedMenuItemInterface;
};

export type MenuItemCartSelectedMenuItemExcludedModifier = {
  __typename?: 'MenuItemCartSelectedMenuItemExcludedModifier';
  id: Scalars['Int']['output'];
  menuItemModifierGroupId: Scalars['Int']['output'];
  menuItemModifierId: Scalars['Int']['output'];
  modifierGroupName: Scalars['String']['output'];
  modifierName: Scalars['String']['output'];
};

export type MenuItemCartSelectedMenuItemExcludedModifierInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  menuItemModifierGroupId: Scalars['Int']['input'];
  menuItemModifierId: Scalars['Int']['input'];
  modifierGroupName: Scalars['String']['input'];
  modifierName: Scalars['String']['input'];
};

export type MenuItemCartSelectedMenuItemInput = {
  crossSoldFromMenuItemId?: InputMaybe<Scalars['Int']['input']>;
  excludedModifiers?: InputMaybe<Array<MenuItemCartSelectedMenuItemExcludedModifierInput>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isVoid?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  profileEventTracking?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Old menu extras system is deprecated. Use selected_modifiers instead. */
  selectedExtras?: InputMaybe<Array<MenuItemCartSelectedMenuItemSelectedExtraInput>>;
  selectedMenuItemSizeId?: InputMaybe<Scalars['Int']['input']>;
  selectedModifierGroups?: InputMaybe<Array<MenuItemCartSelectedMenuItemSelectedModifierGroupInput>>;
};

export type MenuItemCartSelectedMenuItemSelectedExtra = {
  __typename?: 'MenuItemCartSelectedMenuItemSelectedExtra';
  id: Scalars['Int']['output'];
  menuItemExtra?: Maybe<MenuItemExtra>;
  menuItemExtraId?: Maybe<Scalars['Int']['output']>;
  menuItemExtraName?: Maybe<Scalars['String']['output']>;
  selectedMenuItemId?: Maybe<Scalars['Int']['output']>;
  subtotal?: Maybe<Scalars['Decimal']['output']>;
};

export type MenuItemCartSelectedMenuItemSelectedExtraInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  menuItemExtraId: Scalars['Int']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuItemCartSelectedMenuItemSelectedModifierGroup = {
  __typename?: 'MenuItemCartSelectedMenuItemSelectedModifierGroup';
  freeSelectionsCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  menuItemModifierGroup?: Maybe<MenuItemModifierGroup>;
  menuItemModifierGroupId?: Maybe<Scalars['Int']['output']>;
  menuItemModifierGroupName?: Maybe<Scalars['String']['output']>;
  originalName?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  selectedModifierIdsFullyCoveredByFreeSelection: Array<Scalars['Int']['output']>;
  selectedModifiers: Array<MenuItemCartSelectedMenuItemSelectedModifierGroupSelectedModifier>;
};

export type MenuItemCartSelectedMenuItemSelectedModifierGroupInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  menuItemModifierGroupId: Scalars['Int']['input'];
  selectedModifiers: Array<MenuItemCartSelectedMenuItemSelectedModifierGroupSelectedModifierInput>;
};

export type MenuItemCartSelectedMenuItemSelectedModifierGroupSelectedModifier = {
  __typename?: 'MenuItemCartSelectedMenuItemSelectedModifierGroupSelectedModifier';
  id: Scalars['Int']['output'];
  includedQuantity: Scalars['Int']['output'];
  isValid: Scalars['Boolean']['output'];
  menuItemModifier?: Maybe<MenuItemModifierGroupModifier>;
  menuItemModifierId?: Maybe<Scalars['Int']['output']>;
  menuItemSizeModifierPriceId?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  modifierName?: Maybe<Scalars['String']['output']>;
  modifierPrice?: Maybe<Scalars['Decimal']['output']>;
  parentModifierGroupId?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
  selectedModifierGroupId?: Maybe<Scalars['Int']['output']>;
  selectedModifierGroupName?: Maybe<Scalars['String']['output']>;
  selectedModifierGroups: Array<MenuItemCartSelectedMenuItemSelectedModifierGroup>;
};

export type MenuItemCartSelectedMenuItemSelectedModifierGroupSelectedModifierInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  menuItemModifierId: Scalars['Int']['input'];
  menuItemSizeModifierPriceId?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  selectedModifierGroups?: InputMaybe<Array<MenuItemCartSelectedMenuItemSelectedModifierGroupInput>>;
};

export type MenuItemCartSelectedOrderingOfferCode = {
  __typename?: 'MenuItemCartSelectedOrderingOfferCode';
  amount?: Maybe<Scalars['Decimal']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  locationName?: Maybe<Scalars['String']['output']>;
  menuItemCart?: Maybe<MenuItemCart>;
  menuItemCartId: Scalars['Int']['output'];
  minimumOrderAmount?: Maybe<Scalars['Decimal']['output']>;
  offerName?: Maybe<Scalars['String']['output']>;
  offerType?: Maybe<Scalars['String']['output']>;
  orderingOfferCode?: Maybe<OrderingOfferCode>;
  orderingOfferCodeId?: Maybe<Scalars['Int']['output']>;
  originalAmount?: Maybe<Scalars['Decimal']['output']>;
  originalMinimumOrderAmount?: Maybe<Scalars['Decimal']['output']>;
  originalOfferCode?: Maybe<Scalars['String']['output']>;
  originalOfferName?: Maybe<Scalars['String']['output']>;
};

export type MenuItemCartSelectedSquareGiftCard = {
  __typename?: 'MenuItemCartSelectedSquareGiftCard';
  amount: Scalars['Decimal']['output'];
  endingBalance?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['Int']['output'];
  isCaptured?: Maybe<Scalars['Boolean']['output']>;
  lastFour: Scalars['String']['output'];
  menuItemCart?: Maybe<MenuItemCart>;
  menuItemCartId: Scalars['Int']['output'];
  originalAmount: Scalars['Decimal']['output'];
};

export type MenuItemCartSubcart = {
  __typename?: 'MenuItemCartSubcart';
  acceptedStatusAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dueAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isSubmitted?: Maybe<Scalars['Boolean']['output']>;
  kitchenTicketPdfUrl?: Maybe<Scalars['String']['output']>;
  kitchenTicketPngUrl?: Maybe<Scalars['String']['output']>;
  menuItemCart: MenuItemCart;
  message?: Maybe<Scalars['String']['output']>;
  originalSubtotal?: Maybe<Scalars['Decimal']['output']>;
  preparingStatusAt?: Maybe<Scalars['DateTime']['output']>;
  printTicketPdfUrl?: Maybe<Scalars['String']['output']>;
  printTicketPngUrl?: Maybe<Scalars['String']['output']>;
  printToken?: Maybe<Scalars['String']['output']>;
  readyStatusAt?: Maybe<Scalars['DateTime']['output']>;
  selectedMenuItems: Array<MenuItemCartSelectedMenuItem>;
  slug?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  subtotal?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MenuItemCartTopDish = {
  __typename?: 'MenuItemCartTopDish';
  dishId: Scalars['Int']['output'];
  dishName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  menuItemId?: Maybe<Scalars['Int']['output']>;
  originalMenuItemName: Scalars['String']['output'];
  originalMenuItemPriceTotal: Scalars['Decimal']['output'];
  quantityTotal: Scalars['Int']['output'];
};

export type MenuItemCartVersion = Versionable & {
  __typename?: 'MenuItemCartVersion';
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  locationMenuName?: Maybe<Scalars['String']['output']>;
  objectChanges: Array<VersionDiff>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of MenuItemContainsAlcohol */
export type MenuItemContainsAlcoholInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  containsAlcohol: Scalars['Boolean']['input'];
  menuItemId: Scalars['Int']['input'];
};

/** Autogenerated input type of MenuItemCreate */
export type MenuItemCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dishId?: InputMaybe<Scalars['Int']['input']>;
  menuItemInput: MenuItemInput;
  menuSubsectionId: Scalars['Int']['input'];
};

/** Autogenerated input type of MenuItemDestroy */
export type MenuItemDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuItemId: Scalars['Int']['input'];
};

export type MenuItemExtra = {
  __typename?: 'MenuItemExtra';
  id: Scalars['Int']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  outOfStock?: Maybe<Scalars['Boolean']['output']>;
  outOfStockUntil?: Maybe<Scalars['DateTime']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
};

export type MenuItemExtraVersion = Versionable & {
  __typename?: 'MenuItemExtraVersion';
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  locationMenuName?: Maybe<Scalars['String']['output']>;
  objectChanges: Array<VersionDiff>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

export type MenuItemInput = {
  allSelectedDishTags?: InputMaybe<Array<Scalars['String']['input']>>;
  allergens?: InputMaybe<Array<AllergenEnum>>;
  calories?: InputMaybe<Scalars['Int']['input']>;
  chefRecommended?: InputMaybe<Scalars['Boolean']['input']>;
  containsAlcohol?: InputMaybe<Scalars['Boolean']['input']>;
  customTaxRateId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Old menu extras system is deprecated. Use modifier groups instead. */
  extras?: InputMaybe<Array<DishExtraInput>>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  htmlContent?: InputMaybe<Scalars['String']['input']>;
  ignoredIntegrations?: InputMaybe<Array<Scalars['String']['input']>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPoppable?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  modifierGroups?: InputMaybe<Array<MenuItemModifierGroupInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderingEnabledIntegrations?: InputMaybe<Array<Scalars['String']['input']>>;
  outOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  outOfStockUntil?: InputMaybe<Scalars['Boolean']['input']>;
  photoInputs?: InputMaybe<Array<PhotoInput>>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  priceCustomText?: InputMaybe<Scalars['String']['input']>;
  priceType?: InputMaybe<Scalars['String']['input']>;
  showFeaturedPhoto?: InputMaybe<Scalars['Boolean']['input']>;
  sizes?: InputMaybe<Array<DishSizeInput>>;
  temporalPrices?: InputMaybe<Array<MenuItemTemporalPriceInput>>;
  updateTargetItemIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  updateTargetType?: InputMaybe<Scalars['String']['input']>;
};

export type MenuItemModifierGroup = {
  __typename?: 'MenuItemModifierGroup';
  description?: Maybe<Scalars['String']['output']>;
  enabledModifiers: Array<MenuItemModifierGroupModifier>;
  freeSelectionsCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isEnabled: Scalars['Boolean']['output'];
  itemId?: Maybe<Scalars['Int']['output']>;
  locationId?: Maybe<Scalars['Int']['output']>;
  maxSelectionsCount?: Maybe<Scalars['Int']['output']>;
  minSelectionsCount?: Maybe<Scalars['Int']['output']>;
  modifiers: Array<MenuItemModifierGroupModifier>;
  multiSameSelection: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  rootModifierGroupId?: Maybe<Scalars['Int']['output']>;
  showGroupNameOnKitchenTicket?: Maybe<Scalars['Boolean']['output']>;
  topLevelModifierGroupId?: Maybe<Scalars['Int']['output']>;
  uiMenuItemModifierGroup: UiMenuItemModifierGroupInterface;
  uiModifierGroup: UiModifierGroupInterface;
};

export type MenuItemModifierGroupInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  modifierGroupId?: InputMaybe<Scalars['Int']['input']>;
  modifiers?: InputMaybe<Array<MenuItemModifierGroupModifierInput>>;
  price?: InputMaybe<Scalars['Int']['input']>;
  rootModifierGroupId?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuItemModifierGroupModifier = {
  __typename?: 'MenuItemModifierGroupModifier';
  allergens: Array<AllergenEnum>;
  /** Read-only; edit at the dish level. */
  calories?: Maybe<Scalars['Int']['output']>;
  enabledModifierGroups: Array<MenuItemModifierGroup>;
  hasModifiers: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  includedQuantity: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  locationId?: Maybe<Scalars['Int']['output']>;
  modifierGroups: Array<MenuItemModifierGroup>;
  modifierId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  outOfStock: Scalars['Boolean']['output'];
  outOfStockUntil?: Maybe<Scalars['DateTime']['output']>;
  parentModifierGroup: MenuItemModifierGroup;
  parentModifierGroupId: Scalars['Int']['output'];
  parentModifierGroupItemId?: Maybe<Scalars['Int']['output']>;
  position: Scalars['Int']['output'];
  price?: Maybe<Scalars['Decimal']['output']>;
  priceCustomText?: Maybe<Scalars['String']['output']>;
  priceType: Scalars['String']['output'];
  rootModifier: ModifierGroupModifier;
  sizePrices: Array<MenuItemSizeModifierPrice>;
};

export type MenuItemModifierGroupModifierInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  modifierGroups?: InputMaybe<Array<MenuItemModifierGroupInput>>;
  modifierId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  priceCustomText?: InputMaybe<Scalars['String']['input']>;
  priceType?: InputMaybe<Scalars['String']['input']>;
};

export type MenuItemModifierGroupModifierModifierGroup = {
  __typename?: 'MenuItemModifierGroupModifierModifierGroup';
  ancestryGroupNames: Array<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isEnabled: Scalars['Boolean']['output'];
  itemId?: Maybe<Scalars['Int']['output']>;
  locationId?: Maybe<Scalars['Int']['output']>;
  maxSelectionsCount?: Maybe<Scalars['Int']['output']>;
  minSelectionsCount?: Maybe<Scalars['Int']['output']>;
  modifiers: Array<MenuItemModifierGroupModifier>;
  multiSameSelection: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentModifierName: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  rootModifierGroupId?: Maybe<Scalars['Int']['output']>;
  uiModifierGroup: UiModifierGroupInterface;
};

export type MenuItemModifierInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  modifierId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  priceCustomText?: InputMaybe<Scalars['String']['input']>;
  priceType?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of MenuItemOutOfStock */
export type MenuItemOutOfStockInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuItemId: Scalars['Int']['input'];
  outOfStock: Scalars['Boolean']['input'];
};

export type MenuItemPaginationHandler = {
  __typename?: 'MenuItemPaginationHandler';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  offset: Scalars['Int']['output'];
  records: Array<MenuItem>;
};

export type MenuItemPosPhoto = Eventable & PhotoInterface & {
  __typename?: 'MenuItemPosPhoto';
  eventableName: Scalars['String']['output'];
  featured?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  item?: Maybe<MenuItem>;
  name: Scalars['String']['output'];
  photoHeight: Scalars['Int']['output'];
  photoUploadedPhoto?: Maybe<UploadedPhoto>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  photoWidth: Scalars['Int']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  shareUrl?: Maybe<Scalars['String']['output']>;
  show: Scalars['Boolean']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  uiPhoto?: Maybe<UiPhotoInterface>;
};

export type MenuItemSharedExtraGroupVersion = Versionable & {
  __typename?: 'MenuItemSharedExtraGroupVersion';
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  locationMenuName?: Maybe<Scalars['String']['output']>;
  objectChanges: Array<VersionDiff>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

export type MenuItemSize = {
  __typename?: 'MenuItemSize';
  /** Read-only; edit at the dish level. */
  calories?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Decimal']['output']>;
  providerVariation?: Maybe<ProviderVariation>;
  providerVariationId?: Maybe<Scalars['Int']['output']>;
};

export type MenuItemSizeModifierPrice = {
  __typename?: 'MenuItemSizeModifierPrice';
  id: Scalars['Int']['output'];
  menuItemModifierGroupModifierId: Scalars['Int']['output'];
  menuItemSizeId: Scalars['Int']['output'];
  price?: Maybe<Scalars['Decimal']['output']>;
};

export type MenuItemSizeVersion = Versionable & {
  __typename?: 'MenuItemSizeVersion';
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  locationMenuName?: Maybe<Scalars['String']['output']>;
  objectChanges: Array<VersionDiff>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

export type MenuItemSquareWarning = ProviderWarning & {
  __typename?: 'MenuItemSquareWarning';
  id: Scalars['Int']['output'];
  warningType: Scalars['String']['output'];
};

export type MenuItemTemporalPrice = {
  __typename?: 'MenuItemTemporalPrice';
  dayFriday: Scalars['Boolean']['output'];
  dayMonday: Scalars['Boolean']['output'];
  daySaturday: Scalars['Boolean']['output'];
  daySunday: Scalars['Boolean']['output'];
  dayThursday: Scalars['Boolean']['output'];
  dayTuesday: Scalars['Boolean']['output'];
  dayWednesday: Scalars['Boolean']['output'];
  endTime: Scalars['Time']['output'];
  id: Scalars['Int']['output'];
  menuItemId: Scalars['Int']['output'];
  price: Scalars['Decimal']['output'];
  startTime: Scalars['Time']['output'];
};

/** Price change schedule type for menu items */
export type MenuItemTemporalPriceChangeSchedule = {
  __typename?: 'MenuItemTemporalPriceChangeSchedule';
  endTime?: Maybe<Scalars['Time']['output']>;
  id: Scalars['Int']['output'];
  menuItemId: Scalars['Int']['output'];
  menuSectionId: Scalars['Int']['output'];
  startTime?: Maybe<Scalars['Time']['output']>;
};

export type MenuItemTemporalPriceInput = {
  dayFriday?: InputMaybe<Scalars['Boolean']['input']>;
  dayMonday?: InputMaybe<Scalars['Boolean']['input']>;
  daySaturday?: InputMaybe<Scalars['Boolean']['input']>;
  daySunday?: InputMaybe<Scalars['Boolean']['input']>;
  dayThursday?: InputMaybe<Scalars['Boolean']['input']>;
  dayTuesday?: InputMaybe<Scalars['Boolean']['input']>;
  dayWednesday?: InputMaybe<Scalars['Boolean']['input']>;
  endTime: Scalars['Time']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  startTime: Scalars['Time']['input'];
};

export type MenuItemToastWarning = ProviderWarning & {
  __typename?: 'MenuItemToastWarning';
  id: Scalars['Int']['output'];
  warningType: Scalars['String']['output'];
};

/** Autogenerated input type of MenuItemToggle */
export type MenuItemToggleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  menuItemId: Scalars['Int']['input'];
};

/** Autogenerated input type of MenuItemUpdateCateringLimits */
export type MenuItemUpdateCateringLimitsInput = {
  cateringOrderMin?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuItemId: Scalars['Int']['input'];
};

/** Autogenerated input type of MenuItemUpdate */
export type MenuItemUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dishId?: InputMaybe<Scalars['Int']['input']>;
  menuItemId: Scalars['Int']['input'];
  menuItemInput: MenuItemInput;
  photoInputs?: InputMaybe<Array<PhotoInput>>;
};

/** Autogenerated input type of MenuItemUpdateSubsection */
export type MenuItemUpdateSubsectionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  destinationMenuSubsectionId: Scalars['Int']['input'];
  destinationPosition: Scalars['Int']['input'];
  menuItemId: Scalars['Int']['input'];
};

export type MenuItemVersion = Versionable & {
  __typename?: 'MenuItemVersion';
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  locationMenuName?: Maybe<Scalars['String']['output']>;
  objectChanges: Array<VersionDiff>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

export type MenuItemWasDestroyedReturnType = {
  __typename?: 'MenuItemWasDestroyedReturnType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  status: StatusEnum;
};

export type MenuOrderingAppDishTag = {
  __typename?: 'MenuOrderingAppDishTag';
  abbr?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dishesTagCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  imageIconUrl?: Maybe<Scalars['String']['output']>;
  imageUploadedPhoto?: Maybe<UploadedPhoto>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  restaurant?: Maybe<Restaurant>;
};

export type MenuOrderingOpeningRange = OrderingRangeable & {
  __typename?: 'MenuOrderingOpeningRange';
  closeTime?: Maybe<Scalars['Time']['output']>;
  dayFriday?: Maybe<Scalars['Boolean']['output']>;
  dayMonday?: Maybe<Scalars['Boolean']['output']>;
  daySaturday?: Maybe<Scalars['Boolean']['output']>;
  daySunday?: Maybe<Scalars['Boolean']['output']>;
  dayThursday?: Maybe<Scalars['Boolean']['output']>;
  dayTuesday?: Maybe<Scalars['Boolean']['output']>;
  dayWednesday?: Maybe<Scalars['Boolean']['output']>;
  days: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  openAllDay?: Maybe<Scalars['Boolean']['output']>;
  openTime?: Maybe<Scalars['Time']['output']>;
};

export type MenuOrderingOpeningRangeInput = {
  closeTime?: InputMaybe<Scalars['Time']['input']>;
  dayFriday?: InputMaybe<Scalars['Boolean']['input']>;
  dayMonday?: InputMaybe<Scalars['Boolean']['input']>;
  daySaturday?: InputMaybe<Scalars['Boolean']['input']>;
  daySunday?: InputMaybe<Scalars['Boolean']['input']>;
  dayThursday?: InputMaybe<Scalars['Boolean']['input']>;
  dayTuesday?: InputMaybe<Scalars['Boolean']['input']>;
  dayWednesday?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  openAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  openTime?: InputMaybe<Scalars['Time']['input']>;
};

export type MenuOrderingOpeningRangeVersion = Versionable & {
  __typename?: 'MenuOrderingOpeningRangeVersion';
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  locationMenuName?: Maybe<Scalars['String']['output']>;
  objectChanges: Array<VersionDiff>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

export type MenuPaginationHandler = {
  __typename?: 'MenuPaginationHandler';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  offset: Scalars['Int']['output'];
  records: Array<Menu>;
};

export type MenuPolicy = {
  __typename?: 'MenuPolicy';
  destroy: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  promoteToMaster: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
};

export type MenuPresence = {
  __typename?: 'MenuPresence';
  avatar: Scalars['String']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type MenuProcessingResult = {
  __typename?: 'MenuProcessingResult';
  createdAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  fileHash: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  menuId?: Maybe<Scalars['ID']['output']>;
  menuJson?: Maybe<Scalars['JSON']['output']>;
  originalFilename?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Autogenerated input type of MenuPromote */
export type MenuPromoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuId: Scalars['Int']['input'];
};

export type MenuSection = {
  __typename?: 'MenuSection';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabledItems: Array<MenuItem>;
  enabledItemsCount: Scalars['Int']['output'];
  filteredItemsCount: Scalars['Int']['output'];
  hasEnabledCustomHtml?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isDeleting: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isFullWidth: Scalars['Boolean']['output'];
  isHeaderEnabled: Scalars['Boolean']['output'];
  isOrderingSection: Scalars['Boolean']['output'];
  isSecret: Scalars['Boolean']['output'];
  items: Array<MenuItem>;
  locationId?: Maybe<Scalars['Int']['output']>;
  masterSectionId?: Maybe<Scalars['Int']['output']>;
  menu?: Maybe<Menu>;
  menuColumnCount?: Maybe<Scalars['Int']['output']>;
  menuId?: Maybe<Scalars['Int']['output']>;
  menuLayout?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  providerMenuSectionId?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  squareCategory?: Maybe<SquareCategory>;
  subsections: Array<MenuSubsection>;
  uiSection: UiMenuSectionInterface;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type MenuSectionFilteredItemsCountArgs = {
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated input type of MenuSectionAlphabetizeItems */
export type MenuSectionAlphabetizeItemsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuSectionId: Scalars['Int']['input'];
};

/** Autogenerated input type of MenuSectionCreate */
export type MenuSectionCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuId: Scalars['Int']['input'];
  menuSectionInput: MenuSectionInput;
};

/** Autogenerated input type of MenuSectionDestroy */
export type MenuSectionDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuSectionId: Scalars['Int']['input'];
};

export type MenuSectionInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  isHeaderEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isSecret?: InputMaybe<Scalars['Boolean']['input']>;
  menuColumnCount?: InputMaybe<Scalars['Int']['input']>;
  menuLayout?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  subsectionType?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of MenuSectionUpdate */
export type MenuSectionUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuSectionId: Scalars['Int']['input'];
  menuSectionInput: MenuSectionInput;
};

export type MenuSectionVersion = Versionable & {
  __typename?: 'MenuSectionVersion';
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  locationMenuName?: Maybe<Scalars['String']['output']>;
  objectChanges: Array<VersionDiff>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

export type MenuSectionWasUpdatedReturn = {
  __typename?: 'MenuSectionWasUpdatedReturn';
  action: Scalars['String']['output'];
  item?: Maybe<MenuItem>;
  section?: Maybe<MenuSection>;
  subsection?: Maybe<MenuSubsection>;
};

export type MenuSubsection = {
  __typename?: 'MenuSubsection';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customHtml?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabledItems: Array<MenuItem>;
  id: Scalars['Int']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  items: Array<MenuItem>;
  masterSubsectionId?: Maybe<Scalars['Int']['output']>;
  menu?: Maybe<Menu>;
  name?: Maybe<Scalars['String']['output']>;
  orderingItems: Array<MenuItem>;
  position: Scalars['Int']['output'];
  section?: Maybe<MenuSection>;
  subsectionType?: Maybe<Scalars['String']['output']>;
  uiSubsection: UiMenuSubsectionInterface;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type MenuSubsectionOrderingItemsArgs = {
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Autogenerated input type of MenuSubsectionAlphabetizeItems */
export type MenuSubsectionAlphabetizeItemsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuSubsectionId: Scalars['Int']['input'];
};

/** Autogenerated input type of MenuSubsectionCreate */
export type MenuSubsectionCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuSectionId: Scalars['Int']['input'];
  menuSubsectionInput: MenuSubsectionInput;
};

/** Autogenerated input type of MenuSubsectionDestroy */
export type MenuSubsectionDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuSubsectionId: Scalars['Int']['input'];
};

export type MenuSubsectionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subsectionType?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of MenuSubsectionUpdate */
export type MenuSubsectionUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuSubsectionId: Scalars['Int']['input'];
  menuSubsectionInput: MenuSubsectionInput;
};

/** Autogenerated input type of MenuSubsectionUpdateItemPositions */
export type MenuSubsectionUpdateItemPositionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuItemInputs: Array<PositionInput>;
  menuSubsectionId: Scalars['Int']['input'];
};

export type MenuSubsectionVersion = Versionable & {
  __typename?: 'MenuSubsectionVersion';
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  locationMenuName?: Maybe<Scalars['String']['output']>;
  objectChanges: Array<VersionDiff>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

export type MenuSyncHistory = {
  __typename?: 'MenuSyncHistory';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  menu?: Maybe<Menu>;
  menuSyncHistoryItems: Array<MenuSyncHistoryItem>;
  posMenuName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  toastMenu?: Maybe<ToastMenu>;
  toastMenuName: Scalars['String']['output'];
  toastRestaurant?: Maybe<ToastRestaurant>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MenuSyncHistoryItem = {
  __typename?: 'MenuSyncHistoryItem';
  countOk: Scalars['Int']['output'];
  countSkipped: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  itemType: Scalars['String']['output'];
};

/** Autogenerated input type of MenuUpdate */
export type MenuUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuId: Scalars['Int']['input'];
  menuInput: MenuInput;
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of MenuUpdateSectionPositions */
export type MenuUpdateSectionPositionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuId: Scalars['Int']['input'];
  menuSectionInputs: Array<MenuSectionInput>;
};

export type MenuVersion = Versionable & {
  __typename?: 'MenuVersion';
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  locationMenuName?: Maybe<Scalars['String']['output']>;
  objectChanges: Array<VersionDiff>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

export type MenuWasUpdatedReturn = {
  __typename?: 'MenuWasUpdatedReturn';
  action: Scalars['String']['output'];
  featuredSection?: Maybe<MenuFeaturedSection>;
  item?: Maybe<MenuItem>;
  menu?: Maybe<Menu>;
  menuWithoutSubsections?: Maybe<Menu>;
  section?: Maybe<MenuSection>;
  subsection?: Maybe<MenuSubsection>;
};

export type MenuYextSync = {
  __typename?: 'MenuYextSync';
  createdAt: Scalars['DateTime']['output'];
  enqueuedAt?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  menu: Menu;
  menuId: Scalars['Int']['output'];
  parsedErrorMessage?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  yextMenuId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of MergeDish */
export type MergeDishInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  mergeDishInput: DishMergeInput;
};

export type MessageCampaign = {
  __typename?: 'MessageCampaign';
  clickedMessagesCount: Scalars['Int']['output'];
  clickedRate: Scalars['Float']['output'];
  customMessageContent?: Maybe<Scalars['String']['output']>;
  customMessageSubject?: Maybe<Scalars['String']['output']>;
  customMessageTeaser?: Maybe<Scalars['String']['output']>;
  customSmsMessageContent?: Maybe<Scalars['String']['output']>;
  deliveredMessagesCount: Scalars['Int']['output'];
  deliveredRate: Scalars['Float']['output'];
  enabledSelectedLocationsCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  includeFeaturedContent?: Maybe<Scalars['Boolean']['output']>;
  isEnableable?: Maybe<Scalars['Boolean']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isFollowTriggerType?: Maybe<Scalars['Boolean']['output']>;
  isLoyalty?: Maybe<Scalars['Boolean']['output']>;
  masterMessageCampaign?: Maybe<MasterMessageCampaign>;
  messageCampaignSelectedLocations: Array<MessageCampaignSelectedLocation>;
  messageContent?: Maybe<Scalars['String']['output']>;
  messageSubject?: Maybe<Scalars['String']['output']>;
  messageTeaser?: Maybe<Scalars['String']['output']>;
  messagesCount: Scalars['Int']['output'];
  messagesRevenue?: Maybe<MessagesRevenue>;
  offerId?: Maybe<Scalars['Int']['output']>;
  openedMessagesCount: Scalars['Int']['output'];
  openedRate: Scalars['Float']['output'];
  orderingOffer?: Maybe<OrderingOffer>;
  orderingOfferId?: Maybe<Scalars['Int']['output']>;
  position: Scalars['Int']['output'];
  restaurant: Restaurant;
  rootOrderingOfferId?: Maybe<Scalars['Int']['output']>;
  sendOnWeekday?: Maybe<Scalars['String']['output']>;
  sentMessageHtmlPersonalization?: Maybe<Scalars['JSON']['output']>;
  smsMessageContent?: Maybe<Scalars['String']['output']>;
  textAlignment?: Maybe<Scalars['String']['output']>;
  theme?: Maybe<Scalars['String']['output']>;
  totalSelectedLocationsCount: Scalars['Int']['output'];
  triggerAmountSpent?: Maybe<Scalars['Int']['output']>;
  triggerNumberOfDays?: Maybe<Scalars['Int']['output']>;
  triggerNumberOfOrders?: Maybe<Scalars['Int']['output']>;
};

export type MessageCampaignByTriggerType = {
  __typename?: 'MessageCampaignByTriggerType';
  id: Scalars['Int']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type MessageCampaignContentAudit = {
  __typename?: 'MessageCampaignContentAudit';
  contentAuditReasons?: Maybe<Scalars['String']['output']>;
  contentAuditSummary?: Maybe<Scalars['String']['output']>;
  flaggedContentScore?: Maybe<Scalars['Int']['output']>;
  hasFlaggedContent: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isReleased: Scalars['Boolean']['output'];
  messageCampaign: MessageCampaign;
  messageCampaignId: Scalars['Int']['output'];
};

export type MessageCampaignInput = {
  customMessageContent?: InputMaybe<Scalars['String']['input']>;
  customMessageSubject?: InputMaybe<Scalars['String']['input']>;
  customMessageTeaser?: InputMaybe<Scalars['String']['input']>;
  customSmsMessageContent?: InputMaybe<Scalars['String']['input']>;
  fromMarketingOffer?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeaturedContent?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isSelectedLocation?: InputMaybe<Scalars['Boolean']['input']>;
  messageCampaignSelectedLocations?: InputMaybe<Array<MessageCampaignSelectedLocationInput>>;
  offerId?: InputMaybe<Scalars['Int']['input']>;
  orderingOfferId?: InputMaybe<Scalars['Int']['input']>;
  rootOrderingOfferId?: InputMaybe<Scalars['Int']['input']>;
  sendOnWeekday?: InputMaybe<Scalars['String']['input']>;
  textAlignment?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
  triggerAmountSpent?: InputMaybe<Scalars['Int']['input']>;
  triggerNumberOfDays?: InputMaybe<Scalars['Int']['input']>;
  triggerNumberOfOrders?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageCampaignMessage = Messageable & {
  __typename?: 'MessageCampaignMessage';
  bouncedAt?: Maybe<Scalars['DateTime']['output']>;
  clickedAt?: Maybe<Scalars['DateTime']['output']>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  hasBounced?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  locationName?: Maybe<Scalars['String']['output']>;
  messageCampaign?: Maybe<MessageCampaign>;
  messageHtmlUrl?: Maybe<Scalars['String']['output']>;
  messageSubject?: Maybe<Scalars['String']['output']>;
  offerCodeId?: Maybe<Scalars['Int']['output']>;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  personalization?: Maybe<Scalars['JSON']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentMessageHtmlUrl?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type MessageCampaignSelectedLocation = {
  __typename?: 'MessageCampaignSelectedLocation';
  clickedMessagesCount: Scalars['Int']['output'];
  customMessageContent?: Maybe<Scalars['String']['output']>;
  customMessageSubject?: Maybe<Scalars['String']['output']>;
  customMessageTeaser?: Maybe<Scalars['String']['output']>;
  customSmsMessageContent?: Maybe<Scalars['String']['output']>;
  deliveredMessagesCount: Scalars['Int']['output'];
  enabledStatusAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  includeFeaturedContent?: Maybe<Scalars['Boolean']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<RestaurantLocation>;
  locationId?: Maybe<Scalars['Int']['output']>;
  messageCampaign: MessageCampaign;
  messageCampaignId: Scalars['Int']['output'];
  messageContent: Scalars['String']['output'];
  messageSubject: Scalars['String']['output'];
  messageTeaser?: Maybe<Scalars['String']['output']>;
  messagesCount: Scalars['Int']['output'];
  messagesRevenue?: Maybe<MessagesRevenue>;
  offerId?: Maybe<Scalars['Int']['output']>;
  openedMessagesCount: Scalars['Int']['output'];
  orderingOffer?: Maybe<OrderingOffer>;
  orderingOfferId?: Maybe<Scalars['Int']['output']>;
  rootOrderingOfferId?: Maybe<Scalars['Int']['output']>;
  sendOnWeekday?: Maybe<Scalars['String']['output']>;
  smsMessageContent?: Maybe<Scalars['String']['output']>;
  textAlignment?: Maybe<Scalars['String']['output']>;
  theme?: Maybe<Scalars['String']['output']>;
  triggerAmountSpent?: Maybe<Scalars['Int']['output']>;
  triggerNumberOfDays?: Maybe<Scalars['Int']['output']>;
  triggerNumberOfOrders?: Maybe<Scalars['Int']['output']>;
  useLocationContent?: Maybe<Scalars['Boolean']['output']>;
};

export type MessageCampaignSelectedLocationInput = {
  customMessageContent?: InputMaybe<Scalars['String']['input']>;
  customMessageSubject?: InputMaybe<Scalars['String']['input']>;
  customMessageTeaser?: InputMaybe<Scalars['String']['input']>;
  customSmsMessageContent?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeFeaturedContent?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  messageCampaignId?: InputMaybe<Scalars['Int']['input']>;
  offerId?: InputMaybe<Scalars['Int']['input']>;
  orderingOfferId?: InputMaybe<Scalars['Int']['input']>;
  rootOrderingOfferId?: InputMaybe<Scalars['Int']['input']>;
  sendOnWeekday?: InputMaybe<Scalars['String']['input']>;
  textAlignment?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
  triggerAmountSpent?: InputMaybe<Scalars['Int']['input']>;
  triggerNumberOfDays?: InputMaybe<Scalars['Int']['input']>;
  triggerNumberOfOrders?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageGroup = RestaurantMessagePackCommunicationable & {
  __typename?: 'MessageGroup';
  advisorCardTrackerId?: Maybe<Scalars['Int']['output']>;
  aiMarketingContent?: Maybe<AiMarketingContent>;
  allSelected: Scalars['Boolean']['output'];
  campaignItem?: Maybe<CampaignItem>;
  campaignItemId?: Maybe<Scalars['Int']['output']>;
  clickRate: Scalars['Float']['output'];
  clickedMessagesCount: Scalars['Int']['output'];
  clickedRevenueSourcesSum: Scalars['Float']['output'];
  clicksCount: Scalars['Int']['output'];
  communication?: Maybe<RestaurantMessagePackCommunication>;
  communicationPreview?: Maybe<Scalars['String']['output']>;
  contents: Array<MessageGroupContent>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBySegment?: Maybe<Scalars['Boolean']['output']>;
  deliveredMessagesCount: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  excludeUnknownLocations?: Maybe<Scalars['Boolean']['output']>;
  failureIndicators: Array<MessageGroupFailureIndicator>;
  hasSentMessageContent: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  includeFeaturedContent?: Maybe<Scalars['Boolean']['output']>;
  isCreatedByAi?: Maybe<Scalars['Boolean']['output']>;
  isCustomSelection: Scalars['Boolean']['output'];
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  isScheduled?: Maybe<Scalars['Boolean']['output']>;
  locationId?: Maybe<Scalars['Int']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  locationTimezones?: Maybe<Array<Scalars['String']['output']>>;
  mailerLogoEffect?: Maybe<Scalars['String']['output']>;
  messageContent?: Maybe<Scalars['String']['output']>;
  messageGroupAverage?: Maybe<RestaurantMessageGroupAverage>;
  messageGroupExcludedFollowers: Array<MessageGroupExcludedFollower>;
  messageGroupExcludedLocations: Array<MessageGroupExcludedLocation>;
  messageGroupExcludedTags: Array<MessageGroupExcludedTag>;
  messageGroupLinkCategories: Array<MessageGroupLinkCategory>;
  messageGroupSelectedFollowerSegments: Array<MessageGroupSelectedFollowerSegment>;
  messageGroupSelectedFollowers: Array<MessageGroupSelectedFollower>;
  messageGroupSelectedLocations: Array<MessageGroupSelectedLocation>;
  messageGroupSelectedSources: Array<MessageGroupSelectedSource>;
  messageGroupSelectedTags: Array<MessageGroupSelectedTag>;
  messageSubject?: Maybe<Scalars['String']['output']>;
  messageTeaser?: Maybe<Scalars['String']['output']>;
  messagesCount: Scalars['Int']['output'];
  offerId?: Maybe<Scalars['Int']['output']>;
  openRate: Scalars['Float']['output'];
  openedMessagesCount: Scalars['Int']['output'];
  openedRevenueSourcesSum: Scalars['Float']['output'];
  orderingOfferId?: Maybe<Scalars['Int']['output']>;
  ordersCount: Scalars['Int']['output'];
  processNowRequestAt?: Maybe<Scalars['DateTime']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  remarketedAction?: Maybe<Scalars['String']['output']>;
  remarketedCampaignItemChannel?: Maybe<Channel>;
  remarketedCampaignItemId?: Maybe<Scalars['Int']['output']>;
  remarketedLocationId?: Maybe<Scalars['Int']['output']>;
  remarketedTagId?: Maybe<Scalars['Int']['output']>;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  restaurantMessageGroupAverage?: Maybe<RestaurantMessageGroupAverage>;
  restaurantName: Scalars['String']['output'];
  restaurantSlug: Scalars['String']['output'];
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  segmentationMatcher?: Maybe<Scalars['String']['output']>;
  sendToUnknownLocations?: Maybe<Scalars['Boolean']['output']>;
  sentMessageContent?: Maybe<Scalars['String']['output']>;
  sentMessageHtmlPersonalization?: Maybe<Scalars['JSON']['output']>;
  sentMessageHtmlUrl?: Maybe<Scalars['String']['output']>;
  tagName?: Maybe<Scalars['String']['output']>;
  textAlignment?: Maybe<Scalars['String']['output']>;
  theme?: Maybe<Scalars['String']['output']>;
  thumbnailImage?: Maybe<Scalars['String']['output']>;
  unsubscribedCount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};


export type MessageGroupMessageGroupLinkCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageGroupBuilderContentInput = {
  content?: InputMaybe<BuilderContentInput>;
  contents?: InputMaybe<Array<BuilderContentInput>>;
  footer?: InputMaybe<Scalars['Boolean']['input']>;
  hasMultipleSections?: InputMaybe<Scalars['Boolean']['input']>;
  header?: InputMaybe<Scalars['Boolean']['input']>;
  restaurantInput?: InputMaybe<RestaurantInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
};

export type MessageGroupButtonContent = BuilderContentable & {
  __typename?: 'MessageGroupButtonContent';
  buttonLink?: Maybe<Scalars['String']['output']>;
  buttonName?: Maybe<Scalars['String']['output']>;
  buttonType: Scalars['String']['output'];
  content?: Maybe<MessageGroupContent>;
  contentType: Scalars['String']['output'];
  customPage?: Maybe<CustomPage>;
  customPageId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  message?: Maybe<MessageGroup>;
};

export type MessageGroupCalendarEventContent = BuilderContentable & {
  __typename?: 'MessageGroupCalendarEventContent';
  calendarEvent?: Maybe<CalendarEvent>;
  content?: Maybe<MessageGroupContent>;
  contentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type MessageGroupContent = {
  __typename?: 'MessageGroupContent';
  content?: Maybe<BuilderContentable>;
  contentOrder?: Maybe<Scalars['Int']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  messageGroup?: Maybe<MessageGroup>;
  messageGroupId?: Maybe<Scalars['Int']['output']>;
};

export type MessageGroupContentAudit = {
  __typename?: 'MessageGroupContentAudit';
  contentAuditReasons?: Maybe<Scalars['String']['output']>;
  contentAuditSummary?: Maybe<Scalars['String']['output']>;
  flaggedContentScore?: Maybe<Scalars['Int']['output']>;
  hasFlaggedContent: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isReleased: Scalars['Boolean']['output'];
  messageGroup: MessageGroup;
  messageGroupId: Scalars['Int']['output'];
};

export type MessageGroupDishContent = BuilderContentable & {
  __typename?: 'MessageGroupDishContent';
  content?: Maybe<MessageGroupContent>;
  contentType: Scalars['String']['output'];
  dish?: Maybe<Dish>;
  id: Scalars['Int']['output'];
};

export type MessageGroupDishReviewContent = BuilderContentable & {
  __typename?: 'MessageGroupDishReviewContent';
  content: MessageGroupContent;
  contentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  review?: Maybe<Review>;
  reviewId?: Maybe<Scalars['Int']['output']>;
  textContent?: Maybe<Scalars['String']['output']>;
  uploadedPhoto?: Maybe<UploadedPhoto>;
  uploadedPhotoId?: Maybe<Scalars['Int']['output']>;
};

export type MessageGroupDividerContent = BuilderContentable & {
  __typename?: 'MessageGroupDividerContent';
  color?: Maybe<Scalars['String']['output']>;
  content?: Maybe<MessageGroupContent>;
  contentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  message?: Maybe<MessageGroup>;
  spacing?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
};

export type MessageGroupExcludedFollower = {
  __typename?: 'MessageGroupExcludedFollower';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  followerId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
};

export type MessageGroupExcludedLocation = {
  __typename?: 'MessageGroupExcludedLocation';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  location: RestaurantLocation;
  locationId?: Maybe<Scalars['Int']['output']>;
};

export type MessageGroupExcludedLocationInput = {
  locationId: Scalars['Int']['input'];
};

export type MessageGroupExcludedTag = {
  __typename?: 'MessageGroupExcludedTag';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  followerTag: FollowerTag;
  followerTagId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
};

export type MessageGroupExcludedTagInput = {
  followerTagId: Scalars['Int']['input'];
};

export type MessageGroupFailureIndicator = {
  __typename?: 'MessageGroupFailureIndicator';
  createdAt: Scalars['DateTime']['output'];
  dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isResolved: Scalars['Boolean']['output'];
  lastFailureMessage?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MessageGroupFeaturedContent = BuilderContentable & {
  __typename?: 'MessageGroupFeaturedContent';
  content?: Maybe<MessageGroupContent>;
  contentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  message?: Maybe<MessageGroup>;
};

export type MessageGroupFeaturedReviewContent = BuilderContentable & {
  __typename?: 'MessageGroupFeaturedReviewContent';
  content?: Maybe<MessageGroupContent>;
  contentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  message?: Maybe<MessageGroup>;
};

export type MessageGroupGeneratedAiText = {
  __typename?: 'MessageGroupGeneratedAiText';
  messageContent?: Maybe<Scalars['String']['output']>;
  messageSubject?: Maybe<Scalars['String']['output']>;
  messageTeaser?: Maybe<Scalars['String']['output']>;
};

export type MessageGroupHeaderContent = BuilderContentable & {
  __typename?: 'MessageGroupHeaderContent';
  content?: Maybe<Scalars['String']['output']>;
  contentType: Scalars['String']['output'];
  headerText?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type MessageGroupImageContent = BuilderContentable & {
  __typename?: 'MessageGroupImageContent';
  altText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  content?: Maybe<MessageGroupContent>;
  contentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  uploadedPhoto?: Maybe<UploadedPhoto>;
  url?: Maybe<Scalars['String']['output']>;
};

export type MessageGroupInput = {
  advisorCardTrackerId?: InputMaybe<Scalars['Int']['input']>;
  allSelected?: InputMaybe<Scalars['Boolean']['input']>;
  createdBySegment?: InputMaybe<Scalars['Boolean']['input']>;
  excludeUnknownLocations?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeaturedContent?: InputMaybe<Scalars['Boolean']['input']>;
  isCustomSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  messageContent?: InputMaybe<Scalars['String']['input']>;
  messageGroupBuilder?: InputMaybe<Array<BuilderContentInput>>;
  messageGroupExcludedFollowers?: InputMaybe<Array<Scalars['Int']['input']>>;
  messageGroupExcludedLocations?: InputMaybe<Array<Scalars['Int']['input']>>;
  messageGroupExcludedTags?: InputMaybe<Array<Scalars['Int']['input']>>;
  messageGroupSelectedFollowerSegments?: InputMaybe<Array<Scalars['Int']['input']>>;
  messageGroupSelectedFollowers?: InputMaybe<Array<Scalars['Int']['input']>>;
  messageGroupSelectedLocations?: InputMaybe<Array<Scalars['Int']['input']>>;
  messageGroupSelectedSources?: InputMaybe<Array<Scalars['String']['input']>>;
  messageGroupSelectedTags?: InputMaybe<Array<Scalars['Int']['input']>>;
  messageSubject: Scalars['String']['input'];
  messageTeaser?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['Int']['input']>;
  orderingOfferId?: InputMaybe<Scalars['Int']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  remarketedAction?: InputMaybe<Scalars['String']['input']>;
  remarketedCampaignItemId?: InputMaybe<Scalars['Int']['input']>;
  remarketedLocationId?: InputMaybe<Scalars['Int']['input']>;
  remarketedTagId?: InputMaybe<Scalars['Int']['input']>;
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  segmentationMatcher?: InputMaybe<Scalars['String']['input']>;
  sendToUnknownLocations?: InputMaybe<Scalars['Boolean']['input']>;
  textAlignment?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageGroupLink = {
  __typename?: 'MessageGroupLink';
  clickCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  uniqueClickCount: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type MessageGroupLinkCategory = {
  __typename?: 'MessageGroupLinkCategory';
  categoryName: Scalars['String']['output'];
  clickRate: Scalars['Float']['output'];
  linkNames: Array<Scalars['String']['output']>;
  totalClicks: Scalars['Int']['output'];
  uniqueClicks: Scalars['Int']['output'];
};

export type MessageGroupLinkPagination = {
  __typename?: 'MessageGroupLinkPagination';
  count: Scalars['Int']['output'];
  records: Array<MessageGroupLink>;
};

export type MessageGroupMessage = Messageable & {
  __typename?: 'MessageGroupMessage';
  bouncedAt?: Maybe<Scalars['DateTime']['output']>;
  clickedAt?: Maybe<Scalars['DateTime']['output']>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  follower?: Maybe<Follower>;
  hasBounced?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  messageHtmlUrl?: Maybe<Scalars['String']['output']>;
  messageSubject?: Maybe<Scalars['String']['output']>;
  offerCode?: Maybe<OfferCode>;
  offerCodeId?: Maybe<Scalars['Int']['output']>;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  orderingOfferCode?: Maybe<OrderingOfferCode>;
  personalization?: Maybe<Scalars['JSON']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentMessageHtmlUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  unsubscribedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export type MessageGroupMessagePagination = {
  __typename?: 'MessageGroupMessagePagination';
  count: Scalars['Int']['output'];
  records: Array<MessageGroupMessage>;
};

export type MessageGroupOfferContent = BuilderContentable & {
  __typename?: 'MessageGroupOfferContent';
  content?: Maybe<MessageGroupContent>;
  contentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  offer?: Maybe<Offer>;
};

export type MessageGroupOrderingEventContent = BuilderContentable & {
  __typename?: 'MessageGroupOrderingEventContent';
  content?: Maybe<MessageGroupContent>;
  contentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  orderingEvent?: Maybe<OrderingEvent>;
};

export type MessageGroupOrderingOfferContent = BuilderContentable & {
  __typename?: 'MessageGroupOrderingOfferContent';
  content?: Maybe<MessageGroupContent>;
  contentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  orderingOffer?: Maybe<OrderingOffer>;
};

export type MessageGroupPaginationHandler = {
  __typename?: 'MessageGroupPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<MessageGroup>;
};

export type MessageGroupPartialInput = {
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  messageGroupExcludedLocations?: InputMaybe<Array<MessageGroupExcludedLocationInput>>;
  messageGroupExcludedTags?: InputMaybe<Array<MessageGroupExcludedTagInput>>;
  messageGroupSelectedFollowerSegments?: InputMaybe<Array<MessageGroupSelectedFollowerSegmentInput>>;
  messageGroupSelectedLocations?: InputMaybe<Array<MessageGroupSelectedLocationInput>>;
  messageGroupSelectedTags?: InputMaybe<Array<MessageGroupSelectedTagInput>>;
  messageSubject?: InputMaybe<Scalars['String']['input']>;
  messageTeaser?: InputMaybe<Scalars['String']['input']>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  segmentationMatcher?: InputMaybe<Scalars['String']['input']>;
  textAlignment?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
};

export type MessageGroupReturn = {
  __typename?: 'MessageGroupReturn';
  messageGroup?: Maybe<MessageGroup>;
  restaurant?: Maybe<Restaurant>;
};

export type MessageGroupRootOrderingOfferContent = BuilderContentable & {
  __typename?: 'MessageGroupRootOrderingOfferContent';
  content?: Maybe<MessageGroupContent>;
  contentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  rootOrderingOffer?: Maybe<RootOrderingOffer>;
};

export type MessageGroupSelectedFollower = {
  __typename?: 'MessageGroupSelectedFollower';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  followerId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
};

export type MessageGroupSelectedFollowerSegment = {
  __typename?: 'MessageGroupSelectedFollowerSegment';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  restaurantFollowerSegment: RestaurantFollowerSegment;
  restaurantFollowerSegmentId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MessageGroupSelectedFollowerSegmentInput = {
  restaurantFollowerSegmentId: Scalars['Int']['input'];
};

export type MessageGroupSelectedLocation = {
  __typename?: 'MessageGroupSelectedLocation';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  location: RestaurantLocation;
  locationId?: Maybe<Scalars['Int']['output']>;
};

export type MessageGroupSelectedLocationInput = {
  locationId: Scalars['Int']['input'];
};

export type MessageGroupSelectedSource = {
  __typename?: 'MessageGroupSelectedSource';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  source?: Maybe<Scalars['String']['output']>;
};

export type MessageGroupSelectedTag = {
  __typename?: 'MessageGroupSelectedTag';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  followerTag: FollowerTag;
  followerTagId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
};

export type MessageGroupSelectedTagInput = {
  followerTagId: Scalars['Int']['input'];
};

export type MessageGroupTextContent = BuilderContentable & {
  __typename?: 'MessageGroupTextContent';
  content?: Maybe<MessageGroupContent>;
  contentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  textContent?: Maybe<Scalars['String']['output']>;
};

export type MessageLocationOption = {
  __typename?: 'MessageLocationOption';
  count: Scalars['Int']['output'];
  locationCity?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['Int']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  locationTimezone?: Maybe<Scalars['String']['output']>;
  unsubscribedCount: Scalars['Int']['output'];
};

export type MessagePaginationHandler = {
  __typename?: 'MessagePaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<MessageCampaignMessage>;
};

export type MessagePreview = {
  __typename?: 'MessagePreview';
  message: Scalars['String']['output'];
};

export type MessagePreviewInput = {
  advisorCardTrackerId?: InputMaybe<Scalars['Int']['input']>;
  allSelected?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeaturedContent?: InputMaybe<Scalars['Boolean']['input']>;
  messageCampaignId?: InputMaybe<Scalars['Int']['input']>;
  messageContent?: InputMaybe<Scalars['String']['input']>;
  messageGroupBuilder?: InputMaybe<Array<BuilderContentInput>>;
  messageSubject?: InputMaybe<Scalars['String']['input']>;
  messageTeaser?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['Int']['input']>;
  orderingEventId?: InputMaybe<Scalars['Int']['input']>;
  orderingOfferId?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  textAlignment?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
};

export type MessageTagOption = {
  __typename?: 'MessageTagOption';
  count: Scalars['Int']['output'];
  tagId?: Maybe<Scalars['Int']['output']>;
  tagName?: Maybe<Scalars['String']['output']>;
  unsubscribedCount: Scalars['Int']['output'];
};

export type Messageable = {
  bouncedAt?: Maybe<Scalars['DateTime']['output']>;
  clickedAt?: Maybe<Scalars['DateTime']['output']>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  hasBounced?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  messageHtmlUrl?: Maybe<Scalars['String']['output']>;
  messageSubject?: Maybe<Scalars['String']['output']>;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MessagesRevenue = {
  __typename?: 'MessagesRevenue';
  attributableMessagesRevenue: Scalars['Float']['output'];
  averageOrderRevenue: Scalars['Float']['output'];
  directMessagesRevenue: Scalars['Float']['output'];
  totalMessagesRevenue: Scalars['Float']['output'];
  totalOrderCount: Scalars['Int']['output'];
};

export type MicrosOrderType = {
  __typename?: 'MicrosOrderType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MicrosOrg = RestaurantPaymentAccountInterface & {
  __typename?: 'MicrosOrg';
  accountSlug: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  accountUrl: Scalars['String']['output'];
  authUrl: Scalars['String']['output'];
  baseUrl: Scalars['String']['output'];
  canDisconnectPos: Scalars['Boolean']['output'];
  clientId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isDeleting: Scalars['Boolean']['output'];
  isMenuSyncing: Scalars['Boolean']['output'];
  isShopSupported: Scalars['Boolean']['output'];
  isSyncing?: Maybe<Scalars['Boolean']['output']>;
  lastSyncStartedAt?: Maybe<Scalars['DateTime']['output']>;
  menuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  orgShortName: Scalars['String']['output'];
  restaurants: Array<Restaurant>;
  shouldReauthenticate: Scalars['Boolean']['output'];
};

export type MicrosOrgPaginationHandler = {
  __typename?: 'MicrosOrgPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<MicrosOrg>;
};

export type MicrosRvcAttachmentHandler = {
  __typename?: 'MicrosRvcAttachmentHandler';
  id: Scalars['String']['output'];
  rvcHandlerName: Scalars['String']['output'];
};

export type MicrosSettingInput = {
  microsCreditCardTenderId?: InputMaybe<Scalars['Int']['input']>;
  microsEmployeeRefId?: InputMaybe<Scalars['Int']['input']>;
  microsOrderTypeDeliveryId?: InputMaybe<Scalars['Int']['input']>;
  microsOrderTypeDineInId?: InputMaybe<Scalars['Int']['input']>;
  microsOrderTypeTakeOutId?: InputMaybe<Scalars['Int']['input']>;
};

export type MicrosTender = {
  __typename?: 'MicrosTender';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MobileVisitsPercentagesByDaysAgo = {
  __typename?: 'MobileVisitsPercentagesByDaysAgo';
  currentMobileVisitsPercentage: Scalars['Float']['output'];
  previousMobileVisitsPercentage?: Maybe<Scalars['Float']['output']>;
};

export type ModifierGroup = {
  __typename?: 'ModifierGroup';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  inheritsParentSizes: Scalars['Boolean']['output'];
  maxSelectionsCount?: Maybe<Scalars['Int']['output']>;
  minSelectionsCount?: Maybe<Scalars['Int']['output']>;
  modifiers: Array<ModifierGroupModifier>;
  multiSameSelection: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentDishes: Array<Dish>;
  parentDishesCount: Scalars['Int']['output'];
  restaurant: Restaurant;
  showGroupNameOnKitchenTicket?: Maybe<Scalars['Boolean']['output']>;
  uiModifierGroup: UiModifierGroupInterface;
  updatedAt: Scalars['DateTime']['output'];
};

export type ModifierGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  maxSelectionsCount?: InputMaybe<Scalars['Int']['input']>;
  minSelectionsCount?: InputMaybe<Scalars['Int']['input']>;
  modifiers?: InputMaybe<Array<ModifierGroupModifierInput>>;
  multiSameSelection?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  showGroupNameOnKitchenTicket?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ModifierGroupModifier = {
  __typename?: 'ModifierGroupModifier';
  dish: Dish;
  dishId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  itemModifiers?: Maybe<Array<MenuItemModifierGroupModifier>>;
  name?: Maybe<Scalars['String']['output']>;
  outOfStock: Scalars['Boolean']['output'];
  position: Scalars['Int']['output'];
  price?: Maybe<Scalars['Decimal']['output']>;
  priceCustomText?: Maybe<Scalars['String']['output']>;
  priceType: Scalars['String']['output'];
};

export type ModifierGroupModifierInput = {
  dish?: InputMaybe<DishInput>;
  dishId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  modifierGroups?: InputMaybe<Array<MenuItemModifierGroupInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  outOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  priceCustomText?: InputMaybe<Scalars['String']['input']>;
  priceType?: InputMaybe<Scalars['String']['input']>;
};

export type ModifierGroupPaginationHandler = {
  __typename?: 'ModifierGroupPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<ModifierGroup>;
};

export type ModifierGroupWasUpdatedReturnType = {
  __typename?: 'ModifierGroupWasUpdatedReturnType';
  modifierGroup?: Maybe<ModifierGroup>;
  status?: Maybe<StatusEnum>;
};

export type ModularSignUpProgress = {
  __typename?: 'ModularSignUpProgress';
  createdAt: Scalars['DateTime']['output'];
  currentStep: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  menuProcessingResult?: Maybe<MenuProcessingResult>;
  restaurant: Restaurant;
  selectedColor?: Maybe<Scalars['String']['output']>;
  selectedFont?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type ModularSignUpStartTrialInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
};

export type ModularSignUpStartWaitlistTrialInput = {
  restaurantCity: Scalars['String']['input'];
  restaurantCountry: Scalars['String']['input'];
  restaurantName: Scalars['String']['input'];
  restaurantPostalCode: Scalars['String']['input'];
  restaurantState: Scalars['String']['input'];
  restaurantStreet: Scalars['String']['input'];
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userPhone: Scalars['String']['input'];
};

export type ModularSignUpUpdateProgressInput = {
  currentStep?: InputMaybe<Scalars['String']['input']>;
  menuProcessingResultId?: InputMaybe<Scalars['ID']['input']>;
  modularSignUpProgressId: Scalars['ID']['input'];
  selectedColor?: InputMaybe<Scalars['String']['input']>;
  selectedFont?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of MoveSelectedUploads */
export type MoveSelectedUploadsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  folderId?: InputMaybe<Scalars['Int']['input']>;
  selectedIds: Array<Scalars['Int']['input']>;
  uploadType: Scalars['String']['input'];
};

export type MultiCampaignSubscriptionReturnType = {
  __typename?: 'MultiCampaignSubscriptionReturnType';
  campaignItems: Array<CampaignItem>;
  errorMessage: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptClientTerms: User;
  /** Accept an admin invite */
  acceptRestaurantMemberInvite?: Maybe<RestaurantMember>;
  /** Add Featured Items */
  addFeaturedItemDrafts?: Maybe<CustomPageSectionDraft>;
  addGoogleMyBusinessLocation: RestaurantLocation;
  addLinkToPendingImport: WoflowImport;
  addMenuItemToFeaturedSection: MenuFeaturedSection;
  addRestaurantDomain: Restaurant;
  addRestaurantLocationOrderingDelayTime?: Maybe<Restaurant>;
  addRestaurantToGroup: RestaurantGroup;
  addStagedRecord: LiveDomain;
  /** Mark selected menu item out of stock */
  adjustMenuItemCartSelectedMenuItem: Scalars['Boolean']['output'];
  alphabetizeMenuSectionItems: MenuSection;
  alphabetizeMenuSubsectionItems: MenuSubsection;
  applyLoyaltyReward?: Maybe<MenuItemCart>;
  applyMenuItemDishTag: MenuItem;
  applyMenuItemFindAndReplace: MenuItem;
  applyMenuItemModifierGroups: MenuItem;
  applyMenuItemOnlineOrdering: MenuItem;
  applyMenuItemPriceChange: MenuItem;
  applyOrderingOfferOrGiftCard: MenuItemCart;
  applyPendingOffer?: Maybe<MenuItemCart>;
  applyPendingReward?: Maybe<MenuItemCart>;
  applyRootSectionTemplate?: Maybe<CustomPageDraft>;
  applyRootSiteTemplate: Restaurant;
  applyRootThemeTemplate: Restaurant;
  applyTemplateToMessageGroup: MessageGroup;
  approveMultipleContents: Scalars['Boolean']['output'];
  approveRestaurantMessagePackCommunication: RestaurantMessagePackCommunication;
  archiveAgentChat: AgentChat;
  archiveAimPromptConfig: AimPromptConfig;
  archiveRestaurantLocation: Restaurant;
  assignAimPromptConfigToRestaurants: AimPromptConfig;
  attachCloverOrderTypes: CloverAccount;
  attachHeartlandPosLocation: HeartlandPosLocation;
  attachMenuItemToProviderItem: MenuItem;
  attachMenuToProviderMenu: Menu;
  attachMenusToProviderMenu: Array<Menu>;
  attachRestaurantBillingCustomer?: Maybe<BillingCustomer>;
  attachSpotonLocation: RestaurantLocation;
  bulkDestroyAiMarketingContentForRestaurants: Scalars['Int']['output'];
  /** Moves an upload folder to another folder */
  bulkMoveUploadFolder: Scalars['Boolean']['output'];
  bulkSetSubmitted: Restaurant;
  /** Updates uploaded folder aim available */
  bulkUpdateFolderAimAvailable: Scalars['Boolean']['output'];
  cancelCampaign?: Maybe<Campaign>;
  cancelImport: WoflowImport;
  cancelMenuItemCartPayment: MenuItemCart;
  cancelMessageGroup: MessageGroup;
  cancelStripeConnectPayment: StripeConnectPayment;
  cancelTextMessageGroup: TextMessageGroup;
  captureMenuItemCartPayment: MenuItemCart;
  captureSelfSignUpLead: Scalars['Boolean']['output'];
  captureStripeConnectPayment: StripeConnectPayment;
  changeStatusOrderingOffer: OrderingOffer;
  changeStatusUpsellCampaign: UpsellCampaign;
  chargeFailedBillingInvoices: Array<Scalars['String']['output']>;
  checkPhoneVerification: Session;
  clearAllRestaurantOpenCarts: Restaurant;
  clearRestaurantCache: Restaurant;
  cloneMenuItemCartSelectedMenuItemV2: MenuItemCart;
  cloneMenuItemCartV2: CloneMenuItemCartReturn;
  /** @deprecated Use close_menu_item_cart_v2 instead */
  closeMenuItemCart: MenuItemCart;
  closeMenuItemCartV2: MenuItemCart;
  compareAimPlaygroundEvaluationSets: AimContentEvaluationComparison;
  completeGoogleMyBusinessVerification: RestaurantLocation;
  completeLocationPurchase: AddonCheckoutLocationPurchase;
  completePushMfaEnrollment: Session;
  /** Complete a task action */
  completeTaskAction?: Maybe<RootTaskAction>;
  completeWoflowImportMenuQa: WoflowImportMenu;
  confirmMenuUpload: MenuProcessingResult;
  /** Confirm pending email change with access code */
  confirmPendingEmailByAccessCode?: Maybe<User>;
  confirmSessionAuthy: Session;
  confirmSessionTotp: Session;
  confirmTotpSetup: Session;
  /** Connects a Hungrrr Pay Stripe account to a location */
  connectHungrrrPayAccount?: Maybe<HungrrrPayPreflightResult>;
  connectRestaurantEcardAccount?: Maybe<EcardAccount>;
  connectRestaurantLocationAlohaSite: RestaurantLocation;
  connectRestaurantLocationMicrosRvc: RestaurantLocation;
  connectRestaurantLocationNcrSilverStore: RestaurantLocation;
  connectSalesforceAccount: Scalars['Boolean']['output'];
  copyAllCustomResponses: ChatBotCoreCopyIntent;
  copyCategoryCustomResponses: ChatBotCoreCopyIntent;
  /** Copy a custom page */
  copyCustomPage?: Maybe<CustomPage>;
  /** Copy a draft custom page */
  copyCustomPageDraft?: Maybe<CustomPageDraft>;
  /** copy a draft custom page section */
  copyCustomPageSectionDraft?: Maybe<CustomPageSectionDraft>;
  copyMenu: Menu;
  copyMessageGroup: MessageGroup;
  copySyncedMenu: Menu;
  createAccount: Scalars['Boolean']['output'];
  /** Submit a advanced form response */
  createAdvancedFormEntry?: Maybe<Scalars['Boolean']['output']>;
  createAgentChat: AgentChat;
  createAgentChatMessage: AgentChat;
  createAimPromptConfig: AimPromptConfig;
  createAlohaAccount: AlohaAccount;
  /** Create an announcement */
  createAnnouncement: Announcement;
  createAuthorizeAccount: Restaurant;
  createAuthorizePaymentPageToken: Scalars['String']['output'];
  createBillingBankAccount: BillingBankAccount;
  createBillingCoupon: BillingCoupon;
  createBillingCreditCard: BillingCreditCard;
  createBillingEntitlementFeatureFlag: BillingEntitlementFeatureFlag;
  createBillingInvoice: BillingInvoiceReturn;
  createBillingPlan: BillingPlan;
  createBillingProduct: BillingProductReturn;
  createBillingProductPrice: PriceReturn;
  createBlockedTerm: BlockedTerm;
  /** Upload a blog import */
  createBlogImport?: Maybe<BlogImport>;
  /** Create a blog post */
  createBlogPost?: Maybe<BlogPost>;
  /** Create a calendar event */
  createCalendarEvent: CalendarEvent;
  /** Get a new chatbot settion id */
  createChatbotSession: ChatbotSession;
  createCloverAccount: CloverAccount;
  createConsumerUser: User;
  /** Signs up a user by phone number */
  createConsumerUserByPhone: User;
  createCustomFee: CustomFee;
  /** Submit a custom form response */
  createCustomFormEntry?: Maybe<Scalars['Boolean']['output']>;
  /** Create a Custom Image */
  createCustomImage?: Maybe<CustomImage>;
  /** Create a custom page */
  createCustomPage?: Maybe<CustomPage>;
  /** Create a draft custom page */
  createCustomPageDraft?: Maybe<CustomPageDraft>;
  /** Create a draft custom page with link */
  createCustomPageDraftWithLink?: Maybe<CustomPageDraft>;
  /** Create a custom page section */
  createCustomPageSection?: Maybe<CustomPageSection>;
  /** Create a draft custom page section */
  createCustomPageSectionDraft?: Maybe<CustomPageSectionDraft>;
  createCustomTaxRate: CustomTaxRate;
  createDeliverectChannel: DeliverectChannel;
  /** Populate a demo restaurant with reviews and pops */
  createDemoSiteReviews: Scalars['Boolean']['output'];
  createDish: Dish;
  /** Create a calendar event tag */
  createEventTag: EventTag;
  createFacebookCampaign: FacebookCampaign;
  /** Follow a restaurant */
  createFollower?: Maybe<Follower>;
  /** Export followers */
  createFollowerExport: FollowerExport;
  /** Import followers to restaurant */
  createFollowerImport: FollowerImport;
  /** Create a follower tag */
  createFollowerTag: FollowerTag;
  createGoogleMyBusinessPost?: Maybe<GooglePost>;
  createHeartlandAccount: HeartlandAccount;
  /** Create a new login carousel slide */
  createLoginCarouselSlide?: Maybe<LoginCarouselSlide>;
  /** Create a marketing offer */
  createMarketingOffer: MarketingOffer;
  /** Create a new master message campaign */
  createMasterMessageCampaign?: Maybe<MasterMessageCampaign>;
  createMenu: Menu;
  createMenuExport: Scalars['Boolean']['output'];
  createMenuFeaturedSection: MenuFeaturedSection;
  /** Allows menu team to create menus from import files */
  createMenuFromWoflowImport: Scalars['Boolean']['output'];
  createMenuItem: MenuItem;
  createMenuItemCartDeliveryV2: MenuItemCart;
  createMenuItemCartSelectedMenuItem: MenuItemCart;
  /** Review a menu item */
  createMenuItemReview?: Maybe<Review>;
  createMenuSection: MenuSection;
  createMenuSubsection: MenuSubsection;
  createMessageCampaignEngagementOfferPreview: Scalars['String']['output'];
  createMessageCampaignPreview: Scalars['String']['output'];
  createMessageCampaignTextMessagePreview: Scalars['String']['output'];
  createMessageGroup: MessageGroup;
  createMessageGroupContent: MessageGroupContent;
  createMessageGroupFromTemplate: MessageGroup;
  createMessageGroupPreview: Scalars['String']['output'];
  createMicrosOrg: MicrosOrg;
  /** Create a modifier group */
  createModifierGroup: ModifierGroup;
  createNcrPaymentAccount: NcrPaymentAccount;
  createNcrSilverAccount: NcrSilverAccount;
  createNmiAccount: NmiAccount;
  /** Create an oauth application */
  createOauthApplication: OauthApplication;
  createOauthIntegration: Scalars['JSON']['output'];
  /** Create an offer */
  createOffer: Offer;
  createOrUpdateHighlight?: Maybe<Highlight>;
  createOrUpdateHighlightReel?: Maybe<HighlightReel>;
  createOrUpdateLoyaltyProgramPromotion: PopmenuLoyaltyProgram;
  createOrUpdateMenuSectionHighlightReviews: MenuHighlightSection;
  createOrUpdatePopmenuLoyaltyAccount: User;
  createOrUpdatePopmenuLoyaltyProgram: Restaurant;
  /** Creates or updates a Popmenu review reply */
  createOrUpdateReviewReply: ReviewReply;
  createOrUpdateRewardTiers: PopmenuLoyaltyProgram;
  createOrderingBlackout: OrderingBlackout;
  createOrderingEvent: OrderingEvent;
  createOrderingOffer: OrderingOffer;
  /** Create an ordering report export for a restaurant */
  createOrderingReportExport: Scalars['Boolean']['output'];
  createOrderingUser: User;
  createParty: Party;
  /** Send password reminder */
  createPasswordReset?: Maybe<Scalars['Boolean']['output']>;
  createPhoneVerification: TwilioVerifyMfaFactor;
  createPreviewFromTemplate: Scalars['String']['output'];
  createPrintLayout: PrintLayout;
  createPushChallenge: Session;
  createPushMessageGroup: PushMessageGroup;
  createPushMfaEnrollmentAccessToken: PushMfaEnrollmentAccessToken;
  createQrCard: RestaurantQrCard;
  createResellerSignUpSurvey: Scalars['Boolean']['output'];
  /** Create a new restaurant */
  createRestaurant: Restaurant;
  createRestaurantActionBarLinkDraft: Restaurant;
  createRestaurantCustomRedirect?: Maybe<RestaurantCustomRedirect>;
  createRestaurantCustomScript: Restaurant;
  createRestaurantCustomTracking: Restaurant;
  createRestaurantDishTag: RestaurantDishTag;
  /** Create an embed */
  createRestaurantEmbed: RestaurantEmbed;
  createRestaurantFollower: Follower;
  createRestaurantFooterLink: RestaurantFooterLink;
  createRestaurantFooterLinkDraft: RestaurantFooterLinkDraft;
  createRestaurantGroup: RestaurantGroup;
  createRestaurantLocation: RestaurantLocation;
  createRestaurantLocationAnsweringSetting: RestaurantLocationAnsweringSetting;
  createRestaurantMemberInvite: RestaurantMemberInvite;
  createRestaurantMenuImport: Restaurant;
  createRestaurantMessagePack: RestaurantMessagePack;
  createRestaurantNavDropdown: RestaurantNavDropdown;
  createRestaurantNavDropdownDraft: RestaurantNavDropdownDraft;
  createRestaurantNavLink: RestaurantNavLink;
  createRestaurantNavLinkDraft: RestaurantNavLinkDraft;
  createRestaurantOnboardingInfoLink: Restaurant;
  createRestaurantOnboardingInfoNote: Restaurant;
  createRestaurantOnboardingWoflowImport: Restaurant;
  createRestaurantScriptDomain: RestaurantScriptDomain;
  createRestaurantWebhook: RestaurantWebhook;
  createReviewReply: ReviewReply;
  /** Create a root  announcement */
  createRootAnnouncement: RootAnnouncement;
  createRootDishTag: CreateRootDishTagReturn;
  createRootGroup: RootGroup;
  createRootGroupMember: RootGroupMember;
  createRootMessagePack: RootMessagePack;
  createRootMessagePackMessage: RootMessagePackMessage;
  createRootMessagePackSocialPost: RootMessagePackSocialPost;
  createRootNote: RootNote;
  createRootSectionTemplate: RootSectionTemplate;
  createRootSectionType: RootSectionType;
  createRootSiteTemplate: RootSiteTemplate;
  createRootTask: RootTask;
  createRootTheme: RootTheme;
  createRootThemeTemplate: RootThemeTemplate;
  createRootUser: User;
  createSalesDemoRestaurant: Scalars['Int']['output'];
  createSelfAddParty: Party;
  /** Create a social account */
  createSocialAccount?: Maybe<SocialAccount>;
  createSocialPost: SocialPost;
  createSquareSellerAccount: SquareSellerAccount;
  createStripeConnectAccount: StripeConnectAccount;
  createSuggestedDish: SuggestedDish;
  /** Creates the TableTop */
  createTableTop: RestaurantLocationTableTop;
  createTextMessageGroup: TextMessageGroup;
  createTextMessageGroupMessagePreview: MessagePreview;
  createTextMessageGroupPreview: Preview;
  createThemeFont: ThemeFont;
  createToastHostedCheckoutSession: ToastHostedCheckoutSession;
  createTwilioBannedWord: TwilioBannedWords;
  createTwilioPhoneCall: TwilioPhoneCall;
  createTwilioPhoneNumber: TwilioPhoneNumber;
  createUpload: Uploadable;
  /** Creates the upload folder */
  createUploadFolder: UploadableFolder;
  createUpsellCampaign: UpsellCampaign;
  /** Create a user and generate session token */
  createUser?: Maybe<Session>;
  createUserApiToken: UserApiToken;
  /** Create a simple user and generate session token */
  createUserWithoutPassword?: Maybe<Session>;
  customResponseExport: Scalars['Boolean']['output'];
  deleteMyFollowerAccount: Scalars['Boolean']['output'];
  deleteMyUserAccount: Scalars['Boolean']['output'];
  /** Remove an email from the bounce and spam reports list in send grid */
  deleteSelectedEmailFromBounceAndSpamList: DeleteSelectedEmailFromBounceAndSpamList;
  deleteSuggestedDish: SuggestedDish;
  /** Deletes the TableTop */
  deleteTableTop: Array<RestaurantLocationTableTop>;
  demoOrdernerdRestaurantLocation: Scalars['Boolean']['output'];
  /** Calls the demote service for root users */
  demoteRootUser: User;
  deregisterDevice: UserDevice;
  destroyAllDishes: Restaurant;
  destroyAllFollowerImports: Scalars['Boolean']['output'];
  /** Destroy a follower tag */
  destroyAllFollowerTags: Restaurant;
  destroyAllFollowers: Restaurant;
  destroyAllModifierGroups: Scalars['Boolean']['output'];
  destroyAllSquareSyncedMenus: Restaurant;
  /** Destroy an announcement */
  destroyAnnouncement: Restaurant;
  destroyBillingBankAccount: Array<BillingBankAccount>;
  destroyBillingCreditCard: Array<BillingCreditCard>;
  destroyBillingEntitlementFeatureFlag: Scalars['Boolean']['output'];
  destroyBillingSubscription: Restaurant;
  /** Destroy a root blocked term */
  destroyBlockedTerm: Scalars['Boolean']['output'];
  /** Destroy a blog post */
  destroyBlogPost?: Maybe<Restaurant>;
  /** Destroy a calendar event */
  destroyCalendarEvent: Restaurant;
  destroyCampaignItem?: Maybe<CampaignItem>;
  destroyCustomFee: Scalars['Boolean']['output'];
  /** Destroy a custom file */
  destroyCustomFile?: Maybe<CustomFile>;
  /** Destroy a custom page */
  destroyCustomPage?: Maybe<Restaurant>;
  /** Destroy a draft custom page */
  destroyCustomPageDraft?: Maybe<Restaurant>;
  /** Destroy a custom page section */
  destroyCustomPageSection?: Maybe<CustomPage>;
  /** Destroy a draft custom page section */
  destroyCustomPageSectionDraft?: Maybe<CustomPageDraft>;
  destroyCustomTaxRate: Restaurant;
  destroyDeliverectChannel: DeliverectChannel;
  destroyDish: Restaurant;
  /** Destroy a calendar event tag */
  destroyEventTag: Restaurant;
  /** Stop following a restaurant */
  destroyFollower?: Maybe<User>;
  destroyFollowerImport: Scalars['Boolean']['output'];
  /** Destroy a follower tag */
  destroyFollowerTag: Restaurant;
  destroyGoogleMyBusinessPost?: Maybe<GooglePost>;
  destroyHighlight: Scalars['Boolean']['output'];
  destroyHighlightReel: Scalars['Boolean']['output'];
  destroyInstagramPublishedSocialPost: SocialPost;
  /** Allows menu team to destroy large menus with async job */
  destroyLargeMenu: Scalars['Boolean']['output'];
  destroyLastFollowerImport: Restaurant;
  /** Destroy a login carousel slide */
  destroyLoginCarouselSlide?: Maybe<Scalars['Boolean']['output']>;
  /** Destroy a marketing offer */
  destroyMarketingOffer?: Maybe<Restaurant>;
  /** Destroy a master message campaign */
  destroyMasterMessageCampaign?: Maybe<Scalars['Boolean']['output']>;
  destroyMenu: Restaurant;
  destroyMenuFeaturedSection: Menu;
  destroyMenuHighlightSection: Scalars['Boolean']['output'];
  destroyMenuItem: Menu;
  destroyMenuItemCartSelectedMenuItem: MenuItemCart;
  destroyMenuItemCartSelectedMenuItems: MenuItemCart;
  /** Destroy a menu item modifier group */
  destroyMenuItemModifierGroup: MenuItem;
  /** Undo a menu item pop */
  destroyMenuItemPop?: Maybe<DestroyPopReturn>;
  destroyMenuSection: Menu;
  destroyMenuSubsection: Menu;
  destroyMessageGroupContent: MessageGroup;
  destroyMessageGroupDraft: Restaurant;
  /** Destroy a modifier group */
  destroyModifierGroup: Restaurant;
  /** Destroy a modifier group modifier modifier group */
  destroyNestedMenuItemModifierGroup: MenuItemModifierGroupModifier;
  /** Destroy an offer */
  destroyOffer: Restaurant;
  destroyOrderingBlackout: RestaurantLocation;
  destroyOrderingEvent: Restaurant;
  destroyOrderingOffer: Restaurant;
  destroyOrphanDishes: Restaurant;
  destroyParty: Party;
  destroyPrintLayout: Restaurant;
  destroyPublishedSocialPost: SocialPost;
  destroyPushMessageGroup: Restaurant;
  destroyRestaurantActionBarLinkDraft: Restaurant;
  destroyRestaurantCustomRedirect?: Maybe<Restaurant>;
  destroyRestaurantCustomScript: Restaurant;
  destroyRestaurantCustomTracking: Restaurant;
  destroyRestaurantDetectedCookie: Restaurant;
  destroyRestaurantDishTag: RestaurantDishTag;
  /** Destroy an embed */
  destroyRestaurantEmbed: Restaurant;
  destroyRestaurantFooterLink: Restaurant;
  destroyRestaurantFooterLinkDraft: Restaurant;
  destroyRestaurantGroup: Scalars['Boolean']['output'];
  destroyRestaurantLocation: Restaurant;
  destroyRestaurantMember: Restaurant;
  destroyRestaurantMemberInvite: Restaurant;
  destroyRestaurantMessagePackCommunication: Scalars['Boolean']['output'];
  destroyRestaurantMobileAppAsset: Scalars['Boolean']['output'];
  destroyRestaurantNavDropdown: Restaurant;
  destroyRestaurantNavDropdownDraft: Restaurant;
  destroyRestaurantNavLink: Restaurant;
  destroyRestaurantNavLinkDraft: Restaurant;
  destroyRestaurantOnboardingInfoLink: Restaurant;
  destroyRestaurantOnboardingInfoUploadedFont: Restaurant;
  destroyRestaurantOnboardingWoflowImportMenus: WoflowImport;
  destroyRestaurantPaymentAccount: Restaurant;
  destroyRestaurantScriptDomain: Restaurant;
  destroyRestaurantWebhook: Restaurant;
  destroyRewardTier: PopmenuLoyaltyProgram;
  /** Destroy a root announcement */
  destroyRootAnnouncement: Scalars['Boolean']['output'];
  destroyRootGroup: Scalars['Boolean']['output'];
  destroyRootGroupMember: RootGroup;
  destroyRootMessagePack: Scalars['Boolean']['output'];
  destroyRootMessagePackCommunication: RootMessagePack;
  destroyRootNote: Restaurant;
  destroyRootSectionType: Scalars['Boolean']['output'];
  destroySelectedUploads: Scalars['Boolean']['output'];
  /** Revoke session token */
  destroySession?: Maybe<Session>;
  /** Destroy a social account */
  destroySocialAccount?: Maybe<Restaurant>;
  destroySocialPost: Restaurant;
  /** Destroys the selected staged record */
  destroyStagedRecord: LiveDomainStagedRecord;
  destroyTextMessageGroup: Restaurant;
  destroyThemeFont: Restaurant;
  destroyTwilioPhoneCall: TwilioPhoneCall;
  destroyUpload: Uploadable;
  /** Destroys the selected upload folders */
  destroyUploadFolder: Scalars['Boolean']['output'];
  destroyUpsellCampaign: Scalars['Boolean']['output'];
  destroyUserApiToken: Restaurant;
  destroyYextMenu?: Maybe<Scalars['Boolean']['output']>;
  destroyYextMenus?: Maybe<Scalars['Boolean']['output']>;
  /** Removes ordering offer from message campaign */
  detachMessageCampaignOrderingOffer?: Maybe<OrderingOffer>;
  dineInQrCard: RestaurantQrCard;
  /** Disables an advanced form */
  disableAdvancedForm?: Maybe<Scalars['Boolean']['output']>;
  disconnectAllLocationsSalesforceAccount?: Maybe<Array<SalesforceAccount>>;
  disconnectRestaurantEcardAccount?: Maybe<EcardAccount>;
  disconnectRestaurantLocationAlohaSite: RestaurantLocation;
  disconnectRestaurantLocationHeartlandPosLocation: RestaurantLocation;
  disconnectRestaurantLocationMicrosRvc: RestaurantLocation;
  disconnectRestaurantLocationNcrSilverStore: RestaurantLocation;
  /** Disconnects all connected payment accounts (Stripe, Authorize, Everyware, Heartland, NMI) from a restaurant location */
  disconnectRestaurantLocationPaymentAccounts: Scalars['Boolean']['output'];
  disconnectRestaurantLocationSpotonLocation: RestaurantLocation;
  disconnectSalesforceAccount: Scalars['Boolean']['output'];
  dismissFailedFollowerImport: FollowerImport;
  dismissFailedMessageGroup: MessageGroup;
  dismissFailedPosts: SocialPost;
  dismissFailedTextMessageGroup: TextMessageGroup;
  dismissFollowerMassActionNotifications: Scalars['Boolean']['output'];
  dismissNotice: RestaurantNotice;
  dismissReviewBanner: RestaurantMember;
  dismissSocialPostFailureIndicators: SocialPost;
  dismissSuggestedPosts: SocialPostSuggestion;
  /** Dismiss a task action */
  dismissTaskAction?: Maybe<RootTaskAction>;
  earnLoyaltyProgramPromotionPoints: LoyaltyProgramAccount;
  /** Edits the TableTop */
  editTableTop: RestaurantLocationTableTop;
  enableUserAuthy: Session;
  enableUserTotp: TwilioVerifyFactorSecret;
  enqueueLighthouseReport: Restaurant;
  estimateAddon: ChargebeeEstimate;
  evaluateAiMarketingContent: AiMarketingContentEvaluationResult;
  /** Exports all forms for a given restaurant */
  exportAllForms?: Maybe<Scalars['Boolean']['output']>;
  exportOrderingEvent: Scalars['Boolean']['output'];
  exportOrders: Scalars['Boolean']['output'];
  exportOverview: Scalars['Boolean']['output'];
  exportReservations: Scalars['Boolean']['output'];
  exportSelectedUploads: Scalars['Boolean']['output'];
  /** Exports a single form for a given advanced form */
  exportSingleForm?: Maybe<Scalars['Boolean']['output']>;
  /** Fetches Foodtec gift card balance from API */
  fetchCustomPageSectionFoodtecBalance?: Maybe<Scalars['String']['output']>;
  findOrCreateStubUser?: Maybe<FollowerFlow>;
  followerMassAction: MassAction;
  followerSignInQrCard: RestaurantQrCard;
  /** Forces sign out for a list of users by invalidating their sessions */
  forceSignOutUsers?: Maybe<Array<User>>;
  forceSyncMasterMenu: Menu;
  generateAiMarketingExampleContentResponse: AiMarketingContentExampleContentResponse;
  generateAiMarketingPrompt: AiMarketingContentPrompt;
  generateAiResponse?: Maybe<ReviewGeneratedAiResponseType>;
  generateAiText?: Maybe<SocialPostGeneratedAiText>;
  generateCampaignContent: Restaurant;
  generateMessageGroupAiText?: Maybe<MessageGroupGeneratedAiText>;
  generateRestaurantContent: AiMarketingGenerateContentReturn;
  generateTextMessageGroupAiText?: Maybe<TextMessageGroupGeneratedAiText>;
  generateYourToneSample: Scalars['String']['output'];
  gradeAimPlaygroundEvaluationSet: AimContentEvaluationBatch;
  /** Sets impersonated_user_id session variable to impersonate a user */
  impersonateUser?: Maybe<Scalars['Boolean']['output']>;
  initializeChannel: InitializedChannel;
  initiateMenuProcessing: InitiateResponse;
  invalidateGiftCard: GiftCard;
  leaveWaitlist: Scalars['Boolean']['output'];
  linkGoogleMyBusinessLocation?: Maybe<RestaurantLocation>;
  markAsReviewed: ChatBotCoreIntentCustomResponse;
  /** Mark a menu item cart issue as seen (acknowledged or after viewing order details). */
  markMenuItemCartIssueSeen: MenuItemCart;
  /** Mark selected menu item out of stock */
  markMenuItemCartSelectedMenuItemOutOfStock: Scalars['Boolean']['output'];
  markTaskActionsRead: Array<RootTaskAction>;
  mergeDish: Dish;
  moveSelectedUploads: Scalars['Boolean']['output'];
  /** Pause external integration */
  pauseExternalIntegration: ExternalIntegration;
  preparePhoneRegistration: Session;
  /** Previews whether a Hungrrr Pay Stripe account can be connected to a location */
  previewHungrrrPayConnection?: Maybe<HungrrrPayPreflightResult>;
  promoteAimPromptConfigToDefault: AimPromptConfig;
  promoteMenu: Menu;
  publishBillingSubscription: BillingSubscription;
  publishCustomPageDrafts?: Maybe<Restaurant>;
  publishGoogleMyBusinessLocation: GoogleMyBusinessLocation;
  publishLiveDomain: LiveDomain;
  /** Recover a submitted ticket cart before checkout */
  recoverTicketCartForCheckout: CalendarEventTicketCart;
  /** Redeem an offer code */
  redeemOfferCode?: Maybe<OfferCode>;
  redoDraftChanges: CustomPageDraft;
  /** Refresh the applied ecard balance for a cart. */
  refreshEcardBalance?: Maybe<MenuItemCart>;
  refreshMessageGroupAiText?: Maybe<MessageGroupGeneratedAiText>;
  refreshRestaurantMemberInvite: RestaurantMemberInvite;
  refreshSocialPostAiText?: Maybe<SocialPostGeneratedAiText>;
  refreshTextMessageGroupAiText?: Maybe<TextMessageGroupGeneratedAiText>;
  refundMenuItemCartGiftCardPayment: MenuItemCart;
  refundMenuItemCartPayment: MenuItemCart;
  regenerateRestaurantWebhookToken: RegenerateRestaurantWebhookTokenReturn;
  /** Release a flagged content audit by ID and channel */
  releaseContentAudit: Scalars['JSON']['output'];
  removeAppliedReward: MenuItemCart;
  /** Remove Featured Item */
  removeFeaturedItemDraft?: Maybe<CustomPageSectionDraft>;
  removeGiftCard: MenuItemCart;
  removeMenuItemFromFeaturedSection: MenuFeaturedSection;
  removeOrderingOfferCode: MenuItemCart;
  removeRestaurantDomain: Restaurant;
  removeRestaurantFromGroup: RestaurantGroup;
  removeSourceFromPendingImport: WoflowImport;
  /** Reconnect a social account */
  renewSocialAccount?: Maybe<SocialAccount>;
  requestCheckoutSalesAssistance: Scalars['Boolean']['output'];
  requestRestaurantLocationOrdernerdToken: Scalars['Boolean']['output'];
  resendGiftCard: GiftCard;
  resetMyMfa: User;
  resetRestaurantMemberMfa: RestaurantMember;
  /** Updates the alert dismissed_at columns on the member_location */
  restaurantMemberLocationAlertDismissed: RestaurantMemberLocation;
  /** Restores a disabled advanced form */
  restoreAdvancedForm?: Maybe<Scalars['Boolean']['output']>;
  retryFailedFollowerImport: FollowerImport;
  retrySocialPost: SocialPost;
  runAimFeatureEvaluation: AimPromptConfig;
  runRestaurantLocationOrderingBillingConfigProcess?: Maybe<RunProcessPayload>;
  salesforceMigrationConnectAccountToLocation: SalesforceMigrationResult;
  salesforceMigrationDisconnectAccountFromLocation: SalesforceMigrationResult;
  saveTwilioBusinessRegistration: TwilioBusinessRegistration;
  selectIndieBillingPlan: BillingPlan;
  sendMeLinkMessage: Scalars['Boolean']['output'];
  sendMessageCampaignPreview: Scalars['Boolean']['output'];
  sendMessageCampaignTextMessagePreview?: Maybe<Scalars['Boolean']['output']>;
  sendMessageGroupPreview: Scalars['Boolean']['output'];
  /** Send access code to current user pending email */
  sendPendingEmailAccessCode?: Maybe<Scalars['Boolean']['output']>;
  sendPhoneVerification: TwilioVerifyMfaFactor;
  sendTextMessageGroupPreview: Scalars['Boolean']['output'];
  /** Send access code email */
  sendUserAccessCodeEmail?: Maybe<Scalars['Boolean']['output']>;
  sendUserAuthyCode: Scalars['Boolean']['output'];
  /** Email login link */
  sendUserAutoLoginEmail?: Maybe<Scalars['Boolean']['output']>;
  /** Text user access code */
  sendUserSmsAccessCode?: Maybe<Scalars['Boolean']['output']>;
  setRestaurantPrimaryDomain: Restaurant;
  /** Authenticate a user */
  signInUser?: Maybe<Session>;
  /** Login from access code */
  signInUserByAccessCode?: Maybe<Session>;
  skipMfaPhoneFactor: Session;
  startBillingSubscription?: Maybe<Restaurant>;
  startPushMfaEnrollment: Session;
  startSignUp: StartModularSignUpPayload;
  startTrial: StartTrialPayload;
  startWaitlistTrial: StartWaitlistTrialPayload;
  submitCampaign?: Maybe<Campaign>;
  submitCcpaRequest: Scalars['Boolean']['output'];
  submitMenuItemCart: MenuItemCart;
  submitPendingImport: Scalars['Boolean']['output'];
  submitShopItemCart: ShopItemCart;
  syncAlohaAccount: AlohaAccount;
  syncAlohaMenuFromProvider: Scalars['Boolean']['output'];
  syncBillingCustomerPaymentMethods: BillingCustomer;
  syncCloverAccount: CloverAccount;
  syncCloverMenuFromProvider: Scalars['Boolean']['output'];
  syncHeartlandPos: HeartlandPosRoot;
  syncMenuForExternalIntegration: Scalars['Boolean']['output'];
  syncMenuFromProvider: Scalars['Boolean']['output'];
  syncMenuItemCartPaymentV2: MenuItemCart;
  syncMicrosOrg: MicrosOrg;
  syncNcrSilverAccount: NcrSilverAccount;
  syncRestaurantSalesforceAccount?: Maybe<SalesforceAccount>;
  syncReviews?: Maybe<Scalars['Boolean']['output']>;
  syncSandboxLocations?: Maybe<Scalars['Boolean']['output']>;
  syncSpoton: SpotonRoot;
  syncSquareSellerAccount: SquareSellerAccount;
  syncSquareSellerAccountCatalog: SquareSellerAccount;
  syncSquareSellerAccountLocations: Array<SquareSellerLocation>;
  syncStripeConnectAccount: StripeConnectAccount;
  syncStripeConnectPayment: StripeConnectPayment;
  syncToastRestaurant: RestaurantLocation;
  syncToastRestaurantsBasicData: Scalars['Boolean']['output'];
  syncYextMenu?: Maybe<Scalars['Boolean']['output']>;
  syncYextMenus?: Maybe<Scalars['Boolean']['output']>;
  /** Toggle announcement featured */
  toggleFeaturedAnnouncement: Announcement;
  toggleFeaturedDish: Dish;
  toggleMenuItem: MenuItem;
  /** Pause external integration */
  toggleMenuSyncing: ExternalIntegration;
  /** Toggle a message campaign */
  toggleMessageCampaign?: Maybe<MessageCampaign>;
  toggleMessageCampaignSelectedLocation: MessageCampaignSelectedLocation;
  togglePopmenuLoyalty: RestaurantFeatureSetting;
  toggleReviewVote?: Maybe<ToggleReviewVoteReturn>;
  toggleThirdPartyLoyalty: RestaurantFeatureSetting;
  transferReview?: Maybe<TransferReviewReturn>;
  triggerRestaurantAppDeployment: Scalars['Boolean']['output'];
  triggerRestaurantDetectedCookieGeneration: Scalars['Boolean']['output'];
  undoDraftChanges: CustomPageDraft;
  unlinkGoogleMyBusinessLocation?: Maybe<RestaurantLocation>;
  /** Unsubscribes users from all email and SMS marketing across all locations */
  unsubscribeUsersFromAllMarketing?: Maybe<UnsubscribeUsersFromAllMarketingResponse>;
  updateAction: RootTaskAction;
  updateAddon?: Maybe<Scalars['Boolean']['output']>;
  /** Update a advanced form entry */
  updateAdvancedFormEntry?: Maybe<AdvancedFormEntry>;
  updateAiMarketingContent: AiMarketingContent;
  updateAiMarketingDefaultOption: AiMarketingDefaultOption;
  updateAiReviewResponseDefaultSetting: AiReviewResponseDefaultSetting;
  updateAimPromptConfig: AimPromptConfig;
  updateAlohaAccount: AlohaAccount;
  /** Update an announcement */
  updateAnnouncement: Announcement;
  updateAnsweringLocation: RestaurantMemberLocation;
  updateBillingBankAccount: BillingBankAccount;
  updateBillingCoupon: BillingCoupon;
  updateBillingCreditCard: BillingCreditCard;
  updateBillingEntitlementFeatureFlag: BillingEntitlementFeatureFlag;
  updateBillingPlan: BillingPlan;
  updateBillingProduct: BillingProductReturn;
  updateBillingProductPrice: PriceReturn;
  updateBlockedTerm: BlockedTerm;
  /** Update a blog post */
  updateBlogPost?: Maybe<BlogPost>;
  /** Update a calendar event */
  updateCalendarEvent: CalendarEvent;
  /** Update a calendar event */
  updateCalendarEventPop: CalendarEventPop;
  updateCampaignItemSchedule?: Maybe<CampaignItem>;
  updateCloverAccount: CloverAccount;
  updateCuisineGoogleCategory: CuisineType;
  updateCuisineYextCategory: CuisineType;
  updateCustomFee: CustomFee;
  /** Update a custom file */
  updateCustomFile?: Maybe<CustomFile>;
  /** Update a custom page */
  updateCustomPage?: Maybe<CustomPage>;
  /** Update a draft custom page */
  updateCustomPageDraft?: Maybe<CustomPageDraft>;
  /** Update draft custom page header settings */
  updateCustomPageDraftHeader?: Maybe<CustomPageDraft>;
  updateCustomPageDraftPosition?: Maybe<Restaurant>;
  /** Update custom page header settings */
  updateCustomPageHeader?: Maybe<CustomPage>;
  /** Update a custom page section */
  updateCustomPageSection?: Maybe<CustomPageSection>;
  /** Update a draft custom page section */
  updateCustomPageSectionDraft?: Maybe<CustomPageSectionDraft>;
  /** Update a draft custom page section's nested fields */
  updateCustomPageSectionDraftNestedFields?: Maybe<CustomPageSectionDraft>;
  /** Update a draft custom page section's position */
  updateCustomPageSectionDraftPosition?: Maybe<CustomPageDraft>;
  /** Update a custom page section's nested fields */
  updateCustomPageSectionNestedFields?: Maybe<CustomPageSection>;
  /** Update a custom page section's position */
  updateCustomPageSectionPosition?: Maybe<CustomPage>;
  updateCustomTaxRate: CustomTaxRate;
  updateDish: Dish;
  updateDishAllergens: Dish;
  updateDishInventoryLocation: DishInventoryLocation;
  updateDishPhotos: Dish;
  updateDishWeight: Dish;
  /** Update a calendar event tag */
  updateEventTag: EventTag;
  updateFacebookCampaign: FacebookCampaign;
  /** Update section featured items' positions */
  updateFeaturedItemDraftsPosition?: Maybe<CustomPageSectionDraft>;
  /** Update Featured Item selected review */
  updateFeaturedItemReviewDraft?: Maybe<CustomPageSectionDraft>;
  updateFeaturedSectionItemPositions: MenuFeaturedSection;
  updateFeedback: Feedback;
  updateFeedbackSetting: FeedbackSetting;
  updateFollower?: Maybe<Follower>;
  /** Follow a restaurant */
  updateFollowerBlockedStatus?: Maybe<Follower>;
  /** Follow a restaurant */
  updateFollowerFavoriteLocation?: Maybe<Follower>;
  updateFollowerSegment?: Maybe<RestaurantFollowerSegment>;
  /** Update the selected follower tags for a follower */
  updateFollowerSelectedTags?: Maybe<Follower>;
  /** Update a follower tag */
  updateFollowerTag: FollowerTag;
  updateGoogleAccount: Restaurant;
  updateGoogleMyBusinessAttributes?: Maybe<Restaurant>;
  updateGoogleMyBusinessLocationVisibility: Scalars['Boolean']['output'];
  updateGoogleMyBusinessPost?: Maybe<GooglePost>;
  updateHeartlandPosSetting: RestaurantLocation;
  updateHighlightPositions?: Maybe<HighlightReel>;
  updateItemModifierPositions?: Maybe<MenuItemModifierGroup>;
  updateLiveDomain: LiveDomain;
  updateLocationNcrSilverChargeOptions: RestaurantLocationNcrSilverStoreSetting;
  updateLocationToastAlternativePaymentType: RestaurantLocationToastSetting;
  updateLocationToastDiningOptions: RestaurantLocationToastSetting;
  updateLocationToastRevenueCenters: RestaurantLocationToastSetting;
  /** Update a login carousel slide */
  updateLoginCarouselSlide?: Maybe<LoginCarouselSlide>;
  /** Update a marketing offer */
  updateMarketingOffer: Restaurant;
  /** Update a master message campaign */
  updateMasterMessageCampaign?: Maybe<MasterMessageCampaign>;
  updateMemberOnboardingCompleted: RestaurantMember;
  updateMenu: Menu;
  updateMenuFeaturedSection: MenuFeaturedSection;
  updateMenuHighlightSection: MenuHighlightSection;
  updateMenuHighlightSectionPositions: Menu;
  updateMenuIgnoredIntegrations: Menu;
  updateMenuItem: MenuItem;
  updateMenuItemCart: MenuItemCart;
  updateMenuItemCartAcknowledge: MenuItemCart;
  updateMenuItemCartArrival: MenuItemCart;
  updateMenuItemCartSelectedMenuItem: MenuItemCart;
  updateMenuItemCartSelectedMenuItemIsVoid: MenuItemCart;
  updateMenuItemCartStatus: MenuItemCart;
  updateMenuItemCartSubcartStatus: MenuItemCart;
  /** Updates the menu item cart unviewedAt field */
  updateMenuItemCartViewedAt: MenuItemCart;
  updateMenuItemCateringLimits: MenuItem;
  updateMenuItemContainsAlcohol: MenuItem;
  updateMenuItemModGroupsPositions?: Maybe<MenuItem>;
  /** Update modifiers on a menu item modifier group or nested modifier group */
  updateMenuItemModifierGroupModifier?: Maybe<MenuItemModifierGroup>;
  updateMenuItemOutOfStock: MenuItem;
  /** Pop a menu item */
  updateMenuItemPop?: Maybe<Pop>;
  /** Review a menu item */
  updateMenuItemReview?: Maybe<Review>;
  updateMenuItemSubsection: Array<MenuSubsection>;
  updateMenuSection: MenuSection;
  updateMenuSectionPositions: Menu;
  updateMenuSubsection: MenuSubsection;
  updateMenuSubsectionCustomHtml: MenuSubsection;
  updateMenuSubsectionItemPositions: MenuSubsection;
  updateMenuUpload: Restaurant;
  /** Update a message campaign */
  updateMessageCampaign?: Maybe<UpdateMessageCampaignReturn>;
  updateMessageCampaignCreateAndAttachOrderingOffer?: Maybe<OrderingOffer>;
  updateMessageCampaignSelectedLocation: MessageCampaignSelectedLocation;
  updateMessageGroup: MessageGroupReturn;
  updateMessageGroupContent: MessageGroupContent;
  updateMicrosOrg: MicrosOrg;
  /** Update a modifier group */
  updateModifierGroup: ModifierGroup;
  updateModularSignUpProgress: ModularSignUpProgress;
  updateNavLinkStatus: RestaurantNavLinkDraft;
  updateNcrPaymentAccount: NcrPaymentAccount;
  /** Update onboarding info */
  updateNewOnboardingInfo: RestaurantOnboardingInfo;
  /** Update onboarding info links */
  updateNewOnboardingInfoLinks: RestaurantOnboardingInfo;
  /** Update an offer */
  updateOffer: Offer;
  updateOpentableModifiers: Menu;
  updateOrCreateIntentCustomResponse: ChatBotCoreIntentCustomResponse;
  updateOrderingBlackout: OrderingBlackout;
  updateOrderingEvent: OrderingEvent;
  updateOrderingEventSelectedMenu: OrderingEventSelectedMenu;
  updateOrderingOffer: OrderingOffer;
  updateParty: Party;
  updatePartySettings: PartySettings;
  updatePhotos: Array<Uploadable>;
  updatePhotosAimAvailable: Array<Uploadable>;
  updatePopmenuLoyaltyProgramRule: PopmenuLoyaltyProgram;
  updatePrintLayout: PrintLayout;
  updatePushMessageGroup: PushMessageGroup;
  /** Updates the push notification clickedAt field */
  updatePushNotificationClickedAt: Scalars['Boolean']['output'];
  updateReservationBlackouts: RestaurantLocation;
  updateRestaurant: Restaurant;
  updateRestaurantActionBar: RestaurantActionBar;
  updateRestaurantActionBarDraft: RestaurantActionBarDraft;
  updateRestaurantActionBarLinkDrafts: Restaurant;
  updateRestaurantAdvanced: Restaurant;
  updateRestaurantBlogSettings: Restaurant;
  updateRestaurantConciergeGoal: RestaurantConciergeGoal;
  updateRestaurantConsentManagerConfig: RestaurantConsentManagerConfig;
  updateRestaurantCustomRedirect?: Maybe<RestaurantCustomRedirect>;
  updateRestaurantCustomScript: Restaurant;
  updateRestaurantCustomTracking: Restaurant;
  /** Sets the default fulfillment type for a restaurant */
  updateRestaurantDefaultFulfillmentType: Restaurant;
  updateRestaurantDishTag: RestaurantDishTag;
  /** Update an embed */
  updateRestaurantEmbed: RestaurantEmbed;
  updateRestaurantFeatureSetting: Restaurant;
  updateRestaurantFollower: Follower;
  updateRestaurantFooterItemDrafts: Restaurant;
  updateRestaurantFooterItems: Restaurant;
  updateRestaurantFooterLink: RestaurantFooterLink;
  updateRestaurantFooterLinkDraft: RestaurantFooterLinkDraft;
  updateRestaurantFooterSettings: Restaurant;
  updateRestaurantFromGmb: Restaurant;
  updateRestaurantGiftCardPurchasingStatus: Restaurant;
  updateRestaurantGroup: RestaurantGroup;
  updateRestaurantHosting: Restaurant;
  updateRestaurantIndieOnboardingInfo: Restaurant;
  updateRestaurantLegalDocument: RestaurantLegalDocument;
  updateRestaurantLocation: RestaurantLocation;
  updateRestaurantLocationAlohaSiteSetting: RestaurantLocationAlohaSiteSetting;
  updateRestaurantLocationAnsweringSetting: RestaurantLocationAnsweringSetting;
  updateRestaurantLocationAuthorizeAccount: Scalars['Boolean']['output'];
  updateRestaurantLocationCloverAccount: RestaurantLocation;
  updateRestaurantLocationEverywareAccount: Scalars['Boolean']['output'];
  updateRestaurantLocationExternalIntegrationsSettings: RestaurantLocation;
  updateRestaurantLocationFromGmb: Restaurant;
  updateRestaurantLocationHeartlandAccount: Scalars['Boolean']['output'];
  updateRestaurantLocationMenuPositions: RestaurantLocation;
  updateRestaurantLocationMicrosSetting: RestaurantLocation;
  updateRestaurantLocationNcrSilverStoreSetting: RestaurantLocationNcrSilverStoreSetting;
  updateRestaurantLocationNmiAccount: Scalars['Boolean']['output'];
  updateRestaurantLocationOrderingDelay?: Maybe<Restaurant>;
  updateRestaurantLocationOrderingMenus: RestaurantLocation;
  updateRestaurantLocationOrderingPayment: RestaurantLocation;
  updateRestaurantLocationPosition?: Maybe<Restaurant>;
  updateRestaurantLocationSocialHandles: RestaurantLocation;
  updateRestaurantLocationSquareLocation: RestaurantLocation;
  updateRestaurantLocationStripeAccount: RestaurantLocation;
  updateRestaurantLocationToastRestaurant: RestaurantLocation;
  updateRestaurantLocationToastSetting: RestaurantLocation;
  updateRestaurantLogos: Restaurant;
  updateRestaurantMember: RestaurantMember;
  updateRestaurantMemberDismissEngagementOffers: RestaurantMember;
  updateRestaurantMemberDismissEngagementOffersBanner: RestaurantMember;
  updateRestaurantMemberInvite: RestaurantMemberInvite;
  /** Updates ordering notifications for single member_location */
  updateRestaurantMemberLocationOrderNotifications: RestaurantMemberLocation;
  updateRestaurantMemberNotifications: RestaurantMember;
  updateRestaurantMemberOnboarding: User;
  updateRestaurantMessagePack: RestaurantMessagePack;
  updateRestaurantNavDropdown: RestaurantNavDropdown;
  updateRestaurantNavDropdownDraft: RestaurantNavDropdownDraft;
  updateRestaurantNavDropdownDraftNavLinks: RestaurantNavDropdownDraft;
  updateRestaurantNavDropdownNavLinks: RestaurantNavDropdown;
  updateRestaurantNavItemDrafts: Restaurant;
  updateRestaurantNavItems: Restaurant;
  updateRestaurantNavLink: RestaurantNavLink;
  updateRestaurantNavLinkDraft: RestaurantNavLinkDraft;
  updateRestaurantOnboardingInfo: Restaurant;
  updateRestaurantOnboardingInfoLink: Restaurant;
  updateRestaurantOnboardingInfoOrderingStartedAt?: Maybe<Restaurant>;
  updateRestaurantOnboardingStatus: Restaurant;
  updateRestaurantOnboardingWoflowImport: WoflowImport;
  /** Sets the ordering mobile brand color for a restaurant */
  updateRestaurantOrderingMobileBrandColor: Restaurant;
  updateRestaurantOrderingSettings: Restaurant;
  /** Update restaurant profile */
  updateRestaurantProfile: RestaurantProfile;
  updateRestaurantScriptSettings: Restaurant;
  updateRestaurantSignUpSetting: RestaurantSignUpSetting;
  updateRestaurantSignUpSettingDraft: RestaurantSignUpSettingDraft;
  updateRestaurantSocialHandleDrafts: Restaurant;
  updateRestaurantSocialHandles: Restaurant;
  updateRestaurantSproutSocialGroup: SproutSocialGroup;
  updateRestaurantSquareAccount: Restaurant;
  updateRestaurantStripeAccount: Restaurant;
  updateRestaurantTheme: Restaurant;
  updateRestaurantThemeDraft: Restaurant;
  updateRestaurantToastRestaurant: Restaurant;
  updateRestaurantUserSetting: RestaurantUserSetting;
  updateRestaurantVipSettings: Restaurant;
  updateReviewReply: ReviewReply;
  updateReviewStatus: Review;
  /** Update selected role */
  updateRoleMember: RestaurantMember;
  /** Update a root announcement */
  updateRootAnnouncement: RootAnnouncement;
  updateRootDishTag: RootDishTag;
  /** Update an root_group */
  updateRootGroup: RootGroup;
  updateRootMessagePack: RootMessagePack;
  updateRootMessagePackCommunication: RootMessagePackCommunication;
  updateRootMessagePackMessage: RootMessagePackMessage;
  updateRootMessagePackSocialPost: RootMessagePackSocialPost;
  /** Update a root section type */
  updateRootNote: RootNote;
  updateRootSectionTemplate: RootSectionTemplate;
  /** Update a root section type */
  updateRootSectionType: RootSectionType;
  updateRootSiteTemplate: RootSiteTemplate;
  updateRootTask: RootTask;
  /** Update a root theme */
  updateRootTheme: RootTheme;
  updateRootThemeTemplate: RootThemeTemplate;
  /** Update a social account */
  updateSocialAccount?: Maybe<SocialAccount>;
  /** Update multiple social accounts */
  updateSocialAccounts?: Maybe<Array<SocialAccount>>;
  updateSocialPost: SocialPost;
  updateSpotonSetting: RestaurantLocation;
  updateSquareMenuSectionsAvailability: Menu;
  updateStatusCampaignItem?: Maybe<CampaignItem>;
  updateSuggestedDish: SuggestedDish;
  updateSuggestedDishPosition: Array<SuggestedDish>;
  updateTextMessageGroup: TextMessageGroup;
  /** Update a root section type */
  updateThemeFont: ThemeFont;
  /** Update a throttle setting */
  updateThrottleSetting: ThrottleSetting;
  /** Set the ticket quantities on the current session's cart for a calendar event */
  updateTicketCart?: Maybe<CalendarEventTicketCart>;
  updateToastHostedPaymentIntent: ToastHostedPaymentIntent;
  updateToastRestaurantConnection: ToastRestaurant;
  updateToastRestaurantServiceCharges: ToastRestaurant;
  updateTwilioPhoneCall: TwilioPhoneCall;
  updateTwilioPhoneCallIsRead: TwilioPhoneCall;
  updateUnreadFeedback: Array<Feedback>;
  updateUpload: Uploadable;
  /** Updates the upload folder */
  updateUploadFolder: UploadableFolder;
  updateUploadSteps: Restaurant;
  updateUpsellCampaign: UpsellCampaign;
  /** Update a user */
  updateUser: User;
  updateUserFeatureIntroduction: UserFeatureIntroduction;
  updateUserLastReleaseId: User;
  /** Reset a user password */
  updateUserPassword: User;
  /** Update user subscriptions */
  updateUserSubscriptions?: Maybe<User>;
  /** Update a user avatar from UploadedAvatar */
  updateUserUploadedAvatar: User;
  updateYextAccount: YextAccount;
  upgradeRequest: Restaurant;
  upsertDeviceRegistration: UserDevice;
  upsertLead?: Maybe<Session>;
  upsertLocationBillingSubscription: BillingSubscription;
  upsertLocationSalesforceAccount: SalesforceAccount;
  /** Creates or updates a NotificationDevice for the current session */
  upsertNotificationDevice?: Maybe<NotificationDevice>;
  upsertRestaurantBillingCustomer: BillingCustomer;
  upsertRestaurantBillingSubscription: BillingSubscription;
  upsertRestaurantBillingUkCustomer: Restaurant;
  upsertRestaurantDetailsPopTrigger: SalesforcePopTrigger;
  upsertRestaurantLastAdminVisit?: Maybe<User>;
  upsertRestaurantLocation: Restaurant;
  upsertRestaurantLocationOrderingBillingConfig: RestaurantLocation;
  upsertRestaurantMemberClientProfile: RestaurantMemberClientProfile;
  upsertRestaurantMobileAppAsset: RestaurantMobileAppAsset;
  upsertRestaurantSalesforceAccount: SalesforceAccount;
  /** Resets Authy for a list of users */
  userResetAuthy: Array<User>;
  validateMenuItemCartSelectedMenuItems: MenuItemCart;
  validateMenuItemCartSubmit: MenuItemCart;
  /** Validate liquid variables used in content */
  validateMessageCampaignContent?: Maybe<MessageCampaign>;
  verifyGoogleMyBusinessLocation: Verification;
  verifyPhone: Session;
  verifyPushChallenge: Session;
};


export type MutationAcceptClientTermsArgs = {
  input: AcceptClientTermsInput;
};


export type MutationAcceptRestaurantMemberInviteArgs = {
  token: Scalars['String']['input'];
};


export type MutationAddFeaturedItemDraftsArgs = {
  featuredItemInputs: Array<SectionFeaturedItemInput>;
  sectionId: Scalars['Int']['input'];
};


export type MutationAddGoogleMyBusinessLocationArgs = {
  accountName: Scalars['String']['input'];
  locationId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type MutationAddLinkToPendingImportArgs = {
  restaurantId: Scalars['Int']['input'];
  url: Scalars['String']['input'];
};


export type MutationAddMenuItemToFeaturedSectionArgs = {
  itemId: Scalars['Int']['input'];
  menuFeaturedSectionId: Scalars['Int']['input'];
};


export type MutationAddRestaurantDomainArgs = {
  input: RestaurantAddDomainInput;
};


export type MutationAddRestaurantLocationOrderingDelayTimeArgs = {
  delayAmount: Scalars['Int']['input'];
  locationId: Scalars['Int']['input'];
};


export type MutationAddRestaurantToGroupArgs = {
  input: AddRestaurantToGroupInput;
};


export type MutationAddStagedRecordArgs = {
  input: AddStagedRecordInput;
};


export type MutationAdjustMenuItemCartSelectedMenuItemArgs = {
  amount: Scalars['Decimal']['input'];
  menuItemCartId: Scalars['Int']['input'];
  selectedMenuItemId: Scalars['Int']['input'];
};


export type MutationAlphabetizeMenuSectionItemsArgs = {
  input: MenuSectionAlphabetizeItemsInput;
};


export type MutationAlphabetizeMenuSubsectionItemsArgs = {
  input: MenuSubsectionAlphabetizeItemsInput;
};


export type MutationApplyLoyaltyRewardArgs = {
  input: ApplyLoyaltyRewardInput;
};


export type MutationApplyMenuItemDishTagArgs = {
  dishTagId: Scalars['String']['input'];
  menuItemId: Scalars['Int']['input'];
};


export type MutationApplyMenuItemFindAndReplaceArgs = {
  findString: Scalars['String']['input'];
  menuItemId: Scalars['Int']['input'];
  replaceWith: Scalars['String']['input'];
};


export type MutationApplyMenuItemModifierGroupsArgs = {
  input: ApplyMenuItemModifierGroupInput;
};


export type MutationApplyMenuItemOnlineOrderingArgs = {
  ignoredIntegrations?: InputMaybe<Array<Scalars['String']['input']>>;
  isOnlineOrderingEnabled: Scalars['Boolean']['input'];
  menuItemId: Scalars['Int']['input'];
  orderingEnabledIntegrations?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationApplyMenuItemPriceChangeArgs = {
  amount: Scalars['String']['input'];
  menuItemId: Scalars['Int']['input'];
  priceType: Scalars['String']['input'];
};


export type MutationApplyOrderingOfferOrGiftCardArgs = {
  input: ApplyOrderingOfferOrGiftCardInput;
};


export type MutationApplyPendingOfferArgs = {
  input: ApplyPendingOfferInput;
};


export type MutationApplyPendingRewardArgs = {
  input: ApplyPendingRewardInput;
};


export type MutationApplyRootSectionTemplateArgs = {
  customPageId: Scalars['Int']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  rootSectionTemplateId: Scalars['Int']['input'];
};


export type MutationApplyRootSiteTemplateArgs = {
  restaurantId: Scalars['Int']['input'];
  rootSiteTemplateId: Scalars['Int']['input'];
};


export type MutationApplyRootThemeTemplateArgs = {
  restaurantId: Scalars['Int']['input'];
  rootThemeTemplateId: Scalars['Int']['input'];
};


export type MutationApplyTemplateToMessageGroupArgs = {
  input: ApplyTemplateToMessageGroupInput;
};


export type MutationApproveMultipleContentsArgs = {
  input: ApproveMultipleAiContentsTypeInput;
};


export type MutationApproveRestaurantMessagePackCommunicationArgs = {
  input: ApproveRestaurantMessagePackInput;
};


export type MutationArchiveAgentChatArgs = {
  input: ArchiveAgentChatInput;
};


export type MutationArchiveAimPromptConfigArgs = {
  input: ArchiveAimPromptConfigInput;
};


export type MutationArchiveRestaurantLocationArgs = {
  followerMigrationLocationId?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
};


export type MutationAssignAimPromptConfigToRestaurantsArgs = {
  input: AssignAimPromptConfigToRestaurantsInput;
};


export type MutationAttachCloverOrderTypesArgs = {
  input: AttachCloverOrderTypesInput;
};


export type MutationAttachHeartlandPosLocationArgs = {
  input: AttachHeartlandPosLocationInput;
};


export type MutationAttachMenuItemToProviderItemArgs = {
  menuItemId: Scalars['Int']['input'];
  providerId?: InputMaybe<Scalars['Int']['input']>;
  providerVariationId?: InputMaybe<Scalars['Int']['input']>;
  sizeInputs?: InputMaybe<Array<SizesToVariationsInput>>;
};


export type MutationAttachMenuToProviderMenuArgs = {
  menuId: Scalars['Int']['input'];
  providerMenuId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAttachMenusToProviderMenuArgs = {
  menuInputs: Array<MenuInput>;
};


export type MutationAttachRestaurantBillingCustomerArgs = {
  restaurantId: Scalars['Int']['input'];
  stripeId: Scalars['String']['input'];
};


export type MutationAttachSpotonLocationArgs = {
  input: AttachSpotonLocationInput;
};


export type MutationBulkDestroyAiMarketingContentForRestaurantsArgs = {
  input: BulkDestroyAiMarketingContentForRestaurantsInput;
};


export type MutationBulkMoveUploadFolderArgs = {
  input: BulkMoveUploadFolderInput;
};


export type MutationBulkSetSubmittedArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type MutationBulkUpdateFolderAimAvailableArgs = {
  input: BulkUpdateAimAvailableUploadFolderInput;
};


export type MutationCancelCampaignArgs = {
  input: CancelCampaignInput;
};


export type MutationCancelImportArgs = {
  restaurantId: Scalars['Int']['input'];
  woflowImportId: Scalars['Int']['input'];
};


export type MutationCancelMenuItemCartPaymentArgs = {
  menuItemCartId: Scalars['Int']['input'];
};


export type MutationCancelMessageGroupArgs = {
  input: CancelMessageGroupInput;
};


export type MutationCancelStripeConnectPaymentArgs = {
  stripeConnectPaymentId: Scalars['Int']['input'];
};


export type MutationCancelTextMessageGroupArgs = {
  input: CancelTextMessageGroupInput;
};


export type MutationCaptureMenuItemCartPaymentArgs = {
  menuItemCartId: Scalars['Int']['input'];
};


export type MutationCaptureSelfSignUpLeadArgs = {
  input: SelfSignUpCaptureLeadInput;
};


export type MutationCaptureStripeConnectPaymentArgs = {
  stripeConnectPaymentId: Scalars['Int']['input'];
};


export type MutationChangeStatusOrderingOfferArgs = {
  input: ChangeStatusOrderingOfferInput;
};


export type MutationChangeStatusUpsellCampaignArgs = {
  input: ChangeStatusUpsellCampaignInput;
};


export type MutationChargeFailedBillingInvoicesArgs = {
  bankAccountId: Scalars['Int']['input'];
  creditCardId: Scalars['Int']['input'];
  oloInvoiceIds: Array<Scalars['Int']['input']>;
  subscriptionInvoiceIds: Array<Scalars['Int']['input']>;
};


export type MutationCheckPhoneVerificationArgs = {
  input: CheckPhoneVerificationInput;
};


export type MutationClearAllRestaurantOpenCartsArgs = {
  input: ClearAllRestaurantOpenCartsInput;
};


export type MutationClearRestaurantCacheArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type MutationCloneMenuItemCartSelectedMenuItemV2Args = {
  input: CloneMenuItemCartSelectedMenuItemV2Input;
};


export type MutationCloneMenuItemCartV2Args = {
  input: CloneMenuItemCartV2Input;
};


export type MutationCloseMenuItemCartArgs = {
  didAdminCloseCart?: InputMaybe<Scalars['Boolean']['input']>;
  expectedTabTotal?: InputMaybe<Scalars['Decimal']['input']>;
  menuItemCartId: Scalars['Int']['input'];
  menuItemCartInput: MenuItemCartInput;
  paymentInput?: InputMaybe<CartPaymentInput>;
};


export type MutationCloseMenuItemCartV2Args = {
  input: CloseMenuItemCartV2Input;
};


export type MutationCompareAimPlaygroundEvaluationSetsArgs = {
  input: CompareAimPlaygroundEvaluationSetsInput;
};


export type MutationCompleteGoogleMyBusinessVerificationArgs = {
  locationId: Scalars['Int']['input'];
  pin: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
  verificationName: Scalars['String']['input'];
};


export type MutationCompleteLocationPurchaseArgs = {
  input: CompleteLocationPurchaseInput;
};


export type MutationCompletePushMfaEnrollmentArgs = {
  input: CompletePushMfaEnrollmentInput;
};


export type MutationCompleteTaskActionArgs = {
  taskActionId: Scalars['Int']['input'];
};


export type MutationCompleteWoflowImportMenuQaArgs = {
  importMenuId: Scalars['Int']['input'];
};


export type MutationConfirmMenuUploadArgs = {
  input: ConfirmMenuUploadInput;
};


export type MutationConfirmPendingEmailByAccessCodeArgs = {
  accessCode: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type MutationConfirmSessionAuthyArgs = {
  authyCode: Scalars['String']['input'];
};


export type MutationConfirmSessionTotpArgs = {
  input: CreateTwilioVerifyTotpChallengeInput;
};


export type MutationConfirmTotpSetupArgs = {
  input: VerifyTwilioVerifyTotpInput;
};


export type MutationConnectHungrrrPayAccountArgs = {
  input: ConnectHungrrrPayAccountInput;
};


export type MutationConnectRestaurantEcardAccountArgs = {
  input: ConnectRestaurantEcardAccountTypeInput;
};


export type MutationConnectRestaurantLocationAlohaSiteArgs = {
  input: ConnectRestaurantLocationAlohaSiteInput;
};


export type MutationConnectRestaurantLocationMicrosRvcArgs = {
  input: ConnectRestaurantLocationMicrosRvcInput;
};


export type MutationConnectRestaurantLocationNcrSilverStoreArgs = {
  locationId: Scalars['Int']['input'];
  ncrSilverAccountId: Scalars['Int']['input'];
  ncrSilverStoreId: Scalars['Int']['input'];
};


export type MutationConnectSalesforceAccountArgs = {
  input: ConnectSalesforceAccountInput;
};


export type MutationCopyAllCustomResponsesArgs = {
  input: CopyAllCustomResponsesInput;
};


export type MutationCopyCategoryCustomResponsesArgs = {
  input: CopyCategoryCustomResponsesInput;
};


export type MutationCopyCustomPageArgs = {
  customPageId: Scalars['Int']['input'];
};


export type MutationCopyCustomPageDraftArgs = {
  customPageId: Scalars['Int']['input'];
};


export type MutationCopyCustomPageSectionDraftArgs = {
  sectionId: Scalars['Int']['input'];
};


export type MutationCopyMenuArgs = {
  input: MenuCopyInput;
};


export type MutationCopyMessageGroupArgs = {
  input: CopyMessageGroupInput;
};


export type MutationCopySyncedMenuArgs = {
  input: CopySyncedMenuInput;
};


export type MutationCreateAccountArgs = {
  input: SelfSignUpCreateAccountInput;
};


export type MutationCreateAdvancedFormEntryArgs = {
  advancedFormId?: InputMaybe<Scalars['Int']['input']>;
  answers: Array<CustomPageAdvancedFormEntryAnswerInput>;
  captchaMode?: InputMaybe<Scalars['String']['input']>;
  captchaResponse: Scalars['String']['input'];
  followerInput?: InputMaybe<FollowerInput>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateAgentChatArgs = {
  input: CreateAgentChatInput;
};


export type MutationCreateAgentChatMessageArgs = {
  input: CreateAgentChatMessageInput;
};


export type MutationCreateAimPromptConfigArgs = {
  input: CreateAimPromptConfigInput;
};


export type MutationCreateAlohaAccountArgs = {
  input: CreateAlohaAccountInput;
};


export type MutationCreateAnnouncementArgs = {
  announcementInput: AnnouncementInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateAuthorizeAccountArgs = {
  input: CreateAuthorizeAccountInput;
};


export type MutationCreateAuthorizePaymentPageTokenArgs = {
  input: CreateAuthorizeAccountPaymentPageTokenInput;
};


export type MutationCreateBillingBankAccountArgs = {
  accountId: Scalars['String']['input'];
  applyToAllSubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  billingBankAccountId?: InputMaybe<Scalars['Int']['input']>;
  billingCreditCardId?: InputMaybe<Scalars['Int']['input']>;
  billingCustomerId: Scalars['Int']['input'];
  gocardlessMandateId?: InputMaybe<Scalars['String']['input']>;
  isPrimaryPayment?: InputMaybe<Scalars['Boolean']['input']>;
  publicToken: Scalars['String']['input'];
};


export type MutationCreateBillingCouponArgs = {
  billingCouponInput: BillingCouponInput;
};


export type MutationCreateBillingCreditCardArgs = {
  applyToAllSubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  billingBankAccountId?: InputMaybe<Scalars['Int']['input']>;
  billingCreditCardId?: InputMaybe<Scalars['Int']['input']>;
  billingCustomerId: Scalars['Int']['input'];
  isPrimaryPayment?: InputMaybe<Scalars['Boolean']['input']>;
  stripeToken: Scalars['String']['input'];
};


export type MutationCreateBillingEntitlementFeatureFlagArgs = {
  input: CreateBillingEntitlementFeatureFlagInput;
};


export type MutationCreateBillingInvoiceArgs = {
  input: CreateBillingInvoiceInput;
};


export type MutationCreateBillingPlanArgs = {
  billingPlanInput: BillingPlanInput;
};


export type MutationCreateBillingProductArgs = {
  input: CreateBillingProductInput;
};


export type MutationCreateBillingProductPriceArgs = {
  input: CreateBillingProductPriceInput;
};


export type MutationCreateBlockedTermArgs = {
  blockedTermInput: BlockedTermInput;
};


export type MutationCreateBlogImportArgs = {
  restaurantId: Scalars['Int']['input'];
  uploadedImportId: Scalars['Int']['input'];
};


export type MutationCreateBlogPostArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateCalendarEventArgs = {
  input: CreateCalendarEventInput;
};


export type MutationCreateChatbotSessionArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationCreateCloverAccountArgs = {
  input: CreateCloverAccountInput;
};


export type MutationCreateConsumerUserArgs = {
  followerInput?: InputMaybe<FollowerInput>;
  userInput?: InputMaybe<UserInput>;
};


export type MutationCreateConsumerUserByPhoneArgs = {
  input: CreateConsumerUserByPhoneInput;
};


export type MutationCreateCustomFeeArgs = {
  customFeeInput: CustomFeeInput;
  locationId: Scalars['Int']['input'];
};


export type MutationCreateCustomFormEntryArgs = {
  attachmentDataUrl?: InputMaybe<Scalars['String']['input']>;
  captchaResponse: Scalars['String']['input'];
  customFormId?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  selectedDateTime?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationCreateCustomImageArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageSize?: InputMaybe<Scalars['String']['input']>;
  imageUploadedPhoto: SelectedUploadInput;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateCustomPageArgs = {
  customPage?: InputMaybe<CustomPageInput>;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateCustomPageDraftArgs = {
  customPage?: InputMaybe<CustomPageInput>;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateCustomPageDraftWithLinkArgs = {
  customPage?: InputMaybe<CustomPageInput>;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateCustomPageSectionArgs = {
  customPageId: Scalars['Int']['input'];
};


export type MutationCreateCustomPageSectionDraftArgs = {
  customPageId: Scalars['Int']['input'];
};


export type MutationCreateCustomTaxRateArgs = {
  input: CreateCustomTaxRateInput;
};


export type MutationCreateDeliverectChannelArgs = {
  input: CreateDeliverectChannelInput;
};


export type MutationCreateDemoSiteReviewsArgs = {
  input: CreateDemoSiteReviewsInput;
};


export type MutationCreateDishArgs = {
  dishInput: DishInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateEventTagArgs = {
  eventTagInput: EventTagInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateFacebookCampaignArgs = {
  input: CreateFacebookCampaignInput;
};


export type MutationCreateFollowerArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateFollowerExportArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateFollowerImportArgs = {
  followerImportInput: FollowerImportInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateFollowerTagArgs = {
  followerTagInput: FollowerTagInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateGoogleMyBusinessPostArgs = {
  input: CreatePostInput;
  locationNames: Array<Scalars['String']['input']>;
};


export type MutationCreateHeartlandAccountArgs = {
  input: CreateHeartlandAccountInput;
};


export type MutationCreateLoginCarouselSlideArgs = {
  loginCarouselSlideInput: LoginCarouselSlideInput;
};


export type MutationCreateMarketingOfferArgs = {
  marketingOfferInput: MarketingOfferInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateMasterMessageCampaignArgs = {
  masterMessageCampaign: MasterMessageCampaignInput;
};


export type MutationCreateMenuArgs = {
  input: MenuCreateInput;
};


export type MutationCreateMenuExportArgs = {
  input: CreateMenuExportInput;
};


export type MutationCreateMenuFeaturedSectionArgs = {
  menuFeaturedSectionInput: MenuFeaturedSectionInput;
  menuId: Scalars['Int']['input'];
};


export type MutationCreateMenuFromWoflowImportArgs = {
  input: CreateMenuFromWoflowImportInput;
};


export type MutationCreateMenuItemArgs = {
  input: MenuItemCreateInput;
};


export type MutationCreateMenuItemCartDeliveryV2Args = {
  input: CreateMenuItemCartDeliveryV2Input;
};


export type MutationCreateMenuItemCartSelectedMenuItemArgs = {
  menuItemCartId?: InputMaybe<Scalars['Int']['input']>;
  orderingEventId?: InputMaybe<Scalars['Int']['input']>;
  selectedMenuItemInput: MenuItemCartSelectedMenuItemInput;
  selectedMenuItemInputs?: InputMaybe<Array<InputMaybe<MenuItemCartSelectedMenuItemInput>>>;
};


export type MutationCreateMenuItemReviewArgs = {
  content: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  menuItemCartReviewToken?: InputMaybe<Scalars['String']['input']>;
  menuItemId: Scalars['Int']['input'];
};


export type MutationCreateMenuSectionArgs = {
  input: MenuSectionCreateInput;
};


export type MutationCreateMenuSubsectionArgs = {
  input: MenuSubsectionCreateInput;
};


export type MutationCreateMessageCampaignEngagementOfferPreviewArgs = {
  input: CreateEngagementOfferPreviewInput;
};


export type MutationCreateMessageCampaignPreviewArgs = {
  input: CreateMessageCampaignPreviewInput;
};


export type MutationCreateMessageCampaignTextMessagePreviewArgs = {
  input: CreateMessageCampaignTextMessagePreviewInput;
};


export type MutationCreateMessageGroupArgs = {
  input: CreateMessageGroupInput;
};


export type MutationCreateMessageGroupContentArgs = {
  input: CreateMessageGroupContentInput;
};


export type MutationCreateMessageGroupFromTemplateArgs = {
  input: CreateMessageGroupFromTemplateInput;
};


export type MutationCreateMessageGroupPreviewArgs = {
  input: CreateMessageGroupPreviewInput;
};


export type MutationCreateMicrosOrgArgs = {
  input: CreateMicrosOrgInput;
};


export type MutationCreateModifierGroupArgs = {
  modifierGroupInput: ModifierGroupInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateNcrPaymentAccountArgs = {
  input: CreateNcrPaymentAccountInput;
};


export type MutationCreateNcrSilverAccountArgs = {
  input: CreateNcrSilverAccountInput;
};


export type MutationCreateNmiAccountArgs = {
  input: CreateNmiAccountInput;
};


export type MutationCreateOauthApplicationArgs = {
  oauthApplicationInput: OauthApplicationInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateOauthIntegrationArgs = {
  input: CreateOAuthIntegrationInput;
};


export type MutationCreateOfferArgs = {
  offerInput: OfferInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateOrUpdateHighlightArgs = {
  input: CreateOrUpdateHighlightInput;
};


export type MutationCreateOrUpdateHighlightReelArgs = {
  input: CreateOrUpdateHighlightReelInput;
};


export type MutationCreateOrUpdateLoyaltyProgramPromotionArgs = {
  input: CreateOrUpdateLoyaltyProgramPromotionInput;
};


export type MutationCreateOrUpdateMenuSectionHighlightReviewsArgs = {
  input: CreateOrUpdateMenuSectionHighlightReviewsInput;
};


export type MutationCreateOrUpdatePopmenuLoyaltyAccountArgs = {
  input: CreateOrUpdatePopmenuLoyaltyAccountInput;
};


export type MutationCreateOrUpdatePopmenuLoyaltyProgramArgs = {
  input: CreateOrUpdatePopmenuLoyaltyProgramInput;
};


export type MutationCreateOrUpdateReviewReplyArgs = {
  input: CreateOrUpdateReviewReplyInput;
};


export type MutationCreateOrUpdateRewardTiersArgs = {
  input: CreateOrUpdateRewardTiersInput;
};


export type MutationCreateOrderingBlackoutArgs = {
  input: CreateOrderingBlackoutInput;
};


export type MutationCreateOrderingEventArgs = {
  input: CreateOrderingEventInput;
};


export type MutationCreateOrderingOfferArgs = {
  input: CreateOrderingOfferInput;
};


export type MutationCreateOrderingReportExportArgs = {
  input: CreateOrderingReportExportInput;
};


export type MutationCreateOrderingUserArgs = {
  followerInput?: InputMaybe<FollowerInput>;
  userInput?: InputMaybe<UserInput>;
};


export type MutationCreatePartyArgs = {
  overrideCapacity?: InputMaybe<Scalars['Boolean']['input']>;
  partyInput: PartyInput;
};


export type MutationCreatePasswordResetArgs = {
  email: Scalars['String']['input'];
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreatePhoneVerificationArgs = {
  input: CreatePhoneVerificationInput;
};


export type MutationCreatePreviewFromTemplateArgs = {
  input: CreatePreviewFromTemplateInput;
};


export type MutationCreatePrintLayoutArgs = {
  printLayoutInput: PrintLayoutInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreatePushChallengeArgs = {
  input: CreateTwilioVerifyPushChallengeInput;
};


export type MutationCreatePushMessageGroupArgs = {
  input: CreatePushMessageGroupInput;
};


export type MutationCreatePushMfaEnrollmentAccessTokenArgs = {
  input: CreatePushMfaEnrollmentAccessTokenInput;
};


export type MutationCreateQrCardArgs = {
  input: CreateQrCardInput;
};


export type MutationCreateResellerSignUpSurveyArgs = {
  input: CreateResellerSignUpSurveyInput;
};


export type MutationCreateRestaurantArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateRestaurantActionBarLinkDraftArgs = {
  actionBarLinkInput: RestaurantActionBarLinkInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateRestaurantCustomRedirectArgs = {
  fromPath?: InputMaybe<Scalars['String']['input']>;
  hostname?: InputMaybe<Scalars['String']['input']>;
  isMatchAll?: InputMaybe<Scalars['Boolean']['input']>;
  isPermanent?: InputMaybe<Scalars['Boolean']['input']>;
  redirectType: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
  toExternalUrl?: InputMaybe<Scalars['String']['input']>;
  toPath?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateRestaurantCustomScriptArgs = {
  input: CreateRestaurantCustomScriptInput;
};


export type MutationCreateRestaurantCustomTrackingArgs = {
  input: CreateRestaurantCustomTrackingInput;
};


export type MutationCreateRestaurantDishTagArgs = {
  dishTagInput: RestaurantDishTagInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateRestaurantEmbedArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateRestaurantFollowerArgs = {
  input: CreateFollowerInput;
};


export type MutationCreateRestaurantFooterLinkArgs = {
  footerLinkInput: RestaurantNavLinkInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateRestaurantFooterLinkDraftArgs = {
  footerLinkInput: RestaurantNavLinkInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateRestaurantGroupArgs = {
  input: CreateRestaurantGroupInput;
};


export type MutationCreateRestaurantLocationArgs = {
  locationInput?: InputMaybe<RestaurantLocationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateRestaurantLocationAnsweringSettingArgs = {
  answeringSettingsInput: RestaurantLocationAnsweringSettingInput;
  locationId: Scalars['Int']['input'];
};


export type MutationCreateRestaurantMemberInviteArgs = {
  inviteInput: RestaurantMemberInviteInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateRestaurantMenuImportArgs = {
  restaurantId: Scalars['Int']['input'];
  uploadedImportId: Scalars['Int']['input'];
};


export type MutationCreateRestaurantMessagePackArgs = {
  input: CreateRestaurantMessagePackInput;
};


export type MutationCreateRestaurantNavDropdownArgs = {
  navDropdownInput: RestaurantNavDropdownInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateRestaurantNavDropdownDraftArgs = {
  navDropdownInput: RestaurantNavDropdownInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateRestaurantNavLinkArgs = {
  navDropdownId?: InputMaybe<Scalars['Int']['input']>;
  navLinkInput: RestaurantNavLinkInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateRestaurantNavLinkDraftArgs = {
  navDropdownId?: InputMaybe<Scalars['Int']['input']>;
  navLinkInput: RestaurantNavLinkInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateRestaurantOnboardingInfoLinkArgs = {
  linkType: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
  url: Scalars['String']['input'];
};


export type MutationCreateRestaurantOnboardingInfoNoteArgs = {
  noteContent: Scalars['String']['input'];
  noteType: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateRestaurantOnboardingWoflowImportArgs = {
  files?: InputMaybe<Array<Scalars['Int']['input']>>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<Scalars['Int']['input']>>;
  photos?: InputMaybe<Array<Scalars['Int']['input']>>;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateRestaurantScriptDomainArgs = {
  input: CreateRestaurantScriptDomainInput;
};


export type MutationCreateRestaurantWebhookArgs = {
  input: CreateRestaurantWebhookInput;
};


export type MutationCreateReviewReplyArgs = {
  content: Scalars['String']['input'];
  isPublic: Scalars['Boolean']['input'];
  offerId?: InputMaybe<Scalars['Int']['input']>;
  orderingOfferId?: InputMaybe<Scalars['Int']['input']>;
  reviewId: Scalars['Int']['input'];
};


export type MutationCreateRootAnnouncementArgs = {
  rootAnnouncementInput: RootAnnouncementInput;
};


export type MutationCreateRootDishTagArgs = {
  rootDishTagInput: RootDishTagInput;
};


export type MutationCreateRootGroupArgs = {
  rootGroupInput: RootGroupInput;
};


export type MutationCreateRootGroupMemberArgs = {
  memberInput: RootGroupMemberInput;
  rootGroupId: Scalars['Int']['input'];
};


export type MutationCreateRootMessagePackArgs = {
  input: CreateRootMessagePackInput;
};


export type MutationCreateRootMessagePackMessageArgs = {
  input: CreateRootMessagePackMessageInput;
};


export type MutationCreateRootMessagePackSocialPostArgs = {
  input: CreateRootMessagePackSocialPostInput;
};


export type MutationCreateRootNoteArgs = {
  restaurantId: Scalars['Int']['input'];
  rootNoteInput: RootNoteInput;
};


export type MutationCreateRootSectionTemplateArgs = {
  rootSectionTemplateInput: RootSectionTemplateInput;
};


export type MutationCreateRootSectionTypeArgs = {
  rootSectionTypeInput: RootSectionTypeInput;
};


export type MutationCreateRootSiteTemplateArgs = {
  rootSiteTemplateInput: RootSiteTemplateInput;
};


export type MutationCreateRootTaskArgs = {
  rootTaskInput: RootTaskInput;
};


export type MutationCreateRootThemeArgs = {
  rootThemeInput: RootThemeInput;
};


export type MutationCreateRootThemeTemplateArgs = {
  rootThemeTemplateInput: RootThemeTemplateInput;
};


export type MutationCreateRootUserArgs = {
  rootUserInput: RootUserInput;
};


export type MutationCreateSalesDemoRestaurantArgs = {
  name: Scalars['String']['input'];
  sourceRestaurantId: Scalars['Int']['input'];
};


export type MutationCreateSelfAddPartyArgs = {
  followerInput?: InputMaybe<FollowerInput>;
  partyInput: PartyInput;
};


export type MutationCreateSocialAccountArgs = {
  advisorCardTrackerId?: InputMaybe<Scalars['Int']['input']>;
  authCode: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
  socialType: Scalars['String']['input'];
};


export type MutationCreateSocialPostArgs = {
  input: CreateSocialPostInput;
};


export type MutationCreateSquareSellerAccountArgs = {
  country: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
  squareCode: Scalars['String']['input'];
};


export type MutationCreateStripeConnectAccountArgs = {
  restaurantId: Scalars['Int']['input'];
  stripeCode: Scalars['String']['input'];
};


export type MutationCreateSuggestedDishArgs = {
  restaurantId: Scalars['Int']['input'];
  suggestedDishInput: SuggestedDishInput;
};


export type MutationCreateTableTopArgs = {
  input: CreateTableTopInput;
};


export type MutationCreateTextMessageGroupArgs = {
  input: CreateTextMessageGroupInput;
};


export type MutationCreateTextMessageGroupMessagePreviewArgs = {
  input: CreateTextMessageGroupMessagePreviewInput;
};


export type MutationCreateTextMessageGroupPreviewArgs = {
  input: CreateTextMessageGroupPreviewInput;
};


export type MutationCreateThemeFontArgs = {
  restaurantId: Scalars['Int']['input'];
  themeFontInput: ThemeFontInput;
};


export type MutationCreateToastHostedCheckoutSessionArgs = {
  menuItemCartId: Scalars['Int']['input'];
  tipAmount?: InputMaybe<Scalars['Decimal']['input']>;
};


export type MutationCreateTwilioBannedWordArgs = {
  input: CreateTwilioBannedWordInput;
};


export type MutationCreateTwilioPhoneCallArgs = {
  createPhoneCallInput: PhoneCallCreateInputType;
};


export type MutationCreateTwilioPhoneNumberArgs = {
  isAnsweringNumber?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateUploadArgs = {
  input: UploadedPhotoInput;
  isImport?: InputMaybe<Scalars['Boolean']['input']>;
  isOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  uploadType: Scalars['String']['input'];
};


export type MutationCreateUploadFolderArgs = {
  input: CreateUploadFolderInput;
};


export type MutationCreateUpsellCampaignArgs = {
  input: CreateUpsellCampaignInput;
};


export type MutationCreateUserArgs = {
  anniversaryDay?: InputMaybe<Scalars['Int']['input']>;
  anniversaryMonth?: InputMaybe<Scalars['Int']['input']>;
  appleCode?: InputMaybe<Scalars['String']['input']>;
  birthDay?: InputMaybe<Scalars['Int']['input']>;
  birthMonth?: InputMaybe<Scalars['Int']['input']>;
  createAccount?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookCode?: InputMaybe<Scalars['String']['input']>;
  favoriteLocationId?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  followerInput?: InputMaybe<FollowerInput>;
  googleCode?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
  userInput?: InputMaybe<UserInput>;
  weddingDay?: InputMaybe<Scalars['Int']['input']>;
  weddingMonth?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateUserApiTokenArgs = {
  input: CreateUserApiTokenInput;
};


export type MutationCreateUserWithoutPasswordArgs = {
  email: Scalars['String']['input'];
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCustomResponseExportArgs = {
  input: CreateCustomResponseExportInput;
};


export type MutationDeleteMyFollowerAccountArgs = {
  input: DeleteMyFollowerAccountInput;
};


export type MutationDeleteMyUserAccountArgs = {
  input: DeleteMyUserAccountInput;
};


export type MutationDeleteSelectedEmailFromBounceAndSpamListArgs = {
  input: DeleteSelectedEmailFromBounceAndSpamListInput;
};


export type MutationDeleteSuggestedDishArgs = {
  dishId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
  suggestedDishId: Scalars['Int']['input'];
};


export type MutationDeleteTableTopArgs = {
  input: DeleteTableTopInput;
};


export type MutationDemoOrdernerdRestaurantLocationArgs = {
  locationId: Scalars['Int']['input'];
};


export type MutationDemoteRootUserArgs = {
  input: DemoteRootUserInput;
};


export type MutationDeregisterDeviceArgs = {
  pushToken: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationDestroyAllDishesArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type MutationDestroyAllFollowerImportsArgs = {
  input: DestroyAllFollowerImportsInput;
};


export type MutationDestroyAllFollowerTagsArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type MutationDestroyAllFollowersArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type MutationDestroyAllModifierGroupsArgs = {
  input: DestroyAllModifierGroupsInput;
};


export type MutationDestroyAllSquareSyncedMenusArgs = {
  input: DestroyAllSquareSyncedMenusInput;
};


export type MutationDestroyAnnouncementArgs = {
  announcementId: Scalars['Int']['input'];
};


export type MutationDestroyBillingBankAccountArgs = {
  billingBankAccountId: Scalars['Int']['input'];
};


export type MutationDestroyBillingCreditCardArgs = {
  billingCreditCardId: Scalars['Int']['input'];
};


export type MutationDestroyBillingEntitlementFeatureFlagArgs = {
  input: DestroyBillingEntitlementFeatureFlagInput;
};


export type MutationDestroyBillingSubscriptionArgs = {
  billingSubscriptionId: Scalars['Int']['input'];
};


export type MutationDestroyBlockedTermArgs = {
  blockedTermId: Scalars['Int']['input'];
};


export type MutationDestroyBlogPostArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDestroyCalendarEventArgs = {
  calendarEventId: Scalars['Int']['input'];
};


export type MutationDestroyCampaignItemArgs = {
  input: DestroyCampaignItemInput;
};


export type MutationDestroyCustomFeeArgs = {
  customFeeId: Scalars['Int']['input'];
};


export type MutationDestroyCustomFileArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDestroyCustomPageArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDestroyCustomPageDraftArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDestroyCustomPageSectionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDestroyCustomPageSectionDraftArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDestroyCustomTaxRateArgs = {
  input: DestroyCustomTaxRateInput;
};


export type MutationDestroyDeliverectChannelArgs = {
  input: DestroyDeliverectChannelInput;
};


export type MutationDestroyDishArgs = {
  dishId: Scalars['Int']['input'];
};


export type MutationDestroyEventTagArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDestroyFollowerArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type MutationDestroyFollowerImportArgs = {
  input: DestroyFollowerImportInput;
};


export type MutationDestroyFollowerTagArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDestroyGoogleMyBusinessPostArgs = {
  id: Scalars['Int']['input'];
  input: CreatePostInput;
};


export type MutationDestroyHighlightArgs = {
  input: DestroyHighlightInput;
};


export type MutationDestroyHighlightReelArgs = {
  input: DestroyHighlightReelInput;
};


export type MutationDestroyInstagramPublishedSocialPostArgs = {
  input: DestroyInstagramPublishedSocialPostInput;
};


export type MutationDestroyLargeMenuArgs = {
  input: DestroyLargeMenuInput;
};


export type MutationDestroyLastFollowerImportArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type MutationDestroyLoginCarouselSlideArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDestroyMarketingOfferArgs = {
  marketingOfferId?: InputMaybe<Scalars['Int']['input']>;
  messageCampaignId?: InputMaybe<Scalars['Int']['input']>;
  orderingOfferId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationDestroyMasterMessageCampaignArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDestroyMenuArgs = {
  input: MenuDestroyInput;
};


export type MutationDestroyMenuFeaturedSectionArgs = {
  menuFeaturedSectionId: Scalars['Int']['input'];
};


export type MutationDestroyMenuHighlightSectionArgs = {
  input: DestroyMenuHighlightSectionInput;
};


export type MutationDestroyMenuItemArgs = {
  input: MenuItemDestroyInput;
};


export type MutationDestroyMenuItemCartSelectedMenuItemArgs = {
  selectedMenuItemId: Scalars['Int']['input'];
};


export type MutationDestroyMenuItemCartSelectedMenuItemsArgs = {
  selectedMenuItemIds: Array<Scalars['Int']['input']>;
};


export type MutationDestroyMenuItemModifierGroupArgs = {
  modifierGroupId: Scalars['Int']['input'];
};


export type MutationDestroyMenuItemPopArgs = {
  menuItemId: Scalars['Int']['input'];
};


export type MutationDestroyMenuSectionArgs = {
  input: MenuSectionDestroyInput;
};


export type MutationDestroyMenuSubsectionArgs = {
  input: MenuSubsectionDestroyInput;
};


export type MutationDestroyMessageGroupContentArgs = {
  input: DeleteMessageGroupContentInput;
};


export type MutationDestroyMessageGroupDraftArgs = {
  input: DestroyMessageGroupInput;
};


export type MutationDestroyModifierGroupArgs = {
  modifierGroupId: Scalars['Int']['input'];
};


export type MutationDestroyNestedMenuItemModifierGroupArgs = {
  modifierGroupId: Scalars['Int']['input'];
};


export type MutationDestroyOfferArgs = {
  offerId: Scalars['Int']['input'];
};


export type MutationDestroyOrderingBlackoutArgs = {
  input: DestroyOrderingBlackoutInput;
};


export type MutationDestroyOrderingEventArgs = {
  input: DestroyOrderingEventInput;
};


export type MutationDestroyOrderingOfferArgs = {
  input: DestroyOrderingOfferInput;
};


export type MutationDestroyOrphanDishesArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type MutationDestroyPartyArgs = {
  partyId: Scalars['Int']['input'];
};


export type MutationDestroyPrintLayoutArgs = {
  printLayoutId: Scalars['Int']['input'];
};


export type MutationDestroyPublishedSocialPostArgs = {
  input: DestroyPublishedSocialPostInput;
};


export type MutationDestroyPushMessageGroupArgs = {
  input: DestroyPushMessageGroupInput;
};


export type MutationDestroyRestaurantActionBarLinkDraftArgs = {
  actionBarLinkInput: RestaurantActionBarLinkInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationDestroyRestaurantCustomRedirectArgs = {
  customRedirectId: Scalars['Int']['input'];
};


export type MutationDestroyRestaurantCustomScriptArgs = {
  input: DestroyRestaurantCustomScriptInput;
};


export type MutationDestroyRestaurantCustomTrackingArgs = {
  input: DestroyRestaurantCustomTrackingInput;
};


export type MutationDestroyRestaurantDetectedCookieArgs = {
  input: DestroyRestaurantDetectedCookieInput;
};


export type MutationDestroyRestaurantDishTagArgs = {
  dishTagId: Scalars['Int']['input'];
};


export type MutationDestroyRestaurantEmbedArgs = {
  restaurantEmbedId: Scalars['Int']['input'];
};


export type MutationDestroyRestaurantFooterLinkArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDestroyRestaurantFooterLinkDraftArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDestroyRestaurantGroupArgs = {
  input: DestroyRestaurantGroupInput;
};


export type MutationDestroyRestaurantLocationArgs = {
  locationId: Scalars['Int']['input'];
};


export type MutationDestroyRestaurantMemberArgs = {
  memberId: Scalars['Int']['input'];
};


export type MutationDestroyRestaurantMemberInviteArgs = {
  inviteId: Scalars['Int']['input'];
};


export type MutationDestroyRestaurantMessagePackCommunicationArgs = {
  input: DestroyRestaurantMessagePackCommunicationInput;
};


export type MutationDestroyRestaurantMobileAppAssetArgs = {
  input: DestroyRestaurantMobileAppAssetInput;
};


export type MutationDestroyRestaurantNavDropdownArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDestroyRestaurantNavDropdownDraftArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDestroyRestaurantNavLinkArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDestroyRestaurantNavLinkDraftArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDestroyRestaurantOnboardingInfoLinkArgs = {
  id: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type MutationDestroyRestaurantOnboardingInfoUploadedFontArgs = {
  id: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type MutationDestroyRestaurantOnboardingWoflowImportMenusArgs = {
  restaurantId: Scalars['Int']['input'];
  woflowImportId: Scalars['Int']['input'];
};


export type MutationDestroyRestaurantPaymentAccountArgs = {
  input: DestroyRestaurantPaymentAccountInput;
};


export type MutationDestroyRestaurantScriptDomainArgs = {
  input: DestroyRestaurantScriptDomainInput;
};


export type MutationDestroyRestaurantWebhookArgs = {
  input: DestroyRestaurantWebhookInput;
};


export type MutationDestroyRewardTierArgs = {
  input: DestroyRewardTierInput;
};


export type MutationDestroyRootAnnouncementArgs = {
  rootAnnouncementId: Scalars['Int']['input'];
};


export type MutationDestroyRootGroupArgs = {
  rootGroupId: Scalars['Int']['input'];
};


export type MutationDestroyRootGroupMemberArgs = {
  memberId: Scalars['Int']['input'];
};


export type MutationDestroyRootMessagePackArgs = {
  input: DestroyRootMessagePackInput;
};


export type MutationDestroyRootMessagePackCommunicationArgs = {
  input: DestroyRootMessagePackCommunicationInput;
};


export type MutationDestroyRootNoteArgs = {
  rootNoteId: Scalars['Int']['input'];
};


export type MutationDestroyRootSectionTypeArgs = {
  rootSectionTypeId: Scalars['Int']['input'];
};


export type MutationDestroySelectedUploadsArgs = {
  input: DestroySelectedUploadsInput;
};


export type MutationDestroySocialAccountArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDestroySocialPostArgs = {
  input: DestroySocialPostInput;
};


export type MutationDestroyStagedRecordArgs = {
  input: DestroyStagedRecordInput;
};


export type MutationDestroyTextMessageGroupArgs = {
  input: DestroyTextMessageGroupInput;
};


export type MutationDestroyThemeFontArgs = {
  themeFontId: Scalars['Int']['input'];
};


export type MutationDestroyTwilioPhoneCallArgs = {
  input: DestroyTwilioPhoneCallInput;
};


export type MutationDestroyUploadArgs = {
  id: Scalars['Int']['input'];
  uploadType: Scalars['String']['input'];
};


export type MutationDestroyUploadFolderArgs = {
  input: DestroyUploadFolderInput;
};


export type MutationDestroyUpsellCampaignArgs = {
  input: DestroyUpsellCampaignInput;
};


export type MutationDestroyUserApiTokenArgs = {
  input: DestroyUserApiTokenInput;
};


export type MutationDestroyYextMenuArgs = {
  input: DestroyYextMenuInput;
};


export type MutationDestroyYextMenusArgs = {
  input: DestroyYextMenusInput;
};


export type MutationDetachMessageCampaignOrderingOfferArgs = {
  id: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['Int']['input']>;
  orderingOfferId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationDineInQrCardArgs = {
  input: CreateDineInQrCardInput;
};


export type MutationDisableAdvancedFormArgs = {
  input: DisableAdvancedFormInput;
};


export type MutationDisconnectAllLocationsSalesforceAccountArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type MutationDisconnectRestaurantEcardAccountArgs = {
  input: DisconnectRestaurantEcardAccountTypeInput;
};


export type MutationDisconnectRestaurantLocationAlohaSiteArgs = {
  locationId: Scalars['Int']['input'];
};


export type MutationDisconnectRestaurantLocationHeartlandPosLocationArgs = {
  input: DisconnectRestaurantLocationHeartlandPosLocationInput;
};


export type MutationDisconnectRestaurantLocationMicrosRvcArgs = {
  input: DisconnectRestaurantLocationMicrosRvcInput;
};


export type MutationDisconnectRestaurantLocationNcrSilverStoreArgs = {
  locationId: Scalars['Int']['input'];
};


export type MutationDisconnectRestaurantLocationPaymentAccountsArgs = {
  input: DisconnectRestaurantLocationPaymentAccountsInput;
};


export type MutationDisconnectRestaurantLocationSpotonLocationArgs = {
  input: DisconnectRestaurantLocationSpotonLocationInput;
};


export type MutationDisconnectSalesforceAccountArgs = {
  input: DisconnectSalesforceAccountInput;
};


export type MutationDismissFailedFollowerImportArgs = {
  input: FollowerImportDismissFailureInput;
};


export type MutationDismissFailedMessageGroupArgs = {
  input: DismissFailedMessageGroupInput;
};


export type MutationDismissFailedPostsArgs = {
  input: DismissFailedPostsInput;
};


export type MutationDismissFailedTextMessageGroupArgs = {
  input: DismissFailedTextMessageGroupInput;
};


export type MutationDismissFollowerMassActionNotificationsArgs = {
  input: FollowerDismissMassActionNotificationsInput;
};


export type MutationDismissNoticeArgs = {
  noticeId: Scalars['Int']['input'];
};


export type MutationDismissReviewBannerArgs = {
  input: UpdateRestaurantMemberDismissReviewBannerInput;
};


export type MutationDismissSocialPostFailureIndicatorsArgs = {
  input: DismissSocialPostFailureIndicatorsInput;
};


export type MutationDismissSuggestedPostsArgs = {
  input: DismissSuggestedPostsInput;
};


export type MutationDismissTaskActionArgs = {
  taskActionId: Scalars['Int']['input'];
};


export type MutationEarnLoyaltyProgramPromotionPointsArgs = {
  input: EarnLoyaltyProgramPromotionPointsInput;
};


export type MutationEditTableTopArgs = {
  input: EditTableTopInput;
};


export type MutationEnableUserAuthyArgs = {
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationEnableUserTotpArgs = {
  input: CreateTwilioVerifyTotpFactorInput;
};


export type MutationEnqueueLighthouseReportArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type MutationEstimateAddonArgs = {
  addons?: InputMaybe<Array<AddonCheckoutAddonInput>>;
  billingSubscriptionId: Scalars['Int']['input'];
  chargebeeCustomerId: Scalars['String']['input'];
  charges?: InputMaybe<Array<AddonCheckoutAddonInput>>;
  couponId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEvaluateAiMarketingContentArgs = {
  input: EvaluateAiMarketingContentInput;
};


export type MutationExportAllFormsArgs = {
  daysAgo?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type MutationExportOrderingEventArgs = {
  input: ExportOrderingEventInput;
};


export type MutationExportOrdersArgs = {
  input: CreateOrderExportInput;
};


export type MutationExportOverviewArgs = {
  input: CreateOverviewExportInput;
};


export type MutationExportReservationsArgs = {
  input: ExportReservationsInput;
};


export type MutationExportSelectedUploadsArgs = {
  input: ExportSelectedUploadsInput;
};


export type MutationExportSingleFormArgs = {
  advancedFormId: Scalars['Int']['input'];
  daysAgo?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationFetchCustomPageSectionFoodtecBalanceArgs = {
  captchaResponse: Scalars['String']['input'];
  cardNumber: Scalars['String']['input'];
  customPageSectionId: Scalars['Int']['input'];
  pin: Scalars['String']['input'];
};


export type MutationFindOrCreateStubUserArgs = {
  input: FindOrCreateStubUserInput;
};


export type MutationFollowerMassActionArgs = {
  input: FollowerMassActionInput;
};


export type MutationFollowerSignInQrCardArgs = {
  input: CreateFollowerQrCardInput;
};


export type MutationForceSignOutUsersArgs = {
  input: ForceSignOutUsersInput;
};


export type MutationForceSyncMasterMenuArgs = {
  input: MenuForceSyncMasterInput;
};


export type MutationGenerateAiMarketingExampleContentResponseArgs = {
  input: GenerateAiMarketingGenerateExampleContentResponseInput;
};


export type MutationGenerateAiMarketingPromptArgs = {
  input: GenerateAiMarketingPromptInput;
};


export type MutationGenerateAiResponseArgs = {
  input: GenerateAiResponseInput;
};


export type MutationGenerateAiTextArgs = {
  input: GenerateAiTextInput;
};


export type MutationGenerateCampaignContentArgs = {
  input: GenerateAiMarketingCampaignContentInput;
};


export type MutationGenerateMessageGroupAiTextArgs = {
  input: GenerateMessageGroupAiTextInput;
};


export type MutationGenerateRestaurantContentArgs = {
  input: GenerateRestaurantContentTypeInput;
};


export type MutationGenerateTextMessageGroupAiTextArgs = {
  input: GenerateTextMessageGroupAiTextInput;
};


export type MutationGenerateYourToneSampleArgs = {
  input: GenerateYourToneSampleTypeInput;
};


export type MutationGradeAimPlaygroundEvaluationSetArgs = {
  input: GradeAimPlaygroundEvaluationSetInput;
};


export type MutationImpersonateUserArgs = {
  input: ImpersonateUserInput;
};


export type MutationInitializeChannelArgs = {
  input: InitializeChannelInput;
};


export type MutationInitiateMenuProcessingArgs = {
  input: InitiateMenuProcessingInput;
};


export type MutationInvalidateGiftCardArgs = {
  input: InvalidateGiftCardInput;
};


export type MutationLeaveWaitlistArgs = {
  token: Scalars['String']['input'];
};


export type MutationLinkGoogleMyBusinessLocationArgs = {
  googleLocationId: Scalars['Int']['input'];
  locationId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type MutationMarkAsReviewedArgs = {
  input: MarkAsReviewedInput;
};


export type MutationMarkMenuItemCartIssueSeenArgs = {
  input: MarkMenuItemCartIssueSeenInput;
};


export type MutationMarkMenuItemCartSelectedMenuItemOutOfStockArgs = {
  menuItemCartId: Scalars['Int']['input'];
  selectedMenuItemId: Scalars['Int']['input'];
};


export type MutationMarkTaskActionsReadArgs = {
  input: MarkTaskActionsReadInput;
};


export type MutationMergeDishArgs = {
  input: MergeDishInput;
};


export type MutationMoveSelectedUploadsArgs = {
  input: MoveSelectedUploadsInput;
};


export type MutationPauseExternalIntegrationArgs = {
  externalIntegrationId: Scalars['Int']['input'];
  pause: Scalars['Boolean']['input'];
  pauseUntil?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationPreparePhoneRegistrationArgs = {
  input: PreparePhoneRegistrationInput;
};


export type MutationPreviewHungrrrPayConnectionArgs = {
  input: PreviewHungrrrPayConnectionInput;
};


export type MutationPromoteAimPromptConfigToDefaultArgs = {
  input: PromoteAimPromptConfigToDefaultInput;
};


export type MutationPromoteMenuArgs = {
  input: MenuPromoteInput;
};


export type MutationPublishBillingSubscriptionArgs = {
  billingSubscriptionId: Scalars['Int']['input'];
};


export type MutationPublishCustomPageDraftsArgs = {
  input: PublishCustomPageDraftsInput;
};


export type MutationPublishGoogleMyBusinessLocationArgs = {
  googleLocationId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type MutationPublishLiveDomainArgs = {
  input: PublishLiveDomainInput;
};


export type MutationRecoverTicketCartForCheckoutArgs = {
  input: RecoverTicketCartForCheckoutInput;
};


export type MutationRedeemOfferCodeArgs = {
  offerCode: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type MutationRedoDraftChangesArgs = {
  customPageId: Scalars['Int']['input'];
};


export type MutationRefreshEcardBalanceArgs = {
  menuItemCartId: Scalars['Int']['input'];
};


export type MutationRefreshMessageGroupAiTextArgs = {
  input: RefreshMessageGroupAiTextInput;
};


export type MutationRefreshRestaurantMemberInviteArgs = {
  inviteId: Scalars['Int']['input'];
};


export type MutationRefreshSocialPostAiTextArgs = {
  input: RefreshSocialPostAiTextInput;
};


export type MutationRefreshTextMessageGroupAiTextArgs = {
  input: RefreshTextMessageGroupAiTextInput;
};


export type MutationRefundMenuItemCartGiftCardPaymentArgs = {
  menuItemCartId: Scalars['Int']['input'];
};


export type MutationRefundMenuItemCartPaymentArgs = {
  menuItemCartId: Scalars['Int']['input'];
  refundMenuItemCartPaymentInput: RefundMenuItemCartPaymentInput;
};


export type MutationRegenerateRestaurantWebhookTokenArgs = {
  input: RegenerateRestaurantWebhookTokenInput;
};


export type MutationReleaseContentAuditArgs = {
  channel: Scalars['String']['input'];
  id: Scalars['Int']['input'];
};


export type MutationRemoveAppliedRewardArgs = {
  input: RemoveAppliedRewardInput;
};


export type MutationRemoveFeaturedItemDraftArgs = {
  featuredItemId: Scalars['Int']['input'];
  sectionId: Scalars['Int']['input'];
};


export type MutationRemoveGiftCardArgs = {
  menuItemCartId: Scalars['Int']['input'];
};


export type MutationRemoveMenuItemFromFeaturedSectionArgs = {
  menuFeaturedSectionId: Scalars['Int']['input'];
  menuItemId: Scalars['Int']['input'];
};


export type MutationRemoveOrderingOfferCodeArgs = {
  menuItemCartId: Scalars['Int']['input'];
};


export type MutationRemoveRestaurantDomainArgs = {
  input: RestaurantRemoveDomainInput;
};


export type MutationRemoveRestaurantFromGroupArgs = {
  input: RemoveRestaurantFromGroupInput;
};


export type MutationRemoveSourceFromPendingImportArgs = {
  restaurantId: Scalars['Int']['input'];
  woflowImportSourceId: Scalars['Int']['input'];
};


export type MutationRenewSocialAccountArgs = {
  authCode: Scalars['String']['input'];
  socialAccountId: Scalars['Int']['input'];
};


export type MutationRequestCheckoutSalesAssistanceArgs = {
  input: RequestCheckoutSalesAssistanceInput;
};


export type MutationRequestRestaurantLocationOrdernerdTokenArgs = {
  locationId: Scalars['Int']['input'];
};


export type MutationResendGiftCardArgs = {
  input: ResendGiftCardInput;
};


export type MutationResetMyMfaArgs = {
  input: ResetMyMfaInput;
};


export type MutationResetRestaurantMemberMfaArgs = {
  input: ResetRestaurantMemberMfaInput;
};


export type MutationRestaurantMemberLocationAlertDismissedArgs = {
  input: RestaurantMemberLocationAlertDismissedInput;
};


export type MutationRestoreAdvancedFormArgs = {
  input: RestoreAdvancedFormInput;
};


export type MutationRetryFailedFollowerImportArgs = {
  input: FollowerImportRetryInput;
};


export type MutationRetrySocialPostArgs = {
  input: RetrySocialPostInput;
};


export type MutationRunAimFeatureEvaluationArgs = {
  input: RunAimFeatureEvaluationInput;
};


export type MutationRunRestaurantLocationOrderingBillingConfigProcessArgs = {
  input: RunProcessInput;
};


export type MutationSalesforceMigrationConnectAccountToLocationArgs = {
  input: SalesforceMigrationConnectAccountToLocationInput;
};


export type MutationSalesforceMigrationDisconnectAccountFromLocationArgs = {
  input: SalesforceMigrationDisconnectAccountFromLocationInput;
};


export type MutationSaveTwilioBusinessRegistrationArgs = {
  input: SaveTwilioBusinessRegistrationInput;
};


export type MutationSelectIndieBillingPlanArgs = {
  billingPlanId: Scalars['Int']['input'];
};


export type MutationSendMeLinkMessageArgs = {
  input: SendMeLinkMessageInput;
};


export type MutationSendMessageCampaignPreviewArgs = {
  input: SendMessageCampaignPreviewInput;
};


export type MutationSendMessageCampaignTextMessagePreviewArgs = {
  input: SendMessageCampaignTextMessagePreviewInput;
};


export type MutationSendMessageGroupPreviewArgs = {
  input: SendMessageGroupPreviewInput;
};


export type MutationSendPendingEmailAccessCodeArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type MutationSendPhoneVerificationArgs = {
  input: SendPhoneVerificationInput;
};


export type MutationSendTextMessageGroupPreviewArgs = {
  input: SendTextMessageGroupPreviewInput;
};


export type MutationSendUserAccessCodeEmailArgs = {
  email: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
  source?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSendUserAuthyCodeArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationSendUserAutoLoginEmailArgs = {
  email: Scalars['String']['input'];
  modularSignUp?: InputMaybe<Scalars['Boolean']['input']>;
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
  returnTo?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSendUserSmsAccessCodeArgs = {
  phone?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
  userEmail?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetRestaurantPrimaryDomainArgs = {
  input: RestaurantSetPrimaryDomainInput;
};


export type MutationSignInUserArgs = {
  appleCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookCode?: InputMaybe<Scalars['String']['input']>;
  favoriteLocationId?: InputMaybe<Scalars['Int']['input']>;
  googleCode?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
  userEntryPoint?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSignInUserByAccessCodeArgs = {
  accessCode: Scalars['String']['input'];
  isPhoneSignIn?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSkipMfaPhoneFactorArgs = {
  input: SkipTwilioVerifyPhoneFactorInput;
};


export type MutationStartBillingSubscriptionArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type MutationStartPushMfaEnrollmentArgs = {
  input: StartPushMfaEnrollmentInput;
};


export type MutationStartSignUpArgs = {
  input: StartModularSignUpInput;
};


export type MutationStartTrialArgs = {
  input: StartTrialInput;
};


export type MutationStartWaitlistTrialArgs = {
  input: StartWaitlistTrialInput;
};


export type MutationSubmitCampaignArgs = {
  input: SubmitCampaignInput;
};


export type MutationSubmitCcpaRequestArgs = {
  ccpaRequestInput: CcpaRequestInput;
};


export type MutationSubmitMenuItemCartArgs = {
  menuItemCartId: Scalars['Int']['input'];
  menuItemCartInput: MenuItemCartInput;
  shouldCreateFollower?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSubmitPendingImportArgs = {
  instructions?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type MutationSubmitShopItemCartArgs = {
  input: SubmitShopItemCartInput;
};


export type MutationSyncAlohaAccountArgs = {
  input: SyncAlohaAccountInput;
};


export type MutationSyncAlohaMenuFromProviderArgs = {
  input: SyncAlohaMenuFromProviderInput;
};


export type MutationSyncBillingCustomerPaymentMethodsArgs = {
  billingCustomerId: Scalars['Int']['input'];
};


export type MutationSyncCloverAccountArgs = {
  input: SyncCloverAccountInput;
};


export type MutationSyncCloverMenuFromProviderArgs = {
  input: SyncCloverMenuFromProviderInput;
};


export type MutationSyncHeartlandPosArgs = {
  input: SyncHeartlandPosInput;
};


export type MutationSyncMenuForExternalIntegrationArgs = {
  menuId: Scalars['Int']['input'];
};


export type MutationSyncMenuFromProviderArgs = {
  menuId: Scalars['Int']['input'];
};


export type MutationSyncMenuItemCartPaymentV2Args = {
  input: SyncMenuItemCartPaymentV2Input;
};


export type MutationSyncMicrosOrgArgs = {
  input: SyncMicrosOrgInput;
};


export type MutationSyncNcrSilverAccountArgs = {
  input: SyncNcrSilverAccountInput;
};


export type MutationSyncRestaurantSalesforceAccountArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type MutationSyncReviewsArgs = {
  input: YextAccountSyncReviewsInput;
};


export type MutationSyncSandboxLocationsArgs = {
  input: YextAccountSyncSandboxLocationsInput;
};


export type MutationSyncSpotonArgs = {
  input: SyncSpotonInput;
};


export type MutationSyncSquareSellerAccountArgs = {
  squareSellerAccountId: Scalars['Int']['input'];
};


export type MutationSyncSquareSellerAccountCatalogArgs = {
  isSyncFromStart?: InputMaybe<Scalars['Boolean']['input']>;
  squareSellerAccountId: Scalars['Int']['input'];
};


export type MutationSyncSquareSellerAccountLocationsArgs = {
  squareSellerAccountId: Scalars['Int']['input'];
};


export type MutationSyncStripeConnectAccountArgs = {
  stripeConnectAccountId: Scalars['Int']['input'];
};


export type MutationSyncStripeConnectPaymentArgs = {
  stripeConnectPaymentId: Scalars['Int']['input'];
};


export type MutationSyncToastRestaurantArgs = {
  locationId: Scalars['Int']['input'];
  toastRestaurantId: Scalars['Int']['input'];
};


export type MutationSyncYextMenuArgs = {
  input: SyncYextMenuInput;
};


export type MutationSyncYextMenusArgs = {
  input: SyncYextMenusInput;
};


export type MutationToggleFeaturedAnnouncementArgs = {
  announcementId: Scalars['Int']['input'];
  featured: Scalars['Boolean']['input'];
};


export type MutationToggleFeaturedDishArgs = {
  dishId: Scalars['Int']['input'];
  featured: Scalars['Boolean']['input'];
};


export type MutationToggleMenuItemArgs = {
  input: MenuItemToggleInput;
};


export type MutationToggleMenuSyncingArgs = {
  externalIntegrationId: Scalars['Int']['input'];
  toggleValue: Scalars['Boolean']['input'];
};


export type MutationToggleMessageCampaignArgs = {
  id: Scalars['Int']['input'];
  isEnabled: Scalars['Boolean']['input'];
};


export type MutationToggleMessageCampaignSelectedLocationArgs = {
  input: ToggleSelectedLocationInput;
};


export type MutationTogglePopmenuLoyaltyArgs = {
  input: TogglePopmenuLoyaltyInput;
};


export type MutationToggleReviewVoteArgs = {
  reviewId: Scalars['Int']['input'];
};


export type MutationToggleThirdPartyLoyaltyArgs = {
  input: ToggleThirdPartyLoyaltyInput;
};


export type MutationTransferReviewArgs = {
  dishId: Scalars['Int']['input'];
  reviewId: Scalars['Int']['input'];
};


export type MutationTriggerRestaurantAppDeploymentArgs = {
  input: TriggerRestaurantAppDeploymentInput;
};


export type MutationTriggerRestaurantDetectedCookieGenerationArgs = {
  input: TriggerRestaurantDetectedCookieGenerationInput;
};


export type MutationUndoDraftChangesArgs = {
  customPageId: Scalars['Int']['input'];
};


export type MutationUnlinkGoogleMyBusinessLocationArgs = {
  googleLocationId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type MutationUnsubscribeUsersFromAllMarketingArgs = {
  input: UnsubscribeUsersFromAllMarketingInput;
};


export type MutationUpdateActionArgs = {
  input: UpdateRootTaskActionInput;
};


export type MutationUpdateAddonArgs = {
  addons?: InputMaybe<Array<AddonCheckoutAddonInput>>;
  billingSubscriptionId: Scalars['Int']['input'];
  chargebeeCustomerId: Scalars['String']['input'];
  charges?: InputMaybe<Array<AddonCheckoutAddonInput>>;
  couponId?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<RestaurantLocationInput>>;
  paymentMethodId?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodType?: InputMaybe<Scalars['String']['input']>;
  salesforceContactSfid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateAdvancedFormEntryArgs = {
  advancedFormEntryId: Scalars['Int']['input'];
  advancedFormEntryInput: AdvancedFormEntryInput;
};


export type MutationUpdateAiMarketingContentArgs = {
  input: UpdateAiMarketingContentInput;
};


export type MutationUpdateAiMarketingDefaultOptionArgs = {
  input: UpdateAiMarketingDefaultTypeInput;
};


export type MutationUpdateAiReviewResponseDefaultSettingArgs = {
  input: UpdateAiReviewResponseDefaultSettingInput;
};


export type MutationUpdateAimPromptConfigArgs = {
  input: UpdateAimPromptConfigInput;
};


export type MutationUpdateAlohaAccountArgs = {
  input: UpdateAlohaAccountInput;
};


export type MutationUpdateAnnouncementArgs = {
  announcementId: Scalars['Int']['input'];
  announcementInput: AnnouncementInput;
};


export type MutationUpdateAnsweringLocationArgs = {
  answeringLocationId: Scalars['Int']['input'];
  answeringLocationInput: RestaurantMemberLocationInput;
};


export type MutationUpdateBillingBankAccountArgs = {
  billingBankAccountInput: BillingBankAccountInput;
};


export type MutationUpdateBillingCouponArgs = {
  billingCouponId: Scalars['Int']['input'];
  isOnetimeCharge: Scalars['Boolean']['input'];
  isRestricted: Scalars['Boolean']['input'];
  isValid: Scalars['Boolean']['input'];
};


export type MutationUpdateBillingCreditCardArgs = {
  billingCreditCardInput: BillingCreditCardInput;
};


export type MutationUpdateBillingEntitlementFeatureFlagArgs = {
  input: UpdateBillingEntitlementFeatureFlagInput;
};


export type MutationUpdateBillingPlanArgs = {
  billingPlanId: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  isRestricted: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateBillingProductArgs = {
  input: UpdateBillingProductInput;
};


export type MutationUpdateBillingProductPriceArgs = {
  input: UpdateBillingProductPriceInput;
};


export type MutationUpdateBlockedTermArgs = {
  blockedTermId: Scalars['Int']['input'];
  blockedTermInput: BlockedTermInput;
};


export type MutationUpdateBlogPostArgs = {
  blogPost?: InputMaybe<BlogPostInput>;
  id: Scalars['Int']['input'];
};


export type MutationUpdateCalendarEventArgs = {
  calendarEventId: Scalars['Int']['input'];
  calendarEventInput: CalendarEventInput;
};


export type MutationUpdateCalendarEventPopArgs = {
  calendarEventId: Scalars['Int']['input'];
  popType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCampaignItemScheduleArgs = {
  input: UpdateCampaignItemScheduleInput;
};


export type MutationUpdateCloverAccountArgs = {
  input: UpdateCloverAccountInput;
};


export type MutationUpdateCuisineGoogleCategoryArgs = {
  rootCategoryInput: RootCategoryInput;
};


export type MutationUpdateCuisineYextCategoryArgs = {
  rootCategoryInput: RootCategoryInput;
};


export type MutationUpdateCustomFeeArgs = {
  customFeeId: Scalars['Int']['input'];
  customFeeInput: CustomFeeInput;
};


export type MutationUpdateCustomFileArgs = {
  customFileId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateCustomPageArgs = {
  customPage?: InputMaybe<CustomPageInput>;
  id: Scalars['Int']['input'];
};


export type MutationUpdateCustomPageDraftArgs = {
  customPage?: InputMaybe<CustomPageInput>;
  id: Scalars['Int']['input'];
};


export type MutationUpdateCustomPageDraftHeaderArgs = {
  customPage?: InputMaybe<CustomPageInput>;
  id: Scalars['Int']['input'];
};


export type MutationUpdateCustomPageDraftPositionArgs = {
  customPageDraftInputs: Array<RestaurantCustomPageDraftInput>;
  restaurantId: Scalars['Int']['input'];
};


export type MutationUpdateCustomPageHeaderArgs = {
  customPage?: InputMaybe<CustomPageInput>;
  id: Scalars['Int']['input'];
};


export type MutationUpdateCustomPageSectionArgs = {
  id: Scalars['Int']['input'];
  section?: InputMaybe<CustomPageSectionInput>;
};


export type MutationUpdateCustomPageSectionDraftArgs = {
  id: Scalars['Int']['input'];
  section?: InputMaybe<CustomPageSectionInput>;
};


export type MutationUpdateCustomPageSectionDraftNestedFieldsArgs = {
  id: Scalars['Int']['input'];
  section?: InputMaybe<CustomPageSectionNestedFieldsInput>;
};


export type MutationUpdateCustomPageSectionDraftPositionArgs = {
  id: Scalars['Int']['input'];
  up: Scalars['Boolean']['input'];
};


export type MutationUpdateCustomPageSectionNestedFieldsArgs = {
  id: Scalars['Int']['input'];
  section?: InputMaybe<CustomPageSectionNestedFieldsInput>;
};


export type MutationUpdateCustomPageSectionPositionArgs = {
  id: Scalars['Int']['input'];
  up: Scalars['Boolean']['input'];
};


export type MutationUpdateCustomTaxRateArgs = {
  input: UpdateCustomTaxRateInput;
};


export type MutationUpdateDishArgs = {
  dishId: Scalars['Int']['input'];
  dishInput: DishInput;
};


export type MutationUpdateDishAllergensArgs = {
  input: DishUpdateAllergensInput;
};


export type MutationUpdateDishInventoryLocationArgs = {
  input: DishInventoryLocationUpdateInput;
};


export type MutationUpdateDishPhotosArgs = {
  dishId: Scalars['Int']['input'];
  menuItemId?: InputMaybe<Scalars['Int']['input']>;
  photoInputs: Array<PhotoInput>;
};


export type MutationUpdateDishWeightArgs = {
  dishId: Scalars['Int']['input'];
  userDefinedAimWeight: Scalars['Decimal']['input'];
};


export type MutationUpdateEventTagArgs = {
  eventTagId: Scalars['Int']['input'];
  eventTagInput: EventTagInput;
};


export type MutationUpdateFacebookCampaignArgs = {
  input: UpdateFacebookCampaignInput;
};


export type MutationUpdateFeaturedItemDraftsPositionArgs = {
  featuredItemInputs?: InputMaybe<Array<SectionFeaturedItemInput>>;
  sectionId: Scalars['Int']['input'];
};


export type MutationUpdateFeaturedItemReviewDraftArgs = {
  featuredItemId: Scalars['Int']['input'];
  reviewId?: InputMaybe<Scalars['Int']['input']>;
  sectionId: Scalars['Int']['input'];
};


export type MutationUpdateFeaturedSectionItemPositionsArgs = {
  featuredSectionId: Scalars['Int']['input'];
  menuItemInputs: Array<MenuFeaturedSectionItemPositionInput>;
};


export type MutationUpdateFeedbackArgs = {
  input: UpdateFeedbackInput;
};


export type MutationUpdateFeedbackSettingArgs = {
  input: FeedbackSettingUpdateInput;
};


export type MutationUpdateFollowerArgs = {
  followerId: Scalars['Int']['input'];
  followerInput: FollowerInput;
};


export type MutationUpdateFollowerBlockedStatusArgs = {
  followerId: Scalars['Int']['input'];
};


export type MutationUpdateFollowerFavoriteLocationArgs = {
  favoriteLocationId: Scalars['Int']['input'];
  followerId: Scalars['Int']['input'];
};


export type MutationUpdateFollowerSegmentArgs = {
  input: UpdateFollowerSegmentInput;
};


export type MutationUpdateFollowerSelectedTagsArgs = {
  followerId: Scalars['Int']['input'];
  followerSelectedTags: Array<FollowerSelectedTagInput>;
};


export type MutationUpdateFollowerTagArgs = {
  followerTagId: Scalars['Int']['input'];
  followerTagInput: FollowerTagInput;
};


export type MutationUpdateGoogleAccountArgs = {
  enable: Scalars['Boolean']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type MutationUpdateGoogleMyBusinessAttributesArgs = {
  attributes: Array<LocationAttributeInput>;
  googleLocationId: Scalars['Int']['input'];
  locationWebsiteUrl?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateGoogleMyBusinessLocationVisibilityArgs = {
  input: UpdateLocationVisibilityInput;
};


export type MutationUpdateGoogleMyBusinessPostArgs = {
  id: Scalars['Int']['input'];
  input: CreatePostInput;
  locationNames: Array<Scalars['String']['input']>;
};


export type MutationUpdateHeartlandPosSettingArgs = {
  input: HeartlandPosSettingUpdateInput;
};


export type MutationUpdateHighlightPositionsArgs = {
  input: UpdateHighlightPositionsInput;
};


export type MutationUpdateItemModifierPositionsArgs = {
  input: UpdateItemModifierPositionsInput;
};


export type MutationUpdateLiveDomainArgs = {
  liveDomainId: Scalars['Int']['input'];
  liveDomainInput: LiveDomainInput;
};


export type MutationUpdateLocationNcrSilverChargeOptionsArgs = {
  chargeOptionsInput: NcrSilverStoreSettingInput;
  locationId: Scalars['Int']['input'];
};


export type MutationUpdateLocationToastAlternativePaymentTypeArgs = {
  input: UpdateLocationToastAlternativePaymentTypeInput;
};


export type MutationUpdateLocationToastDiningOptionsArgs = {
  input: UpdateLocationToastDiningOptionsInput;
};


export type MutationUpdateLocationToastRevenueCentersArgs = {
  input: UpdateLocationToastRevenueCentersInput;
};


export type MutationUpdateLoginCarouselSlideArgs = {
  id: Scalars['Int']['input'];
  loginCarouselSlideInput: LoginCarouselSlideInput;
};


export type MutationUpdateMarketingOfferArgs = {
  marketingOfferId: Scalars['Int']['input'];
  marketingOfferInput: MarketingOfferInput;
};


export type MutationUpdateMasterMessageCampaignArgs = {
  id: Scalars['Int']['input'];
  masterMessageCampaign: MasterMessageCampaignInput;
};


export type MutationUpdateMemberOnboardingCompletedArgs = {
  memberId: Scalars['Int']['input'];
  onboardingCompleted: Scalars['Boolean']['input'];
};


export type MutationUpdateMenuArgs = {
  input: MenuUpdateInput;
};


export type MutationUpdateMenuFeaturedSectionArgs = {
  menuFeaturedSectionId: Scalars['Int']['input'];
  menuFeaturedSectionInput: MenuFeaturedSectionInput;
};


export type MutationUpdateMenuHighlightSectionArgs = {
  input: MenuHighlightSectionUpdateInput;
};


export type MutationUpdateMenuHighlightSectionPositionsArgs = {
  input: MenuHighlightSectionUpdatePositionsInput;
};


export type MutationUpdateMenuIgnoredIntegrationsArgs = {
  integrationType: Scalars['String']['input'];
  isIgnored: Scalars['Boolean']['input'];
  menuId: Scalars['Int']['input'];
};


export type MutationUpdateMenuItemArgs = {
  input: MenuItemUpdateInput;
};


export type MutationUpdateMenuItemCartArgs = {
  cartType?: InputMaybe<Scalars['String']['input']>;
  existingMenuItemCartId?: InputMaybe<Scalars['Int']['input']>;
  expectedTotal?: InputMaybe<Scalars['Decimal']['input']>;
  followerInput?: InputMaybe<FollowerInput>;
  menuItemCartId?: InputMaybe<Scalars['Int']['input']>;
  menuItemCartInput: MenuItemCartInput;
  paymentInput?: InputMaybe<CartPaymentInput>;
  pickupType?: InputMaybe<Scalars['String']['input']>;
  pickupVehicleColor?: InputMaybe<Scalars['String']['input']>;
  pickupVehicleMakeModel?: InputMaybe<Scalars['String']['input']>;
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
  shouldCreateFollower?: InputMaybe<Scalars['Boolean']['input']>;
  submitMenuItemCart?: InputMaybe<Scalars['Boolean']['input']>;
  userInput?: InputMaybe<UserInput>;
};


export type MutationUpdateMenuItemCartAcknowledgeArgs = {
  menuItemCartId: Scalars['Int']['input'];
  text: Scalars['String']['input'];
};


export type MutationUpdateMenuItemCartArrivalArgs = {
  menuItemCartId: Scalars['Int']['input'];
};


export type MutationUpdateMenuItemCartSelectedMenuItemArgs = {
  selectedMenuItemId: Scalars['Int']['input'];
  selectedMenuItemInput: MenuItemCartSelectedMenuItemInput;
};


export type MutationUpdateMenuItemCartSelectedMenuItemIsVoidArgs = {
  isVoid: Scalars['Boolean']['input'];
  selectedMenuItemId: Scalars['Int']['input'];
};


export type MutationUpdateMenuItemCartStatusArgs = {
  capturePayment?: InputMaybe<Scalars['Boolean']['input']>;
  captureStripeConnectPayment?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemCartId: Scalars['Int']['input'];
  pickupDueMinutes?: InputMaybe<Scalars['Int']['input']>;
  refundGiftCardPayment?: InputMaybe<Scalars['Boolean']['input']>;
  status: Scalars['String']['input'];
};


export type MutationUpdateMenuItemCartSubcartStatusArgs = {
  menuItemCartId: Scalars['Int']['input'];
  status: Scalars['String']['input'];
  subcartId: Scalars['Int']['input'];
};


export type MutationUpdateMenuItemCartViewedAtArgs = {
  input: UpdateMenuItemCartViewedAtInput;
};


export type MutationUpdateMenuItemCateringLimitsArgs = {
  input: MenuItemUpdateCateringLimitsInput;
};


export type MutationUpdateMenuItemContainsAlcoholArgs = {
  input: MenuItemContainsAlcoholInput;
};


export type MutationUpdateMenuItemModGroupsPositionsArgs = {
  input: UpdateMenuItemModGroupsPositionsInput;
};


export type MutationUpdateMenuItemModifierGroupModifierArgs = {
  input: UpdateMenuItemModifierGroupModifierInput;
};


export type MutationUpdateMenuItemOutOfStockArgs = {
  input: MenuItemOutOfStockInput;
};


export type MutationUpdateMenuItemPopArgs = {
  menuItemCartReviewToken?: InputMaybe<Scalars['String']['input']>;
  menuItemId: Scalars['Int']['input'];
  popType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMenuItemReviewArgs = {
  content?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  menuItemCartReviewToken?: InputMaybe<Scalars['String']['input']>;
  menuItemId: Scalars['Int']['input'];
  popType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMenuItemSubsectionArgs = {
  input: MenuItemUpdateSubsectionInput;
};


export type MutationUpdateMenuSectionArgs = {
  input: MenuSectionUpdateInput;
};


export type MutationUpdateMenuSectionPositionsArgs = {
  input: MenuUpdateSectionPositionsInput;
};


export type MutationUpdateMenuSubsectionArgs = {
  input: MenuSubsectionUpdateInput;
};


export type MutationUpdateMenuSubsectionCustomHtmlArgs = {
  customHtml?: InputMaybe<Scalars['String']['input']>;
  menuSubsectionId: Scalars['Int']['input'];
};


export type MutationUpdateMenuSubsectionItemPositionsArgs = {
  input: MenuSubsectionUpdateItemPositionsInput;
};


export type MutationUpdateMenuUploadArgs = {
  id: Scalars['Int']['input'];
  isOloMenu: Scalars['Boolean']['input'];
  isPhoto: Scalars['Boolean']['input'];
  menuCategoryName?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type MutationUpdateMessageCampaignArgs = {
  fromMarketingOffer?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  marketingOfferInput?: InputMaybe<MarketingOfferInput>;
  messageCampaignInput: MessageCampaignInput;
  updateAllLocations?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateMessageCampaignCreateAndAttachOrderingOfferArgs = {
  input: UpdateMessageCampaignCreateAndAttachOrderingOfferInput;
};


export type MutationUpdateMessageCampaignSelectedLocationArgs = {
  input: UpdateSelectedLocationInput;
};


export type MutationUpdateMessageGroupArgs = {
  input: UpdateMessageGroupInput;
};


export type MutationUpdateMessageGroupContentArgs = {
  input: UpdateMessageGroupContentInput;
};


export type MutationUpdateMicrosOrgArgs = {
  input: UpdateMicrosOrgInput;
};


export type MutationUpdateModifierGroupArgs = {
  input: UpdateModifierGroupInput;
};


export type MutationUpdateModularSignUpProgressArgs = {
  input: UpdateModularSignUpProgressInput;
};


export type MutationUpdateNavLinkStatusArgs = {
  id: Scalars['Int']['input'];
  isEnabled: Scalars['Boolean']['input'];
};


export type MutationUpdateNcrPaymentAccountArgs = {
  input: UpdateNcrPaymentAccountInput;
};


export type MutationUpdateNewOnboardingInfoArgs = {
  memberId?: InputMaybe<Scalars['Int']['input']>;
  onboardingInfoInput: RestaurantOnboardingInfoInput;
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateNewOnboardingInfoLinksArgs = {
  memberId?: InputMaybe<Scalars['Int']['input']>;
  onboardingInfoLinksInput: Array<RestaurantOnboardingInfoLinksInput>;
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateOfferArgs = {
  offerId: Scalars['Int']['input'];
  offerInput: OfferInput;
};


export type MutationUpdateOpentableModifiersArgs = {
  menuId: Scalars['Int']['input'];
  menuInput: MenuInput;
};


export type MutationUpdateOrCreateIntentCustomResponseArgs = {
  action: Scalars['Int']['input'];
  fallbackPhoneId: Scalars['Int']['input'];
  intentName: Scalars['String']['input'];
  link: Scalars['String']['input'];
  locationId: Scalars['Int']['input'];
  response: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationUpdateOrderingBlackoutArgs = {
  input: UpdateOrderingBlackoutInput;
};


export type MutationUpdateOrderingEventArgs = {
  input: UpdateOrderingEventInput;
};


export type MutationUpdateOrderingEventSelectedMenuArgs = {
  input: UpdateOrderingEventSelectedMenuInput;
};


export type MutationUpdateOrderingOfferArgs = {
  input: UpdateOrderingOfferInput;
};


export type MutationUpdatePartyArgs = {
  partyId: Scalars['Int']['input'];
  partyInput: PartyInput;
};


export type MutationUpdatePartySettingsArgs = {
  partySettingsInput: PartySettingsInput;
};


export type MutationUpdatePhotosArgs = {
  input: UploadPhotoTypesInput;
};


export type MutationUpdatePhotosAimAvailableArgs = {
  input: UploadPhotosAimAvailableTypeInput;
};


export type MutationUpdatePopmenuLoyaltyProgramRuleArgs = {
  input: UpdatePopmenuLoyaltyProgramRuleInput;
};


export type MutationUpdatePrintLayoutArgs = {
  printLayoutId: Scalars['Int']['input'];
  printLayoutInput: PrintLayoutInput;
};


export type MutationUpdatePushMessageGroupArgs = {
  input: UpdatePushMessageGroupInput;
};


export type MutationUpdatePushNotificationClickedAtArgs = {
  input: UpdatePushNotificationClickedAtInput;
};


export type MutationUpdateReservationBlackoutsArgs = {
  input: UpdateReservationBlackoutsInput;
};


export type MutationUpdateRestaurantArgs = {
  restaurantId: Scalars['Int']['input'];
  restaurantInput: RestaurantInput;
};


export type MutationUpdateRestaurantActionBarArgs = {
  actionBarId: Scalars['Int']['input'];
  actionBarInput: RestaurantActionBarInput;
};


export type MutationUpdateRestaurantActionBarDraftArgs = {
  actionBarId: Scalars['Int']['input'];
  actionBarInput: RestaurantActionBarInput;
};


export type MutationUpdateRestaurantActionBarLinkDraftsArgs = {
  actionBarLinkInputs: Array<RestaurantActionBarLinkInput>;
  restaurantId: Scalars['Int']['input'];
};


export type MutationUpdateRestaurantAdvancedArgs = {
  advancedInput: RestaurantAdvancedInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationUpdateRestaurantBlogSettingsArgs = {
  customBlogTitle?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type MutationUpdateRestaurantConciergeGoalArgs = {
  conciergeGoalInput: RestaurantConciergeGoalInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationUpdateRestaurantConsentManagerConfigArgs = {
  input: UpdateRestaurantConsentManagerConfigInput;
};


export type MutationUpdateRestaurantCustomRedirectArgs = {
  customRedirectId: Scalars['Int']['input'];
  fromPath?: InputMaybe<Scalars['String']['input']>;
  hostname?: InputMaybe<Scalars['String']['input']>;
  isMatchAll?: InputMaybe<Scalars['Boolean']['input']>;
  isPermanent?: InputMaybe<Scalars['Boolean']['input']>;
  redirectType: Scalars['String']['input'];
  toExternalUrl?: InputMaybe<Scalars['String']['input']>;
  toPath?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateRestaurantCustomScriptArgs = {
  input: UpdateRestaurantCustomScriptInput;
};


export type MutationUpdateRestaurantCustomTrackingArgs = {
  input: UpdateRestaurantCustomTrackingInput;
};


export type MutationUpdateRestaurantDefaultFulfillmentTypeArgs = {
  input: UpdateRestaurantDefaultFulfillmentTypeInput;
};


export type MutationUpdateRestaurantDishTagArgs = {
  dishTagId: Scalars['Int']['input'];
  dishTagInput: RestaurantDishTagInput;
};


export type MutationUpdateRestaurantEmbedArgs = {
  restaurantEmbedId: Scalars['Int']['input'];
  restaurantEmbedInput: RestaurantEmbedInput;
};


export type MutationUpdateRestaurantFeatureSettingArgs = {
  featureSettingInput: RestaurantFeatureSettingInput;
  locationsFeatureSettingInput?: InputMaybe<Array<RestaurantLocationFeatureSettingInput>>;
  restaurantId: Scalars['Int']['input'];
};


export type MutationUpdateRestaurantFollowerArgs = {
  input: UpdateFollowerInput;
};


export type MutationUpdateRestaurantFooterItemDraftsArgs = {
  footerItemInputs: Array<RestaurantNavItemInput>;
  restaurantId: Scalars['Int']['input'];
};


export type MutationUpdateRestaurantFooterItemsArgs = {
  footerItemInputs: Array<RestaurantNavItemInput>;
  restaurantId: Scalars['Int']['input'];
};


export type MutationUpdateRestaurantFooterLinkArgs = {
  footerLinkInput: RestaurantNavLinkInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateRestaurantFooterLinkDraftArgs = {
  footerLinkInput: RestaurantNavLinkInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateRestaurantFooterSettingsArgs = {
  displayRestaurantLocations: Scalars['Boolean']['input'];
  displayRestaurantLocationsHours: Scalars['Boolean']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type MutationUpdateRestaurantFromGmbArgs = {
  locationId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
  restaurantInput: RestaurantInput;
};


export type MutationUpdateRestaurantGiftCardPurchasingStatusArgs = {
  giftCardPurchasingStatus: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type MutationUpdateRestaurantGroupArgs = {
  input: UpdateRestaurantGroupInput;
};


export type MutationUpdateRestaurantHostingArgs = {
  hostingInput: RestaurantHostingInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationUpdateRestaurantIndieOnboardingInfoArgs = {
  onboardingInfoInput: RestaurantOnboardingInfoInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationUpdateRestaurantLegalDocumentArgs = {
  input: UpdateRestaurantLegalDocumentInput;
};


export type MutationUpdateRestaurantLocationArgs = {
  locationId: Scalars['Int']['input'];
  locationInput: RestaurantLocationInput;
};


export type MutationUpdateRestaurantLocationAlohaSiteSettingArgs = {
  input: UpdateRestaurantLocationAlohaSiteSettingInput;
};


export type MutationUpdateRestaurantLocationAnsweringSettingArgs = {
  answeringSettingsInput: RestaurantLocationAnsweringSettingInput;
  locationId: Scalars['Int']['input'];
};


export type MutationUpdateRestaurantLocationAuthorizeAccountArgs = {
  input: UpdateAuthorizeAccountInput;
};


export type MutationUpdateRestaurantLocationCloverAccountArgs = {
  cloverAccountId?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
};


export type MutationUpdateRestaurantLocationEverywareAccountArgs = {
  input: UpdateEverywareAccountInput;
};


export type MutationUpdateRestaurantLocationExternalIntegrationsSettingsArgs = {
  locationId: Scalars['Int']['input'];
  settingsInput: RestaurantLocationExternalIntegrationsSettingsInput;
};


export type MutationUpdateRestaurantLocationFromGmbArgs = {
  locationId: Scalars['Int']['input'];
  locationInput: RestaurantLocationInput;
};


export type MutationUpdateRestaurantLocationHeartlandAccountArgs = {
  heartlandAccountId?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
};


export type MutationUpdateRestaurantLocationMenuPositionsArgs = {
  locationId: Scalars['Int']['input'];
  menuInputs: Array<PositionInput>;
};


export type MutationUpdateRestaurantLocationMicrosSettingArgs = {
  input: UpdateRestaurantLocationMicrosSettingInput;
};


export type MutationUpdateRestaurantLocationNcrSilverStoreSettingArgs = {
  locationId: Scalars['Int']['input'];
  storeSettingInput: NcrSilverStoreSettingInput;
};


export type MutationUpdateRestaurantLocationNmiAccountArgs = {
  input: UpdateNmiAccountInput;
};


export type MutationUpdateRestaurantLocationOrderingDelayArgs = {
  delayAmount: Scalars['Int']['input'];
  locationId: Scalars['Int']['input'];
};


export type MutationUpdateRestaurantLocationOrderingMenusArgs = {
  locationId: Scalars['Int']['input'];
  menuInputs: Array<MenuInput>;
};


export type MutationUpdateRestaurantLocationOrderingPaymentArgs = {
  isCloverPaymentRequestButtonEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isSquarePaymentRequestButtonEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isStripePaymentRequestButtonEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isToastPaymentRequestButtonEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['Int']['input'];
};


export type MutationUpdateRestaurantLocationPositionArgs = {
  id: Scalars['Int']['input'];
  up: Scalars['Boolean']['input'];
};


export type MutationUpdateRestaurantLocationSocialHandlesArgs = {
  locationId: Scalars['Int']['input'];
  socialHandles?: InputMaybe<Array<RestaurantLocationSocialHandleInput>>;
};


export type MutationUpdateRestaurantLocationSquareLocationArgs = {
  createNewSquareLocation?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['Int']['input'];
  squareLocationId?: InputMaybe<Scalars['Int']['input']>;
  squareSellerAccountId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateRestaurantLocationStripeAccountArgs = {
  locationId: Scalars['Int']['input'];
  stripeConnectAccountId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateRestaurantLocationToastRestaurantArgs = {
  locationId: Scalars['Int']['input'];
  toastRestaurantId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateRestaurantLocationToastSettingArgs = {
  locationId: Scalars['Int']['input'];
  toastSettingInput: ToastSettingInput;
};


export type MutationUpdateRestaurantLogosArgs = {
  restaurantId: Scalars['Int']['input'];
  restaurantLogosInput: RestaurantLogosInput;
};


export type MutationUpdateRestaurantMemberArgs = {
  memberId: Scalars['Int']['input'];
  memberInput: RestaurantMemberInput;
};


export type MutationUpdateRestaurantMemberDismissEngagementOffersArgs = {
  input: UpdateRestaurantMemberDismissEngagementOffersInput;
};


export type MutationUpdateRestaurantMemberDismissEngagementOffersBannerArgs = {
  input: UpdateRestaurantMemberDismissEngagementOffersBannerInput;
};


export type MutationUpdateRestaurantMemberInviteArgs = {
  inviteId: Scalars['Int']['input'];
  inviteInput: RestaurantMemberInviteInput;
};


export type MutationUpdateRestaurantMemberLocationOrderNotificationsArgs = {
  input: UpdateRestaurantMemberLocationOrderNotificationsInput;
};


export type MutationUpdateRestaurantMemberNotificationsArgs = {
  memberId: Scalars['Int']['input'];
  memberInput: RestaurantMemberNotificationOptionsInputType;
};


export type MutationUpdateRestaurantMemberOnboardingArgs = {
  memberId: Scalars['Int']['input'];
  onboardingCompletionDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingLaunchDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingWelcomeDismissed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateRestaurantMessagePackArgs = {
  input: UpdateRestaurantMessagePackInput;
};


export type MutationUpdateRestaurantNavDropdownArgs = {
  id: Scalars['Int']['input'];
  navDropdownInput: RestaurantNavDropdownInput;
};


export type MutationUpdateRestaurantNavDropdownDraftArgs = {
  id: Scalars['Int']['input'];
  navDropdownInput: RestaurantNavDropdownInput;
};


export type MutationUpdateRestaurantNavDropdownDraftNavLinksArgs = {
  navDropdownId: Scalars['Int']['input'];
  navItemInputs: Array<RestaurantNavItemInput>;
};


export type MutationUpdateRestaurantNavDropdownNavLinksArgs = {
  navDropdownId: Scalars['Int']['input'];
  navItemInputs: Array<RestaurantNavItemInput>;
};


export type MutationUpdateRestaurantNavItemDraftsArgs = {
  navItemInputs: Array<RestaurantNavItemInput>;
  restaurantId: Scalars['Int']['input'];
};


export type MutationUpdateRestaurantNavItemsArgs = {
  navItemInputs: Array<RestaurantNavItemInput>;
  restaurantId: Scalars['Int']['input'];
};


export type MutationUpdateRestaurantNavLinkArgs = {
  id: Scalars['Int']['input'];
  navLinkInput: RestaurantNavLinkInput;
};


export type MutationUpdateRestaurantNavLinkDraftArgs = {
  id: Scalars['Int']['input'];
  navLinkInput: RestaurantNavLinkInput;
};


export type MutationUpdateRestaurantOnboardingInfoArgs = {
  onboardingInfoInput: RestaurantOnboardingInfoInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationUpdateRestaurantOnboardingInfoLinkArgs = {
  id: Scalars['Int']['input'];
  isOloMenu: Scalars['Boolean']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type MutationUpdateRestaurantOnboardingInfoOrderingStartedAtArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type MutationUpdateRestaurantOnboardingStatusArgs = {
  restaurantId: Scalars['Int']['input'];
  status: Scalars['String']['input'];
};


export type MutationUpdateRestaurantOnboardingWoflowImportArgs = {
  restaurantId: Scalars['Int']['input'];
  woflowImportId: Scalars['Int']['input'];
};


export type MutationUpdateRestaurantOrderingMobileBrandColorArgs = {
  input: UpdateRestaurantOrderingMobileBrandColorInput;
};


export type MutationUpdateRestaurantOrderingSettingsArgs = {
  input: RestaurantOrderingInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationUpdateRestaurantProfileArgs = {
  restaurantId: Scalars['Int']['input'];
  restaurantProfileInput: RestaurantProfileInput;
};


export type MutationUpdateRestaurantScriptSettingsArgs = {
  input: UpdateRestaurantScriptSettingsInput;
};


export type MutationUpdateRestaurantSignUpSettingArgs = {
  signUpSettingId: Scalars['Int']['input'];
  signUpSettingInput: SignUpSettingInput;
};


export type MutationUpdateRestaurantSignUpSettingDraftArgs = {
  signUpSettingId: Scalars['Int']['input'];
  signUpSettingInput: SignUpSettingInput;
};


export type MutationUpdateRestaurantSocialHandleDraftsArgs = {
  restaurantId: Scalars['Int']['input'];
  socialHandleDrafts?: InputMaybe<Array<RestaurantSocialHandleInput>>;
};


export type MutationUpdateRestaurantSocialHandlesArgs = {
  restaurantId: Scalars['Int']['input'];
  socialHandles?: InputMaybe<Array<RestaurantSocialHandleInput>>;
};


export type MutationUpdateRestaurantSproutSocialGroupArgs = {
  input: UpdateRestaurantSproutSocialGroupInput;
};


export type MutationUpdateRestaurantSquareAccountArgs = {
  restaurantId: Scalars['Int']['input'];
  squareSellerAccountId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateRestaurantStripeAccountArgs = {
  restaurantId: Scalars['Int']['input'];
  stripeConnectAccountId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateRestaurantThemeArgs = {
  restaurantId: Scalars['Int']['input'];
  themeInput?: InputMaybe<ThemeInput>;
};


export type MutationUpdateRestaurantThemeDraftArgs = {
  restaurantId: Scalars['Int']['input'];
  themeInput?: InputMaybe<ThemeInput>;
};


export type MutationUpdateRestaurantToastRestaurantArgs = {
  restaurantId: Scalars['Int']['input'];
  toastRestaurantId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateRestaurantUserSettingArgs = {
  input: UpdateRestaurantUserSettingInput;
};


export type MutationUpdateRestaurantVipSettingsArgs = {
  input: UpdateRestaurantVipSettingsInput;
};


export type MutationUpdateReviewReplyArgs = {
  content: Scalars['String']['input'];
  isPublic: Scalars['Boolean']['input'];
  reviewId: Scalars['Int']['input'];
};


export type MutationUpdateReviewStatusArgs = {
  affectTasks?: InputMaybe<Scalars['Boolean']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  autoResponseState?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  reviewId: Scalars['Int']['input'];
};


export type MutationUpdateRoleMemberArgs = {
  memberId: Scalars['Int']['input'];
  updateRoleMemberInput: UpdateRoleMemberInput;
};


export type MutationUpdateRootAnnouncementArgs = {
  rootAnnouncementId: Scalars['Int']['input'];
  rootAnnouncementInput: RootAnnouncementInput;
};


export type MutationUpdateRootDishTagArgs = {
  rootDishTagId: Scalars['Int']['input'];
  rootDishTagInput: RootDishTagInput;
};


export type MutationUpdateRootGroupArgs = {
  rootGroupId: Scalars['Int']['input'];
  rootGroupInput: RootGroupInput;
};


export type MutationUpdateRootMessagePackArgs = {
  input: UpdateRootMessagePackInput;
};


export type MutationUpdateRootMessagePackCommunicationArgs = {
  input: UpdateRootMessagePackCommunicationInput;
};


export type MutationUpdateRootMessagePackMessageArgs = {
  input: UpdateRootMessagePackMessageInput;
};


export type MutationUpdateRootMessagePackSocialPostArgs = {
  input: UpdateRootMessagePackSocialPostInput;
};


export type MutationUpdateRootNoteArgs = {
  rootNoteId: Scalars['Int']['input'];
  rootNoteInput: RootNoteInput;
};


export type MutationUpdateRootSectionTemplateArgs = {
  rootSectionTemplateId: Scalars['Int']['input'];
  rootSectionTemplateInput: RootSectionTemplateInput;
};


export type MutationUpdateRootSectionTypeArgs = {
  rootSectionTypeId: Scalars['Int']['input'];
  rootSectionTypeInput: RootSectionTypeInput;
};


export type MutationUpdateRootSiteTemplateArgs = {
  rootSiteTemplateId: Scalars['Int']['input'];
  rootSiteTemplateInput: RootSiteTemplateInput;
};


export type MutationUpdateRootTaskArgs = {
  id: Scalars['Int']['input'];
  rootTaskInput: RootTaskInput;
};


export type MutationUpdateRootThemeArgs = {
  rootThemeId: Scalars['Int']['input'];
  rootThemeInput: RootThemeInput;
};


export type MutationUpdateRootThemeTemplateArgs = {
  rootThemeTemplateId: Scalars['Int']['input'];
  rootThemeTemplateInput: RootThemeTemplateInput;
};


export type MutationUpdateSocialAccountArgs = {
  id: Scalars['Int']['input'];
  selectedFacebookPageId?: InputMaybe<Scalars['Int']['input']>;
  socialAccountSelectedLocations?: InputMaybe<Array<SocialAccountSelectedLocationInput>>;
  syncAiMarketingSocialPostsSelectedLocations?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateSocialAccountsArgs = {
  socialAccountsInput: Array<SocialAccountInput>;
  syncAiMarketingSocialPostsSelectedLocations?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateSocialPostArgs = {
  input: UpdateSocialPostInput;
};


export type MutationUpdateSpotonSettingArgs = {
  input: UpdateSpotonSettingInput;
};


export type MutationUpdateSquareMenuSectionsAvailabilityArgs = {
  input: UpdateSquareMenuSectionsAvailabilityInput;
};


export type MutationUpdateStatusCampaignItemArgs = {
  input: UpdateStatusCampaignItemInput;
};


export type MutationUpdateSuggestedDishArgs = {
  dishSuggestedDishId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
  suggestedDishInput: SuggestedDishInput;
};


export type MutationUpdateSuggestedDishPositionArgs = {
  dishId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
  suggestedDishInput: Array<SuggestedDishPositionInputType>;
};


export type MutationUpdateTextMessageGroupArgs = {
  input: UpdateTextMessageGroupInput;
};


export type MutationUpdateThemeFontArgs = {
  themeFontId: Scalars['Int']['input'];
  themeFontInput: ThemeFontInput;
};


export type MutationUpdateThrottleSettingArgs = {
  throttleSettingId: Scalars['Int']['input'];
  throttleSettingInput: ThrottleSettingInput;
};


export type MutationUpdateTicketCartArgs = {
  input: UpdateTicketCartInput;
};


export type MutationUpdateToastHostedPaymentIntentArgs = {
  captchaMode?: InputMaybe<Scalars['String']['input']>;
  captchaResponse?: InputMaybe<Scalars['String']['input']>;
  intentId: Scalars['String']['input'];
  menuItemCartId: Scalars['Int']['input'];
  tipAmount?: InputMaybe<Scalars['Decimal']['input']>;
};


export type MutationUpdateToastRestaurantConnectionArgs = {
  restaurantIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  toastRestaurantId: Scalars['Int']['input'];
};


export type MutationUpdateToastRestaurantServiceChargesArgs = {
  input: UpdateToastRestaurantServiceChargesInput;
};


export type MutationUpdateTwilioPhoneCallArgs = {
  callSid: Scalars['String']['input'];
  updatePhoneCallInput: PhoneCallUpdateInputType;
};


export type MutationUpdateTwilioPhoneCallIsReadArgs = {
  input: UpdateTwilioPhoneCallIsReadInput;
};


export type MutationUpdateUnreadFeedbackArgs = {
  input: UpdateUnreadFeedbackInput;
};


export type MutationUpdateUploadArgs = {
  id: Scalars['Int']['input'];
  uploadInput: UploadedPhotoInput;
  uploadType: Scalars['String']['input'];
};


export type MutationUpdateUploadFolderArgs = {
  input: UpdateUploadFolderInput;
};


export type MutationUpdateUploadStepsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type MutationUpdateUpsellCampaignArgs = {
  input: UpdateUpsellCampaignInput;
};


export type MutationUpdateUserArgs = {
  userId: Scalars['Int']['input'];
  userInput?: InputMaybe<UserInput>;
};


export type MutationUpdateUserFeatureIntroductionArgs = {
  input: UpdateUserFeatureIntroductionInput;
};


export type MutationUpdateUserLastReleaseIdArgs = {
  releaseId: Scalars['String']['input'];
};


export type MutationUpdateUserPasswordArgs = {
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationUpdateUserSubscriptionsArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  messageGroupMessageToken?: InputMaybe<Scalars['String']['input']>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  unsubscribedRestaurantIds: Array<Scalars['Int']['input']>;
};


export type MutationUpdateUserUploadedAvatarArgs = {
  uploadedAvatarId: Scalars['Int']['input'];
};


export type MutationUpdateYextAccountArgs = {
  input: UpdateYextAccountInput;
};


export type MutationUpgradeRequestArgs = {
  requestType: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type MutationUpsertDeviceRegistrationArgs = {
  deviceInfo: Scalars['String']['input'];
  os: Scalars['String']['input'];
  pushToken: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationUpsertLeadArgs = {
  leadInput: LeadInput;
  resellerAccountEmail?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertLocationBillingSubscriptionArgs = {
  billingSubscriptionInput: BillingSubscriptionInput;
  locationId: Scalars['Int']['input'];
};


export type MutationUpsertLocationSalesforceAccountArgs = {
  locationId: Scalars['Int']['input'];
  salesforceAccountInput: SalesforceAccountInput;
};


export type MutationUpsertNotificationDeviceArgs = {
  input: UpsertNotificationDeviceInput;
};


export type MutationUpsertRestaurantBillingCustomerArgs = {
  billingCustomerInput: BillingCustomerInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationUpsertRestaurantBillingSubscriptionArgs = {
  billingSubscriptionInput: BillingSubscriptionInput;
};


export type MutationUpsertRestaurantBillingUkCustomerArgs = {
  billingCustomerInput: BillingCustomerInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationUpsertRestaurantDetailsPopTriggerArgs = {
  input: UpsertDiscoveryNcrRestaurantInput;
};


export type MutationUpsertRestaurantLastAdminVisitArgs = {
  restaurantSlug: Scalars['String']['input'];
};


export type MutationUpsertRestaurantLocationArgs = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
  locationInput?: InputMaybe<RestaurantLocationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type MutationUpsertRestaurantLocationOrderingBillingConfigArgs = {
  configInput: RestaurantLocationOrderingBillingConfigInput;
  locationId: Scalars['Int']['input'];
};


export type MutationUpsertRestaurantMemberClientProfileArgs = {
  input: UpsertRestaurantMemberClientProfileTypeInput;
};


export type MutationUpsertRestaurantMobileAppAssetArgs = {
  input: UpsertRestaurantMobileAppAssetInput;
};


export type MutationUpsertRestaurantSalesforceAccountArgs = {
  restaurantId: Scalars['Int']['input'];
  salesforceAccountInput: SalesforceAccountInput;
};


export type MutationUserResetAuthyArgs = {
  input: UserResetAuthyInput;
};


export type MutationValidateMenuItemCartSelectedMenuItemsArgs = {
  menuItemCartId: Scalars['Int']['input'];
};


export type MutationValidateMenuItemCartSubmitArgs = {
  expectedTotal?: InputMaybe<Scalars['Decimal']['input']>;
  itemsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemCartId: Scalars['Int']['input'];
  menuItemCartInput?: InputMaybe<MenuItemCartInput>;
  userDataOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationValidateMessageCampaignContentArgs = {
  id: Scalars['Int']['input'];
  messageCampaignInput: MessageCampaignInput;
};


export type MutationVerifyGoogleMyBusinessLocationArgs = {
  input: VerifyLocationInput;
};


export type MutationVerifyPhoneArgs = {
  input: VerifyPhoneInput;
};


export type MutationVerifyPushChallengeArgs = {
  input: VerifyTwilioVerifyPushChallengeInput;
};

/** Nav links and dropdowns */
export type NavItemable = {
  id: Scalars['Int']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

/** Nav link targets */
export type NavLinkable = {
  id: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type NcrPayment = {
  __typename?: 'NcrPayment';
  id: Scalars['Int']['output'];
  sessionRequestUrl?: Maybe<Scalars['String']['output']>;
};

export type NcrPaymentAccount = {
  __typename?: 'NcrPaymentAccount';
  companyId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isNcrKeyPresent: Scalars['Boolean']['output'];
  popmenuPublicKey: Scalars['String']['output'];
  restaurants: Array<Restaurant>;
};

export type NcrPaymentAccountCreateInput = {
  companyId: Scalars['String']['input'];
};

export type NcrPaymentAccountPaginationHandler = {
  __typename?: 'NcrPaymentAccountPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<NcrPaymentAccount>;
};

export type NcrPaymentAccountUpdateInput = {
  ncrKey?: InputMaybe<Scalars['String']['input']>;
  restaurantIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NcrRefund = MenuItemCartRefundable & {
  __typename?: 'NcrRefund';
  amount: Scalars['Decimal']['output'];
  id: Scalars['Int']['output'];
  refundedAt: Scalars['DateTime']['output'];
  refundedByUserEmail?: Maybe<Scalars['String']['output']>;
};

export type NcrSilverAccount = RestaurantPaymentAccountInterface & {
  __typename?: 'NcrSilverAccount';
  accountSlug: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  accountUrl: Scalars['String']['output'];
  canDisconnectPos: Scalars['Boolean']['output'];
  catalogLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  clientId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isDeleting: Scalars['Boolean']['output'];
  isMenuSyncing: Scalars['Boolean']['output'];
  isShopSupported: Scalars['Boolean']['output'];
  isSyncing?: Maybe<Scalars['Boolean']['output']>;
  menuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  ncrSilverChargeOptions?: Maybe<Array<NcrSilverItem>>;
  ncrSilverStores?: Maybe<Array<NcrSilverStore>>;
  restaurants?: Maybe<Array<Restaurant>>;
  shouldReauthenticate: Scalars['Boolean']['output'];
};

export type NcrSilverDiscount = {
  __typename?: 'NcrSilverDiscount';
  amount: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  discountType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type NcrSilverItem = ProviderItem & {
  __typename?: 'NcrSilverItem';
  availableVariations: Array<ProviderVariation>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAvailable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type NcrSilverStore = {
  __typename?: 'NcrSilverStore';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  ncrSilverAccount?: Maybe<NcrSilverAccount>;
  ncrSilverAccountId: Scalars['Int']['output'];
  phoneNumber: Scalars['Int']['output'];
  state?: Maybe<Scalars['String']['output']>;
  storeName: Scalars['String']['output'];
};

export type NcrSilverStoreSettingInput = {
  chargeOptionAdditionalFeeId?: InputMaybe<Scalars['Int']['input']>;
  chargeOptionDeliveryFeeId?: InputMaybe<Scalars['Int']['input']>;
  chargeOptionPopmenuFeeId?: InputMaybe<Scalars['Int']['input']>;
  ncrPaymentAccountId?: InputMaybe<Scalars['Int']['input']>;
  ncrPaymentStoreNumber?: InputMaybe<Scalars['String']['input']>;
};

export type NcrSilverVariation = ProviderVariation & {
  __typename?: 'NcrSilverVariation';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
};

export type NmiAccount = RestaurantPaymentAccountInterface & {
  __typename?: 'NmiAccount';
  accountSlug: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  accountUrl: Scalars['String']['output'];
  canDisconnectPos: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isDeleting: Scalars['Boolean']['output'];
  isMenuSyncing: Scalars['Boolean']['output'];
  isShopSupported: Scalars['Boolean']['output'];
  isSyncing?: Maybe<Scalars['Boolean']['output']>;
  menuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  restaurant: Restaurant;
  shouldReauthenticate: Scalars['Boolean']['output'];
  tokenizationKey: Scalars['String']['output'];
};

export type NmiRefund = MenuItemCartRefundable & {
  __typename?: 'NmiRefund';
  amount: Scalars['Decimal']['output'];
  id: Scalars['Int']['output'];
  refundedAt: Scalars['DateTime']['output'];
  refundedByUserEmail?: Maybe<Scalars['String']['output']>;
};

export type NotFoundPaginationHandler = {
  __typename?: 'NotFoundPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<RestaurantNotFound>;
};

export type NotificationDevice = {
  __typename?: 'NotificationDevice';
  createdAt: Scalars['DateTime']['output'];
  deregisteredAt?: Maybe<Scalars['DateTime']['output']>;
  followerId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  platform: Scalars['String']['output'];
  pushToken: Scalars['String']['output'];
  restaurantId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OauthApplication = {
  __typename?: 'OauthApplication';
  contactEmail?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  redirectUri: Scalars['String']['output'];
  secret: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type OauthApplicationInput = {
  contactEmail: Scalars['String']['input'];
  name: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
};

export type OauthIntegrationParamsInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
};

export type Offer = {
  __typename?: 'Offer';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Int']['output']>;
  discountAmountType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imageUploadedPhoto?: Maybe<UploadedPhoto>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOnetimeUse?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  offerCodesCount: Scalars['Int']['output'];
  redeemedOfferCodesCount: Scalars['Int']['output'];
  restaurant?: Maybe<Restaurant>;
};

export type OfferCode = {
  __typename?: 'OfferCode';
  code: Scalars['String']['output'];
  follower?: Maybe<Follower>;
  id: Scalars['Int']['output'];
  isRedeemed?: Maybe<Scalars['Boolean']['output']>;
  offer?: Maybe<Offer>;
  partyId?: Maybe<Scalars['Int']['output']>;
  redeemedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export type OfferCodesPaginationHandler = {
  __typename?: 'OfferCodesPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<OfferCode>;
};

export type OfferInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  discountAmount?: InputMaybe<Scalars['Decimal']['input']>;
  discountAmountType?: InputMaybe<Scalars['String']['input']>;
  imageUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  isEnabled: Scalars['Boolean']['input'];
  isOnetimeUse?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OfferPaginationHandler = {
  __typename?: 'OfferPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<Offer>;
};

export type OrderExportInput = {
  cartType: Cart;
  endDate: Scalars['DateTime']['input'];
  exportType: Export;
  startDate: Scalars['DateTime']['input'];
};

export type OrderingBillingConfigPolicy = {
  __typename?: 'OrderingBillingConfigPolicy';
  id: Scalars['String']['output'];
  update: Scalars['Boolean']['output'];
};

export type OrderingBillingInvoice = {
  __typename?: 'OrderingBillingInvoice';
  billingInvoice?: Maybe<BillingInvoice>;
  id: Scalars['Int']['output'];
  location: RestaurantLocation;
};

export type OrderingBillingInvoiceBilledCart = {
  __typename?: 'OrderingBillingInvoiceBilledCart';
  id: Scalars['Int']['output'];
  orderingBillingInvoice?: Maybe<OrderingBillingInvoice>;
};

export type OrderingBlackout = {
  __typename?: 'OrderingBlackout';
  blackoutMessage?: Maybe<Scalars['String']['output']>;
  cartType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  disableDelivery: Scalars['Boolean']['output'];
  disablePickup: Scalars['Boolean']['output'];
  endAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isAllDay: Scalars['Boolean']['output'];
  location: RestaurantLocation;
  locationId: Scalars['Int']['output'];
  startAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderingBlackoutCreateInput = {
  blackoutMessage?: InputMaybe<Scalars['String']['input']>;
  cartType: Scalars['String']['input'];
  disableDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  disablePickup?: InputMaybe<Scalars['Boolean']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderingBlackoutUpdateInput = {
  blackoutMessage?: InputMaybe<Scalars['String']['input']>;
  disableDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  disablePickup?: InputMaybe<Scalars['Boolean']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderingEvent = {
  __typename?: 'OrderingEvent';
  aiMarketablePhoto?: Maybe<UploadedPhoto>;
  arrivalInstructions?: Maybe<Scalars['String']['output']>;
  averageOrderValue?: Maybe<Scalars['Decimal']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eventDate: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isUnlimitedOrders?: Maybe<Scalars['Boolean']['output']>;
  itemLimits?: Maybe<Array<OrderingEventItemLimit>>;
  itemLimitsByTotal?: Maybe<Array<OrderingEventItemLimit>>;
  location?: Maybe<RestaurantLocation>;
  maxOrdersCount?: Maybe<Scalars['Int']['output']>;
  maxOrdersMet: Scalars['Boolean']['output'];
  maxPickupPerTimeSlot?: Maybe<Scalars['Int']['output']>;
  menuItemCartsByTotal?: Maybe<Array<MenuItemCart>>;
  minOrdersCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  orderableMenus: Array<OrderingEventSelectedMenu>;
  orderingEventSelectedMenus: Array<OrderingEventSelectedMenu>;
  orderingEventTimeSlots: Array<Scalars['DateTime']['output']>;
  ordersPlacedByDate: Scalars['DateTime']['output'];
  photoUrl?: Maybe<Scalars['String']['output']>;
  pickupEndTime?: Maybe<Scalars['Time']['output']>;
  pickupStartTime: Scalars['Time']['output'];
  pickupStartTimeWithDate: Scalars['DateTime']['output'];
  pickupType?: Maybe<Scalars['String']['output']>;
  pickupWindows?: Maybe<Array<OrderingEventPickupWindow>>;
  restaurant?: Maybe<Restaurant>;
  singlePickupWindowDateWithTime?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  /** Total number of carts that were submitted for the ordering event */
  submittedOrdersCount?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Total number of revenue generating orders placed for the ordering event */
  totalOrders: Scalars['Int']['output'];
  /** Total revenue generated from the ordering event */
  totalSales: Scalars['Decimal']['output'];
  uploadedPhoto?: Maybe<UploadedPhoto>;
};


export type OrderingEventAiMarketablePhotoArgs = {
  withGenericPhoto?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderingEventInput = {
  arrivalInstructions?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventDate?: InputMaybe<Scalars['DateTime']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isUnlimitedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  itemLimits?: InputMaybe<Array<OrderingEventItemLimitInput>>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  maxOrdersCount?: InputMaybe<Scalars['Int']['input']>;
  maxPickupPerTimeSlot?: InputMaybe<Scalars['Int']['input']>;
  minOrdersCount?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderingEventSelectedMenus?: InputMaybe<Array<OrderingEventSelectedMenuInput>>;
  ordersPlacedByDate?: InputMaybe<Scalars['DateTime']['input']>;
  pickupEndTime?: InputMaybe<Scalars['Time']['input']>;
  pickupStartTime?: InputMaybe<Scalars['Time']['input']>;
  pickupType?: InputMaybe<Scalars['String']['input']>;
  pickupWindows?: InputMaybe<Array<OrderingEventPickupWindowInput>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  uploadedPhoto?: InputMaybe<SelectedUploadInput>;
};

export type OrderingEventItemLimit = {
  __typename?: 'OrderingEventItemLimit';
  eventLimit?: Maybe<Scalars['Int']['output']>;
  eventTotal: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  item: MenuItem;
  itemId: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  orderLimit?: Maybe<Scalars['Int']['output']>;
  orderingEventId: Scalars['Int']['output'];
  orderingEventLowInventoryCount?: Maybe<Scalars['Int']['output']>;
};

export type OrderingEventItemLimitInput = {
  eventLimit?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemId: Scalars['Int']['input'];
  orderLimit?: InputMaybe<Scalars['Int']['input']>;
  orderingEventId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderingEventPaginationHandler = {
  __typename?: 'OrderingEventPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<OrderingEvent>;
};

export type OrderingEventPickupWindow = {
  __typename?: 'OrderingEventPickupWindow';
  date: Scalars['DateTime']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  orderingEventId: Scalars['Int']['output'];
  startTime: Scalars['String']['output'];
};

export type OrderingEventPickupWindowInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderingEventId?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type OrderingEventSelectedMenu = {
  __typename?: 'OrderingEventSelectedMenu';
  id: Scalars['Int']['output'];
  isArchived: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  menu?: Maybe<Menu>;
  menuId: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
};

export type OrderingEventSelectedMenuInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  menuId?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** Locations and enabled fullfilment types determening what is displayed on the /popmenu-order page */
export type OrderingLocationsData = {
  __typename?: 'OrderingLocationsData';
  defaultLocation?: Maybe<RestaurantLocation>;
  disableDelivery: Scalars['Boolean']['output'];
  disablePickup: Scalars['Boolean']['output'];
  isDeliveryOnly: Scalars['Boolean']['output'];
  multiLocationAvailableFulfillmentTypes: FulfillmentTypesEnum;
  orderableLocations: Array<RestaurantLocation>;
  orderableLocationsCentroid?: Maybe<Coordinates>;
};

export type OrderingOffer = {
  __typename?: 'OrderingOffer';
  activeMarketingOffers: Array<MarketingOffer>;
  activeStatusAt?: Maybe<Scalars['DateTime']['output']>;
  amount?: Maybe<Scalars['Decimal']['output']>;
  archivedStatusAt?: Maybe<Scalars['DateTime']['output']>;
  canBeUsedToday?: Maybe<Scalars['Boolean']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryMethod?: Maybe<Scalars['String']['output']>;
  dishNames: Array<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  hasAnySelection: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  imageHeight?: Maybe<Scalars['Int']['output']>;
  imageUploadedPhoto?: Maybe<UploadedPhoto>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  imageWidth?: Maybe<Scalars['Int']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isMarketable?: Maybe<Scalars['Boolean']['output']>;
  isMarketed?: Maybe<Scalars['Boolean']['output']>;
  isOnetimeUse?: Maybe<Scalars['Boolean']['output']>;
  isOnetimeUsePerOrder?: Maybe<Scalars['Boolean']['output']>;
  isScheduled?: Maybe<Scalars['Boolean']['output']>;
  locationId?: Maybe<Scalars['Int']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  locationSlug?: Maybe<Scalars['String']['output']>;
  menuNames: Array<Scalars['String']['output']>;
  messageCampaign?: Maybe<MessageCampaign>;
  messageCampaignSelectedLocations: Array<MessageCampaignSelectedLocation>;
  minimumOrderAmount?: Maybe<Scalars['Decimal']['output']>;
  name: Scalars['String']['output'];
  offerAppliedTo?: Maybe<Scalars['String']['output']>;
  offerCodesCount: Scalars['Int']['output'];
  offerStatus?: Maybe<Scalars['String']['output']>;
  offerType?: Maybe<Scalars['String']['output']>;
  orderingOfferBxgyDetail?: Maybe<OrderingOfferBxgyDetail>;
  orderingOfferCodes: Array<OrderingOfferCode>;
  orderingOfferSchedule?: Maybe<OrderingOfferSchedule>;
  redeemedOfferCodesCount: Scalars['Int']['output'];
  redemptionLimit?: Maybe<Scalars['Int']['output']>;
  restaurant?: Maybe<Restaurant>;
  sectionNames: Array<Scalars['String']['output']>;
  selectedDishes: Array<OrderingOfferSelectedDish>;
  selectedMenuSections: Array<OrderingOfferSelectedMenuSection>;
  selectedMenus: Array<OrderingOfferSelectedMenu>;
  totalOfferValue?: Maybe<Scalars['Decimal']['output']>;
  totalOrderValue?: Maybe<Scalars['Decimal']['output']>;
};

export type OrderingOfferBxgyDetail = {
  __typename?: 'OrderingOfferBxgyDetail';
  applicableDishes?: Maybe<Array<OrderingOfferBxgyDish>>;
  applicableQuantity?: Maybe<Scalars['Int']['output']>;
  bxgyType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  listDishes?: Maybe<Scalars['String']['output']>;
  orderingOffer?: Maybe<OrderingOffer>;
  redeemableDishes: Array<OrderingOfferBxgyDish>;
  redeemableQuantity?: Maybe<Scalars['Int']['output']>;
};

export type OrderingOfferBxgyDetailInput = {
  applicableDishes?: InputMaybe<Array<Scalars['Int']['input']>>;
  applicableQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  bxgyType?: InputMaybe<Scalars['Int']['input']>;
  redeemableDishes: Array<Scalars['Int']['input']>;
  redeemableQuantity: Scalars['Decimal']['input'];
};

export type OrderingOfferBxgyDish = {
  __typename?: 'OrderingOfferBxgyDish';
  dish?: Maybe<Dish>;
  dishType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type OrderingOfferCode = {
  __typename?: 'OrderingOfferCode';
  code?: Maybe<Scalars['String']['output']>;
  follower?: Maybe<Follower>;
  id: Scalars['Int']['output'];
  isRedeemed: Scalars['Boolean']['output'];
  orderingOffer?: Maybe<OrderingOffer>;
  orderingOfferExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  orderingOfferIsOnetimeUse: Scalars['Boolean']['output'];
  orderingOfferIsOnetimeUsePerOrder: Scalars['Boolean']['output'];
  orderingOfferMinimumOrderAmount: Scalars['Decimal']['output'];
  orderingOfferName?: Maybe<Scalars['String']['output']>;
  orderingOfferSchedule?: Maybe<OrderingOfferSchedule>;
  redeemedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export type OrderingOfferCodesPaginationHandler = {
  __typename?: 'OrderingOfferCodesPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<OrderingOfferCode>;
};

export type OrderingOfferInput = {
  advisorCardTrackerId?: InputMaybe<Scalars['Int']['input']>;
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  deliveryMethod?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  imageUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  isEnabled: Scalars['Boolean']['input'];
  isOnetimeUse: Scalars['Boolean']['input'];
  isOnetimeUsePerOrder: Scalars['Boolean']['input'];
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  minimumOrderAmount?: InputMaybe<Scalars['Decimal']['input']>;
  name: Scalars['String']['input'];
  offerStatus?: InputMaybe<Scalars['String']['input']>;
  offerType?: InputMaybe<Scalars['String']['input']>;
  orderingOfferBxgyDetail?: InputMaybe<OrderingOfferBxgyDetailInput>;
  orderingOfferSchedule?: InputMaybe<OrderingOfferScheduleInput>;
  redemptionLimit?: InputMaybe<Scalars['Int']['input']>;
  selectedDishes?: InputMaybe<Array<OrderingOfferSelectedDishInput>>;
  selectedMenuSections?: InputMaybe<Array<OrderingOfferSelectedMenuSectionInput>>;
  selectedMenus?: InputMaybe<Array<OrderingOfferSelectedMenuInput>>;
};

export type OrderingOfferPaginationHandler = {
  __typename?: 'OrderingOfferPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<OrderingOffer>;
};

export type OrderingOfferSchedule = {
  __typename?: 'OrderingOfferSchedule';
  dayFriday?: Maybe<Scalars['Boolean']['output']>;
  dayMonday?: Maybe<Scalars['Boolean']['output']>;
  daySaturday?: Maybe<Scalars['Boolean']['output']>;
  daySunday?: Maybe<Scalars['Boolean']['output']>;
  dayThursday?: Maybe<Scalars['Boolean']['output']>;
  dayTuesday?: Maybe<Scalars['Boolean']['output']>;
  dayWednesday?: Maybe<Scalars['Boolean']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  endTime?: Maybe<Scalars['Time']['output']>;
  friendlySchedule?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  openAllDay?: Maybe<Scalars['Boolean']['output']>;
  orderingOffer?: Maybe<OrderingOffer>;
  recurringMonthDay?: Maybe<Scalars['Int']['output']>;
  recurringType?: Maybe<Scalars['String']['output']>;
  repeatsEvery?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  startTime?: Maybe<Scalars['Time']['output']>;
};

export type OrderingOfferScheduleInput = {
  dayFriday?: InputMaybe<Scalars['Boolean']['input']>;
  dayMonday?: InputMaybe<Scalars['Boolean']['input']>;
  daySaturday?: InputMaybe<Scalars['Boolean']['input']>;
  daySunday?: InputMaybe<Scalars['Boolean']['input']>;
  dayThursday?: InputMaybe<Scalars['Boolean']['input']>;
  dayTuesday?: InputMaybe<Scalars['Boolean']['input']>;
  dayWednesday?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['Time']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  openAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  recurringMonthDay?: InputMaybe<Scalars['Int']['input']>;
  recurringType?: InputMaybe<Scalars['String']['input']>;
  repeatsEvery?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['Time']['input']>;
};

export type OrderingOfferSelectedDish = {
  __typename?: 'OrderingOfferSelectedDish';
  dish: Dish;
  id: Scalars['Int']['output'];
  orderingOfferId: Scalars['Int']['output'];
};

export type OrderingOfferSelectedDishInput = {
  dishId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  orderingOfferId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderingOfferSelectedMenu = {
  __typename?: 'OrderingOfferSelectedMenu';
  id: Scalars['Int']['output'];
  menu: Menu;
  orderingOfferId: Scalars['Int']['output'];
};

export type OrderingOfferSelectedMenuInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  menuId: Scalars['Int']['input'];
  orderingOfferId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderingOfferSelectedMenuSection = {
  __typename?: 'OrderingOfferSelectedMenuSection';
  id: Scalars['Int']['output'];
  orderingOfferId: Scalars['Int']['output'];
  section: MenuSection;
};

export type OrderingOfferSelectedMenuSectionInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  orderingOfferId?: InputMaybe<Scalars['Int']['input']>;
  sectionId: Scalars['Int']['input'];
};

export type OrderingOverview = {
  __typename?: 'OrderingOverview';
  averageOrderAmount?: Maybe<Scalars['Float']['output']>;
  lastUpdatedAt?: Maybe<Scalars['String']['output']>;
  orderAveragePercentage?: Maybe<Scalars['Float']['output']>;
  orderRevenueByFullfillmentType?: Maybe<Array<OrderingOverviewOrderRevenueByFullfillment>>;
  orderRevenueBySource?: Maybe<Array<OrderingOverviewOrderRevenueBySource>>;
  orderRevenuePercentage?: Maybe<Scalars['Float']['output']>;
  orderVolumePercentage?: Maybe<Scalars['Float']['output']>;
  orderingVolumeAndRevenue?: Maybe<Array<OrderingOverviewOrderVolumeAndRevenue>>;
  ordersByType?: Maybe<Array<OrderingOverviewOrder>>;
  previousTotalOrderRevenue?: Maybe<Scalars['Float']['output']>;
  previousTotalOrderVolume?: Maybe<Scalars['Int']['output']>;
  revenueSharedDataStartDate?: Maybe<Scalars['DateTime']['output']>;
  totalOrderRevenue?: Maybe<Scalars['Float']['output']>;
  totalOrderVolume?: Maybe<Scalars['Int']['output']>;
};

export type OrderingOverviewOrder = {
  __typename?: 'OrderingOverviewOrder';
  fulfillmentType: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};

export type OrderingOverviewOrderRevenueByFullfillment = {
  __typename?: 'OrderingOverviewOrderRevenueByFullfillment';
  catering?: Maybe<Scalars['Float']['output']>;
  date: Scalars['DateTime']['output'];
  delivery?: Maybe<Scalars['Float']['output']>;
  pickup?: Maybe<Scalars['Float']['output']>;
};

export type OrderingOverviewOrderRevenueBySource = {
  __typename?: 'OrderingOverviewOrderRevenueBySource';
  percentage: Scalars['Float']['output'];
  revenue: Scalars['Float']['output'];
  source: OrderingOverviewOrderSource;
};

export enum OrderingOverviewOrderSource {
  ConsumerApp = 'consumer_app',
  ThirdParty = 'third_party',
  Web = 'web'
}

export type OrderingOverviewOrderVolumeAndRevenue = {
  __typename?: 'OrderingOverviewOrderVolumeAndRevenue';
  date: Scalars['DateTime']['output'];
  orders: Scalars['Int']['output'];
  revenue: Scalars['Float']['output'];
  revenueSharedFees: Scalars['Float']['output'];
};

export type OrderingOverviewOrdersByHour = {
  __typename?: 'OrderingOverviewOrdersByHour';
  hour?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Int']['output']>;
};

/** Ordering Ranges */
export type OrderingRangeable = {
  closeTime?: Maybe<Scalars['Time']['output']>;
  dayFriday?: Maybe<Scalars['Boolean']['output']>;
  dayMonday?: Maybe<Scalars['Boolean']['output']>;
  daySaturday?: Maybe<Scalars['Boolean']['output']>;
  daySunday?: Maybe<Scalars['Boolean']['output']>;
  dayThursday?: Maybe<Scalars['Boolean']['output']>;
  dayTuesday?: Maybe<Scalars['Boolean']['output']>;
  dayWednesday?: Maybe<Scalars['Boolean']['output']>;
  days: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  openTime?: Maybe<Scalars['Time']['output']>;
};

export type OrderingReportExport = {
  __typename?: 'OrderingReportExport';
  exportFileUrl?: Maybe<Scalars['String']['output']>;
  exportedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  restaurant: Restaurant;
  token: Scalars['String']['output'];
  user: User;
  userDisplayName: Scalars['String']['output'];
};

export type OrderingReportExportInput = {
  cartType?: InputMaybe<Scalars['String']['input']>;
  endAt?: InputMaybe<Scalars['String']['input']>;
  futureWeeks?: InputMaybe<Scalars['Boolean']['input']>;
  groupBy?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  invoices?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  orderingPlatform?: InputMaybe<Scalars['String']['input']>;
  reportMonth?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Scalars['String']['input']>;
};

export type OrdersByHourByDate = {
  __typename?: 'OrdersByHourByDate';
  ordersByHour?: Maybe<Array<OrderingOverviewOrdersByHour>>;
};

export type OrganicSiteVisitsPercentagesByDaysAgo = {
  __typename?: 'OrganicSiteVisitsPercentagesByDaysAgo';
  currentSiteVisitsPercentage: Scalars['Float']['output'];
  previousSiteVisitsPercentage?: Maybe<Scalars['Float']['output']>;
};

export type OutboundClickEvents = {
  __typename?: 'OutboundClickEvents';
  iconStrings: Array<Scalars['String']['output']>;
  percentage: Scalars['Float']['output'];
  targetFriendlyLabel: Scalars['String']['output'];
};

export type OverviewExportInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  dateRangeData?: InputMaybe<DateRangeDataInput>;
  daysAgo?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  exportType: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OverviewGraphDataPoint = {
  __typename?: 'OverviewGraphDataPoint';
  day: Scalars['Int']['output'];
  impressions: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  revenue: Scalars['Decimal']['output'];
  week: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

/** Page content */
export type PageContentable = {
  id: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type PaginatedReviewsHandler = {
  __typename?: 'PaginatedReviewsHandler';
  count: Scalars['Int']['output'];
  records: Array<Review>;
};

export type PaginationHandler = {
  __typename?: 'PaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<RootTask>;
};

export type PaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
  sortNullsFirst?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Party = {
  __typename?: 'Party';
  cancelledPartyStateAt?: Maybe<Scalars['DateTime']['output']>;
  completedPartyStateAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  estimatedSeatingTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  internalNotes?: Maybe<Scalars['String']['output']>;
  isExpired: Scalars['Boolean']['output'];
  locationId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nextNotifyStateAt?: Maybe<Scalars['DateTime']['output']>;
  nextRepliedState?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['Text']['output']>;
  notifyState?: Maybe<Scalars['String']['output']>;
  partyEntryPoint?: Maybe<Scalars['String']['output']>;
  partySize?: Maybe<Scalars['Int']['output']>;
  partyState?: Maybe<Scalars['String']['output']>;
  partyType?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  placeInLine?: Maybe<Scalars['String']['output']>;
  quotedWaitTime?: Maybe<Scalars['Int']['output']>;
  readyLastCallNotifyStateAt?: Maybe<Scalars['DateTime']['output']>;
  readyNotifyStateAt?: Maybe<Scalars['DateTime']['output']>;
  reservationDate?: Maybe<Scalars['DateTime']['output']>;
  reservationDatetime?: Maybe<Scalars['DateTime']['output']>;
  reservationExtendTime: Scalars['Int']['output'];
  /** @deprecated This field is deprecated and will be removed in a future release */
  reservationSmsNotification?: Maybe<Scalars['Boolean']['output']>;
  reservationTime?: Maybe<Scalars['Time']['output']>;
  reservationTurnTime?: Maybe<Scalars['Int']['output']>;
  seatedPartyStateAt?: Maybe<Scalars['DateTime']['output']>;
  tableTops?: Maybe<Array<RestaurantLocationTableTop>>;
  token: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  waitlistMenuUrl?: Maybe<Scalars['String']['output']>;
};

export type PartyAvailableReservations = {
  __typename?: 'PartyAvailableReservations';
  availableDates?: Maybe<Array<Scalars['DateTime']['output']>>;
};

export type PartyCount = {
  __typename?: 'PartyCount';
  locationId: Scalars['Int']['output'];
  reservationsCount?: Maybe<Scalars['Int']['output']>;
  waitlistCount?: Maybe<Scalars['Int']['output']>;
};

export type PartyInput = {
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Internal Notes */
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  /** Location ID */
  locationId?: InputMaybe<Scalars['Int']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Notify State */
  notifyState?: InputMaybe<Scalars['String']['input']>;
  /** Party Entry Point */
  partyEntryPoint?: InputMaybe<Scalars['String']['input']>;
  /** Party Size */
  partySize?: InputMaybe<Scalars['Int']['input']>;
  /** Party State */
  partyState?: InputMaybe<Scalars['String']['input']>;
  /** Party Type */
  partyType?: InputMaybe<Scalars['String']['input']>;
  /** Phone Number */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Quoted Wait Time */
  quotedWaitTime?: InputMaybe<Scalars['Int']['input']>;
  /** Reservation Date */
  reservationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Reservation Extend Time */
  reservationExtendTime?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Reservation SMS Notification
   * @deprecated This argument is deprecated and will be removed in a future release
   */
  reservationSmsNotification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reservation Time */
  reservationTime?: InputMaybe<Scalars['Time']['input']>;
  /** Table Top IDs */
  tableTopIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PartyPaginationHandler = {
  __typename?: 'PartyPaginationHandler';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  offset: Scalars['Int']['output'];
  records: Array<Party>;
};

export type PartySettings = {
  __typename?: 'PartySettings';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  location?: Maybe<RestaurantLocation>;
  locationId?: Maybe<Scalars['Int']['output']>;
  partySettingsMenuRanges: Array<PartySettingsMenuRange>;
  reservationAutoAccept: Scalars['Boolean']['output'];
  reservationAutoComplete: Scalars['Boolean']['output'];
  reservationAvailabilityLimited?: Maybe<Scalars['Boolean']['output']>;
  reservationEarliestAvailable?: Maybe<Scalars['Int']['output']>;
  reservationEarliestAvailableUnit?: Maybe<Scalars['String']['output']>;
  reservationInterval?: Maybe<Scalars['Int']['output']>;
  reservationIsEnabled: Scalars['Boolean']['output'];
  reservationLatestAvailable?: Maybe<Scalars['Int']['output']>;
  reservationLatestAvailableUnit?: Maybe<Scalars['String']['output']>;
  reservationPartyLimit: Scalars['Int']['output'];
  reservationPolicy?: Maybe<Scalars['Text']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  waitlistAverageWaitTime?: Maybe<Scalars['Int']['output']>;
  waitlistCheckInRequired?: Maybe<Scalars['Boolean']['output']>;
  waitlistConsumerNotesEnabled: Scalars['Boolean']['output'];
  waitlistIsEnabled?: Maybe<Scalars['Boolean']['output']>;
  waitlistMenu?: Maybe<Menu>;
  waitlistMenuId?: Maybe<Scalars['Int']['output']>;
  waitlistMenuSlug?: Maybe<Scalars['String']['output']>;
  waitlistPartyLimit: Scalars['Int']['output'];
  waitlistPlaceInLineEnabled: Scalars['Boolean']['output'];
  waitlistSelfAddEnabled?: Maybe<Scalars['Boolean']['output']>;
  waitlistSendMenuLink?: Maybe<Scalars['Boolean']['output']>;
  waitlistShowAverageWaitTime?: Maybe<Scalars['Boolean']['output']>;
};

export type PartySettingsInput = {
  /** Location ID */
  locationId: Scalars['Int']['input'];
  partySettingsMenuRanges?: InputMaybe<Array<PartySettingsMenuRangesInput>>;
  /** Reservation - Party Auto Accept */
  reservationAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reservation - Party Auto Complete */
  reservationAutoComplete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reservation - Interval */
  reservationInterval?: InputMaybe<Scalars['Int']['input']>;
  /** Reservation - Is Enabled */
  reservationIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reservation - Booking Window */
  reservationLatestAvailable?: InputMaybe<Scalars['Int']['input']>;
  /** Reservation - Party Limit */
  reservationPartyLimit?: InputMaybe<Scalars['Int']['input']>;
  /** Reservation - Policy */
  reservationPolicy?: InputMaybe<Scalars['String']['input']>;
  /** Waitlist - Average Wait Time */
  waitlistAverageWaitTime?: InputMaybe<Scalars['Int']['input']>;
  /** Waitlist - Check-In Required */
  waitlistCheckInRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Waitlist - Consumer Notes Enabled */
  waitlistConsumerNotesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Waitlist - Is Enabled */
  waitlistIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Waitlist - Menu ID */
  waitlistMenuId?: InputMaybe<Scalars['Int']['input']>;
  /** Waitlist - Party Limit */
  waitlistPartyLimit?: InputMaybe<Scalars['Int']['input']>;
  /** Waitlist - In Line Enabled */
  waitlistPlaceInLineEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Waitlist - Self-Add Enabled */
  waitlistSelfAddEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Waitlist - Send Menu Link */
  waitlistSendMenuLink?: InputMaybe<Scalars['Boolean']['input']>;
  /** Waitlist - Show Average Wait Time */
  waitlistShowAverageWaitTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartySettingsMenuRange = {
  __typename?: 'PartySettingsMenuRange';
  createdAt: Scalars['DateTime']['output'];
  endTime?: Maybe<Scalars['Time']['output']>;
  id: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  menu: Menu;
  partySettings: PartySettings;
  startTime?: Maybe<Scalars['Time']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PartySettingsMenuRangesInput = {
  endTime?: InputMaybe<Scalars['Time']['input']>;
  isDefault: Scalars['Boolean']['input'];
  menuId: Scalars['Int']['input'];
  startTime?: InputMaybe<Scalars['Time']['input']>;
};

export type PartySettingsWasUpdatedReturn = {
  __typename?: 'PartySettingsWasUpdatedReturn';
  action: Scalars['String']['output'];
  partySettings?: Maybe<PartySettings>;
};

export type PartyWasDeletedReturn = {
  __typename?: 'PartyWasDeletedReturn';
  action: Scalars['String']['output'];
  partyId: Scalars['Int']['output'];
};

export type PartyWasUpdatedReturn = {
  __typename?: 'PartyWasUpdatedReturn';
  action: Scalars['String']['output'];
  party?: Maybe<Party>;
};

export type PendingReviewTasksReturn = {
  __typename?: 'PendingReviewTasksReturn';
  event?: Maybe<Scalars['String']['output']>;
};

export type PerformanceSnapshotBrandImpressions = {
  __typename?: 'PerformanceSnapshotBrandImpressions';
  totalBrandImpressions: Scalars['Int']['output'];
};

export type PerformanceSnapshotEstimatedRevenues = {
  __typename?: 'PerformanceSnapshotEstimatedRevenues';
  date: Scalars['String']['output'];
  estimatedRevenue: Scalars['Float']['output'];
  maxDate: Scalars['String']['output'];
  minDate: Scalars['String']['output'];
  revenueSources: Array<PerformanceSnapshotRevenueSource>;
};

export type PerformanceSnapshotFollowerByTime = {
  __typename?: 'PerformanceSnapshotFollowerByTime';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export type PerformanceSnapshotRevenueGeneratingSources = {
  __typename?: 'PerformanceSnapshotRevenueGeneratingSources';
  icon: Scalars['String']['output'];
  itemCount: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  revenue: Scalars['Float']['output'];
  source: Scalars['String']['output'];
};

export type PerformanceSnapshotRevenueSource = {
  __typename?: 'PerformanceSnapshotRevenueSource';
  estRevenue: Scalars['Float']['output'];
  targetFriendlyLabel: Scalars['String']['output'];
};

export type PerformanceSnapshotReviewSentiment = {
  __typename?: 'PerformanceSnapshotReviewSentiment';
  positivePercentage: Scalars['Float']['output'];
  totalReviews: Scalars['Int']['output'];
};

export type PhoneCallCreateInputType = {
  /** Call Sid */
  callSid: Scalars['String']['input'];
  /** From Number */
  fromNumber: Scalars['String']['input'];
  /** To Number */
  toNumber: Scalars['String']['input'];
};

export type PhoneCallUpdateInputType = {
  /** Call Duration */
  callDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Call Outcome */
  callOutcome?: InputMaybe<Scalars['Int']['input']>;
  /** Call Recording Duration */
  callRecordingDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Call Recording Sid */
  callRecordingSid?: InputMaybe<Scalars['String']['input']>;
  /** Call Recording Source */
  callRecordingSource?: InputMaybe<Scalars['String']['input']>;
  /** Call Recording Status */
  callRecordingStatus?: InputMaybe<Scalars['String']['input']>;
  /** Call Recording Url */
  callRecordingUrl?: InputMaybe<Scalars['String']['input']>;
  /** Call Topic */
  callTopic?: InputMaybe<Scalars['String']['input']>;
  /** Call Topic Stats */
  callTopicData?: InputMaybe<Scalars['JSON']['input']>;
  /** Forwarded Call Duration */
  forwardedCallDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Forwarding Outcome */
  forwardingOutcome?: InputMaybe<Scalars['Int']['input']>;
  /** Is Spam Nomorobo */
  isSpamNomorobo?: InputMaybe<Scalars['Boolean']['input']>;
  twilioDateCreated?: InputMaybe<Scalars['DateTime']['input']>;
  twilioDateUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  /** VM Recording Duration */
  vmRecordingDuration?: InputMaybe<Scalars['Int']['input']>;
  /** VM Recording Sid */
  vmRecordingSid?: InputMaybe<Scalars['String']['input']>;
  /** VM Recording Source */
  vmRecordingSource?: InputMaybe<Scalars['String']['input']>;
  /** VM Recording Status */
  vmRecordingStatus?: InputMaybe<Scalars['String']['input']>;
  /** VM Recording Url */
  vmRecordingUrl?: InputMaybe<Scalars['String']['input']>;
  /** VM Transcription Sid */
  vmTranscriptionSid?: InputMaybe<Scalars['String']['input']>;
  /** VM Transcription Text */
  vmTranscriptionText?: InputMaybe<Scalars['String']['input']>;
  /** VM Transcription Url */
  vmTranscriptionUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PhoneCallWasUpdatedReturn = {
  __typename?: 'PhoneCallWasUpdatedReturn';
  action: Scalars['String']['output'];
  phoneCall?: Maybe<TwilioPhoneCall>;
};

export type PhoneInput = {
  phoneNumber: Scalars['String']['input'];
};

export type PhoneUser = {
  __typename?: 'PhoneUser';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isFollower: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};


export type PhoneUserIsFollowerArgs = {
  restaurantId: Scalars['Int']['input'];
};

export type Photo = Eventable & PhotoInterface & {
  __typename?: 'Photo';
  eventableName: Scalars['String']['output'];
  featured?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  item?: Maybe<MenuItem>;
  name: Scalars['String']['output'];
  photoHeight: Scalars['Int']['output'];
  photoUploadedPhoto?: Maybe<UploadedPhoto>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  photoWidth: Scalars['Int']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  shareUrl?: Maybe<Scalars['String']['output']>;
  show: Scalars['Boolean']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  uiPhoto?: Maybe<UiPhotoInterface>;
};

export enum PhotoBorder {
  Double = 'double',
  None = 'none',
  Thick = 'thick',
  Thin = 'thin'
}

export type PhotoInput = {
  featured: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isPosSynced?: InputMaybe<Scalars['Boolean']['input']>;
  photoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  show?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Event subjects */
export type PhotoInterface = {
  eventableName: Scalars['String']['output'];
  featured?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  item?: Maybe<MenuItem>;
  name: Scalars['String']['output'];
  photoHeight: Scalars['Int']['output'];
  photoUploadedPhoto?: Maybe<UploadedPhoto>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  photoWidth: Scalars['Int']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  shareUrl?: Maybe<Scalars['String']['output']>;
  show: Scalars['Boolean']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  uiPhoto?: Maybe<UiPhotoInterface>;
};

export enum PhotoShadow {
  None = 'none',
  Soft = 'soft'
}

export enum PhotoShape {
  Rounded = 'rounded',
  Softened = 'softened',
  Square = 'square'
}

export type PhotoStyles = {
  __typename?: 'PhotoStyles';
  border?: Maybe<Scalars['String']['output']>;
  borderRadius?: Maybe<Scalars['String']['output']>;
  boxShadow?: Maybe<Scalars['String']['output']>;
};

export type PhotoVersion = Versionable & {
  __typename?: 'PhotoVersion';
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  locationMenuName?: Maybe<Scalars['String']['output']>;
  objectChanges: Array<VersionDiff>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

export type Pop = Eventable & {
  __typename?: 'Pop';
  createdAt: Scalars['DateTime']['output'];
  dishable: Dishable;
  dishableId?: Maybe<Scalars['Int']['output']>;
  dishableType?: Maybe<Scalars['String']['output']>;
  eventableName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  item?: Maybe<MenuItem>;
  name: Scalars['String']['output'];
  /** Possible ratings of `loved_it`, `liked_it`, `wanna_try`, or `disliked_it` */
  popType: Scalars['String']['output'];
  session?: Maybe<Session>;
  user?: Maybe<User>;
  userAvatarUrl: Scalars['String']['output'];
  /** Public user display name or "Guest" */
  userDisplayName: Scalars['String']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
};

export type PopPaginationHandler = {
  __typename?: 'PopPaginationHandler';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  offset: Scalars['Int']['output'];
  records: Array<Pop>;
};

export type PopmenuConfig = {
  __typename?: 'PopmenuConfig';
  afsSsupMenuEmbedded: Scalars['Boolean']['output'];
  authorizePaymentUrl?: Maybe<Scalars['String']['output']>;
  billingJeanSsupSysco: Scalars['Boolean']['output'];
  billingMaintenanceEnabled: Scalars['Boolean']['output'];
  branchIoKey?: Maybe<Scalars['String']['output']>;
  chatbotApiToken?: Maybe<Scalars['String']['output']>;
  chatbotUrl?: Maybe<Scalars['String']['output']>;
  chatbotWebsocketUrl?: Maybe<Scalars['String']['output']>;
  churnZeroAppId?: Maybe<Scalars['String']['output']>;
  cloudflareUrl: Scalars['String']['output'];
  cloverSdkUrl: Scalars['String']['output'];
  deliverectStatusWebhookUrl: Scalars['String']['output'];
  draftModeKey?: Maybe<Scalars['String']['output']>;
  eatPopmenuUrl: Scalars['String']['output'];
  env: Scalars['String']['output'];
  facebookOauthDisabled: Scalars['Boolean']['output'];
  froalaKey: Scalars['String']['output'];
  fullStoryOrg?: Maybe<Scalars['String']['output']>;
  ga4AdminMeasurementId?: Maybe<Scalars['String']['output']>;
  ga4MeasurementId?: Maybe<Scalars['String']['output']>;
  goCardlessEnvironment: Scalars['String']['output'];
  googleAdminAnalyticsId?: Maybe<Scalars['String']['output']>;
  googleAnalyticsId?: Maybe<Scalars['String']['output']>;
  googleMapsKey?: Maybe<Scalars['String']['output']>;
  googleTagManagerContainerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  intercomAppId?: Maybe<Scalars['String']['output']>;
  isAteamGetWaitlistTrialEnabled: Scalars['Boolean']['output'];
  isAteamModularSignUpFlowEnabled: Scalars['Boolean']['output'];
  isSquareApplicationCaPresent: Scalars['Boolean']['output'];
  isSquareApplicationGbPresent: Scalars['Boolean']['output'];
  launchnotesProjectId?: Maybe<Scalars['String']['output']>;
  launchnotesPublicKey?: Maybe<Scalars['String']['output']>;
  lighthouseMaintenanceEnabled: Scalars['Boolean']['output'];
  mapboxPublicKey: Scalars['String']['output'];
  mapboxTestMode: Scalars['Boolean']['output'];
  pendoApiKey?: Maybe<Scalars['String']['output']>;
  plaidEnv: Scalars['String']['output'];
  plaidPublicKey: Scalars['String']['output'];
  popmenuAdminAppAndroidVersion: Scalars['String']['output'];
  popmenuAdminAppIosVersion: Scalars['String']['output'];
  popmenuEnv: Scalars['String']['output'];
  popmenuVersion: Scalars['String']['output'];
  recaptchaInvisibleSiteKey?: Maybe<Scalars['String']['output']>;
  recaptchaSiteKey: Scalars['String']['output'];
  rootDishTags: Array<RootDishTag>;
  rootMessagePacks: Array<RootMessagePack>;
  signInUrl: Scalars['String']['output'];
  snowplowUrl?: Maybe<Scalars['String']['output']>;
  spreedlyKey?: Maybe<Scalars['String']['output']>;
  squareEnvironment?: Maybe<Scalars['String']['output']>;
  squareJsUrl: Scalars['String']['output'];
  stripePublishableKey: Scalars['String']['output'];
  toastSdkUrl?: Maybe<Scalars['String']['output']>;
  websocketUrl?: Maybe<Scalars['String']['output']>;
  zendeskKey?: Maybe<Scalars['String']['output']>;
};

export type PopmenuIdToken = {
  __typename?: 'PopmenuIdToken';
  id: Scalars['String']['output'];
  ordernerdUrl: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type PopmenuLoyaltyProgram = {
  __typename?: 'PopmenuLoyaltyProgram';
  accrualRule?: Maybe<PopmenuLoyaltyProgramAccrualRule>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  promotions: Array<LoyaltyProgramPromotion>;
  rewardTiers: Array<LoyaltyProgramRewardTier>;
  status: Scalars['String']['output'];
  terminologyOne: Scalars['String']['output'];
  terminologyPlural: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PopmenuLoyaltyProgramAccrualRule = {
  __typename?: 'PopmenuLoyaltyProgramAccrualRule';
  accrualType: Scalars['String']['output'];
  amount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  points: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PopmenuRoot = {
  __typename?: 'PopmenuRoot';
  billingSubscriptionsCount: Scalars['Int']['output'];
  billingSubscriptionsUpcomingInvoiceTotal: Scalars['Int']['output'];
  ccpaRequests: CcpaRequestPaginationHandler;
  dncList: DncListPaginationHandler;
  id: Scalars['Int']['output'];
  lighthouseReports: LighthouseReportPaginationHandler;
  liveDomains: LiveDomainPaginationHandler;
  locations: Array<RestaurantLocation>;
  /** @deprecated no longer using looker for locations map */
  lookerLocationsEmbedUrl: Scalars['String']['output'];
  messageGroups: MessageGroupPaginationHandler;
  orderezeMigrationCohortNames: Array<Scalars['String']['output']>;
  orderezeRestaurants: RestaurantPaginationHandler;
  restaurants: RestaurantPaginationHandler;
  restaurantsWithBillingCustomers: RestaurantPaginationHandler;
  rootCuisineTypes: CuisineTypePaginationHandler;
  rootGoogleCategories: CategoryPaginationHandler;
  rootGroup: RootGroup;
  rootGroups: RootGroupPaginationHandler;
  /** Fetch a message pack */
  rootMessagePack: RootMessagePack;
  rootMessagePackCategories: Array<RootMessagePackCategory>;
  rootMessagePacks: RootMessagePackPaginationHandler;
  rootSectionType: RootSectionType;
  rootTheme: RootTheme;
  rootYextCategories: YextCategoryPaginationHandler;
  socialPostInstagramLivePosts: InstagramLivePostPaginationHandler;
  socialPostLivePosts: LivePostPaginationHandler;
  users: UserPaginationHandler;
  versions: VersionPaginationHandler;
};


export type PopmenuRootCcpaRequestsArgs = {
  pagination: PaginationInput;
};


export type PopmenuRootDncListArgs = {
  pagination: PaginationInput;
};


export type PopmenuRootLighthouseReportsArgs = {
  pagination: PaginationInput;
};


export type PopmenuRootLiveDomainsArgs = {
  pagination: PaginationInput;
};


export type PopmenuRootMessageGroupsArgs = {
  pagination: PaginationInput;
};


export type PopmenuRootOrderezeRestaurantsArgs = {
  migrationCohortName?: InputMaybe<Scalars['String']['input']>;
  pagination: PaginationInput;
};


export type PopmenuRootRestaurantsArgs = {
  cuisineTypeId?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type PopmenuRootRestaurantsWithBillingCustomersArgs = {
  pagination: PaginationInput;
};


export type PopmenuRootRootCuisineTypesArgs = {
  pagination: PaginationInput;
};


export type PopmenuRootRootGoogleCategoriesArgs = {
  pagination: PaginationInput;
};


export type PopmenuRootRootGroupArgs = {
  rootGroupId: Scalars['Int']['input'];
};


export type PopmenuRootRootGroupsArgs = {
  pagination: PaginationInput;
};


export type PopmenuRootRootMessagePackArgs = {
  id: Scalars['Int']['input'];
};


export type PopmenuRootRootMessagePacksArgs = {
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: PaginationInput;
  withHoliday?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PopmenuRootRootSectionTypeArgs = {
  rootSectionTypeId: Scalars['Int']['input'];
};


export type PopmenuRootRootThemeArgs = {
  rootThemeId: Scalars['Int']['input'];
};


export type PopmenuRootRootYextCategoriesArgs = {
  pagination: PaginationInput;
};


export type PopmenuRootSocialPostInstagramLivePostsArgs = {
  pagination: PaginationInput;
};


export type PopmenuRootSocialPostLivePostsArgs = {
  pagination: PaginationInput;
};


export type PopmenuRootUsersArgs = {
  pagination: PaginationInput;
};


export type PopmenuRootVersionsArgs = {
  modelId?: InputMaybe<Scalars['Int']['input']>;
  modelName: Scalars['String']['input'];
  pagination: PaginationInput;
};

export type PopmenuTerms = {
  __typename?: 'PopmenuTerms';
  clientAccessibility: Scalars['String']['output'];
  clientTerms: Scalars['String']['output'];
  dmcaPolicy: Scalars['String']['output'];
  giveawayTerms: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  privacy: Scalars['String']['output'];
  terms: Scalars['String']['output'];
  webAccessibility: Scalars['String']['output'];
};

export type PopsMetrics = {
  __typename?: 'PopsMetrics';
  currentWeekPopsCount: Scalars['Int']['output'];
  previousWeekPopsCount: Scalars['Int']['output'];
};

export type PopsMetricsByDaysAgo = {
  __typename?: 'PopsMetricsByDaysAgo';
  currentPopsCount: Scalars['Int']['output'];
  previousPopsCount?: Maybe<Scalars['Int']['output']>;
};

export type PositionInput = {
  id: Scalars['Int']['input'];
  position: Scalars['Int']['input'];
};

/** Autogenerated input type of PreparePhoneRegistration */
export type PreparePhoneRegistrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type Preview = {
  __typename?: 'Preview';
  previewHtml: Scalars['String']['output'];
};

/** Autogenerated input type of PreviewHungrrrPayConnection */
export type PreviewHungrrrPayConnectionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
  stripeAccountId: Scalars['String']['input'];
};

export type PriceReturn = {
  __typename?: 'PriceReturn';
  billingProductPrice?: Maybe<BillingProductPrice>;
};

export enum PrimaryButtonScale {
  Large = 'large',
  Medium = 'medium',
  Small = 'small'
}

export enum PrimaryButtonShape {
  Pill = 'pill',
  Rounded = 'rounded',
  Softened = 'softened',
  Square = 'square'
}

export type PrintLayout = {
  __typename?: 'PrintLayout';
  backgroundImageOpacity?: Maybe<Scalars['Decimal']['output']>;
  backgroundImageUploadedPhoto?: Maybe<UploadedPhoto>;
  backgroundImageUrl?: Maybe<Scalars['String']['output']>;
  bodyFont: FontSelection;
  bodyFontId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dishTagKeyHeight?: Maybe<Scalars['Int']['output']>;
  dishTagKeyPositionX?: Maybe<Scalars['Int']['output']>;
  dishTagKeyPositionY?: Maybe<Scalars['Int']['output']>;
  dishTagKeyWidth?: Maybe<Scalars['Int']['output']>;
  headingFont: FontSelection;
  headingFontId?: Maybe<Scalars['Int']['output']>;
  height: Scalars['Decimal']['output'];
  id: Scalars['Int']['output'];
  imageSections: Array<PrintLayoutImageSection>;
  menuItemDescriptionStyle?: Maybe<Scalars['String']['output']>;
  menuItemDishTagAlignment: Scalars['String']['output'];
  menuItemNameFont: FontSelection;
  menuItemNameFontCase?: Maybe<Scalars['String']['output']>;
  menuItemNameFontId?: Maybe<Scalars['Int']['output']>;
  menuItemPriceAlignment: Scalars['String']['output'];
  menuItemSizeExtraAlignment: Scalars['String']['output'];
  menuSectionDescriptionFont: FontSelection;
  menuSectionDescriptionFontId?: Maybe<Scalars['Int']['output']>;
  menuSectionNameFont: FontSelection;
  menuSectionNameFontId?: Maybe<Scalars['Int']['output']>;
  menuSections: Array<PrintLayoutMenuSection>;
  name: Scalars['String']['output'];
  printLayoutUrl?: Maybe<Scalars['String']['output']>;
  restaurant?: Maybe<Restaurant>;
  showMenuItemCurrency?: Maybe<Scalars['Boolean']['output']>;
  showMenuItemDishTagsKey?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['String']['output'];
  textSections: Array<PrintLayoutTextSection>;
  width: Scalars['Decimal']['output'];
};

export type PrintLayoutImageSection = {
  __typename?: 'PrintLayoutImageSection';
  height: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  imageUploadedPhoto?: Maybe<UploadedPhoto>;
  imageUrl: Scalars['String']['output'];
  opacity: Scalars['Decimal']['output'];
  positionX: Scalars['Int']['output'];
  positionY: Scalars['Int']['output'];
  positionZ: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export type PrintLayoutImageSectionInput = {
  height: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  imageUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  opacity: Scalars['Decimal']['input'];
  positionX: Scalars['Int']['input'];
  positionY: Scalars['Int']['input'];
  positionZ: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type PrintLayoutInput = {
  backgroundImageOpacity: Scalars['Decimal']['input'];
  backgroundImageUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  bodyFontColor?: InputMaybe<Scalars['String']['input']>;
  bodyFontId?: InputMaybe<Scalars['Int']['input']>;
  dishTagKeyHeight: Scalars['Int']['input'];
  dishTagKeyPositionX: Scalars['Int']['input'];
  dishTagKeyPositionY: Scalars['Int']['input'];
  dishTagKeyWidth: Scalars['Int']['input'];
  headingFontColor?: InputMaybe<Scalars['String']['input']>;
  headingFontId?: InputMaybe<Scalars['Int']['input']>;
  height: Scalars['Decimal']['input'];
  imageSections: Array<PrintLayoutImageSectionInput>;
  menuItemDescriptionStyle: Scalars['String']['input'];
  menuItemDishTagAlignment: Scalars['String']['input'];
  menuItemNameFontCase: Scalars['String']['input'];
  menuItemNameFontColor?: InputMaybe<Scalars['String']['input']>;
  menuItemNameFontId?: InputMaybe<Scalars['Int']['input']>;
  menuItemPriceAlignment: Scalars['String']['input'];
  menuItemSizeExtraAlignment: Scalars['String']['input'];
  menuSectionDescriptionFontColor?: InputMaybe<Scalars['String']['input']>;
  menuSectionDescriptionFontId?: InputMaybe<Scalars['Int']['input']>;
  menuSectionNameFontColor?: InputMaybe<Scalars['String']['input']>;
  menuSectionNameFontId?: InputMaybe<Scalars['Int']['input']>;
  menuSections: Array<PrintLayoutMenuSectionInput>;
  name: Scalars['String']['input'];
  showMenuItemCurrency: Scalars['Boolean']['input'];
  showMenuItemDishTagsKey: Scalars['Boolean']['input'];
  textSections: Array<PrintLayoutTextSectionInput>;
  width: Scalars['Decimal']['input'];
};

export type PrintLayoutMenuSection = {
  __typename?: 'PrintLayoutMenuSection';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  columnCount?: Maybe<Scalars['Int']['output']>;
  height: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  layoutIndex: Scalars['Int']['output'];
  menuSection?: Maybe<MenuSection>;
  menuSectionBorderColor?: Maybe<Scalars['String']['output']>;
  menuSectionBorderStyle: Scalars['String']['output'];
  menuSectionBorderWidth?: Maybe<Scalars['Int']['output']>;
  menuSectionId: Scalars['Int']['output'];
  menuSectionNameFlow?: Maybe<Scalars['String']['output']>;
  paddingTop: Scalars['Int']['output'];
  positionX: Scalars['Int']['output'];
  positionY: Scalars['Int']['output'];
  textAlignment: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type PrintLayoutMenuSectionInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  columnCount: Scalars['Int']['input'];
  height: Scalars['Int']['input'];
  menuSectionBorderColor?: InputMaybe<Scalars['String']['input']>;
  menuSectionBorderStyle: Scalars['String']['input'];
  menuSectionBorderWidth?: InputMaybe<Scalars['Int']['input']>;
  menuSectionId: Scalars['Int']['input'];
  menuSectionNameFlow: Scalars['String']['input'];
  paddingTop: Scalars['Int']['input'];
  positionX: Scalars['Int']['input'];
  positionY: Scalars['Int']['input'];
  textAlignment: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type PrintLayoutTextSection = {
  __typename?: 'PrintLayoutTextSection';
  content: Scalars['String']['output'];
  font: FontSelection;
  fontId?: Maybe<Scalars['Int']['output']>;
  fontSize: Scalars['Decimal']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isAutoFontSize?: Maybe<Scalars['Boolean']['output']>;
  positionX: Scalars['Int']['output'];
  positionY: Scalars['Int']['output'];
  positionZ: Scalars['Int']['output'];
  textAlignment: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type PrintLayoutTextSectionInput = {
  content: Scalars['String']['input'];
  fontColor?: InputMaybe<Scalars['String']['input']>;
  fontId?: InputMaybe<Scalars['Int']['input']>;
  fontSize: Scalars['Decimal']['input'];
  height: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isAutoFontSize: Scalars['Boolean']['input'];
  positionX: Scalars['Int']['input'];
  positionY: Scalars['Int']['input'];
  positionZ: Scalars['Int']['input'];
  textAlignment: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

/** Autogenerated input type of PromoteAimPromptConfigToDefault */
export type PromoteAimPromptConfigToDefaultInput = {
  aimPromptConfigId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Provider item types */
export type ProviderItem = {
  availableVariations: Array<ProviderVariation>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Provider menu types */
export type ProviderMenu = {
  availableMenuSections: Array<ProviderMenuSection>;
  id: Scalars['Int']['output'];
  isConnected: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** Provider menu section types */
export type ProviderMenuSection = {
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** Provider modifier types */
export type ProviderModifier = {
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
};

/** Provider variation types */
export type ProviderVariation = {
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
};

/** Provider warning types */
export type ProviderWarning = {
  id: Scalars['Int']['output'];
  warningType: Scalars['String']['output'];
};

/** Autogenerated input type of PublishCustomPageDrafts */
export type PublishCustomPageDraftsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customPageDraftIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of PublishLiveDomain */
export type PublishLiveDomainInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  liveDomainId: Scalars['Int']['input'];
};

export type Publishing = {
  __typename?: 'Publishing';
  categoryName: Scalars['String']['output'];
  data?: Maybe<Array<Data>>;
  id?: Maybe<Scalars['String']['output']>;
};

export type PushMessageGroup = {
  __typename?: 'PushMessageGroup';
  allSelected?: Maybe<Scalars['Boolean']['output']>;
  campaignItem?: Maybe<CampaignItem>;
  campaignItemId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBySegment?: Maybe<Scalars['Boolean']['output']>;
  deliveredMessagesCount: Scalars['Int']['output'];
  excludeUnknownLocations?: Maybe<Scalars['Boolean']['output']>;
  excludedFollowers: Array<PushMessageGroupExcludedFollower>;
  excludedLocations: Array<PushMessageGroupExcludedLocation>;
  excludedTags: Array<PushMessageGroupExcludedTag>;
  id: Scalars['Int']['output'];
  isCustomSelection: Scalars['Boolean']['output'];
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  isScheduled?: Maybe<Scalars['Boolean']['output']>;
  locationName: Scalars['String']['output'];
  message: Scalars['String']['output'];
  messagesCount: Scalars['Int']['output'];
  orderingOfferId?: Maybe<Scalars['Int']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  remarketedAction: Scalars['String']['output'];
  remarketedCampaignItemChannel?: Maybe<Channel>;
  remarketedCampaignItemId?: Maybe<Scalars['Int']['output']>;
  remarketedLocationId?: Maybe<Scalars['Int']['output']>;
  remarketedTagId?: Maybe<Scalars['Int']['output']>;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  scheduledMessagesCount: Scalars['Int']['output'];
  segmentationMatcher?: Maybe<Scalars['String']['output']>;
  selectedFollowerSegments: Array<PushMessageGroupSelectedFollowerSegment>;
  selectedFollowers: Array<PushMessageGroupSelectedFollower>;
  selectedLocations: Array<PushMessageGroupSelectedLocation>;
  selectedSources: Array<PushMessageGroupSelectedSource>;
  selectedTags: Array<PushMessageGroupSelectedTag>;
  sendToUnknownLocations?: Maybe<Scalars['Boolean']['output']>;
  tagName: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type PushMessageGroupExcludedFollower = {
  __typename?: 'PushMessageGroupExcludedFollower';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  follower?: Maybe<Follower>;
  followerId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
};

export type PushMessageGroupExcludedFollowerInput = {
  followerId: Scalars['Int']['input'];
};

export type PushMessageGroupExcludedLocation = {
  __typename?: 'PushMessageGroupExcludedLocation';
  id: Scalars['Int']['output'];
  location?: Maybe<RestaurantLocation>;
  locationId?: Maybe<Scalars['Int']['output']>;
};

export type PushMessageGroupExcludedLocationInput = {
  locationId: Scalars['Int']['input'];
};

export type PushMessageGroupExcludedTag = {
  __typename?: 'PushMessageGroupExcludedTag';
  followerTag?: Maybe<FollowerTag>;
  followerTagId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
};

export type PushMessageGroupExcludedTagInput = {
  followerTagId: Scalars['Int']['input'];
};

export type PushMessageGroupInput = {
  allSelected?: InputMaybe<Scalars['Boolean']['input']>;
  createdBySegment?: InputMaybe<Scalars['Boolean']['input']>;
  excludeUnknownLocations?: InputMaybe<Scalars['Boolean']['input']>;
  excludedFollowers?: InputMaybe<Array<PushMessageGroupExcludedFollowerInput>>;
  excludedLocations?: InputMaybe<Array<PushMessageGroupExcludedLocationInput>>;
  excludedTags?: InputMaybe<Array<PushMessageGroupExcludedTagInput>>;
  isCustomSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  orderingOfferId?: InputMaybe<Scalars['Int']['input']>;
  remarketedAction?: InputMaybe<Scalars['String']['input']>;
  remarketedCampaignItemId?: InputMaybe<Scalars['Int']['input']>;
  remarketedLocationId?: InputMaybe<Scalars['Int']['input']>;
  remarketedTagId?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledMessagesCount?: InputMaybe<Scalars['Int']['input']>;
  segmentationMatcher?: InputMaybe<Scalars['String']['input']>;
  selectedFollowerSegments?: InputMaybe<Array<PushMessageGroupSelectedFollowerSegmentInput>>;
  selectedFollowers?: InputMaybe<Array<PushMessageGroupSelectedFollowerInput>>;
  selectedLocations?: InputMaybe<Array<PushMessageGroupSelectedLocationInput>>;
  selectedSources?: InputMaybe<Array<PushMessageGroupSelectedSourceInput>>;
  selectedTags?: InputMaybe<Array<PushMessageGroupSelectedTagInput>>;
  sendToUnknownLocations?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PushMessageGroupSelectedFollower = {
  __typename?: 'PushMessageGroupSelectedFollower';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  follower?: Maybe<Follower>;
  followerId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
};

export type PushMessageGroupSelectedFollowerInput = {
  followerId: Scalars['Int']['input'];
};

export type PushMessageGroupSelectedFollowerSegment = {
  __typename?: 'PushMessageGroupSelectedFollowerSegment';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  restaurantFollowerSegment: RestaurantFollowerSegment;
  restaurantFollowerSegmentId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PushMessageGroupSelectedFollowerSegmentInput = {
  restaurantFollowerSegmentId: Scalars['Int']['input'];
};

export type PushMessageGroupSelectedLocation = {
  __typename?: 'PushMessageGroupSelectedLocation';
  id: Scalars['Int']['output'];
  location?: Maybe<RestaurantLocation>;
  locationId?: Maybe<Scalars['Int']['output']>;
};

export type PushMessageGroupSelectedLocationInput = {
  locationId: Scalars['Int']['input'];
};

export type PushMessageGroupSelectedSource = {
  __typename?: 'PushMessageGroupSelectedSource';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  source?: Maybe<Scalars['String']['output']>;
};

export type PushMessageGroupSelectedSourceInput = {
  source: Scalars['String']['input'];
};

export type PushMessageGroupSelectedTag = {
  __typename?: 'PushMessageGroupSelectedTag';
  followerTag?: Maybe<FollowerTag>;
  followerTagId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
};

export type PushMessageGroupSelectedTagInput = {
  followerTagId: Scalars['Int']['input'];
};

export type PushMfaChallengeVerifiedReturn = {
  __typename?: 'PushMfaChallengeVerifiedReturn';
  challengeSid?: Maybe<Scalars['String']['output']>;
  session: Session;
};

export type PushMfaEnrollmentAccessToken = {
  __typename?: 'PushMfaEnrollmentAccessToken';
  accessToken: Scalars['String']['output'];
  identity: Scalars['String']['output'];
  serviceSid: Scalars['String']['output'];
  ttlSeconds: Scalars['Int']['output'];
};

export type PushMfaEnrollmentUpdatedReturn = {
  __typename?: 'PushMfaEnrollmentUpdatedReturn';
  mfaFactor: TwilioVerifyMfaFactor;
  session: Session;
};

export type QrCardInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
  url: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  aiMarketingContent: AiMarketingContent;
  aiMarketingContents?: Maybe<Array<AiMarketingContent>>;
  /** Fetch a restaurant ai marketing default option */
  aiMarketingDefaultOption?: Maybe<AiMarketingDefaultOption>;
  aiMarketingMonthlyContents: Array<AiMarketingContentMonthlyWrapper>;
  aiReviewAutoResponseRules: Array<AiReviewResponseAutoResponseRule>;
  aiReviewResponseDefaultSetting: AiReviewResponseDefaultSetting;
  aimContentEvaluationBatch?: Maybe<AimContentEvaluationBatch>;
  /** Find an AIM default photo */
  aimDefaultPhoto?: Maybe<UploadedPhoto>;
  /** Find AIM default photos */
  aimDefaultPhotos?: Maybe<AimDefaultPhotoPaginationHandler>;
  aimExcludedDishes: DishPaginationHandler;
  aimIncludedDishes: DishPaginationHandler;
  aimPromptConfig?: Maybe<AimPromptConfig>;
  aimPromptConfigs: Array<AimPromptConfig>;
  allFollowerImports: Array<FollowerImport>;
  /** Find all ordering offers */
  allOrderingOffers: OrderingOfferPaginationHandler;
  /** Find all popmenu restaurants available to attach to Aloha account */
  alohaAccountAvailableRestaurants: RestaurantPaginationHandler;
  /** Find all Aloha Accounts for Root */
  alohaAccounts: AlohaAccountPaginationHandler;
  /** Find Aloha sites by aloha account */
  alohaSitesByAccount: Array<AlohaSite>;
  /** Find an announcement by ID */
  announcement: Announcement;
  /** Find announcements */
  announcements: AnnouncementPaginationHandler;
  /** Answering Overview Data */
  answeringOverview: AnsweringOverview;
  /** Answering Overview call outcomes */
  answeringOverviewCallOutcomes: AnsweringOverviewCallOutcomes;
  /** Answering Overview calls by day of week */
  answeringOverviewCallsByDayOfWeek: Array<AnsweringOverviewCallsByDayOfWeek>;
  /** Answering Overview KPI tiles */
  answeringOverviewKpis: AnsweringOverview;
  /** Answering Overview top topics */
  answeringOverviewTopTopics: Array<AnsweringOverviewTopTopics>;
  /**
   * Answering Performance Snapshot Data
   * @deprecated This is only used in mobile app for legacy reasons
   */
  answeringPerformanceSnapshot: AnsweringOverview;
  answeringSetting?: Maybe<RestaurantLocationAnsweringSetting>;
  /** Answering Usage and Limits Data */
  answeringUsageLimits: Array<AnsweringUsageLimits>;
  availableBillingProductPrices: Array<BillingProductPrice>;
  /** Get list of all available feature flags */
  availableFeatureFlags: FeatureFlags;
  availableReservationTimes: Array<AvailableReservationTime>;
  availableReservations: PartyAvailableReservations;
  /** Find all popmenu restaurants available to attach to Toast restaurant */
  availableRestaurantsToAttach: RestaurantPaginationHandler;
  averageSessionTimeInMinutes?: Maybe<AverageSessionTimeInMinutes>;
  awsSignature: AwsSignature;
  billingCoupon: BillingCoupon;
  billingCoupons: BillingCouponPaginationHandler;
  billingEntitlementFeatureFlagByFeature?: Maybe<BillingEntitlementFeatureFlag>;
  billingEntitlementFeatureFlags: Array<BillingEntitlementFeatureFlag>;
  billingEntitlements: Array<BillingEntitlement>;
  billingEntitlementsByFeature: Array<BillingEntitlement>;
  billingInvoices: BillingInvoicePaginationHandler;
  billingPlan: BillingPlan;
  billingPlans: BillingPlanPaginationHandler;
  billingProduct: BillingProduct;
  billingProductPrices: BillingProductPricePaginationHandler;
  billingProducts: BillingProductPaginationHandler;
  /** Find Root Blocked Term */
  blockedTerm: BlockedTerm;
  /** Find Root Blocked Terms */
  blockedTerms: BlockedTermPaginationHandler;
  /** Find a post by ID */
  blogPost: BlogPost;
  /** Find a post by slug */
  blogPostBySlug: BlogPost;
  /** Find blog posts */
  blogPosts: BlogPostPaginationHandler;
  /** Brand Impression Data */
  brandImpressionMetrics: PerformanceSnapshotBrandImpressions;
  /** Find an calendar event by ID */
  calendarEvent: CalendarEvent;
  /** Find a event by slug */
  calendarEventBySlug: CalendarEvent;
  /** Find a ticket cart by slug for admin */
  calendarEventTicketCart?: Maybe<CalendarEventTicketCart>;
  /** Find completed and refunded ticket carts for a calendar event */
  calendarEventTicketCarts: CalendarEventTicketCartPaginationHandler;
  /** Find calendar events */
  calendarEvents: CalendarEventPaginationHandler;
  /** Find calendar events by date range */
  calendarEventsByDateRange: CalendarEventPaginationHandler;
  callsByHourByDate: CallsByHourByDate;
  /** Campaign Item Data */
  campaignItem: CampaignItem;
  /** Campaign Items Data */
  campaignItems: CampaignItemPaginationHandler;
  /** Campaign Items Data */
  campaignItemsBySelectedDate: Array<CampaignItem>;
  /** Campaign Item Data */
  campaignItemsFromCampaign: Array<CampaignItem>;
  categories: Array<ChatBotCoreCategory>;
  /** Get response to a message from popmenu chatbot */
  chatbotResponse: ChatbotResponse;
  /** Get active session for popmenu chatbot */
  chatbotSession: ChatbotSession;
  consumerUser?: Maybe<User>;
  consumerUserByEmail?: Maybe<FollowerFlow>;
  consumerUserByPhone?: Maybe<FollowerFlow>;
  createBillingRequestFlow: GocardlessBillingRequestFlow;
  cuisineTypes: Array<CuisineType>;
  /** Current session */
  currentSession: Session;
  /** Current authenticated user */
  currentUser?: Maybe<User>;
  /** Find one custom fee */
  customFee: CustomFee;
  /** Find all custom fees per location */
  customFees: CustomFeePaginationHandler;
  customForms?: Maybe<CustomFormPaginationHandler>;
  customPage?: Maybe<CustomPage>;
  customPageAdvancedFormById?: Maybe<CustomPageAdvancedForm>;
  customPageAdvancedFormNotificationRecipients?: Maybe<CustomPageAdvancedFormNotificationRecipientPaginationHandler>;
  customPageAdvancedForms?: Maybe<CustomPageAdvancedFormPaginationHandler>;
  customPageById?: Maybe<CustomPage>;
  /** Find a draft custom page by ID */
  customPageDraftById?: Maybe<CustomPageDraft>;
  /** Find draft custom pages */
  customPageDrafts?: Maybe<DraftPaginationHandler>;
  customPagePublishPreview?: Maybe<CustomPagePublishPreview>;
  customPageSection?: Maybe<CustomPageSection>;
  customPageSectionDraft?: Maybe<CustomPageSectionDraft>;
  customPages?: Maybe<CustomPagePaginationHandler>;
  customRedirect: RestaurantCustomRedirect;
  customRedirectsByRestaurant: CustomRedirectPaginationHandler;
  customResponsesByActionId: Array<ChatBotCoreIntentCustomResponse>;
  customTaxRate: CustomTaxRate;
  dish: Dish;
  dishHistory: DishHistoryPaginationHandler;
  dishInteractionsPopCount?: Maybe<Array<DishInteractionsPopCount>>;
  dishList: DishList;
  dishLists: DishListPaginationHandler;
  dishes: DishPaginationHandler;
  dishesById: Array<Dish>;
  dishesOnlineOrdering: DishPaginationHandler;
  dishesOnlineOrderingFeaturedItems: DishPaginationHandler;
  dishesReviews: Array<Review>;
  /** Earliest phone call for a location */
  earliestPhoneCall?: Maybe<TwilioPhoneCall>;
  /** @deprecated This is only used in mobile app for legacy reasons */
  emailOpenRateMetrics?: Maybe<EmailMetrics>;
  /** Find offers */
  enabledOffers: EnabledOffersReturn;
  /** Estimated Revenue Data */
  estimatedRevenueMetrics: Array<PerformanceSnapshotEstimatedRevenues>;
  eventTag: EventTag;
  eventTags: EventTagPaginationHandler;
  existingRestaurantMember: Scalars['Boolean']['output'];
  failedFollowerImports: Array<FollowerImport>;
  /** Fetch restaurant's failed message groups */
  failedMessageGroups: Array<MessageGroup>;
  /** Find failed social posts */
  failedSocialPosts: Array<SocialPost>;
  /** Find failure indicator social posts */
  failureIndicatorSocialPosts: Array<SocialPost>;
  feedbackByToken?: Maybe<Feedback>;
  feedbacks: FeedbackPaginationHandler;
  fetchParties: PartyPaginationHandler;
  fetchPartiesCount: Array<PartyCount>;
  fetchPartyByToken?: Maybe<Party>;
  fetchPartySettings: PartySettings;
  /** Fetch seatable TableTops that can be assigned when seating a party */
  fetchSeatableTableTops: Array<RestaurantLocationTableTop>;
  /** Find TableTops by location id */
  fetchTableTops: TableTopPaginationHandler;
  fetchUserPastParties: Array<Party>;
  flaggedContentAuditsByRestaurant: CombinedContentAudits;
  /** Find an Upload Folder by id */
  folder: UploadableFolder;
  follower: Follower;
  followerByRestaurant?: Maybe<Follower>;
  /** Follower By Time Data */
  followerByTimeMetrics: Array<PerformanceSnapshotFollowerByTime>;
  followerFavoriteLocation?: Maybe<Follower>;
  followerKpiCounts?: Maybe<FollowerKpiCounts>;
  /** Find a restaurant follower segment by ID */
  followerSegment: RestaurantFollowerSegment;
  /** Get estimated audience counts for a follower segment with optional new settings */
  followerSegmentEstimatedAudience: FollowerSegmentEstimatedAudience;
  /** Get paginated list of follower segmentations for a segment */
  followerSegmentPaginatedAudience: FollowerSegmentationPaginationHandler;
  /** Find an follower tag by ID */
  followerTag: FollowerTag;
  /** Find all follower tags */
  followerTags: FollowerTagPaginationHandler;
  followersByRestaurant?: Maybe<FollowerPaginationHandler>;
  followersForMessages?: Maybe<FollowersForMessages>;
  followersMessageLocationAudienceOptions?: Maybe<CombinedLocationOptions>;
  followersMessageTagAudienceOptions?: Maybe<CombinedMessageTagOptions>;
  followersTableFilterOptions: FollowerTableFilterOptions;
  /** Find a gift card by code */
  giftCardByCode?: Maybe<GiftCard>;
  /** Find all gift cards */
  giftCards: GiftCardPaginationHandler;
  gmbLocalPost: GooglePost;
  googleAccount?: Maybe<SocialAccount>;
  gradedPlaygroundEvaluationBatches: Array<AimContentEvaluationBatch>;
  guestProfileUser?: Maybe<GuestProfile>;
  /** @deprecated This is only used in mobile app for legacy reasons */
  hasOnlineOrderingBeenEnabled?: Maybe<Scalars['Boolean']['output']>;
  highlightReel?: Maybe<HighlightReel>;
  highlightReels: Array<HighlightReel>;
  /** Social account Facebook photos */
  instagramPhotos: Array<SocialAccountFacebookPageInstagramPhoto>;
  lastUpdatedOverviewMetrics?: Maybe<Scalars['String']['output']>;
  lighthouseReportPageReport?: Maybe<LighthouseReportPageReport>;
  liveDomain: LiveDomain;
  liveDomainStagedRecords?: Maybe<LiveDomainStagedRecordPaginationHandler>;
  /** Find a location by ID or slug */
  location: RestaurantLocation;
  /** Find a location by twilio phone number */
  locationByTwilioPhone?: Maybe<RestaurantLocation>;
  /** Collect data across location about Toast integration */
  locationToastSummary: ToastRestaurantSummary;
  /** Find a login carousel slide */
  loginCarouselSlide?: Maybe<LoginCarouselSlide>;
  /** Find login carousel slides */
  loginCarouselSlides?: Maybe<LoginCarouselSlidePaginationHandler>;
  loyaltyAccount?: Maybe<LoyaltyAccount>;
  /** Fetch a loyalty program */
  loyaltyProgram?: Maybe<LoyaltyProgram>;
  marketingCalendarWeekDates?: Maybe<Scalars['JSON']['output']>;
  marketingMessageDays?: Maybe<Array<Scalars['String']['output']>>;
  marketingMessages: Array<MarketingMessages>;
  /** Find a marketing offer by id */
  marketingOffer: MarketingOffer;
  /** Find marketing offers */
  marketingOffers: MarketingOfferPaginationHandler;
  /** Find active mass message ordering offers */
  massMessageOrderingOffers: OrderingOfferPaginationHandler;
  /** Find a master message campaign */
  masterMessageCampaign?: Maybe<MasterMessageCampaign>;
  /** Find master message campaigns */
  masterMessageCampaigns?: Maybe<MasterMessageCampaignPaginationHandler>;
  /** Menu entry point */
  menu?: Maybe<Menu>;
  /** Find menu featured section by menu id */
  menuFeaturedSection?: Maybe<MenuFeaturedSection>;
  /** Menu item entry point */
  menuItem?: Maybe<MenuItem>;
  menuItemByDishAndLocation?: Maybe<MenuItem>;
  menuItemByLocationAndFulfillmentType?: Maybe<MenuItem>;
  menuItemCart: MenuItemCart;
  menuItemCartApplicableCustomFees: MenuItemCart;
  menuItemCartByToken: MenuItemCart;
  menuItemCartConfirmed: MenuItemCart;
  menuItemCartExternalIntegration?: Maybe<ExternalIntegration>;
  menuItemCartHistory: MenuItemCartHistoryPaginationHandler;
  menuItemCartSelectedMenuItem: MenuItemCartSelectedMenuItem;
  menuItemCartSelectedModifier: MenuItemCartSelectedMenuItemSelectedModifierGroupSelectedModifier;
  menuItemCartVerifyAddress: DeliveryAddress;
  menuItemCartsByLocationId: MenuItemCartPaginationHandler;
  menuItemCartsSubmittedAtDateByInvoiceNumber: Array<Scalars['DateTime']['output']>;
  menuItemModifier: MenuItemModifierGroupModifier;
  /** Find a menu item modifier group by ID */
  menuItemModifierGroup: MenuItemModifierGroup;
  menuItems?: Maybe<MenuItemPaginationHandler>;
  /** Find menu items by menu */
  menuItemsByMenu?: Maybe<MenuItemPaginationHandler>;
  /** Menu section temporal prices entry point */
  menuItemsWithTemporalPrices?: Maybe<Array<MenuItem>>;
  /** Find menu presence users */
  menuPresenceUsers?: Maybe<Array<MenuPresence>>;
  /** Fetch a menu processing result by ID */
  menuProcessingResult?: Maybe<MenuProcessingResult>;
  /** Menu section entry point */
  menuSection?: Maybe<MenuSection>;
  /** Menu subsection entry point */
  menuSubsection?: Maybe<MenuSubsection>;
  menuSyncHistories?: Maybe<Array<MenuSyncHistory>>;
  menuYextSync?: Maybe<MenuYextSync>;
  /** Get list of menus from list of ids */
  menusById?: Maybe<Array<Menu>>;
  /** Find a message by its unique token */
  messageByToken: MessageGroupMessage;
  /** Find a message campaign */
  messageCampaign: MessageCampaign;
  /** Find a message campaign by trigger type */
  messageCampaignByTriggerType: MessageCampaignByTriggerType;
  /** Find message campaigns engagement offers by restaurant and member (optional) */
  messageCampaignEngagementOffers: Array<MessageCampaign>;
  /** Find messages sent by a message campaigns */
  messageCampaignMessages: MessagePaginationHandler;
  /** Fetch revenue data for a batch of message campaigns */
  messageCampaignRevenues: Array<MessageCampaign>;
  /** Fetch a mass message */
  messageGroup: MessageGroup;
  /** Fetch index location of requested message group */
  messageGroupIndex?: Maybe<Scalars['Int']['output']>;
  /** Fetch links by a message group */
  messageGroupLinks: MessageGroupLinkPagination;
  /** Fetch messages by mass message */
  messageGroupMessages: MessageGroupMessagePagination;
  /** Fetch mass messages */
  messageGroups: MessageGroupPaginationHandler;
  /** Find all popmenu restaurants available to attach to Micros org */
  microsOrgAvailableRestaurants: RestaurantPaginationHandler;
  /** Find all Micros Organizations for Root */
  microsOrgs: MicrosOrgPaginationHandler;
  /** Micros RVC handlers for attachment to Pop Location */
  microsRvcAttachmentHandlers: Array<MicrosRvcAttachmentHandler>;
  mobileVisitsPercentagesByDaysAgo?: Maybe<MobileVisitsPercentagesByDaysAgo>;
  /** Find a modifier group by ID */
  modifierGroup: ModifierGroup;
  /** Find all modifier groups for a given restaurant */
  modifierGroups: ModifierGroupPaginationHandler;
  modularSignUpProgress?: Maybe<ModularSignUpProgress>;
  ncrOnboardingFeePrice: Scalars['Int']['output'];
  /** Find Ncr Payment Account by id */
  ncrPaymentAccount: NcrPaymentAccount;
  /** Find all popmenu restaurants available to attach to NCR payment account */
  ncrPaymentAccountAvailableRestaurants: RestaurantPaginationHandler;
  /** Find all Ncr Payment Accounts for Root */
  ncrPaymentAccounts: NcrPaymentAccountPaginationHandler;
  /** Initialize Ncr WebEPS payment session */
  ncrPaymentSessionRequestUrl: NcrPayment;
  /** Find Ncr Silver stores by ncr silver account */
  ncrSilverStoresByAccount: Array<NcrSilverStore>;
  /** Find a nested menu item modifier group by ID */
  nestedMenuItemModifierGroup: MenuItemModifierGroupModifierModifierGroup;
  notFoundsByRestaurant: NotFoundPaginationHandler;
  /** List oauth applications */
  oauthApplications: Array<OauthApplication>;
  /** Find an offer by ID */
  offer: Offer;
  /** Find an offer code by code */
  offerCode: OfferCode;
  /** Find offer codes by offer ID */
  offerCodes: OfferCodesPaginationHandler;
  /** Find offers */
  offers: OfferPaginationHandler;
  /** Find an ordering_event by ID */
  orderingEvent: OrderingEvent;
  /** Find an ordering_event by slug */
  orderingEventBySlug: OrderingEvent;
  /** Find ordering_events */
  orderingEvents: OrderingEventPaginationHandler;
  /** @deprecated This is only used in mobile app for legacy reasons */
  orderingFullfilmentType?: Maybe<OrderingOverview>;
  /** Specifically for ordering app. Lightest query possible for menu item */
  orderingMenuItem?: Maybe<MenuItem>;
  orderingMenuItemModifier: MenuItemModifierGroupModifier;
  /** Specifically for ordering app prefetching. Uses the simplest, lightest query possible */
  orderingMenuItemPreview?: Maybe<MenuItem>;
  /** fetch menus viewed in the ordering app or with items in the menu item cart */
  orderingMenus?: Maybe<Array<Menu>>;
  /** Find an ordering offer by ID */
  orderingOffer: OrderingOffer;
  /** Find an ordering offer code by code */
  orderingOfferCode: OrderingOfferCode;
  /** Find ordering offer codes by restaurant ID */
  orderingOfferCodes: OrderingOfferPaginationHandler;
  /** Get the order offer preview by offer ID */
  orderingOfferPreview: Scalars['String']['output'];
  /** Find ordering offers */
  orderingOffers: OrderingOfferPaginationHandler;
  orderingOverview: OrderingOverview;
  /** Ordering Overview KPI tiles */
  orderingOverviewKpis: OrderingOverview;
  /** Ordering Overview orders by type */
  orderingOverviewOrdersByType: Array<OrderingOverviewOrder>;
  /** Ordering Overview revenue by fulfillment type */
  orderingOverviewRevenueByFulfillment: Array<OrderingOverviewOrderRevenueByFullfillment>;
  /** Ordering Overview revenue by source */
  orderingOverviewRevenueBySource: Array<OrderingOverviewOrderRevenueBySource>;
  /** Ordering Overview volume and revenue chart */
  orderingOverviewVolumeAndRevenue: OrderingOverview;
  /** @deprecated This is only used in mobile app for legacy reasons */
  orderingRevenueAndVolume?: Maybe<OrderingOverview>;
  ordersByHourByDate: OrdersByHourByDate;
  outboundClickEvents?: Maybe<Array<OutboundClickEvents>>;
  /** Reviews table sortable requests */
  paginatedReviews: PaginatedReviewsHandler;
  /** Pending menu item cart */
  pendingMenuItemCart: MenuItemCart;
  /** Returns true if the phone is already used by another user with MFA enabled */
  phoneUsedByMfa?: Maybe<Scalars['Boolean']['output']>;
  /** Popmenu configuration */
  popmenuConfig: PopmenuConfig;
  popmenuIdToken: PopmenuIdToken;
  /** Fetch a loyalty program */
  popmenuLoyaltyProgram?: Maybe<PopmenuLoyaltyProgram>;
  popmenuRoot: PopmenuRoot;
  /** Popmenu legal documents */
  popmenuTerms: PopmenuTerms;
  positivePopsCountByDaysAgo?: Maybe<PopsMetricsByDaysAgo>;
  positivePopsCountByWeek?: Maybe<PopsMetrics>;
  potentialDuplicateDishes: Array<Dish>;
  priceChangeSchedules: Array<MenuItemTemporalPriceChangeSchedule>;
  printLayout: PrintLayout;
  /** Find a promoted offer by restaurant id and marketing type */
  promotedOffer?: Maybe<MarketingOffer>;
  /** Find login carousel slides */
  publicLoginCarouselSlides?: Maybe<LoginCarouselSlidePaginationHandler>;
  recentFollowerMassActionNotifications?: Maybe<Array<FollowerMassActionNotification>>;
  /** Find redeemed ordering offer codes by offer ID */
  redeemedOrderingOfferCodes: OrderingOfferCodesPaginationHandler;
  resellerSalesforceAccount: Scalars['Boolean']['output'];
  /** Restaurant entry point */
  restaurant: Restaurant;
  /** Gets all locations based on the aim permissions */
  restaurantAimLocations: Array<RestaurantLocation>;
  restaurantAllFeaturedAnnouncements?: Maybe<Array<Announcement>>;
  /** Find automated emails from restaurant */
  restaurantAutomatedEmails: AutomatedEmailPaginationHandle;
  /** Find a restaurant by slug */
  restaurantBySlug: Restaurant;
  restaurantDishTag: RestaurantDishTag;
  restaurantDishTags: DishTagPaginationHandler;
  restaurantEmbedBySlug: RestaurantEmbed;
  /** Find restaurant rollout flags */
  restaurantFeatureFlags: RestaurantFeatureFlags;
  restaurantFeaturedAnnouncement?: Maybe<Announcement>;
  restaurantFeaturedAnnouncements?: Maybe<Array<Announcement>>;
  restaurantFooterLink: RestaurantFooterLink;
  restaurantFooterLinkDraft: RestaurantFooterLinkDraft;
  /** Find restaurant group and its restaurants */
  restaurantGroup: RestaurantGroup;
  restaurantGroups: RestaurantGroupPaginationHandler;
  /** Location entry point */
  restaurantLocation: RestaurantLocation;
  /** Find a location by id */
  restaurantLocationOrderingAvailability: RestaurantLocation;
  /** Gets all locations based on the permission requested */
  restaurantLocationsByUserPermission: Array<RestaurantLocation>;
  /** Count of restaurant locations */
  restaurantLocationsCount: RestaurantLocationsCount;
  restaurantMember: RestaurantMember;
  restaurantMemberClientProfile?: Maybe<RestaurantMemberClientProfile>;
  /** Find an admin invite by token */
  restaurantMemberInvite?: Maybe<RestaurantMemberInvite>;
  restaurantMemberInvites: MemberInvitePaginationHandler;
  restaurantMemberLocation?: Maybe<RestaurantMemberLocation>;
  restaurantMembers: MemberPaginationHandler;
  restaurantMobileAppAssets: Array<RestaurantMobileAppAsset>;
  restaurantNavDropdown: RestaurantNavDropdown;
  restaurantNavDropdownDraft: RestaurantNavDropdownDraft;
  restaurantNavLink: RestaurantNavLink;
  restaurantNavLinkDraft: RestaurantNavLinkDraft;
  /** Count of available offers */
  restaurantOffersCount: RestaurantOffersCount;
  restaurantSessionsByDeviceType?: Maybe<Array<RestaurantSessionsByDevice>>;
  restaurantSessionsByMarketingSource?: Maybe<Array<RestaurantSessionsByMarketingSource>>;
  restaurantWebsitePublishRecords: WebsitePublishRecordPaginationHandler;
  /** Restaurants entry point */
  restaurants: Array<Restaurant>;
  /** Find restaurants without a restaurant group */
  restaurantsWithoutGroups: RestaurantPaginationHandler;
  /** Revenue Generating Source Data */
  revenueGeneratingSourceMetrics: Array<PerformanceSnapshotRevenueGeneratingSources>;
  /** Review entry point */
  review: Review;
  reviewMetrics: ReviewMetrics;
  /** Review Sentiment Data */
  reviewSentimentMetrics: PerformanceSnapshotReviewSentiment;
  /** Find a root announcement by ID */
  rootAnnouncement: RootAnnouncement;
  /** Find root announcements */
  rootAnnouncements: RootAnnouncementPaginationHandler;
  rootDishCategoryBySlug: RootDishCategory;
  rootDishTag: RootDishTag;
  rootDishTags: RootDishTagPaginationHandler;
  rootMessagePackEmailTemplates: Array<RootMessagePack>;
  rootMessagePacksByRestaurant: Array<RootMessagePack>;
  rootOrderingOffers: Array<RootOrderingOffer>;
  rootPlace: RootPlace;
  rootPlaces: RootPlacePaginationHandler;
  rootPlatformFees: Array<RootPlatformFee>;
  rootSalesDemoRestaurants?: Maybe<RestaurantPaginationHandler>;
  rootSalesDemoTemplateRestaurants?: Maybe<Array<Restaurant>>;
  rootSectionTemplate: RootSectionTemplate;
  rootSectionTemplates: RootSectionTemplatePaginationHandler;
  rootSectionTemplatesByType: Array<RootSectionTemplate>;
  rootSectionTypes: RootSectionTypePaginationHandler;
  rootSiteTemplate: RootSiteTemplate;
  rootSiteTemplates: RootSiteTemplatePaginationHandler;
  rootSproutSocialGroups?: Maybe<GroupPaginationHandler>;
  rootTask?: Maybe<RootTask>;
  rootTasks?: Maybe<PaginationHandler>;
  rootThemeTemplates: RootThemeTemplatePaginationHandler;
  rootThemes: RootThemePaginationHandler;
  rootUsers: Array<User>;
  salesMeetingLink?: Maybe<Scalars['String']['output']>;
  salesforceMigrationInspect: SalesforceMigrationInspectResult;
  selfCheckoutProductCatalog: Array<BillingPlan>;
  selfSignUpPlans: Array<SelfSignUpPlan>;
  /** @deprecated This is only used in mobile app for legacy reasons */
  sentMessagesMetrics?: Maybe<SentMessagesMetrics>;
  seoCrawlIssue?: Maybe<SeoCrawlIssue>;
  siteVisits?: Maybe<Array<WebsiteMetrics>>;
  /** Sms Limits Data */
  smsLimitsUsage: SmsLimits;
  /** Social account */
  socialAccount: SocialAccount;
  /** Find social post */
  socialPost: SocialPost;
  /** Find suggested social posts */
  socialPostSuggestions: Array<SocialPostSuggestion>;
  /** Find social posts */
  socialPosts: SocialPostPaginationHandler;
  /** Spoton location handlers for attachment to Pop Location */
  spotonLocationAttachmentHandlers: Array<SpotonLocationAttachmentHandler>;
  /** Return one of each related menu sections with menu_type_square from all related locations */
  squareMenuRelatedUniqSections: Array<MenuSection>;
  /** Find Square seller locations by square account */
  squareSellerLocationsByAccount: Array<SquareSellerLocation>;
  subscriptionPayerBillingCustomer?: Maybe<BillingCustomer>;
  suggestedDishOptions: DishPaginationHandler;
  suggestedDishes: Array<SuggestedDish>;
  suggestedMenuItems: Array<MenuItem>;
  supportCaseReplies?: Maybe<Array<SalesforceCaseReply>>;
  supportCaseRepliesCount: Scalars['Int']['output'];
  supportCases: CasePaginationHandler;
  synthesizeSpeech: Scalars['String']['output'];
  /** Fetch text messages by a text message group */
  textMessages: TextMessagePaginationHandler;
  themeFont: ThemeFont;
  themeFonts: Array<ThemeFont>;
  /** Find a location ordering throttle setting */
  throttleSetting: ThrottleSetting;
  /** Find or create the current session's active ticket cart for a calendar event */
  ticketCart?: Maybe<CalendarEventTicketCart>;
  toastHostedPaymentIntent: ToastHostedPaymentIntent;
  /** Find toast restaurant by id */
  toastRestaurant?: Maybe<ToastRestaurant>;
  /** Find all toast restaurants for Root */
  toastRestaurants: ToastRestaurantPaginationHandler;
  /** Fetch top performing message groups */
  topMessageGroups: Array<MessageGroup>;
  topReviewedItems?: Maybe<Array<TopReviewedItems>>;
  /** Find top social posts */
  topSocialPosts: Array<SocialPost>;
  totalFollowersBySelectedMonth?: Maybe<Scalars['Int']['output']>;
  /** @deprecated This is only used in mobile app for legacy reasons */
  totalFollowersByWeek?: Maybe<FollowerMetrics>;
  /** @deprecated This is only used in mobile app for legacy reasons */
  totalMarketingRevenueByWeek?: Maybe<RevenueMetrics>;
  totalOrganicSiteVisitsByDaysAgo?: Maybe<OrganicSiteVisitsPercentagesByDaysAgo>;
  totalReviewsBySelectedMonth?: Maybe<Scalars['Int']['output']>;
  /** @deprecated This is only used in mobile app for legacy reasons */
  totalReviewsByWeek?: Maybe<ReviewsMetrics>;
  totalReviewsCountByDaysAgo?: Maybe<ReviewsMetricsByDaysAgo>;
  totalSiteVisitsByDaysAgo?: Maybe<SiteVisitsMetricsByDaysAgo>;
  /** @deprecated This is only used in mobile app for legacy reasons */
  totalSiteVisitsByWeek?: Maybe<SiteVisitsMetrics>;
  totalUniqueSessionsBySelectedMonth?: Maybe<Scalars['Int']['output']>;
  totalVisitsBySelectedMonth?: Maybe<Array<VisitMetricsBoostReport>>;
  trafficByCityBySelectedMonth?: Maybe<Array<TrafficByCity>>;
  trafficByDeviceTypeBySelectedMonth?: Maybe<Array<RestaurantSessionsByDevice>>;
  twilioBannedWords: Array<TwilioBannedWords>;
  twilioIncomingMessages: TwilioIncomingMessagePaginationHandler;
  /** Find a Twilio phone call */
  twilioPhoneCall: TwilioPhoneCall;
  /** Find Twilio phone calls */
  twilioPhoneCalls: TwilioPhoneCallPaginationHandler;
  twilioPhoneNumbers: TwilioPhoneNumberPaginationHandler;
  twilioSentMessages: TwilioMessagePaginationHandler;
  /** Find Twilio voicemails */
  twilioVoicemails: TwilioPhoneCallPaginationHandler;
  upsellCampaign: UpsellCampaign;
  upsellCampaignEligibleDishes: UpsellCampaignEligibleDishPaginationHandler;
  upsellCampaigns: Array<UpsellCampaign>;
  user: User;
  userByContacts?: Maybe<User>;
  userByEmail?: Maybe<User>;
  userById: User;
  userByPhone?: Maybe<PhoneUser>;
  userByUnsubscribeMessageToken: UserByUnsubscribeTokenReturn;
  userByUnsubscribeToken: User;
  userDevice: UserDevice;
  userLocationsSearch: Array<UserLocationsSearchResult>;
  userPhoneSearch?: Maybe<Array<User>>;
  userSalesforceAccounts: Array<SalesforceAccount>;
  usersWithUserImpersonationToolAccess: Array<UserImpersonationAccess>;
  visibleDishes: DishPaginationHandler;
  yextAccount?: Maybe<YextAccount>;
  yextLoginUrl?: Maybe<Scalars['String']['output']>;
};


export type QueryAiMarketingContentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAiMarketingContentsArgs = {
  monthDate?: InputMaybe<Scalars['DateTime']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryAiMarketingDefaultOptionArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryAiMarketingMonthlyContentsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  restaurantId: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryAiReviewAutoResponseRulesArgs = {
  defaultSettingId: Scalars['Int']['input'];
};


export type QueryAiReviewResponseDefaultSettingArgs = {
  locationId: Scalars['Int']['input'];
};


export type QueryAimContentEvaluationBatchArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAimDefaultPhotoArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAimDefaultPhotosArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAimExcludedDishesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryAimIncludedDishesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryAimPromptConfigArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAimPromptConfigsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAllFollowerImportsArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryAllOrderingOffersArgs = {
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryAlohaAccountAvailableRestaurantsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAlohaAccountsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAlohaSitesByAccountArgs = {
  alohaAccountId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type QueryAnnouncementArgs = {
  announcementId: Scalars['Int']['input'];
};


export type QueryAnnouncementsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  rangeTime?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryAnsweringOverviewArgs = {
  dateRange?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
  metricType: Scalars['String']['input'];
};


export type QueryAnsweringOverviewCallOutcomesArgs = {
  dateRange?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
};


export type QueryAnsweringOverviewCallsByDayOfWeekArgs = {
  dateRange?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
};


export type QueryAnsweringOverviewKpisArgs = {
  dateRange?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
};


export type QueryAnsweringOverviewTopTopicsArgs = {
  dateRange?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
};


export type QueryAnsweringPerformanceSnapshotArgs = {
  metricType: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type QueryAnsweringSettingArgs = {
  locationId: Scalars['Int']['input'];
};


export type QueryAnsweringUsageLimitsArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryAvailableReservationTimesArgs = {
  locationId: Scalars['Int']['input'];
  overrideCapacity?: InputMaybe<Scalars['Boolean']['input']>;
  partySize: Scalars['Int']['input'];
  reservationDate: Scalars['DateTime']['input'];
  reservationTime: Scalars['String']['input'];
};


export type QueryAvailableReservationsArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  locationId: Scalars['Int']['input'];
};


export type QueryAvailableRestaurantsToAttachArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAverageSessionTimeInMinutesArgs = {
  daysAgo?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
  selectedMonth?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAwsSignatureArgs = {
  input: AwsSignatureInput;
};


export type QueryBillingCouponArgs = {
  billingCouponId: Scalars['Int']['input'];
};


export type QueryBillingCouponsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryBillingEntitlementFeatureFlagByFeatureArgs = {
  featureId: Scalars['String']['input'];
};


export type QueryBillingEntitlementsByFeatureArgs = {
  featureId: Scalars['String']['input'];
};


export type QueryBillingInvoicesArgs = {
  billingCustomerId: Scalars['Int']['input'];
  daysAgo?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceType?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryBillingPlanArgs = {
  billingPlanId: Scalars['Int']['input'];
};


export type QueryBillingPlansArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryBillingProductArgs = {
  billingProductId: Scalars['Int']['input'];
};


export type QueryBillingProductPricesArgs = {
  billingProductId: Scalars['Int']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryBillingProductsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryBlockedTermArgs = {
  blockedTermId: Scalars['Int']['input'];
};


export type QueryBlockedTermsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryBlogPostArgs = {
  blogPostId: Scalars['Int']['input'];
};


export type QueryBlogPostBySlugArgs = {
  restaurantId: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
};


export type QueryBlogPostsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBrandImpressionMetricsArgs = {
  daysAgo?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryCalendarEventArgs = {
  calendarEventId: Scalars['Int']['input'];
};


export type QueryCalendarEventBySlugArgs = {
  restaurantId: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
};


export type QueryCalendarEventTicketCartArgs = {
  slug: Scalars['String']['input'];
};


export type QueryCalendarEventTicketCartsArgs = {
  calendarEventId: Scalars['Int']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCalendarEventsArgs = {
  afterDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventTagId?: InputMaybe<Scalars['Int']['input']>;
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
  showOnlyActiveEvents?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCalendarEventsByDateRangeArgs = {
  endAt: Scalars['DateTime']['input'];
  eventTagId?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
  startAt: Scalars['DateTime']['input'];
};


export type QueryCallsByHourByDateArgs = {
  dateRange?: InputMaybe<Scalars['Int']['input']>;
  day?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCampaignItemArgs = {
  campaignItemId: Scalars['Int']['input'];
};


export type QueryCampaignItemsArgs = {
  channelType?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  pagination: PaginationInput;
  restaurantId: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCampaignItemsBySelectedDateArgs = {
  channelType?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  rangeType?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
  selectedDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCampaignItemsFromCampaignArgs = {
  campaignId: Scalars['Int']['input'];
};


export type QueryCategoriesArgs = {
  locationId: Scalars['Int']['input'];
  popGroupName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatbotResponseArgs = {
  chatbotSessionId: Scalars['String']['input'];
  message: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type QueryChatbotSessionArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryConsumerUserArgs = {
  emailOrPhone: Scalars['String']['input'];
};


export type QueryConsumerUserByEmailArgs = {
  userEmail: Scalars['String']['input'];
};


export type QueryConsumerUserByPhoneArgs = {
  userPhone: Scalars['String']['input'];
};


export type QueryCreateBillingRequestFlowArgs = {
  billingCustomerId: Scalars['Int']['input'];
};


export type QueryCuisineTypesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCustomFeeArgs = {
  customFeeId: Scalars['Int']['input'];
};


export type QueryCustomFeesArgs = {
  locationId: Scalars['Int']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCustomFormsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryCustomPageArgs = {
  customPageId?: InputMaybe<Scalars['Int']['input']>;
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomPageAdvancedFormByIdArgs = {
  advancedFormId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type QueryCustomPageAdvancedFormNotificationRecipientsArgs = {
  advancedFormId: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryCustomPageAdvancedFormsArgs = {
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryCustomPageByIdArgs = {
  customPageId: Scalars['Int']['input'];
};


export type QueryCustomPageDraftByIdArgs = {
  customPageId: Scalars['Int']['input'];
};


export type QueryCustomPageDraftsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryCustomPagePublishPreviewArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryCustomPageSectionArgs = {
  sectionId: Scalars['Int']['input'];
};


export type QueryCustomPageSectionDraftArgs = {
  sectionId: Scalars['Int']['input'];
};


export type QueryCustomPagesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryCustomRedirectArgs = {
  customRedirectId: Scalars['Int']['input'];
};


export type QueryCustomRedirectsByRestaurantArgs = {
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryCustomResponsesByActionIdArgs = {
  actionId: Scalars['Int']['input'];
  locationId: Scalars['Int']['input'];
};


export type QueryCustomTaxRateArgs = {
  customTaxRateId: Scalars['Int']['input'];
};


export type QueryDishArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  menuItemId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDishHistoryArgs = {
  id: Scalars['Int']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryDishInteractionsPopCountArgs = {
  daysAgo?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
  selectedMonth?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDishListArgs = {
  slug: Scalars['String']['input'];
};


export type QueryDishListsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryDishesArgs = {
  enabledMenuItems?: InputMaybe<Scalars['Boolean']['input']>;
  hasPhotos?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryDishesByIdArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryDishesOnlineOrderingArgs = {
  enabledMenuItems?: InputMaybe<Scalars['Boolean']['input']>;
  isFreeOffer?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryDishesOnlineOrderingFeaturedItemsArgs = {
  excludeDishIds: Array<Scalars['Int']['input']>;
  pagination: PaginationInput;
  restaurantId: Scalars['Int']['input'];
};


export type QueryDishesReviewsArgs = {
  dishesId: Array<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryEarliestPhoneCallArgs = {
  locationId: Scalars['Int']['input'];
};


export type QueryEmailOpenRateMetricsArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryEnabledOffersArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryEstimatedRevenueMetricsArgs = {
  daysAgo?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryEventTagArgs = {
  eventTagId: Scalars['Int']['input'];
};


export type QueryEventTagsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryExistingRestaurantMemberArgs = {
  email: Scalars['String']['input'];
};


export type QueryFailedFollowerImportsArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryFailedMessageGroupsArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryFailedSocialPostsArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryFailureIndicatorSocialPostsArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryFeedbackByTokenArgs = {
  restaurantId: Scalars['Int']['input'];
  token: Scalars['String']['input'];
};


export type QueryFeedbacksArgs = {
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  pagination: PaginationInput;
  restaurantId: Scalars['Int']['input'];
  sentiment?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFetchPartiesArgs = {
  locationId: Scalars['Int']['input'];
  pagination: PaginationInput;
  partyState?: InputMaybe<Scalars['String']['input']>;
  partyStates?: InputMaybe<Array<Scalars['String']['input']>>;
  partyType?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  unseated?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFetchPartiesCountArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryFetchPartyByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryFetchPartySettingsArgs = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
  locationSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFetchSeatableTableTopsArgs = {
  locationId: Scalars['Int']['input'];
};


export type QueryFetchTableTopsArgs = {
  locationId: Scalars['Int']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFetchUserPastPartiesArgs = {
  locationId: Scalars['Int']['input'];
  partyType: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type QueryFlaggedContentAuditsByRestaurantArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryFolderArgs = {
  id: Scalars['Int']['input'];
  uploadType: Scalars['String']['input'];
};


export type QueryFollowerArgs = {
  followerId: Scalars['Int']['input'];
};


export type QueryFollowerByRestaurantArgs = {
  input: FollowerByRestaurantInput;
  restaurantId: Scalars['Int']['input'];
};


export type QueryFollowerByTimeMetricsArgs = {
  daysAgo?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryFollowerFavoriteLocationArgs = {
  restaurantId: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFollowerKpiCountsArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryFollowerSegmentArgs = {
  followerSegmentId: Scalars['Int']['input'];
};


export type QueryFollowerSegmentEstimatedAudienceArgs = {
  daysAgo?: InputMaybe<Scalars['Int']['input']>;
  followerSegmentId: Scalars['Int']['input'];
  minAmount?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFollowerSegmentPaginatedAudienceArgs = {
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  pagination?: InputMaybe<PaginationInput>;
  segmentId: Scalars['Int']['input'];
};


export type QueryFollowerTagArgs = {
  followerTagId: Scalars['Int']['input'];
};


export type QueryFollowerTagsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryFollowersByRestaurantArgs = {
  input: RestaurantFollowerInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFollowersForMessagesArgs = {
  input: RestaurantFollowerInput;
};


export type QueryFollowersMessageLocationAudienceOptionsArgs = {
  input: RestaurantFollowerInput;
};


export type QueryFollowersMessageTagAudienceOptionsArgs = {
  input: RestaurantFollowerInput;
};


export type QueryFollowersTableFilterOptionsArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryGiftCardByCodeArgs = {
  code: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type QueryGiftCardsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGmbLocalPostArgs = {
  postId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type QueryGoogleAccountArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryGuestProfileUserArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryHasOnlineOrderingBeenEnabledArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryHighlightReelArgs = {
  id: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryHighlightReelsArgs = {
  restaurantId: Scalars['ID']['input'];
};


export type QueryInstagramPhotosArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryLastUpdatedOverviewMetricsArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryLighthouseReportPageReportArgs = {
  pageReportId: Scalars['Int']['input'];
};


export type QueryLiveDomainArgs = {
  domain: Scalars['String']['input'];
};


export type QueryLiveDomainStagedRecordsArgs = {
  domain: Scalars['String']['input'];
  pagination: PaginationInput;
};


export type QueryLocationArgs = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLocationByTwilioPhoneArgs = {
  twilioPhone: Scalars['String']['input'];
};


export type QueryLocationToastSummaryArgs = {
  locationId: Scalars['Int']['input'];
};


export type QueryLoginCarouselSlideArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLoginCarouselSlidesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryLoyaltyAccountArgs = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLoyaltyProgramArgs = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMarketingCalendarWeekDatesArgs = {
  restaurantId: Scalars['Int']['input'];
  selectedDate: Scalars['String']['input'];
};


export type QueryMarketingMessageDaysArgs = {
  restaurantId: Scalars['Int']['input'];
  selectedDate: Scalars['String']['input'];
};


export type QueryMarketingMessagesArgs = {
  restaurantId: Scalars['Int']['input'];
  selectedDate: Scalars['String']['input'];
};


export type QueryMarketingOfferArgs = {
  marketingOfferId: Scalars['Int']['input'];
};


export type QueryMarketingOffersArgs = {
  excludeLocationOffers?: InputMaybe<Scalars['Boolean']['input']>;
  marketingType?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryMassMessageOrderingOffersArgs = {
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryMasterMessageCampaignArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMasterMessageCampaignsArgs = {
  pagination: PaginationInput;
};


export type QueryMenuArgs = {
  cartType?: InputMaybe<Scalars['String']['input']>;
  fulfillmentType?: InputMaybe<Scalars['String']['input']>;
  locationSlug?: InputMaybe<Scalars['String']['input']>;
  menuId?: InputMaybe<Scalars['Int']['input']>;
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMenuFeaturedSectionArgs = {
  menuId: Scalars['Int']['input'];
};


export type QueryMenuItemArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  locationSlug?: InputMaybe<Scalars['String']['input']>;
  menuSlug?: InputMaybe<Scalars['String']['input']>;
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMenuItemByDishAndLocationArgs = {
  cartType?: InputMaybe<Scalars['String']['input']>;
  dishId: Scalars['Int']['input'];
  fulfillmentType: Scalars['String']['input'];
  locationId: Scalars['Int']['input'];
};


export type QueryMenuItemByLocationAndFulfillmentTypeArgs = {
  cartType?: InputMaybe<Scalars['String']['input']>;
  fulfillmentType: Scalars['String']['input'];
  locationId: Scalars['Int']['input'];
  menuItemId: Scalars['Int']['input'];
};


export type QueryMenuItemCartArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  limitedAuthToken?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMenuItemCartApplicableCustomFeesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMenuItemCartByTokenArgs = {
  limitedAuthToken?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMenuItemCartConfirmedArgs = {
  id: Scalars['Int']['input'];
  validateFromPos?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMenuItemCartExternalIntegrationArgs = {
  menuItemCartId: Scalars['Int']['input'];
};


export type QueryMenuItemCartHistoryArgs = {
  pagination: PaginationInput;
  slug: Scalars['String']['input'];
};


export type QueryMenuItemCartSelectedMenuItemArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMenuItemCartSelectedModifierArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMenuItemCartVerifyAddressArgs = {
  address: Scalars['String']['input'];
  cartType?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  menuItemCartId?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryMenuItemCartsByLocationIdArgs = {
  cartBucket?: InputMaybe<Scalars['String']['input']>;
  cartType: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  pagination: PaginationInput;
  paymentCaptureReady?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMenuItemCartsSubmittedAtDateByInvoiceNumberArgs = {
  invoiceNumbers: Array<Scalars['String']['input']>;
};


export type QueryMenuItemModifierArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMenuItemModifierGroupArgs = {
  modifierGroupId: Scalars['Int']['input'];
};


export type QueryMenuItemsArgs = {
  isPoppable?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryMenuItemsByMenuArgs = {
  menuId: Scalars['Int']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryMenuItemsWithTemporalPricesArgs = {
  datetime?: InputMaybe<Scalars['DateTime']['input']>;
  sectionId: Scalars['Int']['input'];
};


export type QueryMenuPresenceUsersArgs = {
  menuId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMenuProcessingResultArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMenuSectionArgs = {
  orderingEventId?: InputMaybe<Scalars['Int']['input']>;
  sectionId: Scalars['Int']['input'];
};


export type QueryMenuSubsectionArgs = {
  subsectionId: Scalars['Int']['input'];
};


export type QueryMenuSyncHistoriesArgs = {
  menuId: Scalars['Int']['input'];
};


export type QueryMenuYextSyncArgs = {
  menuId: Scalars['Int']['input'];
};


export type QueryMenusByIdArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryMessageByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryMessageCampaignArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMessageCampaignByTriggerTypeArgs = {
  restaurantId: Scalars['Int']['input'];
  triggerType: Scalars['String']['input'];
};


export type QueryMessageCampaignEngagementOffersArgs = {
  memberId?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryMessageCampaignMessagesArgs = {
  pagination: PaginationInput;
  restaurantId: Scalars['Int']['input'];
};


export type QueryMessageCampaignRevenuesArgs = {
  campaignIds: Array<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryMessageGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMessageGroupIndexArgs = {
  id: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type QueryMessageGroupLinksArgs = {
  messageGroupId: Scalars['Int']['input'];
  pagination: PaginationInput;
};


export type QueryMessageGroupMessagesArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  messageGroupId: Scalars['Int']['input'];
  pagination: PaginationInput;
  tagId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMessageGroupsArgs = {
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: PaginationInput;
  restaurantId: Scalars['Int']['input'];
};


export type QueryMicrosOrgAvailableRestaurantsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryMicrosOrgsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryMicrosRvcAttachmentHandlersArgs = {
  microsOrgId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type QueryMobileVisitsPercentagesByDaysAgoArgs = {
  daysAgo?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryModifierGroupArgs = {
  modifierGroupId: Scalars['Int']['input'];
};


export type QueryModifierGroupsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryNcrOnboardingFeePriceArgs = {
  locationQuantity: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type QueryNcrPaymentAccountArgs = {
  accountId: Scalars['Int']['input'];
};


export type QueryNcrPaymentAccountAvailableRestaurantsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryNcrPaymentAccountsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryNcrPaymentSessionRequestUrlArgs = {
  menuItemCartId: Scalars['Int']['input'];
};


export type QueryNcrSilverStoresByAccountArgs = {
  ncrSilverAccountId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type QueryNestedMenuItemModifierGroupArgs = {
  nestedModifierGroupId: Scalars['Int']['input'];
};


export type QueryNotFoundsByRestaurantArgs = {
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryOauthApplicationsArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryOfferArgs = {
  offerId: Scalars['Int']['input'];
};


export type QueryOfferCodeArgs = {
  offerCode: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type QueryOfferCodesArgs = {
  offerId: Scalars['Int']['input'];
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryOffersArgs = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryOrderingEventArgs = {
  orderingEventId: Scalars['Int']['input'];
};


export type QueryOrderingEventBySlugArgs = {
  restaurantId: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
};


export type QueryOrderingEventsArgs = {
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrderingFullfilmentTypeArgs = {
  dateRange?: InputMaybe<Scalars['Int']['input']>;
  metricType: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type QueryOrderingMenuItemArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrderingMenuItemModifierArgs = {
  modifierId: Scalars['Int']['input'];
};


export type QueryOrderingMenuItemPreviewArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrderingMenusArgs = {
  menuIds: Array<Scalars['Int']['input']>;
};


export type QueryOrderingOfferArgs = {
  orderingOfferId: Scalars['Int']['input'];
};


export type QueryOrderingOfferCodeArgs = {
  orderingOfferCode: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type QueryOrderingOfferCodesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryOrderingOfferPreviewArgs = {
  orderingOfferId: Scalars['Int']['input'];
};


export type QueryOrderingOffersArgs = {
  deliveryMethod?: InputMaybe<Scalars['String']['input']>;
  excludeLocationOffers?: InputMaybe<Scalars['Boolean']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryOrderingOverviewArgs = {
  dateRange?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  metricType: Scalars['String']['input'];
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrderingOverviewKpisArgs = {
  dateRange?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type QueryOrderingOverviewOrdersByTypeArgs = {
  dateRange?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type QueryOrderingOverviewRevenueByFulfillmentArgs = {
  dateRange?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type QueryOrderingOverviewRevenueBySourceArgs = {
  dateRange?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type QueryOrderingOverviewVolumeAndRevenueArgs = {
  dateRange?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrderingRevenueAndVolumeArgs = {
  dateRange?: InputMaybe<Scalars['Int']['input']>;
  metricType: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type QueryOrdersByHourByDateArgs = {
  dateRange?: InputMaybe<Scalars['Int']['input']>;
  day?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOutboundClickEventsArgs = {
  daysAgo?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryPaginatedReviewsArgs = {
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  daysAgo: Scalars['Int']['input'];
  isPotentiallySpam?: InputMaybe<Scalars['Boolean']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  needsAction?: InputMaybe<Scalars['Boolean']['input']>;
  needsResponse?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
  sentiment?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPendingMenuItemCartArgs = {
  cartRestaurantId?: InputMaybe<Scalars['Int']['input']>;
  cartType: Scalars['String']['input'];
  fulfillmentType?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  orderingEventId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPhoneUsedByMfaArgs = {
  excludeUserId?: InputMaybe<Scalars['Int']['input']>;
  phone: Scalars['String']['input'];
};


export type QueryPopmenuIdTokenArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryPopmenuLoyaltyProgramArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryPositivePopsCountByDaysAgoArgs = {
  daysAgo?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryPositivePopsCountByWeekArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryPotentialDuplicateDishesArgs = {
  dishId: Scalars['Int']['input'];
};


export type QueryPriceChangeSchedulesArgs = {
  cartId: Scalars['Int']['input'];
  locationId: Scalars['Int']['input'];
};


export type QueryPrintLayoutArgs = {
  printLayoutId: Scalars['Int']['input'];
};


export type QueryPromotedOfferArgs = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
  marketingType: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type QueryPublicLoginCarouselSlidesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryRecentFollowerMassActionNotificationsArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryRedeemedOrderingOfferCodesArgs = {
  orderingOfferId: Scalars['Int']['input'];
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryResellerSalesforceAccountArgs = {
  email: Scalars['String']['input'];
};


export type QueryRestaurantArgs = {
  draftMode?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
};


export type QueryRestaurantAimLocationsArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryRestaurantAllFeaturedAnnouncementsArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryRestaurantAutomatedEmailsArgs = {
  pagination: PaginationInput;
  restaurantId: Scalars['Int']['input'];
};


export type QueryRestaurantBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryRestaurantDishTagArgs = {
  dishTagId: Scalars['Int']['input'];
};


export type QueryRestaurantDishTagsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryRestaurantEmbedBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryRestaurantFeatureFlagsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRestaurantFeaturedAnnouncementArgs = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
  menuId?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryRestaurantFeaturedAnnouncementsArgs = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
  menuId?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryRestaurantFooterLinkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRestaurantFooterLinkDraftArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRestaurantGroupArgs = {
  restaurantGroupId: Scalars['Int']['input'];
};


export type QueryRestaurantGroupsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryRestaurantLocationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRestaurantLocationOrderingAvailabilityArgs = {
  locationId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type QueryRestaurantLocationsByUserPermissionArgs = {
  memberLevel?: InputMaybe<Scalars['String']['input']>;
  permission?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryRestaurantLocationsCountArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryRestaurantMemberArgs = {
  memberId: Scalars['Int']['input'];
};


export type QueryRestaurantMemberClientProfileArgs = {
  memberId: Scalars['Int']['input'];
};


export type QueryRestaurantMemberInviteArgs = {
  inviteId?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRestaurantMemberInvitesArgs = {
  pagination: PaginationInput;
  restaurantId: Scalars['Int']['input'];
};


export type QueryRestaurantMemberLocationArgs = {
  locationId: Scalars['Int']['input'];
  memberId: Scalars['Int']['input'];
};


export type QueryRestaurantMembersArgs = {
  pagination: PaginationInput;
  restaurantId: Scalars['Int']['input'];
};


export type QueryRestaurantMobileAppAssetsArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryRestaurantNavDropdownArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRestaurantNavDropdownDraftArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRestaurantNavLinkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRestaurantNavLinkDraftArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRestaurantOffersCountArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryRestaurantSessionsByDeviceTypeArgs = {
  daysAgo?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryRestaurantSessionsByMarketingSourceArgs = {
  restaurantId: Scalars['Int']['input'];
  selectedMonth: Scalars['String']['input'];
};


export type QueryRestaurantWebsitePublishRecordsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryRestaurantsWithoutGroupsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryRevenueGeneratingSourceMetricsArgs = {
  daysAgo?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryReviewArgs = {
  reviewId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReviewMetricsArgs = {
  daysAgo?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryReviewSentimentMetricsArgs = {
  daysAgo?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryRootAnnouncementArgs = {
  rootAnnouncementId: Scalars['Int']['input'];
};


export type QueryRootAnnouncementsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryRootDishCategoryBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryRootDishTagArgs = {
  rootDishTagId: Scalars['Int']['input'];
};


export type QueryRootDishTagsArgs = {
  pagination: PaginationInput;
};


export type QueryRootMessagePackEmailTemplatesArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryRootMessagePacksByRestaurantArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryRootOrderingOffersArgs = {
  deliveryMethod?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRootPlaceArgs = {
  slug: Scalars['String']['input'];
};


export type QueryRootPlacesArgs = {
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryRootSalesDemoRestaurantsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryRootSectionTemplateArgs = {
  rootSectionTemplateId: Scalars['Int']['input'];
};


export type QueryRootSectionTemplatesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryRootSectionTemplatesByTypeArgs = {
  type: Scalars['String']['input'];
};


export type QueryRootSectionTypesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryRootSiteTemplateArgs = {
  rootSiteTemplateId: Scalars['Int']['input'];
};


export type QueryRootSiteTemplatesArgs = {
  isOnboardingTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  templateType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRootSproutSocialGroupsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryRootTaskArgs = {
  rootTaskId: Scalars['Int']['input'];
};


export type QueryRootTasksArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryRootThemeTemplatesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryRootThemesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QuerySalesforceMigrationInspectArgs = {
  popmenuLocationId?: InputMaybe<Scalars['Int']['input']>;
  sfid: Scalars['String']['input'];
};


export type QuerySelfCheckoutProductCatalogArgs = {
  billingCustomerId: Scalars['Int']['input'];
};


export type QuerySelfSignUpPlansArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  intervalCount?: InputMaybe<Scalars['Int']['input']>;
  intervalType?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySentMessagesMetricsArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QuerySeoCrawlIssueArgs = {
  issueId: Scalars['Int']['input'];
};


export type QuerySiteVisitsArgs = {
  daysAgo?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type QuerySmsLimitsUsageArgs = {
  input?: InputMaybe<SmsLimitsInput>;
  restaurantId: Scalars['Int']['input'];
  textMessageGroupId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySocialAccountArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySocialPostArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySocialPostSuggestionsArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QuerySocialPostsArgs = {
  includeScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessed?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QuerySpotonLocationAttachmentHandlersArgs = {
  code: Scalars['String']['input'];
  locationId: Scalars['Int']['input'];
};


export type QuerySquareMenuRelatedUniqSectionsArgs = {
  menuId: Scalars['Int']['input'];
};


export type QuerySquareSellerLocationsByAccountArgs = {
  squareSellerAccountId: Scalars['Int']['input'];
};


export type QuerySubscriptionPayerBillingCustomerArgs = {
  billingSubscriptionId: Scalars['Int']['input'];
  locationId: Scalars['Int']['input'];
};


export type QuerySuggestedDishOptionsArgs = {
  dishId: Scalars['Int']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QuerySuggestedDishesArgs = {
  dishId: Scalars['Int']['input'];
};


export type QuerySuggestedMenuItemsArgs = {
  cartType?: InputMaybe<Scalars['String']['input']>;
  fulfillmentType?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  menuItemId: Scalars['Int']['input'];
  orderingEventId?: InputMaybe<Scalars['Int']['input']>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QuerySupportCaseRepliesArgs = {
  caseId: Scalars['Int']['input'];
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupportCaseRepliesCountArgs = {
  caseId: Scalars['Int']['input'];
};


export type QuerySupportCasesArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySynthesizeSpeechArgs = {
  botVoice?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  text: Scalars['String']['input'];
  textType: Scalars['String']['input'];
  voiceSpeed?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTextMessagesArgs = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
  pagination: PaginationInput;
  tagId?: InputMaybe<Scalars['Int']['input']>;
  textMessageGroupId: Scalars['Int']['input'];
};


export type QueryThemeFontArgs = {
  themeFontId: Scalars['Int']['input'];
};


export type QueryThemeFontsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryThrottleSettingArgs = {
  locationId: Scalars['Int']['input'];
};


export type QueryTicketCartArgs = {
  calendarEventId: Scalars['Int']['input'];
};


export type QueryToastHostedPaymentIntentArgs = {
  intentId: Scalars['String']['input'];
  menuItemCartId: Scalars['Int']['input'];
};


export type QueryToastRestaurantArgs = {
  toastRestaurantId: Scalars['Int']['input'];
};


export type QueryToastRestaurantsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryTopMessageGroupsArgs = {
  rangeEndAt?: InputMaybe<Scalars['DateTime']['input']>;
  rangeStartAt: Scalars['DateTime']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type QueryTopReviewedItemsArgs = {
  daysAgo?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryTopSocialPostsArgs = {
  rangeEndAt?: InputMaybe<Scalars['DateTime']['input']>;
  rangeStartAt: Scalars['DateTime']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type QueryTotalFollowersBySelectedMonthArgs = {
  restaurantId: Scalars['Int']['input'];
  selectedMonth: Scalars['String']['input'];
};


export type QueryTotalFollowersByWeekArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryTotalMarketingRevenueByWeekArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryTotalOrganicSiteVisitsByDaysAgoArgs = {
  daysAgo?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryTotalReviewsBySelectedMonthArgs = {
  restaurantId: Scalars['Int']['input'];
  selectedMonth: Scalars['String']['input'];
};


export type QueryTotalReviewsByWeekArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryTotalReviewsCountByDaysAgoArgs = {
  daysAgo?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryTotalSiteVisitsByDaysAgoArgs = {
  daysAgo?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryTotalSiteVisitsByWeekArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryTotalUniqueSessionsBySelectedMonthArgs = {
  restaurantId: Scalars['Int']['input'];
  selectedMonth: Scalars['String']['input'];
};


export type QueryTotalVisitsBySelectedMonthArgs = {
  restaurantId: Scalars['Int']['input'];
  selectedMonth: Scalars['String']['input'];
};


export type QueryTrafficByCityBySelectedMonthArgs = {
  restaurantId: Scalars['Int']['input'];
  selectedMonth: Scalars['String']['input'];
};


export type QueryTrafficByDeviceTypeBySelectedMonthArgs = {
  restaurantId: Scalars['Int']['input'];
  selectedMonth: Scalars['String']['input'];
};


export type QueryTwilioIncomingMessagesArgs = {
  locationId: Scalars['Int']['input'];
  pagination: PaginationInput;
  restaurantId: Scalars['Int']['input'];
};


export type QueryTwilioPhoneCallArgs = {
  phoneCallId: Scalars['Int']['input'];
};


export type QueryTwilioPhoneCallsArgs = {
  locationId: Scalars['Int']['input'];
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
  spam?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTwilioPhoneNumbersArgs = {
  isAnsweringPhone?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: PaginationInput;
};


export type QueryTwilioSentMessagesArgs = {
  locationId: Scalars['Int']['input'];
  pagination: PaginationInput;
  restaurantId: Scalars['Int']['input'];
};


export type QueryTwilioVoicemailsArgs = {
  locationId: Scalars['Int']['input'];
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryUpsellCampaignArgs = {
  upsellCampaignId: Scalars['Int']['input'];
};


export type QueryUpsellCampaignEligibleDishesArgs = {
  locationIds: Array<Scalars['Int']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryUpsellCampaignsArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryUserArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryUserByContactsArgs = {
  email: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type QueryUserByEmailArgs = {
  userEmail: Scalars['String']['input'];
};


export type QueryUserByIdArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryUserByPhoneArgs = {
  userPhone: Scalars['String']['input'];
};


export type QueryUserByUnsubscribeMessageTokenArgs = {
  messageToken?: InputMaybe<Scalars['String']['input']>;
  unsubscribeToken: Scalars['String']['input'];
};


export type QueryUserByUnsubscribeTokenArgs = {
  unsubscribeToken: Scalars['String']['input'];
};


export type QueryUserDeviceArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserLocationsSearchArgs = {
  userInput: Scalars['String']['input'];
};


export type QueryUserPhoneSearchArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type QueryVisibleDishesArgs = {
  hasPhotos?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  restaurantId: Scalars['Int']['input'];
};


export type QueryYextAccountArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type QueryYextLoginUrlArgs = {
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of RecoverTicketCartForCheckout */
export type RecoverTicketCartForCheckoutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ticketCartId: Scalars['Int']['input'];
};

/** Autogenerated input type of RefreshMessageGroupAiText */
export type RefreshMessageGroupAiTextInput = {
  aiMarketingContentId?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of RefreshSocialPostAiText */
export type RefreshSocialPostAiTextInput = {
  aiMarketingContentId?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of RefreshTextMessageGroupAiText */
export type RefreshTextMessageGroupAiTextInput = {
  aiMarketingContentId?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

export type RefundMenuItemCartPaymentInput = {
  amount: Scalars['Decimal']['input'];
  isFullRefund: Scalars['Boolean']['input'];
  refundReason?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of RegenerateRestaurantWebhookToken */
export type RegenerateRestaurantWebhookTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

export type RegenerateRestaurantWebhookTokenReturn = {
  __typename?: 'RegenerateRestaurantWebhookTokenReturn';
  restaurant: Restaurant;
  token: Scalars['String']['output'];
};

/** Autogenerated input type of RemoveAppliedReward */
export type RemoveAppliedRewardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuItemCartId: Scalars['Int']['input'];
};

/** Autogenerated input type of RemoveRestaurantFromGroup */
export type RemoveRestaurantFromGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantGroupId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of RequestCheckoutSalesAssistance */
export type RequestCheckoutSalesAssistanceInput = {
  billingPlanIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

export type ResellerSignUpSurveyInput = {
  additionalDesignInfo?: InputMaybe<Scalars['String']['input']>;
  addons: Scalars['JSON']['input'];
  aiAnsweringQuestion?: InputMaybe<Scalars['String']['input']>;
  charges: Scalars['JSON']['input'];
  city: Scalars['String']['input'];
  communicationTime: Scalars['String']['input'];
  communicationType: Scalars['String']['input'];
  contractContent?: InputMaybe<Scalars['String']['input']>;
  contractFileName?: InputMaybe<Scalars['String']['input']>;
  contracts?: InputMaybe<Scalars['JSON']['input']>;
  email: Scalars['String']['input'];
  existingWebsite: Scalars['Boolean']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  onlineOrderingQuestion?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  phoneType: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  restaurantName: Scalars['String']['input'];
  role: Scalars['String']['input'];
  siteDesignExamples: Scalars['String']['input'];
  spanishOnboardingConsultant: Scalars['Boolean']['input'];
  state: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
  subscriptionName: Scalars['String']['input'];
  subscriptions: Scalars['JSON']['input'];
  websiteUrl: Scalars['String']['input'];
  whoIsContractingAndBilling: Scalars['String']['input'];
};

/** Autogenerated input type of ResendGiftCard */
export type ResendGiftCardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  giftCardInput: GiftCardInput;
};

export type ReservationBlackout = {
  __typename?: 'ReservationBlackout';
  createdAt: Scalars['DateTime']['output'];
  endAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isAllDay: Scalars['Boolean']['output'];
  location: RestaurantLocation;
  locationId: Scalars['Int']['output'];
  startAt: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ReservationBlackoutInput = {
  endAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isAllDay: Scalars['Boolean']['input'];
  startAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
};

export type ReservationsOpeningRangeTableTopInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  tableTopId: Scalars['Int']['input'];
  turnTime?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of ResetMyMfa */
export type ResetMyMfaInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of ResetRestaurantMemberMfa */
export type ResetRestaurantMemberMfaInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['Int']['input'];
};

export type Restaurant = Eventable & {
  __typename?: 'Restaurant';
  accessibilityContact?: Maybe<Scalars['String']['output']>;
  accountOwner?: Maybe<Scalars['String']['output']>;
  actionBar?: Maybe<RestaurantActionBar>;
  actionBarDraft?: Maybe<RestaurantActionBarDraft>;
  activeAdvisorCardTrackers?: Maybe<Array<AdvisorCardTracker>>;
  activeBecomeVipMarketingOffer?: Maybe<MarketingOffer>;
  additionalLocationCheckout?: Maybe<RestaurantAdditionalLocationCheckout>;
  additionalLocationPricing?: Maybe<RestaurantAdditionalLocationPricing>;
  adminReviews: ReviewPaginationHandler;
  aiMarketingContentsByMonth: Array<AiMarketingContent>;
  aiReviewResponseDefaultSettings: Array<AiReviewResponseDefaultSetting>;
  aiReviewResponseUpsellRecentlySubmitted: Scalars['Boolean']['output'];
  allDishTags: Array<DishTagObject>;
  allHolidays?: Maybe<Array<Holiday>>;
  allowAnonymousPops?: Maybe<Scalars['Boolean']['output']>;
  allowAnonymousReviews?: Maybe<Scalars['Boolean']['output']>;
  announcements: Array<Announcement>;
  answeringLocations: Array<RestaurantLocation>;
  answeringOffer?: Maybe<OrderingOffer>;
  apiTokens: ApiTokenPaginationHandler;
  appleMerchantVerificationKey?: Maybe<Scalars['String']['output']>;
  approvedReviews: Array<Review>;
  attire?: Maybe<Scalars['String']['output']>;
  availableBillingBankAccounts?: Maybe<Array<BillingBankAccount>>;
  availableBillingCoupons: Array<BillingCoupon>;
  availableBillingCreditCards?: Maybe<Array<BillingCreditCard>>;
  availableBillingPlans: Array<BillingPlan>;
  averageAutomatedEmailRates: AverageRate;
  averageCateringOrderAmount?: Maybe<Scalars['Decimal']['output']>;
  averageDineInOrderAmount?: Maybe<Scalars['Decimal']['output']>;
  averageOnlineOrderAmount?: Maybe<Scalars['Decimal']['output']>;
  billingBankAccounts?: Maybe<Array<BillingBankAccount>>;
  billingCity?: Maybe<Scalars['String']['output']>;
  billingCreditCards?: Maybe<Array<BillingCreditCard>>;
  billingCustomer?: Maybe<BillingCustomer>;
  billingLocations: Array<RestaurantLocation>;
  billingState?: Maybe<Scalars['String']['output']>;
  billingSubscription?: Maybe<BillingSubscription>;
  billingSubscriptions?: Maybe<Array<BillingSubscription>>;
  billingUkCustomer?: Maybe<BillingUkCustomer>;
  blogImports: Array<BlogImport>;
  blogPosts: Array<BlogPost>;
  buildExpectedAt?: Maybe<Scalars['DateTime']['output']>;
  calendarEventView?: Maybe<Scalars['String']['output']>;
  calendarEvents: Array<CalendarEvent>;
  calendarEventsByMonth: Array<CalendarEvent>;
  cateringDefaultFulfillmentType: Scalars['String']['output'];
  cateringDeliveryPlatformFeeAmount: Scalars['Decimal']['output'];
  cateringDeliveryPlatformFeeAmountType: Amount;
  cateringDeliveryTotalFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  cateringPickupPlatformFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  cateringPickupPlatformFeeAmountType?: Maybe<Amount>;
  cateringPickupTotalFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  chargebeeSyncedFeatureNames: Array<Scalars['String']['output']>;
  chatRoutingFrequency?: Maybe<Scalars['String']['output']>;
  cloverAccounts: Array<CloverAccount>;
  completedOnlineOrdersAmount?: Maybe<Scalars['Decimal']['output']>;
  completedOnlineOrdersCount?: Maybe<Scalars['Int']['output']>;
  conceptGroupBillingCustomer?: Maybe<BillingCustomer>;
  concierge: Scalars['Boolean']['output'];
  conciergeGoal?: Maybe<RestaurantConciergeGoal>;
  consentManagerConfig?: Maybe<RestaurantConsentManagerConfig>;
  consumerLocale: Scalars['String']['output'];
  countries: Array<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUser?: Maybe<User>;
  cssHeadingsMigrated: Scalars['Boolean']['output'];
  cuisineType?: Maybe<CuisineType>;
  cuisineTypeName?: Maybe<Scalars['String']['output']>;
  currencyDisplayOverrideType?: Maybe<Scalars['String']['output']>;
  customBlogTitle?: Maybe<Scalars['String']['output']>;
  customConversionScripts: Array<RestaurantCustomScript>;
  customDisclaimer?: Maybe<Scalars['String']['output']>;
  customDishTabContent?: Maybe<Scalars['String']['output']>;
  customDishTabName?: Maybe<Scalars['String']['output']>;
  customFile: CustomFile;
  customFiles: CustomFilePaginationHandler;
  customFollowButton?: Maybe<Scalars['String']['output']>;
  customFollowCollapseSubheading?: Maybe<Scalars['String']['output']>;
  customFollowHeading?: Maybe<Scalars['String']['output']>;
  customFollowPath?: Maybe<Scalars['String']['output']>;
  customFollowSubheading?: Maybe<Scalars['String']['output']>;
  customForms: Array<CustomForm>;
  customImages: Array<CustomImage>;
  customPage: CustomPage;
  customPageDraft: CustomPageDraft;
  customPageDrafts?: Maybe<Array<CustomPageDraft>>;
  customPageDraftsPagination: DraftPaginationHandler;
  customPageMenuSections: Array<CustomPageSection>;
  customPageOrderingSections: Array<CustomPageSection>;
  customPages: Array<CustomPage>;
  customPagesPagination: CustomPagePaginationHandler;
  customScripts: Array<RestaurantCustomScript>;
  customSignUpButton?: Maybe<Scalars['String']['output']>;
  customSignUpHeading?: Maybe<Scalars['String']['output']>;
  customSignUpSubheading?: Maybe<Scalars['String']['output']>;
  customSiteTitle?: Maybe<Scalars['String']['output']>;
  customSmsContactDisclaimer?: Maybe<Scalars['String']['output']>;
  customTaxRates: Array<CustomTaxRate>;
  customTrackings: Array<RestaurantCustomTracking>;
  customVipCopyRow1?: Maybe<Scalars['String']['output']>;
  customVipCopyRow2?: Maybe<Scalars['String']['output']>;
  defaultMenuLayout?: Maybe<Scalars['String']['output']>;
  defaultSiteTitle: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  designConsultationLink: Scalars['String']['output'];
  detectedCookies: Array<RestaurantDetectedCookie>;
  dishTags: Array<RestaurantDishTag>;
  displayDoordashAtCheckout?: Maybe<Scalars['Boolean']['output']>;
  displayEventTags?: Maybe<Scalars['Boolean']['output']>;
  displayRestaurantLocations?: Maybe<Scalars['Boolean']['output']>;
  displayRestaurantLocationsHours?: Maybe<Scalars['Boolean']['output']>;
  displayRootAnnouncements?: Maybe<Scalars['Boolean']['output']>;
  displayVipPopup?: Maybe<Scalars['Boolean']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  domainExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  draftMode?: Maybe<Scalars['Boolean']['output']>;
  draftModeKey?: Maybe<Scalars['String']['output']>;
  ecardAccount?: Maybe<EcardAccount>;
  ecardAccounts?: Maybe<Array<EcardAccount>>;
  emailSocialHandles: Array<RestaurantSocialHandle>;
  enableGoogleAccount?: Maybe<Scalars['Boolean']['output']>;
  enabledMenuItems: Array<MenuItem>;
  enabledMenuItemsCount?: Maybe<Scalars['Int']['output']>;
  enabledOrderingOffers: Array<OrderingOffer>;
  eventTags: Array<EventTag>;
  eventableName: Scalars['String']['output'];
  excludeDoordashMiddlewareFee: Scalars['Boolean']['output'];
  excludeUberDirectMiddlewareFee: Scalars['Boolean']['output'];
  externalIntegrations?: Maybe<Array<ExternalIntegration>>;
  externalWebsiteUrl?: Maybe<Scalars['String']['output']>;
  facebookCampaign: FacebookCampaign;
  facebookCampaigns: Array<FacebookCampaign>;
  facebookCampaignsPagination: FacbeookCampaignPaginationHandler;
  facebookPageUrl?: Maybe<Scalars['String']['output']>;
  facebookPixelId?: Maybe<Scalars['String']['output']>;
  failedPaymentCount: Scalars['Int']['output'];
  failedSubscriptionInvoices?: Maybe<Array<BillingInvoice>>;
  failedTextMessageGroups: Array<TextMessageGroup>;
  faviconUploadedPhoto?: Maybe<UploadedPhoto>;
  faviconUrl?: Maybe<Scalars['String']['output']>;
  featureFlags?: Maybe<Scalars['Flags']['output']>;
  featureSetting?: Maybe<RestaurantFeatureSetting>;
  featuredAnnouncement?: Maybe<Announcement>;
  featuredAnnouncements?: Maybe<Array<Announcement>>;
  featuredAnnouncementsCount: Scalars['Int']['output'];
  featuredAnnouncementsToday: Scalars['Boolean']['output'];
  featuredDishes?: Maybe<Array<Dish>>;
  featuredPhotosCount?: Maybe<Scalars['Int']['output']>;
  feedbackLocations: Array<RestaurantLocation>;
  feedbackSummary: FeedbackSummary;
  firstAvailablePhoneNumber?: Maybe<Scalars['String']['output']>;
  firstGoogleAnalyticsReportDate?: Maybe<Scalars['DateTime']['output']>;
  firstLocation?: Maybe<RestaurantLocation>;
  firstRevenueAt?: Maybe<Scalars['String']['output']>;
  firstSubmittedMenuItemCartAt?: Maybe<Scalars['DateTime']['output']>;
  followButtonCta: Scalars['String']['output'];
  followCollapseSubheadingCta: Scalars['String']['output'];
  followHeadingCta: Scalars['String']['output'];
  followSubheadingCta: Scalars['String']['output'];
  followTriggerOrderingOfferDiscountName?: Maybe<Scalars['String']['output']>;
  followerSegments: Array<RestaurantFollowerSegment>;
  followerTags: Array<FollowerTag>;
  followers: Array<Follower>;
  followersCount?: Maybe<Scalars['Int']['output']>;
  footerItemDrafts?: Maybe<Array<NavItemable>>;
  footerItems: Array<NavItemable>;
  footerLogoUploadedPhoto?: Maybe<UploadedPhoto>;
  footerLogoUrl?: Maybe<Scalars['String']['output']>;
  geocodeNewLocationAddress?: Maybe<RestaurantGeocodedNewLocationAddress>;
  giveawayAmount: Scalars['String']['output'];
  gmbAccounts?: Maybe<Array<GoogleMyBusinessAccount>>;
  gmbLocalPostLocations?: Maybe<Array<GooglePostLocation>>;
  gmbLocalPosts: Array<GooglePost>;
  gmbLocalPostsPagination: GooglePostPaginationHandler;
  gmbLocation?: Maybe<GoogleMyBusinessLocation>;
  gmbLocationApi: GoogleMyBusinessLocation;
  gmbLocationAvailableAttributes: Array<GoogleMyBusinessAvailableAttribute>;
  gmbLocations?: Maybe<Array<GoogleMyBusinessLocation>>;
  gmbPublishingData: Array<Publishing>;
  gmbVerificationOptions?: Maybe<Array<VerificationOptions>>;
  gmbVerifications: VerificationPaginationHandler;
  googleAccount?: Maybe<RestaurantGoogleAccount>;
  /** @deprecated Google Ads integration was removed. Always returns null. */
  googleAdsConversionActionScripts?: Maybe<Array<RestaurantGoogleAccountConversionAction>>;
  /** @deprecated Google Ads integration was removed. Always returns null. */
  googleAdsConversionPageScript?: Maybe<Scalars['String']['output']>;
  /** @deprecated Google Ads integration was removed. Always returns null. */
  googleAdsConversionScript?: Maybe<Scalars['String']['output']>;
  /** @deprecated Google Ads integration was removed. Always returns false. */
  googleAdsLinked: Scalars['Boolean']['output'];
  googleAnalyticsId?: Maybe<Scalars['String']['output']>;
  googleMyBusinessLinked: Scalars['Boolean']['output'];
  googleReviews: GoogleLocationReviewPaginationType;
  hasActiveSocialAccount: Scalars['Boolean']['output'];
  hasActiveSubscription: Scalars['Boolean']['output'];
  hasActiveSubscriptionWithoutPaymentMethod: Scalars['Boolean']['output'];
  hasAiReviewResponseUpgradeRequest: Scalars['Boolean']['output'];
  hasAnnouncements: Scalars['Boolean']['output'];
  hasAnsweringUpgradeRequest: Scalars['Boolean']['output'];
  hasBlogPosts: Scalars['Boolean']['output'];
  hasCompletedOrderingSetup: Scalars['Boolean']['output'];
  hasCustomForms: Scalars['Boolean']['output'];
  hasDineInEnabledLocation?: Maybe<Scalars['Boolean']['output']>;
  hasDoorDash: Scalars['Boolean']['output'];
  hasEnabledMessagePacks: Scalars['Boolean']['output'];
  hasEnabledSmartMessages: Scalars['Boolean']['output'];
  hasFacebook: Scalars['Boolean']['output'];
  hasFailedPaymentForOnlineOrdering: Scalars['Boolean']['output'];
  hasFailedPaymentForSubscription: Scalars['Boolean']['output'];
  hasFollowerTags: Scalars['Boolean']['output'];
  hasInstagram: Scalars['Boolean']['output'];
  hasLocationOpportunityOpen: Scalars['Boolean']['output'];
  hasLocationWithDeliveryDisabled: Scalars['Boolean']['output'];
  hasLocationWithDoordashDisabled: Scalars['Boolean']['output'];
  hasLocationWithFailedStripeInvoices: Scalars['Boolean']['output'];
  hasLocationWithInvoiceDue: Scalars['Boolean']['output'];
  hasLocationWithOnlineOrderingDisabled: Scalars['Boolean']['output'];
  hasLocationWithoutPaymentMethodForOrderingFees: Scalars['Boolean']['output'];
  hasLoyaltyProgram?: Maybe<Scalars['Boolean']['output']>;
  hasMaxLocationsCount: Scalars['Boolean']['output'];
  hasMultipleLocations: Scalars['Boolean']['output'];
  hasMultipleOrderableLocations: Scalars['Boolean']['output'];
  hasNoneUpgradeRequest: Scalars['Boolean']['output'];
  hasOnlineOrderingUpgradeRequest: Scalars['Boolean']['output'];
  hasOnlyOneLocation: Scalars['Boolean']['output'];
  hasOnlyOneOrderableLocation: Scalars['Boolean']['output'];
  hasOrderNerdUpgradeRequest: Scalars['Boolean']['output'];
  hasOrderingDeliveryLocationEnabled: Scalars['Boolean']['output'];
  hasOrderingDineInLocationEnabled: Scalars['Boolean']['output'];
  hasOrderingLocationEnabled: Scalars['Boolean']['output'];
  hasPrintLayouts: Scalars['Boolean']['output'];
  hasProOrNoneUpgradeRequest: Scalars['Boolean']['output'];
  hasProUpgradeRequest: Scalars['Boolean']['output'];
  hasPublishedPrivacyPolicy: Scalars['Boolean']['output'];
  hasReservationsUpgradeRequest: Scalars['Boolean']['output'];
  hasSalesforceAccount: Scalars['Boolean']['output'];
  hasSentMessageGroups: Scalars['Boolean']['output'];
  hasTwitter: Scalars['Boolean']['output'];
  hasValidAimSocialAccountLocations: Scalars['Boolean']['output'];
  hasYextUpgradeRequest: Scalars['Boolean']['output'];
  highlightReels: Array<HighlightReel>;
  highlights: Array<Highlight>;
  homePage?: Maybe<CustomPage>;
  homePageDraft?: Maybe<CustomPageDraft>;
  homeRedirectUrl?: Maybe<Scalars['String']['output']>;
  hostingType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  importMessageCampaignId?: Maybe<Scalars['Int']['output']>;
  includeLocationContent?: Maybe<Scalars['Boolean']['output']>;
  indieBillingPlanPrice?: Maybe<Scalars['Int']['output']>;
  instagramHandle?: Maybe<Scalars['String']['output']>;
  instagramPageUrl?: Maybe<Scalars['String']['output']>;
  invoiceNumbersMenuItemCartReport: Array<Scalars['String']['output']>;
  isAiAnsweringEnabled?: Maybe<Scalars['Boolean']['output']>;
  isAimLiteEnabled: Scalars['Boolean']['output'];
  isAimLiteOverrideEnabled: Scalars['Boolean']['output'];
  isAlohaMenuSyncEnabled: Scalars['Boolean']['output'];
  isBecomeVipV2Enabled?: Maybe<Scalars['Boolean']['output']>;
  isBentoEnabled?: Maybe<Scalars['Boolean']['output']>;
  isCheckLocationsBoxEnabled?: Maybe<Scalars['Boolean']['output']>;
  isCloverMenuSyncEnabled?: Maybe<Scalars['Boolean']['output']>;
  isConsentManagerActive: Scalars['Boolean']['output'];
  isCurbsideEnabled?: Maybe<Scalars['Boolean']['output']>;
  isCurrencyDisplayOverrideEnabled?: Maybe<Scalars['Boolean']['output']>;
  isDishCustomHtmlEnabled?: Maybe<Scalars['Boolean']['output']>;
  isDraftsUndoEnabled?: Maybe<Scalars['Boolean']['output']>;
  isEnablingDrafts?: Maybe<Scalars['Boolean']['output']>;
  isErrorTrackingEnabled?: Maybe<Scalars['Boolean']['output']>;
  isEssentialsStatus?: Maybe<Scalars['Boolean']['output']>;
  isFacebookCampaignsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isFollowerImportEnabled?: Maybe<Scalars['Boolean']['output']>;
  isForceSyncMenusEnabled: Scalars['Boolean']['output'];
  isFullstoryEnabled?: Maybe<Scalars['Boolean']['output']>;
  isGiftCardPurchasingEnabled?: Maybe<Scalars['Boolean']['output']>;
  isGiftCardsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isHeartlandPosMenuSyncEnabled: Scalars['Boolean']['output'];
  isImportedFollowerSmsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isImportedFollowerSmsEnabledAt?: Maybe<Scalars['DateTime']['output']>;
  isImportedFollowerSmsEnabledBy?: Maybe<Scalars['Int']['output']>;
  isIndie?: Maybe<Scalars['Boolean']['output']>;
  isIndieEnabled?: Maybe<Scalars['Boolean']['output']>;
  isInstagramEnabled?: Maybe<Scalars['Boolean']['output']>;
  isInstagramFeedEnabled?: Maybe<Scalars['Boolean']['output']>;
  isItemCardV2Enabled?: Maybe<Scalars['Boolean']['output']>;
  isLimitedStatus?: Maybe<Scalars['Boolean']['output']>;
  isLoyaltyEnabled?: Maybe<Scalars['Boolean']['output']>;
  isMarketingOptInEnabled: Scalars['Boolean']['output'];
  isMenuSyncUiEnabled?: Maybe<Scalars['Boolean']['output']>;
  isMessagePacksEnabled?: Maybe<Scalars['Boolean']['output']>;
  isMicrosMenuSyncEnabled: Scalars['Boolean']['output'];
  isNavV2Enabled?: Maybe<Scalars['Boolean']['output']>;
  isNcr?: Maybe<Scalars['Boolean']['output']>;
  isNcrSilverEnabled: Scalars['Boolean']['output'];
  isNcrSilverMenuSyncEnabled: Scalars['Boolean']['output'];
  isNestedModifiersEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOnlyUkBased: Scalars['Boolean']['output'];
  isOpenTableIntegrationEnabled: Scalars['Boolean']['output'];
  isOrderezeClient?: Maybe<Scalars['Boolean']['output']>;
  isOrderingCateringEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingDeliveryEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingDineInEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingDoorDashEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingEventsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingPaymentEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingRefundsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOtterEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOtterV2Enabled?: Maybe<Scalars['Boolean']['output']>;
  isPageLimitReached: Scalars['Boolean']['output'];
  isPendoEnabled?: Maybe<Scalars['Boolean']['output']>;
  isPrintCenterEnabled?: Maybe<Scalars['Boolean']['output']>;
  isProfileV2Enabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Password-protected sites were removed. Always returns false. */
  isProtectedSite: Scalars['Boolean']['output'];
  isPublishingDrafts?: Maybe<Scalars['Boolean']['output']>;
  isRebuildInProcess?: Maybe<Scalars['Boolean']['output']>;
  isRestaurantOnboarding: Scalars['Boolean']['output'];
  isScriptConsentActive: Scalars['Boolean']['output'];
  isShopPaymentAvailable: Scalars['Boolean']['output'];
  isShopSquarePaymentAvailable: Scalars['Boolean']['output'];
  isShopStripePaymentAvailable: Scalars['Boolean']['output'];
  isShopToastPaymentAvailable: Scalars['Boolean']['output'];
  isShowVipPromptOnHomePageOnlyEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSingleLocation?: Maybe<Scalars['Boolean']['output']>;
  isSquareMenuSyncEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSquarePaymentAvailable?: Maybe<Scalars['Boolean']['output']>;
  isSslOnly: Scalars['Boolean']['output'];
  isStandaloneAnswering?: Maybe<Scalars['Boolean']['output']>;
  isStarterStatus?: Maybe<Scalars['Boolean']['output']>;
  isStatusTest: Scalars['Boolean']['output'];
  isStripePaymentAvailable?: Maybe<Scalars['Boolean']['output']>;
  isSuspended?: Maybe<Scalars['Boolean']['output']>;
  isTextMessageEnabled?: Maybe<Scalars['Boolean']['output']>;
  isToastMenuSyncEnabled?: Maybe<Scalars['Boolean']['output']>;
  isToastPaymentAvailable?: Maybe<Scalars['Boolean']['output']>;
  isUkBased: Scalars['Boolean']['output'];
  isUpdatingMenuItemCartsStatus?: Maybe<Scalars['Boolean']['output']>;
  isWaitlistEnabled?: Maybe<Scalars['Boolean']['output']>;
  isWaitlistV2Enabled?: Maybe<Scalars['Boolean']['output']>;
  kpiMetrics: Array<RestaurantKpiMetric>;
  lastBillingInvoice?: Maybe<BillingInvoice>;
  lastBillingSyncError?: Maybe<Scalars['String']['output']>;
  lastClientLogin?: Maybe<Scalars['DateTime']['output']>;
  lastPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  latestAgentChat?: Maybe<AgentChat>;
  launchedAt?: Maybe<Scalars['DateTime']['output']>;
  legacyOrderDefaultUrl?: Maybe<Scalars['String']['output']>;
  legalDocumentPreview: RestaurantLegalDocumentPreview;
  legalDocuments: Array<RestaurantLegalDocument>;
  legalReviewInformationDefaults: RestaurantLegalReviewInformationDefaults;
  liveDomain?: Maybe<LiveDomain>;
  locationTimezones?: Maybe<Array<Scalars['String']['output']>>;
  locations: Array<RestaurantLocation>;
  locationsCount?: Maybe<Scalars['Int']['output']>;
  logoUploadedPhoto?: Maybe<UploadedPhoto>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  logoWithPaddingUrl?: Maybe<Scalars['String']['output']>;
  loyaltyProgram?: Maybe<LoyaltyProgram>;
  mailerBrandColor?: Maybe<Scalars['String']['output']>;
  mailerDarkThemeLogoUploadedPhoto?: Maybe<UploadedPhoto>;
  mailerDarkThemeLogoUrl?: Maybe<Scalars['String']['output']>;
  mailerFooterImageUploadedPhoto?: Maybe<UploadedPhoto>;
  mailerFooterImageUrl?: Maybe<Scalars['String']['output']>;
  mailerFooterMessage?: Maybe<Scalars['String']['output']>;
  mailerFromAddress?: Maybe<Scalars['String']['output']>;
  mailerFromName?: Maybe<Scalars['String']['output']>;
  mailerLinkColor?: Maybe<Scalars['String']['output']>;
  mailerLogoUploadedPhoto?: Maybe<UploadedPhoto>;
  mailerLogoUrl?: Maybe<Scalars['String']['output']>;
  marketingOffers?: Maybe<Array<MarketingOffer>>;
  marketingOverviewGraphData: Array<OverviewGraphDataPoint>;
  masterMenus: Array<Menu>;
  masterMenusCount: Scalars['Int']['output'];
  maxLocationsCount: Scalars['Int']['output'];
  members: Array<RestaurantMember>;
  membersCount: Scalars['Int']['output'];
  menuImports: MenuImportPaginationHandler;
  menuItemCartReport: MenuItemCartReport;
  menuItemCartReports: Array<MenuItemCartReport>;
  menuItemCartTopDishes: Array<MenuItemCartTopDish>;
  menuItemCartWithLatestReportAt?: Maybe<Scalars['DateTime']['output']>;
  menuItemCarts: MenuItemCartPaginationHandler;
  menuPages: Array<CustomPageSelectedMenu>;
  messageCampaignMessage: MessageCampaignMessage;
  messageCampaigns: Array<MessageCampaign>;
  messageCampaignsDeliveredCount: Scalars['Int']['output'];
  messageGroupAverage?: Maybe<RestaurantMessageGroupAverage>;
  messageGroupBuilderContentPreview: ContentBuilderPreview;
  messageGroupMessage: MessageGroupMessage;
  messageGroups: MessageGroupPaginationHandler;
  messageGroupsDeliveredCount: Scalars['Int']['output'];
  messagePackCommunication: RestaurantMessagePackCommunication;
  messagePackCommunicationPreview: Scalars['String']['output'];
  messagePackCommunications: Array<RestaurantMessagePackCommunication>;
  messagePacks: Array<RestaurantMessagePack>;
  messagesUsageCount: Scalars['Int']['output'];
  messagesUsageLimitAlmostReached: Scalars['Boolean']['output'];
  messagesUsageLimitReached: Scalars['Boolean']['output'];
  mondayId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  navDropdowns: Array<RestaurantNavDropdown>;
  navItemDrafts?: Maybe<Array<NavItemable>>;
  navItems: Array<NavItemable>;
  navLinks: Array<RestaurantNavLink>;
  ncrBillingPlanName?: Maybe<Scalars['String']['output']>;
  ncrDetails?: Maybe<SalesforcePopTrigger>;
  ncrPaymentAccounts?: Maybe<Array<NcrPaymentAccount>>;
  notices: Array<RestaurantNotice>;
  offerMessageCampaignCount?: Maybe<Scalars['Int']['output']>;
  offers: Array<Offer>;
  onboardingInfo?: Maybe<RestaurantOnboardingInfo>;
  onboardingStatus?: Maybe<Scalars['String']['output']>;
  onboardingStatusAt?: Maybe<Scalars['DateTime']['output']>;
  onboardingStatusByUser?: Maybe<User>;
  onlineOrderCateringUrl?: Maybe<Scalars['String']['output']>;
  onlineOrderDefaultUrl?: Maybe<Scalars['String']['output']>;
  openAiGptModel: Scalars['String']['output'];
  orderezeStatus?: Maybe<RestaurantOrderezeStatusType>;
  orderingDefaultFulfillmentType: Scalars['String']['output'];
  orderingDeliveryPlatformFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  orderingDeliveryPlatformFeeAmountType: Amount;
  orderingDeliveryTotalFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  orderingDineInPlatformFeeAmount: Scalars['Decimal']['output'];
  orderingDineInPlatformFeeAmountType: Amount;
  orderingDineInTotalFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  orderingEventPlatformFeeAmount: Scalars['Decimal']['output'];
  orderingEventPlatformFeeAmountType: Amount;
  orderingEventTotalFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  orderingEvents: Array<OrderingEvent>;
  orderingEventsByMonth: Array<OrderingEvent>;
  orderingFooterLogoUploadedPhoto?: Maybe<UploadedPhoto>;
  orderingFooterLogoUrl?: Maybe<Scalars['String']['output']>;
  orderingLocationMembers: Array<RestaurantMember>;
  orderingLocations: Array<RestaurantLocation>;
  orderingLocationsData?: Maybe<OrderingLocationsData>;
  orderingLogoUploadedPhoto?: Maybe<UploadedPhoto>;
  orderingLogoUrl?: Maybe<Scalars['String']['output']>;
  orderingMobileBrandColor?: Maybe<Scalars['String']['output']>;
  orderingOfferCodes: Array<OrderingOfferCode>;
  orderingOffers: Array<OrderingOffer>;
  orderingPickupPlatformFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  orderingPickupPlatformFeeAmountType: Amount;
  orderingPickupTotalFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  orderingUrl?: Maybe<Scalars['String']['output']>;
  pageContent?: Maybe<PageContentable>;
  /** Returns paginated enabled menus: If location is specified, then enabled location menus with ordering filters, else enabled master menus */
  paginatedEnabledMenus: MenuPaginationHandler;
  paginatedLocations: RestaurantLocationPaginationHandler;
  /** Fetches paginated ROI notification alerts for the current restaurant member. Root users receive unique restaurant alerts. */
  paginatedMemberAlerts: AlertPaginationHandler;
  /** Fetches paginated task actions by type and category that are not completed or dismissed */
  paginatedTaskActions: ActionPaginationHandler;
  paymentAccounts?: Maybe<Array<RestaurantPaymentAccountInterface>>;
  pendingCustomPhotos: Array<CustomPhoto>;
  pendingInvitesCount: Scalars['Int']['output'];
  pendingReviews: Array<Review>;
  pendingReviewsCount: Scalars['Int']['output'];
  photoUploadedPhoto?: Maybe<UploadedPhoto>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  platformBrand: Scalars['String']['output'];
  platformBrandName: Scalars['String']['output'];
  platformBrandUrl: Scalars['String']['output'];
  policy: RestaurantPolicy;
  /** @deprecated Google Analytics provisioning was removed. Always returns null. */
  popmenuGoogleAnalyticsId?: Maybe<Scalars['String']['output']>;
  popmenuOrderingAllLocations: Array<RestaurantLocation>;
  popmenuOrderingLocations: Array<RestaurantLocation>;
  popmenuUrl?: Maybe<Scalars['String']['output']>;
  popularDishes: Array<Dish>;
  previewExpectedAt?: Maybe<Scalars['DateTime']['output']>;
  priceRange?: Maybe<Scalars['String']['output']>;
  priceRangeSymbols?: Maybe<Scalars['String']['output']>;
  primaryCurrency: Scalars['String']['output'];
  primaryLocationId?: Maybe<Scalars['Int']['output']>;
  primarySubdomain: Scalars['String']['output'];
  printLayouts: Array<PrintLayout>;
  profile?: Maybe<RestaurantProfile>;
  publishedLegalDocuments: Array<RestaurantPublishedLegalDocument>;
  qrCardLogoUploadedPhoto?: Maybe<UploadedPhoto>;
  recentDishes: Array<Dish>;
  recentFollowerExports: Array<FollowerExport>;
  recentFollowers: Array<Follower>;
  recentOrderingReportExports: Array<OrderingReportExport>;
  recentPops: Array<Pop>;
  replyToEmail?: Maybe<Scalars['String']['output']>;
  requiresTollFreeVerification: Scalars['Boolean']['output'];
  reservationLocations: Array<RestaurantLocation>;
  restaurantEmbeds: Array<RestaurantEmbed>;
  restaurantUrl?: Maybe<Scalars['String']['output']>;
  reviewLocations: Array<RestaurantLocation>;
  reviewTasks: Array<RootTaskReviewAction>;
  reviews: ReviewPaginationHandler;
  rootAnnouncement?: Maybe<RootAnnouncement>;
  rootGroups: Array<RootGroup>;
  rootNotes: Array<RootNote>;
  rootNotesCount?: Maybe<Scalars['Int']['output']>;
  salesforceAccount?: Maybe<SalesforceAccount>;
  salesforceAccountSfid?: Maybe<Scalars['String']['output']>;
  salesforceAccounts?: Maybe<Array<SalesforceAccount>>;
  salesforceLeadEmail?: Maybe<Scalars['String']['output']>;
  salesforceLeadPhone?: Maybe<Scalars['String']['output']>;
  scheduledAnnouncements: AnnouncementPaginationHandler;
  scriptDomains: Array<RestaurantScriptDomain>;
  seasonalDishes: Array<Dish>;
  secondaryDomains: Array<RestaurantSecondaryDomain>;
  selectedCuisineTypes: Array<RestaurantSelectedCuisineType>;
  selectedPaymentMethodTypes: Array<Scalars['String']['output']>;
  selectedProduct?: Maybe<RestaurantSelectedProduct>;
  selectedRootSiteTemplate?: Maybe<RootSiteTemplate>;
  selectedRootThemeTemplate?: Maybe<RootThemeTemplate>;
  sentMessagesCount: Scalars['Int']['output'];
  sentTextMessagesCount: Scalars['Int']['output'];
  seoDashboard: SeoDashboard;
  servedMealTypes: Array<Scalars['String']['output']>;
  serviceType?: Maybe<Scalars['String']['output']>;
  setupContactEmail?: Maybe<Scalars['String']['output']>;
  setupContactName?: Maybe<Scalars['String']['output']>;
  setupContactPhone?: Maybe<Scalars['String']['output']>;
  setupPromoCode?: Maybe<Scalars['String']['output']>;
  shopItemCartReport: ShopItemCartReport;
  shopItemCartReports: Array<ShopItemCartReport>;
  shopSquareApplicationId?: Maybe<Scalars['String']['output']>;
  shopSquareLocationId?: Maybe<Scalars['String']['output']>;
  shopSquareSellerAccount?: Maybe<SquareSellerAccount>;
  shopSquareSellerAccountId?: Maybe<Scalars['Int']['output']>;
  shopStripeConnectAccount?: Maybe<StripeConnectAccount>;
  shopStripeConnectAccountId?: Maybe<Scalars['Int']['output']>;
  shopStripePublishableKey?: Maybe<Scalars['String']['output']>;
  showAllLocations?: Maybe<Scalars['Boolean']['output']>;
  showIndieOnboarding?: Maybe<Scalars['Boolean']['output']>;
  showMigrationApprovalBanner: Scalars['Boolean']['output'];
  showMigrationResourceCenter: Scalars['Boolean']['output'];
  showNavLocation?: Maybe<Scalars['Boolean']['output']>;
  showNavSignUp?: Maybe<Scalars['Boolean']['output']>;
  showNcrOnboarding?: Maybe<Scalars['Boolean']['output']>;
  showOrderingOnboarding: Scalars['Boolean']['output'];
  signUpBackgroundImageUploadedPhoto?: Maybe<UploadedPhoto>;
  signUpBackgroundImageUrl?: Maybe<Scalars['String']['output']>;
  signUpButtonCta: Scalars['String']['output'];
  signUpHeadingCta: Scalars['String']['output'];
  signUpSetting?: Maybe<RestaurantSignUpSetting>;
  signUpSettingDraft?: Maybe<RestaurantSignUpSettingDraft>;
  signUpSubheadingCta: Scalars['String']['output'];
  siteTitle: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  socialAccounts: Array<SocialAccount>;
  socialAccountsCount: Scalars['Int']['output'];
  socialHandleDrafts: Array<RestaurantSocialHandleDraft>;
  socialHandles: Array<RestaurantSocialHandle>;
  socialPosts: SocialPostPaginationHandler;
  socialPostsCount?: Maybe<Scalars['Int']['output']>;
  socialPostsImpressionsCount: Scalars['Int']['output'];
  sproutSocialPostsImpressionsCount: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
  stripeBillingSource?: Maybe<Scalars['String']['output']>;
  subdomain?: Maybe<Scalars['String']['output']>;
  taskActions: Array<RootTaskAction>;
  termsSigned?: Maybe<Scalars['Boolean']['output']>;
  termsSignedAt?: Maybe<Scalars['DateTime']['output']>;
  termsSigneeFirstName?: Maybe<Scalars['String']['output']>;
  termsSigneeLastName?: Maybe<Scalars['String']['output']>;
  textMessageGroup: TextMessageGroup;
  textMessageGroupPreview: Preview;
  textMessageGroups: TextMessageGroupPaginationHandler;
  textMessageGroupsDeliveredCount: Scalars['Int']['output'];
  textMessagesUsageCount: Scalars['Int']['output'];
  theme?: Maybe<Theme>;
  themeDraft?: Maybe<ThemeDraft>;
  themeFonts: Array<ThemeFont>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  toastConnectedLocations: Array<RestaurantLocation>;
  tollFreeVerificationComplete: Scalars['Boolean']['output'];
  twitterHandle?: Maybe<Scalars['String']['output']>;
  uiRestaurant?: Maybe<UiRestaurant>;
  unapprovedReviewsCount: Scalars['Int']['output'];
  unreadFeedbacks: Array<Feedback>;
  unreadFeedbacksCount: Scalars['Int']['output'];
  /** Fetches the unread task actions count by type and category that are not completed or dismissed */
  unreadTaskActionsCount: Scalars['Int']['output'];
  upcomingBillingInvoice?: Maybe<BillingInvoice>;
  upcomingHolidays?: Maybe<Array<Holiday>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  upgradeRequests?: Maybe<Array<RestaurantUpgradeRequest>>;
  /** Fetches root upload folders */
  uploadFolders: UploadFolderPaginationHandler;
  uploadedBrandFiles: Array<CustomFile>;
  uploadedBrandPhotos: Array<UploadedPhoto>;
  uploadedContentFiles: Array<CustomFile>;
  uploadedContentPhotos: Array<UploadedPhoto>;
  uploadedFonts: Array<UploadedFont>;
  uploadedMenuFiles: Array<CustomFile>;
  uploadedMenuPhotos: Array<UploadedPhoto>;
  /** Fetches root uploads */
  uploads: UploadPaginationHandler;
  upsellCampaigns: Array<UpsellCampaign>;
  useLastLocation?: Maybe<Scalars['Boolean']['output']>;
  useOloGettingStarted?: Maybe<Scalars['Boolean']['output']>;
  userSetting?: Maybe<RestaurantUserSetting>;
  vipLogoUploadedPhoto?: Maybe<UploadedPhoto>;
  vipLogoUrl?: Maybe<Scalars['String']['output']>;
  waitlistingLocations: Array<RestaurantLocation>;
  webhookToken?: Maybe<RestaurantWebhookToken>;
  webhooks: WebhookPaginationHandler;
  websiteBuildStatus?: Maybe<Scalars['String']['output']>;
  websitePublishRecords: Array<RestaurantWebsitePublishRecord>;
  woflowImports: WoflowImportPaginationHandler;
  yearEstablished?: Maybe<Scalars['Int']['output']>;
  yextUpsellRecentlySubmitted: Scalars['Boolean']['output'];
};


export type RestaurantAdditionalLocationPricingArgs = {
  country: Scalars['String']['input'];
  productBillingPlanIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RestaurantAdminReviewsArgs = {
  dishId?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type RestaurantAiMarketingContentsByMonthArgs = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  monthDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  utcOffsetHours?: InputMaybe<Scalars['Float']['input']>;
};


export type RestaurantAllHolidaysArgs = {
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RestaurantApiTokensArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type RestaurantCalendarEventsByMonthArgs = {
  monthDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RestaurantCustomFileArgs = {
  id: Scalars['Int']['input'];
};


export type RestaurantCustomFilesArgs = {
  pagination: PaginationInput;
};


export type RestaurantCustomPageArgs = {
  id: Scalars['Int']['input'];
};


export type RestaurantCustomPageDraftArgs = {
  id: Scalars['Int']['input'];
};


export type RestaurantCustomPageDraftsPaginationArgs = {
  pagination: PaginationInput;
};


export type RestaurantCustomPagesPaginationArgs = {
  pagination: PaginationInput;
};


export type RestaurantFacebookCampaignArgs = {
  id: Scalars['Int']['input'];
};


export type RestaurantFacebookCampaignsPaginationArgs = {
  pagination: PaginationInput;
};


export type RestaurantFeedbackSummaryArgs = {
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RestaurantFollowTriggerOrderingOfferDiscountNameArgs = {
  menuItemCartId: Scalars['Int']['input'];
};


export type RestaurantFollowerSegmentsArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  isEditable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RestaurantGeocodeNewLocationAddressArgs = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  streetAddress: Scalars['String']['input'];
};


export type RestaurantGmbLocalPostLocationsArgs = {
  googlePostId: Scalars['Int']['input'];
};


export type RestaurantGmbLocalPostsArgs = {
  isProcessed?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcoming?: InputMaybe<Scalars['Boolean']['input']>;
  rangeTime?: InputMaybe<Scalars['Int']['input']>;
};


export type RestaurantGmbLocalPostsPaginationArgs = {
  isProcessed?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: PaginationInput;
};


export type RestaurantGmbLocationArgs = {
  id: Scalars['Int']['input'];
};


export type RestaurantGmbLocationApiArgs = {
  id: Scalars['Int']['input'];
};


export type RestaurantGmbLocationAvailableAttributesArgs = {
  id: Scalars['Int']['input'];
};


export type RestaurantGmbLocationsArgs = {
  visibleOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RestaurantGmbPublishingDataArgs = {
  googleLocationId?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
};


export type RestaurantGmbVerificationOptionsArgs = {
  locationName: Scalars['String']['input'];
};


export type RestaurantGmbVerificationsArgs = {
  locationName: Scalars['String']['input'];
  pagination: PaginationInput;
};


export type RestaurantGoogleReviewsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type RestaurantHasMultipleOrderableLocationsArgs = {
  catering?: Scalars['Boolean']['input'];
};


export type RestaurantHasOnlyOneOrderableLocationArgs = {
  catering?: Scalars['Boolean']['input'];
};


export type RestaurantInvoiceNumbersMenuItemCartReportArgs = {
  cartType?: InputMaybe<Scalars['String']['input']>;
  currencyType?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fulfillmentType?: InputMaybe<Scalars['String']['input']>;
  futureWeeks?: InputMaybe<Scalars['Boolean']['input']>;
  groupBy?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  orderingPlatform?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  reportMonth?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RestaurantLatestAgentChatArgs = {
  agentType: Scalars['String']['input'];
};


export type RestaurantLegalDocumentPreviewArgs = {
  answers: RestaurantLegalDocumentAnswersInput;
  documentType: Scalars['String']['input'];
};


export type RestaurantMarketingOverviewGraphDataArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate: Scalars['DateTime']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type RestaurantMenuImportsArgs = {
  pagination: PaginationInput;
};


export type RestaurantMenuItemCartReportArgs = {
  cartType?: InputMaybe<Scalars['String']['input']>;
  fulfillmentType?: InputMaybe<Scalars['String']['input']>;
  futureWeeks?: InputMaybe<Scalars['Boolean']['input']>;
  groupBy?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  invoices?: InputMaybe<Array<Scalars['String']['input']>>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  orderingPlatform?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  reportAt: Scalars['DateTime']['input'];
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RestaurantMenuItemCartReportsArgs = {
  cartType?: InputMaybe<Scalars['String']['input']>;
  currencyType?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fulfillmentType?: InputMaybe<Scalars['String']['input']>;
  groupBy?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  invoices?: InputMaybe<Array<Scalars['String']['input']>>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  orderingPlatform?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  reportMonth?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RestaurantMenuItemCartTopDishesArgs = {
  cartType?: InputMaybe<Scalars['String']['input']>;
  currencyType?: InputMaybe<Scalars['String']['input']>;
  daysAgo?: InputMaybe<Scalars['Int']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  reportEndAt?: InputMaybe<Scalars['DateTime']['input']>;
  reportMonth?: InputMaybe<Scalars['DateTime']['input']>;
  reportStartAt?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RestaurantMenuItemCartsArgs = {
  cartBucket?: InputMaybe<Scalars['String']['input']>;
  cartType?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  rangeTime?: InputMaybe<Scalars['Int']['input']>;
  readyForCapture?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  statusGroup?: InputMaybe<Scalars['String']['input']>;
};


export type RestaurantMessageCampaignMessageArgs = {
  messageId: Scalars['ID']['input'];
};


export type RestaurantMessageCampaignsArgs = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
};


export type RestaurantMessageGroupBuilderContentPreviewArgs = {
  input: MessageGroupBuilderContentInput;
};


export type RestaurantMessageGroupMessageArgs = {
  messageId: Scalars['ID']['input'];
};


export type RestaurantMessageGroupsArgs = {
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessed?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcoming?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  rangeTime?: InputMaybe<Scalars['Int']['input']>;
};


export type RestaurantMessagePackCommunicationArgs = {
  communicationId: Scalars['Int']['input'];
};


export type RestaurantMessagePackCommunicationPreviewArgs = {
  communicationId: Scalars['Int']['input'];
};


export type RestaurantMessagePackCommunicationsArgs = {
  isPast?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RestaurantOrderingEventsByMonthArgs = {
  monthDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RestaurantOrderingLocationsDataArgs = {
  isCatering: Scalars['Boolean']['input'];
};


export type RestaurantPageContentArgs = {
  draftMode?: InputMaybe<Scalars['Boolean']['input']>;
  url: Scalars['String']['input'];
};


export type RestaurantPaginatedEnabledMenusArgs = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type RestaurantPaginatedLocationsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type RestaurantPaginatedMemberAlertsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type RestaurantPaginatedTaskActionsArgs = {
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  pagination?: InputMaybe<PaginationInput>;
  taskCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  taskTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RestaurantPopmenuOrderingAllLocationsArgs = {
  catering?: Scalars['Boolean']['input'];
};


export type RestaurantPopmenuOrderingLocationsArgs = {
  catering?: Scalars['Boolean']['input'];
};


export type RestaurantReviewTasksArgs = {
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RestaurantReviewsArgs = {
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type RestaurantScheduledAnnouncementsArgs = {
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcoming?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  rangeTime?: InputMaybe<Scalars['Int']['input']>;
};


export type RestaurantSeoDashboardArgs = {
  month?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type RestaurantShopItemCartReportArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  reportAt: Scalars['DateTime']['input'];
};


export type RestaurantShopItemCartReportsArgs = {
  currencyType?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  reportMonth?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RestaurantSocialPostsArgs = {
  includeScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessed?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcoming?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  rangeTime?: InputMaybe<Scalars['Int']['input']>;
};


export type RestaurantTextMessageGroupArgs = {
  textMessageGroupId: Scalars['Int']['input'];
};


export type RestaurantTextMessageGroupPreviewArgs = {
  textMessageGroupId: Scalars['Int']['input'];
};


export type RestaurantTextMessageGroupsArgs = {
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessed?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcoming?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  rangeTime?: InputMaybe<Scalars['Int']['input']>;
};


export type RestaurantUnreadFeedbacksCountArgs = {
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RestaurantUnreadTaskActionsCountArgs = {
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  taskCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  taskTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RestaurantUploadFoldersArgs = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  uploadType: Scalars['String']['input'];
};


export type RestaurantUploadsArgs = {
  aimMarketingOnly?: InputMaybe<Scalars['Boolean']['input']>;
  allUploads?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  uploadType: Scalars['String']['input'];
};


export type RestaurantWebhooksArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type RestaurantWoflowImportsArgs = {
  importState?: InputMaybe<Scalars['String']['input']>;
  pagination: PaginationInput;
};

export type RestaurantActionBar = {
  __typename?: 'RestaurantActionBar';
  actionBarLinks?: Maybe<Array<RestaurantActionBarLink>>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isEnabled: Scalars['Boolean']['output'];
  restaurant: Restaurant;
};

export type RestaurantActionBarDraft = {
  __typename?: 'RestaurantActionBarDraft';
  actionBarLinks?: Maybe<Array<RestaurantActionBarLinkDraft>>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isEnabled: Scalars['Boolean']['output'];
  restaurant: Restaurant;
};

export type RestaurantActionBarInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RestaurantActionBarLink = {
  __typename?: 'RestaurantActionBarLink';
  customHref?: Maybe<Scalars['String']['output']>;
  customPageTarget?: Maybe<CustomPage>;
  id: Scalars['Int']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isExternal: Scalars['Boolean']['output'];
  linkType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  restaurant: Restaurant;
  target?: Maybe<NavLinkable>;
  targetId?: Maybe<Scalars['String']['output']>;
  targetType?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type RestaurantActionBarLinkDraft = {
  __typename?: 'RestaurantActionBarLinkDraft';
  customHref?: Maybe<Scalars['String']['output']>;
  customPageTarget?: Maybe<CustomPage>;
  id: Scalars['Int']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isExternal: Scalars['Boolean']['output'];
  linkType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  restaurant: Restaurant;
  target?: Maybe<NavLinkable>;
  targetId?: Maybe<Scalars['String']['output']>;
  targetType?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type RestaurantActionBarLinkInput = {
  customHref?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  linkType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  targetId?: InputMaybe<Scalars['Int']['input']>;
  typename?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of RestaurantAddDomain */
export type RestaurantAddDomainInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  fullDomain?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
  subdomain?: InputMaybe<Scalars['String']['input']>;
};

export type RestaurantAdditionalLocationCheckout = {
  __typename?: 'RestaurantAdditionalLocationCheckout';
  existingOptions: Array<RestaurantAdditionalLocationCheckoutExistingOption>;
  newLocationOption: RestaurantAdditionalLocationCheckoutNewLocationOption;
};

export type RestaurantAdditionalLocationCheckoutExistingOption = {
  __typename?: 'RestaurantAdditionalLocationCheckoutExistingOption';
  billingCustomer: BillingCustomer;
  eligibleSubscriptions: Array<BillingSubscription>;
  errorCode?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  resolvedSubscription?: Maybe<BillingSubscription>;
};

export type RestaurantAdditionalLocationCheckoutNewLocationOption = {
  __typename?: 'RestaurantAdditionalLocationCheckoutNewLocationOption';
  anchor?: Maybe<BillingPlan>;
  availableCountries: Array<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  products: Array<BillingPlan>;
  tier?: Maybe<Scalars['String']['output']>;
  tierAddon?: Maybe<BillingPlan>;
};

export type RestaurantAdditionalLocationPricing = {
  __typename?: 'RestaurantAdditionalLocationPricing';
  anchor?: Maybe<RestaurantAdditionalLocationPricingItem>;
  currency?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  products: Array<RestaurantAdditionalLocationPricingItem>;
  tierAddon?: Maybe<RestaurantAdditionalLocationPricingItem>;
  unresolvedItemId?: Maybe<Scalars['String']['output']>;
  unresolvedItemName?: Maybe<Scalars['String']['output']>;
};

export type RestaurantAdditionalLocationPricingItem = {
  __typename?: 'RestaurantAdditionalLocationPricingItem';
  billingPlan: BillingPlan;
  unitPrice?: Maybe<Scalars['Int']['output']>;
};

export type RestaurantAdvancedInput = {
  allowAnonymousPops?: InputMaybe<Scalars['Boolean']['input']>;
  allowAnonymousReviews?: InputMaybe<Scalars['Boolean']['input']>;
  cateringDeliveryPlatformFeeAmount?: InputMaybe<Scalars['Decimal']['input']>;
  cateringDeliveryPlatformFeeAmountType?: InputMaybe<Amount>;
  cateringDeliveryTotalFeeAmount?: InputMaybe<Scalars['Decimal']['input']>;
  cateringPickupPlatformFeeAmount?: InputMaybe<Scalars['Decimal']['input']>;
  cateringPickupPlatformFeeAmountType?: InputMaybe<Amount>;
  cateringPickupTotalFeeAmount?: InputMaybe<Scalars['Decimal']['input']>;
  consumerLocale?: InputMaybe<Scalars['String']['input']>;
  currencyDisplayOverrideType?: InputMaybe<Scalars['String']['input']>;
  customDisclaimer?: InputMaybe<Scalars['String']['input']>;
  customDishTabContent?: InputMaybe<Scalars['String']['input']>;
  customDishTabName?: InputMaybe<Scalars['String']['input']>;
  customFollowButton?: InputMaybe<Scalars['String']['input']>;
  customFollowCollapseSubheading?: InputMaybe<Scalars['String']['input']>;
  customFollowHeading?: InputMaybe<Scalars['String']['input']>;
  customFollowPath?: InputMaybe<Scalars['String']['input']>;
  customFollowSubheading?: InputMaybe<Scalars['String']['input']>;
  customSignUpButton?: InputMaybe<Scalars['String']['input']>;
  customSignUpHeading?: InputMaybe<Scalars['String']['input']>;
  customSignUpSubheading?: InputMaybe<Scalars['String']['input']>;
  customSmsContactDisclaimer?: InputMaybe<Scalars['String']['input']>;
  customTooltipContent?: InputMaybe<Scalars['String']['input']>;
  customTooltipHeading?: InputMaybe<Scalars['String']['input']>;
  customVipCopyRow1?: InputMaybe<Scalars['String']['input']>;
  customVipCopyRow2?: InputMaybe<Scalars['String']['input']>;
  displayDoordashAtCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  displayRootAnnouncements?: InputMaybe<Scalars['Boolean']['input']>;
  displayVipPopup?: InputMaybe<Scalars['Boolean']['input']>;
  excludeDoordashMiddlewareFee?: InputMaybe<Scalars['Boolean']['input']>;
  excludeUberDirectMiddlewareFee?: InputMaybe<Scalars['Boolean']['input']>;
  increaseMonthlyTextMessages?: InputMaybe<Scalars['Int']['input']>;
  isAimLiteOverrideEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isCurrencyDisplayOverrideEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isErrorTrackingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFullstoryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isIndieEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Password-protected sites were removed. This argument is ignored. */
  isProtectedSite?: InputMaybe<Scalars['Boolean']['input']>;
  isStandaloneAnswering?: InputMaybe<Scalars['Boolean']['input']>;
  maxMonthlyMmsMessages?: InputMaybe<Scalars['Int']['input']>;
  orderingDeliveryPlatformFeeAmount?: InputMaybe<Scalars['Decimal']['input']>;
  orderingDeliveryPlatformFeeAmountType?: InputMaybe<Amount>;
  orderingDeliveryTotalFeeAmount?: InputMaybe<Scalars['Decimal']['input']>;
  orderingDineInPlatformFeeAmount?: InputMaybe<Scalars['Decimal']['input']>;
  orderingDineInPlatformFeeAmountType?: InputMaybe<Amount>;
  orderingDineInTotalFeeAmount?: InputMaybe<Scalars['Decimal']['input']>;
  orderingEventPlatformFeeAmount?: InputMaybe<Scalars['Decimal']['input']>;
  orderingEventPlatformFeeAmountType?: InputMaybe<Amount>;
  orderingEventTotalFeeAmount?: InputMaybe<Scalars['Decimal']['input']>;
  orderingPickupPlatformFeeAmount?: InputMaybe<Scalars['Decimal']['input']>;
  orderingPickupPlatformFeeAmountType?: InputMaybe<Amount>;
  orderingPickupTotalFeeAmount?: InputMaybe<Scalars['Decimal']['input']>;
  platformBrand?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Password-protected sites were removed. This argument is ignored. */
  protectedSitePassword?: InputMaybe<Scalars['String']['input']>;
  showNavSignUp?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stripeBillingSource?: InputMaybe<Scalars['String']['input']>;
  useLastLocation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RestaurantConciergeGoal = {
  __typename?: 'RestaurantConciergeGoal';
  googleAdsClicks?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  messages?: Maybe<Scalars['Int']['output']>;
  socialPosts?: Maybe<Scalars['Int']['output']>;
};

export type RestaurantConciergeGoalInput = {
  googleAdsClicks?: InputMaybe<Scalars['Int']['input']>;
  messages?: InputMaybe<Scalars['Int']['input']>;
  socialPosts?: InputMaybe<Scalars['Int']['input']>;
};

export type RestaurantConsentManagerConfig = {
  __typename?: 'RestaurantConsentManagerConfig';
  acceptButtonText?: Maybe<Scalars['String']['output']>;
  bannerDescription?: Maybe<Scalars['String']['output']>;
  bannerTitle?: Maybe<Scalars['String']['output']>;
  closeButtonAction: Scalars['String']['output'];
  declineButtonText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Do Not Sell is no longer supported. Always returns false. */
  doNotSellLinkEnabled: Scalars['Boolean']['output'];
  /** @deprecated Do Not Sell is no longer supported. Always returns null. */
  doNotSellLinkUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isScriptConsentEnabled: Scalars['Boolean']['output'];
  privacyPolicyLinkText?: Maybe<Scalars['String']['output']>;
  /** @deprecated The privacy policy link always opens in a new window. Always returns true. */
  privacyPolicyNewWindow: Scalars['Boolean']['output'];
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  showAcceptButton: Scalars['Boolean']['output'];
  showCloseButton: Scalars['Boolean']['output'];
  showCookieBadge: Scalars['Boolean']['output'];
  showCookieCategories: Scalars['Boolean']['output'];
  showDeclineButton: Scalars['Boolean']['output'];
  showPrivacyPolicyLink: Scalars['Boolean']['output'];
  theme: Scalars['String']['output'];
};

export type RestaurantCustomPageDraftInput = {
  id: Scalars['Int']['input'];
  isEnabled: Scalars['Boolean']['input'];
  position: Scalars['Int']['input'];
  typename?: InputMaybe<Scalars['String']['input']>;
};

export type RestaurantCustomRedirect = PageContentable & {
  __typename?: 'RestaurantCustomRedirect';
  fromPath?: Maybe<Scalars['String']['output']>;
  hostname?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isMatchAll: Scalars['Boolean']['output'];
  isPermanent: Scalars['Boolean']['output'];
  redirectType: Scalars['String']['output'];
  redirectUrl: Scalars['String']['output'];
  toExternalUrl?: Maybe<Scalars['String']['output']>;
  toPath?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type RestaurantCustomScript = {
  __typename?: 'RestaurantCustomScript';
  consentCategory?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  deferExecution: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  scriptType?: Maybe<Scalars['String']['output']>;
  trackingScriptType?: Maybe<Scalars['String']['output']>;
};

export type RestaurantCustomScriptInput = {
  consentCategory?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  deferExecution?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  scriptType: Scalars['String']['input'];
  trackingScriptType?: InputMaybe<Scalars['String']['input']>;
};

export type RestaurantCustomTracking = {
  __typename?: 'RestaurantCustomTracking';
  id: Scalars['Int']['output'];
  trackingId: Scalars['String']['output'];
  trackingType: Scalars['String']['output'];
};

export type RestaurantCustomTrackingInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  trackingId: Scalars['String']['input'];
  trackingType: Scalars['String']['input'];
};

export type RestaurantDefaultFulfillmentTypeInput = {
  cateringDefaultFulfillmentType?: InputMaybe<Scalars['String']['input']>;
  orderingDefaultFulfillmentType?: InputMaybe<Scalars['String']['input']>;
};

export type RestaurantDetectedCookie = {
  __typename?: 'RestaurantDetectedCookie';
  category: Scalars['String']['output'];
  cookieDomain: Scalars['String']['output'];
  cookieName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastSeenAt: Scalars['DateTime']['output'];
};

export type RestaurantDishTag = {
  __typename?: 'RestaurantDishTag';
  abbr?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dishesTagCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  imageIconUrl?: Maybe<Scalars['String']['output']>;
  imageUploadedPhoto?: Maybe<UploadedPhoto>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  restaurant?: Maybe<Restaurant>;
};

export type RestaurantDishTagInput = {
  abbr: Scalars['String']['input'];
  color: Scalars['String']['input'];
  imageUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  name: Scalars['String']['input'];
};

export type RestaurantEmbed = {
  __typename?: 'RestaurantEmbed';
  embedPreviewUrl?: Maybe<Scalars['String']['output']>;
  embedScriptUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  preloadScriptUrl?: Maybe<Scalars['String']['output']>;
  restaurant?: Maybe<Restaurant>;
  selectedMenus: Array<RestaurantEmbedSelectedMenu>;
  slug: Scalars['String']['output'];
};

export type RestaurantEmbedInput = {
  selectedMenus: Array<RestaurantEmbedSelectedMenuInput>;
};

export type RestaurantEmbedSelectedMenu = {
  __typename?: 'RestaurantEmbedSelectedMenu';
  id: Scalars['Int']['output'];
  menu?: Maybe<Menu>;
  menuId: Scalars['Int']['output'];
};

export type RestaurantEmbedSelectedMenuInput = {
  menuId: Scalars['Int']['input'];
};

export type RestaurantFeatureFlags = {
  __typename?: 'RestaurantFeatureFlags';
  featureFlags?: Maybe<Scalars['Flags']['output']>;
};

export type RestaurantFeatureSetting = {
  __typename?: 'RestaurantFeatureSetting';
  accessibilityFooterIconStatus: Scalars['String']['output'];
  aiAnsweringStatus: Scalars['String']['output'];
  aiMarketingCalendarPerLocationStatus: Scalars['String']['output'];
  aiMarketingCalendarStatus: Scalars['String']['output'];
  aiMarketingLiteStatus: Scalars['String']['output'];
  aiReviewResponseStatus: Scalars['String']['output'];
  applePayStatus: Scalars['String']['output'];
  autoRevShareCustomFeesCreationStatus: Scalars['String']['output'];
  boostAiMarketingCalendarStatus: Scalars['String']['output'];
  cateringPlatformFeesStatus: Scalars['String']['output'];
  chargebeePortalStatus: Scalars['String']['output'];
  checkLocationsBoxStatus: Scalars['String']['output'];
  clientProfileStatus: Scalars['String']['output'];
  consumerMobileAppStatus: Scalars['String']['output'];
  creditCardSurchargeStatus: Scalars['String']['output'];
  cspHeaderStatus: Scalars['String']['output'];
  curbsideStatus: Scalars['String']['output'];
  customCssStatus: Scalars['String']['output'];
  developerApiStatus: Scalars['String']['output'];
  dishCustomHtmlStatus: Scalars['String']['output'];
  draftsUndoStatus: Scalars['String']['output'];
  eatAppStatus: Scalars['String']['output'];
  emailOptInStatus: Scalars['String']['output'];
  enablingDraftsStatus: Scalars['String']['output'];
  facebookCampaignsStatus: Scalars['String']['output'];
  feedbackStatus: Scalars['String']['output'];
  followerImportStatus: Scalars['String']['output'];
  forceSyncMenusStatus: Scalars['String']['output'];
  giftCardPurchasingStatus: Scalars['String']['output'];
  giftCardsStatus: Scalars['String']['output'];
  globalGoogleAnalyticsStatus: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  increaseMonthlyTextMessages?: Maybe<Scalars['Int']['output']>;
  initialMonthlyMessages?: Maybe<Scalars['Int']['output']>;
  instagramFeedStatus: Scalars['String']['output'];
  instagramStatus: Scalars['String']['output'];
  isAccessibilityFooterIconEnabled: Scalars['Boolean']['output'];
  isAiAnsweringEnabled: Scalars['Boolean']['output'];
  isAiAnsweringLocked: Scalars['Boolean']['output'];
  isAiMarketingCalendarEnabled: Scalars['Boolean']['output'];
  isAiMarketingCalendarPerLocationEnabled: Scalars['Boolean']['output'];
  isAiMarketingLiteEnabled: Scalars['Boolean']['output'];
  isAiReviewResponseEnabled: Scalars['Boolean']['output'];
  isApplePayEnabled: Scalars['Boolean']['output'];
  isAutoRevShareCustomFeesCreationEnabled: Scalars['Boolean']['output'];
  isBoostAiMarketingCalendarEnabled: Scalars['Boolean']['output'];
  isCateringPlatformFeesEnabled: Scalars['Boolean']['output'];
  isChargebeePortalEnabled: Scalars['Boolean']['output'];
  isCheckLocationsBoxEnabled: Scalars['Boolean']['output'];
  isClientProfileEnabled: Scalars['Boolean']['output'];
  isConsumerMobileAppEnabled: Scalars['Boolean']['output'];
  isCreditCardSurchargeEnabled: Scalars['Boolean']['output'];
  isCspHeaderEnabled: Scalars['Boolean']['output'];
  isCurbsideEnabled: Scalars['Boolean']['output'];
  isCustomCssEnabled: Scalars['Boolean']['output'];
  isDeveloperApiEnabled: Scalars['Boolean']['output'];
  isDishCustomHtmlEnabled: Scalars['Boolean']['output'];
  isDraftsUndoEnabled: Scalars['Boolean']['output'];
  isEatAppEnabled: Scalars['Boolean']['output'];
  isEmailOptInEnabled: Scalars['Boolean']['output'];
  isEnablingDrafts: Scalars['Boolean']['output'];
  isEnablingDraftsEnabled: Scalars['Boolean']['output'];
  isFacebookCampaignsEnabled: Scalars['Boolean']['output'];
  isFeedbackEnabled: Scalars['Boolean']['output'];
  isFollowerImportEnabled: Scalars['Boolean']['output'];
  isForceSyncMenusEnabled: Scalars['Boolean']['output'];
  isGiftCardPurchasingEnabled: Scalars['Boolean']['output'];
  isGiftCardsEnabled: Scalars['Boolean']['output'];
  isGiftCardsLocked: Scalars['Boolean']['output'];
  isGlobalGoogleAnalyticsEnabled: Scalars['Boolean']['output'];
  isInstagramEnabled: Scalars['Boolean']['output'];
  isInstagramFeedEnabled: Scalars['Boolean']['output'];
  isItemCardV2Enabled: Scalars['Boolean']['output'];
  isLoyaltyEnabled: Scalars['Boolean']['output'];
  isMainNavPanelEnabled: Scalars['Boolean']['output'];
  isMarketingCalendarEnabled: Scalars['Boolean']['output'];
  isMarketingDashboardEnabled: Scalars['Boolean']['output'];
  isMassMessagesSegmentationEnabled: Scalars['Boolean']['output'];
  isMenuSyncUiEnabled: Scalars['Boolean']['output'];
  isMessageDetailsOverviewEnabled: Scalars['Boolean']['output'];
  isMessageGroupAutosaveEnabled: Scalars['Boolean']['output'];
  isMessagePacksEnabled: Scalars['Boolean']['output'];
  isMessagePacksLocked: Scalars['Boolean']['output'];
  isMfaRequiredEnabled: Scalars['Boolean']['output'];
  isMmsMessageEnabled: Scalars['Boolean']['output'];
  isMobileMenuNavigationV2Enabled: Scalars['Boolean']['output'];
  isMobileOrderDetailsV2Enabled: Scalars['Boolean']['output'];
  isMultiChannelCampaignAiEnabled: Scalars['Boolean']['output'];
  isMultiLocationOloBillingEnabled: Scalars['Boolean']['output'];
  isNcrSilverEnabled: Scalars['Boolean']['output'];
  isNestedModifiersEnabled: Scalars['Boolean']['output'];
  isOpenTableIntegrationEnabled: Scalars['Boolean']['output'];
  isOrderingBillingConfigValidationEnabled: Scalars['Boolean']['output'];
  isOrderingCateringEnabled: Scalars['Boolean']['output'];
  isOrderingCateringLocked: Scalars['Boolean']['output'];
  isOrderingDeliveryEnabled: Scalars['Boolean']['output'];
  isOrderingDineInEnabled: Scalars['Boolean']['output'];
  isOrderingDineInLocked: Scalars['Boolean']['output'];
  isOrderingDoorDashEnabled: Scalars['Boolean']['output'];
  isOrderingEnabled: Scalars['Boolean']['output'];
  isOrderingEventsEnabled: Scalars['Boolean']['output'];
  isOrderingEventsLocked: Scalars['Boolean']['output'];
  isOrderingPaymentEnabled: Scalars['Boolean']['output'];
  isOrderingRefundsEnabled: Scalars['Boolean']['output'];
  isOrdernerdEnabled: Scalars['Boolean']['output'];
  isOtterV2Enabled: Scalars['Boolean']['output'];
  isPopmenuLoyaltyEnabled: Scalars['Boolean']['output'];
  isPrintCenterEnabled: Scalars['Boolean']['output'];
  isPrintCenterLocked: Scalars['Boolean']['output'];
  isProfileV2Enabled: Scalars['Boolean']['output'];
  isReservationsEnabled: Scalars['Boolean']['output'];
  isRoiAlertsEnabled: Scalars['Boolean']['output'];
  isSelfServeProductCheckoutEnabled: Scalars['Boolean']['output'];
  isShowGlobalBillingAlertEnabled: Scalars['Boolean']['output'];
  isShowVipPromptOnHomePageOnlyEnabled: Scalars['Boolean']['output'];
  isSmsLimitsEnabled: Scalars['Boolean']['output'];
  isSmsOptInEnabled: Scalars['Boolean']['output'];
  isSocialPostSuggestionsEnabled: Scalars['Boolean']['output'];
  isTextBoxExtendedToolbarEnabled: Scalars['Boolean']['output'];
  isTextChatbotEnabled: Scalars['Boolean']['output'];
  isTextMessageEnabled: Scalars['Boolean']['output'];
  isTextMessageLocked: Scalars['Boolean']['output'];
  isTextMessagesSegmentationEnabled: Scalars['Boolean']['output'];
  isThirdPartyLoyaltyEnabled: Scalars['Boolean']['output'];
  isWaitlistEnabled: Scalars['Boolean']['output'];
  isWaitlistLocked: Scalars['Boolean']['output'];
  isWaitlistV2Enabled: Scalars['Boolean']['output'];
  isYextReviewsEnabled: Scalars['Boolean']['output'];
  itemCardV2Status: Scalars['String']['output'];
  lockableFeatures: Array<Scalars['String']['output']>;
  loyaltyStatus: Scalars['String']['output'];
  mainNavPanelStatus: Scalars['String']['output'];
  marketingCalendarStatus: Scalars['String']['output'];
  marketingDashboardStatus: Scalars['String']['output'];
  massMessagesSegmentationStatus: Scalars['String']['output'];
  maxMonthlyMessages?: Maybe<Scalars['Int']['output']>;
  maxMonthlyMmsMessages?: Maybe<Scalars['Int']['output']>;
  maxMonthlyTextMessages?: Maybe<Scalars['Int']['output']>;
  menuSyncUiStatus: Scalars['String']['output'];
  messageDetailsOverviewStatus: Scalars['String']['output'];
  messageGroupAutosaveStatus: Scalars['String']['output'];
  messagePacksStatus: Scalars['String']['output'];
  mfaRequiredStatus: Scalars['String']['output'];
  mmsMessageStatus: Scalars['String']['output'];
  mobileMenuNavigationV2Status: Scalars['String']['output'];
  mobileOrderDetailsV2Status: Scalars['String']['output'];
  multiChannelCampaignAiStatus: Scalars['String']['output'];
  multiLocationOloBillingStatus: Scalars['String']['output'];
  ncrSilverStatus: Scalars['String']['output'];
  nestedModifiersStatus: Scalars['String']['output'];
  openTableIntegrationStatus: Scalars['String']['output'];
  orderingBillingConfigValidationStatus: Scalars['String']['output'];
  orderingCateringStatus: Scalars['String']['output'];
  orderingDeliveryStatus: Scalars['String']['output'];
  orderingDineInStatus: Scalars['String']['output'];
  orderingDoorDashStatus: Scalars['String']['output'];
  orderingEventsStatus: Scalars['String']['output'];
  orderingPaymentStatus: Scalars['String']['output'];
  orderingRefundsStatus: Scalars['String']['output'];
  orderingStatus: Scalars['String']['output'];
  ordernerdStatus: Scalars['String']['output'];
  otterV2Status: Scalars['String']['output'];
  popmenuLoyaltyStatus: Scalars['String']['output'];
  printCenterStatus: Scalars['String']['output'];
  profileV2Status: Scalars['String']['output'];
  reservationsStatus: Scalars['String']['output'];
  roiAlertsStatus: Scalars['String']['output'];
  selfServeProductCheckoutStatus: Scalars['String']['output'];
  showGlobalBillingAlertStatus: Scalars['String']['output'];
  showVipPromptOnHomePageOnlyStatus: Scalars['String']['output'];
  smsLimitsStatus: Scalars['String']['output'];
  smsOptInStatus: Scalars['String']['output'];
  socialPostSuggestionsStatus: Scalars['String']['output'];
  textBoxExtendedToolbarStatus: Scalars['String']['output'];
  textChatbotStatus: Scalars['String']['output'];
  textMessageStatus: Scalars['String']['output'];
  textMessagesSegmentationStatus: Scalars['String']['output'];
  thirdPartyLoyaltyStatus: Scalars['String']['output'];
  waitlistStatus: Scalars['String']['output'];
  waitlistV2Status: Scalars['String']['output'];
  yextReviewsStatus: Scalars['String']['output'];
};

export type RestaurantFeatureSettingInput = {
  accessibilityFooterIconStatus?: InputMaybe<Scalars['String']['input']>;
  aiAnsweringStatus?: InputMaybe<Scalars['String']['input']>;
  aiMarketingCalendarPerLocationStatus?: InputMaybe<Scalars['String']['input']>;
  aiMarketingCalendarStatus?: InputMaybe<Scalars['String']['input']>;
  aiMarketingLiteStatus?: InputMaybe<Scalars['String']['input']>;
  aiReviewResponseStatus?: InputMaybe<Scalars['String']['input']>;
  applePayStatus?: InputMaybe<Scalars['String']['input']>;
  autoRevShareCustomFeesCreationStatus?: InputMaybe<Scalars['String']['input']>;
  boostAiMarketingCalendarStatus?: InputMaybe<Scalars['String']['input']>;
  chargebeePortalStatus?: InputMaybe<Scalars['String']['input']>;
  clientProfileStatus?: InputMaybe<Scalars['String']['input']>;
  consumerMobileAppStatus?: InputMaybe<Scalars['String']['input']>;
  creditCardSurchargeStatus?: InputMaybe<Scalars['String']['input']>;
  cspHeaderStatus?: InputMaybe<Scalars['String']['input']>;
  curbsideStatus?: InputMaybe<Scalars['String']['input']>;
  customCssStatus?: InputMaybe<Scalars['String']['input']>;
  developerApiStatus?: InputMaybe<Scalars['String']['input']>;
  dishCustomHtmlStatus?: InputMaybe<Scalars['String']['input']>;
  draftsUndoStatus?: InputMaybe<Scalars['String']['input']>;
  eatAppStatus?: InputMaybe<Scalars['String']['input']>;
  emailOptInStatus?: InputMaybe<Scalars['String']['input']>;
  enablingDraftsStatus?: InputMaybe<Scalars['String']['input']>;
  facebookCampaignsStatus?: InputMaybe<Scalars['String']['input']>;
  feedbackStatus?: InputMaybe<Scalars['String']['input']>;
  followerImportStatus?: InputMaybe<Scalars['String']['input']>;
  forceSyncMenusStatus?: InputMaybe<Scalars['String']['input']>;
  giftCardPurchasingStatus?: InputMaybe<Scalars['String']['input']>;
  giftCardsStatus?: InputMaybe<Scalars['String']['input']>;
  globalGoogleAnalyticsStatus?: InputMaybe<Scalars['String']['input']>;
  instagramFeedStatus?: InputMaybe<Scalars['String']['input']>;
  instagramStatus?: InputMaybe<Scalars['String']['input']>;
  itemCardV2Status?: InputMaybe<Scalars['String']['input']>;
  loyaltyStatus?: InputMaybe<Scalars['String']['input']>;
  mainNavPanelStatus?: InputMaybe<Scalars['String']['input']>;
  marketingCalendarStatus?: InputMaybe<Scalars['String']['input']>;
  massMessagesSegmentationStatus?: InputMaybe<Scalars['String']['input']>;
  menuSyncUiStatus?: InputMaybe<Scalars['String']['input']>;
  messageDetailsOverviewStatus?: InputMaybe<Scalars['String']['input']>;
  messageGroupAutosaveStatus?: InputMaybe<Scalars['String']['input']>;
  messagePacksStatus?: InputMaybe<Scalars['String']['input']>;
  mfaRequiredStatus?: InputMaybe<Scalars['String']['input']>;
  mmsMessageStatus?: InputMaybe<Scalars['String']['input']>;
  mobileOrderDetailsV2Status?: InputMaybe<Scalars['String']['input']>;
  multiChannelCampaignAiStatus?: InputMaybe<Scalars['String']['input']>;
  multiLocationOloBillingStatus?: InputMaybe<Scalars['String']['input']>;
  ncrSilverStatus?: InputMaybe<Scalars['String']['input']>;
  nestedModifiersStatus?: InputMaybe<Scalars['String']['input']>;
  openTableIntegrationStatus?: InputMaybe<Scalars['String']['input']>;
  orderingBillingConfigValidationStatus?: InputMaybe<Scalars['String']['input']>;
  orderingCateringStatus?: InputMaybe<Scalars['String']['input']>;
  orderingDeliveryStatus?: InputMaybe<Scalars['String']['input']>;
  orderingDineInStatus?: InputMaybe<Scalars['String']['input']>;
  orderingDoorDashStatus?: InputMaybe<Scalars['String']['input']>;
  orderingEventsStatus?: InputMaybe<Scalars['String']['input']>;
  orderingPaymentStatus?: InputMaybe<Scalars['String']['input']>;
  orderingRefundsStatus?: InputMaybe<Scalars['String']['input']>;
  orderingStatus?: InputMaybe<Scalars['String']['input']>;
  ordernerdStatus?: InputMaybe<Scalars['String']['input']>;
  otterV2Status?: InputMaybe<Scalars['String']['input']>;
  popmenuLoyaltyStatus?: InputMaybe<Scalars['String']['input']>;
  printCenterStatus?: InputMaybe<Scalars['String']['input']>;
  profileV2Status?: InputMaybe<Scalars['String']['input']>;
  reservationsStatus?: InputMaybe<Scalars['String']['input']>;
  roiAlertsStatus?: InputMaybe<Scalars['String']['input']>;
  selfServeProductCheckoutStatus?: InputMaybe<Scalars['String']['input']>;
  showGlobalBillingAlertStatus?: InputMaybe<Scalars['String']['input']>;
  showVipPromptOnHomePageOnlyStatus?: InputMaybe<Scalars['String']['input']>;
  smsOptInStatus?: InputMaybe<Scalars['String']['input']>;
  socialPostSuggestionsStatus?: InputMaybe<Scalars['String']['input']>;
  textBoxExtendedToolbarStatus?: InputMaybe<Scalars['String']['input']>;
  textChatbotStatus?: InputMaybe<Scalars['String']['input']>;
  textMessageStatus?: InputMaybe<Scalars['String']['input']>;
  textMessagesSegmentationStatus?: InputMaybe<Scalars['String']['input']>;
  thirdPartyLoyaltyStatus?: InputMaybe<Scalars['String']['input']>;
  waitlistStatus?: InputMaybe<Scalars['String']['input']>;
  waitlistV2Status?: InputMaybe<Scalars['String']['input']>;
  yextReviewsStatus?: InputMaybe<Scalars['String']['input']>;
};

export type RestaurantFollowerInput = {
  allSelected?: InputMaybe<Scalars['Boolean']['input']>;
  createdSince?: InputMaybe<Scalars['DateTime']['input']>;
  followerTagId?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  messageGroupExcludedFollowerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  messageGroupExcludedLocationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  messageGroupExcludedTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  messageGroupSelectedFollowerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  messageGroupSelectedFollowerSegmentsIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  messageGroupSelectedLocationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  messageGroupSelectedSegmentationMatcher?: InputMaybe<Scalars['String']['input']>;
  messageGroupSelectedSources?: InputMaybe<Array<Scalars['String']['input']>>;
  messageGroupSelectedTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  push?: InputMaybe<Scalars['Boolean']['input']>;
  remarketedAction?: InputMaybe<Scalars['String']['input']>;
  remarketedCampaignItemId?: InputMaybe<Scalars['Int']['input']>;
  remarketedLocationId?: InputMaybe<Scalars['Int']['input']>;
  remarketedTagId?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
  sms?: InputMaybe<Scalars['Boolean']['input']>;
  textMessageGroupId?: InputMaybe<Scalars['Int']['input']>;
};

export type RestaurantFollowerSegment = {
  __typename?: 'RestaurantFollowerSegment';
  audienceType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  daysAgo?: Maybe<Scalars['Int']['output']>;
  enabled: Scalars['Boolean']['output'];
  estimatedAudience?: Maybe<Scalars['Int']['output']>;
  estimatedEmailAudience?: Maybe<Scalars['Int']['output']>;
  estimatedSmsAudience?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isEditable: Scalars['Boolean']['output'];
  isEmailEligible: Scalars['Boolean']['output'];
  isPushEligible: Scalars['Boolean']['output'];
  isSmsEligible: Scalars['Boolean']['output'];
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  locationAudiences: Array<RestaurantFollowerSegmentLocationAudience>;
  minAmount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  restaurantId: Scalars['Int']['output'];
  rootFollowerSegmentId: Scalars['Int']['output'];
  segmentType: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RestaurantFollowerSegmentInput = {
  daysAgo?: InputMaybe<Scalars['Int']['input']>;
  estimatedAudience?: InputMaybe<Scalars['Int']['input']>;
  estimatedEmailAudience?: InputMaybe<Scalars['Int']['input']>;
  estimatedSmsAudience?: InputMaybe<Scalars['Int']['input']>;
  minAmount?: InputMaybe<Scalars['Int']['input']>;
};

export type RestaurantFollowerSegmentLocationAudience = {
  __typename?: 'RestaurantFollowerSegmentLocationAudience';
  createdAt: Scalars['DateTime']['output'];
  estimatedAudience?: Maybe<Scalars['Int']['output']>;
  followerSegmentId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  locationId: Scalars['Int']['output'];
  restaurantId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RestaurantFooterLink = NavItemable & {
  __typename?: 'RestaurantFooterLink';
  customHref?: Maybe<Scalars['String']['output']>;
  disableAjaxLoad: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isExternal: Scalars['Boolean']['output'];
  linkType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  photoUploadedPhoto?: Maybe<UploadedPhoto>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  restaurant?: Maybe<Restaurant>;
  target?: Maybe<NavLinkable>;
  targetId?: Maybe<Scalars['String']['output']>;
  targetType?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type RestaurantFooterLinkDraft = NavItemable & {
  __typename?: 'RestaurantFooterLinkDraft';
  customHref?: Maybe<Scalars['String']['output']>;
  disableAjaxLoad: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isExternal: Scalars['Boolean']['output'];
  linkType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  photoUploadedPhoto?: Maybe<UploadedPhoto>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  restaurant?: Maybe<Restaurant>;
  target?: Maybe<NavLinkable>;
  targetId?: Maybe<Scalars['String']['output']>;
  targetType?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type RestaurantGeocodedNewLocationAddress = {
  __typename?: 'RestaurantGeocodedNewLocationAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  timeZone: Scalars['String']['output'];
};

export type RestaurantGoogleAccount = {
  __typename?: 'RestaurantGoogleAccount';
  /** @deprecated Google Ads integration was removed. Always returns null. */
  adsCampaignId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Google Ads integration was removed. Always returns null. */
  adsClientId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Google Analytics provisioning was removed. Always returns null. */
  analyticsAccountCreated?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Google Analytics provisioning was removed. Always returns null. */
  analyticsAccountCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Google Analytics provisioning was removed. Always returns null. */
  analyticsAccountError?: Maybe<Scalars['String']['output']>;
  /** @deprecated Google Analytics provisioning was removed. Always returns null. */
  analyticsAccountErrorAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Google Analytics provisioning was removed. Always returns null. */
  analyticsId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Google Analytics provisioning was removed. Always returns null. */
  analyticsViewCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Google Analytics provisioning was removed. Always returns null. */
  analyticsViewErrorAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  restaurantId: Scalars['Int']['output'];
  sitemapError?: Maybe<Scalars['String']['output']>;
  sitemapErrorAt?: Maybe<Scalars['DateTime']['output']>;
  sitemapSubmitted?: Maybe<Scalars['Boolean']['output']>;
  sitemapSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  verificationError?: Maybe<Scalars['String']['output']>;
  verificationErrorAt?: Maybe<Scalars['DateTime']['output']>;
  verificationToken?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Google Analytics provisioning was removed. Always returns null. */
  viewCreatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RestaurantGoogleAccountConversionAction = {
  __typename?: 'RestaurantGoogleAccountConversionAction';
  actionType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  pageFormat?: Maybe<Scalars['String']['output']>;
  tag: Scalars['String']['output'];
};

export type RestaurantGroup = {
  __typename?: 'RestaurantGroup';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  restaurants: RestaurantPaginationHandler;
};


export type RestaurantGroupRestaurantsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type RestaurantGroupPaginationHandler = {
  __typename?: 'RestaurantGroupPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<RestaurantGroup>;
};

export type RestaurantHostingInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  hostingType?: InputMaybe<Scalars['String']['input']>;
  secondaryDomains?: InputMaybe<Array<RestaurantSecondaryDomainInput>>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
};

export type RestaurantInput = {
  accessibilityContact?: InputMaybe<Scalars['String']['input']>;
  attire?: InputMaybe<Scalars['String']['input']>;
  averageCateringOrderAmount?: InputMaybe<Scalars['Float']['input']>;
  averageDineInOrderAmount?: InputMaybe<Scalars['Float']['input']>;
  averageOnlineOrderAmount?: InputMaybe<Scalars['Float']['input']>;
  calendarEventView?: InputMaybe<Scalars['String']['input']>;
  cuisineTypeId?: InputMaybe<Scalars['Int']['input']>;
  customSiteTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayEventTags?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocationContent?: InputMaybe<Scalars['Boolean']['input']>;
  isImportedFollowerSmsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isSingleLocation?: InputMaybe<Scalars['Boolean']['input']>;
  mailerBrandColor?: InputMaybe<Scalars['String']['input']>;
  mailerDarkThemeLogoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  mailerFooterImageUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  mailerFooterMessage?: InputMaybe<Scalars['String']['input']>;
  mailerLinkColor?: InputMaybe<Scalars['String']['input']>;
  mailerLogoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  priceRange?: InputMaybe<Scalars['String']['input']>;
  removeSignUpBackgroundImage?: InputMaybe<Scalars['Boolean']['input']>;
  replyToEmail?: InputMaybe<Scalars['String']['input']>;
  selectedCuisineTypes?: InputMaybe<Array<RestaurantSelectedCuisineTypeInput>>;
  selectedPaymentMethodTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  servedMealTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  serviceType?: InputMaybe<Scalars['String']['input']>;
  setupContactEmail?: InputMaybe<Scalars['String']['input']>;
  setupContactName?: InputMaybe<Scalars['String']['input']>;
  setupContactPhone?: InputMaybe<Scalars['String']['input']>;
  showAllLocations?: InputMaybe<Scalars['Boolean']['input']>;
  showNavLocation?: InputMaybe<Scalars['Boolean']['input']>;
  signUpBackgroundImageDataUrl?: InputMaybe<Scalars['String']['input']>;
  yearEstablished?: InputMaybe<Scalars['Int']['input']>;
};

export type RestaurantKpiMetric = {
  __typename?: 'RestaurantKpiMetric';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  metricType: Scalars['String']['output'];
  restaurantId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type RestaurantLegalDocument = {
  __typename?: 'RestaurantLegalDocument';
  content?: Maybe<Scalars['String']['output']>;
  documentType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPublished: Scalars['Boolean']['output'];
  popmenuEmployeeName?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedByUser?: Maybe<User>;
  representativeName?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type RestaurantLegalDocumentAnswersInput = {
  appealMethod?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  financialIncentiveProgram?: InputMaybe<Scalars['String']['input']>;
  financialIncentiveTerms?: InputMaybe<Scalars['String']['input']>;
  financialIncentiveValuation?: InputMaybe<Scalars['String']['input']>;
  legalEntityName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  privacyContactEmail?: InputMaybe<Scalars['String']['input']>;
  privacyRequestByEmail?: InputMaybe<Scalars['Boolean']['input']>;
  privacyRequestByPhone?: InputMaybe<Scalars['Boolean']['input']>;
  privacyRequestOtherMethod?: InputMaybe<Scalars['String']['input']>;
  restaurantNames?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type RestaurantLegalDocumentPreview = {
  __typename?: 'RestaurantLegalDocumentPreview';
  document: Scalars['String']['output'];
  notice: Scalars['String']['output'];
};

export type RestaurantLegalReviewInformationDefaults = {
  __typename?: 'RestaurantLegalReviewInformationDefaults';
  city?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  legalEntityName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  restaurantNames?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type RestaurantLocation = Eventable & NavLinkable & {
  __typename?: 'RestaurantLocation';
  activeCartBucketMenuItemCartsCount: Scalars['Int']['output'];
  activeCateringCartBucketMenuItemCartsCount: Scalars['Int']['output'];
  activeCateringDeliveryRanges?: Maybe<Array<OrderingRangeable>>;
  activeCateringOrderingRanges?: Maybe<Array<OrderingRangeable>>;
  activeDeliveryRanges?: Maybe<Array<OrderingRangeable>>;
  activeDineInCartBucketMenuItemCartsCount: Scalars['Int']['output'];
  activeDineInRanges?: Maybe<Array<OrderingRangeable>>;
  activeOrderingRanges?: Maybe<Array<OrderingRangeable>>;
  activeReservationRanges?: Maybe<Array<OrderingRangeable>>;
  allowReservations?: Maybe<Scalars['Boolean']['output']>;
  alohaAccount?: Maybe<AlohaAccount>;
  alohaSite?: Maybe<AlohaSite>;
  alohaSiteSetting?: Maybe<RestaurantLocationAlohaSiteSetting>;
  answeringNumber?: Maybe<TwilioPhoneNumber>;
  answeringPhone?: Maybe<Scalars['String']['output']>;
  answeringSetting?: Maybe<RestaurantLocationAnsweringSetting>;
  anyAvailableOrderingDeliveryMenus: Scalars['Boolean']['output'];
  anyAvailableOrderingMenus: Scalars['Boolean']['output'];
  anyAvailableOrderingPickupMenus: Scalars['Boolean']['output'];
  appliedAddOns?: Maybe<Array<Scalars['String']['output']>>;
  authorizeAccount?: Maybe<AuthorizeAccount>;
  autoTextOnCurbsideArrival?: Maybe<Scalars['Boolean']['output']>;
  availableFulfillmentTypes: FulfillmentTypesEnum;
  availableOrderDates: Array<Scalars['DateTime']['output']>;
  availableOrderTimes?: Maybe<Array<Scalars['Time']['output']>>;
  bagFeeAmount: Scalars['Decimal']['output'];
  billingCustomer?: Maybe<BillingCustomer>;
  canEnableDoordash: Scalars['Boolean']['output'];
  canToggleOrderingCateringDelivery: Scalars['Boolean']['output'];
  canToggleOrderingDelivery: Scalars['Boolean']['output'];
  canToggleOrderingDineIn: Scalars['Boolean']['output'];
  cateringDaysInAdvanceCount: Scalars['Int']['output'];
  cateringDefaultFulfillmentType: Scalars['Int']['output'];
  cateringDeliveryAreaGeoJson?: Maybe<Scalars['JSON']['output']>;
  cateringDeliveryAreaType: Scalars['String']['output'];
  cateringDeliveryCoverMinimumAmount: Scalars['Decimal']['output'];
  cateringDeliveryDisabledAt?: Maybe<Scalars['DateTime']['output']>;
  cateringDeliveryFeeAmount: Scalars['Decimal']['output'];
  cateringDeliveryFeeAmountType: Scalars['String']['output'];
  cateringDeliveryFeeType: Scalars['String']['output'];
  cateringDeliveryFees: Array<RestaurantLocationDeliveryFee>;
  cateringDeliveryMaxMenuItemCartSubtotal?: Maybe<Scalars['Decimal']['output']>;
  cateringDeliveryMinMenuItemCartSubtotal?: Maybe<Scalars['Decimal']['output']>;
  cateringDeliveryMinimumFeeAmount: Scalars['Decimal']['output'];
  cateringDeliveryOpeningRanges: Array<RestaurantLocationCateringDeliveryOpeningRange>;
  cateringDeliveryRadiusMiles?: Maybe<Scalars['Decimal']['output']>;
  cateringDeliveryType: Scalars['String']['output'];
  cateringDisabledAt?: Maybe<Scalars['DateTime']['output']>;
  cateringDoorDashPickupInstructions?: Maybe<Scalars['String']['output']>;
  cateringDoordashFeeSubsidy?: Maybe<Scalars['Decimal']['output']>;
  cateringDoordashLargeOrderMin?: Maybe<Scalars['Decimal']['output']>;
  cateringFeeDisclaimer?: Maybe<Scalars['String']['output']>;
  cateringOrderingOpeningRanges: Array<RestaurantLocationCateringOrderingOpeningRange>;
  cateringPickupMaxMenuItemCartSubtotal?: Maybe<Scalars['Decimal']['output']>;
  cateringPickupMinMenuItemCartSubtotal?: Maybe<Scalars['Decimal']['output']>;
  cateringUberDirectFeeSubsidy: Scalars['Decimal']['output'];
  cateringUtensilsCheck: Scalars['Boolean']['output'];
  city: Scalars['String']['output'];
  cloverAccount?: Maybe<CloverAccount>;
  cloverApiKey?: Maybe<Scalars['String']['output']>;
  cloverMerchantId?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  curbsidePhone?: Maybe<Scalars['String']['output']>;
  /** ISO 3-letter currency code for formatting associated item prices */
  currency?: Maybe<Scalars['String']['output']>;
  currentCateringDeliveryDueMinutes: Scalars['Decimal']['output'];
  currentCateringPickupDueMinutes: Scalars['Decimal']['output'];
  currentDeliveryDueMinutes: Scalars['Decimal']['output'];
  currentOrderingBlackout?: Maybe<OrderingBlackout>;
  currentPickupDueMinutes: Scalars['Decimal']['output'];
  currentlyAvailableFulfillmentTypes: FulfillmentTypesEnum;
  customContentLinks?: Maybe<Array<LocationCustomContentLink>>;
  customDishTabContent?: Maybe<Scalars['String']['output']>;
  customDishTabName?: Maybe<Scalars['String']['output']>;
  customFees?: Maybe<Array<CustomFee>>;
  customFormEmailCsv?: Maybe<Scalars['String']['output']>;
  customLat?: Maybe<Scalars['Decimal']['output']>;
  customLng?: Maybe<Scalars['Decimal']['output']>;
  customLocationContent?: Maybe<Scalars['String']['output']>;
  defaultCateringTipOption?: Maybe<Scalars['Int']['output']>;
  defaultDineInTabTip?: Maybe<Scalars['Decimal']['output']>;
  defaultOrderingEventTipOption?: Maybe<Scalars['Int']['output']>;
  defaultPickupDueMinutes?: Maybe<Scalars['Int']['output']>;
  defaultReservationPreference?: Maybe<Scalars['String']['output']>;
  defaultTipOption?: Maybe<Scalars['Int']['output']>;
  deliverectChannel?: Maybe<DeliverectChannel>;
  deliveryAreaGeoJson?: Maybe<Scalars['JSON']['output']>;
  deliveryAreaType?: Maybe<Scalars['String']['output']>;
  deliveryDisabledAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryFees: Array<RestaurantLocationDeliveryFee>;
  deliveryIssueCateringCartBucketMenuItemCartsCount: Scalars['Int']['output'];
  deliveryIssueDefaultCartBucketMenuItemCartsCount: Scalars['Int']['output'];
  deliveryOpeningRanges: Array<RestaurantLocationDeliveryOpeningRange>;
  deliveryScore: Scalars['Int']['output'];
  deliveryType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dineInInactiveTabAutoCloseTime?: Maybe<Scalars['Time']['output']>;
  dineInOpeningRanges: Array<RestaurantLocationDineInOpeningRange>;
  dineInSkipPaymentAllowed?: Maybe<Scalars['Boolean']['output']>;
  dineInTabActiveMinutes?: Maybe<Scalars['Int']['output']>;
  displayPhone?: Maybe<Scalars['String']['output']>;
  doordashFeeSubsidy?: Maybe<Scalars['Decimal']['output']>;
  eatPopCtaLinkUrl: Scalars['String']['output'];
  eatPopCtaText: Scalars['String']['output'];
  ecardAccountId?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enabledMenus: Array<Menu>;
  eventableName: Scalars['String']['output'];
  everywareAccount?: Maybe<EverywareAccount>;
  externalIntegrations?: Maybe<Array<ExternalIntegration>>;
  externalIntegrationsSettings?: Maybe<RestaurantLocationsExternalIntegrationsSettings>;
  failedOrderingInvoices?: Maybe<Array<BillingInvoice>>;
  featureSetting: RestaurantLocationFeatureSetting;
  featuredAnnouncement?: Maybe<Announcement>;
  feedbackSetting: FeedbackSetting;
  firstDayOfWeek?: Maybe<Scalars['String']['output']>;
  followersCount: Scalars['Int']['output'];
  fullAddress?: Maybe<Scalars['String']['output']>;
  googleMapLocationUrl?: Maybe<Scalars['String']['output']>;
  googleMyBusinessLocation?: Maybe<GoogleMyBusinessLocation>;
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  hasCateringMenu: Scalars['Boolean']['output'];
  hasCustomerSetForOrdering: Scalars['Boolean']['output'];
  hasDeliveryEnabledMenus: Scalars['Boolean']['output'];
  hasDeliveryMenu: Scalars['Boolean']['output'];
  hasDineInMenu: Scalars['Boolean']['output'];
  hasMultipleInvoiceDue: Scalars['Boolean']['output'];
  hasNonCateringMenu: Scalars['Boolean']['output'];
  hasPaymentMethod: Scalars['Boolean']['output'];
  hasPaymentSelected: Scalars['Boolean']['output'];
  hasPickupEnabledMenus: Scalars['Boolean']['output'];
  hasPickupMenu: Scalars['Boolean']['output'];
  hasRequiredPaymentMethod: Scalars['Boolean']['output'];
  hasSubmittedMenuItemCarts: Scalars['Boolean']['output'];
  hasToastGiftCardSupport: Scalars['Boolean']['output'];
  hasToastOfferSupport: Scalars['Boolean']['output'];
  heartlandAccount?: Maybe<HeartlandAccount>;
  heartlandPosLocation?: Maybe<HeartlandPosLocation>;
  heartlandPosSetting?: Maybe<HeartlandPosSetting>;
  heartlandPublicKey?: Maybe<Scalars['String']['output']>;
  hideTaxesAndTipsDisclaimersOnPickup: Scalars['Boolean']['output'];
  historyCartBucketMenuItemCartsCount: Scalars['Int']['output'];
  historyCateringCartBucketMenuItemCartsCount: Scalars['Int']['output'];
  historyDineInCartBucketMenuItemCartsCount: Scalars['Int']['output'];
  holidayOpeningRanges: Array<RestaurantLocationHolidayOpeningRange>;
  id: Scalars['Int']['output'];
  ignorePastDueInvoices?: Maybe<Scalars['Boolean']['output']>;
  inactiveDineInCartBucketMenuItemCartsCount: Scalars['Int']['output'];
  isAlohaMenuSyncEnabled: Scalars['Boolean']['output'];
  isAlohaPayment: Scalars['Boolean']['output'];
  isAlohaPaymentAvailable: Scalars['Boolean']['output'];
  isAnyOrderingEnabled: Scalars['Boolean']['output'];
  isAppleGooglePayAvailableInCountry: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  isAuthorizePayment: Scalars['Boolean']['output'];
  isAuthorizePaymentAvailable: Scalars['Boolean']['output'];
  isAuthorizeWithGeniusPayment: Scalars['Boolean']['output'];
  isBagFeeEnabled: Scalars['Boolean']['output'];
  isBillable: Scalars['Boolean']['output'];
  isBillingBlockDoordashEnabled: Scalars['Boolean']['output'];
  isCateringDeliveryAvailable: Scalars['Boolean']['output'];
  isCateringDoordashLargeOrderFulfillmentEnabled: Scalars['Boolean']['output'];
  isCateringOrderingAvailable: Scalars['Boolean']['output'];
  isCateringPickupInStoreEnabled: Scalars['Boolean']['output'];
  isCateringTipsEnabled: Scalars['Boolean']['output'];
  isCloverGuestImportEnabled: Scalars['Boolean']['output'];
  isCloverPayment: Scalars['Boolean']['output'];
  isCloverPaymentAvailable: Scalars['Boolean']['output'];
  isCloverPaymentRequestButtonEnabled: Scalars['Boolean']['output'];
  isCustomGooglePlaceId?: Maybe<Scalars['Boolean']['output']>;
  isDeliverectPayment: Scalars['Boolean']['output'];
  isDeliveryAvailable: Scalars['Boolean']['output'];
  isDeliveryBlockSetAuto: Scalars['Boolean']['output'];
  isDeliveryBlocked: Scalars['Boolean']['output'];
  isDineInAvailable: Scalars['Boolean']['output'];
  isDoordashBlockSetAuto: Scalars['Boolean']['output'];
  isEverywarePayment: Scalars['Boolean']['output'];
  isEverywarePaymentAvailable: Scalars['Boolean']['output'];
  isGoogleOrderingEnabled?: Maybe<Scalars['Boolean']['output']>;
  isHeartlandPayment: Scalars['Boolean']['output'];
  isHeartlandPaymentAvailable: Scalars['Boolean']['output'];
  isHeartlandPosPayment: Scalars['Boolean']['output'];
  isLocationClosed?: Maybe<Scalars['Boolean']['output']>;
  isLocationEnabled: Scalars['Boolean']['output'];
  isLocationSuspended: Scalars['Boolean']['output'];
  isMenuAutoSyncEnabled?: Maybe<Scalars['Boolean']['output']>;
  isMenuSyncEnabled: Scalars['Boolean']['output'];
  isMicrosPayment: Scalars['Boolean']['output'];
  isNcrPayment: Scalars['Boolean']['output'];
  isNcrSilverMenuSyncEnabled: Scalars['Boolean']['output'];
  isNcrSilverPayment: Scalars['Boolean']['output'];
  isNcrSilverPaymentAvailable: Scalars['Boolean']['output'];
  isOnlinePaymentAvailable: Scalars['Boolean']['output'];
  isOrderingAppDeliveryAvailable: Scalars['Boolean']['output'];
  isOrderingAppPickupAvailable: Scalars['Boolean']['output'];
  isOrderingAutoAcceptEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingAvailable: Scalars['Boolean']['output'];
  isOrderingCateringDeliveryCoverMinimumEnabled: Scalars['Boolean']['output'];
  isOrderingCateringDeliveryEnabled: Scalars['Boolean']['output'];
  isOrderingCateringDeliveryPlatformFeeEnabled: Scalars['Boolean']['output'];
  isOrderingCateringEnabled: Scalars['Boolean']['output'];
  isOrderingCateringPayOnPickupEnabled: Scalars['Boolean']['output'];
  isOrderingCateringPickupPlatformFeeEnabled: Scalars['Boolean']['output'];
  isOrderingComplete?: Maybe<Scalars['Boolean']['output']>;
  isOrderingConsumerPlatformFeeEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingDeliveryComplete?: Maybe<Scalars['Boolean']['output']>;
  isOrderingDeliveryCoverMinimumEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingDeliveryEnabled: Scalars['Boolean']['output'];
  isOrderingDeliveryForCateringEnabled: Scalars['Boolean']['output'];
  isOrderingDeliveryPlatformFeeEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingDineInAutoAcceptEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingDineInEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingDineInFeeEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingDineInHideEmailFieldEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingDineInHideNameFieldEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingDineInHidePaymentStepEnabled: Scalars['Boolean']['output'];
  isOrderingDineInHidePhoneNumberFieldEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingDineInPlatformFeeEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingDineInRemoveTableLabelEnabled: Scalars['Boolean']['output'];
  isOrderingEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingEventPlatformFeeEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingEventTipsEnabled: Scalars['Boolean']['output'];
  isOrderingFeeEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingFeeTaxEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingHolidaysEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingMessagesEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingMessagesForCateringEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingPayOnPickupEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingPaymentEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingPaymentsDirect: Scalars['Boolean']['output'];
  isOrderingScheduleEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingSpecialInstructionsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingTaxEnabled: Scalars['Boolean']['output'];
  isOrderingTextMessagesEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingTipsEnabled: Scalars['Boolean']['output'];
  isPickupBlockSetAuto: Scalars['Boolean']['output'];
  isPickupBlocked: Scalars['Boolean']['output'];
  isPickupCurbsideEnabled?: Maybe<Scalars['Boolean']['output']>;
  isPickupInStoreEnabled?: Maybe<Scalars['Boolean']['output']>;
  isPosProcessing: Scalars['Boolean']['output'];
  isSpotonPayment: Scalars['Boolean']['output'];
  isSquareAutoCatalogSyncEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSquareDisconnecting: Scalars['Boolean']['output'];
  isSquareGuestImportEnabled: Scalars['Boolean']['output'];
  isSquareLoyaltyEnabled: Scalars['Boolean']['output'];
  isSquareMenuAutoSyncEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSquareMenuSyncEnabled: Scalars['Boolean']['output'];
  isSquarePayment: Scalars['Boolean']['output'];
  isSquarePaymentAvailable: Scalars['Boolean']['output'];
  isSquarePaymentRequestButtonEnabled: Scalars['Boolean']['output'];
  isStripePayment: Scalars['Boolean']['output'];
  isStripePaymentAvailable: Scalars['Boolean']['output'];
  isStripePaymentRequestButtonEnabled: Scalars['Boolean']['output'];
  isToastMenuSyncEnabled: Scalars['Boolean']['output'];
  isToastPayment: Scalars['Boolean']['output'];
  isToastPaymentAvailable: Scalars['Boolean']['output'];
  isToastPaymentRequestButtonEnabled: Scalars['Boolean']['output'];
  isUkBased: Scalars['Boolean']['output'];
  lastBillingSyncError?: Maybe<Scalars['String']['output']>;
  lastHeartlandPosRooms: Array<HeartlandPosRoom>;
  lastInvoiceDue?: Maybe<Scalars['Boolean']['output']>;
  lastMicrosOrderTypes: Array<MicrosOrderType>;
  lastMicrosTenders: Array<MicrosTender>;
  lastSpotonMenus: Array<SpotonMenu>;
  lat?: Maybe<Scalars['Decimal']['output']>;
  lng?: Maybe<Scalars['Decimal']['output']>;
  locationLandingPageId?: Maybe<Scalars['Int']['output']>;
  locationLandingPageUrl?: Maybe<Scalars['String']['output']>;
  locationVersionsCount: Scalars['Int']['output'];
  locationWebsiteUrl?: Maybe<Scalars['String']['output']>;
  manageOrderingLocationMembers: Array<RestaurantMember>;
  mapUrl?: Maybe<Scalars['String']['output']>;
  maxMenuItemCartSubtotal?: Maybe<Scalars['Decimal']['output']>;
  /** @deprecated Use member_location instead */
  memberAnsweringLocation?: Maybe<RestaurantMemberLocation>;
  memberLocation?: Maybe<RestaurantMemberLocation>;
  menuLandingPageId?: Maybe<Scalars['Int']['output']>;
  menuLandingPageUrl?: Maybe<Scalars['String']['output']>;
  menus: Array<Menu>;
  microsMenuId?: Maybe<Scalars['String']['output']>;
  microsOrg?: Maybe<MicrosOrg>;
  microsRvcName?: Maybe<Scalars['String']['output']>;
  microsSetting?: Maybe<RestaurantLocationMicrosSetting>;
  minMenuItemCartSubtotal?: Maybe<Scalars['Decimal']['output']>;
  name: Scalars['String']['output'];
  ncrSilverAccount?: Maybe<NcrSilverAccount>;
  ncrSilverStore?: Maybe<NcrSilverStore>;
  ncrSilverStoreSetting?: Maybe<RestaurantLocationNcrSilverStoreSetting>;
  newCartBucketMenuItemCartsCount: Scalars['Int']['output'];
  newCateringCartBucketMenuItemCartsCount: Scalars['Int']['output'];
  newDineInCartBucketMenuItemCartsCount: Scalars['Int']['output'];
  nmiAccount?: Maybe<NmiAccount>;
  nmiTokenizationKey?: Maybe<Scalars['String']['output']>;
  openTableId?: Maybe<Scalars['String']['output']>;
  openTableLocationLastSync?: Maybe<Scalars['String']['output']>;
  openTableReservationUrl?: Maybe<Scalars['String']['output']>;
  openTableSyncClientId?: Maybe<Scalars['String']['output']>;
  openTableSyncClientSecret?: Maybe<Scalars['String']['output']>;
  openingRanges: Array<RestaurantLocationOpeningRange>;
  opentablePartnerId?: Maybe<Scalars['String']['output']>;
  orderCurrency?: Maybe<Scalars['String']['output']>;
  orderInjectionType?: Maybe<Scalars['String']['output']>;
  orderTimeLaterOptionCustomLabel?: Maybe<Scalars['String']['output']>;
  orderTypePickupOptionCustomLabel?: Maybe<Scalars['String']['output']>;
  orderingBillingConfig?: Maybe<RestaurantLocationOrderingBillingConfig>;
  orderingBlackouts: Array<OrderingBlackout>;
  orderingDelayMinutes?: Maybe<Scalars['Int']['output']>;
  orderingDelayUntil?: Maybe<Scalars['DateTime']['output']>;
  orderingDeliveryCoverMinimumAmount?: Maybe<Scalars['Decimal']['output']>;
  orderingDeliveryDriveTime?: Maybe<Scalars['Decimal']['output']>;
  orderingDeliveryFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  orderingDeliveryFeeAmountType?: Maybe<Scalars['String']['output']>;
  orderingDeliveryFeeType?: Maybe<Scalars['String']['output']>;
  orderingDeliveryMaxMenuItemCartSubtotal?: Maybe<Scalars['Decimal']['output']>;
  orderingDeliveryMinMenuItemCartSubtotal?: Maybe<Scalars['Decimal']['output']>;
  orderingDeliveryMinimumFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  orderingDeliveryOnboardingStatus?: Maybe<Scalars['String']['output']>;
  orderingDeliveryRadiusMiles?: Maybe<Scalars['Decimal']['output']>;
  orderingDineInFeePercent?: Maybe<Scalars['Decimal']['output']>;
  orderingDineInIntroText?: Maybe<Scalars['String']['output']>;
  orderingDineInTableNumberDescription?: Maybe<Scalars['String']['output']>;
  orderingDineInTableNumberLabel?: Maybe<Scalars['String']['output']>;
  orderingDisabledAt?: Maybe<Scalars['DateTime']['output']>;
  orderingEventFeeDisclaimer?: Maybe<Scalars['String']['output']>;
  orderingEventUtensilsCheck: Scalars['Boolean']['output'];
  orderingFeeBillingCustomer?: Maybe<BillingCustomer>;
  orderingFeePercent?: Maybe<Scalars['Decimal']['output']>;
  orderingFeeTitle?: Maybe<Scalars['String']['output']>;
  orderingLandingPageId?: Maybe<Scalars['Int']['output']>;
  orderingLandingPageUrl?: Maybe<Scalars['String']['output']>;
  orderingOnboardingStatus?: Maybe<Scalars['String']['output']>;
  orderingOpeningRanges: Array<RestaurantLocationOrderingOpeningRange>;
  orderingPaymentMessage?: Maybe<Scalars['String']['output']>;
  orderingPickupMaxMenuItemCartSubtotal?: Maybe<Scalars['Decimal']['output']>;
  orderingPickupMinMenuItemCartSubtotal?: Maybe<Scalars['Decimal']['output']>;
  orderingTaxPercent?: Maybe<Scalars['Decimal']['output']>;
  orderingUtensilsCheck: Scalars['Boolean']['output'];
  partySettings: PartySettings;
  pauseUntil?: Maybe<Scalars['DateTime']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  photoUploadedPhoto?: Maybe<UploadedPhoto>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  pickupCurbsideCustomLabel?: Maybe<Scalars['String']['output']>;
  pickupCurbsideDelayFifteenText?: Maybe<Scalars['String']['output']>;
  pickupCurbsideDelayFiveText?: Maybe<Scalars['String']['output']>;
  pickupCurbsideDelayTenText?: Maybe<Scalars['String']['output']>;
  pickupCurbsideDescription?: Maybe<Scalars['String']['output']>;
  pickupCurbsidePhone?: Maybe<Scalars['String']['output']>;
  pickupCurbsideReplyText?: Maybe<Scalars['String']['output']>;
  pickupInStoreCustomLabel?: Maybe<Scalars['String']['output']>;
  pickupInStoreDescription?: Maybe<Scalars['String']['output']>;
  pickupScore: Scalars['Int']['output'];
  policy: LocationPolicy;
  popmenuOrderingMenus: Array<Menu>;
  posLastSyncAt: Scalars['DateTime']['output'];
  posTypeMenus: Array<Menu>;
  position?: Maybe<Scalars['Int']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  publishingName?: Maybe<Scalars['String']['output']>;
  reservationBlackouts: Array<ReservationBlackout>;
  reservationsLandingPageId?: Maybe<Scalars['Int']['output']>;
  reservationsLandingPageUrl?: Maybe<Scalars['String']['output']>;
  reservationsOpeningRanges?: Maybe<Array<RestaurantLocationReservationsOpeningRange>>;
  restaurant?: Maybe<Restaurant>;
  restaurantBillingCustomer?: Maybe<BillingCustomer>;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  resyApiKey?: Maybe<Scalars['String']['output']>;
  resyLinkUrl?: Maybe<Scalars['String']['output']>;
  resyVenueId?: Maybe<Scalars['Int']['output']>;
  salesforceAccount?: Maybe<SalesforceAccount>;
  scheduledCartBucketMenuItemCartsCount: Scalars['Int']['output'];
  scheduledCateringCartBucketMenuItemCartsCount: Scalars['Int']['output'];
  /** @deprecated No longer populated */
  schemaHours?: Maybe<Array<Scalars['String']['output']>>;
  showCurbsideVehicleInputs?: Maybe<Scalars['Boolean']['output']>;
  showLocationPhotoInLocationSearch?: Maybe<Scalars['Boolean']['output']>;
  showLocationPhotoInLocationSection?: Maybe<Scalars['Boolean']['output']>;
  skipOnlineTaxCalculation: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  smsRegulatoryBundle?: Maybe<TwilioPhoneNumberRegulatoryBundle>;
  socialHandles: Array<RestaurantLocationSocialHandle>;
  spotonLocation?: Maybe<SpotonLocation>;
  spotonRoot?: Maybe<SpotonRoot>;
  spotonSetting?: Maybe<SpotonSetting>;
  squareApplicationId?: Maybe<Scalars['String']['output']>;
  squareLocation?: Maybe<SquareSellerLocation>;
  squareLocationId?: Maybe<Scalars['String']['output']>;
  squareSellerAccount?: Maybe<SquareSellerAccount>;
  standardDaysInAdvanceCount: Scalars['Int']['output'];
  standardDoorDashPickupInstructions?: Maybe<Scalars['String']['output']>;
  standardFeeDisclaimer?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateName?: Maybe<Scalars['String']['output']>;
  streetAddress: Scalars['String']['output'];
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  stripeAccountType?: Maybe<Scalars['String']['output']>;
  stripeConnectAccount?: Maybe<StripeConnectAccount>;
  stripePublishableKey?: Maybe<Scalars['String']['output']>;
  submittedMenuItemCartsCount: Scalars['Int']['output'];
  submittedStatusMenuItemCartsCount: Scalars['Int']['output'];
  taxId?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  ticketSaleSetting?: Maybe<RestaurantLocationTicketSaleSetting>;
  timezone?: Maybe<Scalars['String']['output']>;
  toastConnectedMenus: Array<Menu>;
  toastRestaurant?: Maybe<ToastRestaurant>;
  toastSetting?: Maybe<RestaurantLocationToastSetting>;
  toastSummary?: Maybe<ToastRestaurantSummary>;
  twilioBusinessRegistration?: Maybe<TwilioBusinessRegistration>;
  twilioPhoneNumber?: Maybe<TwilioPhoneNumber>;
  twilioStatus?: Maybe<TwilioStatus>;
  uberDirectFeeSubsidy: Scalars['Decimal']['output'];
  uiLocation?: Maybe<UiRestaurantLocationInterface>;
  unviewedCateringCartsCount: Scalars['Int']['output'];
  unviewedDefaultCartsCount: Scalars['Int']['output'];
  unviewedDineInCartsCount: Scalars['Int']['output'];
  upsellCampaignMenuItems: Array<MenuItem>;
  url?: Maybe<Scalars['String']['output']>;
  useCloudflareMapboxUrl: Scalars['Boolean']['output'];
  useCurbsidePhone?: Maybe<Scalars['Boolean']['output']>;
  useLocationOpeningHours: Scalars['Boolean']['output'];
  useLocationOpeningHoursForCatering: Scalars['Boolean']['output'];
  useLocationOpeningHoursForCateringDelivery: Scalars['Boolean']['output'];
  useLocationOpeningHoursForDelivery: Scalars['Boolean']['output'];
  useLocationOpeningHoursForDineIn: Scalars['Boolean']['output'];
  useLocationOpeningHoursForReservations: Scalars['Boolean']['output'];
  waitingCurbsideCartBucketMenuItemCartsCount: Scalars['Int']['output'];
  yelpFriendlyId?: Maybe<Scalars['String']['output']>;
  yelpReservationUrl?: Maybe<Scalars['String']['output']>;
};


export type RestaurantLocationAnyAvailableOrderingDeliveryMenusArgs = {
  catering?: InputMaybe<Scalars['Boolean']['input']>;
  requestedDatetime?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RestaurantLocationAnyAvailableOrderingMenusArgs = {
  cartType?: InputMaybe<Scalars['String']['input']>;
  requestedDatetime?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RestaurantLocationAnyAvailableOrderingPickupMenusArgs = {
  catering?: InputMaybe<Scalars['Boolean']['input']>;
  requestedDatetime?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RestaurantLocationAvailableFulfillmentTypesArgs = {
  catering: Scalars['Boolean']['input'];
};


export type RestaurantLocationAvailableOrderDatesArgs = {
  cartType: Scalars['String']['input'];
  fulfillmentType: Scalars['String']['input'];
  menuIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  orderingEventSlug?: InputMaybe<Scalars['String']['input']>;
};


export type RestaurantLocationAvailableOrderTimesArgs = {
  cartType: Scalars['String']['input'];
  fulfillmentType: Scalars['String']['input'];
  menuIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  orderingEventSlug?: InputMaybe<Scalars['String']['input']>;
  requestedDate: Scalars['DateTime']['input'];
};


export type RestaurantLocationCurrentOrderingBlackoutArgs = {
  cartType?: InputMaybe<Scalars['String']['input']>;
  fulfillmentType?: InputMaybe<Scalars['String']['input']>;
  requestedDatetime?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RestaurantLocationCurrentlyAvailableFulfillmentTypesArgs = {
  catering: Scalars['Boolean']['input'];
  requestedDatetime?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RestaurantLocationDeliveryScoreArgs = {
  catering?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RestaurantLocationHasDeliveryEnabledMenusArgs = {
  catering?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RestaurantLocationHasPickupEnabledMenusArgs = {
  catering?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RestaurantLocationIsOrderingAppDeliveryAvailableArgs = {
  catering?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RestaurantLocationIsOrderingAppPickupAvailableArgs = {
  catering?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RestaurantLocationOrderingBlackoutsArgs = {
  cartType: Scalars['String']['input'];
};


export type RestaurantLocationPickupScoreArgs = {
  catering?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RestaurantLocationPopmenuOrderingMenusArgs = {
  catering?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RestaurantLocationPosTypeMenusArgs = {
  fulfillmentType?: InputMaybe<Scalars['String']['input']>;
};


export type RestaurantLocationUpsellCampaignMenuItemsArgs = {
  cartType: Scalars['String']['input'];
  fulfillmentType: Scalars['String']['input'];
  isScheduled: Scalars['Boolean']['input'];
  orderingEventId?: InputMaybe<Scalars['Int']['input']>;
  requestedDatetime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RestaurantLocationAlohaSiteSetting = {
  __typename?: 'RestaurantLocationAlohaSiteSetting';
  accountType: Scalars['String']['output'];
  alohaOfferReferenceId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  ncrPaymentAccount?: Maybe<NcrPaymentAccount>;
  ncrPaymentStoreNumber?: Maybe<Scalars['String']['output']>;
};

export type RestaurantLocationAnsweringSetting = {
  __typename?: 'RestaurantLocationAnsweringSetting';
  afterCloseBuffer: Scalars['Int']['output'];
  answeringNumber?: Maybe<TwilioPhoneNumber>;
  beforeOpenBuffer: Scalars['Int']['output'];
  customClosedGreetingMessage?: Maybe<Scalars['String']['output']>;
  customClosingMessage?: Maybe<Scalars['String']['output']>;
  customGreetingMessage?: Maybe<Scalars['String']['output']>;
  customVoicemailMessage?: Maybe<Scalars['String']['output']>;
  /** How long Twilio waits for before marking call as unanswered in seconds */
  dialTimeout?: Maybe<Scalars['Int']['output']>;
  fallbackPhoneNumbers?: Maybe<Array<RestaurantLocationAnsweringSettingFallbackPhoneNumber>>;
  id?: Maybe<Scalars['Int']['output']>;
  isAfterHoursRoutingBufferEnabled: Scalars['Boolean']['output'];
  isAfterHoursRoutingEnabled: Scalars['Boolean']['output'];
  isAiAnsweringCustomResponsesEnabled: Scalars['Boolean']['output'];
  isAiAnsweringEnabled: Scalars['Boolean']['output'];
  isAiAnsweringOffHoursOnlyEnabled: Scalars['Boolean']['output'];
  isAiAnsweringOriginalCallerIdEnabled: Scalars['Boolean']['output'];
  isAiAnsweringPhonePublishEnabled: Scalars['Boolean']['output'];
  isAiAnsweringRecordingEnabled: Scalars['Boolean']['output'];
  isForwardingEnabled: Scalars['Boolean']['output'];
  isSpamBlockingEnabled: Scalars['Boolean']['output'];
  isVoicemailEnabled: Scalars['Boolean']['output'];
  isVoicemailFallbackEnabled: Scalars['Boolean']['output'];
  location?: Maybe<RestaurantLocation>;
  phone?: Maybe<Scalars['String']['output']>;
  voiceSettings?: Maybe<RestaurantLocationAnsweringSettingVoiceSetting>;
};

export type RestaurantLocationAnsweringSettingFallbackPhoneNumber = {
  __typename?: 'RestaurantLocationAnsweringSettingFallbackPhoneNumber';
  fallbackType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isPrimary: Scalars['Boolean']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type RestaurantLocationAnsweringSettingFallbackPhoneNumberInput = {
  /** Fallback Number - Fallback Type */
  fallbackType?: InputMaybe<Scalars['String']['input']>;
  /** Fallback Number - ID */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Fallback Number - Primary Number */
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Fallback Number - Phone Number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type RestaurantLocationAnsweringSettingInput = {
  /** Answering - After Close Buffer */
  afterCloseBuffer?: InputMaybe<Scalars['Int']['input']>;
  /** Answering - Before Open Buffer */
  beforeOpenBuffer?: InputMaybe<Scalars['Int']['input']>;
  /** Answering - Bot Voice */
  botVoice?: InputMaybe<Scalars['String']['input']>;
  /** Answering - Custom Closed Greeting Message */
  customClosedGreetingMessage?: InputMaybe<Scalars['String']['input']>;
  /** Answering - Custom Closing Message */
  customClosingMessage?: InputMaybe<Scalars['String']['input']>;
  /** Answering - Custom Greeting Message */
  customGreetingMessage?: InputMaybe<Scalars['String']['input']>;
  /** Answering - Custom Voicemail Message */
  customVoicemailMessage?: InputMaybe<Scalars['String']['input']>;
  /** Answering - Fallback Phone Numbers */
  fallbackPhoneNumbers?: InputMaybe<Array<RestaurantLocationAnsweringSettingFallbackPhoneNumberInput>>;
  /** Answering - After Hours Routing Buffer */
  isAfterHoursRoutingBufferEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Answering - After Hours Call Routing */
  isAfterHoursRoutingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Answering - Custom Responses */
  isAiAnsweringCustomResponsesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Answering - Is Enabled */
  isAiAnsweringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Answering - Non Business Hours Only */
  isAiAnsweringOffHoursOnlyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Answering - Caller Id */
  isAiAnsweringOriginalCallerIdEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Answering - Publish Phone Number */
  isAiAnsweringPhonePublishEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Answering - Call Recording */
  isAiAnsweringRecordingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Answering - Forwarding */
  isForwardingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Answering - Spam Filtering */
  isSpamBlockingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Answering - Voicemail */
  isVoicemailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Answering - Voicemail Fallback */
  isVoicemailFallbackEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Answering - Location ID */
  locationId?: InputMaybe<Scalars['Int']['input']>;
  /** Answering - Voice Speed */
  voiceSpeed?: InputMaybe<Scalars['String']['input']>;
};

export type RestaurantLocationAnsweringSettingVoiceSetting = {
  __typename?: 'RestaurantLocationAnsweringSettingVoiceSetting';
  botVoice?: Maybe<Scalars['String']['output']>;
  voiceSpeed?: Maybe<Scalars['String']['output']>;
};

export type RestaurantLocationCateringDeliveryOpeningRange = OrderingRangeable & {
  __typename?: 'RestaurantLocationCateringDeliveryOpeningRange';
  closeTime?: Maybe<Scalars['Time']['output']>;
  dayFriday?: Maybe<Scalars['Boolean']['output']>;
  dayMonday?: Maybe<Scalars['Boolean']['output']>;
  daySaturday?: Maybe<Scalars['Boolean']['output']>;
  daySunday?: Maybe<Scalars['Boolean']['output']>;
  dayThursday?: Maybe<Scalars['Boolean']['output']>;
  dayTuesday?: Maybe<Scalars['Boolean']['output']>;
  dayWednesday?: Maybe<Scalars['Boolean']['output']>;
  days: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  openAllDay?: Maybe<Scalars['Boolean']['output']>;
  openTime?: Maybe<Scalars['Time']['output']>;
  untilClose?: Maybe<Scalars['Boolean']['output']>;
};

export type RestaurantLocationCateringOrderingOpeningRange = OrderingRangeable & {
  __typename?: 'RestaurantLocationCateringOrderingOpeningRange';
  closeTime?: Maybe<Scalars['Time']['output']>;
  dayFriday?: Maybe<Scalars['Boolean']['output']>;
  dayMonday?: Maybe<Scalars['Boolean']['output']>;
  daySaturday?: Maybe<Scalars['Boolean']['output']>;
  daySunday?: Maybe<Scalars['Boolean']['output']>;
  dayThursday?: Maybe<Scalars['Boolean']['output']>;
  dayTuesday?: Maybe<Scalars['Boolean']['output']>;
  dayWednesday?: Maybe<Scalars['Boolean']['output']>;
  days: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  openAllDay?: Maybe<Scalars['Boolean']['output']>;
  openTime?: Maybe<Scalars['Time']['output']>;
  untilClose?: Maybe<Scalars['Boolean']['output']>;
};

export type RestaurantLocationCustomContentLinkInput = {
  customHref?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  linkType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  targetId?: InputMaybe<Scalars['Int']['input']>;
};

export type RestaurantLocationDeliveryFee = {
  __typename?: 'RestaurantLocationDeliveryFee';
  distance?: Maybe<Scalars['Decimal']['output']>;
  feeAmount?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['Int']['output'];
};

export type RestaurantLocationDeliveryOpeningRange = OrderingRangeable & {
  __typename?: 'RestaurantLocationDeliveryOpeningRange';
  closeTime?: Maybe<Scalars['Time']['output']>;
  dayFriday?: Maybe<Scalars['Boolean']['output']>;
  dayMonday?: Maybe<Scalars['Boolean']['output']>;
  daySaturday?: Maybe<Scalars['Boolean']['output']>;
  daySunday?: Maybe<Scalars['Boolean']['output']>;
  dayThursday?: Maybe<Scalars['Boolean']['output']>;
  dayTuesday?: Maybe<Scalars['Boolean']['output']>;
  dayWednesday?: Maybe<Scalars['Boolean']['output']>;
  days: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  openTime?: Maybe<Scalars['Time']['output']>;
};

export type RestaurantLocationDineInOpeningRange = OrderingRangeable & {
  __typename?: 'RestaurantLocationDineInOpeningRange';
  closeTime?: Maybe<Scalars['Time']['output']>;
  dayFriday?: Maybe<Scalars['Boolean']['output']>;
  dayMonday?: Maybe<Scalars['Boolean']['output']>;
  daySaturday?: Maybe<Scalars['Boolean']['output']>;
  daySunday?: Maybe<Scalars['Boolean']['output']>;
  dayThursday?: Maybe<Scalars['Boolean']['output']>;
  dayTuesday?: Maybe<Scalars['Boolean']['output']>;
  dayWednesday?: Maybe<Scalars['Boolean']['output']>;
  days: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  openTime?: Maybe<Scalars['Time']['output']>;
};

export type RestaurantLocationExternalIntegrationsSettingsInput = {
  shortIntegrationsNames: Scalars['Boolean']['input'];
  showModifierGroupName: Scalars['Boolean']['input'];
};

export type RestaurantLocationFeatureSetting = {
  __typename?: 'RestaurantLocationFeatureSetting';
  aiMarketingCalendarStatus: Scalars['String']['output'];
  billingBlockDeliveryStatus: Scalars['String']['output'];
  billingBlockDoordashStatus: Scalars['String']['output'];
  billingBlockPickupStatus: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAiMarketingCalendarEnabled: Scalars['Boolean']['output'];
  isBillingBlockDeliveryEnabled: Scalars['Boolean']['output'];
  isBillingBlockDoordashEnabled: Scalars['Boolean']['output'];
  isBillingBlockPickupEnabled: Scalars['Boolean']['output'];
  isUberDirectEnabled: Scalars['Boolean']['output'];
  uberDirectStatus: Scalars['String']['output'];
};

export type RestaurantLocationFeatureSettingInput = {
  aiMarketingCalendarStatus?: InputMaybe<Scalars['String']['input']>;
  billingBlockDeliveryStatus?: InputMaybe<Scalars['String']['input']>;
  billingBlockDoordashStatus?: InputMaybe<Scalars['String']['input']>;
  billingBlockPickupStatus?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  uberDirectStatus?: InputMaybe<Scalars['String']['input']>;
};

export type RestaurantLocationHolidayOpeningRange = {
  __typename?: 'RestaurantLocationHolidayOpeningRange';
  closeTime?: Maybe<Scalars['Time']['output']>;
  holidayDate: Scalars['DateTime']['output'];
  holidayName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locationId?: Maybe<Scalars['Int']['output']>;
  openTime?: Maybe<Scalars['Time']['output']>;
};

export type RestaurantLocationHolidayOpeningRangeInput = {
  closeTime?: InputMaybe<Scalars['Time']['input']>;
  holidayDate?: InputMaybe<Scalars['DateTime']['input']>;
  holidayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  openTime?: InputMaybe<Scalars['Time']['input']>;
};

export type RestaurantLocationInput = {
  allowReservations?: InputMaybe<Scalars['Boolean']['input']>;
  autoTextOnCurbsideArrival?: InputMaybe<Scalars['Boolean']['input']>;
  bagFeeAmount?: InputMaybe<Scalars['Decimal']['input']>;
  canToggleOrderingDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  canToggleOrderingDineIn?: InputMaybe<Scalars['Boolean']['input']>;
  cateringDaysInAdvanceCount?: InputMaybe<Scalars['Int']['input']>;
  cateringDeliveryAreaGeoJson?: InputMaybe<Scalars['JSON']['input']>;
  cateringDeliveryAreaType?: InputMaybe<Scalars['String']['input']>;
  cateringDeliveryCoverMinimumAmount?: InputMaybe<Scalars['Decimal']['input']>;
  cateringDeliveryFeeAmount?: InputMaybe<Scalars['Decimal']['input']>;
  cateringDeliveryFeeAmountType?: InputMaybe<Scalars['String']['input']>;
  cateringDeliveryFeeType?: InputMaybe<Scalars['String']['input']>;
  cateringDeliveryFees?: InputMaybe<Array<DeliveryFeeInput>>;
  cateringDeliveryMaxMenuItemCartSubtotal?: InputMaybe<Scalars['Decimal']['input']>;
  cateringDeliveryMinMenuItemCartSubtotal?: InputMaybe<Scalars['Decimal']['input']>;
  cateringDeliveryMinimumFeeAmount?: InputMaybe<Scalars['Decimal']['input']>;
  cateringDeliveryOpeningRanges?: InputMaybe<Array<RestaurantLocationOrderingOpeningRangeInput>>;
  cateringDeliveryRadiusMiles?: InputMaybe<Scalars['Decimal']['input']>;
  cateringDeliveryType?: InputMaybe<Scalars['String']['input']>;
  cateringDoorDashPickupInstructions?: InputMaybe<Scalars['String']['input']>;
  cateringDoordashFeeSubsidy?: InputMaybe<Scalars['Decimal']['input']>;
  cateringDoordashLargeOrderMin?: InputMaybe<Scalars['Decimal']['input']>;
  cateringFeeDisclaimer?: InputMaybe<Scalars['String']['input']>;
  cateringOrderingOpeningRanges?: InputMaybe<Array<RestaurantLocationOrderingOpeningRangeInput>>;
  cateringPickupMaxMenuItemCartSubtotal?: InputMaybe<Scalars['Decimal']['input']>;
  cateringPickupMinMenuItemCartSubtotal?: InputMaybe<Scalars['Decimal']['input']>;
  cateringUberDirectFeeSubsidy?: InputMaybe<Scalars['Decimal']['input']>;
  cateringUtensilsCheck?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customContentLinks?: InputMaybe<Array<RestaurantLocationCustomContentLinkInput>>;
  customDishTabContent?: InputMaybe<Scalars['String']['input']>;
  customDishTabName?: InputMaybe<Scalars['String']['input']>;
  customFormEmailCsv?: InputMaybe<Scalars['String']['input']>;
  customLat?: InputMaybe<Scalars['Decimal']['input']>;
  customLng?: InputMaybe<Scalars['Decimal']['input']>;
  customLocationContent?: InputMaybe<Scalars['String']['input']>;
  defaultCateringTipOption?: InputMaybe<Scalars['Int']['input']>;
  defaultDineInTabTip?: InputMaybe<Scalars['Decimal']['input']>;
  defaultOrderingEventTipOption?: InputMaybe<Scalars['Int']['input']>;
  defaultPickupDueMinutes?: InputMaybe<Scalars['Int']['input']>;
  defaultReservationPreference?: InputMaybe<Scalars['String']['input']>;
  defaultTipOption?: InputMaybe<Scalars['Int']['input']>;
  deliveryAreaGeoJson?: InputMaybe<Scalars['JSON']['input']>;
  deliveryAreaType?: InputMaybe<Scalars['String']['input']>;
  deliveryFees?: InputMaybe<Array<DeliveryFeeInput>>;
  deliveryOpeningRanges?: InputMaybe<Array<RestaurantLocationOrderingOpeningRangeInput>>;
  deliveryType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dineInInactiveTabAutoCloseTime?: InputMaybe<Scalars['Time']['input']>;
  dineInOpeningRanges?: InputMaybe<Array<RestaurantLocationOrderingOpeningRangeInput>>;
  dineInSkipPaymentAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  dineInTabActiveMinutes?: InputMaybe<Scalars['Int']['input']>;
  doordashFeeSubsidy?: InputMaybe<Scalars['Decimal']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  featureSetting?: InputMaybe<RestaurantLocationFeatureSettingInput>;
  firstDayOfWeek?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  hideTaxesAndTipsDisclaimersOnPickup?: InputMaybe<Scalars['Boolean']['input']>;
  holidayOpeningRanges?: InputMaybe<Array<RestaurantLocationHolidayOpeningRangeInput>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ignorePastDueInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  isBagFeeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isBillable?: InputMaybe<Scalars['Boolean']['input']>;
  isCateringDoordashLargeOrderFulfillmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isCateringPickupInStoreEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isCateringTipsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isCloverGuestImportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isCustomGooglePlaceId?: InputMaybe<Scalars['Boolean']['input']>;
  isGoogleOrderingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isLocationClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isLocationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isLocationSuspended?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingAutoAcceptEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingCateringDeliveryCoverMinimumEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingCateringDeliveryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingCateringDeliveryPlatformFeeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingCateringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingCateringPayOnPickupEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingCateringPickupPlatformFeeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingConsumerPlatformFeeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingDeliveryCoverMinimumEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingDeliveryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingDeliveryForCateringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingDeliveryPlatformFeeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingDineInAutoAcceptEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingDineInEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingDineInFeeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingDineInHideEmailFieldEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingDineInHideNameFieldEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingDineInHidePaymentStepEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingDineInHidePhoneNumberFieldEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingDineInPlatformFeeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingDineInRemoveTableLabelEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingEventPlatformFeeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingEventTipsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingFeeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingFeeTaxEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingHolidaysEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingMessagesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingMessagesForCateringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingPayOnPickupEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingScheduleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingSpecialInstructionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingTaxEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingTextMessagesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingTipsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPickupCurbsideEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPickupInStoreEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isSquareGuestImportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isSquarePaymentRequestButtonEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isStripePaymentRequestButtonEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isToastPaymentRequestButtonEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  largeOrderFulfillmentMinAmount?: InputMaybe<Scalars['Decimal']['input']>;
  locationLandingPageId?: InputMaybe<Scalars['Int']['input']>;
  menuLandingPageId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  openTableId?: InputMaybe<Scalars['String']['input']>;
  openTableReservationUrl?: InputMaybe<Scalars['String']['input']>;
  openTableSyncClientId?: InputMaybe<Scalars['String']['input']>;
  openTableSyncClientSecret?: InputMaybe<Scalars['String']['input']>;
  openingRanges?: InputMaybe<Array<RestaurantLocationOpeningRangeInput>>;
  orderInjectionType?: InputMaybe<Scalars['String']['input']>;
  orderTimeLaterOptionCustomLabel?: InputMaybe<Scalars['String']['input']>;
  orderTypePickupOptionCustomLabel?: InputMaybe<Scalars['String']['input']>;
  orderingDeliveryCoverMinimumAmount?: InputMaybe<Scalars['Decimal']['input']>;
  orderingDeliveryDriveTime?: InputMaybe<Scalars['Int']['input']>;
  orderingDeliveryFeeAmount?: InputMaybe<Scalars['Decimal']['input']>;
  orderingDeliveryFeeAmountType?: InputMaybe<Scalars['String']['input']>;
  orderingDeliveryFeeType?: InputMaybe<Scalars['String']['input']>;
  orderingDeliveryMaxMenuItemCartSubtotal?: InputMaybe<Scalars['Decimal']['input']>;
  orderingDeliveryMinMenuItemCartSubtotal?: InputMaybe<Scalars['Decimal']['input']>;
  orderingDeliveryMinimumFeeAmount?: InputMaybe<Scalars['Decimal']['input']>;
  orderingDeliveryOnboardingStatus?: InputMaybe<Scalars['String']['input']>;
  orderingDeliveryRadiusMiles?: InputMaybe<Scalars['Decimal']['input']>;
  orderingDineInFeePercent?: InputMaybe<Scalars['Decimal']['input']>;
  orderingDineInIntroText?: InputMaybe<Scalars['String']['input']>;
  orderingDineInTableNumberDescription?: InputMaybe<Scalars['String']['input']>;
  orderingDineInTableNumberLabel?: InputMaybe<Scalars['String']['input']>;
  orderingEventFeeDisclaimer?: InputMaybe<Scalars['String']['input']>;
  orderingEventUtensilsCheck?: InputMaybe<Scalars['Boolean']['input']>;
  orderingFeePercent?: InputMaybe<Scalars['Decimal']['input']>;
  orderingFeeTitle?: InputMaybe<Scalars['String']['input']>;
  orderingLandingPageId?: InputMaybe<Scalars['Int']['input']>;
  orderingOnboardingStatus?: InputMaybe<Scalars['String']['input']>;
  orderingOpeningRanges?: InputMaybe<Array<RestaurantLocationOrderingOpeningRangeInput>>;
  orderingPaymentMessage?: InputMaybe<Scalars['String']['input']>;
  orderingPickupMaxMenuItemCartSubtotal?: InputMaybe<Scalars['Decimal']['input']>;
  orderingPickupMinMenuItemCartSubtotal?: InputMaybe<Scalars['Decimal']['input']>;
  orderingTaxPercent?: InputMaybe<Scalars['Decimal']['input']>;
  orderingUtensilsCheck?: InputMaybe<Scalars['Boolean']['input']>;
  pauseUntil?: InputMaybe<Scalars['DateTime']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  photoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  pickupCurbsideCustomLabel?: InputMaybe<Scalars['String']['input']>;
  pickupCurbsideDelayFifteenText?: InputMaybe<Scalars['String']['input']>;
  pickupCurbsideDelayFiveText?: InputMaybe<Scalars['String']['input']>;
  pickupCurbsideDelayTenText?: InputMaybe<Scalars['String']['input']>;
  pickupCurbsideDescription?: InputMaybe<Scalars['String']['input']>;
  pickupCurbsidePhone?: InputMaybe<Scalars['String']['input']>;
  pickupCurbsideReplyText?: InputMaybe<Scalars['String']['input']>;
  pickupInStoreCustomLabel?: InputMaybe<Scalars['String']['input']>;
  pickupInStoreDescription?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  publishingName?: InputMaybe<Scalars['String']['input']>;
  reservationsLandingPageId?: InputMaybe<Scalars['Int']['input']>;
  reservationsOpeningRanges?: InputMaybe<Array<RestaurantLocationReservationsOpeningRangeInput>>;
  resyApiKey?: InputMaybe<Scalars['String']['input']>;
  resyLinkUrl?: InputMaybe<Scalars['String']['input']>;
  resyVenueId?: InputMaybe<Scalars['Int']['input']>;
  showCurbsideVehicleInputs?: InputMaybe<Scalars['Boolean']['input']>;
  showLocationPhotoInLocationSearch?: InputMaybe<Scalars['Boolean']['input']>;
  showLocationPhotoInLocationSection?: InputMaybe<Scalars['Boolean']['input']>;
  standardDaysInAdvanceCount?: InputMaybe<Scalars['Int']['input']>;
  standardDoorDashPickupInstructions?: InputMaybe<Scalars['String']['input']>;
  standardFeeDisclaimer?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  uberDirectFeeSubsidy?: InputMaybe<Scalars['Decimal']['input']>;
  useCurbsidePhone?: InputMaybe<Scalars['Boolean']['input']>;
  useLocationOpeningHours?: InputMaybe<Scalars['Boolean']['input']>;
  useLocationOpeningHoursForCatering?: InputMaybe<Scalars['Boolean']['input']>;
  useLocationOpeningHoursForCateringDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  useLocationOpeningHoursForDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  useLocationOpeningHoursForDineIn?: InputMaybe<Scalars['Boolean']['input']>;
  useLocationOpeningHoursForReservations?: InputMaybe<Scalars['Boolean']['input']>;
  yelpFriendlyId?: InputMaybe<Scalars['String']['input']>;
  yelpReservationUrl?: InputMaybe<Scalars['String']['input']>;
};

export type RestaurantLocationMicrosSetting = {
  __typename?: 'RestaurantLocationMicrosSetting';
  id: Scalars['Int']['output'];
  microsCreditCardTenderId?: Maybe<Scalars['Int']['output']>;
  microsDeliveryServiceChargeId?: Maybe<Scalars['Int']['output']>;
  microsDiscountId?: Maybe<Scalars['Int']['output']>;
  microsEmployeeRefId?: Maybe<Scalars['Int']['output']>;
  microsFeeServiceChargeId?: Maybe<Scalars['Int']['output']>;
  microsOrderTypeDeliveryId?: Maybe<Scalars['Int']['output']>;
  microsOrderTypeDineInId?: Maybe<Scalars['Int']['output']>;
  microsOrderTypeTakeOutId?: Maybe<Scalars['Int']['output']>;
};

export type RestaurantLocationNcrSilverStoreSetting = {
  __typename?: 'RestaurantLocationNcrSilverStoreSetting';
  accountType: Scalars['String']['output'];
  chargeOptionAdditionalFee?: Maybe<NcrSilverItem>;
  chargeOptionDeliveryFee?: Maybe<NcrSilverItem>;
  chargeOptionPopmenuFee?: Maybe<NcrSilverItem>;
  id: Scalars['Int']['output'];
  isAllChargeOptionsSet: Scalars['Boolean']['output'];
  ncrPaymentAccount?: Maybe<NcrPaymentAccount>;
  ncrPaymentStoreNumber?: Maybe<Scalars['String']['output']>;
  offerDiscountAmount?: Maybe<NcrSilverDiscount>;
  offerDiscountPercent?: Maybe<NcrSilverDiscount>;
};

export type RestaurantLocationOpeningRange = OrderingRangeable & {
  __typename?: 'RestaurantLocationOpeningRange';
  additionalHoursContent?: Maybe<Scalars['String']['output']>;
  closeTime?: Maybe<Scalars['Time']['output']>;
  dayFriday?: Maybe<Scalars['Boolean']['output']>;
  dayMonday?: Maybe<Scalars['Boolean']['output']>;
  daySaturday?: Maybe<Scalars['Boolean']['output']>;
  daySunday?: Maybe<Scalars['Boolean']['output']>;
  dayThursday?: Maybe<Scalars['Boolean']['output']>;
  dayTuesday?: Maybe<Scalars['Boolean']['output']>;
  dayWednesday?: Maybe<Scalars['Boolean']['output']>;
  days: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  openAllDay?: Maybe<Scalars['Boolean']['output']>;
  openTime?: Maybe<Scalars['Time']['output']>;
  untilClose?: Maybe<Scalars['Boolean']['output']>;
};

export type RestaurantLocationOpeningRangeInput = {
  additionalHoursContent?: InputMaybe<Scalars['String']['input']>;
  closeTime?: InputMaybe<Scalars['Time']['input']>;
  dayFriday?: InputMaybe<Scalars['Boolean']['input']>;
  dayMonday?: InputMaybe<Scalars['Boolean']['input']>;
  daySaturday?: InputMaybe<Scalars['Boolean']['input']>;
  daySunday?: InputMaybe<Scalars['Boolean']['input']>;
  dayThursday?: InputMaybe<Scalars['Boolean']['input']>;
  dayTuesday?: InputMaybe<Scalars['Boolean']['input']>;
  dayWednesday?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  openAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  openTime?: InputMaybe<Scalars['Time']['input']>;
  untilClose?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RestaurantLocationOrderingBillingConfig = {
  __typename?: 'RestaurantLocationOrderingBillingConfig';
  availableBillingBankAccounts: Array<BillingBankAccount>;
  availableBillingCreditCards: Array<BillingCreditCard>;
  billingBankAccount?: Maybe<BillingBankAccount>;
  billingBankAccountId?: Maybe<Scalars['Int']['output']>;
  billingCreditCard?: Maybe<BillingCreditCard>;
  billingCreditCardId?: Maybe<Scalars['Int']['output']>;
  billingCustomerId?: Maybe<Scalars['Int']['output']>;
  billingDay: Scalars['String']['output'];
  billingFrequency: Scalars['String']['output'];
  hasBillingCustomer: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isProcessRunning: Scalars['Boolean']['output'];
  lastProcessError?: Maybe<Scalars['String']['output']>;
  policy: OrderingBillingConfigPolicy;
};

export type RestaurantLocationOrderingBillingConfigInput = {
  billingBankAccountId?: InputMaybe<Scalars['Int']['input']>;
  billingCreditCardId?: InputMaybe<Scalars['Int']['input']>;
  billingDay?: InputMaybe<Scalars['String']['input']>;
  billingFrequency?: InputMaybe<Scalars['String']['input']>;
};

export type RestaurantLocationOrderingInput = {
  id: Scalars['Int']['input'];
  orderingTaxPercent?: InputMaybe<Scalars['Decimal']['input']>;
};

export type RestaurantLocationOrderingOpeningRange = OrderingRangeable & {
  __typename?: 'RestaurantLocationOrderingOpeningRange';
  closeTime?: Maybe<Scalars['Time']['output']>;
  dayFriday?: Maybe<Scalars['Boolean']['output']>;
  dayMonday?: Maybe<Scalars['Boolean']['output']>;
  daySaturday?: Maybe<Scalars['Boolean']['output']>;
  daySunday?: Maybe<Scalars['Boolean']['output']>;
  dayThursday?: Maybe<Scalars['Boolean']['output']>;
  dayTuesday?: Maybe<Scalars['Boolean']['output']>;
  dayWednesday?: Maybe<Scalars['Boolean']['output']>;
  days: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  openTime?: Maybe<Scalars['Time']['output']>;
};

export type RestaurantLocationOrderingOpeningRangeInput = {
  closeTime?: InputMaybe<Scalars['Time']['input']>;
  dayFriday?: InputMaybe<Scalars['Boolean']['input']>;
  dayMonday?: InputMaybe<Scalars['Boolean']['input']>;
  daySaturday?: InputMaybe<Scalars['Boolean']['input']>;
  daySunday?: InputMaybe<Scalars['Boolean']['input']>;
  dayThursday?: InputMaybe<Scalars['Boolean']['input']>;
  dayTuesday?: InputMaybe<Scalars['Boolean']['input']>;
  dayWednesday?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  openAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  openTime?: InputMaybe<Scalars['Time']['input']>;
};

export type RestaurantLocationOrdernerdTokenReceivedReturn = {
  __typename?: 'RestaurantLocationOrdernerdTokenReceivedReturn';
  ordernerdUrl: Scalars['String']['output'];
};

export type RestaurantLocationPaginationHandler = {
  __typename?: 'RestaurantLocationPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<RestaurantLocation>;
};

export type RestaurantLocationReservationsOpeningRange = OrderingRangeable & {
  __typename?: 'RestaurantLocationReservationsOpeningRange';
  closeTime?: Maybe<Scalars['Time']['output']>;
  dayFriday?: Maybe<Scalars['Boolean']['output']>;
  dayMonday?: Maybe<Scalars['Boolean']['output']>;
  daySaturday?: Maybe<Scalars['Boolean']['output']>;
  daySunday?: Maybe<Scalars['Boolean']['output']>;
  dayThursday?: Maybe<Scalars['Boolean']['output']>;
  dayTuesday?: Maybe<Scalars['Boolean']['output']>;
  dayWednesday?: Maybe<Scalars['Boolean']['output']>;
  days: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  openAllDay?: Maybe<Scalars['Boolean']['output']>;
  openTime?: Maybe<Scalars['Time']['output']>;
  tableTops?: Maybe<Array<RestaurantLocationReservationsOpeningRangeTableTop>>;
  turnTime: Scalars['Int']['output'];
};

export type RestaurantLocationReservationsOpeningRangeInput = {
  closeTime?: InputMaybe<Scalars['Time']['input']>;
  dayFriday?: InputMaybe<Scalars['Boolean']['input']>;
  dayMonday?: InputMaybe<Scalars['Boolean']['input']>;
  daySaturday?: InputMaybe<Scalars['Boolean']['input']>;
  daySunday?: InputMaybe<Scalars['Boolean']['input']>;
  dayThursday?: InputMaybe<Scalars['Boolean']['input']>;
  dayTuesday?: InputMaybe<Scalars['Boolean']['input']>;
  dayWednesday?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  openAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  openTime?: InputMaybe<Scalars['Time']['input']>;
  tableTops?: InputMaybe<Array<ReservationsOpeningRangeTableTopInput>>;
  turnTime?: InputMaybe<Scalars['Int']['input']>;
};

export type RestaurantLocationReservationsOpeningRangeTableTop = {
  __typename?: 'RestaurantLocationReservationsOpeningRangeTableTop';
  id: Scalars['Int']['output'];
  reservationsOpeningRange: RestaurantLocationReservationsOpeningRange;
  tableTop: RestaurantLocationTableTop;
  turnTime?: Maybe<Scalars['Int']['output']>;
};

export type RestaurantLocationSocialHandle = {
  __typename?: 'RestaurantLocationSocialHandle';
  id: Scalars['Int']['output'];
  locationId?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  socialType: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type RestaurantLocationSocialHandleInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  socialType: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type RestaurantLocationTableTop = {
  __typename?: 'RestaurantLocationTableTop';
  id: Scalars['Int']['output'];
  maxOccupancy: Scalars['Int']['output'];
  minOccupancy: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type RestaurantLocationTicketSaleSetting = {
  __typename?: 'RestaurantLocationTicketSaleSetting';
  defaultPaymentMethod?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isPaymentEnabled: Scalars['Boolean']['output'];
  isPlatformFeeEnabled: Scalars['Boolean']['output'];
  isSquarePayment: Scalars['Boolean']['output'];
  isSquarePaymentAvailable: Scalars['Boolean']['output'];
  isStripePayment: Scalars['Boolean']['output'];
  isStripePaymentAvailable: Scalars['Boolean']['output'];
  salesTaxPercent: Scalars['Float']['output'];
  squareApplicationId?: Maybe<Scalars['String']['output']>;
  squareLocationId?: Maybe<Scalars['String']['output']>;
  squareSellerAccount?: Maybe<SquareSellerAccount>;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  stripeAccountType?: Maybe<Scalars['String']['output']>;
  stripeConnectAccount?: Maybe<StripeConnectAccount>;
  stripePublishableKey?: Maybe<Scalars['String']['output']>;
};

export type RestaurantLocationToastSetting = {
  __typename?: 'RestaurantLocationToastSetting';
  deliveryDueSynced: Scalars['Boolean']['output'];
  deliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  diningOptionCurbside?: Maybe<ToastDiningOption>;
  diningOptionDelivery?: Maybe<ToastDiningOption>;
  diningOptionDineIn?: Maybe<ToastDiningOption>;
  diningOptionTakeOut?: Maybe<ToastDiningOption>;
  dueSynced: Scalars['Boolean']['output'];
  externalPaymentMethodUid?: Maybe<Scalars['String']['output']>;
  giftCardPaymentType?: Maybe<ToastAlternativePaymentType>;
  id: Scalars['Int']['output'];
  isAllDiningOptionsSet: Scalars['Boolean']['output'];
  isDueAtMappingEnabled: Scalars['Boolean']['output'];
  isOrderingScheduleMappingEnabled: Scalars['Boolean']['output'];
  isPhotoSyncEnabled: Scalars['Boolean']['output'];
  orderingOpeningRangesSynced: Scalars['Boolean']['output'];
  pickupDueSynced: Scalars['Boolean']['output'];
  revenueCenterDelivery?: Maybe<ToastRevenueCenter>;
  revenueCenterPickup?: Maybe<ToastRevenueCenter>;
  toastAlternativePaymentType?: Maybe<ToastAlternativePaymentType>;
};

export type RestaurantLocationVersion = Versionable & {
  __typename?: 'RestaurantLocationVersion';
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  locationMenuName?: Maybe<Scalars['String']['output']>;
  objectChanges: Array<VersionDiff>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

export type RestaurantLocationsCount = {
  __typename?: 'RestaurantLocationsCount';
  activeLocationsCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  locationsCount: Scalars['Int']['output'];
};

export type RestaurantLocationsExternalIntegrationsSettings = {
  __typename?: 'RestaurantLocationsExternalIntegrationsSettings';
  id?: Maybe<Scalars['Int']['output']>;
  shortIntegrationsNames: Scalars['Boolean']['output'];
  showModifierGroupName: Scalars['Boolean']['output'];
};

export type RestaurantLogosInput = {
  faviconUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  footerLogoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  logoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  mailerDarkThemeLogoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  mailerLogoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  orderingFooterLogoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  orderingLogoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  photoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  qrCardLogoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  signUpBackgroundImageUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  vipLogoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
};

export type RestaurantMember = {
  __typename?: 'RestaurantMember';
  aiAutoResponseBannerRecentlyDismissed: Scalars['Boolean']['output'];
  aiReviewResponseUpsellBannerRecentlyDismissed: Scalars['Boolean']['output'];
  canManageAiMarketing?: Maybe<Scalars['Boolean']['output']>;
  canManageAnnouncements?: Maybe<Scalars['Boolean']['output']>;
  canManageAnswering?: Maybe<Scalars['Boolean']['output']>;
  canManageAnyLocationAnswering: Scalars['Boolean']['output'];
  canManageAnyLocationCalendarEvents: Scalars['Boolean']['output'];
  canManageAnyLocationFeedback: Scalars['Boolean']['output'];
  canManageAnyLocationMessages: Scalars['Boolean']['output'];
  canManageAnyLocationOrderSettings: Scalars['Boolean']['output'];
  canManageAnyLocationOrders: Scalars['Boolean']['output'];
  canManageAnyLocationReservations: Scalars['Boolean']['output'];
  canManageAnyLocationReviewSettings: Scalars['Boolean']['output'];
  canManageAnyLocationReviews: Scalars['Boolean']['output'];
  canManageAnyLocationWaitlists: Scalars['Boolean']['output'];
  canManageBillingAccounts?: Maybe<Scalars['Boolean']['output']>;
  canManageCalendarEvents: Scalars['Boolean']['output'];
  canManageCampaignConsolidation: Scalars['Boolean']['output'];
  canManageCustomFiles?: Maybe<Scalars['Boolean']['output']>;
  canManageDishes?: Maybe<Scalars['Boolean']['output']>;
  canManageFeedback?: Maybe<Scalars['Boolean']['output']>;
  canManageGiftCards?: Maybe<Scalars['Boolean']['output']>;
  canManageItemList?: Maybe<Scalars['Boolean']['output']>;
  canManageLoyalty?: Maybe<Scalars['Boolean']['output']>;
  canManageMessages?: Maybe<Scalars['Boolean']['output']>;
  canManageOffers?: Maybe<Scalars['Boolean']['output']>;
  canManageOrderSettings?: Maybe<Scalars['Boolean']['output']>;
  canManageOrders?: Maybe<Scalars['Boolean']['output']>;
  canManageRefunds?: Maybe<Scalars['Boolean']['output']>;
  canManageReservations?: Maybe<Scalars['Boolean']['output']>;
  canManageReviewSettings?: Maybe<Scalars['Boolean']['output']>;
  canManageReviews?: Maybe<Scalars['Boolean']['output']>;
  canManageSocialPosts?: Maybe<Scalars['Boolean']['output']>;
  canManageThemes?: Maybe<Scalars['Boolean']['output']>;
  canManageWaitlists?: Maybe<Scalars['Boolean']['output']>;
  canManageYextIntegration?: Maybe<Scalars['Boolean']['output']>;
  canReceiveAnyLocationFormNotifications: Scalars['Boolean']['output'];
  canViewBillingAccounts?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  engagementOffersDismissedAt: Scalars['DateTime']['output'];
  formEmailNotifications: Scalars['Boolean']['output'];
  formPushNotifications: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  invitedByUserDisplayName?: Maybe<Scalars['String']['output']>;
  isAuthyEnabled: Scalars['Boolean']['output'];
  lastOrderingSummarySentAt?: Maybe<Scalars['DateTime']['output']>;
  locationGroups?: Maybe<Array<Array<Scalars['Int']['output']>>>;
  locations: Array<RestaurantMemberLocation>;
  memberLevel: Scalars['String']['output'];
  onboardingCompleted?: Maybe<Scalars['Boolean']['output']>;
  onboardingCompletionDismissed?: Maybe<Scalars['Boolean']['output']>;
  onboardingLaunchDismissed?: Maybe<Scalars['Boolean']['output']>;
  onboardingWelcomeDismissed?: Maybe<Scalars['Boolean']['output']>;
  orderEmailNotifications: Scalars['Boolean']['output'];
  orderPushNotifications: Scalars['Boolean']['output'];
  orderTextNotifications: Scalars['Boolean']['output'];
  receiveAimEmailNotifications?: Maybe<Scalars['Boolean']['output']>;
  receiveFormNotifications?: Maybe<Scalars['Boolean']['output']>;
  receiveOnboardingAppNotifications?: Maybe<Scalars['Boolean']['output']>;
  receiveOnboardingEmailNotifications?: Maybe<Scalars['Boolean']['output']>;
  receiveOnboardingSmsNotifications?: Maybe<Scalars['Boolean']['output']>;
  receivePerformanceSnapshotNotifications?: Maybe<Scalars['Boolean']['output']>;
  receiveRoiAlertAppNotifications?: Maybe<Scalars['Boolean']['output']>;
  receiveRoiAlertSmsNotifications?: Maybe<Scalars['Boolean']['output']>;
  restaurant: Restaurant;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  reviewEmailNotifications: Scalars['Boolean']['output'];
  reviewPushNotifications: Scalars['Boolean']['output'];
  reviewTextNotifications: Scalars['Boolean']['output'];
  showEngagementOffersBanner: Scalars['Boolean']['output'];
  tasksNotificationFrequency?: Maybe<Scalars['String']['output']>;
  user: User;
  userId?: Maybe<Scalars['Int']['output']>;
  userSelectedRole?: Maybe<Scalars['String']['output']>;
  voicemailEmailNotifications: Scalars['Boolean']['output'];
  voicemailPushNotifications: Scalars['Boolean']['output'];
  voicemailTextNotifications: Scalars['Boolean']['output'];
  yextUpsellBannerRecentlyDismissed: Scalars['Boolean']['output'];
};

export type RestaurantMemberAlert = {
  __typename?: 'RestaurantMemberAlert';
  alertType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isPush: Scalars['Boolean']['output'];
  isSms: Scalars['Boolean']['output'];
  memberId: Scalars['Int']['output'];
  pushContent?: Maybe<Scalars['String']['output']>;
  pushTitle?: Maybe<Scalars['String']['output']>;
  restaurantId: Scalars['Int']['output'];
  smsContent?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Int']['output'];
  webContent?: Maybe<Scalars['String']['output']>;
  webTitle?: Maybe<Scalars['String']['output']>;
};

export type RestaurantMemberClientProfile = {
  __typename?: 'RestaurantMemberClientProfile';
  attire?: Maybe<Scalars['String']['output']>;
  businessGoals?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  otherGoals?: Maybe<Scalars['String']['output']>;
  otherRole?: Maybe<Scalars['String']['output']>;
  priceRange?: Maybe<Scalars['Int']['output']>;
  restaurantCategory?: Maybe<Scalars['String']['output']>;
  serviceType?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RestaurantMemberClientProfileInput = {
  attire: Scalars['String']['input'];
  businessGoals: Array<Scalars['String']['input']>;
  otherGoals: Scalars['String']['input'];
  otherRole: Scalars['String']['input'];
  priceRange: Scalars['Int']['input'];
  restaurantCategory: Scalars['String']['input'];
  serviceType: Scalars['String']['input'];
};

export type RestaurantMemberInput = {
  canManageAiMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  canManageAnnouncements?: InputMaybe<Scalars['Boolean']['input']>;
  canManageAnswering?: InputMaybe<Scalars['Boolean']['input']>;
  canManageBillingAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  canManageCalendarEvents?: InputMaybe<Scalars['Boolean']['input']>;
  canManageCustomFiles?: InputMaybe<Scalars['Boolean']['input']>;
  canManageDishes?: InputMaybe<Scalars['Boolean']['input']>;
  canManageFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  canManageGiftCards?: InputMaybe<Scalars['Boolean']['input']>;
  canManageItemList?: InputMaybe<Scalars['Boolean']['input']>;
  canManageLoyalty?: InputMaybe<Scalars['Boolean']['input']>;
  canManageMessages?: InputMaybe<Scalars['Boolean']['input']>;
  canManageOffers?: InputMaybe<Scalars['Boolean']['input']>;
  canManageOrderSettings?: InputMaybe<Scalars['Boolean']['input']>;
  canManageOrders?: InputMaybe<Scalars['Boolean']['input']>;
  canManageRefunds?: InputMaybe<Scalars['Boolean']['input']>;
  canManageReservations?: InputMaybe<Scalars['Boolean']['input']>;
  canManageReviewSettings?: InputMaybe<Scalars['Boolean']['input']>;
  canManageReviews?: InputMaybe<Scalars['Boolean']['input']>;
  canManageSocialPosts?: InputMaybe<Scalars['Boolean']['input']>;
  canManageThemes?: InputMaybe<Scalars['Boolean']['input']>;
  canManageWaitlists?: InputMaybe<Scalars['Boolean']['input']>;
  canManageYextIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  canViewBillingAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  formPushNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locationGroups?: InputMaybe<Array<Array<Scalars['Int']['input']>>>;
  locations?: InputMaybe<Array<RestaurantMemberLocationInput>>;
  memberLevel?: InputMaybe<Scalars['String']['input']>;
  receiveAimEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receiveFormNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receiveOnboardingAppNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receiveOnboardingEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receiveOnboardingSmsNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receivePerformanceSnapshotNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receiveRoiAlertAppNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receiveRoiAlertSmsNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  reviewEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  reviewPushNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  tasksNotificationFrequency?: InputMaybe<Scalars['String']['input']>;
};

export type RestaurantMemberInvite = {
  __typename?: 'RestaurantMemberInvite';
  bounced?: Maybe<Scalars['Boolean']['output']>;
  bouncedAt?: Maybe<Scalars['DateTime']['output']>;
  canManageAiMarketing?: Maybe<Scalars['Boolean']['output']>;
  canManageAnnouncements?: Maybe<Scalars['Boolean']['output']>;
  canManageAnswering?: Maybe<Scalars['Boolean']['output']>;
  canManageBillingAccounts: Scalars['Boolean']['output'];
  canManageCalendarEvents: Scalars['Boolean']['output'];
  canManageCustomFiles?: Maybe<Scalars['Boolean']['output']>;
  canManageDishes?: Maybe<Scalars['Boolean']['output']>;
  canManageFeedback?: Maybe<Scalars['Boolean']['output']>;
  canManageGiftCards?: Maybe<Scalars['Boolean']['output']>;
  canManageItemList?: Maybe<Scalars['Boolean']['output']>;
  canManageLoyalty?: Maybe<Scalars['Boolean']['output']>;
  canManageMessages?: Maybe<Scalars['Boolean']['output']>;
  canManageOffers?: Maybe<Scalars['Boolean']['output']>;
  canManageOrderSettings?: Maybe<Scalars['Boolean']['output']>;
  canManageOrders?: Maybe<Scalars['Boolean']['output']>;
  canManageRefunds?: Maybe<Scalars['Boolean']['output']>;
  canManageReservations?: Maybe<Scalars['Boolean']['output']>;
  canManageReviewSettings?: Maybe<Scalars['Boolean']['output']>;
  canManageReviews?: Maybe<Scalars['Boolean']['output']>;
  canManageSocialPosts?: Maybe<Scalars['Boolean']['output']>;
  canManageThemes?: Maybe<Scalars['Boolean']['output']>;
  canManageWaitlists?: Maybe<Scalars['Boolean']['output']>;
  canManageYextIntegration?: Maybe<Scalars['Boolean']['output']>;
  canViewBillingAccounts: Scalars['Boolean']['output'];
  clicked?: Maybe<Scalars['Boolean']['output']>;
  clickedAt?: Maybe<Scalars['DateTime']['output']>;
  delivered?: Maybe<Scalars['Boolean']['output']>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  emailExists: Scalars['Boolean']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  formEmailNotifications: Scalars['Boolean']['output'];
  formPushNotifications: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  inviteUrl?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastOrderingSummarySentAt?: Maybe<Scalars['DateTime']['output']>;
  locationGroups?: Maybe<Array<Array<Scalars['Int']['output']>>>;
  locations: Array<RestaurantMemberInviteLocation>;
  memberLevel: Scalars['String']['output'];
  opened?: Maybe<Scalars['Boolean']['output']>;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  orderEmailNotifications: Scalars['Boolean']['output'];
  orderPushNotifications: Scalars['Boolean']['output'];
  orderTextNotifications: Scalars['Boolean']['output'];
  receiveAimEmailNotifications?: Maybe<Scalars['Boolean']['output']>;
  receiveFormNotifications?: Maybe<Scalars['Boolean']['output']>;
  receiveOnboardingAppNotifications?: Maybe<Scalars['Boolean']['output']>;
  receiveOnboardingEmailNotifications?: Maybe<Scalars['Boolean']['output']>;
  receiveOnboardingSmsNotifications?: Maybe<Scalars['Boolean']['output']>;
  receivePerformanceSnapshotNotifications?: Maybe<Scalars['Boolean']['output']>;
  receiveRoiAlertAppNotifications?: Maybe<Scalars['Boolean']['output']>;
  receiveRoiAlertSmsNotifications?: Maybe<Scalars['Boolean']['output']>;
  restaurant: Restaurant;
  reviewEmailNotifications: Scalars['Boolean']['output'];
  reviewPushNotifications: Scalars['Boolean']['output'];
  reviewTextNotifications: Scalars['Boolean']['output'];
  tasksNotificationFrequency?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  unsubscribed?: Maybe<Scalars['Boolean']['output']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']['output']>;
  voicemailEmailNotifications: Scalars['Boolean']['output'];
  voicemailPushNotifications: Scalars['Boolean']['output'];
  voicemailTextNotifications: Scalars['Boolean']['output'];
};

export type RestaurantMemberInviteInput = {
  canManageAiMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  canManageAnnouncements?: InputMaybe<Scalars['Boolean']['input']>;
  canManageAnswering?: InputMaybe<Scalars['Boolean']['input']>;
  canManageBillingAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  canManageCalendarEvents?: InputMaybe<Scalars['Boolean']['input']>;
  canManageCustomFiles?: InputMaybe<Scalars['Boolean']['input']>;
  canManageDishes?: InputMaybe<Scalars['Boolean']['input']>;
  canManageFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  canManageGiftCards?: InputMaybe<Scalars['Boolean']['input']>;
  canManageItemList?: InputMaybe<Scalars['Boolean']['input']>;
  canManageLoyalty?: InputMaybe<Scalars['Boolean']['input']>;
  canManageMessages?: InputMaybe<Scalars['Boolean']['input']>;
  canManageOffers?: InputMaybe<Scalars['Boolean']['input']>;
  canManageOrderSettings?: InputMaybe<Scalars['Boolean']['input']>;
  canManageOrders?: InputMaybe<Scalars['Boolean']['input']>;
  canManageRefunds?: InputMaybe<Scalars['Boolean']['input']>;
  canManageReservations?: InputMaybe<Scalars['Boolean']['input']>;
  canManageReviewSettings?: InputMaybe<Scalars['Boolean']['input']>;
  canManageReviews?: InputMaybe<Scalars['Boolean']['input']>;
  canManageSocialPosts?: InputMaybe<Scalars['Boolean']['input']>;
  canManageThemes?: InputMaybe<Scalars['Boolean']['input']>;
  canManageWaitlists?: InputMaybe<Scalars['Boolean']['input']>;
  canManageYextIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  canViewBillingAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  formEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  formPushNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  locationGroups?: InputMaybe<Array<Array<Scalars['Int']['input']>>>;
  locations?: InputMaybe<Array<RestaurantMemberInviteLocationInput>>;
  memberLevel: Scalars['String']['input'];
  receiveAimEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receiveFormNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receiveOnboardingAppNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receiveOnboardingEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receiveOnboardingSmsNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receivePerformanceSnapshotNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receiveRoiAlertAppNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receiveRoiAlertSmsNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  reviewEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  reviewPushNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  tasksNotificationFrequency?: InputMaybe<Scalars['String']['input']>;
};

export type RestaurantMemberInviteLocation = {
  __typename?: 'RestaurantMemberInviteLocation';
  canManageAnswering: Scalars['Boolean']['output'];
  canManageBillingAccounts: Scalars['Boolean']['output'];
  canManageCalendarEvents: Scalars['Boolean']['output'];
  canManageFeedback?: Maybe<Scalars['Boolean']['output']>;
  canManageGiftCards: Scalars['Boolean']['output'];
  canManageLoyalty?: Maybe<Scalars['Boolean']['output']>;
  canManageMessages: Scalars['Boolean']['output'];
  canManageOffers: Scalars['Boolean']['output'];
  canManageOrderSettings: Scalars['Boolean']['output'];
  canManageOrders: Scalars['Boolean']['output'];
  canManageRefunds: Scalars['Boolean']['output'];
  canManageReservations: Scalars['Boolean']['output'];
  canManageReviewSettings: Scalars['Boolean']['output'];
  canManageReviews: Scalars['Boolean']['output'];
  canManageSocialPosts: Scalars['Boolean']['output'];
  canManageWaitlists: Scalars['Boolean']['output'];
  canViewBillingAccounts: Scalars['Boolean']['output'];
  formEmailNotifications: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  lastOrderingSummarySentAt?: Maybe<Scalars['DateTime']['output']>;
  location: RestaurantLocation;
  locationId: Scalars['Int']['output'];
  member: RestaurantMember;
  memberLevel?: Maybe<Scalars['String']['output']>;
  orderEmailNotifications: Scalars['Boolean']['output'];
  orderPushNotifications: Scalars['Boolean']['output'];
  orderTextNotifications: Scalars['Boolean']['output'];
  reviewEmailNotifications: Scalars['Boolean']['output'];
  reviewPushNotifications: Scalars['Boolean']['output'];
  reviewTextNotifications: Scalars['Boolean']['output'];
  voicemailEmailNotifications: Scalars['Boolean']['output'];
  voicemailPushNotifications: Scalars['Boolean']['output'];
  voicemailTextNotifications: Scalars['Boolean']['output'];
};

export type RestaurantMemberInviteLocationInput = {
  canManageAnswering?: InputMaybe<Scalars['Boolean']['input']>;
  canManageBillingAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  canManageCalendarEvents?: InputMaybe<Scalars['Boolean']['input']>;
  canManageFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  canManageMessages?: InputMaybe<Scalars['Boolean']['input']>;
  canManageOrderSettings?: InputMaybe<Scalars['Boolean']['input']>;
  canManageOrders?: InputMaybe<Scalars['Boolean']['input']>;
  canManageRefunds?: InputMaybe<Scalars['Boolean']['input']>;
  canManageReservations?: InputMaybe<Scalars['Boolean']['input']>;
  canManageReviewSettings?: InputMaybe<Scalars['Boolean']['input']>;
  canManageReviews?: InputMaybe<Scalars['Boolean']['input']>;
  canManageWaitlists?: InputMaybe<Scalars['Boolean']['input']>;
  canViewBillingAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  formEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
  memberLevel: Scalars['String']['input'];
  reviewEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  reviewPushNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RestaurantMemberLocation = {
  __typename?: 'RestaurantMemberLocation';
  canManageAnswering: Scalars['Boolean']['output'];
  canManageBillingAccounts?: Maybe<Scalars['Boolean']['output']>;
  canManageCalendarEvents: Scalars['Boolean']['output'];
  canManageFeedback?: Maybe<Scalars['Boolean']['output']>;
  canManageGiftCards: Scalars['Boolean']['output'];
  canManageLoyalty?: Maybe<Scalars['Boolean']['output']>;
  canManageMessages: Scalars['Boolean']['output'];
  canManageOffers: Scalars['Boolean']['output'];
  canManageOrderSettings: Scalars['Boolean']['output'];
  canManageOrders: Scalars['Boolean']['output'];
  canManageRefunds: Scalars['Boolean']['output'];
  canManageReservations: Scalars['Boolean']['output'];
  canManageReviewSettings: Scalars['Boolean']['output'];
  canManageReviews: Scalars['Boolean']['output'];
  canManageSocialPosts: Scalars['Boolean']['output'];
  canManageWaitlists: Scalars['Boolean']['output'];
  canViewBillingAccounts?: Maybe<Scalars['Boolean']['output']>;
  cateringEmailNotifications: Scalars['Boolean']['output'];
  cateringPushNotifications: Scalars['Boolean']['output'];
  cateringTextNotifications: Scalars['Boolean']['output'];
  formEmailNotifications: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  lastOrderingSummarySentAt?: Maybe<Scalars['DateTime']['output']>;
  location: RestaurantLocation;
  locationId: Scalars['Int']['output'];
  member: RestaurantMember;
  memberLevel?: Maybe<Scalars['String']['output']>;
  orderEmailNotifications: Scalars['Boolean']['output'];
  orderPushNotifications: Scalars['Boolean']['output'];
  orderTextNotifications: Scalars['Boolean']['output'];
  orderingEventsEmailNotifications: Scalars['Boolean']['output'];
  orderingEventsPushNotifications: Scalars['Boolean']['output'];
  orderingEventsTextNotifications: Scalars['Boolean']['output'];
  orderingSummaryEmailNotifications: Scalars['Boolean']['output'];
  reviewEmailNotifications: Scalars['Boolean']['output'];
  reviewPushNotifications: Scalars['Boolean']['output'];
  reviewTextNotifications: Scalars['Boolean']['output'];
  showOrderingDisabledAlert: Scalars['Boolean']['output'];
  voicemailEmailNotifications: Scalars['Boolean']['output'];
  voicemailPushNotifications: Scalars['Boolean']['output'];
  voicemailTextNotifications: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RestaurantMemberLocationAlertDismissed */
export type RestaurantMemberLocationAlertDismissedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: RestaurantMemberLocationAlertDismissedOptionsInputType;
  locationId: Scalars['Int']['input'];
  memberId: Scalars['Int']['input'];
};

export type RestaurantMemberLocationAlertDismissedOptionsInputType = {
  orderingDisabledAlertDismissedAt?: InputMaybe<Scalars['DateTime']['input']>;
  orderingDisabledAlertExtendedDismissedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RestaurantMemberLocationInput = {
  canManageAnswering?: InputMaybe<Scalars['Boolean']['input']>;
  canManageBillingAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  canManageCalendarEvents?: InputMaybe<Scalars['Boolean']['input']>;
  canManageFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  canManageMessages?: InputMaybe<Scalars['Boolean']['input']>;
  canManageOrderSettings?: InputMaybe<Scalars['Boolean']['input']>;
  canManageOrders?: InputMaybe<Scalars['Boolean']['input']>;
  canManageRefunds?: InputMaybe<Scalars['Boolean']['input']>;
  canManageReservations?: InputMaybe<Scalars['Boolean']['input']>;
  canManageReviewSettings?: InputMaybe<Scalars['Boolean']['input']>;
  canManageReviews?: InputMaybe<Scalars['Boolean']['input']>;
  canManageWaitlists?: InputMaybe<Scalars['Boolean']['input']>;
  canViewBillingAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  formEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['Int']['input'];
  memberLevel: Scalars['String']['input'];
  reviewEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  reviewPushNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  voicemailEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  voicemailPushNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  voicemailTextNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RestaurantMemberLocationNotificationOptionsInputType = {
  cateringEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  cateringPushNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  cateringTextNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['Int']['input'];
  orderEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  orderPushNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  orderTextNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  orderingEventsEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  orderingEventsPushNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  orderingEventsTextNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  orderingSummaryEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  reviewEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  reviewPushNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  reviewTextNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  voicemailEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  voicemailPushNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  voicemailTextNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RestaurantMemberNotificationOptionsInputType = {
  formEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  formPushNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  locations?: InputMaybe<Array<RestaurantMemberLocationNotificationOptionsInputType>>;
  orderEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  orderPushNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  orderTextNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receiveAimEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receiveFormNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receivePerformanceSnapshotNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  reviewEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  reviewPushNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  reviewTextNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  tasksNotificationFrequency?: InputMaybe<Scalars['String']['input']>;
  voicemailEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  voicemailPushNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  voicemailTextNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RestaurantMemberVersion = Versionable & {
  __typename?: 'RestaurantMemberVersion';
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  locationMenuName?: Maybe<Scalars['String']['output']>;
  objectChanges: Array<VersionDiff>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

export type RestaurantMessageGroupAverage = {
  __typename?: 'RestaurantMessageGroupAverage';
  attributableRevenue: Scalars['Float']['output'];
  clickRate: Scalars['Float']['output'];
  deliveredRate: Scalars['Float']['output'];
  directRevenue: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  messageCampaignsAttributableRevenue: Scalars['Float']['output'];
  messageCampaignsClickRate: Scalars['Float']['output'];
  messageCampaignsDeliveredCount: Scalars['Int']['output'];
  messageCampaignsDeliveredRate: Scalars['Float']['output'];
  messageCampaignsDirectRevenue: Scalars['Float']['output'];
  messageCampaignsOpenRate: Scalars['Float']['output'];
  messageCampaignsUnsubscribedRate: Scalars['Float']['output'];
  messageGroupsAttributableRevenue: Scalars['Float']['output'];
  messageGroupsClickRate: Scalars['Float']['output'];
  messageGroupsDeliveredCount: Scalars['Int']['output'];
  messageGroupsDeliveredRate: Scalars['Float']['output'];
  messageGroupsDirectRevenue: Scalars['Float']['output'];
  messageGroupsOpenRate: Scalars['Float']['output'];
  messageGroupsUnsubscribedRate: Scalars['Float']['output'];
  messagePacksAttributableRevenue: Scalars['Float']['output'];
  messagePacksClickRate: Scalars['Float']['output'];
  messagePacksDeliveredCount: Scalars['Int']['output'];
  messagePacksDeliveredRate: Scalars['Float']['output'];
  messagePacksDirectRevenue: Scalars['Float']['output'];
  messagePacksOpenRate: Scalars['Float']['output'];
  messagePacksUnsubscribedRate: Scalars['Float']['output'];
  mmsTextMessagesDeliveredRate: Scalars['Float']['output'];
  mmsTextMessagesUnsubscribedRate: Scalars['Float']['output'];
  openRate: Scalars['Float']['output'];
  textMessagesAttributableRevenue: Scalars['Float']['output'];
  textMessagesClickRate: Scalars['Float']['output'];
  textMessagesDeliveredCount: Scalars['Int']['output'];
  textMessagesDeliveredRate: Scalars['Float']['output'];
  textMessagesDirectRevenue: Scalars['Float']['output'];
  textMessagesOpenRate: Scalars['Float']['output'];
  textMessagesUnsubscribedRate: Scalars['Float']['output'];
  unsubscribedRate: Scalars['Float']['output'];
};

export type RestaurantMessageInput = {
  includeLocationContent?: InputMaybe<Scalars['Boolean']['input']>;
  mailerBrandColor?: InputMaybe<Scalars['String']['input']>;
  mailerDarkThemeLogoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  mailerFooterImageUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  mailerFooterMessage?: InputMaybe<Scalars['String']['input']>;
  mailerLinkColor?: InputMaybe<Scalars['String']['input']>;
  mailerLogoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  replyToEmail?: InputMaybe<Scalars['String']['input']>;
  showAllLocations?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RestaurantMessagePack = {
  __typename?: 'RestaurantMessagePack';
  communications: Array<RestaurantMessagePackCommunication>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  lastCommunicationDate?: Maybe<Scalars['DateTime']['output']>;
  restaurant?: Maybe<Restaurant>;
  rootMessagePack?: Maybe<RootMessagePack>;
  rootMessagePackId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RestaurantMessagePackCommunication = {
  __typename?: 'RestaurantMessagePackCommunication';
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  communication?: Maybe<RootMessagePackCommunication>;
  communicationDate?: Maybe<Scalars['DateTime']['output']>;
  communicationable?: Maybe<RestaurantMessagePackCommunicationable>;
  id: Scalars['Int']['output'];
  isApproved?: Maybe<Scalars['Boolean']['output']>;
  messagePack?: Maybe<RestaurantMessagePack>;
};

export type RestaurantMessagePackCommunicationable = {
  communicationPreview?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RestaurantMobileAppAsset = {
  __typename?: 'RestaurantMobileAppAsset';
  assetType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RestaurantNavDropdown = NavItemable & {
  __typename?: 'RestaurantNavDropdown';
  id: Scalars['Int']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isFeatured: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  navLinks: Array<RestaurantNavLink>;
  position: Scalars['Int']['output'];
  restaurant?: Maybe<Restaurant>;
};

export type RestaurantNavDropdownDraft = NavItemable & {
  __typename?: 'RestaurantNavDropdownDraft';
  id: Scalars['Int']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isFeatured: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  navLinks: Array<RestaurantNavLinkDraft>;
  position: Scalars['Int']['output'];
  restaurant?: Maybe<Restaurant>;
};

export type RestaurantNavDropdownInput = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type RestaurantNavItemInput = {
  id: Scalars['Int']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  position: Scalars['Int']['input'];
  typename?: InputMaybe<Scalars['String']['input']>;
};

export type RestaurantNavLink = NavItemable & {
  __typename?: 'RestaurantNavLink';
  customHref?: Maybe<Scalars['String']['output']>;
  customPageTarget?: Maybe<CustomPage>;
  disableAjaxLoad: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isExternal: Scalars['Boolean']['output'];
  isFeatured: Scalars['Boolean']['output'];
  linkType?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  photoUploadedPhoto?: Maybe<UploadedPhoto>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  restaurant?: Maybe<Restaurant>;
  target?: Maybe<NavLinkable>;
  targetId?: Maybe<Scalars['String']['output']>;
  targetType?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type RestaurantNavLinkDraft = NavItemable & {
  __typename?: 'RestaurantNavLinkDraft';
  customHref?: Maybe<Scalars['String']['output']>;
  customPageTarget?: Maybe<CustomPage>;
  disableAjaxLoad: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isExternal: Scalars['Boolean']['output'];
  isFeatured: Scalars['Boolean']['output'];
  linkType?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  photoUploadedPhoto?: Maybe<UploadedPhoto>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  restaurant?: Maybe<Restaurant>;
  target?: Maybe<NavLinkable>;
  targetId?: Maybe<Scalars['String']['output']>;
  targetType?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type RestaurantNavLinkInput = {
  customHref?: InputMaybe<Scalars['String']['input']>;
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  linkType?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  targetId?: InputMaybe<Scalars['Int']['input']>;
};

export type RestaurantNotFound = {
  __typename?: 'RestaurantNotFound';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hasRedirect: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  lastOccurredAt: Scalars['DateTime']['output'];
  occurrenceCount: Scalars['Int']['output'];
  path: Scalars['String']['output'];
};

export type RestaurantNotice = {
  __typename?: 'RestaurantNotice';
  id: Scalars['Int']['output'];
  milestoneType: Scalars['Int']['output'];
  milestoneTypeName?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type RestaurantOffersCount = {
  __typename?: 'RestaurantOffersCount';
  offersCount: Scalars['Int']['output'];
  orderingOffersCount: Scalars['Int']['output'];
};

export type RestaurantOnboardingInfo = {
  __typename?: 'RestaurantOnboardingInfo';
  bodyFont: FontSelection;
  bodyFontId?: Maybe<Scalars['Int']['output']>;
  brandColors: Array<RestaurantOnboardingInfoBrandColor>;
  brandNotes?: Maybe<Scalars['String']['output']>;
  businessGoals: Array<Scalars['String']['output']>;
  contentAbout?: Maybe<Scalars['Boolean']['output']>;
  contentBlog?: Maybe<Scalars['Boolean']['output']>;
  contentCatering?: Maybe<Scalars['Boolean']['output']>;
  contentContactUs?: Maybe<Scalars['Boolean']['output']>;
  contentEventsCalendar?: Maybe<Scalars['Boolean']['output']>;
  contentExternalOrdering?: Maybe<Scalars['Boolean']['output']>;
  contentGiftCard?: Maybe<Scalars['Boolean']['output']>;
  contentHiring?: Maybe<Scalars['Boolean']['output']>;
  contentLiveBeerList?: Maybe<Scalars['Boolean']['output']>;
  contentNotes?: Maybe<Scalars['String']['output']>;
  contentOlo?: Maybe<Scalars['Boolean']['output']>;
  contentOnlineStore?: Maybe<Scalars['Boolean']['output']>;
  contentPhotoGallery?: Maybe<Scalars['Boolean']['output']>;
  contentPressPage?: Maybe<Scalars['Boolean']['output']>;
  contentPrivateEvent?: Maybe<Scalars['Boolean']['output']>;
  contentPromotions?: Maybe<Scalars['Boolean']['output']>;
  contentReservation?: Maybe<Scalars['Boolean']['output']>;
  fontNotes?: Maybe<Scalars['String']['output']>;
  hasBrand?: Maybe<Scalars['Boolean']['output']>;
  hasFont?: Maybe<Scalars['Boolean']['output']>;
  headingFont: FontSelection;
  headingFontId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  indieStatus?: Maybe<Scalars['String']['output']>;
  isOnboardingNotificationsEnabled: Scalars['Boolean']['output'];
  links: Array<RestaurantOnboardingInfoLink>;
  logoNotes?: Maybe<Scalars['String']['output']>;
  menuNotes?: Maybe<Scalars['String']['output']>;
  notes: Array<RestaurantOnboardingInfoNote>;
  orderingStartedAt?: Maybe<Scalars['DateTime']['output']>;
  otherBusinessGoals?: Maybe<Scalars['String']['output']>;
  photoNotes?: Maybe<Scalars['String']['output']>;
  previousWebsite?: Maybe<Scalars['String']['output']>;
  selectedRootSiteTemplate?: Maybe<RootSiteTemplate>;
  siteBuildExpectedDate?: Maybe<Scalars['DateTime']['output']>;
  stepBusinessGoalsAt?: Maybe<Scalars['DateTime']['output']>;
  stepBusinessGoalsByUser?: Maybe<User>;
  stepBusinessGoalsStatus?: Maybe<Scalars['String']['output']>;
  stepContentAt?: Maybe<Scalars['DateTime']['output']>;
  stepContentByUser?: Maybe<User>;
  stepContentStatus?: Maybe<Scalars['String']['output']>;
  stepDomainAt?: Maybe<Scalars['DateTime']['output']>;
  stepDomainByUser?: Maybe<User>;
  stepDomainStatus?: Maybe<Scalars['String']['output']>;
  stepInfoAt?: Maybe<Scalars['DateTime']['output']>;
  stepInfoByUser?: Maybe<User>;
  stepInfoRestaurantStepSaved?: Maybe<Scalars['Boolean']['output']>;
  stepInfoStatus?: Maybe<Scalars['String']['output']>;
  stepLogoAt?: Maybe<Scalars['DateTime']['output']>;
  stepLogoByUser?: Maybe<User>;
  stepLogoStatus?: Maybe<Scalars['String']['output']>;
  stepMenuAt?: Maybe<Scalars['DateTime']['output']>;
  stepMenuByUser?: Maybe<User>;
  stepMenuOption?: Maybe<Scalars['String']['output']>;
  stepMenuStatus?: Maybe<Scalars['String']['output']>;
  stepPhotoAt?: Maybe<Scalars['DateTime']['output']>;
  stepPhotoByUser?: Maybe<User>;
  stepPhotoStatus?: Maybe<Scalars['String']['output']>;
  stepStyleAt?: Maybe<Scalars['DateTime']['output']>;
  stepStyleByUser?: Maybe<User>;
  stepStyleStatus?: Maybe<Scalars['String']['output']>;
  styleNotes?: Maybe<Scalars['String']['output']>;
};

export type RestaurantOnboardingInfoBrandColor = {
  __typename?: 'RestaurantOnboardingInfoBrandColor';
  color: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
};

export type RestaurantOnboardingInfoBrandColorInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type RestaurantOnboardingInfoInput = {
  bodyFontId?: InputMaybe<Scalars['Int']['input']>;
  brandColors?: InputMaybe<Array<RestaurantOnboardingInfoBrandColorInput>>;
  brandNotes?: InputMaybe<Scalars['String']['input']>;
  businessGoals?: InputMaybe<Array<Scalars['String']['input']>>;
  contentAbout?: InputMaybe<Scalars['Boolean']['input']>;
  contentBlog?: InputMaybe<Scalars['Boolean']['input']>;
  contentCatering?: InputMaybe<Scalars['Boolean']['input']>;
  contentContactUs?: InputMaybe<Scalars['Boolean']['input']>;
  contentEventsCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  contentExternalOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  contentGiftCard?: InputMaybe<Scalars['Boolean']['input']>;
  contentHiring?: InputMaybe<Scalars['Boolean']['input']>;
  contentLiveBeerList?: InputMaybe<Scalars['Boolean']['input']>;
  contentNotes?: InputMaybe<Scalars['String']['input']>;
  contentOlo?: InputMaybe<Scalars['Boolean']['input']>;
  contentOnlineStore?: InputMaybe<Scalars['Boolean']['input']>;
  contentPhotoGallery?: InputMaybe<Scalars['Boolean']['input']>;
  contentPressPage?: InputMaybe<Scalars['Boolean']['input']>;
  contentPrivateEvent?: InputMaybe<Scalars['Boolean']['input']>;
  contentPromotions?: InputMaybe<Scalars['Boolean']['input']>;
  contentReservation?: InputMaybe<Scalars['Boolean']['input']>;
  fontNotes?: InputMaybe<Scalars['String']['input']>;
  headingFontId?: InputMaybe<Scalars['Int']['input']>;
  indieStatus?: InputMaybe<Scalars['String']['input']>;
  isContentStep?: InputMaybe<Scalars['Boolean']['input']>;
  isOnboardingNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  logoNotes?: InputMaybe<Scalars['String']['input']>;
  menuNotes?: InputMaybe<Scalars['String']['input']>;
  otherBusinessGoals?: InputMaybe<Scalars['String']['input']>;
  photoNotes?: InputMaybe<Scalars['String']['input']>;
  previousWebsite?: InputMaybe<Scalars['String']['input']>;
  selectedRootSiteTemplateId?: InputMaybe<Scalars['Int']['input']>;
  shouldCreateTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  stepContentStatus?: InputMaybe<Scalars['String']['input']>;
  stepDomainStatus?: InputMaybe<Scalars['String']['input']>;
  stepInfoStatus?: InputMaybe<Scalars['String']['input']>;
  stepLogoStatus?: InputMaybe<Scalars['String']['input']>;
  stepMenuOption?: InputMaybe<Scalars['String']['input']>;
  stepMenuStatus?: InputMaybe<Scalars['String']['input']>;
  stepPhotoStatus?: InputMaybe<Scalars['String']['input']>;
  stepStyleStatus?: InputMaybe<Scalars['String']['input']>;
  styleNotes?: InputMaybe<Scalars['String']['input']>;
};

export type RestaurantOnboardingInfoLink = {
  __typename?: 'RestaurantOnboardingInfoLink';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isOloMenu?: Maybe<Scalars['Boolean']['output']>;
  linkType: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type RestaurantOnboardingInfoLinksInput = {
  linkType: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type RestaurantOnboardingInfoNote = {
  __typename?: 'RestaurantOnboardingInfoNote';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  noteContent: Scalars['String']['output'];
  noteType: Scalars['String']['output'];
};

export type RestaurantOrderezeStatusType = {
  __typename?: 'RestaurantOrderezeStatusType';
  canLaunch: Scalars['Boolean']['output'];
  childSitesCount: Scalars['Int']['output'];
  friendlySyncStatus?: Maybe<Scalars['String']['output']>;
  hasCustomForms: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isAuthorizeSyncEnabled: Scalars['Boolean']['output'];
  isAutoSyncEnabled: Scalars['Boolean']['output'];
  isEverywareSyncEnabled: Scalars['Boolean']['output'];
  isFollowersSyncEnabled: Scalars['Boolean']['output'];
  isHeartlandSyncEnabled: Scalars['Boolean']['output'];
  isLocationsSyncEnabled: Scalars['Boolean']['output'];
  isMenuSyncEnabled: Scalars['Boolean']['output'];
  isMicrosite: Scalars['Boolean']['output'];
  isOrderingSyncEnabled: Scalars['Boolean']['output'];
  isPagesSyncEnabled: Scalars['Boolean']['output'];
  isStripeSyncEnabled: Scalars['Boolean']['output'];
  isTeamMemberSyncEnabled: Scalars['Boolean']['output'];
  lastSyncAt?: Maybe<Scalars['DateTime']['output']>;
  migrationCohortName?: Maybe<Scalars['String']['output']>;
  orderezeCrmCustomerId?: Maybe<Scalars['Int']['output']>;
  orderezeDomainName?: Maybe<Scalars['String']['output']>;
  orderezeProductsJson?: Maybe<Scalars['String']['output']>;
  orderezeSiteId?: Maybe<Scalars['Int']['output']>;
  orderezeStagingUrl?: Maybe<Scalars['String']['output']>;
  orderingPaymentProcessor?: Maybe<Scalars['String']['output']>;
  recentOrdersCount: Scalars['Int']['output'];
};

export type RestaurantOrderingInput = {
  locations: Array<RestaurantLocationOrderingInput>;
};

export type RestaurantPaginationHandler = {
  __typename?: 'RestaurantPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<Restaurant>;
};

/** Restaurant payment accounts UI info */
export type RestaurantPaymentAccountInterface = {
  accountSlug: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  accountUrl: Scalars['String']['output'];
  canDisconnectPos: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isAvailable: Scalars['Boolean']['output'];
  isDeleting: Scalars['Boolean']['output'];
  isMenuSyncing: Scalars['Boolean']['output'];
  isShopSupported: Scalars['Boolean']['output'];
  isSyncing?: Maybe<Scalars['Boolean']['output']>;
  menuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  shouldReauthenticate: Scalars['Boolean']['output'];
};

export type RestaurantPolicy = {
  __typename?: 'RestaurantPolicy';
  addLocationRequest: Scalars['Boolean']['output'];
  addSquareMenus: Scalars['Boolean']['output'];
  bulkSetSubmitted: Scalars['Boolean']['output'];
  canViewHistoryChanges: Scalars['Boolean']['output'];
  canViewOrderNotification: Scalars['Boolean']['output'];
  createLocation: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  manageAdvancedSettings: Scalars['Boolean']['output'];
  manageAllLocationsOrderSettings: Scalars['Boolean']['output'];
  manageAnyReservations: Scalars['Boolean']['output'];
  manageApiTokens: Scalars['Boolean']['output'];
  manageBlogPosts: Scalars['Boolean']['output'];
  manageCalendarEvents: Scalars['Boolean']['output'];
  manageCustomFiles: Scalars['Boolean']['output'];
  manageCustomPages: Scalars['Boolean']['output'];
  manageDineInSettings: Scalars['Boolean']['output'];
  manageFeatures: Scalars['Boolean']['output'];
  manageGoogleAccount: Scalars['Boolean']['output'];
  manageHosting: Scalars['Boolean']['output'];
  manageLegalSettings: Scalars['Boolean']['output'];
  manageLimitedBilling: Scalars['Boolean']['output'];
  manageMarketing: Scalars['Boolean']['output'];
  manageMessages: Scalars['Boolean']['output'];
  manageMobileAppAssets: Scalars['Boolean']['output'];
  manageOrderPayments: Scalars['Boolean']['output'];
  manageOrderReports: Scalars['Boolean']['output'];
  manageOrderingEvents: Scalars['Boolean']['output'];
  manageOrderingOffers: Scalars['Boolean']['output'];
  manageReservations: Scalars['Boolean']['output'];
  manageReviewsTab: Scalars['Boolean']['output'];
  manageSegments: Scalars['Boolean']['output'];
  manageSocialAccounts: Scalars['Boolean']['output'];
  manageTwilio: Scalars['Boolean']['output'];
  manageUpgradeRequests: Scalars['Boolean']['output'];
  manageUpselling: Scalars['Boolean']['output'];
  manageYextIntegration: Scalars['Boolean']['output'];
  submitAiAnsweringTwilioNumber: Scalars['Boolean']['output'];
  suspendLocation: Scalars['Boolean']['output'];
  viewLimitedBilling: Scalars['Boolean']['output'];
};

export type RestaurantProfile = {
  __typename?: 'RestaurantProfile';
  acceptsReservations: Scalars['String']['output'];
  advisorCardTrackerId?: Maybe<Scalars['Int']['output']>;
  businessNeeds: Array<Scalars['String']['output']>;
  hostsTicketedEvents: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  marketingMethods: Array<Scalars['String']['output']>;
  onlineOrderingWeekly: Scalars['String']['output'];
  onlineOrderingWeeklyGoal: Scalars['String']['output'];
  posProvider: Scalars['String']['output'];
  restaurant: Restaurant;
};

export type RestaurantProfileInput = {
  acceptsReservations: Scalars['String']['input'];
  advisorCardTrackerId?: InputMaybe<Scalars['Int']['input']>;
  businessNeeds?: InputMaybe<Array<Scalars['String']['input']>>;
  hostsTicketedEvents: Scalars['String']['input'];
  marketingMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  onlineOrderingWeekly: Scalars['String']['input'];
  onlineOrderingWeeklyGoal: Scalars['String']['input'];
  posProvider: Scalars['String']['input'];
};

export type RestaurantPublishedLegalDocument = {
  __typename?: 'RestaurantPublishedLegalDocument';
  content: Scalars['String']['output'];
  documentType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type RestaurantPublishingDraftsSuccess = {
  __typename?: 'RestaurantPublishingDraftsSuccess';
  errors?: Maybe<Scalars['String']['output']>;
  publishSuccessful: Scalars['Boolean']['output'];
  restaurant: Restaurant;
};

export type RestaurantQrCard = {
  __typename?: 'RestaurantQrCard';
  id: Scalars['Int']['output'];
  pdfUrl?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of RestaurantRemoveDomain */
export type RestaurantRemoveDomainInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  domain: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
  subdomain: Scalars['String']['input'];
};

export type RestaurantScriptDomain = {
  __typename?: 'RestaurantScriptDomain';
  domain: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  restaurant: Restaurant;
};

export type RestaurantScriptDomainInput = {
  domain: Scalars['String']['input'];
};

export type RestaurantScriptSettingsInput = {
  appleMerchantVerificationKey?: InputMaybe<Scalars['String']['input']>;
  customScripts?: InputMaybe<Array<RestaurantCustomScriptInput>>;
  customTrackings?: InputMaybe<Array<RestaurantCustomTrackingInput>>;
  facebookPixelId?: InputMaybe<Scalars['String']['input']>;
};

export type RestaurantSecondaryDomain = {
  __typename?: 'RestaurantSecondaryDomain';
  domain: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  liveDomain?: Maybe<LiveDomain>;
  primarySubdomain: Scalars['String']['output'];
};

export type RestaurantSecondaryDomainInput = {
  domain: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type RestaurantSelectedCuisineType = {
  __typename?: 'RestaurantSelectedCuisineType';
  cuisineType?: Maybe<CuisineType>;
  id: Scalars['Int']['output'];
};

export type RestaurantSelectedCuisineTypeInput = {
  cuisineTypeId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type RestaurantSelectedProduct = {
  __typename?: 'RestaurantSelectedProduct';
  discount?: Maybe<Scalars['Decimal']['output']>;
  hasPhotography?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isBilledUpFront?: Maybe<Scalars['Boolean']['output']>;
  locationCount?: Maybe<Scalars['Int']['output']>;
  photographyPrice?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  recurringMonths?: Maybe<Scalars['Int']['output']>;
  restaurant?: Maybe<Restaurant>;
  unitPrice?: Maybe<Scalars['Int']['output']>;
};

export type RestaurantSessionsByDevice = {
  __typename?: 'RestaurantSessionsByDevice';
  deviceType: Scalars['String']['output'];
  sessionsCount: Scalars['Int']['output'];
};

export type RestaurantSessionsByMarketingSource = {
  __typename?: 'RestaurantSessionsByMarketingSource';
  medium: Scalars['String']['output'];
  sessionsCount: Scalars['Int']['output'];
};

/** Autogenerated input type of RestaurantSetPrimaryDomain */
export type RestaurantSetPrimaryDomainInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  domain: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
  subdomain: Scalars['String']['input'];
};

export type RestaurantSignUpSetting = {
  __typename?: 'RestaurantSignUpSetting';
  id: Scalars['Int']['output'];
  isSignUpAnniversaryEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSignUpAnniversaryRequired?: Maybe<Scalars['Boolean']['output']>;
  isSignUpBirthdayEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSignUpBirthdayRequired?: Maybe<Scalars['Boolean']['output']>;
  isSignUpNameEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSignUpNameRequired?: Maybe<Scalars['Boolean']['output']>;
  isSignUpPhoneEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSignUpPhoneRequired?: Maybe<Scalars['Boolean']['output']>;
  signUpLogoEffect?: Maybe<Scalars['String']['output']>;
};

export type RestaurantSignUpSettingDraft = {
  __typename?: 'RestaurantSignUpSettingDraft';
  id: Scalars['Int']['output'];
  isSignUpAnniversaryEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSignUpAnniversaryRequired?: Maybe<Scalars['Boolean']['output']>;
  isSignUpBirthdayEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSignUpBirthdayRequired?: Maybe<Scalars['Boolean']['output']>;
  isSignUpNameEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSignUpNameRequired?: Maybe<Scalars['Boolean']['output']>;
  isSignUpPhoneEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSignUpPhoneRequired?: Maybe<Scalars['Boolean']['output']>;
  signUpLogoEffect?: Maybe<Scalars['String']['output']>;
};

export type RestaurantSocialHandle = {
  __typename?: 'RestaurantSocialHandle';
  id: Scalars['Int']['output'];
  socialType: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type RestaurantSocialHandleDraft = {
  __typename?: 'RestaurantSocialHandleDraft';
  id: Scalars['Int']['output'];
  socialType: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type RestaurantSocialHandleInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  socialType: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type RestaurantUpgradeRequest = {
  __typename?: 'RestaurantUpgradeRequest';
  id: Scalars['Int']['output'];
  requestType: Scalars['String']['output'];
};

export type RestaurantUserSetting = {
  __typename?: 'RestaurantUserSetting';
  allLocationsSelected: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  orderingCartBucketsEnabled: Scalars['Boolean']['output'];
  orderingReportGroupBy?: Maybe<Scalars['String']['output']>;
  orderingSelectedCartBucket?: Maybe<Scalars['String']['output']>;
  orderingSelectedLocationId?: Maybe<Scalars['Int']['output']>;
  orderingSelectedStatusGroup?: Maybe<Scalars['String']['output']>;
  restaurant: Restaurant;
};

export type RestaurantUserSettingInput = {
  allLocationsSelected?: InputMaybe<Scalars['Boolean']['input']>;
  orderingCartBucketsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingReportGroupBy?: InputMaybe<Scalars['String']['input']>;
  orderingSelectedCartBucket?: InputMaybe<Scalars['String']['input']>;
  orderingSelectedLocationId?: InputMaybe<Scalars['Int']['input']>;
  orderingSelectedStatusGroup?: InputMaybe<Scalars['String']['input']>;
};

export type RestaurantVersion = Versionable & {
  __typename?: 'RestaurantVersion';
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  locationMenuName?: Maybe<Scalars['String']['output']>;
  objectChanges: Array<VersionDiff>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

export type RestaurantVipSettingsInput = {
  customDisclaimer?: InputMaybe<Scalars['String']['input']>;
  customFollowButton?: InputMaybe<Scalars['String']['input']>;
  customFollowHeading?: InputMaybe<Scalars['String']['input']>;
  customFollowPath?: InputMaybe<Scalars['String']['input']>;
  customSmsContactDisclaimer?: InputMaybe<Scalars['String']['input']>;
  customVipCopyRow1?: InputMaybe<Scalars['String']['input']>;
  customVipCopyRow2?: InputMaybe<Scalars['String']['input']>;
  displayVipPopup?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RestaurantVipSignUpSettingInput = {
  isSignUpAnniversaryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isSignUpAnniversaryRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isSignUpBirthdayEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isSignUpBirthdayRequired?: InputMaybe<Scalars['Boolean']['input']>;
  signUpLogoEffect?: InputMaybe<Scalars['String']['input']>;
};

export type RestaurantWebhook = {
  __typename?: 'RestaurantWebhook';
  createdAt: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  lastSentAt?: Maybe<Scalars['DateTime']['output']>;
  userDisplayName: Scalars['String']['output'];
  webhookUrl: Scalars['String']['output'];
};

export type RestaurantWebhookInput = {
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export type RestaurantWebhookToken = {
  __typename?: 'RestaurantWebhookToken';
  id: Scalars['Int']['output'];
  lastGeneratedAt: Scalars['DateTime']['output'];
  lastGeneratedByUserDisplayName: Scalars['String']['output'];
};

export type RestaurantWebsitePublishRecord = {
  __typename?: 'RestaurantWebsitePublishRecord';
  id: Scalars['Int']['output'];
  publishedAt: Scalars['DateTime']['output'];
  userDisplayName: Scalars['String']['output'];
};

/** Autogenerated input type of RestoreAdvancedForm */
export type RestoreAdvancedFormInput = {
  advancedFormId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of RetrySocialPost */
export type RetrySocialPostInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  socialPostId: Scalars['Int']['input'];
};

export type RevenueMetrics = {
  __typename?: 'RevenueMetrics';
  currentWeekRevenueCount: Scalars['Float']['output'];
  previousWeekRevenueCount: Scalars['Float']['output'];
};

export type Review = Eventable & {
  __typename?: 'Review';
  /** Only approved reviews may be displayed publicly */
  approved?: Maybe<Scalars['Boolean']['output']>;
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedByDisplayName?: Maybe<Scalars['String']['output']>;
  authorEmail?: Maybe<Scalars['String']['output']>;
  authorName?: Maybe<Scalars['String']['output']>;
  autoResponseState: Scalars['String']['output'];
  avatarUrl?: Maybe<Scalars['String']['output']>;
  canRespond: Scalars['Boolean']['output'];
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dishable?: Maybe<Dishable>;
  dishableId?: Maybe<Scalars['Int']['output']>;
  dishableType?: Maybe<Scalars['String']['output']>;
  displayPhotoUrl?: Maybe<Scalars['String']['output']>;
  eventableName: Scalars['String']['output'];
  externalLink?: Maybe<Scalars['String']['output']>;
  follower?: Maybe<Follower>;
  generatedResponse?: Maybe<Scalars['String']['output']>;
  googleProfilePhotoUrl?: Maybe<Scalars['String']['output']>;
  googleReviewResourceName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isApprovalRecommended?: Maybe<Scalars['Boolean']['output']>;
  isPotentiallySpam: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  isRespondableSource: Scalars['Boolean']['output'];
  item?: Maybe<MenuItem>;
  linkedDishes: Array<ReviewLinkedDish>;
  location?: Maybe<RestaurantLocation>;
  locationId?: Maybe<Scalars['Int']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  needsAction: Scalars['Boolean']['output'];
  needsResponse: Scalars['Boolean']['output'];
  pop?: Maybe<Pop>;
  reply?: Maybe<ReviewReply>;
  restaurant?: Maybe<Restaurant>;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  reviewUpvotesCount?: Maybe<Scalars['Int']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  sensitiveContent?: Maybe<Scalars['String']['output']>;
  sentiment?: Maybe<Scalars['String']['output']>;
  session?: Maybe<Session>;
  sessionAvatarUrl?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  starRating: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  upvotes: Array<ReviewUpvote>;
  user?: Maybe<User>;
  userAvatarUrl: Scalars['String']['output'];
  /** Public user display name or "Guest" */
  userDisplayName: Scalars['String']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
  yextReviewId?: Maybe<Scalars['Int']['output']>;
};

export type ReviewGeneratedAiResponseType = {
  __typename?: 'ReviewGeneratedAiResponseType';
  text: Scalars['String']['output'];
};

export type ReviewLinkedDish = {
  __typename?: 'ReviewLinkedDish';
  dish?: Maybe<Dish>;
  id: Scalars['Int']['output'];
};

export type ReviewMetrics = {
  __typename?: 'ReviewMetrics';
  responseRate: Scalars['Int']['output'];
  reviewSentiment: Scalars['Int']['output'];
  totalReviews: Scalars['Int']['output'];
};

export type ReviewPaginationHandler = {
  __typename?: 'ReviewPaginationHandler';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  offset: Scalars['Int']['output'];
  records: Array<Review>;
};

export type ReviewReply = {
  __typename?: 'ReviewReply';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<MessageGroupMessage>;
  messageId?: Maybe<Scalars['ID']['output']>;
  repliedAt?: Maybe<Scalars['DateTime']['output']>;
  review?: Maybe<Review>;
  reviewId: Scalars['Int']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  yextCommentId?: Maybe<Scalars['Int']['output']>;
};

export type ReviewUpvote = {
  __typename?: 'ReviewUpvote';
  id: Scalars['Int']['output'];
  review?: Maybe<Review>;
  reviewId?: Maybe<Scalars['Int']['output']>;
  session?: Maybe<Session>;
  sessionId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type ReviewsMetrics = {
  __typename?: 'ReviewsMetrics';
  currentWeekReviewsCount: Scalars['Int']['output'];
  previousWeekReviewsCount: Scalars['Int']['output'];
};

export type ReviewsMetricsByDaysAgo = {
  __typename?: 'ReviewsMetricsByDaysAgo';
  currentReviewsCount: Scalars['Int']['output'];
  previousReviewsCount?: Maybe<Scalars['Int']['output']>;
};

export type RewardTierInput = {
  amountDiscount: Scalars['Int']['input'];
  discountType: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  points: Scalars['Int']['input'];
  scope: Scalars['String']['input'];
};

export type RootAdvisorCard = {
  __typename?: 'RootAdvisorCard';
  cardType: Scalars['String']['output'];
  description: Scalars['String']['output'];
  heading: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  imageKey?: Maybe<Scalars['String']['output']>;
  linkText: Scalars['String']['output'];
  linkUrl: Scalars['String']['output'];
  rootMessagePack?: Maybe<RootMessagePack>;
};

export type RootAnnouncement = {
  __typename?: 'RootAnnouncement';
  content: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  reviewContent?: Maybe<Scalars['String']['output']>;
};

export type RootAnnouncementInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  reviewContent?: InputMaybe<Scalars['String']['input']>;
};

export type RootAnnouncementPaginationHandler = {
  __typename?: 'RootAnnouncementPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<RootAnnouncement>;
};

/** Computed CSS styles for root button sizing with border radius */
export type RootButtonStyles = {
  __typename?: 'RootButtonStyles';
  /** CSS border-radius value, example: "15px" */
  borderRadius?: Maybe<Scalars['String']['output']>;
  /** CSS font-size value, example: "0.875rem !important" */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** CSS min-height value, example: "36px !important" */
  minHeight?: Maybe<Scalars['String']['output']>;
  /** CSS padding value, example: "6px 16px !important" */
  padding?: Maybe<Scalars['String']['output']>;
};

export type RootCategoryInput = {
  cuisineTypeId: Scalars['Int']['input'];
  googleMyBusinessCategoryId?: InputMaybe<Scalars['Int']['input']>;
  yextCategoryId?: InputMaybe<Scalars['Int']['input']>;
};

export type RootCwvTechReport = {
  __typename?: 'RootCwvTechReport';
  accessibilityScore?: Maybe<Scalars['Decimal']['output']>;
  bestPracticesScore?: Maybe<Scalars['Decimal']['output']>;
  client: Scalars['String']['output'];
  clsGoodRatio?: Maybe<Scalars['Float']['output']>;
  cwvGoodRatio?: Maybe<Scalars['Float']['output']>;
  fcpGoodRatio?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  inpGoodRatio?: Maybe<Scalars['Float']['output']>;
  lcpGoodRatio?: Maybe<Scalars['Float']['output']>;
  month: Scalars['Int']['output'];
  origins?: Maybe<Scalars['Int']['output']>;
  performanceScore?: Maybe<Scalars['Decimal']['output']>;
  seoScore?: Maybe<Scalars['Decimal']['output']>;
  technology: Scalars['String']['output'];
  ttfbGoodRatio?: Maybe<Scalars['Float']['output']>;
  year: Scalars['Int']['output'];
};

export type RootDishCategory = {
  __typename?: 'RootDishCategory';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type RootDishTag = {
  __typename?: 'RootDishTag';
  abbr?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dishesTagCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  imageIconUrl?: Maybe<Scalars['String']['output']>;
  imageUploadedPhoto?: Maybe<UploadedPhoto>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  restaurantsTagCount?: Maybe<Scalars['Int']['output']>;
};

export type RootDishTagInput = {
  abbr: Scalars['String']['input'];
  color: Scalars['String']['input'];
  imageUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  name: Scalars['String']['input'];
};

export type RootDishTagPaginationHandler = {
  __typename?: 'RootDishTagPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<RootDishTag>;
};

export type RootGroup = {
  __typename?: 'RootGroup';
  aggregateReport: AggregateReport;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserDisplayName?: Maybe<Scalars['String']['output']>;
  followersCount: Scalars['Int']['output'];
  groupType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  members: Array<RootGroupMember>;
  membersCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  restaurants: Array<Restaurant>;
  zohoGroup?: Maybe<ZohoGroup>;
};


export type RootGroupAggregateReportArgs = {
  endAt: Scalars['DateTime']['input'];
  groupByDomain: Scalars['String']['input'];
  startAt: Scalars['DateTime']['input'];
};

export type RootGroupInput = {
  groupType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type RootGroupMember = {
  __typename?: 'RootGroupMember';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  restaurant?: Maybe<Restaurant>;
  rootGroup?: Maybe<RootGroup>;
};

export type RootGroupMemberInput = {
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
};

export type RootGroupPaginationHandler = {
  __typename?: 'RootGroupPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<RootGroup>;
};

export type RootMessagePack = {
  __typename?: 'RootMessagePack';
  category?: Maybe<RootMessagePackCategory>;
  categoryName?: Maybe<Scalars['String']['output']>;
  clientType?: Maybe<Scalars['String']['output']>;
  communicationCount: Scalars['Int']['output'];
  communications: Array<RootMessagePackCommunication>;
  countries: Array<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  day?: Maybe<Scalars['Int']['output']>;
  enabledPack: Scalars['Boolean']['output'];
  frequencyType?: Maybe<Scalars['String']['output']>;
  holiday?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  message: RootMessagePackMessage;
  messagePackType?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  nextHolidayDate?: Maybe<Scalars['DateTime']['output']>;
  selectedCategory?: Maybe<RootMessagePackSelectedCategory>;
  socialPost: RootMessagePackSocialPost;
  thumbnailImage?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  useForAi: Scalars['Boolean']['output'];
  weekday?: Maybe<Scalars['String']['output']>;
};


export type RootMessagePackEnabledPackArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type RootMessagePackMessageArgs = {
  id: Scalars['Int']['input'];
};


export type RootMessagePackSocialPostArgs = {
  id: Scalars['Int']['input'];
};

export type RootMessagePackCategory = {
  __typename?: 'RootMessagePackCategory';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RootMessagePackCommunication = {
  __typename?: 'RootMessagePackCommunication';
  communicationable: RootMessagePackCommunicationable;
  communicationableType?: Maybe<Scalars['String']['output']>;
  daysOffset?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isDraft?: Maybe<Scalars['Boolean']['output']>;
};

export type RootMessagePackCommunicationInput = {
  daysOffset?: InputMaybe<Scalars['Int']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RootMessagePackCommunicationable = {
  communicationPreview?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type RootMessagePackInput = {
  clientType?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  day?: InputMaybe<Scalars['Int']['input']>;
  frequencyType?: InputMaybe<Scalars['String']['input']>;
  holiday?: InputMaybe<Scalars['String']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  messagePackType?: InputMaybe<Scalars['String']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  selectedCategory?: InputMaybe<RootMessagePackSelectedCategoryInput>;
  useForAi?: InputMaybe<Scalars['Boolean']['input']>;
  weekday?: InputMaybe<Scalars['String']['input']>;
};

export type RootMessagePackMessage = RootMessagePackCommunicationable & {
  __typename?: 'RootMessagePackMessage';
  communicationPreview?: Maybe<Scalars['String']['output']>;
  contents: Array<RootMessagePackMessageContent>;
  id: Scalars['Int']['output'];
  subject?: Maybe<Scalars['String']['output']>;
};

export type RootMessagePackMessageButtonContent = BuilderContentable & {
  __typename?: 'RootMessagePackMessageButtonContent';
  buttonLink?: Maybe<Scalars['String']['output']>;
  buttonName?: Maybe<Scalars['String']['output']>;
  buttonType: Scalars['String']['output'];
  content?: Maybe<RootMessagePackMessageContent>;
  contentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  message?: Maybe<RootMessagePackMessage>;
};

export type RootMessagePackMessageCalendarEventContent = BuilderContentable & {
  __typename?: 'RootMessagePackMessageCalendarEventContent';
  calendarEvent?: Maybe<CalendarEvent>;
  content?: Maybe<RootMessagePackMessageContent>;
  contentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type RootMessagePackMessageContent = {
  __typename?: 'RootMessagePackMessageContent';
  content?: Maybe<BuilderContentable>;
  contentOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
};

export type RootMessagePackMessageDishContent = BuilderContentable & {
  __typename?: 'RootMessagePackMessageDishContent';
  content?: Maybe<RootMessagePackMessageContent>;
  contentType: Scalars['String']['output'];
  dish?: Maybe<Dish>;
  id: Scalars['Int']['output'];
};

export type RootMessagePackMessageDividerContent = BuilderContentable & {
  __typename?: 'RootMessagePackMessageDividerContent';
  color?: Maybe<Scalars['String']['output']>;
  content?: Maybe<RootMessagePackMessageContent>;
  contentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  message?: Maybe<RootMessagePackMessage>;
  spacing?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
};

export type RootMessagePackMessageFeaturedContent = BuilderContentable & {
  __typename?: 'RootMessagePackMessageFeaturedContent';
  content?: Maybe<RootMessagePackMessageContent>;
  contentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  message?: Maybe<RootMessagePackMessage>;
};

export type RootMessagePackMessageFeaturedReviewContent = BuilderContentable & {
  __typename?: 'RootMessagePackMessageFeaturedReviewContent';
  content?: Maybe<RootMessagePackMessageContent>;
  contentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  message?: Maybe<RootMessagePackMessage>;
};

export type RootMessagePackMessageImageContent = BuilderContentable & {
  __typename?: 'RootMessagePackMessageImageContent';
  altText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  content?: Maybe<RootMessagePackMessageContent>;
  contentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  uploadedPhoto?: Maybe<UploadedPhoto>;
  url?: Maybe<Scalars['String']['output']>;
};

export type RootMessagePackMessageInput = {
  messageGroupExcludedLocations?: InputMaybe<Array<Scalars['Int']['input']>>;
  messageGroupExcludedTags?: InputMaybe<Array<Scalars['Int']['input']>>;
  messageGroupSelectedLocations?: InputMaybe<Array<Scalars['Int']['input']>>;
  messageGroupSelectedTags?: InputMaybe<Array<Scalars['Int']['input']>>;
  messagePackBuilder?: InputMaybe<Array<BuilderContentInput>>;
  messageTeaser?: InputMaybe<Scalars['String']['input']>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  subject: Scalars['String']['input'];
  theme?: InputMaybe<Scalars['String']['input']>;
};

export type RootMessagePackMessageOfferContent = BuilderContentable & {
  __typename?: 'RootMessagePackMessageOfferContent';
  content?: Maybe<RootMessagePackMessageContent>;
  contentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  offer?: Maybe<Offer>;
};

export type RootMessagePackMessageOrderingEventContent = BuilderContentable & {
  __typename?: 'RootMessagePackMessageOrderingEventContent';
  content?: Maybe<RootMessagePackMessageContent>;
  contentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  orderingEvent?: Maybe<OrderingEvent>;
};

export type RootMessagePackMessageOrderingOfferContent = BuilderContentable & {
  __typename?: 'RootMessagePackMessageOrderingOfferContent';
  content?: Maybe<RootMessagePackMessageContent>;
  contentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  orderingOffer?: Maybe<OrderingOffer>;
};

export type RootMessagePackMessageRootOrderingOfferContent = BuilderContentable & {
  __typename?: 'RootMessagePackMessageRootOrderingOfferContent';
  content?: Maybe<RootMessagePackMessageContent>;
  contentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  rootOrderingOffer?: Maybe<RootOrderingOffer>;
};

export type RootMessagePackMessageTextContent = BuilderContentable & {
  __typename?: 'RootMessagePackMessageTextContent';
  content?: Maybe<RootMessagePackMessageContent>;
  contentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  textContent?: Maybe<Scalars['String']['output']>;
};

export type RootMessagePackPaginationHandler = {
  __typename?: 'RootMessagePackPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<RootMessagePack>;
};

export type RootMessagePackSelectedCategory = {
  __typename?: 'RootMessagePackSelectedCategory';
  category: RootMessagePackCategory;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  rootMessagePack: RootMessagePack;
  updatedAt: Scalars['DateTime']['output'];
};

export type RootMessagePackSelectedCategoryInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  rootMessagePackId?: InputMaybe<Scalars['Int']['input']>;
};

export type RootMessagePackSocialPost = RootMessagePackCommunicationable & {
  __typename?: 'RootMessagePackSocialPost';
  communicationPreview?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  photoUploadedPhoto?: Maybe<UploadedPhoto>;
};

export type RootMessagePackSocialPostInput = {
  message: Scalars['String']['input'];
  photoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
};

export type RootNote = {
  __typename?: 'RootNote';
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  isResolved?: Maybe<Scalars['Boolean']['output']>;
  noteType: Scalars['String']['output'];
  pinnedAt?: Maybe<Scalars['DateTime']['output']>;
  pinnedByUser?: Maybe<User>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedByUser?: Maybe<User>;
  restaurant?: Maybe<Restaurant>;
  user?: Maybe<User>;
};

export type RootNoteInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isResolved?: InputMaybe<Scalars['Boolean']['input']>;
  noteType?: InputMaybe<Scalars['String']['input']>;
};

export type RootNoteVersion = Versionable & {
  __typename?: 'RootNoteVersion';
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  locationMenuName?: Maybe<Scalars['String']['output']>;
  objectChanges: Array<VersionDiff>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

export type RootOrderingOffer = {
  __typename?: 'RootOrderingOffer';
  amount: Scalars['Decimal']['output'];
  deliveryMethod: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isOnetimeUse: Scalars['Boolean']['output'];
  isOnetimeUsePerOrder: Scalars['Boolean']['output'];
  minimumOrderAmount: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
  offerType: Scalars['String']['output'];
  redemptionLimit?: Maybe<Scalars['Int']['output']>;
};

export type RootPlace = {
  __typename?: 'RootPlace';
  feedTitle: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locationsCount: Scalars['Int']['output'];
  menuItem?: Maybe<MenuItem>;
  menuItems: MenuItemPaginationHandler;
  menuItemsCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};


export type RootPlaceMenuItemArgs = {
  id: Scalars['Int']['input'];
};


export type RootPlaceMenuItemsArgs = {
  pagination: PaginationInput;
  rootDishCategorySlug?: InputMaybe<Scalars['String']['input']>;
};

export type RootPlacePaginationHandler = {
  __typename?: 'RootPlacePaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<RootPlace>;
};

export type RootPlatformFee = {
  __typename?: 'RootPlatformFee';
  amount: Scalars['Decimal']['output'];
  amountType: Amount;
  fulfillmentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
};

export type RootSectionTemplate = {
  __typename?: 'RootSectionTemplate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  restaurant?: Maybe<Restaurant>;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  screenshotUploadedPhoto?: Maybe<UploadedPhoto>;
  screenshotUrl?: Maybe<Scalars['String']['output']>;
  sectionId?: Maybe<Scalars['Int']['output']>;
};

export type RootSectionTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
  screenshotUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  sectionId: Scalars['Int']['input'];
};

export type RootSectionTemplatePaginationHandler = {
  __typename?: 'RootSectionTemplatePaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<RootSectionTemplate>;
};

export type RootSectionType = {
  __typename?: 'RootSectionType';
  categoryName: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  templateHtml: Scalars['String']['output'];
  variableNames?: Maybe<Array<Scalars['String']['output']>>;
};

export type RootSectionTypeInput = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  templateHtml?: InputMaybe<Scalars['String']['input']>;
};

export type RootSectionTypePaginationHandler = {
  __typename?: 'RootSectionTypePaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<RootSectionType>;
};

export type RootSectionTypeVersion = Versionable & {
  __typename?: 'RootSectionTypeVersion';
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  locationMenuName?: Maybe<Scalars['String']['output']>;
  objectChanges: Array<VersionDiff>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

export type RootSiteTemplate = {
  __typename?: 'RootSiteTemplate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isEssentialsEnabled: Scalars['Boolean']['output'];
  isRootAccessOnly: Scalars['Boolean']['output'];
  isThemeTemplate?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  previewScreenshots: Array<RootSiteTemplatePreviewScreenshot>;
  restaurant?: Maybe<Restaurant>;
  restaurantId: Scalars['Int']['output'];
  rootSiteTemplates: Array<RootSiteTemplate>;
  screenshotUploadedPhoto?: Maybe<UploadedPhoto>;
  screenshotUrl?: Maybe<Scalars['String']['output']>;
};

export type RootSiteTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isEssentialsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isRootAccessOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isThemeTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  previewScreenshots?: InputMaybe<Array<RootSiteTemplatePreviewScreenshotInputType>>;
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
  screenshotUploadedPhoto?: InputMaybe<SelectedUploadInput>;
};

export type RootSiteTemplatePaginationHandler = {
  __typename?: 'RootSiteTemplatePaginationHandler';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  offset: Scalars['Int']['output'];
  records: Array<RootSiteTemplate>;
};

export type RootSiteTemplatePreviewScreenshot = {
  __typename?: 'RootSiteTemplatePreviewScreenshot';
  id: Scalars['Int']['output'];
  imageUploadedPhoto?: Maybe<UploadedPhoto>;
  imageUrl: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  thumbnailUrl: Scalars['String']['output'];
};

export type RootSiteTemplatePreviewScreenshotInputType = {
  id?: InputMaybe<Scalars['Int']['input']>;
  imageUploadedPhoto?: InputMaybe<SelectedUploadInput>;
};

export type RootTask = {
  __typename?: 'RootTask';
  actionLink?: Maybe<Scalars['String']['output']>;
  actionTitle?: Maybe<Scalars['String']['output']>;
  concierge?: Maybe<Scalars['Boolean']['output']>;
  conciergeMessage?: Maybe<Scalars['String']['output']>;
  dismissible?: Maybe<Scalars['Boolean']['output']>;
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recurring?: Maybe<Scalars['Boolean']['output']>;
  root?: Maybe<Scalars['Boolean']['output']>;
  stagingClients?: Maybe<Scalars['Boolean']['output']>;
  taskCategory: Scalars['String']['output'];
  taskType: Scalars['String']['output'];
};

export type RootTaskAction = {
  __typename?: 'RootTaskAction';
  actionId: Scalars['Int']['output'];
  body: Scalars['String']['output'];
  calendarEvent?: Maybe<CalendarEvent>;
  completed: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customPageAdvancedFormEntry?: Maybe<CustomPageAdvancedFormEntry>;
  dismissed: Scalars['Boolean']['output'];
  dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  googleReview?: Maybe<GoogleMyBusinessLocationReview>;
  id: Scalars['Int']['output'];
  memberAlert?: Maybe<RestaurantMemberAlert>;
  orderingEvent?: Maybe<OrderingEvent>;
  phoneCall?: Maybe<TwilioPhoneCall>;
  read: Scalars['Boolean']['output'];
  restaurantId: Scalars['Int']['output'];
  review?: Maybe<Review>;
  rootTask?: Maybe<RootTask>;
  title: Scalars['String']['output'];
};

export type RootTaskActionInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RootTaskInput = {
  actionLink?: InputMaybe<Scalars['String']['input']>;
  actionTitle?: InputMaybe<Scalars['String']['input']>;
  concierge: Scalars['Boolean']['input'];
  conciergeMessage?: InputMaybe<Scalars['String']['input']>;
  dismissible: Scalars['Boolean']['input'];
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recurring: Scalars['Boolean']['input'];
  root: Scalars['Boolean']['input'];
  stagingClients: Scalars['Boolean']['input'];
  taskType: Scalars['String']['input'];
};

export type RootTaskReviewAction = {
  __typename?: 'RootTaskReviewAction';
  actionId?: Maybe<Scalars['Int']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  dismissed?: Maybe<Scalars['Boolean']['output']>;
  dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  googleReview?: Maybe<GoogleMyBusinessLocationReview>;
  id: Scalars['Int']['output'];
  restaurantId: Scalars['Int']['output'];
  review?: Maybe<Review>;
  rootTask?: Maybe<RootTask>;
};

export type RootTheme = {
  __typename?: 'RootTheme';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customCss?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type RootThemeInput = {
  customCss?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type RootThemePaginationHandler = {
  __typename?: 'RootThemePaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<RootTheme>;
};

export type RootThemeTemplate = {
  __typename?: 'RootThemeTemplate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAvailableToEssential: Scalars['Boolean']['output'];
  isAvailableToStarter: Scalars['Boolean']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isRootAccessOnly: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  restaurant?: Maybe<Restaurant>;
  restaurantId: Scalars['Int']['output'];
  screenshotUploadedPhoto?: Maybe<UploadedPhoto>;
  screenshotUrl?: Maybe<Scalars['String']['output']>;
};

export type RootThemeTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isAvailableToEssential?: InputMaybe<Scalars['Boolean']['input']>;
  isAvailableToStarter?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isRootAccessOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
  screenshotUploadedPhoto?: InputMaybe<SelectedUploadInput>;
};

export type RootThemeTemplatePaginationHandler = {
  __typename?: 'RootThemeTemplatePaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<RootThemeTemplate>;
};

export type RootThemeVersion = Versionable & {
  __typename?: 'RootThemeVersion';
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  locationMenuName?: Maybe<Scalars['String']['output']>;
  objectChanges: Array<VersionDiff>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

export type RootUserInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  userRole: Scalars['String']['input'];
};

/** Autogenerated input type of RunAimFeatureEvaluation */
export type RunAimFeatureEvaluationInput = {
  aimPromptConfigId: Scalars['Int']['input'];
  brief?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of RunProcess */
export type RunProcessInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
};

/** Autogenerated return type of RunProcess. */
export type RunProcessPayload = {
  __typename?: 'RunProcessPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type SalesforceAccount = {
  __typename?: 'SalesforceAccount';
  accountManager?: Maybe<SalesforceUser>;
  accountOwnerAppointmentLinkC?: Maybe<Scalars['String']['output']>;
  accountTierC?: Maybe<Scalars['String']['output']>;
  billingcity?: Maybe<Scalars['String']['output']>;
  billingcountry?: Maybe<Scalars['String']['output']>;
  billingpostalcode?: Maybe<Scalars['String']['output']>;
  billingstate?: Maybe<Scalars['String']['output']>;
  billingstreet?: Maybe<Scalars['String']['output']>;
  chargebeeappsEmailC?: Maybe<Scalars['String']['output']>;
  chargebeeappsFirstNameC?: Maybe<Scalars['String']['output']>;
  chargebeeappsLastNameC?: Maybe<Scalars['String']['output']>;
  chargebeeappsVatNumberC?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isLocation: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  onboardingConsultant?: Maybe<SalesforceUser>;
  parentAccount?: Maybe<SalesforceAccount>;
  phone?: Maybe<Scalars['String']['output']>;
  recordTypeIsConceptGroup?: Maybe<Scalars['Boolean']['output']>;
  restaurant?: Maybe<Restaurant>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SalesforceAccountInput = {
  billingCity: Scalars['String']['input'];
  billingCountry: Scalars['String']['input'];
  billingEmail: Scalars['String']['input'];
  billingPhone: Scalars['String']['input'];
  billingPostalCode: Scalars['String']['input'];
  billingState?: InputMaybe<Scalars['String']['input']>;
  billingStreetAddress: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type SalesforceAccountSnapshot = {
  __typename?: 'SalesforceAccountSnapshot';
  linkedLocationArchived?: Maybe<Scalars['Boolean']['output']>;
  linkedLocationId?: Maybe<Scalars['Int']['output']>;
  linkedLocationName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sfid: Scalars['String']['output'];
};

export type SalesforceCase = {
  __typename?: 'SalesforceCase';
  account: SalesforceAccount;
  caseOwnerName: Scalars['String']['output'];
  casenumber: Scalars['String']['output'];
  createddate: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isInProgress: Scalars['Boolean']['output'];
  isNew: Scalars['Boolean']['output'];
  isResolved: Scalars['Boolean']['output'];
  parentAccount?: Maybe<SalesforceAccount>;
  status: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  systemmodstamp: Scalars['DateTime']['output'];
};

export type SalesforceCaseReply = {
  __typename?: 'SalesforceCaseReply';
  createddate: Scalars['DateTime']['output'];
  replyFrom: Scalars['String']['output'];
  replyText: Scalars['String']['output'];
  replyTo: Scalars['String']['output'];
  sfid: Scalars['String']['output'];
};

export type SalesforceConceptChildAccount = {
  __typename?: 'SalesforceConceptChildAccount';
  connectionState: Scalars['String']['output'];
  linkedLocationId?: Maybe<Scalars['Int']['output']>;
  linkedLocationName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sfid: Scalars['String']['output'];
};

export type SalesforceDisconnectTarget = {
  __typename?: 'SalesforceDisconnectTarget';
  description: Scalars['String']['output'];
  sfid?: Maybe<Scalars['String']['output']>;
  side: Scalars['String']['output'];
};

export type SalesforceLead = {
  __typename?: 'SalesforceLead';
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  restaurant?: Maybe<Restaurant>;
};

/** Autogenerated input type of SalesforceMigrationConnectAccountToLocation */
export type SalesforceMigrationConnectAccountToLocationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  popmenuLocationId: Scalars['Int']['input'];
  sfid: Scalars['String']['input'];
};

/** Autogenerated input type of SalesforceMigrationDisconnectAccountFromLocation */
export type SalesforceMigrationDisconnectAccountFromLocationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  popmenuLocationId: Scalars['Int']['input'];
  sfid: Scalars['String']['input'];
};

export type SalesforceMigrationInspectResult = {
  __typename?: 'SalesforceMigrationInspectResult';
  conceptChildren?: Maybe<Array<SalesforceConceptChildAccount>>;
  salesforceLocationAccount?: Maybe<SalesforceAccountSnapshot>;
  sfidClassification: Scalars['String']['output'];
  verify?: Maybe<SalesforceMigrationVerify>;
};

export type SalesforceMigrationResult = {
  __typename?: 'SalesforceMigrationResult';
  errors: Array<Scalars['String']['output']>;
  inspect: SalesforceMigrationInspectResult;
  /** Only meaningful for Connect — verification that both sides now point to each other. Null on Disconnect. */
  match?: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SalesforceMigrationVerify = {
  __typename?: 'SalesforceMigrationVerify';
  actionEnabled: Scalars['String']['output'];
  disconnectTarget?: Maybe<SalesforceDisconnectTarget>;
  flag: Scalars['String']['output'];
  message: Scalars['String']['output'];
  orderingHistoryEvidence?: Maybe<SalesforceOrderingHistoryEvidence>;
  popmenuLocation: SalesforcePopmenuLocationSnapshot;
  salesforceAccount: SalesforceAccountSnapshot;
};

export type SalesforceOrderingHistoryEvidence = {
  __typename?: 'SalesforceOrderingHistoryEvidence';
  externalOrdersCount: Scalars['Int']['output'];
  orderingEventsCount: Scalars['Int']['output'];
};

export type SalesforcePopTrigger = {
  __typename?: 'SalesforcePopTrigger';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  numberOfLocationsC: Scalars['Int']['output'];
  preferredCommunicationMethodC: Scalars['String']['output'];
  preferredCommunicationTimeC: Scalars['String']['output'];
};

export type SalesforcePopTriggerInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfLocations?: InputMaybe<Scalars['Int']['input']>;
  preferredCommunicationMethod?: InputMaybe<Scalars['String']['input']>;
  preferredCommunicationTime?: InputMaybe<Scalars['String']['input']>;
};

export type SalesforcePopmenuLocationSnapshot = {
  __typename?: 'SalesforcePopmenuLocationSnapshot';
  archived: Scalars['Boolean']['output'];
  currentSfName?: Maybe<Scalars['String']['output']>;
  currentSfSfid?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type SalesforceUser = {
  __typename?: 'SalesforceUser';
  appointmentLinkC?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  mediumphotourl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of SaveTwilioBusinessRegistration */
export type SaveTwilioBusinessRegistrationInput = {
  businessRegistrationInput: TwilioBusinessRegistrationInputType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
};

export type SearchConsoleReport = {
  __typename?: 'SearchConsoleReport';
  brandedClicks: Scalars['Int']['output'];
  clicks?: Maybe<Scalars['Int']['output']>;
  ctr?: Maybe<Scalars['Decimal']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  impressions?: Maybe<Scalars['Int']['output']>;
  month: Scalars['Int']['output'];
  position?: Maybe<Scalars['Decimal']['output']>;
  queriesCount: Scalars['Int']['output'];
  queriesInTop3Count: Scalars['Int']['output'];
  queriesInTop10Count: Scalars['Int']['output'];
  queriesShownCount: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type SectionFeaturedItemInput = {
  dishId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  menuItemId?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  reviewId?: InputMaybe<Scalars['Int']['input']>;
  typename?: InputMaybe<Scalars['String']['input']>;
};

export type SelectedMediumInput = {
  mediaId: Scalars['Int']['input'];
  mediaType: Scalars['String']['input'];
  position: Scalars['Int']['input'];
};

export enum SelectedMenuItemsPersistStatusEnum {
  All = 'all',
  None = 'none',
  Partial = 'partial'
}

export type SelectedUploadInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  fullUrl?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  originalFilename?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type SelectedVideoInput = {
  fullUrl?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  originalFilename?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type SelfSignUpCaptureLeadAttributesInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  productPlan?: InputMaybe<Scalars['String']['input']>;
  signupAbandonedAt?: InputMaybe<Scalars['String']['input']>;
  signupAbandonedStep?: InputMaybe<Scalars['String']['input']>;
  signupStartedAt?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of SelfSignUpCaptureLead */
export type SelfSignUpCaptureLeadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: SelfSignUpCaptureLeadAttributesInput;
};

export type SelfSignUpCreateAccountAttributesInput = {
  city: Scalars['String']['input'];
  communicationTime?: InputMaybe<Scalars['String']['input']>;
  communicationType?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['String']['input'];
  country: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  locations: Scalars['Int']['input'];
  menuUrl?: InputMaybe<Scalars['String']['input']>;
  optInInformationalText?: InputMaybe<Scalars['Boolean']['input']>;
  optInPromotionalText?: InputMaybe<Scalars['Boolean']['input']>;
  partnerEmail?: InputMaybe<Scalars['String']['input']>;
  partnerFirstName?: InputMaybe<Scalars['String']['input']>;
  partnerLastName?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  phoneType: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  productPlan?: InputMaybe<Scalars['String']['input']>;
  signupFlow?: InputMaybe<Scalars['String']['input']>;
  siteDesignExamples: Array<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of SelfSignUpCreateAccount */
export type SelfSignUpCreateAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: SelfSignUpCreateAccountAttributesInput;
};

export enum SelfSignUpFeedbackEventEnum {
  FiringUpYourOrder = 'firing_up_your_order',
  PreppingYourProfile = 'prepping_your_profile',
  SeasoningYourDesign = 'seasoning_your_design',
  ServingUpYourMyPopDashboard = 'serving_up_your_my_pop_dashboard'
}

export type SelfSignUpFeedbackReturn = {
  __typename?: 'SelfSignUpFeedbackReturn';
  event: SelfSignUpFeedbackEventEnum;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SelfSignUpPlan = {
  __typename?: 'SelfSignUpPlan';
  annualSavingsAmount?: Maybe<Scalars['Int']['output']>;
  annualSavingsPercentage?: Maybe<Scalars['Int']['output']>;
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  intervalCount: Scalars['Int']['output'];
  intervalType: Scalars['String']['output'];
  lineItems: Array<SelfSignUpPlanLineItem>;
  name: Scalars['String']['output'];
  oneTimeAmount: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  recurringAmount: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  trialPeriodDays: Scalars['Int']['output'];
};

export type SelfSignUpPlanLineItem = {
  __typename?: 'SelfSignUpPlanLineItem';
  isOneTime: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
};

/** Autogenerated input type of SendMeLinkMessage */
export type SendMeLinkMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

/** Autogenerated input type of SendMessageCampaignPreview */
export type SendMessageCampaignPreviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  messageCampaignInput: MessageCampaignInput;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of SendMessageCampaignTextMessagePreview */
export type SendMessageCampaignTextMessagePreviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  messageCampaignInput: MessageCampaignInput;
  userId: Scalars['Int']['input'];
};

/** Autogenerated input type of SendMessageGroupPreview */
export type SendMessageGroupPreviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messagePreviewInput: MessagePreviewInput;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of SendPhoneVerification */
export type SendPhoneVerificationInput = {
  channel: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  mfaFactorId: Scalars['Int']['input'];
};

/** Autogenerated input type of SendTextMessageGroupPreview */
export type SendTextMessageGroupPreviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  textMessageGroupInput: TextMessageGroupInput;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type SentMessagesMetrics = {
  __typename?: 'SentMessagesMetrics';
  messageCampaignsCount?: Maybe<Scalars['Int']['output']>;
  messageCampaignsPercentage?: Maybe<Scalars['Int']['output']>;
  messageGroupsCount?: Maybe<Scalars['Int']['output']>;
  messageGroupsPercentage?: Maybe<Scalars['Int']['output']>;
  textMessageGroupsCount?: Maybe<Scalars['Int']['output']>;
  textMessageGroupsPercentage?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SeoCrawl = {
  __typename?: 'SeoCrawl';
  crawlAt: Scalars['DateTime']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  indexablePagesCount?: Maybe<Scalars['Int']['output']>;
  issueCount: Scalars['Int']['output'];
  issues: Array<SeoCrawlIssue>;
  opportunityCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
  warningCount: Scalars['Int']['output'];
};

export type SeoCrawlIssue = {
  __typename?: 'SeoCrawlIssue';
  description?: Maybe<Scalars['String']['output']>;
  howToFix?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  issueType: Scalars['String']['output'];
  issueUrls: Array<SeoCrawlIssueUrl>;
  issueUrlsCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  percentOfTotal?: Maybe<Scalars['Decimal']['output']>;
  priority: Scalars['String']['output'];
  urlsCount?: Maybe<Scalars['Int']['output']>;
};

export type SeoCrawlIssueUrl = {
  __typename?: 'SeoCrawlIssueUrl';
  id: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type SeoDashboard = {
  __typename?: 'SeoDashboard';
  aiReadiness: SeoDashboardAiReadiness;
  availableMonths: Array<SeoDashboardMonth>;
  cloudflareTrafficReport?: Maybe<CloudflareTrafficReport>;
  cwvBenchmarks: Array<RootCwvTechReport>;
  id: Scalars['String']['output'];
  indexPositionHistory: Array<SeoDashboardPositionBucketPoint>;
  isLatest: Scalars['Boolean']['output'];
  keywords: Array<SeoDashboardKeyword>;
  lighthouseReport?: Maybe<LighthouseReport>;
  locations: Array<SeoDashboardLocation>;
  locationsCount: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  positionHistory: Array<SeoDashboardPositionBucketPoint>;
  previousCloudflareTrafficReport?: Maybe<CloudflareTrafficReport>;
  previousLighthouseReport?: Maybe<LighthouseReport>;
  previousSearchConsoleReport?: Maybe<SearchConsoleReport>;
  previousSeoCrawl?: Maybe<SeoCrawl>;
  previousSeoReport?: Maybe<SeoReport>;
  recordedDeviceVisits?: Maybe<SeoDashboardDeviceVisits>;
  recordedTrafficHistory: Array<SeoDashboardRecordedTrafficPoint>;
  searchConsoleEarliestDataOn?: Maybe<Scalars['String']['output']>;
  searchConsoleReport?: Maybe<SearchConsoleReport>;
  seoCrawl?: Maybe<SeoCrawl>;
  seoReport?: Maybe<SeoReport>;
  siteHealthFindings: Array<SeoDashboardSiteHealthFinding>;
  siteHealthPassingChecks: Array<SeoDashboardSiteHealthPassingCheck>;
  topPages: Array<SeoDashboardPageVisits>;
  trafficHistory: Array<SeoDashboardTrafficPoint>;
  year: Scalars['Int']['output'];
};

export type SeoDashboardAiReadiness = {
  __typename?: 'SeoDashboardAiReadiness';
  checkedAt: Scalars['DateTime']['output'];
  emptyMenuNames: Array<Scalars['String']['output']>;
  llmsTxtUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  menusCount: Scalars['Int']['output'];
  siteUrl?: Maybe<Scalars['String']['output']>;
  sitemapUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  sitemapUrlsCount?: Maybe<Scalars['Int']['output']>;
};

export type SeoDashboardDeviceVisits = {
  __typename?: 'SeoDashboardDeviceVisits';
  allVisits: Scalars['Int']['output'];
  desktopVisits: Scalars['Int']['output'];
  mobileVisits: Scalars['Int']['output'];
  tabletVisits: Scalars['Int']['output'];
};

export type SeoDashboardKeyword = {
  __typename?: 'SeoDashboardKeyword';
  clicks?: Maybe<Scalars['Int']['output']>;
  ctr?: Maybe<Scalars['Decimal']['output']>;
  impressions?: Maybe<Scalars['Int']['output']>;
  isBranded: Scalars['Boolean']['output'];
  position?: Maybe<Scalars['Decimal']['output']>;
  previousPosition?: Maybe<Scalars['Decimal']['output']>;
  query: Scalars['String']['output'];
  topPagePath?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Int']['output']>;
};

export type SeoDashboardLighthouseAudit = {
  __typename?: 'SeoDashboardLighthouseAudit';
  auditId: Scalars['String']['output'];
  category: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  learnMoreUrl?: Maybe<Scalars['String']['output']>;
  pageReports: Array<LighthouseReportPageReport>;
  savingsMs?: Maybe<Scalars['Int']['output']>;
  scripts: Array<SeoDashboardLighthouseScript>;
  title: Scalars['String']['output'];
};

export type SeoDashboardLighthouseScript = {
  __typename?: 'SeoDashboardLighthouseScript';
  totalBytes?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
  wastedBytes?: Maybe<Scalars['Int']['output']>;
};

export type SeoDashboardLocation = {
  __typename?: 'SeoDashboardLocation';
  location: RestaurantLocation;
  packRankings: Array<SeoDashboardPackRanking>;
  rating?: Maybe<Scalars['Decimal']['output']>;
  ratingVotesCount?: Maybe<Scalars['Int']['output']>;
  topRival?: Maybe<SeoDashboardTopRival>;
  tracked: Scalars['Boolean']['output'];
};

export type SeoDashboardMonth = {
  __typename?: 'SeoDashboardMonth';
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type SeoDashboardPackMapResult = {
  __typename?: 'SeoDashboardPackMapResult';
  isOwn: Scalars['Boolean']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  rank: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type SeoDashboardPackRanking = {
  __typename?: 'SeoDashboardPackRanking';
  keyword: Scalars['String']['output'];
  lat: Scalars['Decimal']['output'];
  lng: Scalars['Decimal']['output'];
  mapResults: Array<SeoDashboardPackMapResult>;
  previousRank?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  searchedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SeoDashboardPageVisits = {
  __typename?: 'SeoDashboardPageVisits';
  name?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  previousVisits?: Maybe<Scalars['Int']['output']>;
  visits: Scalars['Int']['output'];
};

export type SeoDashboardPositionBucketPoint = {
  __typename?: 'SeoDashboardPositionBucketPoint';
  beyond: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  top3: Scalars['Int']['output'];
  top10: Scalars['Int']['output'];
  top20: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type SeoDashboardRecordedTrafficPoint = {
  __typename?: 'SeoDashboardRecordedTrafficPoint';
  allVisits: Scalars['Int']['output'];
  directVisits: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  otherVisits: Scalars['Int']['output'];
  searchVisits: Scalars['Int']['output'];
  socialVisits: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type SeoDashboardSiteHealthFinding = {
  __typename?: 'SeoDashboardSiteHealthFinding';
  affectedCount: Scalars['Int']['output'];
  category: Scalars['String']['output'];
  key: Scalars['String']['output'];
  lighthouseAudit?: Maybe<SeoDashboardLighthouseAudit>;
  locationNames: Array<Scalars['String']['output']>;
  priority: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  seoCrawlIssue?: Maybe<SeoCrawlIssue>;
};

export type SeoDashboardSiteHealthPassingCheck = {
  __typename?: 'SeoDashboardSiteHealthPassingCheck';
  category: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type SeoDashboardTopRival = {
  __typename?: 'SeoDashboardTopRival';
  rating?: Maybe<Scalars['Decimal']['output']>;
  ratingVotesCount?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type SeoDashboardTrafficPoint = {
  __typename?: 'SeoDashboardTrafficPoint';
  month: Scalars['Int']['output'];
  organicTraffic?: Maybe<Scalars['Int']['output']>;
  year: Scalars['Int']['output'];
};

export type SeoReport = {
  __typename?: 'SeoReport';
  backlinks: Array<SeoReportBacklink>;
  backlinksAllTimeCount?: Maybe<Scalars['Int']['output']>;
  backlinksLiveCount?: Maybe<Scalars['Int']['output']>;
  domain: Scalars['String']['output'];
  domainRating?: Maybe<Scalars['Decimal']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  keywords: Array<SeoReportKeyword>;
  keywordsCount: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  organicTraffic?: Maybe<Scalars['Int']['output']>;
  organicTrafficCost?: Maybe<Scalars['Int']['output']>;
  refdomainsAllTimeCount?: Maybe<Scalars['Int']['output']>;
  refdomainsLiveCount?: Maybe<Scalars['Int']['output']>;
  topBacklinksCount: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type SeoReportBacklink = {
  __typename?: 'SeoReportBacklink';
  anchor?: Maybe<Scalars['String']['output']>;
  domainRatingSource?: Maybe<Scalars['Decimal']['output']>;
  firstSeenAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  urlFrom: Scalars['String']['output'];
};

export type SeoReportKeyword = {
  __typename?: 'SeoReportKeyword';
  bestPosition?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  keyword: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  sumTraffic?: Maybe<Scalars['Int']['output']>;
  volume?: Maybe<Scalars['Int']['output']>;
};

export type Session = {
  __typename?: 'Session';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  calendarEventPops: Array<CalendarEventPop>;
  id: Scalars['String']['output'];
  isAuthyRequired: Scalars['Boolean']['output'];
  isAuthyVerified: Scalars['Boolean']['output'];
  isMfaRequired: Scalars['Boolean']['output'];
  isMfaVerified: Scalars['Boolean']['output'];
  isSoftAuthenticated: Scalars['Boolean']['output'];
  pendingMenuItemCart?: Maybe<MenuItemCart>;
  pendingMenuItemCartContainsAlcohol?: Maybe<Array<MenuItemCartContainsAlcohol>>;
  pops: Array<Pop>;
  reviewUpvotes: Array<ReviewUpvote>;
  reviews: Array<Review>;
  salesforceLead?: Maybe<SalesforceLead>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};


export type SessionPendingMenuItemCartArgs = {
  cartRestaurantId?: InputMaybe<Scalars['Int']['input']>;
  cartType: Scalars['String']['input'];
  fulfillmentType?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  orderingEventId?: InputMaybe<Scalars['Int']['input']>;
};


export type SessionPendingMenuItemCartContainsAlcoholArgs = {
  cartType: Scalars['String']['input'];
  locationsId?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type SharedExtraGroupToastWarning = ProviderWarning & {
  __typename?: 'SharedExtraGroupToastWarning';
  id: Scalars['Int']['output'];
  warningType: Scalars['String']['output'];
};

export type ShopItem = {
  __typename?: 'ShopItem';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  prices: Array<ShopItemPrice>;
  restaurant?: Maybe<Restaurant>;
  restaurantId?: Maybe<Scalars['Int']['output']>;
};

export type ShopItemCart = {
  __typename?: 'ShopItemCart';
  capturedAmount?: Maybe<Scalars['Decimal']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isSubmitted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  netOriginalTotal?: Maybe<Scalars['Decimal']['output']>;
  originalSubtotal?: Maybe<Scalars['Decimal']['output']>;
  originalTotal?: Maybe<Scalars['Decimal']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  reportAt?: Maybe<Scalars['DateTime']['output']>;
  selectedShopItems: Array<ShopItemCartSelectedShopItem>;
  slug?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ShopItemCartInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  paymentMethod: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
  selectedShopItems: Array<ShopItemCartSelectedShopItemInput>;
};

export type ShopItemCartReport = {
  __typename?: 'ShopItemCartReport';
  capturedAmountTotal: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  reportAt: Scalars['DateTime']['output'];
  shopItemCarts: Array<ShopItemCart>;
  shopItemCartsCount: Scalars['Int']['output'];
  subtotalTotal: Scalars['Decimal']['output'];
  totalTotal: Scalars['Decimal']['output'];
};

export type ShopItemCartSelectedShopItem = {
  __typename?: 'ShopItemCartSelectedShopItem';
  id: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  recipientEmail?: Maybe<Scalars['String']['output']>;
  recipientName?: Maybe<Scalars['String']['output']>;
  senderEmail?: Maybe<Scalars['String']['output']>;
  senderName?: Maybe<Scalars['String']['output']>;
  shopItemId?: Maybe<Scalars['Int']['output']>;
  shopItemName?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Scalars['Decimal']['output']>;
};

export type ShopItemCartSelectedShopItemInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  recipientName?: InputMaybe<Scalars['String']['input']>;
  selectedImage?: InputMaybe<ShopItemCartSelectedShopItemSelectedImageInput>;
  selectedPrice?: InputMaybe<ShopItemCartSelectedShopItemSelectedPriceInput>;
  senderEmail?: InputMaybe<Scalars['String']['input']>;
  senderName?: InputMaybe<Scalars['String']['input']>;
  shopItemId?: InputMaybe<Scalars['Int']['input']>;
};

export type ShopItemCartSelectedShopItemSelectedImageInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  imageUploadedPhotoId: Scalars['Int']['input'];
};

export type ShopItemCartSelectedShopItemSelectedPriceInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  shopItemPriceId: Scalars['Int']['input'];
};

export type ShopItemInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  prices?: InputMaybe<Array<ShopItemPriceInput>>;
};

export type ShopItemPrice = {
  __typename?: 'ShopItemPrice';
  id: Scalars['Int']['output'];
  price?: Maybe<Scalars['Decimal']['output']>;
};

export type ShopItemPriceInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Int']['input'];
};

export type SignUpSettingInput = {
  isSignUpAnniversaryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isSignUpAnniversaryRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isSignUpBirthdayEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isSignUpBirthdayRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isSignUpNameEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isSignUpNameRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isSignUpPhoneEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isSignUpPhoneRequired?: InputMaybe<Scalars['Boolean']['input']>;
  signUpLogoEffect?: InputMaybe<Scalars['String']['input']>;
};

export type SiteVisitsMetrics = {
  __typename?: 'SiteVisitsMetrics';
  currentWeekSiteVisitsCount: Scalars['Int']['output'];
  previousWeekSiteVisitsCount: Scalars['Int']['output'];
};

export type SiteVisitsMetricsByDaysAgo = {
  __typename?: 'SiteVisitsMetricsByDaysAgo';
  currentSiteVisitsCount: Scalars['Int']['output'];
  previousSiteVisitsCount?: Maybe<Scalars['Int']['output']>;
};

export type SizesToVariationsInput = {
  menuItemSizeId: Scalars['Int']['input'];
  providerVariationId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of SkipTwilioVerifyPhoneFactor */
export type SkipTwilioVerifyPhoneFactorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  mfaFactorId: Scalars['Int']['input'];
};

export type SmsLimits = {
  __typename?: 'SmsLimits';
  extraMonthlyTextMessages: Scalars['Int']['output'];
  initialMonthlyMessages: Scalars['Int']['output'];
  isExceedingMmsUsageLimit: Scalars['Boolean']['output'];
  isExceedingSmsUsageLimit: Scalars['Boolean']['output'];
  maxMonthlyMmsMessages: Scalars['Int']['output'];
  maxMonthlyTextMessages: Scalars['Int']['output'];
  mmsMessagesUsageCount: Scalars['Int']['output'];
  mmsMonthlyCapExhausted: Scalars['Boolean']['output'];
  reachedLimitMms: Scalars['Boolean']['output'];
  reachedLimitSms: Scalars['Boolean']['output'];
  smsMonthlyCapExhausted: Scalars['Boolean']['output'];
  textMessagesUsageCount: Scalars['Int']['output'];
};

export type SmsLimitsInput = {
  followersCount?: InputMaybe<Scalars['Int']['input']>;
  smsUnsubscribedCount?: InputMaybe<Scalars['Int']['input']>;
};

export type SocialAccount = {
  __typename?: 'SocialAccount';
  accountAvatarUrl?: Maybe<Scalars['String']['output']>;
  accountName: Scalars['String']['output'];
  accountPageUrl?: Maybe<Scalars['String']['output']>;
  advisorCardTrackerId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayName: Scalars['String']['output'];
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  facebookPages: Array<SocialAccountFacebookPage>;
  hasInstagram: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  instagramName?: Maybe<Scalars['String']['output']>;
  instagramProfilePictureUrl?: Maybe<Scalars['String']['output']>;
  instagramUserId?: Maybe<Scalars['String']['output']>;
  instagramUsername?: Maybe<Scalars['String']['output']>;
  isExpired?: Maybe<Scalars['Boolean']['output']>;
  isValid: Scalars['Boolean']['output'];
  policy: SocialAccountPolicy;
  restaurant?: Maybe<Restaurant>;
  selectedFacebookPageId?: Maybe<Scalars['Int']['output']>;
  selectedLocations: Array<RestaurantLocation>;
  socialAccountSelectedLocations: Array<SocialAccountSocialAccountSelectedLocation>;
  socialType: Scalars['String']['output'];
  userDisplayName?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type SocialAccountFacebookPage = {
  __typename?: 'SocialAccountFacebookPage';
  id: Scalars['Int']['output'];
  instagramBusinessAccountId?: Maybe<Scalars['String']['output']>;
  instagramPhotos?: Maybe<Array<SocialAccountFacebookPageInstagramPhoto>>;
  pageCategory: Scalars['String']['output'];
  pageCity?: Maybe<Scalars['String']['output']>;
  pageId: Scalars['String']['output'];
  pageName: Scalars['String']['output'];
  pageState?: Maybe<Scalars['String']['output']>;
};

export type SocialAccountFacebookPageInstagramPhoto = {
  __typename?: 'SocialAccountFacebookPageInstagramPhoto';
  caption?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  photoUrl?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
};

export type SocialAccountInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  socialAccountSelectedLocations?: InputMaybe<Array<SocialAccountSelectedLocationInput>>;
};

export type SocialAccountPolicy = {
  __typename?: 'SocialAccountPolicy';
  canManageSocialAccount: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
};

export type SocialAccountSelectedLocationInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
};

export type SocialAccountSocialAccountSelectedLocation = {
  __typename?: 'SocialAccountSocialAccountSelectedLocation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  location: RestaurantLocation;
  updatedAt: Scalars['DateTime']['output'];
};

export type SocialPost = RestaurantMessagePackCommunicationable & {
  __typename?: 'SocialPost';
  advisorCardTrackerId?: Maybe<Scalars['Int']['output']>;
  aiMarketingContent?: Maybe<AiMarketingContent>;
  aiTextGenerationCount: Scalars['Int']['output'];
  calendarEvent?: Maybe<CalendarEvent>;
  campaignItem?: Maybe<CampaignItem>;
  campaignItemId?: Maybe<Scalars['Int']['output']>;
  communication?: Maybe<RestaurantMessagePackCommunication>;
  communicationPreview?: Maybe<Scalars['String']['output']>;
  failedPosts: Array<SocialPostLivePostFailedPost>;
  failureIndicators: Array<SocialPostFailureIndicator>;
  firstThumbnailImage?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  impressionsCount?: Maybe<Scalars['Int']['output']>;
  instagramLivePosts: Array<SocialPostInstagramLivePost>;
  isCreatedByAi?: Maybe<Scalars['Boolean']['output']>;
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  isProcessed?: Maybe<Scalars['Boolean']['output']>;
  isScheduled?: Maybe<Scalars['Boolean']['output']>;
  lastAiGeneratedText?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  livePosts: Array<SocialPostLivePost>;
  menuItem?: Maybe<MenuItem>;
  message: Scalars['String']['output'];
  orderingEvent?: Maybe<OrderingEvent>;
  photoUploadedPhoto?: Maybe<UploadedPhoto>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  publishInstagram?: Maybe<Scalars['Boolean']['output']>;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  selectedAccounts: Array<SocialPostSelectedAccount>;
  selectedMedia: Array<SocialPostSelectedMedium>;
  selectedPhotos: Array<SocialPostSelectedPhoto>;
  selectedPhotosThumbnailImage?: Maybe<Scalars['String']['output']>;
  selectedVideos: Array<SocialPostSelectedVideo>;
  socialAccounts: Array<SocialAccount>;
  sproutSocialProfilePost?: Maybe<SproutSocialProfilePost>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  useShortLinks?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<User>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  videoUploadedVideo?: Maybe<UploadedVideo>;
};

export type SocialPostFailureIndicator = {
  __typename?: 'SocialPostFailureIndicator';
  createdAt: Scalars['DateTime']['output'];
  dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isResolved: Scalars['Boolean']['output'];
  lastFailureMessage?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SocialPostGeneratedAiText = {
  __typename?: 'SocialPostGeneratedAiText';
  text: Scalars['String']['output'];
};

export type SocialPostInput = {
  advisorCardTrackerId?: InputMaybe<Scalars['Int']['input']>;
  aiTextGenerationCount?: InputMaybe<Scalars['Int']['input']>;
  calendarEventId?: InputMaybe<Scalars['Int']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessed?: InputMaybe<Scalars['Boolean']['input']>;
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  lastAiGeneratedText?: InputMaybe<Scalars['String']['input']>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  menuItemId?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  orderingEventId?: InputMaybe<Scalars['Int']['input']>;
  photoUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishInstagram?: InputMaybe<Scalars['Boolean']['input']>;
  restaurantId: Scalars['Int']['input'];
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  selectedAccounts?: InputMaybe<Array<SocialPostSelectedAccountInput>>;
  selectedMedia?: InputMaybe<Array<SelectedMediumInput>>;
  selectedPhotos?: InputMaybe<Array<SelectedUploadInput>>;
  selectedVideos?: InputMaybe<Array<SelectedVideoInput>>;
  shareToInstagramCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  shareToInstagramFeed?: InputMaybe<Scalars['Boolean']['input']>;
  shareToInstagramReels?: InputMaybe<Scalars['Boolean']['input']>;
  shareToInstagramStory?: InputMaybe<Scalars['Boolean']['input']>;
  socialPostSuggestionId?: InputMaybe<Scalars['Int']['input']>;
  useShortLinks?: InputMaybe<Scalars['Boolean']['input']>;
  videoUploadedVideo?: InputMaybe<SelectedUploadInput>;
};

export type SocialPostInstagramLivePost = {
  __typename?: 'SocialPostInstagramLivePost';
  commentsCount?: Maybe<Scalars['Int']['output']>;
  engagements?: Maybe<Scalars['Int']['output']>;
  failureMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  impressions?: Maybe<Scalars['Int']['output']>;
  isProcessed?: Maybe<Scalars['Boolean']['output']>;
  lastStatSnapshotAt?: Maybe<Scalars['DateTime']['output']>;
  livePostUrl?: Maybe<Scalars['String']['output']>;
  postStatus?: Maybe<Scalars['String']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  restaurantName: Scalars['String']['output'];
  restaurantSlug: Scalars['String']['output'];
  socialAccount?: Maybe<SocialAccount>;
  socialPost?: Maybe<SocialPost>;
  socialType: Scalars['String']['output'];
};

export type SocialPostLivePost = {
  __typename?: 'SocialPostLivePost';
  facebookEngagedUsersCount?: Maybe<Scalars['Int']['output']>;
  facebookImpressionsCount?: Maybe<Scalars['Int']['output']>;
  facebookReactionsCount?: Maybe<Scalars['Int']['output']>;
  failureMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isProcessed?: Maybe<Scalars['Boolean']['output']>;
  lastStatSnapshotAt?: Maybe<Scalars['DateTime']['output']>;
  livePostUrl?: Maybe<Scalars['String']['output']>;
  postStatus?: Maybe<Scalars['String']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  restaurantName: Scalars['String']['output'];
  restaurantSlug: Scalars['String']['output'];
  socialAccount?: Maybe<SocialAccount>;
  socialPost?: Maybe<SocialPost>;
  socialType: Scalars['String']['output'];
  twitterFavoritesCount?: Maybe<Scalars['Int']['output']>;
  twitterRetweetsCount?: Maybe<Scalars['Int']['output']>;
};

export type SocialPostLivePostFailedPost = {
  __typename?: 'SocialPostLivePostFailedPost';
  createdAt: Scalars['DateTime']['output'];
  dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  lastFailedAt: Scalars['DateTime']['output'];
  lastFailureMessage: Scalars['String']['output'];
  lastRetryAt?: Maybe<Scalars['DateTime']['output']>;
  retriesCount: Scalars['Int']['output'];
  socialAccountDisplayName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SocialPostPaginationHandler = {
  __typename?: 'SocialPostPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<SocialPost>;
};

export type SocialPostSelectedAccount = {
  __typename?: 'SocialPostSelectedAccount';
  id: Scalars['Int']['output'];
  publishInstagram?: Maybe<Scalars['Boolean']['output']>;
  shareToInstagramCarousel: Scalars['Boolean']['output'];
  shareToInstagramFeed: Scalars['Boolean']['output'];
  shareToInstagramReels: Scalars['Boolean']['output'];
  shareToInstagramStory: Scalars['Boolean']['output'];
  socialAccount: SocialAccount;
  socialPost: SocialPost;
};

export type SocialPostSelectedAccountInput = {
  publishInstagram?: InputMaybe<Scalars['Boolean']['input']>;
  shareToInstagramCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  shareToInstagramFeed?: InputMaybe<Scalars['Boolean']['input']>;
  shareToInstagramReels?: InputMaybe<Scalars['Boolean']['input']>;
  shareToInstagramStory?: InputMaybe<Scalars['Boolean']['input']>;
  socialAccountId: Scalars['Int']['input'];
};

export type SocialPostSelectedMedium = {
  __typename?: 'SocialPostSelectedMedium';
  id: Scalars['Int']['output'];
  media?: Maybe<Medium>;
};

export type SocialPostSelectedPhoto = {
  __typename?: 'SocialPostSelectedPhoto';
  id: Scalars['Int']['output'];
  photoUploadedPhoto?: Maybe<UploadedPhoto>;
  socialPost?: Maybe<SocialPost>;
};

export type SocialPostSelectedVideo = {
  __typename?: 'SocialPostSelectedVideo';
  id: Scalars['Int']['output'];
  socialPost?: Maybe<SocialPost>;
  videoUploadedVideo?: Maybe<UploadedVideo>;
};

export type SocialPostSuggestion = {
  __typename?: 'SocialPostSuggestion';
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  contentable?: Maybe<SocialPostSuggestionContentable>;
  contentableId?: Maybe<Scalars['Int']['output']>;
  contentableType?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  featuredMenuItemId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  previewMessage: Scalars['String']['output'];
  socialPostId?: Maybe<Scalars['Int']['output']>;
  socialPostSelectedMessage?: Maybe<Scalars['String']['output']>;
  socialPostType?: Maybe<Scalars['String']['output']>;
  suggestionType: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uploadedPhoto?: Maybe<UploadedPhoto>;
};

export type SocialPostSuggestionContentable = {
  id: Scalars['Int']['output'];
};

export type SpotonLocation = {
  __typename?: 'SpotonLocation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  spotonId: Scalars['String']['output'];
  spotonRoot: SpotonRoot;
};

export type SpotonLocationAttachmentHandler = {
  __typename?: 'SpotonLocationAttachmentHandler';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SpotonMenu = {
  __typename?: 'SpotonMenu';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SpotonRoot = RestaurantPaymentAccountInterface & {
  __typename?: 'SpotonRoot';
  accountSlug: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  accountUrl: Scalars['String']['output'];
  canDisconnectPos: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isDeleting: Scalars['Boolean']['output'];
  isMenuSyncing: Scalars['Boolean']['output'];
  isShopSupported: Scalars['Boolean']['output'];
  isSyncing: Scalars['Boolean']['output'];
  lastSyncStartedAt?: Maybe<Scalars['DateTime']['output']>;
  menuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  shouldReauthenticate: Scalars['Boolean']['output'];
};

export type SpotonSetting = {
  __typename?: 'SpotonSetting';
  id: Scalars['Int']['output'];
  spotonCateringDeliveryMenuId?: Maybe<Scalars['String']['output']>;
  spotonCateringPickupMenuId?: Maybe<Scalars['String']['output']>;
  spotonDeliveryMenuId?: Maybe<Scalars['String']['output']>;
  spotonOrderingEventMenuIds: Array<Scalars['String']['output']>;
  spotonPickupMenuId?: Maybe<Scalars['String']['output']>;
};

export type SpotonSettingInput = {
  spotonCateringDeliveryMenuId?: InputMaybe<Scalars['String']['input']>;
  spotonCateringPickupMenuId?: InputMaybe<Scalars['String']['input']>;
  spotonDeliveryMenuId?: InputMaybe<Scalars['String']['input']>;
  spotonOrderingEventMenuIds?: InputMaybe<Array<Scalars['String']['input']>>;
  spotonPickupMenuId?: InputMaybe<Scalars['String']['input']>;
};

export type SproutSocialGroup = {
  __typename?: 'SproutSocialGroup';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  restaurant?: Maybe<Restaurant>;
};

export type SproutSocialProfile = {
  __typename?: 'SproutSocialProfile';
  id: Scalars['Int']['output'];
  link?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  networkType?: Maybe<Scalars['String']['output']>;
};

export type SproutSocialProfilePost = {
  __typename?: 'SproutSocialProfilePost';
  commentsCount?: Maybe<Scalars['Int']['output']>;
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  engagementsUnique?: Maybe<Scalars['Int']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  fromProfilePhotoUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  impressions?: Maybe<Scalars['Int']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  permaLink?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<SproutSocialProfile>;
  reactions?: Maybe<Scalars['Int']['output']>;
  sharesCount?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type SquareCategory = {
  __typename?: 'SquareCategory';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SquareItem = ProviderItem & {
  __typename?: 'SquareItem';
  availableVariations: Array<ProviderVariation>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SquareLoyaltyAccount = {
  __typename?: 'SquareLoyaltyAccount';
  balance?: Maybe<Scalars['Int']['output']>;
  enrolledAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isFacebookFollowPromotionEarned: Scalars['Boolean']['output'];
  isInstagramFollowPromotionEarned: Scalars['Boolean']['output'];
  lifetimePoints?: Maybe<Scalars['Int']['output']>;
};

export type SquareLoyaltyProgram = {
  __typename?: 'SquareLoyaltyProgram';
  accrualRule?: Maybe<PopmenuLoyaltyProgramAccrualRule>;
  createdAt: Scalars['DateTime']['output'];
  expirationPolicy?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  promotions: Array<LoyaltyProgramPromotion>;
  rewardTiers: Array<SquareLoyaltyRewardTier>;
  terminologyOne: Scalars['String']['output'];
  terminologyPlural: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SquareLoyaltyRewardTier = {
  __typename?: 'SquareLoyaltyRewardTier';
  amountDiscount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  points: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SquareSellerAccount = RestaurantPaymentAccountInterface & {
  __typename?: 'SquareSellerAccount';
  accountSlug: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  accountUrl: Scalars['String']['output'];
  businessName?: Maybe<Scalars['String']['output']>;
  canDisconnectPos: Scalars['Boolean']['output'];
  catalogLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  connectedByUserDisplayName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  giftCardPermissionStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isDeleting: Scalars['Boolean']['output'];
  isMenuSyncing: Scalars['Boolean']['output'];
  isNonUsBillingEnabled: Scalars['Boolean']['output'];
  isShopSupported: Scalars['Boolean']['output'];
  isSquareCatalogUpdating?: Maybe<Scalars['Boolean']['output']>;
  isSyncing?: Maybe<Scalars['Boolean']['output']>;
  isUsSeller: Scalars['Boolean']['output'];
  languageCode?: Maybe<Scalars['String']['output']>;
  locations: Array<RestaurantLocation>;
  loyaltyProgramStatus?: Maybe<Scalars['String']['output']>;
  menuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  merchantId: Scalars['String']['output'];
  restaurant?: Maybe<Restaurant>;
  shouldReauthenticate: Scalars['Boolean']['output'];
  squareSellerLocations: Array<SquareSellerLocation>;
  status?: Maybe<Scalars['String']['output']>;
};

export type SquareSellerLocation = {
  __typename?: 'SquareSellerLocation';
  businessName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  giftCardPermissionStatus?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  loyaltyProgramStatus?: Maybe<Scalars['String']['output']>;
  merchantId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  squareId?: Maybe<Scalars['String']['output']>;
  squareSellerAccount?: Maybe<SquareSellerAccount>;
  squareSellerAccountId?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type SquareSellerRefund = MenuItemCartRefundable & {
  __typename?: 'SquareSellerRefund';
  amount: Scalars['Decimal']['output'];
  id: Scalars['Int']['output'];
  refundedAt: Scalars['DateTime']['output'];
  refundedByUserEmail?: Maybe<Scalars['String']['output']>;
};

export type SquareVariation = ProviderVariation & {
  __typename?: 'SquareVariation';
  id: Scalars['Int']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  pricingType?: Maybe<Scalars['String']['output']>;
  squareLocations: Array<SquareSellerLocation>;
};

export type StartModularSignUpAttributesInput = {
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  restaurantName: Scalars['String']['input'];
};

/** Autogenerated input type of StartModularSignUp */
export type StartModularSignUpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: StartModularSignUpAttributesInput;
};

/** Autogenerated return type of StartModularSignUp. */
export type StartModularSignUpPayload = {
  __typename?: 'StartModularSignUpPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<ModularSignUpProgress>;
  status: StartModularSignUpStatus;
};

export enum StartModularSignUpStatus {
  Created = 'CREATED',
  RestaurantWithProgressExists = 'RESTAURANT_WITH_PROGRESS_EXISTS',
  UserWithoutMemberExists = 'USER_WITHOUT_MEMBER_EXISTS',
  UserWithMemberExists = 'USER_WITH_MEMBER_EXISTS',
  UserWithProgressExists = 'USER_WITH_PROGRESS_EXISTS'
}

/** Autogenerated input type of StartPushMfaEnrollment */
export type StartPushMfaEnrollmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of StartTrial */
export type StartTrialInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: ModularSignUpStartTrialInput;
};

/** Autogenerated return type of StartTrial. */
export type StartTrialPayload = {
  __typename?: 'StartTrialPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of StartWaitlistTrial */
export type StartWaitlistTrialInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: ModularSignUpStartWaitlistTrialInput;
};

/** Autogenerated return type of StartWaitlistTrial. */
export type StartWaitlistTrialPayload = {
  __typename?: 'StartWaitlistTrialPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum StatusEnum {
  Failure = 'failure',
  Initiated = 'initiated',
  Success = 'success'
}

export type StripeConnectAccount = RestaurantPaymentAccountInterface & {
  __typename?: 'StripeConnectAccount';
  accountSlug: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  accountUrl: Scalars['String']['output'];
  businessEmail?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  canDisconnectPos: Scalars['Boolean']['output'];
  cardPaymentsStatus?: Maybe<Scalars['String']['output']>;
  chargesEnabled?: Maybe<Scalars['Boolean']['output']>;
  connectedByUserDisplayName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isDeleting: Scalars['Boolean']['output'];
  isMenuSyncing: Scalars['Boolean']['output'];
  isShopSupported: Scalars['Boolean']['output'];
  isSyncing?: Maybe<Scalars['Boolean']['output']>;
  locations: Array<RestaurantLocation>;
  menuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  payoutsEnabled?: Maybe<Scalars['Boolean']['output']>;
  restaurant?: Maybe<Restaurant>;
  shouldReauthenticate: Scalars['Boolean']['output'];
  statementDescriptor?: Maybe<Scalars['String']['output']>;
  stripeAccountId: Scalars['String']['output'];
  stripeAccountType: Scalars['String']['output'];
  stripePublishableKey?: Maybe<Scalars['String']['output']>;
  transfersStatus?: Maybe<Scalars['String']['output']>;
};

export type StripeConnectPayment = {
  __typename?: 'StripeConnectPayment';
  amount: Scalars['Decimal']['output'];
  capturedAt?: Maybe<Scalars['DateTime']['output']>;
  cardBrand?: Maybe<Scalars['String']['output']>;
  cardExpMonth?: Maybe<Scalars['Int']['output']>;
  cardExpYear?: Maybe<Scalars['Int']['output']>;
  cardLast4?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isCaptured?: Maybe<Scalars['Boolean']['output']>;
  readyForCapture: Scalars['Boolean']['output'];
  status?: Maybe<Scalars['String']['output']>;
  stripeUrl?: Maybe<Scalars['String']['output']>;
};

export type StripeConnectRefund = MenuItemCartRefundable & {
  __typename?: 'StripeConnectRefund';
  amount: Scalars['Decimal']['output'];
  id: Scalars['Int']['output'];
  refundedAt: Scalars['DateTime']['output'];
  refundedByUserEmail?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of SubmitCampaign */
export type SubmitCampaignInput = {
  campaignId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  remarketedAction?: InputMaybe<Scalars['String']['input']>;
  remarketedCampaignItemId?: InputMaybe<Scalars['Int']['input']>;
  remarketedLocationId?: InputMaybe<Scalars['Int']['input']>;
  remarketedTagId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of SubmitShopItemCart */
export type SubmitShopItemCartInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paymentInput: CartPaymentInput;
  shopItemCartInput: ShopItemCartInput;
};

export type Subscription = {
  __typename?: 'Subscription';
  agentChatWasUpdated?: Maybe<AgentChat>;
  cloverAccountSyncStatusChanged?: Maybe<CloverAccount>;
  createMultiCampaignIsCompleted?: Maybe<MultiCampaignSubscriptionReturnType>;
  customPageDraftWasUpdated?: Maybe<CustomPageDraftWasUpdatedReturn>;
  deliverectChannelStatusChanged?: Maybe<DeliverectChannel>;
  dishWasUpdated?: Maybe<Dish>;
  feedbackWasSubmitted?: Maybe<FeedbackWasSubmittedReturn>;
  liveDomainWasUpdated?: Maybe<LiveDomain>;
  menuItemCartCurbsideArrival?: Maybe<MenuItemCart>;
  menuItemCartSubcartWasAccepted?: Maybe<MenuItemCartSubcart>;
  menuItemCartWasSubmitted?: Maybe<MenuItemCart>;
  menuItemCartWasUpdated?: Maybe<MenuItemCart>;
  menuItemWasDestroyed?: Maybe<MenuItemWasDestroyedReturnType>;
  menuPresenceWasUpdated?: Maybe<Array<MenuPresence>>;
  menuProcessingResultWasUpdated?: Maybe<MenuProcessingResult>;
  menuSectionWasUpdated?: Maybe<MenuSectionWasUpdatedReturn>;
  menuSyncHistoryStatusUpdated?: Maybe<MenuSyncHistory>;
  menuWasUpdated?: Maybe<MenuWasUpdatedReturn>;
  modifierGroupWasUpdated?: Maybe<ModifierGroupWasUpdatedReturnType>;
  partyCountWasUpdated?: Maybe<PartyWasUpdatedReturn>;
  partySettingsWasUpdated?: Maybe<PartySettingsWasUpdatedReturn>;
  partyWasDeleted?: Maybe<PartyWasDeletedReturn>;
  partyWasUpdated?: Maybe<PartyWasUpdatedReturn>;
  paymentAccountSync?: Maybe<RestaurantPaymentAccountInterface>;
  pendingReviewTasks?: Maybe<PendingReviewTasksReturn>;
  pushMfaChallengeVerified?: Maybe<PushMfaChallengeVerifiedReturn>;
  pushMfaEnrollmentUpdated?: Maybe<PushMfaEnrollmentUpdatedReturn>;
  restaurantFollowerMassActionNotificationUpdated?: Maybe<FollowerMassActionNotification>;
  restaurantIsPublishingDraftsWasUpdated?: Maybe<RestaurantPublishingDraftsSuccess>;
  restaurantLocationMenuItemCartWasUpdated?: Maybe<MenuItemCart>;
  restaurantLocationOpeningRangesUpdated?: Maybe<RestaurantLocation>;
  restaurantLocationOrdernerdTokenReceived?: Maybe<RestaurantLocationOrdernerdTokenReceivedReturn>;
  restaurantLocationProviderConnectingStatusUpdated?: Maybe<RestaurantLocation>;
  restaurantLocationProviderDisconnectingStatusUpdated?: Maybe<RestaurantLocation>;
  restaurantMenuItemCartWasUpdated?: Maybe<MenuItemCart>;
  restaurantMenuItemCartsCountUpdated?: Maybe<Restaurant>;
  restaurantMessageGroupWasUpdated?: Maybe<MessageGroup>;
  restaurantPaymentAccountsListUpdated?: Maybe<Restaurant>;
  restaurantUpdateMenuItemCartsStatusWasUpdated?: Maybe<Restaurant>;
  restaurantWasUpdated?: Maybe<Restaurant>;
  selfSignUpFeedback?: Maybe<SelfSignUpFeedbackReturn>;
  socialPostWasUpdated?: Maybe<SocialPost>;
  squareCatalogSync?: Maybe<SquareSellerAccount>;
  toastRestaurantSyncBasicsStatusChanged?: Maybe<Scalars['Boolean']['output']>;
  twilioPhoneCallWasUpdated?: Maybe<PhoneCallWasUpdatedReturn>;
  uploadableWasUpdated?: Maybe<Uploadable>;
};


export type SubscriptionAgentChatWasUpdatedArgs = {
  agentChatId: Scalars['Int']['input'];
};


export type SubscriptionCloverAccountSyncStatusChangedArgs = {
  cloverAccountId: Scalars['Int']['input'];
};


export type SubscriptionCreateMultiCampaignIsCompletedArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type SubscriptionCustomPageDraftWasUpdatedArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type SubscriptionDeliverectChannelStatusChangedArgs = {
  deliverectChannelId: Scalars['Int']['input'];
};


export type SubscriptionDishWasUpdatedArgs = {
  dishId: Scalars['Int']['input'];
};


export type SubscriptionFeedbackWasSubmittedArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type SubscriptionLiveDomainWasUpdatedArgs = {
  liveDomainId: Scalars['Int']['input'];
};


export type SubscriptionMenuItemCartCurbsideArrivalArgs = {
  locationId: Scalars['Int']['input'];
};


export type SubscriptionMenuItemCartSubcartWasAcceptedArgs = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type SubscriptionMenuItemCartWasSubmittedArgs = {
  locationId: Scalars['Int']['input'];
};


export type SubscriptionMenuItemCartWasUpdatedArgs = {
  menuItemCartId: Scalars['Int']['input'];
};


export type SubscriptionMenuItemWasDestroyedArgs = {
  sectionId: Scalars['Int']['input'];
};


export type SubscriptionMenuPresenceWasUpdatedArgs = {
  menuId: Scalars['Int']['input'];
};


export type SubscriptionMenuProcessingResultWasUpdatedArgs = {
  menuProcessingResultId: Scalars['Int']['input'];
};


export type SubscriptionMenuSectionWasUpdatedArgs = {
  sectionId: Scalars['Int']['input'];
};


export type SubscriptionMenuSyncHistoryStatusUpdatedArgs = {
  menuSyncHistoryId: Scalars['Int']['input'];
};


export type SubscriptionMenuWasUpdatedArgs = {
  menuId: Scalars['Int']['input'];
};


export type SubscriptionModifierGroupWasUpdatedArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type SubscriptionPartyCountWasUpdatedArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type SubscriptionPartySettingsWasUpdatedArgs = {
  locationId: Scalars['Int']['input'];
};


export type SubscriptionPartyWasDeletedArgs = {
  locationId: Scalars['Int']['input'];
  partyState: Scalars['String']['input'];
  partyType: Scalars['String']['input'];
};


export type SubscriptionPartyWasUpdatedArgs = {
  locationId: Scalars['Int']['input'];
  partyState: Scalars['String']['input'];
  partyType: Scalars['String']['input'];
};


export type SubscriptionPaymentAccountSyncArgs = {
  accountId: Scalars['Int']['input'];
  accountType: Scalars['String']['input'];
};


export type SubscriptionPendingReviewTasksArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type SubscriptionPushMfaChallengeVerifiedArgs = {
  userId: Scalars['Int']['input'];
};


export type SubscriptionPushMfaEnrollmentUpdatedArgs = {
  userId: Scalars['Int']['input'];
};


export type SubscriptionRestaurantFollowerMassActionNotificationUpdatedArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type SubscriptionRestaurantIsPublishingDraftsWasUpdatedArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type SubscriptionRestaurantLocationMenuItemCartWasUpdatedArgs = {
  locationId: Scalars['Int']['input'];
};


export type SubscriptionRestaurantLocationOpeningRangesUpdatedArgs = {
  locationId: Scalars['Int']['input'];
};


export type SubscriptionRestaurantLocationOrdernerdTokenReceivedArgs = {
  locationId: Scalars['Int']['input'];
};


export type SubscriptionRestaurantLocationProviderConnectingStatusUpdatedArgs = {
  locationId: Scalars['Int']['input'];
};


export type SubscriptionRestaurantLocationProviderDisconnectingStatusUpdatedArgs = {
  locationId: Scalars['Int']['input'];
};


export type SubscriptionRestaurantMenuItemCartWasUpdatedArgs = {
  cartType: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
};


export type SubscriptionRestaurantMenuItemCartsCountUpdatedArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type SubscriptionRestaurantMessageGroupWasUpdatedArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type SubscriptionRestaurantPaymentAccountsListUpdatedArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type SubscriptionRestaurantUpdateMenuItemCartsStatusWasUpdatedArgs = {
  restaurantSlug: Scalars['String']['input'];
};


export type SubscriptionRestaurantWasUpdatedArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type SubscriptionSocialPostWasUpdatedArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type SubscriptionSquareCatalogSyncArgs = {
  squareAccountId: Scalars['Int']['input'];
};


export type SubscriptionTwilioPhoneCallWasUpdatedArgs = {
  locationId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type SubscriptionUploadableWasUpdatedArgs = {
  uploadableId: Scalars['Int']['input'];
  uploadableType: Scalars['String']['input'];
};

export type SuggestedDish = {
  __typename?: 'SuggestedDish';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dishId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  policy: SuggestedDishPolicy;
  position?: Maybe<Scalars['Int']['output']>;
  suggestedDish?: Maybe<Dish>;
  suggestedDishId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SuggestedDishInput = {
  dishId: Scalars['Int']['input'];
  suggestedDishId: Scalars['Int']['input'];
};

export type SuggestedDishPolicy = {
  __typename?: 'SuggestedDishPolicy';
  create: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
};

export type SuggestedDishPositionInputType = {
  id: Scalars['Int']['input'];
  position: Scalars['Int']['input'];
};

/** Autogenerated input type of SyncAlohaAccount */
export type SyncAlohaAccountInput = {
  accountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of SyncAlohaMenuFromProvider */
export type SyncAlohaMenuFromProviderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuId: Scalars['Int']['input'];
};

/** Autogenerated input type of SyncCloverAccount */
export type SyncCloverAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cloverAccountId: Scalars['Int']['input'];
};

/** Autogenerated input type of SyncCloverMenuFromProvider */
export type SyncCloverMenuFromProviderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuId: Scalars['Int']['input'];
};

/** Autogenerated input type of SyncHeartlandPos */
export type SyncHeartlandPosInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  heartlandPosRootId: Scalars['Int']['input'];
};

/** Autogenerated input type of SyncMenuItemCartPaymentV2 */
export type SyncMenuItemCartPaymentV2Input = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuItemCartId: Scalars['Int']['input'];
};

/** Autogenerated input type of SyncMicrosOrg */
export type SyncMicrosOrgInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  microsOrgId: Scalars['Int']['input'];
};

/** Autogenerated input type of SyncNcrSilverAccount */
export type SyncNcrSilverAccountInput = {
  accountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of SyncSpoton */
export type SyncSpotonInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  spotonRootId: Scalars['Int']['input'];
};

/** Autogenerated input type of SyncYextMenu */
export type SyncYextMenuInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuId: Scalars['Int']['input'];
};

/** Autogenerated input type of SyncYextMenus */
export type SyncYextMenusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

export type TableTopInput = {
  maxOccupancy?: InputMaybe<Scalars['Int']['input']>;
  minOccupancy?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TableTopPaginationHandler = {
  __typename?: 'TableTopPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<RestaurantLocationTableTop>;
};

export type TextMessage = {
  __typename?: 'TextMessage';
  followerId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  phone: Scalars['String']['output'];
  remarketedCampaignItemChannel?: Maybe<Channel>;
  status: Scalars['String']['output'];
  user?: Maybe<User>;
};

export type TextMessageGroup = {
  __typename?: 'TextMessageGroup';
  aiMarketingContent?: Maybe<AiMarketingContent>;
  allSelected?: Maybe<Scalars['Boolean']['output']>;
  campaignItem?: Maybe<CampaignItem>;
  campaignItemId?: Maybe<Scalars['Int']['output']>;
  clickedMessagesCount: Scalars['Int']['output'];
  clickedRevenueSourcesSum: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBySegment?: Maybe<Scalars['Boolean']['output']>;
  deliveredMessagesCount: Scalars['Int']['output'];
  excludeUnknownLocations?: Maybe<Scalars['Boolean']['output']>;
  excludedFollowers: Array<TextMessageGroupExcludedFollower>;
  excludedLocations: Array<TextMessageGroupExcludedLocation>;
  excludedTags: Array<TextMessageGroupExcludedTag>;
  failureIndicators: Array<TextMessageGroupFailureIndicator>;
  id: Scalars['Int']['output'];
  isCreatedByAi?: Maybe<Scalars['Boolean']['output']>;
  isCustomSelection: Scalars['Boolean']['output'];
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  isMms?: Maybe<Scalars['Boolean']['output']>;
  isScheduled?: Maybe<Scalars['Boolean']['output']>;
  locationName: Scalars['String']['output'];
  locationTimezones?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
  messageGroupAverage?: Maybe<RestaurantMessageGroupAverage>;
  messagesCount: Scalars['Int']['output'];
  openedMessagesCount: Scalars['Int']['output'];
  openedRevenueSourcesSum: Scalars['Float']['output'];
  orderingOfferId?: Maybe<Scalars['Int']['output']>;
  ordersCount: Scalars['Int']['output'];
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  remarketedAction: Scalars['String']['output'];
  remarketedCampaignItemChannel?: Maybe<Channel>;
  remarketedCampaignItemId?: Maybe<Scalars['Int']['output']>;
  remarketedLocationId?: Maybe<Scalars['Int']['output']>;
  remarketedTagId?: Maybe<Scalars['Int']['output']>;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  scheduledMessagesCount: Scalars['Int']['output'];
  segmentationMatcher?: Maybe<Scalars['String']['output']>;
  selectedFollowerSegments: Array<TextMessageGroupSelectedFollowerSegment>;
  selectedFollowers: Array<TextMessageGroupSelectedFollower>;
  selectedLocations: Array<TextMessageGroupSelectedLocation>;
  selectedSources: Array<TextMessageGroupSelectedSource>;
  selectedTags: Array<TextMessageGroupSelectedTag>;
  sendToUnknownLocations?: Maybe<Scalars['Boolean']['output']>;
  tagName: Scalars['String']['output'];
  unsubscribedCount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadedPhoto?: Maybe<UploadedPhoto>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type TextMessageGroupContentAudit = {
  __typename?: 'TextMessageGroupContentAudit';
  contentAuditReasons?: Maybe<Scalars['String']['output']>;
  contentAuditSummary?: Maybe<Scalars['String']['output']>;
  flaggedContentScore?: Maybe<Scalars['Int']['output']>;
  hasFlaggedContent: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isReleased: Scalars['Boolean']['output'];
  textMessageGroup: TextMessageGroup;
  textMessageGroupId: Scalars['Int']['output'];
};

export type TextMessageGroupExcludedFollower = {
  __typename?: 'TextMessageGroupExcludedFollower';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  follower?: Maybe<Follower>;
  followerId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
};

export type TextMessageGroupExcludedFollowerInput = {
  followerId: Scalars['Int']['input'];
};

export type TextMessageGroupExcludedLocation = {
  __typename?: 'TextMessageGroupExcludedLocation';
  id: Scalars['Int']['output'];
  location?: Maybe<RestaurantLocation>;
  locationId?: Maybe<Scalars['Int']['output']>;
};

export type TextMessageGroupExcludedLocationInput = {
  locationId: Scalars['Int']['input'];
};

export type TextMessageGroupExcludedTag = {
  __typename?: 'TextMessageGroupExcludedTag';
  followerTag?: Maybe<FollowerTag>;
  followerTagId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
};

export type TextMessageGroupExcludedTagInput = {
  followerTagId: Scalars['Int']['input'];
};

export type TextMessageGroupFailureIndicator = {
  __typename?: 'TextMessageGroupFailureIndicator';
  createdAt: Scalars['DateTime']['output'];
  dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isResolved: Scalars['Boolean']['output'];
  lastFailureMessage?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TextMessageGroupGeneratedAiText = {
  __typename?: 'TextMessageGroupGeneratedAiText';
  message?: Maybe<Scalars['String']['output']>;
};

export type TextMessageGroupInput = {
  advisorCardTrackerId?: InputMaybe<Scalars['Int']['input']>;
  allSelected?: InputMaybe<Scalars['Boolean']['input']>;
  createdBySegment?: InputMaybe<Scalars['Boolean']['input']>;
  excludeUnknownLocations?: InputMaybe<Scalars['Boolean']['input']>;
  excludedFollowers?: InputMaybe<Array<TextMessageGroupExcludedFollowerInput>>;
  excludedLocations?: InputMaybe<Array<TextMessageGroupExcludedLocationInput>>;
  excludedTags?: InputMaybe<Array<TextMessageGroupExcludedTagInput>>;
  followersCount?: InputMaybe<Scalars['Int']['input']>;
  forceSend?: InputMaybe<Scalars['Boolean']['input']>;
  isCustomSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isMms?: InputMaybe<Scalars['Boolean']['input']>;
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  orderingOfferId?: InputMaybe<Scalars['Int']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  remarketedAction?: InputMaybe<Scalars['String']['input']>;
  remarketedCampaignItemId?: InputMaybe<Scalars['Int']['input']>;
  remarketedLocationId?: InputMaybe<Scalars['Int']['input']>;
  remarketedTagId?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['Int']['input'];
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledMessagesCount?: InputMaybe<Scalars['Int']['input']>;
  segmentationMatcher?: InputMaybe<Scalars['String']['input']>;
  selectedFollowerSegments?: InputMaybe<Array<TextMessageGroupSelectedFollowerSegmentInput>>;
  selectedFollowers?: InputMaybe<Array<TextMessageGroupSelectedFollowerInput>>;
  selectedLocations?: InputMaybe<Array<TextMessageGroupSelectedLocationInput>>;
  selectedSources?: InputMaybe<Array<TextMessageGroupSelectedSourceInput>>;
  selectedTags?: InputMaybe<Array<TextMessageGroupSelectedTagInput>>;
  sendToUnknownLocations?: InputMaybe<Scalars['Boolean']['input']>;
  smsUnsubscribedCount?: InputMaybe<Scalars['Int']['input']>;
  uploadedPhoto?: InputMaybe<SelectedUploadInput>;
};

export type TextMessageGroupPaginationHandler = {
  __typename?: 'TextMessageGroupPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<TextMessageGroup>;
};

export type TextMessageGroupSelectedFollower = {
  __typename?: 'TextMessageGroupSelectedFollower';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  follower?: Maybe<Follower>;
  followerId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
};

export type TextMessageGroupSelectedFollowerInput = {
  followerId: Scalars['Int']['input'];
};

export type TextMessageGroupSelectedFollowerSegment = {
  __typename?: 'TextMessageGroupSelectedFollowerSegment';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  restaurantFollowerSegment: RestaurantFollowerSegment;
  restaurantFollowerSegmentId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TextMessageGroupSelectedFollowerSegmentInput = {
  restaurantFollowerSegmentId: Scalars['Int']['input'];
};

export type TextMessageGroupSelectedLocation = {
  __typename?: 'TextMessageGroupSelectedLocation';
  id: Scalars['Int']['output'];
  location?: Maybe<RestaurantLocation>;
  locationId?: Maybe<Scalars['Int']['output']>;
};

export type TextMessageGroupSelectedLocationInput = {
  locationId: Scalars['Int']['input'];
};

export type TextMessageGroupSelectedSource = {
  __typename?: 'TextMessageGroupSelectedSource';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  source?: Maybe<Scalars['String']['output']>;
};

export type TextMessageGroupSelectedSourceInput = {
  source: Scalars['String']['input'];
};

export type TextMessageGroupSelectedTag = {
  __typename?: 'TextMessageGroupSelectedTag';
  followerTag?: Maybe<FollowerTag>;
  followerTagId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
};

export type TextMessageGroupSelectedTagInput = {
  followerTagId: Scalars['Int']['input'];
};

export type TextMessagePaginationHandler = {
  __typename?: 'TextMessagePaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<TextMessage>;
};

export type Theme = {
  __typename?: 'Theme';
  activeNavlinkColor?: Maybe<Scalars['String']['output']>;
  announcementBgColor?: Maybe<Scalars['String']['output']>;
  announcementBorderColor?: Maybe<Scalars['String']['output']>;
  customCss?: Maybe<Scalars['Text']['output']>;
  customCssEnabled?: Maybe<Scalars['Boolean']['output']>;
  customPageHeaderAlignment?: Maybe<HorizontalAlignment>;
  customSass?: Maybe<Scalars['String']['output']>;
  customSectionBackgroundImageEffect?: Maybe<ThemeBackgroundImageEffect>;
  customSectionBackgroundImageSetting?: Maybe<ThemeBackgroundImageSetting>;
  customSectionBackgroundImageUploadedPhoto?: Maybe<UploadedPhoto>;
  customSectionBackgroundImageUploadedPhotoId?: Maybe<Scalars['Int']['output']>;
  customSectionBackgroundImageUrl?: Maybe<Scalars['String']['output']>;
  customSectionContentFont: FontSelection;
  customSectionContentFontId?: Maybe<Scalars['Int']['output']>;
  customSectionHeaderFont: FontSelection;
  customSectionHeaderFontCase?: Maybe<FontCase>;
  customSectionHeaderFontId?: Maybe<Scalars['Int']['output']>;
  customSectionHeaderFontSize?: Maybe<FontSize>;
  customSectionHeaderFontWeight?: Maybe<FontWeight>;
  customSectionSpacing?: Maybe<CustomSectionSpacing>;
  customSectionSubHeaderFont?: Maybe<FontSelection>;
  customSectionSubHeaderFontCase?: Maybe<FontCase>;
  customSectionSubHeaderFontSize?: Maybe<FontSize>;
  customSectionSubHeaderFontWeight?: Maybe<FontWeight>;
  customTooltipContent?: Maybe<Scalars['String']['output']>;
  customTooltipHeading?: Maybe<Scalars['String']['output']>;
  defaultBackgroundColor?: Maybe<Scalars['String']['output']>;
  defaultBackgroundEffect?: Maybe<Scalars['String']['output']>;
  defaultBackgroundImageUploadedPhoto?: Maybe<UploadedPhoto>;
  defaultBackgroundImageUrl?: Maybe<Scalars['String']['output']>;
  defaultCustomSectionBgColor?: Maybe<Scalars['String']['output']>;
  defaultDishDetailTab?: Maybe<Scalars['String']['output']>;
  defaultFont: FontSelection;
  defaultFontId?: Maybe<Scalars['Int']['output']>;
  defaultMenuLayout?: Maybe<Scalars['String']['output']>;
  defaultTransitionTiming?: Maybe<Scalars['Int']['output']>;
  defaultTransitionType?: Maybe<Scalars['String']['output']>;
  dishDetailActionButton?: Maybe<Scalars['String']['output']>;
  dishDetailImageAlignment?: Maybe<Scalars['String']['output']>;
  dishDetailTab?: Maybe<Scalars['String']['output']>;
  dishLayout?: Maybe<Scalars['String']['output']>;
  dishTagKeyPosition?: Maybe<Scalars['String']['output']>;
  editorEmailStyleUrls: Array<Scalars['String']['output']>;
  editorStyleUrls: Array<Scalars['String']['output']>;
  editorStyles: Scalars['String']['output'];
  featuredDishBgColor?: Maybe<Scalars['String']['output']>;
  footerLogoEffect?: Maybe<Scalars['String']['output']>;
  headerBackgroundEffect?: Maybe<Scalars['String']['output']>;
  headerBorderColor?: Maybe<Scalars['String']['output']>;
  headerFontWeight?: Maybe<Scalars['String']['output']>;
  headerLogoAlignment?: Maybe<Scalars['String']['output']>;
  headerLogoEffect?: Maybe<Scalars['String']['output']>;
  headerLogoSize?: Maybe<Scalars['String']['output']>;
  headerNavFontColor?: Maybe<Scalars['String']['output']>;
  hostingType: HostingType;
  id: Scalars['Int']['output'];
  isActiveNavlinkColorEnabled?: Maybe<Scalars['Boolean']['output']>;
  isFontAwesomeEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingButtonEnabled?: Maybe<Scalars['Boolean']['output']>;
  isWidgetResponsive?: Maybe<Scalars['Boolean']['output']>;
  /** Computed styles for large buttons */
  largeButtonStyles: ButtonStyles;
  menuColumnCount: Scalars['Int']['output'];
  menuFlowSetting?: Maybe<Scalars['String']['output']>;
  menuHeaderFont: FontSelection;
  menuHeaderFontId?: Maybe<Scalars['Int']['output']>;
  menuIconEffect?: Maybe<Scalars['String']['output']>;
  menuItemDescriptionFont: FontSelection;
  menuItemDescriptionFontId?: Maybe<Scalars['Int']['output']>;
  menuItemDots?: Maybe<Scalars['Boolean']['output']>;
  menuItemFontAlignment?: Maybe<Scalars['String']['output']>;
  menuItemMobileFullWidth?: Maybe<Scalars['Boolean']['output']>;
  menuItemNameFont: FontSelection;
  menuItemNameFontId?: Maybe<Scalars['Int']['output']>;
  menuRowHeight?: Maybe<Scalars['String']['output']>;
  menuTabsLayout?: Maybe<Scalars['String']['output']>;
  navbarBgColor?: Maybe<Scalars['String']['output']>;
  orderingLogoBackgroundColor?: Maybe<Scalars['String']['output']>;
  pageHeaderFont: FontSelection;
  pageHeaderFontCase?: Maybe<Scalars['String']['output']>;
  pageHeaderFontId?: Maybe<Scalars['Int']['output']>;
  pageHeaderFontSize?: Maybe<Scalars['String']['output']>;
  pageSubHeaderCase?: Maybe<Scalars['String']['output']>;
  pageSubHeaderFont: FontSelection;
  pageSubHeaderFontId?: Maybe<Scalars['Int']['output']>;
  pageSubHeaderFontSize?: Maybe<Scalars['String']['output']>;
  pageSubHeaderFontWeight?: Maybe<FontWeight>;
  paletteType?: Maybe<Scalars['String']['output']>;
  photoBorder?: Maybe<PhotoBorder>;
  photoShadow?: Maybe<PhotoShadow>;
  photoShape?: Maybe<PhotoShape>;
  photoStyles: PhotoStyles;
  popmenuLogoEffect?: Maybe<Scalars['String']['output']>;
  primaryButtonScale?: Maybe<PrimaryButtonScale>;
  primaryButtonShape?: Maybe<PrimaryButtonShape>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  /** Computed styles for default button size */
  rootButtonStyles: RootButtonStyles;
  rootThemeId?: Maybe<Scalars['Int']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  showCurrencySymbol?: Maybe<Scalars['Boolean']['output']>;
  showCustomTab?: Maybe<Scalars['Boolean']['output']>;
  showDishLikes?: Maybe<Scalars['Boolean']['output']>;
  showDishShare?: Maybe<Scalars['Boolean']['output']>;
  showFollowSection?: Maybe<Scalars['Boolean']['output']>;
  showMenuItemDescription?: Maybe<Scalars['Boolean']['output']>;
  showMenuItemDishTags?: Maybe<Scalars['Boolean']['output']>;
  showMenuReviewSection?: Maybe<Scalars['Boolean']['output']>;
  showMenuShareSection?: Maybe<Scalars['Boolean']['output']>;
  showPopularSection?: Maybe<Scalars['Boolean']['output']>;
  showPrice?: Maybe<Scalars['Boolean']['output']>;
  showReservationsTab?: Maybe<Scalars['Boolean']['output']>;
  showTooltipHint: Scalars['Boolean']['output'];
  showWaitlistTab?: Maybe<Scalars['Boolean']['output']>;
  /** Computed styles for small buttons */
  smallButtonStyles: ButtonStyles;
  subsectionDisplay?: Maybe<Scalars['String']['output']>;
  themeStyles: Scalars['String']['output'];
  useLegacyDishLayout: Scalars['Boolean']['output'];
  useMobileMenuTabsLayout?: Maybe<Scalars['Boolean']['output']>;
  useNextHeadings: Scalars['Boolean']['output'];
  useNextSignUpForm?: Maybe<Scalars['Boolean']['output']>;
  websiteMaxWidth?: Maybe<WebsiteMaxWidth>;
};

export enum ThemeBackgroundImageEffect {
  BgCover = 'bg_cover',
  BgRepeat = 'bg_repeat',
  BgRepeatY = 'bg_repeat_y',
  BgStatic = 'bg_static'
}

export enum ThemeBackgroundImageSetting {
  Fixed = 'fixed',
  Static = 'static'
}

export type ThemeDraft = {
  __typename?: 'ThemeDraft';
  activeNavlinkColor?: Maybe<Scalars['String']['output']>;
  announcementBgColor?: Maybe<Scalars['String']['output']>;
  announcementBorderColor?: Maybe<Scalars['String']['output']>;
  customCss?: Maybe<Scalars['Text']['output']>;
  customCssEnabled?: Maybe<Scalars['Boolean']['output']>;
  customPageHeaderAlignment?: Maybe<HorizontalAlignment>;
  customSass?: Maybe<Scalars['String']['output']>;
  customSectionBackgroundImageEffect?: Maybe<ThemeBackgroundImageEffect>;
  customSectionBackgroundImageSetting?: Maybe<ThemeBackgroundImageSetting>;
  customSectionBackgroundImageUploadedPhoto?: Maybe<UploadedPhoto>;
  customSectionBackgroundImageUploadedPhotoId?: Maybe<Scalars['Int']['output']>;
  customSectionBackgroundImageUrl?: Maybe<Scalars['String']['output']>;
  customSectionContentFont: FontSelection;
  customSectionContentFontId?: Maybe<Scalars['Int']['output']>;
  customSectionHeaderFont: FontSelection;
  customSectionHeaderFontCase?: Maybe<FontCase>;
  customSectionHeaderFontId?: Maybe<Scalars['Int']['output']>;
  customSectionHeaderFontSize?: Maybe<FontSize>;
  customSectionHeaderFontWeight?: Maybe<FontWeight>;
  customSectionSpacing?: Maybe<CustomSectionSpacing>;
  customSectionSubHeaderFont?: Maybe<FontSelection>;
  customSectionSubHeaderFontCase?: Maybe<FontCase>;
  customSectionSubHeaderFontSize?: Maybe<FontSize>;
  customSectionSubHeaderFontWeight?: Maybe<FontWeight>;
  customTooltipContent?: Maybe<Scalars['String']['output']>;
  customTooltipHeading?: Maybe<Scalars['String']['output']>;
  defaultBackgroundColor?: Maybe<Scalars['String']['output']>;
  defaultBackgroundEffect?: Maybe<Scalars['String']['output']>;
  defaultBackgroundImageUploadedPhoto?: Maybe<UploadedPhoto>;
  defaultBackgroundImageUrl?: Maybe<Scalars['String']['output']>;
  defaultCustomSectionBgColor?: Maybe<Scalars['String']['output']>;
  defaultDishDetailTab?: Maybe<Scalars['String']['output']>;
  defaultFont: FontSelection;
  defaultFontId?: Maybe<Scalars['Int']['output']>;
  defaultMenuLayout?: Maybe<Scalars['String']['output']>;
  defaultTransitionTiming?: Maybe<Scalars['Int']['output']>;
  defaultTransitionType?: Maybe<Scalars['String']['output']>;
  dishDetailActionButton?: Maybe<Scalars['String']['output']>;
  dishDetailImageAlignment?: Maybe<Scalars['String']['output']>;
  dishDetailTab?: Maybe<Scalars['String']['output']>;
  dishLayout?: Maybe<Scalars['String']['output']>;
  dishTagKeyPosition?: Maybe<Scalars['String']['output']>;
  editorEmailStyleUrls: Array<Scalars['String']['output']>;
  editorStyleUrls: Array<Scalars['String']['output']>;
  editorStyles: Scalars['String']['output'];
  featuredDishBgColor?: Maybe<Scalars['String']['output']>;
  footerLogoEffect?: Maybe<Scalars['String']['output']>;
  headerBackgroundEffect?: Maybe<Scalars['String']['output']>;
  headerBorderColor?: Maybe<Scalars['String']['output']>;
  headerFontWeight?: Maybe<Scalars['String']['output']>;
  headerLogoAlignment?: Maybe<Scalars['String']['output']>;
  headerLogoEffect?: Maybe<Scalars['String']['output']>;
  headerLogoSize?: Maybe<Scalars['String']['output']>;
  headerNavFontColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isActiveNavlinkColorEnabled?: Maybe<Scalars['Boolean']['output']>;
  isFontAwesomeEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingButtonEnabled?: Maybe<Scalars['Boolean']['output']>;
  isWidgetResponsive?: Maybe<Scalars['Boolean']['output']>;
  /** Computed styles for large buttons */
  largeButtonStyles: ButtonStyles;
  menuColumnCount: Scalars['Int']['output'];
  menuFlowSetting?: Maybe<Scalars['String']['output']>;
  menuHeaderFont: FontSelection;
  menuHeaderFontId?: Maybe<Scalars['Int']['output']>;
  menuIconEffect?: Maybe<Scalars['String']['output']>;
  menuItemDescriptionFont: FontSelection;
  menuItemDescriptionFontId?: Maybe<Scalars['Int']['output']>;
  menuItemDots?: Maybe<Scalars['Boolean']['output']>;
  menuItemFontAlignment?: Maybe<Scalars['String']['output']>;
  menuItemMobileFullWidth?: Maybe<Scalars['Boolean']['output']>;
  menuItemNameFont: FontSelection;
  menuItemNameFontId?: Maybe<Scalars['Int']['output']>;
  menuRowHeight?: Maybe<Scalars['String']['output']>;
  menuTabsLayout?: Maybe<Scalars['String']['output']>;
  navbarBgColor?: Maybe<Scalars['String']['output']>;
  orderingLogoBackgroundColor?: Maybe<Scalars['String']['output']>;
  pageHeaderFont: FontSelection;
  pageHeaderFontCase?: Maybe<Scalars['String']['output']>;
  pageHeaderFontId?: Maybe<Scalars['Int']['output']>;
  pageHeaderFontSize?: Maybe<Scalars['String']['output']>;
  pageSubHeaderCase?: Maybe<Scalars['String']['output']>;
  pageSubHeaderFont: FontSelection;
  pageSubHeaderFontId?: Maybe<Scalars['Int']['output']>;
  pageSubHeaderFontSize?: Maybe<Scalars['String']['output']>;
  pageSubHeaderFontWeight?: Maybe<FontWeight>;
  paletteType?: Maybe<Scalars['String']['output']>;
  photoBorder?: Maybe<PhotoBorder>;
  photoShadow?: Maybe<PhotoShadow>;
  photoShape?: Maybe<PhotoShape>;
  photoStyles: PhotoStyles;
  popmenuLogoEffect?: Maybe<Scalars['String']['output']>;
  primaryButtonScale?: Maybe<PrimaryButtonScale>;
  primaryButtonShape?: Maybe<PrimaryButtonShape>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  /** Computed styles for default button size */
  rootButtonStyles: RootButtonStyles;
  rootThemeId?: Maybe<Scalars['Int']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  showCurrencySymbol?: Maybe<Scalars['Boolean']['output']>;
  showCustomTab?: Maybe<Scalars['Boolean']['output']>;
  showDishLikes?: Maybe<Scalars['Boolean']['output']>;
  showDishShare?: Maybe<Scalars['Boolean']['output']>;
  showFollowSection?: Maybe<Scalars['Boolean']['output']>;
  showMenuItemDescription?: Maybe<Scalars['Boolean']['output']>;
  showMenuItemDishTags?: Maybe<Scalars['Boolean']['output']>;
  showMenuReviewSection?: Maybe<Scalars['Boolean']['output']>;
  showMenuShareSection?: Maybe<Scalars['Boolean']['output']>;
  showPopularSection?: Maybe<Scalars['Boolean']['output']>;
  showPrice?: Maybe<Scalars['Boolean']['output']>;
  showReservationsTab?: Maybe<Scalars['Boolean']['output']>;
  showTooltipHint: Scalars['Boolean']['output'];
  showWaitlistTab?: Maybe<Scalars['Boolean']['output']>;
  /** Computed styles for small buttons */
  smallButtonStyles: ButtonStyles;
  subsectionDisplay?: Maybe<Scalars['String']['output']>;
  themeStyles: Scalars['String']['output'];
  useLegacyDishLayout: Scalars['Boolean']['output'];
  useMobileMenuTabsLayout?: Maybe<Scalars['Boolean']['output']>;
  useNextHeadings: Scalars['Boolean']['output'];
  useNextSignUpForm?: Maybe<Scalars['Boolean']['output']>;
  websiteMaxWidth?: Maybe<WebsiteMaxWidth>;
};

export type ThemeFont = {
  __typename?: 'ThemeFont';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserDisplayName?: Maybe<Scalars['String']['output']>;
  customFontUrls: Array<Scalars['String']['output']>;
  fontFiles: Array<ThemeFontFontFile>;
  googleFontId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  restaurant?: Maybe<Restaurant>;
};

export type ThemeFontFontFile = {
  __typename?: 'ThemeFontFontFile';
  fileExtension: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  uploadedFont?: Maybe<UploadedFont>;
};

export type ThemeFontFontFileInput = {
  fileDataUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  uploadedFontId?: InputMaybe<Scalars['Int']['input']>;
};

export type ThemeFontInput = {
  fontFiles?: InputMaybe<Array<ThemeFontFontFileInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ThemeInput = {
  activeNavlinkColor?: InputMaybe<Scalars['String']['input']>;
  announcementBgColor?: InputMaybe<Scalars['String']['input']>;
  announcementBorderColor?: InputMaybe<Scalars['String']['input']>;
  customCssEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  customPageHeaderAlignment?: InputMaybe<Scalars['String']['input']>;
  customSass?: InputMaybe<Scalars['String']['input']>;
  customSectionBackgroundImageEffect?: InputMaybe<ThemeBackgroundImageEffect>;
  customSectionBackgroundImageSetting?: InputMaybe<ThemeBackgroundImageSetting>;
  customSectionBackgroundImageUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  customSectionBackgroundImageUploadedPhotoId?: InputMaybe<Scalars['Int']['input']>;
  customSectionContentFontColor?: InputMaybe<Scalars['String']['input']>;
  customSectionContentFontId?: InputMaybe<Scalars['Int']['input']>;
  customSectionHeaderFontCase?: InputMaybe<Scalars['String']['input']>;
  customSectionHeaderFontColor?: InputMaybe<Scalars['String']['input']>;
  customSectionHeaderFontId?: InputMaybe<Scalars['Int']['input']>;
  customSectionHeaderFontSize?: InputMaybe<Scalars['String']['input']>;
  customSectionHeaderFontWeight?: InputMaybe<Scalars['String']['input']>;
  customSectionSpacing?: InputMaybe<Scalars['String']['input']>;
  customSectionSubHeaderFontCase?: InputMaybe<Scalars['String']['input']>;
  customSectionSubHeaderFontColor?: InputMaybe<Scalars['String']['input']>;
  customSectionSubHeaderFontId?: InputMaybe<Scalars['Int']['input']>;
  customSectionSubHeaderFontSize?: InputMaybe<Scalars['String']['input']>;
  customSectionSubHeaderFontWeight?: InputMaybe<Scalars['String']['input']>;
  defaultBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  defaultBackgroundEffect?: InputMaybe<Scalars['String']['input']>;
  defaultBackgroundImageUploadedPhoto?: InputMaybe<SelectedUploadInput>;
  defaultCustomSectionBgColor?: InputMaybe<Scalars['String']['input']>;
  defaultDishDetailTab?: InputMaybe<Scalars['String']['input']>;
  defaultFontColor?: InputMaybe<Scalars['String']['input']>;
  defaultFontId?: InputMaybe<Scalars['Int']['input']>;
  defaultMenuLayout?: InputMaybe<Scalars['String']['input']>;
  defaultTransitionTiming?: InputMaybe<Scalars['Int']['input']>;
  defaultTransitionType?: InputMaybe<Scalars['String']['input']>;
  dishDetailActionButton?: InputMaybe<Scalars['String']['input']>;
  dishDetailImageAlignment?: InputMaybe<Scalars['String']['input']>;
  dishDetailTab?: InputMaybe<Scalars['String']['input']>;
  dishLayout?: InputMaybe<Scalars['String']['input']>;
  dishTagKeyPosition?: InputMaybe<Scalars['String']['input']>;
  featuredDishBgColor?: InputMaybe<Scalars['String']['input']>;
  footerLogoEffect?: InputMaybe<Scalars['String']['input']>;
  headerBackgroundEffect?: InputMaybe<Scalars['String']['input']>;
  headerBorderColor?: InputMaybe<Scalars['String']['input']>;
  headerFontWeight?: InputMaybe<Scalars['String']['input']>;
  headerLogoAlignment?: InputMaybe<Scalars['String']['input']>;
  headerLogoEffect?: InputMaybe<Scalars['String']['input']>;
  headerLogoSize?: InputMaybe<Scalars['String']['input']>;
  headerNavFontColor?: InputMaybe<Scalars['String']['input']>;
  isActiveNavlinkColorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFontAwesomeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingButtonEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWidgetResponsive?: InputMaybe<Scalars['Boolean']['input']>;
  menuColumnCount?: InputMaybe<Scalars['Int']['input']>;
  menuFlowSetting?: InputMaybe<Scalars['String']['input']>;
  menuHeaderFontColor?: InputMaybe<Scalars['String']['input']>;
  menuHeaderFontId?: InputMaybe<Scalars['Int']['input']>;
  menuIconEffect?: InputMaybe<Scalars['String']['input']>;
  menuItemDescriptionFontColor?: InputMaybe<Scalars['String']['input']>;
  menuItemDescriptionFontId?: InputMaybe<Scalars['Int']['input']>;
  menuItemDots?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemFontAlignment?: InputMaybe<Scalars['String']['input']>;
  menuItemMobileFullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemNameFontCase?: InputMaybe<Scalars['String']['input']>;
  menuItemNameFontColor?: InputMaybe<Scalars['String']['input']>;
  menuItemNameFontId?: InputMaybe<Scalars['Int']['input']>;
  menuItemNameFontWeight?: InputMaybe<Scalars['String']['input']>;
  menuRowHeight?: InputMaybe<Scalars['String']['input']>;
  menuTabsLayout?: InputMaybe<Scalars['String']['input']>;
  navbarBgColor?: InputMaybe<Scalars['String']['input']>;
  orderingLogoBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  pageHeaderFontCase?: InputMaybe<Scalars['String']['input']>;
  pageHeaderFontColor?: InputMaybe<Scalars['String']['input']>;
  pageHeaderFontId?: InputMaybe<Scalars['Int']['input']>;
  pageHeaderFontSize?: InputMaybe<Scalars['String']['input']>;
  pageSubHeaderCase?: InputMaybe<Scalars['String']['input']>;
  pageSubHeaderFontColor?: InputMaybe<Scalars['String']['input']>;
  pageSubHeaderFontId?: InputMaybe<Scalars['Int']['input']>;
  pageSubHeaderFontSize?: InputMaybe<Scalars['String']['input']>;
  pageSubHeaderFontWeight?: InputMaybe<Scalars['String']['input']>;
  paletteType?: InputMaybe<Scalars['String']['input']>;
  photoBorder?: InputMaybe<Scalars['String']['input']>;
  photoShadow?: InputMaybe<Scalars['String']['input']>;
  photoShape?: InputMaybe<Scalars['String']['input']>;
  popmenuLogoEffect?: InputMaybe<Scalars['String']['input']>;
  primaryButtonScale?: InputMaybe<Scalars['String']['input']>;
  primaryButtonShape?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  rootThemeId?: InputMaybe<Scalars['Int']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCurrencySymbol?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomTab?: InputMaybe<Scalars['Boolean']['input']>;
  showDishLikes?: InputMaybe<Scalars['Boolean']['input']>;
  showDishShare?: InputMaybe<Scalars['Boolean']['input']>;
  showFollowSection?: InputMaybe<Scalars['Boolean']['input']>;
  showMenuItemDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showMenuItemDishTags?: InputMaybe<Scalars['Boolean']['input']>;
  showMenuReviewSection?: InputMaybe<Scalars['Boolean']['input']>;
  showMenuShareSection?: InputMaybe<Scalars['Boolean']['input']>;
  showPopularSection?: InputMaybe<Scalars['Boolean']['input']>;
  showPrice?: InputMaybe<Scalars['Boolean']['input']>;
  showReservationsTab?: InputMaybe<Scalars['Boolean']['input']>;
  showTooltipHint?: InputMaybe<Scalars['Boolean']['input']>;
  showWaitlistTab?: InputMaybe<Scalars['Boolean']['input']>;
  subsectionDisplay?: InputMaybe<Scalars['String']['input']>;
  useMobileMenuTabsLayout?: InputMaybe<Scalars['Boolean']['input']>;
  useNextHeadings?: InputMaybe<Scalars['Boolean']['input']>;
  useNextSignUpForm?: InputMaybe<Scalars['Boolean']['input']>;
  websiteMaxWidth?: InputMaybe<Scalars['String']['input']>;
};

export type ThemeVersion = Versionable & {
  __typename?: 'ThemeVersion';
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  locationMenuName?: Maybe<Scalars['String']['output']>;
  objectChanges: Array<VersionDiff>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

export type ThrottleSetting = {
  __typename?: 'ThrottleSetting';
  delayTimeMinutes: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  thresholdCurrencyAmount: Scalars['Decimal']['output'];
  thresholdTimeMinutes: Scalars['Int']['output'];
  throttlingEnabled: Scalars['Boolean']['output'];
};

export type ThrottleSettingInput = {
  delayTimeMinutes?: InputMaybe<Scalars['Int']['input']>;
  thresholdCurrencyAmount?: InputMaybe<Scalars['Decimal']['input']>;
  thresholdTimeMinutes?: InputMaybe<Scalars['Int']['input']>;
  throttlingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ToastAlternativePaymentType = {
  __typename?: 'ToastAlternativePaymentType';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ToastAlternativePaymentTypeInput = {
  giftCardPaymentTypeId?: InputMaybe<Scalars['Int']['input']>;
  toastAlternativePaymentTypeId?: InputMaybe<Scalars['Int']['input']>;
};

export type ToastDiningOption = {
  __typename?: 'ToastDiningOption';
  curbside?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ToastDiningOptionsInput = {
  diningOptionCurbsideId?: InputMaybe<Scalars['Int']['input']>;
  diningOptionDeliveryId?: InputMaybe<Scalars['Int']['input']>;
  diningOptionDineInId?: InputMaybe<Scalars['Int']['input']>;
  diningOptionTakeOutId?: InputMaybe<Scalars['Int']['input']>;
};

export type ToastHostedCheckoutSession = {
  __typename?: 'ToastHostedCheckoutSession';
  intentId: Scalars['String']['output'];
  oauthToken: Scalars['String']['output'];
  sessionSecret: Scalars['String']['output'];
};

export type ToastHostedPaymentIntent = {
  __typename?: 'ToastHostedPaymentIntent';
  amountCents?: Maybe<Scalars['Int']['output']>;
  externalReferenceId?: Maybe<Scalars['String']['output']>;
  intentId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ToastItem = ProviderItem & {
  __typename?: 'ToastItem';
  availableVariations: Array<ProviderVariation>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ToastMenu = ProviderMenu & {
  __typename?: 'ToastMenu';
  availableMenuSections: Array<ProviderMenuSection>;
  id: Scalars['Int']['output'];
  isConnected: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ToastMenuGroup = ProviderMenuSection & {
  __typename?: 'ToastMenuGroup';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ToastModifierOption = ProviderModifier & ProviderVariation & {
  __typename?: 'ToastModifierOption';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
};

export type ToastRestaurant = RestaurantPaymentAccountInterface & {
  __typename?: 'ToastRestaurant';
  accountSlug: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  accountUrl: Scalars['String']['output'];
  canDisconnectPos: Scalars['Boolean']['output'];
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  connectedByUserDisplayName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryServiceCharge?: Maybe<ToastServiceCharge>;
  feeServiceCharge?: Maybe<ToastServiceCharge>;
  giftCardDiscountId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isDeleting: Scalars['Boolean']['output'];
  isMenuSyncing: Scalars['Boolean']['output'];
  isOrderingEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOrderingScheduleEnabled?: Maybe<Scalars['Boolean']['output']>;
  isShopSupported: Scalars['Boolean']['output'];
  isSyncing?: Maybe<Scalars['Boolean']['output']>;
  lastMenusSyncAt: Scalars['DateTime']['output'];
  lastSyncAt: Scalars['DateTime']['output'];
  locationName?: Maybe<Scalars['String']['output']>;
  locations: Array<RestaurantLocation>;
  menuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offerDiscountId?: Maybe<Scalars['Int']['output']>;
  restaurants: Array<Restaurant>;
  shouldReauthenticate: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  toastAlternativePaymentTypes: Array<ToastAlternativePaymentType>;
  toastCurbsidePickupDiningOptions: Array<ToastDiningOption>;
  toastDeliveryDiningOptions: Array<ToastDiningOption>;
  toastDineInDiningOptions: Array<ToastDiningOption>;
  toastDiningOptions: Array<ToastDiningOption>;
  toastGuid: Scalars['String']['output'];
  toastRevenueCenters: Array<ToastRevenueCenter>;
  toastServiceCharges: Array<ToastServiceCharge>;
  toastWalkInPickupDiningOptions: Array<ToastDiningOption>;
};

export type ToastRestaurantPaginationHandler = {
  __typename?: 'ToastRestaurantPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<ToastRestaurant>;
};

export type ToastRestaurantSummary = {
  __typename?: 'ToastRestaurantSummary';
  deliveryOpeningRanges: Array<RestaurantLocationDeliveryOpeningRange>;
  dineInOpeningRanges: Array<RestaurantLocationDineInOpeningRange>;
  groupsAllVisibilityMissing: Array<Scalars['String']['output']>;
  groupsInvalidVisibilityCount: Scalars['Int']['output'];
  isDeliveryServiceChargeMissing: Scalars['Boolean']['output'];
  isDiningOptionMissing: Scalars['Boolean']['output'];
  isFeeServiceChargeMissing: Scalars['Boolean']['output'];
  isGiftCardDiscountMissing: Scalars['Boolean']['output'];
  isOfferDiscountMissing: Scalars['Boolean']['output'];
  itemWarningsCount: Array<WarningCount>;
  itemsInvalidVisibilityCount: Scalars['Int']['output'];
  location: RestaurantLocation;
  menusAllVisibilityMissing: Array<Scalars['String']['output']>;
  menusInvalidVisibilityCount: Scalars['Int']['output'];
};

export type ToastRevenueCenter = {
  __typename?: 'ToastRevenueCenter';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ToastRevenueCentersInput = {
  revenueCenterDeliveryId?: InputMaybe<Scalars['Int']['input']>;
  revenueCenterPickupId?: InputMaybe<Scalars['Int']['input']>;
};

export type ToastServiceCharge = {
  __typename?: 'ToastServiceCharge';
  id: Scalars['Int']['output'];
  isValidPopmenuCharge: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ToastSettingInput = {
  isDueAtMappingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderingScheduleMappingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPhotoSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of TogglePopmenuLoyalty */
export type TogglePopmenuLoyaltyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

export type ToggleReviewVoteReturn = {
  __typename?: 'ToggleReviewVoteReturn';
  review: Review;
  session?: Maybe<Session>;
  user?: Maybe<User>;
};

/** Autogenerated input type of ToggleSelectedLocation */
export type ToggleSelectedLocationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enable: Scalars['Boolean']['input'];
  selectedLocationId: Scalars['Int']['input'];
};

/** Autogenerated input type of ToggleThirdPartyLoyalty */
export type ToggleThirdPartyLoyaltyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

export type TopReviewedItems = {
  __typename?: 'TopReviewedItems';
  dishId: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TrafficByCity = {
  __typename?: 'TrafficByCity';
  city: Scalars['String']['output'];
  sessionCount: Scalars['Int']['output'];
};

export type TransferReviewReturn = {
  __typename?: 'TransferReviewReturn';
  originalDish: Dish;
  review: Review;
};

/** Autogenerated input type of TriggerRestaurantAppDeployment */
export type TriggerRestaurantAppDeploymentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lane: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
  shouldAuditUsers: Scalars['Boolean']['input'];
  versionBumpType: Scalars['String']['input'];
};

/** Autogenerated input type of TriggerRestaurantDetectedCookieGeneration */
export type TriggerRestaurantDetectedCookieGenerationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

export type TwilioBannedWords = {
  __typename?: 'TwilioBannedWords';
  id: Scalars['Int']['output'];
  word: Scalars['String']['output'];
};

export enum TwilioBusinessIdentificationType {
  BusinessRegistrationNumber = 'BUSINESS_REGISTRATION_NUMBER',
  Crn = 'CRN',
  Ein = 'EIN'
}

export type TwilioBusinessRegistration = {
  __typename?: 'TwilioBusinessRegistration';
  businessIdentification?: Maybe<Scalars['String']['output']>;
  businessIdentificationType?: Maybe<TwilioBusinessIdentificationType>;
  businessType?: Maybe<TwilioBusinessType>;
  country?: Maybe<TwilioBusinessRegistrationCountry>;
  id: Scalars['Int']['output'];
  legalBusinessName?: Maybe<Scalars['String']['output']>;
  policy: BusinessRegistrationPolicy;
  registrationAuthority?: Maybe<Scalars['String']['output']>;
};

export enum TwilioBusinessRegistrationCountry {
  Ca = 'CA',
  Gb = 'GB',
  Us = 'US'
}

export type TwilioBusinessRegistrationInputType = {
  businessIdentification: Scalars['String']['input'];
  businessIdentificationType: TwilioBusinessIdentificationType;
  businessType: TwilioBusinessType;
  country: TwilioBusinessRegistrationCountry;
  legalBusinessName: Scalars['String']['input'];
  registrationAuthority?: InputMaybe<Scalars['String']['input']>;
};

export enum TwilioBusinessType {
  NonProfit = 'NON_PROFIT',
  PrivateProfit = 'PRIVATE_PROFIT',
  PublicProfit = 'PUBLIC_PROFIT',
  SoleProprietor = 'SOLE_PROPRIETOR'
}

export type TwilioIncomingMessage = {
  __typename?: 'TwilioIncomingMessage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fromNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type TwilioIncomingMessagePaginationHandler = {
  __typename?: 'TwilioIncomingMessagePaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<TwilioIncomingMessage>;
};

export type TwilioMessage = {
  __typename?: 'TwilioMessage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isSent?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  senderType?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  toNumber?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type TwilioMessagePaginationHandler = {
  __typename?: 'TwilioMessagePaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<TwilioMessage>;
};

export type TwilioPhoneCall = {
  __typename?: 'TwilioPhoneCall';
  callDuration?: Maybe<Scalars['Int']['output']>;
  callIntents?: Maybe<Array<Scalars['String']['output']>>;
  callOutcome?: Maybe<Scalars['Int']['output']>;
  callRecordingDuration?: Maybe<Scalars['Int']['output']>;
  callRecordingSid?: Maybe<Scalars['String']['output']>;
  callRecordingSource?: Maybe<Scalars['String']['output']>;
  callRecordingStatus?: Maybe<Scalars['String']['output']>;
  callRecordingUrl?: Maybe<Scalars['String']['output']>;
  callSid?: Maybe<Scalars['String']['output']>;
  callTopic?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  formattedFromNumber?: Maybe<Scalars['String']['output']>;
  formattedTopics?: Maybe<Array<Scalars['String']['output']>>;
  fromNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isRead: Scalars['Boolean']['output'];
  isSpamNomorobo: Scalars['Boolean']['output'];
  location?: Maybe<RestaurantLocation>;
  menuItemCart?: Maybe<MenuItemCart>;
  toNumber?: Maybe<Scalars['String']['output']>;
  twilioDateCreated?: Maybe<Scalars['DateTime']['output']>;
  twilioDateUpdated?: Maybe<Scalars['DateTime']['output']>;
  twilioPhoneId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  vmRecordingDuration?: Maybe<Scalars['Int']['output']>;
  vmRecordingSid?: Maybe<Scalars['String']['output']>;
  vmRecordingSource?: Maybe<Scalars['String']['output']>;
  vmRecordingStatus?: Maybe<Scalars['String']['output']>;
  vmRecordingUrl?: Maybe<Scalars['String']['output']>;
  vmTranscriptionSid?: Maybe<Scalars['String']['output']>;
  vmTranscriptionText?: Maybe<Scalars['String']['output']>;
  vmTranscriptionUrl?: Maybe<Scalars['String']['output']>;
};

export type TwilioPhoneCallPaginationHandler = {
  __typename?: 'TwilioPhoneCallPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<TwilioPhoneCall>;
};

export type TwilioPhoneNumber = {
  __typename?: 'TwilioPhoneNumber';
  accountSid?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  sid?: Maybe<Scalars['String']['output']>;
  tollFreeVerification?: Maybe<TwilioPhoneNumberTollFreeVerification>;
};

export type TwilioPhoneNumberPaginationHandler = {
  __typename?: 'TwilioPhoneNumberPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<TwilioPhoneNumber>;
};

export type TwilioPhoneNumberRegulatoryBundle = {
  __typename?: 'TwilioPhoneNumberRegulatoryBundle';
  id: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type TwilioPhoneNumberTollFreeVerification = {
  __typename?: 'TwilioPhoneNumberTollFreeVerification';
  createdAt: Scalars['DateTime']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type TwilioStatus = {
  __typename?: 'TwilioStatus';
  alertMessages?: Maybe<Array<Scalars['JSON']['output']>>;
  isTollFreeEligible?: Maybe<Scalars['Boolean']['output']>;
};

export type TwilioVerifyFactorSecret = {
  __typename?: 'TwilioVerifyFactorSecret';
  bindingSecret: Scalars['String']['output'];
  bindingUri: Scalars['String']['output'];
  factorSid: Scalars['String']['output'];
};

export type TwilioVerifyMfaFactor = {
  __typename?: 'TwilioVerifyMfaFactor';
  createdAt: Scalars['DateTime']['output'];
  destination?: Maybe<Scalars['String']['output']>;
  factorSid?: Maybe<Scalars['String']['output']>;
  factorType: Scalars['String']['output'];
  friendlyName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type UberDirectDelivery = {
  __typename?: 'UberDirectDelivery';
  cancelationReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  complete: Scalars['Boolean']['output'];
  courierImminent: Scalars['Boolean']['output'];
  courierLat?: Maybe<Scalars['Decimal']['output']>;
  courierLng?: Maybe<Scalars['Decimal']['output']>;
  courierName?: Maybe<Scalars['String']['output']>;
  courierPhoneNumber?: Maybe<Scalars['String']['output']>;
  courierVehicle?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  deliverableAction?: Maybe<Scalars['String']['output']>;
  deliveryId: Scalars['String']['output'];
  driverStatus?: Maybe<Scalars['String']['output']>;
  dropoffAddress1: Scalars['String']['output'];
  dropoffAddress2?: Maybe<Scalars['String']['output']>;
  dropoffCity: Scalars['String']['output'];
  dropoffCountry: Scalars['String']['output'];
  dropoffCourierNotes?: Maybe<Scalars['String']['output']>;
  dropoffEta?: Maybe<Scalars['DateTime']['output']>;
  dropoffLat?: Maybe<Scalars['Decimal']['output']>;
  dropoffLong?: Maybe<Scalars['Decimal']['output']>;
  dropoffName?: Maybe<Scalars['String']['output']>;
  dropoffNotes?: Maybe<Scalars['String']['output']>;
  dropoffPhoneNumber: Scalars['String']['output'];
  dropoffSellerNotes?: Maybe<Scalars['String']['output']>;
  dropoffState?: Maybe<Scalars['String']['output']>;
  dropoffStatus?: Maybe<Scalars['String']['output']>;
  dropoffStatusTimestamp?: Maybe<Scalars['DateTime']['output']>;
  dropoffWindowEndTime?: Maybe<Scalars['DateTime']['output']>;
  dropoffWindowStartTime?: Maybe<Scalars['DateTime']['output']>;
  dropoffZipCode: Scalars['String']['output'];
  estimateId: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  externalStoreId?: Maybe<Scalars['String']['output']>;
  fee: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  menuItemCartId: Scalars['Int']['output'];
  middlewareFee: Scalars['Int']['output'];
  orderId?: Maybe<Scalars['String']['output']>;
  orderTotalValue: Scalars['Int']['output'];
  pickupAddress1: Scalars['String']['output'];
  pickupAddress2?: Maybe<Scalars['String']['output']>;
  pickupCity: Scalars['String']['output'];
  pickupCountry: Scalars['String']['output'];
  pickupEta?: Maybe<Scalars['DateTime']['output']>;
  pickupLat?: Maybe<Scalars['Decimal']['output']>;
  pickupLong?: Maybe<Scalars['Decimal']['output']>;
  pickupName: Scalars['String']['output'];
  pickupNotes?: Maybe<Scalars['String']['output']>;
  pickupPhoneNumber: Scalars['String']['output'];
  pickupReady?: Maybe<Scalars['DateTime']['output']>;
  pickupSellerNotes?: Maybe<Scalars['String']['output']>;
  pickupState?: Maybe<Scalars['String']['output']>;
  pickupStatus?: Maybe<Scalars['String']['output']>;
  pickupStatusTimestamp?: Maybe<Scalars['DateTime']['output']>;
  pickupWindowEndTime?: Maybe<Scalars['DateTime']['output']>;
  pickupWindowStartTime?: Maybe<Scalars['DateTime']['output']>;
  pickupZipCode: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  tip: Scalars['Int']['output'];
  trackingUrl?: Maybe<Scalars['String']['output']>;
  uberDirectDeliveryEvents: Array<UberDirectDeliveryEvent>;
  undeliverableAction?: Maybe<Scalars['String']['output']>;
  undeliverableReason?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

export type UberDirectDeliveryEvent = {
  __typename?: 'UberDirectDeliveryEvent';
  courierImminent: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  deliveryStatus: Scalars['String']['output'];
  driverStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type UiDishBase = UiDishInterface & {
  __typename?: 'UiDishBase';
  hasNcrSilverItem: Scalars['Boolean']['output'];
  hasNoPosItem: Scalars['Boolean']['output'];
  hasSquareItem: Scalars['Boolean']['output'];
  hasToastItem: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
};

export type UiDishClover = UiDishInterface & {
  __typename?: 'UiDishClover';
  hasNcrSilverItem: Scalars['Boolean']['output'];
  hasNoPosItem: Scalars['Boolean']['output'];
  hasSquareItem: Scalars['Boolean']['output'];
  hasToastItem: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
};

/** Dish UI precalculated settings */
export type UiDishInterface = {
  hasNcrSilverItem: Scalars['Boolean']['output'];
  hasNoPosItem: Scalars['Boolean']['output'];
  hasSquareItem: Scalars['Boolean']['output'];
  hasToastItem: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
};

export type UiDishNcrSilver = UiDishInterface & {
  __typename?: 'UiDishNcrSilver';
  hasNcrSilverItem: Scalars['Boolean']['output'];
  hasNoPosItem: Scalars['Boolean']['output'];
  hasSquareItem: Scalars['Boolean']['output'];
  hasToastItem: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
};

export type UiDishSquare = UiDishInterface & {
  __typename?: 'UiDishSquare';
  hasNcrSilverItem: Scalars['Boolean']['output'];
  hasNoPosItem: Scalars['Boolean']['output'];
  hasSquareItem: Scalars['Boolean']['output'];
  hasToastItem: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
};

export type UiDishToast = UiDishInterface & {
  __typename?: 'UiDishToast';
  hasNcrSilverItem: Scalars['Boolean']['output'];
  hasNoPosItem: Scalars['Boolean']['output'];
  hasSquareItem: Scalars['Boolean']['output'];
  hasToastItem: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
};

export type UiMenuAloha = UiMenuInterface & {
  __typename?: 'UiMenuAloha';
  canBeForceSynced: Scalars['Boolean']['output'];
  canToggleModifierGroupVisibility: Scalars['Boolean']['output'];
  featuredSectionCanBeAdded: Scalars['Boolean']['output'];
  hasNoChildSquareMenus: Scalars['Boolean']['output'];
  hasTimeSpecificPricing: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isBuildTypeWithNestedModifiers: Scalars['Boolean']['output'];
  isMasterWithLocation: Scalars['Boolean']['output'];
  isMasterWithoutLocation: Scalars['Boolean']['output'];
  isMenuAttachedToPos: Scalars['Boolean']['output'];
  isMenuFromPos: Scalars['Boolean']['output'];
  isMenuLocationAloha: Scalars['Boolean']['output'];
  isMenuLocationClover: Scalars['Boolean']['output'];
  isMenuLocationDeliverect: Scalars['Boolean']['output'];
  isMenuLocationHeartlandPos: Scalars['Boolean']['output'];
  isMenuLocationMicros: Scalars['Boolean']['output'];
  isMenuLocationNcrSilver: Scalars['Boolean']['output'];
  isMenuLocationSpoton: Scalars['Boolean']['output'];
  isMenuLocationSquare: Scalars['Boolean']['output'];
  isMenuLocationToast: Scalars['Boolean']['output'];
  isMenuSyncEnabled: Scalars['Boolean']['output'];
  isMovingItemsAcrossSectionsEnabled: Scalars['Boolean']['output'];
  isOpentableMenu: Scalars['Boolean']['output'];
  menuHoursCanBeChanged: Scalars['Boolean']['output'];
  posMenuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  sectionCanBeAdded: Scalars['Boolean']['output'];
  showMenu: Scalars['Boolean']['output'];
};

export type UiMenuBase = UiMenuInterface & {
  __typename?: 'UiMenuBase';
  canBeForceSynced: Scalars['Boolean']['output'];
  canToggleModifierGroupVisibility: Scalars['Boolean']['output'];
  featuredSectionCanBeAdded: Scalars['Boolean']['output'];
  hasNoChildSquareMenus: Scalars['Boolean']['output'];
  hasTimeSpecificPricing: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isBuildTypeWithNestedModifiers: Scalars['Boolean']['output'];
  isMasterWithLocation: Scalars['Boolean']['output'];
  isMasterWithoutLocation: Scalars['Boolean']['output'];
  isMenuAttachedToPos: Scalars['Boolean']['output'];
  isMenuFromPos: Scalars['Boolean']['output'];
  isMenuLocationAloha: Scalars['Boolean']['output'];
  isMenuLocationClover: Scalars['Boolean']['output'];
  isMenuLocationDeliverect: Scalars['Boolean']['output'];
  isMenuLocationHeartlandPos: Scalars['Boolean']['output'];
  isMenuLocationMicros: Scalars['Boolean']['output'];
  isMenuLocationNcrSilver: Scalars['Boolean']['output'];
  isMenuLocationSpoton: Scalars['Boolean']['output'];
  isMenuLocationSquare: Scalars['Boolean']['output'];
  isMenuLocationToast: Scalars['Boolean']['output'];
  isMenuSyncEnabled: Scalars['Boolean']['output'];
  isMovingItemsAcrossSectionsEnabled: Scalars['Boolean']['output'];
  isOpentableMenu: Scalars['Boolean']['output'];
  menuHoursCanBeChanged: Scalars['Boolean']['output'];
  posMenuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  sectionCanBeAdded: Scalars['Boolean']['output'];
  showMenu: Scalars['Boolean']['output'];
};

export type UiMenuClover = UiMenuInterface & {
  __typename?: 'UiMenuClover';
  canBeForceSynced: Scalars['Boolean']['output'];
  canToggleModifierGroupVisibility: Scalars['Boolean']['output'];
  featuredSectionCanBeAdded: Scalars['Boolean']['output'];
  hasNoChildSquareMenus: Scalars['Boolean']['output'];
  hasTimeSpecificPricing: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isBuildTypeWithNestedModifiers: Scalars['Boolean']['output'];
  isMasterWithLocation: Scalars['Boolean']['output'];
  isMasterWithoutLocation: Scalars['Boolean']['output'];
  isMenuAttachedToPos: Scalars['Boolean']['output'];
  isMenuFromPos: Scalars['Boolean']['output'];
  isMenuLocationAloha: Scalars['Boolean']['output'];
  isMenuLocationClover: Scalars['Boolean']['output'];
  isMenuLocationDeliverect: Scalars['Boolean']['output'];
  isMenuLocationHeartlandPos: Scalars['Boolean']['output'];
  isMenuLocationMicros: Scalars['Boolean']['output'];
  isMenuLocationNcrSilver: Scalars['Boolean']['output'];
  isMenuLocationSpoton: Scalars['Boolean']['output'];
  isMenuLocationSquare: Scalars['Boolean']['output'];
  isMenuLocationToast: Scalars['Boolean']['output'];
  isMenuSyncEnabled: Scalars['Boolean']['output'];
  isMovingItemsAcrossSectionsEnabled: Scalars['Boolean']['output'];
  isOpentableMenu: Scalars['Boolean']['output'];
  menuHoursCanBeChanged: Scalars['Boolean']['output'];
  posMenuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  sectionCanBeAdded: Scalars['Boolean']['output'];
  showMenu: Scalars['Boolean']['output'];
};

export type UiMenuDeliverect = UiMenuInterface & {
  __typename?: 'UiMenuDeliverect';
  canBeForceSynced: Scalars['Boolean']['output'];
  canToggleModifierGroupVisibility: Scalars['Boolean']['output'];
  featuredSectionCanBeAdded: Scalars['Boolean']['output'];
  hasNoChildSquareMenus: Scalars['Boolean']['output'];
  hasTimeSpecificPricing: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isBuildTypeWithNestedModifiers: Scalars['Boolean']['output'];
  isMasterWithLocation: Scalars['Boolean']['output'];
  isMasterWithoutLocation: Scalars['Boolean']['output'];
  isMenuAttachedToPos: Scalars['Boolean']['output'];
  isMenuFromPos: Scalars['Boolean']['output'];
  isMenuLocationAloha: Scalars['Boolean']['output'];
  isMenuLocationClover: Scalars['Boolean']['output'];
  isMenuLocationDeliverect: Scalars['Boolean']['output'];
  isMenuLocationHeartlandPos: Scalars['Boolean']['output'];
  isMenuLocationMicros: Scalars['Boolean']['output'];
  isMenuLocationNcrSilver: Scalars['Boolean']['output'];
  isMenuLocationSpoton: Scalars['Boolean']['output'];
  isMenuLocationSquare: Scalars['Boolean']['output'];
  isMenuLocationToast: Scalars['Boolean']['output'];
  isMenuSyncEnabled: Scalars['Boolean']['output'];
  isMovingItemsAcrossSectionsEnabled: Scalars['Boolean']['output'];
  isOpentableMenu: Scalars['Boolean']['output'];
  menuHoursCanBeChanged: Scalars['Boolean']['output'];
  posMenuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  sectionCanBeAdded: Scalars['Boolean']['output'];
  showMenu: Scalars['Boolean']['output'];
};

export type UiMenuHeartlandPos = UiMenuInterface & {
  __typename?: 'UiMenuHeartlandPos';
  canBeForceSynced: Scalars['Boolean']['output'];
  canToggleModifierGroupVisibility: Scalars['Boolean']['output'];
  featuredSectionCanBeAdded: Scalars['Boolean']['output'];
  hasNoChildSquareMenus: Scalars['Boolean']['output'];
  hasTimeSpecificPricing: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isBuildTypeWithNestedModifiers: Scalars['Boolean']['output'];
  isMasterWithLocation: Scalars['Boolean']['output'];
  isMasterWithoutLocation: Scalars['Boolean']['output'];
  isMenuAttachedToPos: Scalars['Boolean']['output'];
  isMenuFromPos: Scalars['Boolean']['output'];
  isMenuLocationAloha: Scalars['Boolean']['output'];
  isMenuLocationClover: Scalars['Boolean']['output'];
  isMenuLocationDeliverect: Scalars['Boolean']['output'];
  isMenuLocationHeartlandPos: Scalars['Boolean']['output'];
  isMenuLocationMicros: Scalars['Boolean']['output'];
  isMenuLocationNcrSilver: Scalars['Boolean']['output'];
  isMenuLocationSpoton: Scalars['Boolean']['output'];
  isMenuLocationSquare: Scalars['Boolean']['output'];
  isMenuLocationToast: Scalars['Boolean']['output'];
  isMenuSyncEnabled: Scalars['Boolean']['output'];
  isMovingItemsAcrossSectionsEnabled: Scalars['Boolean']['output'];
  isOpentableMenu: Scalars['Boolean']['output'];
  menuHoursCanBeChanged: Scalars['Boolean']['output'];
  posMenuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  sectionCanBeAdded: Scalars['Boolean']['output'];
  showMenu: Scalars['Boolean']['output'];
};

/** Menu UI precalculated settings */
export type UiMenuInterface = {
  canBeForceSynced: Scalars['Boolean']['output'];
  canToggleModifierGroupVisibility: Scalars['Boolean']['output'];
  featuredSectionCanBeAdded: Scalars['Boolean']['output'];
  hasNoChildSquareMenus: Scalars['Boolean']['output'];
  hasTimeSpecificPricing: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isBuildTypeWithNestedModifiers: Scalars['Boolean']['output'];
  isMasterWithLocation: Scalars['Boolean']['output'];
  isMasterWithoutLocation: Scalars['Boolean']['output'];
  isMenuAttachedToPos: Scalars['Boolean']['output'];
  isMenuFromPos: Scalars['Boolean']['output'];
  isMenuLocationAloha: Scalars['Boolean']['output'];
  isMenuLocationClover: Scalars['Boolean']['output'];
  isMenuLocationDeliverect: Scalars['Boolean']['output'];
  isMenuLocationHeartlandPos: Scalars['Boolean']['output'];
  isMenuLocationMicros: Scalars['Boolean']['output'];
  isMenuLocationNcrSilver: Scalars['Boolean']['output'];
  isMenuLocationSpoton: Scalars['Boolean']['output'];
  isMenuLocationSquare: Scalars['Boolean']['output'];
  isMenuLocationToast: Scalars['Boolean']['output'];
  isMenuSyncEnabled: Scalars['Boolean']['output'];
  isMovingItemsAcrossSectionsEnabled: Scalars['Boolean']['output'];
  isOpentableMenu: Scalars['Boolean']['output'];
  menuHoursCanBeChanged: Scalars['Boolean']['output'];
  posMenuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  sectionCanBeAdded: Scalars['Boolean']['output'];
  showMenu: Scalars['Boolean']['output'];
};

export type UiMenuItemAloha = UiMenuItemInterface & {
  __typename?: 'UiMenuItemAloha';
  canBeDeleted: Scalars['Boolean']['output'];
  canBeDisabled: Scalars['Boolean']['output'];
  canBeDragged: Scalars['Boolean']['output'];
  canSyncFromProvider: Scalars['Boolean']['output'];
  canUpdateContainsAlcohol: Scalars['Boolean']['output'];
  canUpdateOutOfStock: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isItemAttachedToPos: Scalars['Boolean']['output'];
  isItemCustomPriceType: Scalars['Boolean']['output'];
  isItemDeliverect: Scalars['Boolean']['output'];
  isItemHasBlockingSyncWarning: Scalars['Boolean']['output'];
  isItemLocationSquare: Scalars['Boolean']['output'];
  isItemLocationToast: Scalars['Boolean']['output'];
  isItemNcrSilver: Scalars['Boolean']['output'];
  isItemSquare: Scalars['Boolean']['output'];
  isItemToast: Scalars['Boolean']['output'];
  isToastPhotoSyncEnabled: Scalars['Boolean']['output'];
  itemSpecialInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  modGroupsCanBeDragged: Scalars['Boolean']['output'];
  showItemNotAttachedWarning: Scalars['Boolean']['output'];
  showSyncTab: Scalars['Boolean']['output'];
  sizeVariationCanBeChanged: Scalars['Boolean']['output'];
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UiMenuItemBase = UiMenuItemInterface & {
  __typename?: 'UiMenuItemBase';
  canBeDeleted: Scalars['Boolean']['output'];
  canBeDisabled: Scalars['Boolean']['output'];
  canBeDragged: Scalars['Boolean']['output'];
  canSyncFromProvider: Scalars['Boolean']['output'];
  canUpdateContainsAlcohol: Scalars['Boolean']['output'];
  canUpdateOutOfStock: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isItemAttachedToPos: Scalars['Boolean']['output'];
  isItemCustomPriceType: Scalars['Boolean']['output'];
  isItemDeliverect: Scalars['Boolean']['output'];
  isItemHasBlockingSyncWarning: Scalars['Boolean']['output'];
  isItemLocationSquare: Scalars['Boolean']['output'];
  isItemLocationToast: Scalars['Boolean']['output'];
  isItemNcrSilver: Scalars['Boolean']['output'];
  isItemSquare: Scalars['Boolean']['output'];
  isItemToast: Scalars['Boolean']['output'];
  isToastPhotoSyncEnabled: Scalars['Boolean']['output'];
  itemSpecialInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  modGroupsCanBeDragged: Scalars['Boolean']['output'];
  showItemNotAttachedWarning: Scalars['Boolean']['output'];
  showSyncTab: Scalars['Boolean']['output'];
  sizeVariationCanBeChanged: Scalars['Boolean']['output'];
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UiMenuItemCartAloha = UiMenuItemCartInterface & {
  __typename?: 'UiMenuItemCartAloha';
  deliveryInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  deliveryInstructionsMinLength: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isDoorDashDeliveryMissing: Scalars['Boolean']['output'];
  isGiftCardsAndOffersDisabled: Scalars['Boolean']['output'];
  isRefundButtonDisabled: Scalars['Boolean']['output'];
  isUkBased: Scalars['Boolean']['output'];
  isValidateOnCheckoutLoad: Scalars['Boolean']['output'];
  posOrderId?: Maybe<Scalars['String']['output']>;
  refundDisabledReason?: Maybe<Scalars['String']['output']>;
  showDeliveryInstructionsField: Scalars['Boolean']['output'];
  showModifiersPrices: Scalars['Boolean']['output'];
  specialInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  specialInstructionsMinLength: Scalars['Int']['output'];
};

export type UiMenuItemCartAppliedGiftCardBase = UiMenuItemCartAppliedGiftCardInterface & {
  __typename?: 'UiMenuItemCartAppliedGiftCardBase';
  amount?: Maybe<Scalars['Decimal']['output']>;
  isRefundButtonDisabled: Scalars['Boolean']['output'];
  lastFour?: Maybe<Scalars['String']['output']>;
  originalAmount?: Maybe<Scalars['Decimal']['output']>;
  refundedByUserEmail?: Maybe<Scalars['String']['output']>;
};

export type UiMenuItemCartAppliedGiftCardEcard = UiMenuItemCartAppliedGiftCardInterface & {
  __typename?: 'UiMenuItemCartAppliedGiftCardEcard';
  amount?: Maybe<Scalars['Decimal']['output']>;
  isRefundButtonDisabled: Scalars['Boolean']['output'];
  lastFour?: Maybe<Scalars['String']['output']>;
  originalAmount?: Maybe<Scalars['Decimal']['output']>;
  refundedByUserEmail?: Maybe<Scalars['String']['output']>;
};

/** Applied gift card UI precalculated settings */
export type UiMenuItemCartAppliedGiftCardInterface = {
  amount?: Maybe<Scalars['Decimal']['output']>;
  isRefundButtonDisabled: Scalars['Boolean']['output'];
  lastFour?: Maybe<Scalars['String']['output']>;
  originalAmount?: Maybe<Scalars['Decimal']['output']>;
  refundedByUserEmail?: Maybe<Scalars['String']['output']>;
};

export type UiMenuItemCartAppliedGiftCardPopmenu = UiMenuItemCartAppliedGiftCardInterface & {
  __typename?: 'UiMenuItemCartAppliedGiftCardPopmenu';
  amount?: Maybe<Scalars['Decimal']['output']>;
  isRefundButtonDisabled: Scalars['Boolean']['output'];
  lastFour?: Maybe<Scalars['String']['output']>;
  originalAmount?: Maybe<Scalars['Decimal']['output']>;
  refundedByUserEmail?: Maybe<Scalars['String']['output']>;
};

export type UiMenuItemCartAppliedGiftCardSquare = UiMenuItemCartAppliedGiftCardInterface & {
  __typename?: 'UiMenuItemCartAppliedGiftCardSquare';
  amount?: Maybe<Scalars['Decimal']['output']>;
  isRefundButtonDisabled: Scalars['Boolean']['output'];
  lastFour?: Maybe<Scalars['String']['output']>;
  originalAmount?: Maybe<Scalars['Decimal']['output']>;
  refundedByUserEmail?: Maybe<Scalars['String']['output']>;
};

export type UiMenuItemCartBase = UiMenuItemCartInterface & {
  __typename?: 'UiMenuItemCartBase';
  deliveryInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  deliveryInstructionsMinLength: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isDoorDashDeliveryMissing: Scalars['Boolean']['output'];
  isGiftCardsAndOffersDisabled: Scalars['Boolean']['output'];
  isRefundButtonDisabled: Scalars['Boolean']['output'];
  isUkBased: Scalars['Boolean']['output'];
  isValidateOnCheckoutLoad: Scalars['Boolean']['output'];
  posOrderId?: Maybe<Scalars['String']['output']>;
  refundDisabledReason?: Maybe<Scalars['String']['output']>;
  showDeliveryInstructionsField: Scalars['Boolean']['output'];
  showModifiersPrices: Scalars['Boolean']['output'];
  specialInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  specialInstructionsMinLength: Scalars['Int']['output'];
};

export type UiMenuItemCartClover = UiMenuItemCartInterface & {
  __typename?: 'UiMenuItemCartClover';
  deliveryInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  deliveryInstructionsMinLength: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isDoorDashDeliveryMissing: Scalars['Boolean']['output'];
  isGiftCardsAndOffersDisabled: Scalars['Boolean']['output'];
  isRefundButtonDisabled: Scalars['Boolean']['output'];
  isUkBased: Scalars['Boolean']['output'];
  isValidateOnCheckoutLoad: Scalars['Boolean']['output'];
  posOrderId?: Maybe<Scalars['String']['output']>;
  refundDisabledReason?: Maybe<Scalars['String']['output']>;
  showDeliveryInstructionsField: Scalars['Boolean']['output'];
  showModifiersPrices: Scalars['Boolean']['output'];
  specialInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  specialInstructionsMinLength: Scalars['Int']['output'];
};

export type UiMenuItemCartDeliverect = UiMenuItemCartInterface & {
  __typename?: 'UiMenuItemCartDeliverect';
  deliveryInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  deliveryInstructionsMinLength: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isDoorDashDeliveryMissing: Scalars['Boolean']['output'];
  isGiftCardsAndOffersDisabled: Scalars['Boolean']['output'];
  isRefundButtonDisabled: Scalars['Boolean']['output'];
  isUkBased: Scalars['Boolean']['output'];
  isValidateOnCheckoutLoad: Scalars['Boolean']['output'];
  posOrderId?: Maybe<Scalars['String']['output']>;
  refundDisabledReason?: Maybe<Scalars['String']['output']>;
  showDeliveryInstructionsField: Scalars['Boolean']['output'];
  showModifiersPrices: Scalars['Boolean']['output'];
  specialInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  specialInstructionsMinLength: Scalars['Int']['output'];
};

export type UiMenuItemCartEveryware = UiMenuItemCartInterface & {
  __typename?: 'UiMenuItemCartEveryware';
  deliveryInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  deliveryInstructionsMinLength: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isDoorDashDeliveryMissing: Scalars['Boolean']['output'];
  isGiftCardsAndOffersDisabled: Scalars['Boolean']['output'];
  isRefundButtonDisabled: Scalars['Boolean']['output'];
  isUkBased: Scalars['Boolean']['output'];
  isValidateOnCheckoutLoad: Scalars['Boolean']['output'];
  posOrderId?: Maybe<Scalars['String']['output']>;
  refundDisabledReason?: Maybe<Scalars['String']['output']>;
  showDeliveryInstructionsField: Scalars['Boolean']['output'];
  showModifiersPrices: Scalars['Boolean']['output'];
  specialInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  specialInstructionsMinLength: Scalars['Int']['output'];
};

export type UiMenuItemCartHeartland = UiMenuItemCartInterface & {
  __typename?: 'UiMenuItemCartHeartland';
  deliveryInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  deliveryInstructionsMinLength: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isDoorDashDeliveryMissing: Scalars['Boolean']['output'];
  isGiftCardsAndOffersDisabled: Scalars['Boolean']['output'];
  isRefundButtonDisabled: Scalars['Boolean']['output'];
  isUkBased: Scalars['Boolean']['output'];
  isValidateOnCheckoutLoad: Scalars['Boolean']['output'];
  posOrderId?: Maybe<Scalars['String']['output']>;
  refundDisabledReason?: Maybe<Scalars['String']['output']>;
  showDeliveryInstructionsField: Scalars['Boolean']['output'];
  showModifiersPrices: Scalars['Boolean']['output'];
  specialInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  specialInstructionsMinLength: Scalars['Int']['output'];
};

export type UiMenuItemCartHeartlandPos = UiMenuItemCartInterface & {
  __typename?: 'UiMenuItemCartHeartlandPos';
  deliveryInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  deliveryInstructionsMinLength: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isDoorDashDeliveryMissing: Scalars['Boolean']['output'];
  isGiftCardsAndOffersDisabled: Scalars['Boolean']['output'];
  isRefundButtonDisabled: Scalars['Boolean']['output'];
  isUkBased: Scalars['Boolean']['output'];
  isValidateOnCheckoutLoad: Scalars['Boolean']['output'];
  posOrderId?: Maybe<Scalars['String']['output']>;
  refundDisabledReason?: Maybe<Scalars['String']['output']>;
  showDeliveryInstructionsField: Scalars['Boolean']['output'];
  showModifiersPrices: Scalars['Boolean']['output'];
  specialInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  specialInstructionsMinLength: Scalars['Int']['output'];
};

/** Menu item cart UI precalculated settings */
export type UiMenuItemCartInterface = {
  deliveryInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  deliveryInstructionsMinLength: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isDoorDashDeliveryMissing: Scalars['Boolean']['output'];
  isGiftCardsAndOffersDisabled: Scalars['Boolean']['output'];
  isRefundButtonDisabled: Scalars['Boolean']['output'];
  isUkBased: Scalars['Boolean']['output'];
  isValidateOnCheckoutLoad: Scalars['Boolean']['output'];
  posOrderId?: Maybe<Scalars['String']['output']>;
  refundDisabledReason?: Maybe<Scalars['String']['output']>;
  showDeliveryInstructionsField: Scalars['Boolean']['output'];
  showModifiersPrices: Scalars['Boolean']['output'];
  specialInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  specialInstructionsMinLength: Scalars['Int']['output'];
};

export type UiMenuItemCartMicros = UiMenuItemCartInterface & {
  __typename?: 'UiMenuItemCartMicros';
  deliveryInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  deliveryInstructionsMinLength: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isDoorDashDeliveryMissing: Scalars['Boolean']['output'];
  isGiftCardsAndOffersDisabled: Scalars['Boolean']['output'];
  isRefundButtonDisabled: Scalars['Boolean']['output'];
  isUkBased: Scalars['Boolean']['output'];
  isValidateOnCheckoutLoad: Scalars['Boolean']['output'];
  posOrderId?: Maybe<Scalars['String']['output']>;
  refundDisabledReason?: Maybe<Scalars['String']['output']>;
  showDeliveryInstructionsField: Scalars['Boolean']['output'];
  showModifiersPrices: Scalars['Boolean']['output'];
  specialInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  specialInstructionsMinLength: Scalars['Int']['output'];
};

export type UiMenuItemCartNcrSilver = UiMenuItemCartInterface & {
  __typename?: 'UiMenuItemCartNcrSilver';
  deliveryInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  deliveryInstructionsMinLength: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isDoorDashDeliveryMissing: Scalars['Boolean']['output'];
  isGiftCardsAndOffersDisabled: Scalars['Boolean']['output'];
  isRefundButtonDisabled: Scalars['Boolean']['output'];
  isUkBased: Scalars['Boolean']['output'];
  isValidateOnCheckoutLoad: Scalars['Boolean']['output'];
  posOrderId?: Maybe<Scalars['String']['output']>;
  refundDisabledReason?: Maybe<Scalars['String']['output']>;
  showDeliveryInstructionsField: Scalars['Boolean']['output'];
  showModifiersPrices: Scalars['Boolean']['output'];
  specialInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  specialInstructionsMinLength: Scalars['Int']['output'];
};

export type UiMenuItemCartSpoton = UiMenuItemCartInterface & {
  __typename?: 'UiMenuItemCartSpoton';
  deliveryInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  deliveryInstructionsMinLength: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isDoorDashDeliveryMissing: Scalars['Boolean']['output'];
  isGiftCardsAndOffersDisabled: Scalars['Boolean']['output'];
  isRefundButtonDisabled: Scalars['Boolean']['output'];
  isUkBased: Scalars['Boolean']['output'];
  isValidateOnCheckoutLoad: Scalars['Boolean']['output'];
  posOrderId?: Maybe<Scalars['String']['output']>;
  refundDisabledReason?: Maybe<Scalars['String']['output']>;
  showDeliveryInstructionsField: Scalars['Boolean']['output'];
  showModifiersPrices: Scalars['Boolean']['output'];
  specialInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  specialInstructionsMinLength: Scalars['Int']['output'];
};

export type UiMenuItemCartSquare = UiMenuItemCartInterface & {
  __typename?: 'UiMenuItemCartSquare';
  deliveryInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  deliveryInstructionsMinLength: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isDoorDashDeliveryMissing: Scalars['Boolean']['output'];
  isGiftCardsAndOffersDisabled: Scalars['Boolean']['output'];
  isRefundButtonDisabled: Scalars['Boolean']['output'];
  isUkBased: Scalars['Boolean']['output'];
  isValidateOnCheckoutLoad: Scalars['Boolean']['output'];
  posOrderId?: Maybe<Scalars['String']['output']>;
  refundDisabledReason?: Maybe<Scalars['String']['output']>;
  showDeliveryInstructionsField: Scalars['Boolean']['output'];
  showModifiersPrices: Scalars['Boolean']['output'];
  specialInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  specialInstructionsMinLength: Scalars['Int']['output'];
};

export type UiMenuItemCartStripe = UiMenuItemCartInterface & {
  __typename?: 'UiMenuItemCartStripe';
  deliveryInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  deliveryInstructionsMinLength: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isDoorDashDeliveryMissing: Scalars['Boolean']['output'];
  isGiftCardsAndOffersDisabled: Scalars['Boolean']['output'];
  isRefundButtonDisabled: Scalars['Boolean']['output'];
  isUkBased: Scalars['Boolean']['output'];
  isValidateOnCheckoutLoad: Scalars['Boolean']['output'];
  posOrderId?: Maybe<Scalars['String']['output']>;
  refundDisabledReason?: Maybe<Scalars['String']['output']>;
  showDeliveryInstructionsField: Scalars['Boolean']['output'];
  showModifiersPrices: Scalars['Boolean']['output'];
  specialInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  specialInstructionsMinLength: Scalars['Int']['output'];
};

export type UiMenuItemCartToast = UiMenuItemCartInterface & {
  __typename?: 'UiMenuItemCartToast';
  deliveryInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  deliveryInstructionsMinLength: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isDoorDashDeliveryMissing: Scalars['Boolean']['output'];
  isGiftCardsAndOffersDisabled: Scalars['Boolean']['output'];
  isRefundButtonDisabled: Scalars['Boolean']['output'];
  isUkBased: Scalars['Boolean']['output'];
  isValidateOnCheckoutLoad: Scalars['Boolean']['output'];
  posOrderId?: Maybe<Scalars['String']['output']>;
  refundDisabledReason?: Maybe<Scalars['String']['output']>;
  showDeliveryInstructionsField: Scalars['Boolean']['output'];
  showModifiersPrices: Scalars['Boolean']['output'];
  specialInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  specialInstructionsMinLength: Scalars['Int']['output'];
};

export type UiMenuItemClover = UiMenuItemInterface & {
  __typename?: 'UiMenuItemClover';
  canBeDeleted: Scalars['Boolean']['output'];
  canBeDisabled: Scalars['Boolean']['output'];
  canBeDragged: Scalars['Boolean']['output'];
  canSyncFromProvider: Scalars['Boolean']['output'];
  canUpdateContainsAlcohol: Scalars['Boolean']['output'];
  canUpdateOutOfStock: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isItemAttachedToPos: Scalars['Boolean']['output'];
  isItemCustomPriceType: Scalars['Boolean']['output'];
  isItemDeliverect: Scalars['Boolean']['output'];
  isItemHasBlockingSyncWarning: Scalars['Boolean']['output'];
  isItemLocationSquare: Scalars['Boolean']['output'];
  isItemLocationToast: Scalars['Boolean']['output'];
  isItemNcrSilver: Scalars['Boolean']['output'];
  isItemSquare: Scalars['Boolean']['output'];
  isItemToast: Scalars['Boolean']['output'];
  isToastPhotoSyncEnabled: Scalars['Boolean']['output'];
  itemSpecialInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  modGroupsCanBeDragged: Scalars['Boolean']['output'];
  showItemNotAttachedWarning: Scalars['Boolean']['output'];
  showSyncTab: Scalars['Boolean']['output'];
  sizeVariationCanBeChanged: Scalars['Boolean']['output'];
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UiMenuItemDeliverect = UiMenuItemInterface & {
  __typename?: 'UiMenuItemDeliverect';
  canBeDeleted: Scalars['Boolean']['output'];
  canBeDisabled: Scalars['Boolean']['output'];
  canBeDragged: Scalars['Boolean']['output'];
  canSyncFromProvider: Scalars['Boolean']['output'];
  canUpdateContainsAlcohol: Scalars['Boolean']['output'];
  canUpdateOutOfStock: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isItemAttachedToPos: Scalars['Boolean']['output'];
  isItemCustomPriceType: Scalars['Boolean']['output'];
  isItemDeliverect: Scalars['Boolean']['output'];
  isItemHasBlockingSyncWarning: Scalars['Boolean']['output'];
  isItemLocationSquare: Scalars['Boolean']['output'];
  isItemLocationToast: Scalars['Boolean']['output'];
  isItemNcrSilver: Scalars['Boolean']['output'];
  isItemSquare: Scalars['Boolean']['output'];
  isItemToast: Scalars['Boolean']['output'];
  isToastPhotoSyncEnabled: Scalars['Boolean']['output'];
  itemSpecialInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  modGroupsCanBeDragged: Scalars['Boolean']['output'];
  showItemNotAttachedWarning: Scalars['Boolean']['output'];
  showSyncTab: Scalars['Boolean']['output'];
  sizeVariationCanBeChanged: Scalars['Boolean']['output'];
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UiMenuItemHeartlandPos = UiMenuItemInterface & {
  __typename?: 'UiMenuItemHeartlandPos';
  canBeDeleted: Scalars['Boolean']['output'];
  canBeDisabled: Scalars['Boolean']['output'];
  canBeDragged: Scalars['Boolean']['output'];
  canSyncFromProvider: Scalars['Boolean']['output'];
  canUpdateContainsAlcohol: Scalars['Boolean']['output'];
  canUpdateOutOfStock: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isItemAttachedToPos: Scalars['Boolean']['output'];
  isItemCustomPriceType: Scalars['Boolean']['output'];
  isItemDeliverect: Scalars['Boolean']['output'];
  isItemHasBlockingSyncWarning: Scalars['Boolean']['output'];
  isItemLocationSquare: Scalars['Boolean']['output'];
  isItemLocationToast: Scalars['Boolean']['output'];
  isItemNcrSilver: Scalars['Boolean']['output'];
  isItemSquare: Scalars['Boolean']['output'];
  isItemToast: Scalars['Boolean']['output'];
  isToastPhotoSyncEnabled: Scalars['Boolean']['output'];
  itemSpecialInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  modGroupsCanBeDragged: Scalars['Boolean']['output'];
  showItemNotAttachedWarning: Scalars['Boolean']['output'];
  showSyncTab: Scalars['Boolean']['output'];
  sizeVariationCanBeChanged: Scalars['Boolean']['output'];
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Item UI precalculated settings */
export type UiMenuItemInterface = {
  canBeDeleted: Scalars['Boolean']['output'];
  canBeDisabled: Scalars['Boolean']['output'];
  canBeDragged: Scalars['Boolean']['output'];
  canSyncFromProvider: Scalars['Boolean']['output'];
  canUpdateContainsAlcohol: Scalars['Boolean']['output'];
  canUpdateOutOfStock: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isItemAttachedToPos: Scalars['Boolean']['output'];
  isItemCustomPriceType: Scalars['Boolean']['output'];
  isItemDeliverect: Scalars['Boolean']['output'];
  isItemHasBlockingSyncWarning: Scalars['Boolean']['output'];
  isItemLocationSquare: Scalars['Boolean']['output'];
  isItemLocationToast: Scalars['Boolean']['output'];
  isItemNcrSilver: Scalars['Boolean']['output'];
  isItemSquare: Scalars['Boolean']['output'];
  isItemToast: Scalars['Boolean']['output'];
  isToastPhotoSyncEnabled: Scalars['Boolean']['output'];
  itemSpecialInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  modGroupsCanBeDragged: Scalars['Boolean']['output'];
  showItemNotAttachedWarning: Scalars['Boolean']['output'];
  showSyncTab: Scalars['Boolean']['output'];
  sizeVariationCanBeChanged: Scalars['Boolean']['output'];
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UiMenuItemMicros = UiMenuItemInterface & {
  __typename?: 'UiMenuItemMicros';
  canBeDeleted: Scalars['Boolean']['output'];
  canBeDisabled: Scalars['Boolean']['output'];
  canBeDragged: Scalars['Boolean']['output'];
  canSyncFromProvider: Scalars['Boolean']['output'];
  canUpdateContainsAlcohol: Scalars['Boolean']['output'];
  canUpdateOutOfStock: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isItemAttachedToPos: Scalars['Boolean']['output'];
  isItemCustomPriceType: Scalars['Boolean']['output'];
  isItemDeliverect: Scalars['Boolean']['output'];
  isItemHasBlockingSyncWarning: Scalars['Boolean']['output'];
  isItemLocationSquare: Scalars['Boolean']['output'];
  isItemLocationToast: Scalars['Boolean']['output'];
  isItemNcrSilver: Scalars['Boolean']['output'];
  isItemSquare: Scalars['Boolean']['output'];
  isItemToast: Scalars['Boolean']['output'];
  isToastPhotoSyncEnabled: Scalars['Boolean']['output'];
  itemSpecialInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  modGroupsCanBeDragged: Scalars['Boolean']['output'];
  showItemNotAttachedWarning: Scalars['Boolean']['output'];
  showSyncTab: Scalars['Boolean']['output'];
  sizeVariationCanBeChanged: Scalars['Boolean']['output'];
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UiMenuItemModifierGroupAloha = UiMenuItemModifierGroupInterface & {
  __typename?: 'UiMenuItemModifierGroupAloha';
  canChangeModifierPositions: Scalars['Boolean']['output'];
  canToggleModifierGroupVisibility: Scalars['Boolean']['output'];
  canToggleModifierVisibility: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
};

export type UiMenuItemModifierGroupBase = UiMenuItemModifierGroupInterface & {
  __typename?: 'UiMenuItemModifierGroupBase';
  canChangeModifierPositions: Scalars['Boolean']['output'];
  canToggleModifierGroupVisibility: Scalars['Boolean']['output'];
  canToggleModifierVisibility: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
};

export type UiMenuItemModifierGroupClover = UiMenuItemModifierGroupInterface & {
  __typename?: 'UiMenuItemModifierGroupClover';
  canChangeModifierPositions: Scalars['Boolean']['output'];
  canToggleModifierGroupVisibility: Scalars['Boolean']['output'];
  canToggleModifierVisibility: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
};

export type UiMenuItemModifierGroupDeliverect = UiMenuItemModifierGroupInterface & {
  __typename?: 'UiMenuItemModifierGroupDeliverect';
  canChangeModifierPositions: Scalars['Boolean']['output'];
  canToggleModifierGroupVisibility: Scalars['Boolean']['output'];
  canToggleModifierVisibility: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
};

export type UiMenuItemModifierGroupHeartlandPos = UiMenuItemModifierGroupInterface & {
  __typename?: 'UiMenuItemModifierGroupHeartlandPos';
  canChangeModifierPositions: Scalars['Boolean']['output'];
  canToggleModifierGroupVisibility: Scalars['Boolean']['output'];
  canToggleModifierVisibility: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
};

/** Menu Item Modifier group UI precalculated settings */
export type UiMenuItemModifierGroupInterface = {
  canChangeModifierPositions: Scalars['Boolean']['output'];
  canToggleModifierGroupVisibility: Scalars['Boolean']['output'];
  canToggleModifierVisibility: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
};

export type UiMenuItemModifierGroupSpoton = UiMenuItemModifierGroupInterface & {
  __typename?: 'UiMenuItemModifierGroupSpoton';
  canChangeModifierPositions: Scalars['Boolean']['output'];
  canToggleModifierGroupVisibility: Scalars['Boolean']['output'];
  canToggleModifierVisibility: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
};

export type UiMenuItemModifierGroupSquare = UiMenuItemModifierGroupInterface & {
  __typename?: 'UiMenuItemModifierGroupSquare';
  canChangeModifierPositions: Scalars['Boolean']['output'];
  canToggleModifierGroupVisibility: Scalars['Boolean']['output'];
  canToggleModifierVisibility: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
};

export type UiMenuItemModifierGroupToast = UiMenuItemModifierGroupInterface & {
  __typename?: 'UiMenuItemModifierGroupToast';
  canChangeModifierPositions: Scalars['Boolean']['output'];
  canToggleModifierGroupVisibility: Scalars['Boolean']['output'];
  canToggleModifierVisibility: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
};

export type UiMenuItemNcrSilver = UiMenuItemInterface & {
  __typename?: 'UiMenuItemNcrSilver';
  canBeDeleted: Scalars['Boolean']['output'];
  canBeDisabled: Scalars['Boolean']['output'];
  canBeDragged: Scalars['Boolean']['output'];
  canSyncFromProvider: Scalars['Boolean']['output'];
  canUpdateContainsAlcohol: Scalars['Boolean']['output'];
  canUpdateOutOfStock: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isItemAttachedToPos: Scalars['Boolean']['output'];
  isItemCustomPriceType: Scalars['Boolean']['output'];
  isItemDeliverect: Scalars['Boolean']['output'];
  isItemHasBlockingSyncWarning: Scalars['Boolean']['output'];
  isItemLocationSquare: Scalars['Boolean']['output'];
  isItemLocationToast: Scalars['Boolean']['output'];
  isItemNcrSilver: Scalars['Boolean']['output'];
  isItemSquare: Scalars['Boolean']['output'];
  isItemToast: Scalars['Boolean']['output'];
  isToastPhotoSyncEnabled: Scalars['Boolean']['output'];
  itemSpecialInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  modGroupsCanBeDragged: Scalars['Boolean']['output'];
  showItemNotAttachedWarning: Scalars['Boolean']['output'];
  showSyncTab: Scalars['Boolean']['output'];
  sizeVariationCanBeChanged: Scalars['Boolean']['output'];
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UiMenuItemSpoton = UiMenuItemInterface & {
  __typename?: 'UiMenuItemSpoton';
  canBeDeleted: Scalars['Boolean']['output'];
  canBeDisabled: Scalars['Boolean']['output'];
  canBeDragged: Scalars['Boolean']['output'];
  canSyncFromProvider: Scalars['Boolean']['output'];
  canUpdateContainsAlcohol: Scalars['Boolean']['output'];
  canUpdateOutOfStock: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isItemAttachedToPos: Scalars['Boolean']['output'];
  isItemCustomPriceType: Scalars['Boolean']['output'];
  isItemDeliverect: Scalars['Boolean']['output'];
  isItemHasBlockingSyncWarning: Scalars['Boolean']['output'];
  isItemLocationSquare: Scalars['Boolean']['output'];
  isItemLocationToast: Scalars['Boolean']['output'];
  isItemNcrSilver: Scalars['Boolean']['output'];
  isItemSquare: Scalars['Boolean']['output'];
  isItemToast: Scalars['Boolean']['output'];
  isToastPhotoSyncEnabled: Scalars['Boolean']['output'];
  itemSpecialInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  modGroupsCanBeDragged: Scalars['Boolean']['output'];
  showItemNotAttachedWarning: Scalars['Boolean']['output'];
  showSyncTab: Scalars['Boolean']['output'];
  sizeVariationCanBeChanged: Scalars['Boolean']['output'];
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UiMenuItemSquare = UiMenuItemInterface & {
  __typename?: 'UiMenuItemSquare';
  canBeDeleted: Scalars['Boolean']['output'];
  canBeDisabled: Scalars['Boolean']['output'];
  canBeDragged: Scalars['Boolean']['output'];
  canSyncFromProvider: Scalars['Boolean']['output'];
  canUpdateContainsAlcohol: Scalars['Boolean']['output'];
  canUpdateOutOfStock: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isItemAttachedToPos: Scalars['Boolean']['output'];
  isItemCustomPriceType: Scalars['Boolean']['output'];
  isItemDeliverect: Scalars['Boolean']['output'];
  isItemHasBlockingSyncWarning: Scalars['Boolean']['output'];
  isItemLocationSquare: Scalars['Boolean']['output'];
  isItemLocationToast: Scalars['Boolean']['output'];
  isItemNcrSilver: Scalars['Boolean']['output'];
  isItemSquare: Scalars['Boolean']['output'];
  isItemToast: Scalars['Boolean']['output'];
  isToastPhotoSyncEnabled: Scalars['Boolean']['output'];
  itemSpecialInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  modGroupsCanBeDragged: Scalars['Boolean']['output'];
  showItemNotAttachedWarning: Scalars['Boolean']['output'];
  showSyncTab: Scalars['Boolean']['output'];
  sizeVariationCanBeChanged: Scalars['Boolean']['output'];
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UiMenuItemToast = UiMenuItemInterface & {
  __typename?: 'UiMenuItemToast';
  canBeDeleted: Scalars['Boolean']['output'];
  canBeDisabled: Scalars['Boolean']['output'];
  canBeDragged: Scalars['Boolean']['output'];
  canSyncFromProvider: Scalars['Boolean']['output'];
  canUpdateContainsAlcohol: Scalars['Boolean']['output'];
  canUpdateOutOfStock: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isItemAttachedToPos: Scalars['Boolean']['output'];
  isItemCustomPriceType: Scalars['Boolean']['output'];
  isItemDeliverect: Scalars['Boolean']['output'];
  isItemHasBlockingSyncWarning: Scalars['Boolean']['output'];
  isItemLocationSquare: Scalars['Boolean']['output'];
  isItemLocationToast: Scalars['Boolean']['output'];
  isItemNcrSilver: Scalars['Boolean']['output'];
  isItemSquare: Scalars['Boolean']['output'];
  isItemToast: Scalars['Boolean']['output'];
  isToastPhotoSyncEnabled: Scalars['Boolean']['output'];
  itemSpecialInstructionsMaxLength?: Maybe<Scalars['Int']['output']>;
  modGroupsCanBeDragged: Scalars['Boolean']['output'];
  showItemNotAttachedWarning: Scalars['Boolean']['output'];
  showSyncTab: Scalars['Boolean']['output'];
  sizeVariationCanBeChanged: Scalars['Boolean']['output'];
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UiMenuMicros = UiMenuInterface & {
  __typename?: 'UiMenuMicros';
  canBeForceSynced: Scalars['Boolean']['output'];
  canToggleModifierGroupVisibility: Scalars['Boolean']['output'];
  featuredSectionCanBeAdded: Scalars['Boolean']['output'];
  hasNoChildSquareMenus: Scalars['Boolean']['output'];
  hasTimeSpecificPricing: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isBuildTypeWithNestedModifiers: Scalars['Boolean']['output'];
  isMasterWithLocation: Scalars['Boolean']['output'];
  isMasterWithoutLocation: Scalars['Boolean']['output'];
  isMenuAttachedToPos: Scalars['Boolean']['output'];
  isMenuFromPos: Scalars['Boolean']['output'];
  isMenuLocationAloha: Scalars['Boolean']['output'];
  isMenuLocationClover: Scalars['Boolean']['output'];
  isMenuLocationDeliverect: Scalars['Boolean']['output'];
  isMenuLocationHeartlandPos: Scalars['Boolean']['output'];
  isMenuLocationMicros: Scalars['Boolean']['output'];
  isMenuLocationNcrSilver: Scalars['Boolean']['output'];
  isMenuLocationSpoton: Scalars['Boolean']['output'];
  isMenuLocationSquare: Scalars['Boolean']['output'];
  isMenuLocationToast: Scalars['Boolean']['output'];
  isMenuSyncEnabled: Scalars['Boolean']['output'];
  isMovingItemsAcrossSectionsEnabled: Scalars['Boolean']['output'];
  isOpentableMenu: Scalars['Boolean']['output'];
  menuHoursCanBeChanged: Scalars['Boolean']['output'];
  posMenuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  sectionCanBeAdded: Scalars['Boolean']['output'];
  showMenu: Scalars['Boolean']['output'];
};

export type UiMenuNcrSilver = UiMenuInterface & {
  __typename?: 'UiMenuNcrSilver';
  canBeForceSynced: Scalars['Boolean']['output'];
  canToggleModifierGroupVisibility: Scalars['Boolean']['output'];
  featuredSectionCanBeAdded: Scalars['Boolean']['output'];
  hasNoChildSquareMenus: Scalars['Boolean']['output'];
  hasTimeSpecificPricing: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isBuildTypeWithNestedModifiers: Scalars['Boolean']['output'];
  isMasterWithLocation: Scalars['Boolean']['output'];
  isMasterWithoutLocation: Scalars['Boolean']['output'];
  isMenuAttachedToPos: Scalars['Boolean']['output'];
  isMenuFromPos: Scalars['Boolean']['output'];
  isMenuLocationAloha: Scalars['Boolean']['output'];
  isMenuLocationClover: Scalars['Boolean']['output'];
  isMenuLocationDeliverect: Scalars['Boolean']['output'];
  isMenuLocationHeartlandPos: Scalars['Boolean']['output'];
  isMenuLocationMicros: Scalars['Boolean']['output'];
  isMenuLocationNcrSilver: Scalars['Boolean']['output'];
  isMenuLocationSpoton: Scalars['Boolean']['output'];
  isMenuLocationSquare: Scalars['Boolean']['output'];
  isMenuLocationToast: Scalars['Boolean']['output'];
  isMenuSyncEnabled: Scalars['Boolean']['output'];
  isMovingItemsAcrossSectionsEnabled: Scalars['Boolean']['output'];
  isOpentableMenu: Scalars['Boolean']['output'];
  menuHoursCanBeChanged: Scalars['Boolean']['output'];
  posMenuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  sectionCanBeAdded: Scalars['Boolean']['output'];
  showMenu: Scalars['Boolean']['output'];
};

export type UiMenuSectionAloha = UiMenuSectionInterface & {
  __typename?: 'UiMenuSectionAloha';
  canBeAlphabetized: Scalars['Boolean']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  canBeDisabled: Scalars['Boolean']['output'];
  canBeDragged: Scalars['Boolean']['output'];
  descriptionCanBeChanged: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  subsectionCanBeAdded: Scalars['Boolean']['output'];
  titleCanBeChanged: Scalars['Boolean']['output'];
};

export type UiMenuSectionBase = UiMenuSectionInterface & {
  __typename?: 'UiMenuSectionBase';
  canBeAlphabetized: Scalars['Boolean']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  canBeDisabled: Scalars['Boolean']['output'];
  canBeDragged: Scalars['Boolean']['output'];
  descriptionCanBeChanged: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  subsectionCanBeAdded: Scalars['Boolean']['output'];
  titleCanBeChanged: Scalars['Boolean']['output'];
};

export type UiMenuSectionClover = UiMenuSectionInterface & {
  __typename?: 'UiMenuSectionClover';
  canBeAlphabetized: Scalars['Boolean']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  canBeDisabled: Scalars['Boolean']['output'];
  canBeDragged: Scalars['Boolean']['output'];
  descriptionCanBeChanged: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  subsectionCanBeAdded: Scalars['Boolean']['output'];
  titleCanBeChanged: Scalars['Boolean']['output'];
};

export type UiMenuSectionDeliverect = UiMenuSectionInterface & {
  __typename?: 'UiMenuSectionDeliverect';
  canBeAlphabetized: Scalars['Boolean']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  canBeDisabled: Scalars['Boolean']['output'];
  canBeDragged: Scalars['Boolean']['output'];
  descriptionCanBeChanged: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  subsectionCanBeAdded: Scalars['Boolean']['output'];
  titleCanBeChanged: Scalars['Boolean']['output'];
};

export type UiMenuSectionHeartlandPos = UiMenuSectionInterface & {
  __typename?: 'UiMenuSectionHeartlandPos';
  canBeAlphabetized: Scalars['Boolean']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  canBeDisabled: Scalars['Boolean']['output'];
  canBeDragged: Scalars['Boolean']['output'];
  descriptionCanBeChanged: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  subsectionCanBeAdded: Scalars['Boolean']['output'];
  titleCanBeChanged: Scalars['Boolean']['output'];
};

/** Section UI precalculated settings */
export type UiMenuSectionInterface = {
  canBeAlphabetized: Scalars['Boolean']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  canBeDisabled: Scalars['Boolean']['output'];
  canBeDragged: Scalars['Boolean']['output'];
  descriptionCanBeChanged: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  subsectionCanBeAdded: Scalars['Boolean']['output'];
  titleCanBeChanged: Scalars['Boolean']['output'];
};

export type UiMenuSectionMicros = UiMenuSectionInterface & {
  __typename?: 'UiMenuSectionMicros';
  canBeAlphabetized: Scalars['Boolean']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  canBeDisabled: Scalars['Boolean']['output'];
  canBeDragged: Scalars['Boolean']['output'];
  descriptionCanBeChanged: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  subsectionCanBeAdded: Scalars['Boolean']['output'];
  titleCanBeChanged: Scalars['Boolean']['output'];
};

export type UiMenuSectionNcrSilver = UiMenuSectionInterface & {
  __typename?: 'UiMenuSectionNcrSilver';
  canBeAlphabetized: Scalars['Boolean']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  canBeDisabled: Scalars['Boolean']['output'];
  canBeDragged: Scalars['Boolean']['output'];
  descriptionCanBeChanged: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  subsectionCanBeAdded: Scalars['Boolean']['output'];
  titleCanBeChanged: Scalars['Boolean']['output'];
};

export type UiMenuSectionSpoton = UiMenuSectionInterface & {
  __typename?: 'UiMenuSectionSpoton';
  canBeAlphabetized: Scalars['Boolean']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  canBeDisabled: Scalars['Boolean']['output'];
  canBeDragged: Scalars['Boolean']['output'];
  descriptionCanBeChanged: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  subsectionCanBeAdded: Scalars['Boolean']['output'];
  titleCanBeChanged: Scalars['Boolean']['output'];
};

export type UiMenuSectionSquare = UiMenuSectionInterface & {
  __typename?: 'UiMenuSectionSquare';
  canBeAlphabetized: Scalars['Boolean']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  canBeDisabled: Scalars['Boolean']['output'];
  canBeDragged: Scalars['Boolean']['output'];
  descriptionCanBeChanged: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  subsectionCanBeAdded: Scalars['Boolean']['output'];
  titleCanBeChanged: Scalars['Boolean']['output'];
};

export type UiMenuSectionToast = UiMenuSectionInterface & {
  __typename?: 'UiMenuSectionToast';
  canBeAlphabetized: Scalars['Boolean']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  canBeDisabled: Scalars['Boolean']['output'];
  canBeDragged: Scalars['Boolean']['output'];
  descriptionCanBeChanged: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  subsectionCanBeAdded: Scalars['Boolean']['output'];
  titleCanBeChanged: Scalars['Boolean']['output'];
};

export type UiMenuSpoton = UiMenuInterface & {
  __typename?: 'UiMenuSpoton';
  canBeForceSynced: Scalars['Boolean']['output'];
  canToggleModifierGroupVisibility: Scalars['Boolean']['output'];
  featuredSectionCanBeAdded: Scalars['Boolean']['output'];
  hasNoChildSquareMenus: Scalars['Boolean']['output'];
  hasTimeSpecificPricing: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isBuildTypeWithNestedModifiers: Scalars['Boolean']['output'];
  isMasterWithLocation: Scalars['Boolean']['output'];
  isMasterWithoutLocation: Scalars['Boolean']['output'];
  isMenuAttachedToPos: Scalars['Boolean']['output'];
  isMenuFromPos: Scalars['Boolean']['output'];
  isMenuLocationAloha: Scalars['Boolean']['output'];
  isMenuLocationClover: Scalars['Boolean']['output'];
  isMenuLocationDeliverect: Scalars['Boolean']['output'];
  isMenuLocationHeartlandPos: Scalars['Boolean']['output'];
  isMenuLocationMicros: Scalars['Boolean']['output'];
  isMenuLocationNcrSilver: Scalars['Boolean']['output'];
  isMenuLocationSpoton: Scalars['Boolean']['output'];
  isMenuLocationSquare: Scalars['Boolean']['output'];
  isMenuLocationToast: Scalars['Boolean']['output'];
  isMenuSyncEnabled: Scalars['Boolean']['output'];
  isMovingItemsAcrossSectionsEnabled: Scalars['Boolean']['output'];
  isOpentableMenu: Scalars['Boolean']['output'];
  menuHoursCanBeChanged: Scalars['Boolean']['output'];
  posMenuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  sectionCanBeAdded: Scalars['Boolean']['output'];
  showMenu: Scalars['Boolean']['output'];
};

export type UiMenuSquare = UiMenuInterface & {
  __typename?: 'UiMenuSquare';
  canBeForceSynced: Scalars['Boolean']['output'];
  canToggleModifierGroupVisibility: Scalars['Boolean']['output'];
  featuredSectionCanBeAdded: Scalars['Boolean']['output'];
  hasNoChildSquareMenus: Scalars['Boolean']['output'];
  hasTimeSpecificPricing: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isBuildTypeWithNestedModifiers: Scalars['Boolean']['output'];
  isMasterWithLocation: Scalars['Boolean']['output'];
  isMasterWithoutLocation: Scalars['Boolean']['output'];
  isMenuAttachedToPos: Scalars['Boolean']['output'];
  isMenuFromPos: Scalars['Boolean']['output'];
  isMenuLocationAloha: Scalars['Boolean']['output'];
  isMenuLocationClover: Scalars['Boolean']['output'];
  isMenuLocationDeliverect: Scalars['Boolean']['output'];
  isMenuLocationHeartlandPos: Scalars['Boolean']['output'];
  isMenuLocationMicros: Scalars['Boolean']['output'];
  isMenuLocationNcrSilver: Scalars['Boolean']['output'];
  isMenuLocationSpoton: Scalars['Boolean']['output'];
  isMenuLocationSquare: Scalars['Boolean']['output'];
  isMenuLocationToast: Scalars['Boolean']['output'];
  isMenuSyncEnabled: Scalars['Boolean']['output'];
  isMovingItemsAcrossSectionsEnabled: Scalars['Boolean']['output'];
  isOpentableMenu: Scalars['Boolean']['output'];
  menuHoursCanBeChanged: Scalars['Boolean']['output'];
  posMenuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  sectionCanBeAdded: Scalars['Boolean']['output'];
  showMenu: Scalars['Boolean']['output'];
};

export type UiMenuSubsectionAloha = UiMenuSubsectionInterface & {
  __typename?: 'UiMenuSubsectionAloha';
  canBeAlphabetized: Scalars['Boolean']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  descriptionCanBeChanged: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  itemCanBeAdded: Scalars['Boolean']['output'];
  titleCanBeChanged: Scalars['Boolean']['output'];
  typeCanBeChanged: Scalars['Boolean']['output'];
};

export type UiMenuSubsectionBase = UiMenuSubsectionInterface & {
  __typename?: 'UiMenuSubsectionBase';
  canBeAlphabetized: Scalars['Boolean']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  descriptionCanBeChanged: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  itemCanBeAdded: Scalars['Boolean']['output'];
  titleCanBeChanged: Scalars['Boolean']['output'];
  typeCanBeChanged: Scalars['Boolean']['output'];
};

export type UiMenuSubsectionClover = UiMenuSubsectionInterface & {
  __typename?: 'UiMenuSubsectionClover';
  canBeAlphabetized: Scalars['Boolean']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  descriptionCanBeChanged: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  itemCanBeAdded: Scalars['Boolean']['output'];
  titleCanBeChanged: Scalars['Boolean']['output'];
  typeCanBeChanged: Scalars['Boolean']['output'];
};

export type UiMenuSubsectionDeliverect = UiMenuSubsectionInterface & {
  __typename?: 'UiMenuSubsectionDeliverect';
  canBeAlphabetized: Scalars['Boolean']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  descriptionCanBeChanged: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  itemCanBeAdded: Scalars['Boolean']['output'];
  titleCanBeChanged: Scalars['Boolean']['output'];
  typeCanBeChanged: Scalars['Boolean']['output'];
};

export type UiMenuSubsectionHeartlandPos = UiMenuSubsectionInterface & {
  __typename?: 'UiMenuSubsectionHeartlandPos';
  canBeAlphabetized: Scalars['Boolean']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  descriptionCanBeChanged: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  itemCanBeAdded: Scalars['Boolean']['output'];
  titleCanBeChanged: Scalars['Boolean']['output'];
  typeCanBeChanged: Scalars['Boolean']['output'];
};

/** Subsection UI precalculated settings */
export type UiMenuSubsectionInterface = {
  canBeAlphabetized: Scalars['Boolean']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  descriptionCanBeChanged: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  itemCanBeAdded: Scalars['Boolean']['output'];
  titleCanBeChanged: Scalars['Boolean']['output'];
  typeCanBeChanged: Scalars['Boolean']['output'];
};

export type UiMenuSubsectionMicros = UiMenuSubsectionInterface & {
  __typename?: 'UiMenuSubsectionMicros';
  canBeAlphabetized: Scalars['Boolean']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  descriptionCanBeChanged: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  itemCanBeAdded: Scalars['Boolean']['output'];
  titleCanBeChanged: Scalars['Boolean']['output'];
  typeCanBeChanged: Scalars['Boolean']['output'];
};

export type UiMenuSubsectionNcrSilver = UiMenuSubsectionInterface & {
  __typename?: 'UiMenuSubsectionNcrSilver';
  canBeAlphabetized: Scalars['Boolean']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  descriptionCanBeChanged: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  itemCanBeAdded: Scalars['Boolean']['output'];
  titleCanBeChanged: Scalars['Boolean']['output'];
  typeCanBeChanged: Scalars['Boolean']['output'];
};

export type UiMenuSubsectionSpoton = UiMenuSubsectionInterface & {
  __typename?: 'UiMenuSubsectionSpoton';
  canBeAlphabetized: Scalars['Boolean']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  descriptionCanBeChanged: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  itemCanBeAdded: Scalars['Boolean']['output'];
  titleCanBeChanged: Scalars['Boolean']['output'];
  typeCanBeChanged: Scalars['Boolean']['output'];
};

export type UiMenuSubsectionSquare = UiMenuSubsectionInterface & {
  __typename?: 'UiMenuSubsectionSquare';
  canBeAlphabetized: Scalars['Boolean']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  descriptionCanBeChanged: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  itemCanBeAdded: Scalars['Boolean']['output'];
  titleCanBeChanged: Scalars['Boolean']['output'];
  typeCanBeChanged: Scalars['Boolean']['output'];
};

export type UiMenuSubsectionToast = UiMenuSubsectionInterface & {
  __typename?: 'UiMenuSubsectionToast';
  canBeAlphabetized: Scalars['Boolean']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  descriptionCanBeChanged: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  itemCanBeAdded: Scalars['Boolean']['output'];
  titleCanBeChanged: Scalars['Boolean']['output'];
  typeCanBeChanged: Scalars['Boolean']['output'];
};

export type UiMenuToast = UiMenuInterface & {
  __typename?: 'UiMenuToast';
  canBeForceSynced: Scalars['Boolean']['output'];
  canToggleModifierGroupVisibility: Scalars['Boolean']['output'];
  featuredSectionCanBeAdded: Scalars['Boolean']['output'];
  hasNoChildSquareMenus: Scalars['Boolean']['output'];
  hasTimeSpecificPricing: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isBuildTypeWithNestedModifiers: Scalars['Boolean']['output'];
  isMasterWithLocation: Scalars['Boolean']['output'];
  isMasterWithoutLocation: Scalars['Boolean']['output'];
  isMenuAttachedToPos: Scalars['Boolean']['output'];
  isMenuFromPos: Scalars['Boolean']['output'];
  isMenuLocationAloha: Scalars['Boolean']['output'];
  isMenuLocationClover: Scalars['Boolean']['output'];
  isMenuLocationDeliverect: Scalars['Boolean']['output'];
  isMenuLocationHeartlandPos: Scalars['Boolean']['output'];
  isMenuLocationMicros: Scalars['Boolean']['output'];
  isMenuLocationNcrSilver: Scalars['Boolean']['output'];
  isMenuLocationSpoton: Scalars['Boolean']['output'];
  isMenuLocationSquare: Scalars['Boolean']['output'];
  isMenuLocationToast: Scalars['Boolean']['output'];
  isMenuSyncEnabled: Scalars['Boolean']['output'];
  isMovingItemsAcrossSectionsEnabled: Scalars['Boolean']['output'];
  isOpentableMenu: Scalars['Boolean']['output'];
  menuHoursCanBeChanged: Scalars['Boolean']['output'];
  posMenuLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  sectionCanBeAdded: Scalars['Boolean']['output'];
  showMenu: Scalars['Boolean']['output'];
};

export type UiModifierGroupBase = UiModifierGroupInterface & {
  __typename?: 'UiModifierGroupBase';
  id: Scalars['Int']['output'];
  isGroupAttachedToPos: Scalars['Boolean']['output'];
};

export type UiModifierGroupDeliverect = UiModifierGroupInterface & {
  __typename?: 'UiModifierGroupDeliverect';
  id: Scalars['Int']['output'];
  isGroupAttachedToPos: Scalars['Boolean']['output'];
};

export type UiModifierGroupHeartlandPos = UiModifierGroupInterface & {
  __typename?: 'UiModifierGroupHeartlandPos';
  id: Scalars['Int']['output'];
  isGroupAttachedToPos: Scalars['Boolean']['output'];
};

/** Modifier group UI precalculated settings */
export type UiModifierGroupInterface = {
  id: Scalars['Int']['output'];
  isGroupAttachedToPos: Scalars['Boolean']['output'];
};

export type UiModifierGroupNcrSilver = UiModifierGroupInterface & {
  __typename?: 'UiModifierGroupNcrSilver';
  id: Scalars['Int']['output'];
  isGroupAttachedToPos: Scalars['Boolean']['output'];
};

export type UiModifierGroupSquare = UiModifierGroupInterface & {
  __typename?: 'UiModifierGroupSquare';
  id: Scalars['Int']['output'];
  isGroupAttachedToPos: Scalars['Boolean']['output'];
};

export type UiModifierGroupToast = UiModifierGroupInterface & {
  __typename?: 'UiModifierGroupToast';
  id: Scalars['Int']['output'];
  isGroupAttachedToPos: Scalars['Boolean']['output'];
};

export type UiPhoto = UiPhotoInterface & {
  __typename?: 'UiPhoto';
  id: Scalars['Int']['output'];
  isShowHideButtonVisible: Scalars['Boolean']['output'];
  showDeleteButton: Scalars['Boolean']['output'];
};

/** Photo UI settings */
export type UiPhotoInterface = {
  id: Scalars['Int']['output'];
  isShowHideButtonVisible: Scalars['Boolean']['output'];
  showDeleteButton: Scalars['Boolean']['output'];
};

export type UiPosPhoto = UiPhotoInterface & {
  __typename?: 'UiPosPhoto';
  id: Scalars['Int']['output'];
  isShowHideButtonVisible: Scalars['Boolean']['output'];
  showDeleteButton: Scalars['Boolean']['output'];
};

export type UiRestaurant = {
  __typename?: 'UiRestaurant';
  canConnectNcrSilver: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isAllLocationsSquareMenuSyncEnabled: Scalars['Boolean']['output'];
  isGiftCardPaymentTypeMissingForAnyLocation: Scalars['Boolean']['output'];
  isGiftCardPurchaseSupported: Scalars['Boolean']['output'];
  isHeartlandPosDiscountMissingForAnyLocation: Scalars['Boolean']['output'];
  isLoyaltyPermissionGrantedForAllSquareAccounts: Scalars['Boolean']['output'];
  isMicrosDiscountMissingForAnyLocation: Scalars['Boolean']['output'];
  isNcrSilverEnabled: Scalars['Boolean']['output'];
  isPosMissingOffersSupport: Scalars['Boolean']['output'];
  isToastOfferDiscountMissingForAnyLocation: Scalars['Boolean']['output'];
  unsupportedGiftCardPurchaseAttachedTypes: Array<Scalars['String']['output']>;
};

export type UiRestaurantLocationAloha = UiRestaurantLocationInterface & {
  __typename?: 'UiRestaurantLocationAloha';
  canConnectAuthorizeDotNet: Scalars['Boolean']['output'];
  canConnectClover: Scalars['Boolean']['output'];
  canConnectDeliverect: Scalars['Boolean']['output'];
  canConnectHeartland: Scalars['Boolean']['output'];
  canConnectHeartlandPos: Scalars['Boolean']['output'];
  canConnectNcrSilver: Scalars['Boolean']['output'];
  canConnectNmi: Scalars['Boolean']['output'];
  canConnectSpoton: Scalars['Boolean']['output'];
  canConnectSquare: Scalars['Boolean']['output'];
  canConnectStripe: Scalars['Boolean']['output'];
  canConnectToast: Scalars['Boolean']['output'];
  canDisconnectPos: Scalars['Boolean']['output'];
  canEnableOrdering: Scalars['Boolean']['output'];
  cloverMerchantId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAcceptOnlinePayments: Scalars['Boolean']['output'];
  isAlternativePaymentMissing: Scalars['Boolean']['output'];
  isAnyToastServiceChargeMissing: Scalars['Boolean']['output'];
  isAttachedPosProvidesPayments: Scalars['Boolean']['output'];
  isAutoAcceptOrders: Scalars['Boolean']['output'];
  isBagFeesDisplayed: Scalars['Boolean']['output'];
  isBagFeesEnabled: Scalars['Boolean']['output'];
  isCloverAppDisconnected: Scalars['Boolean']['output'];
  isCloverOrderTypeDeliveryNotFound: Scalars['Boolean']['output'];
  isCurbsideToggleEnabled: Scalars['Boolean']['output'];
  isDefaultTax: Scalars['Boolean']['output'];
  isDefaultTaxMissing: Scalars['Boolean']['output'];
  isDeliverectChannelReady: Scalars['Boolean']['output'];
  isDeliveryEnableable: Scalars['Boolean']['output'];
  isDineInAutoAcceptToggleEnabled: Scalars['Boolean']['output'];
  isDineInToggleEnabled: Scalars['Boolean']['output'];
  isDoordashAvailable: Scalars['Boolean']['output'];
  isEditCustomFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultTaxEnabled: Scalars['Boolean']['output'];
  isFeesManagedByProvider: Scalars['Boolean']['output'];
  isGiftCardPaymentTypeMissing: Scalars['Boolean']['output'];
  isGoogleApplePayToggleAvailable: Scalars['Boolean']['output'];
  isHeartlandDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isNestingMenusSupported: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceDisabled: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceEnabled: Scalars['Boolean']['output'];
  isPayOnPickupAvailable: Scalars['Boolean']['output'];
  isPosCateringDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosCateringOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isTaxManagedByProvider: Scalars['Boolean']['output'];
  isTaxSettingsAvailable: Scalars['Boolean']['output'];
  isToastDeliveryDiningOptionNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastFeeServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastLocation: Scalars['Boolean']['output'];
  isUberDirectAvailable: Scalars['Boolean']['output'];
  showAlternativePayment: Scalars['Boolean']['output'];
  showOnlyPaymentProcessors: Scalars['Boolean']['output'];
  useAlternativePayment: Scalars['Boolean']['output'];
};

export type UiRestaurantLocationBase = UiRestaurantLocationInterface & {
  __typename?: 'UiRestaurantLocationBase';
  canConnectAuthorizeDotNet: Scalars['Boolean']['output'];
  canConnectClover: Scalars['Boolean']['output'];
  canConnectDeliverect: Scalars['Boolean']['output'];
  canConnectHeartland: Scalars['Boolean']['output'];
  canConnectHeartlandPos: Scalars['Boolean']['output'];
  canConnectNcrSilver: Scalars['Boolean']['output'];
  canConnectNmi: Scalars['Boolean']['output'];
  canConnectSpoton: Scalars['Boolean']['output'];
  canConnectSquare: Scalars['Boolean']['output'];
  canConnectStripe: Scalars['Boolean']['output'];
  canConnectToast: Scalars['Boolean']['output'];
  canDisconnectPos: Scalars['Boolean']['output'];
  canEnableOrdering: Scalars['Boolean']['output'];
  cloverMerchantId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAcceptOnlinePayments: Scalars['Boolean']['output'];
  isAlternativePaymentMissing: Scalars['Boolean']['output'];
  isAnyToastServiceChargeMissing: Scalars['Boolean']['output'];
  isAttachedPosProvidesPayments: Scalars['Boolean']['output'];
  isAutoAcceptOrders: Scalars['Boolean']['output'];
  isBagFeesDisplayed: Scalars['Boolean']['output'];
  isBagFeesEnabled: Scalars['Boolean']['output'];
  isCloverAppDisconnected: Scalars['Boolean']['output'];
  isCloverOrderTypeDeliveryNotFound: Scalars['Boolean']['output'];
  isCurbsideToggleEnabled: Scalars['Boolean']['output'];
  isDefaultTax: Scalars['Boolean']['output'];
  isDefaultTaxMissing: Scalars['Boolean']['output'];
  isDeliverectChannelReady: Scalars['Boolean']['output'];
  isDeliveryEnableable: Scalars['Boolean']['output'];
  isDineInAutoAcceptToggleEnabled: Scalars['Boolean']['output'];
  isDineInToggleEnabled: Scalars['Boolean']['output'];
  isDoordashAvailable: Scalars['Boolean']['output'];
  isEditCustomFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultTaxEnabled: Scalars['Boolean']['output'];
  isFeesManagedByProvider: Scalars['Boolean']['output'];
  isGiftCardPaymentTypeMissing: Scalars['Boolean']['output'];
  isGoogleApplePayToggleAvailable: Scalars['Boolean']['output'];
  isHeartlandDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isNestingMenusSupported: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceDisabled: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceEnabled: Scalars['Boolean']['output'];
  isPayOnPickupAvailable: Scalars['Boolean']['output'];
  isPosCateringDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosCateringOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isTaxManagedByProvider: Scalars['Boolean']['output'];
  isTaxSettingsAvailable: Scalars['Boolean']['output'];
  isToastDeliveryDiningOptionNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastFeeServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastLocation: Scalars['Boolean']['output'];
  isUberDirectAvailable: Scalars['Boolean']['output'];
  showAlternativePayment: Scalars['Boolean']['output'];
  showOnlyPaymentProcessors: Scalars['Boolean']['output'];
  useAlternativePayment: Scalars['Boolean']['output'];
};

export type UiRestaurantLocationClover = UiRestaurantLocationInterface & {
  __typename?: 'UiRestaurantLocationClover';
  canConnectAuthorizeDotNet: Scalars['Boolean']['output'];
  canConnectClover: Scalars['Boolean']['output'];
  canConnectDeliverect: Scalars['Boolean']['output'];
  canConnectHeartland: Scalars['Boolean']['output'];
  canConnectHeartlandPos: Scalars['Boolean']['output'];
  canConnectNcrSilver: Scalars['Boolean']['output'];
  canConnectNmi: Scalars['Boolean']['output'];
  canConnectSpoton: Scalars['Boolean']['output'];
  canConnectSquare: Scalars['Boolean']['output'];
  canConnectStripe: Scalars['Boolean']['output'];
  canConnectToast: Scalars['Boolean']['output'];
  canDisconnectPos: Scalars['Boolean']['output'];
  canEnableOrdering: Scalars['Boolean']['output'];
  cloverMerchantId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAcceptOnlinePayments: Scalars['Boolean']['output'];
  isAlternativePaymentMissing: Scalars['Boolean']['output'];
  isAnyToastServiceChargeMissing: Scalars['Boolean']['output'];
  isAttachedPosProvidesPayments: Scalars['Boolean']['output'];
  isAutoAcceptOrders: Scalars['Boolean']['output'];
  isBagFeesDisplayed: Scalars['Boolean']['output'];
  isBagFeesEnabled: Scalars['Boolean']['output'];
  isCloverAppDisconnected: Scalars['Boolean']['output'];
  isCloverOrderTypeDeliveryNotFound: Scalars['Boolean']['output'];
  isCurbsideToggleEnabled: Scalars['Boolean']['output'];
  isDefaultTax: Scalars['Boolean']['output'];
  isDefaultTaxMissing: Scalars['Boolean']['output'];
  isDeliverectChannelReady: Scalars['Boolean']['output'];
  isDeliveryEnableable: Scalars['Boolean']['output'];
  isDineInAutoAcceptToggleEnabled: Scalars['Boolean']['output'];
  isDineInToggleEnabled: Scalars['Boolean']['output'];
  isDoordashAvailable: Scalars['Boolean']['output'];
  isEditCustomFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultTaxEnabled: Scalars['Boolean']['output'];
  isFeesManagedByProvider: Scalars['Boolean']['output'];
  isGiftCardPaymentTypeMissing: Scalars['Boolean']['output'];
  isGoogleApplePayToggleAvailable: Scalars['Boolean']['output'];
  isHeartlandDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isNestingMenusSupported: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceDisabled: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceEnabled: Scalars['Boolean']['output'];
  isPayOnPickupAvailable: Scalars['Boolean']['output'];
  isPosCateringDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosCateringOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isTaxManagedByProvider: Scalars['Boolean']['output'];
  isTaxSettingsAvailable: Scalars['Boolean']['output'];
  isToastDeliveryDiningOptionNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastFeeServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastLocation: Scalars['Boolean']['output'];
  isUberDirectAvailable: Scalars['Boolean']['output'];
  showAlternativePayment: Scalars['Boolean']['output'];
  showOnlyPaymentProcessors: Scalars['Boolean']['output'];
  useAlternativePayment: Scalars['Boolean']['output'];
};

export type UiRestaurantLocationDeliverect = UiRestaurantLocationInterface & {
  __typename?: 'UiRestaurantLocationDeliverect';
  canConnectAuthorizeDotNet: Scalars['Boolean']['output'];
  canConnectClover: Scalars['Boolean']['output'];
  canConnectDeliverect: Scalars['Boolean']['output'];
  canConnectHeartland: Scalars['Boolean']['output'];
  canConnectHeartlandPos: Scalars['Boolean']['output'];
  canConnectNcrSilver: Scalars['Boolean']['output'];
  canConnectNmi: Scalars['Boolean']['output'];
  canConnectSpoton: Scalars['Boolean']['output'];
  canConnectSquare: Scalars['Boolean']['output'];
  canConnectStripe: Scalars['Boolean']['output'];
  canConnectToast: Scalars['Boolean']['output'];
  canDisconnectPos: Scalars['Boolean']['output'];
  canEnableOrdering: Scalars['Boolean']['output'];
  cloverMerchantId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAcceptOnlinePayments: Scalars['Boolean']['output'];
  isAlternativePaymentMissing: Scalars['Boolean']['output'];
  isAnyToastServiceChargeMissing: Scalars['Boolean']['output'];
  isAttachedPosProvidesPayments: Scalars['Boolean']['output'];
  isAutoAcceptOrders: Scalars['Boolean']['output'];
  isBagFeesDisplayed: Scalars['Boolean']['output'];
  isBagFeesEnabled: Scalars['Boolean']['output'];
  isCloverAppDisconnected: Scalars['Boolean']['output'];
  isCloverOrderTypeDeliveryNotFound: Scalars['Boolean']['output'];
  isCurbsideToggleEnabled: Scalars['Boolean']['output'];
  isDefaultTax: Scalars['Boolean']['output'];
  isDefaultTaxMissing: Scalars['Boolean']['output'];
  isDeliverectChannelReady: Scalars['Boolean']['output'];
  isDeliveryEnableable: Scalars['Boolean']['output'];
  isDineInAutoAcceptToggleEnabled: Scalars['Boolean']['output'];
  isDineInToggleEnabled: Scalars['Boolean']['output'];
  isDoordashAvailable: Scalars['Boolean']['output'];
  isEditCustomFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultTaxEnabled: Scalars['Boolean']['output'];
  isFeesManagedByProvider: Scalars['Boolean']['output'];
  isGiftCardPaymentTypeMissing: Scalars['Boolean']['output'];
  isGoogleApplePayToggleAvailable: Scalars['Boolean']['output'];
  isHeartlandDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isNestingMenusSupported: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceDisabled: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceEnabled: Scalars['Boolean']['output'];
  isPayOnPickupAvailable: Scalars['Boolean']['output'];
  isPosCateringDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosCateringOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isTaxManagedByProvider: Scalars['Boolean']['output'];
  isTaxSettingsAvailable: Scalars['Boolean']['output'];
  isToastDeliveryDiningOptionNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastFeeServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastLocation: Scalars['Boolean']['output'];
  isUberDirectAvailable: Scalars['Boolean']['output'];
  showAlternativePayment: Scalars['Boolean']['output'];
  showOnlyPaymentProcessors: Scalars['Boolean']['output'];
  useAlternativePayment: Scalars['Boolean']['output'];
};

export type UiRestaurantLocationHeartland = UiRestaurantLocationInterface & {
  __typename?: 'UiRestaurantLocationHeartland';
  canConnectAuthorizeDotNet: Scalars['Boolean']['output'];
  canConnectClover: Scalars['Boolean']['output'];
  canConnectDeliverect: Scalars['Boolean']['output'];
  canConnectHeartland: Scalars['Boolean']['output'];
  canConnectHeartlandPos: Scalars['Boolean']['output'];
  canConnectNcrSilver: Scalars['Boolean']['output'];
  canConnectNmi: Scalars['Boolean']['output'];
  canConnectSpoton: Scalars['Boolean']['output'];
  canConnectSquare: Scalars['Boolean']['output'];
  canConnectStripe: Scalars['Boolean']['output'];
  canConnectToast: Scalars['Boolean']['output'];
  canDisconnectPos: Scalars['Boolean']['output'];
  canEnableOrdering: Scalars['Boolean']['output'];
  cloverMerchantId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAcceptOnlinePayments: Scalars['Boolean']['output'];
  isAlternativePaymentMissing: Scalars['Boolean']['output'];
  isAnyToastServiceChargeMissing: Scalars['Boolean']['output'];
  isAttachedPosProvidesPayments: Scalars['Boolean']['output'];
  isAutoAcceptOrders: Scalars['Boolean']['output'];
  isBagFeesDisplayed: Scalars['Boolean']['output'];
  isBagFeesEnabled: Scalars['Boolean']['output'];
  isCloverAppDisconnected: Scalars['Boolean']['output'];
  isCloverOrderTypeDeliveryNotFound: Scalars['Boolean']['output'];
  isCurbsideToggleEnabled: Scalars['Boolean']['output'];
  isDefaultTax: Scalars['Boolean']['output'];
  isDefaultTaxMissing: Scalars['Boolean']['output'];
  isDeliverectChannelReady: Scalars['Boolean']['output'];
  isDeliveryEnableable: Scalars['Boolean']['output'];
  isDineInAutoAcceptToggleEnabled: Scalars['Boolean']['output'];
  isDineInToggleEnabled: Scalars['Boolean']['output'];
  isDoordashAvailable: Scalars['Boolean']['output'];
  isEditCustomFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultTaxEnabled: Scalars['Boolean']['output'];
  isFeesManagedByProvider: Scalars['Boolean']['output'];
  isGiftCardPaymentTypeMissing: Scalars['Boolean']['output'];
  isGoogleApplePayToggleAvailable: Scalars['Boolean']['output'];
  isHeartlandDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isNestingMenusSupported: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceDisabled: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceEnabled: Scalars['Boolean']['output'];
  isPayOnPickupAvailable: Scalars['Boolean']['output'];
  isPosCateringDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosCateringOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isTaxManagedByProvider: Scalars['Boolean']['output'];
  isTaxSettingsAvailable: Scalars['Boolean']['output'];
  isToastDeliveryDiningOptionNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastFeeServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastLocation: Scalars['Boolean']['output'];
  isUberDirectAvailable: Scalars['Boolean']['output'];
  showAlternativePayment: Scalars['Boolean']['output'];
  showOnlyPaymentProcessors: Scalars['Boolean']['output'];
  useAlternativePayment: Scalars['Boolean']['output'];
};

export type UiRestaurantLocationHeartlandPos = UiRestaurantLocationInterface & {
  __typename?: 'UiRestaurantLocationHeartlandPos';
  canConnectAuthorizeDotNet: Scalars['Boolean']['output'];
  canConnectClover: Scalars['Boolean']['output'];
  canConnectDeliverect: Scalars['Boolean']['output'];
  canConnectHeartland: Scalars['Boolean']['output'];
  canConnectHeartlandPos: Scalars['Boolean']['output'];
  canConnectNcrSilver: Scalars['Boolean']['output'];
  canConnectNmi: Scalars['Boolean']['output'];
  canConnectSpoton: Scalars['Boolean']['output'];
  canConnectSquare: Scalars['Boolean']['output'];
  canConnectStripe: Scalars['Boolean']['output'];
  canConnectToast: Scalars['Boolean']['output'];
  canDisconnectPos: Scalars['Boolean']['output'];
  canEnableOrdering: Scalars['Boolean']['output'];
  cloverMerchantId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAcceptOnlinePayments: Scalars['Boolean']['output'];
  isAlternativePaymentMissing: Scalars['Boolean']['output'];
  isAnyToastServiceChargeMissing: Scalars['Boolean']['output'];
  isAttachedPosProvidesPayments: Scalars['Boolean']['output'];
  isAutoAcceptOrders: Scalars['Boolean']['output'];
  isBagFeesDisplayed: Scalars['Boolean']['output'];
  isBagFeesEnabled: Scalars['Boolean']['output'];
  isCloverAppDisconnected: Scalars['Boolean']['output'];
  isCloverOrderTypeDeliveryNotFound: Scalars['Boolean']['output'];
  isCurbsideToggleEnabled: Scalars['Boolean']['output'];
  isDefaultTax: Scalars['Boolean']['output'];
  isDefaultTaxMissing: Scalars['Boolean']['output'];
  isDeliverectChannelReady: Scalars['Boolean']['output'];
  isDeliveryEnableable: Scalars['Boolean']['output'];
  isDineInAutoAcceptToggleEnabled: Scalars['Boolean']['output'];
  isDineInToggleEnabled: Scalars['Boolean']['output'];
  isDoordashAvailable: Scalars['Boolean']['output'];
  isEditCustomFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultTaxEnabled: Scalars['Boolean']['output'];
  isFeesManagedByProvider: Scalars['Boolean']['output'];
  isGiftCardPaymentTypeMissing: Scalars['Boolean']['output'];
  isGoogleApplePayToggleAvailable: Scalars['Boolean']['output'];
  isHeartlandDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isNestingMenusSupported: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceDisabled: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceEnabled: Scalars['Boolean']['output'];
  isPayOnPickupAvailable: Scalars['Boolean']['output'];
  isPosCateringDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosCateringOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isTaxManagedByProvider: Scalars['Boolean']['output'];
  isTaxSettingsAvailable: Scalars['Boolean']['output'];
  isToastDeliveryDiningOptionNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastFeeServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastLocation: Scalars['Boolean']['output'];
  isUberDirectAvailable: Scalars['Boolean']['output'];
  showAlternativePayment: Scalars['Boolean']['output'];
  showOnlyPaymentProcessors: Scalars['Boolean']['output'];
  useAlternativePayment: Scalars['Boolean']['output'];
};

/** Restaurant Location UI precalculated settings */
export type UiRestaurantLocationInterface = {
  canConnectAuthorizeDotNet: Scalars['Boolean']['output'];
  canConnectClover: Scalars['Boolean']['output'];
  canConnectDeliverect: Scalars['Boolean']['output'];
  canConnectHeartland: Scalars['Boolean']['output'];
  canConnectHeartlandPos: Scalars['Boolean']['output'];
  canConnectNcrSilver: Scalars['Boolean']['output'];
  canConnectNmi: Scalars['Boolean']['output'];
  canConnectSpoton: Scalars['Boolean']['output'];
  canConnectSquare: Scalars['Boolean']['output'];
  canConnectStripe: Scalars['Boolean']['output'];
  canConnectToast: Scalars['Boolean']['output'];
  canDisconnectPos: Scalars['Boolean']['output'];
  canEnableOrdering: Scalars['Boolean']['output'];
  cloverMerchantId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAcceptOnlinePayments: Scalars['Boolean']['output'];
  isAlternativePaymentMissing: Scalars['Boolean']['output'];
  isAnyToastServiceChargeMissing: Scalars['Boolean']['output'];
  isAttachedPosProvidesPayments: Scalars['Boolean']['output'];
  isAutoAcceptOrders: Scalars['Boolean']['output'];
  isBagFeesDisplayed: Scalars['Boolean']['output'];
  isBagFeesEnabled: Scalars['Boolean']['output'];
  isCloverAppDisconnected: Scalars['Boolean']['output'];
  isCloverOrderTypeDeliveryNotFound: Scalars['Boolean']['output'];
  isCurbsideToggleEnabled: Scalars['Boolean']['output'];
  isDefaultTax: Scalars['Boolean']['output'];
  isDefaultTaxMissing: Scalars['Boolean']['output'];
  isDeliverectChannelReady: Scalars['Boolean']['output'];
  isDeliveryEnableable: Scalars['Boolean']['output'];
  isDineInAutoAcceptToggleEnabled: Scalars['Boolean']['output'];
  isDineInToggleEnabled: Scalars['Boolean']['output'];
  isDoordashAvailable: Scalars['Boolean']['output'];
  isEditCustomFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultTaxEnabled: Scalars['Boolean']['output'];
  isFeesManagedByProvider: Scalars['Boolean']['output'];
  isGiftCardPaymentTypeMissing: Scalars['Boolean']['output'];
  isGoogleApplePayToggleAvailable: Scalars['Boolean']['output'];
  isHeartlandDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isNestingMenusSupported: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceDisabled: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceEnabled: Scalars['Boolean']['output'];
  isPayOnPickupAvailable: Scalars['Boolean']['output'];
  isPosCateringDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosCateringOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isTaxManagedByProvider: Scalars['Boolean']['output'];
  isTaxSettingsAvailable: Scalars['Boolean']['output'];
  isToastDeliveryDiningOptionNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastFeeServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastLocation: Scalars['Boolean']['output'];
  isUberDirectAvailable: Scalars['Boolean']['output'];
  showAlternativePayment: Scalars['Boolean']['output'];
  showOnlyPaymentProcessors: Scalars['Boolean']['output'];
  useAlternativePayment: Scalars['Boolean']['output'];
};

export type UiRestaurantLocationMicros = UiRestaurantLocationInterface & {
  __typename?: 'UiRestaurantLocationMicros';
  canConnectAuthorizeDotNet: Scalars['Boolean']['output'];
  canConnectClover: Scalars['Boolean']['output'];
  canConnectDeliverect: Scalars['Boolean']['output'];
  canConnectHeartland: Scalars['Boolean']['output'];
  canConnectHeartlandPos: Scalars['Boolean']['output'];
  canConnectNcrSilver: Scalars['Boolean']['output'];
  canConnectNmi: Scalars['Boolean']['output'];
  canConnectSpoton: Scalars['Boolean']['output'];
  canConnectSquare: Scalars['Boolean']['output'];
  canConnectStripe: Scalars['Boolean']['output'];
  canConnectToast: Scalars['Boolean']['output'];
  canDisconnectPos: Scalars['Boolean']['output'];
  canEnableOrdering: Scalars['Boolean']['output'];
  cloverMerchantId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAcceptOnlinePayments: Scalars['Boolean']['output'];
  isAlternativePaymentMissing: Scalars['Boolean']['output'];
  isAnyToastServiceChargeMissing: Scalars['Boolean']['output'];
  isAttachedPosProvidesPayments: Scalars['Boolean']['output'];
  isAutoAcceptOrders: Scalars['Boolean']['output'];
  isBagFeesDisplayed: Scalars['Boolean']['output'];
  isBagFeesEnabled: Scalars['Boolean']['output'];
  isCloverAppDisconnected: Scalars['Boolean']['output'];
  isCloverOrderTypeDeliveryNotFound: Scalars['Boolean']['output'];
  isCurbsideToggleEnabled: Scalars['Boolean']['output'];
  isDefaultTax: Scalars['Boolean']['output'];
  isDefaultTaxMissing: Scalars['Boolean']['output'];
  isDeliverectChannelReady: Scalars['Boolean']['output'];
  isDeliveryEnableable: Scalars['Boolean']['output'];
  isDineInAutoAcceptToggleEnabled: Scalars['Boolean']['output'];
  isDineInToggleEnabled: Scalars['Boolean']['output'];
  isDoordashAvailable: Scalars['Boolean']['output'];
  isEditCustomFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultTaxEnabled: Scalars['Boolean']['output'];
  isFeesManagedByProvider: Scalars['Boolean']['output'];
  isGiftCardPaymentTypeMissing: Scalars['Boolean']['output'];
  isGoogleApplePayToggleAvailable: Scalars['Boolean']['output'];
  isHeartlandDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isNestingMenusSupported: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceDisabled: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceEnabled: Scalars['Boolean']['output'];
  isPayOnPickupAvailable: Scalars['Boolean']['output'];
  isPosCateringDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosCateringOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isTaxManagedByProvider: Scalars['Boolean']['output'];
  isTaxSettingsAvailable: Scalars['Boolean']['output'];
  isToastDeliveryDiningOptionNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastFeeServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastLocation: Scalars['Boolean']['output'];
  isUberDirectAvailable: Scalars['Boolean']['output'];
  showAlternativePayment: Scalars['Boolean']['output'];
  showOnlyPaymentProcessors: Scalars['Boolean']['output'];
  useAlternativePayment: Scalars['Boolean']['output'];
};

export type UiRestaurantLocationNcrSilver = UiRestaurantLocationInterface & {
  __typename?: 'UiRestaurantLocationNcrSilver';
  canConnectAuthorizeDotNet: Scalars['Boolean']['output'];
  canConnectClover: Scalars['Boolean']['output'];
  canConnectDeliverect: Scalars['Boolean']['output'];
  canConnectHeartland: Scalars['Boolean']['output'];
  canConnectHeartlandPos: Scalars['Boolean']['output'];
  canConnectNcrSilver: Scalars['Boolean']['output'];
  canConnectNmi: Scalars['Boolean']['output'];
  canConnectSpoton: Scalars['Boolean']['output'];
  canConnectSquare: Scalars['Boolean']['output'];
  canConnectStripe: Scalars['Boolean']['output'];
  canConnectToast: Scalars['Boolean']['output'];
  canDisconnectPos: Scalars['Boolean']['output'];
  canEnableOrdering: Scalars['Boolean']['output'];
  cloverMerchantId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAcceptOnlinePayments: Scalars['Boolean']['output'];
  isAlternativePaymentMissing: Scalars['Boolean']['output'];
  isAnyToastServiceChargeMissing: Scalars['Boolean']['output'];
  isAttachedPosProvidesPayments: Scalars['Boolean']['output'];
  isAutoAcceptOrders: Scalars['Boolean']['output'];
  isBagFeesDisplayed: Scalars['Boolean']['output'];
  isBagFeesEnabled: Scalars['Boolean']['output'];
  isCloverAppDisconnected: Scalars['Boolean']['output'];
  isCloverOrderTypeDeliveryNotFound: Scalars['Boolean']['output'];
  isCurbsideToggleEnabled: Scalars['Boolean']['output'];
  isDefaultTax: Scalars['Boolean']['output'];
  isDefaultTaxMissing: Scalars['Boolean']['output'];
  isDeliverectChannelReady: Scalars['Boolean']['output'];
  isDeliveryEnableable: Scalars['Boolean']['output'];
  isDineInAutoAcceptToggleEnabled: Scalars['Boolean']['output'];
  isDineInToggleEnabled: Scalars['Boolean']['output'];
  isDoordashAvailable: Scalars['Boolean']['output'];
  isEditCustomFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultTaxEnabled: Scalars['Boolean']['output'];
  isFeesManagedByProvider: Scalars['Boolean']['output'];
  isGiftCardPaymentTypeMissing: Scalars['Boolean']['output'];
  isGoogleApplePayToggleAvailable: Scalars['Boolean']['output'];
  isHeartlandDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isNestingMenusSupported: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceDisabled: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceEnabled: Scalars['Boolean']['output'];
  isPayOnPickupAvailable: Scalars['Boolean']['output'];
  isPosCateringDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosCateringOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isTaxManagedByProvider: Scalars['Boolean']['output'];
  isTaxSettingsAvailable: Scalars['Boolean']['output'];
  isToastDeliveryDiningOptionNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastFeeServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastLocation: Scalars['Boolean']['output'];
  isUberDirectAvailable: Scalars['Boolean']['output'];
  showAlternativePayment: Scalars['Boolean']['output'];
  showOnlyPaymentProcessors: Scalars['Boolean']['output'];
  useAlternativePayment: Scalars['Boolean']['output'];
};

export type UiRestaurantLocationSpoton = UiRestaurantLocationInterface & {
  __typename?: 'UiRestaurantLocationSpoton';
  canConnectAuthorizeDotNet: Scalars['Boolean']['output'];
  canConnectClover: Scalars['Boolean']['output'];
  canConnectDeliverect: Scalars['Boolean']['output'];
  canConnectHeartland: Scalars['Boolean']['output'];
  canConnectHeartlandPos: Scalars['Boolean']['output'];
  canConnectNcrSilver: Scalars['Boolean']['output'];
  canConnectNmi: Scalars['Boolean']['output'];
  canConnectSpoton: Scalars['Boolean']['output'];
  canConnectSquare: Scalars['Boolean']['output'];
  canConnectStripe: Scalars['Boolean']['output'];
  canConnectToast: Scalars['Boolean']['output'];
  canDisconnectPos: Scalars['Boolean']['output'];
  canEnableOrdering: Scalars['Boolean']['output'];
  cloverMerchantId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAcceptOnlinePayments: Scalars['Boolean']['output'];
  isAlternativePaymentMissing: Scalars['Boolean']['output'];
  isAnyToastServiceChargeMissing: Scalars['Boolean']['output'];
  isAttachedPosProvidesPayments: Scalars['Boolean']['output'];
  isAutoAcceptOrders: Scalars['Boolean']['output'];
  isBagFeesDisplayed: Scalars['Boolean']['output'];
  isBagFeesEnabled: Scalars['Boolean']['output'];
  isCloverAppDisconnected: Scalars['Boolean']['output'];
  isCloverOrderTypeDeliveryNotFound: Scalars['Boolean']['output'];
  isCurbsideToggleEnabled: Scalars['Boolean']['output'];
  isDefaultTax: Scalars['Boolean']['output'];
  isDefaultTaxMissing: Scalars['Boolean']['output'];
  isDeliverectChannelReady: Scalars['Boolean']['output'];
  isDeliveryEnableable: Scalars['Boolean']['output'];
  isDineInAutoAcceptToggleEnabled: Scalars['Boolean']['output'];
  isDineInToggleEnabled: Scalars['Boolean']['output'];
  isDoordashAvailable: Scalars['Boolean']['output'];
  isEditCustomFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultTaxEnabled: Scalars['Boolean']['output'];
  isFeesManagedByProvider: Scalars['Boolean']['output'];
  isGiftCardPaymentTypeMissing: Scalars['Boolean']['output'];
  isGoogleApplePayToggleAvailable: Scalars['Boolean']['output'];
  isHeartlandDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isNestingMenusSupported: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceDisabled: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceEnabled: Scalars['Boolean']['output'];
  isPayOnPickupAvailable: Scalars['Boolean']['output'];
  isPosCateringDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosCateringOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isTaxManagedByProvider: Scalars['Boolean']['output'];
  isTaxSettingsAvailable: Scalars['Boolean']['output'];
  isToastDeliveryDiningOptionNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastFeeServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastLocation: Scalars['Boolean']['output'];
  isUberDirectAvailable: Scalars['Boolean']['output'];
  showAlternativePayment: Scalars['Boolean']['output'];
  showOnlyPaymentProcessors: Scalars['Boolean']['output'];
  useAlternativePayment: Scalars['Boolean']['output'];
};

export type UiRestaurantLocationSquare = UiRestaurantLocationInterface & {
  __typename?: 'UiRestaurantLocationSquare';
  canConnectAuthorizeDotNet: Scalars['Boolean']['output'];
  canConnectClover: Scalars['Boolean']['output'];
  canConnectDeliverect: Scalars['Boolean']['output'];
  canConnectHeartland: Scalars['Boolean']['output'];
  canConnectHeartlandPos: Scalars['Boolean']['output'];
  canConnectNcrSilver: Scalars['Boolean']['output'];
  canConnectNmi: Scalars['Boolean']['output'];
  canConnectSpoton: Scalars['Boolean']['output'];
  canConnectSquare: Scalars['Boolean']['output'];
  canConnectStripe: Scalars['Boolean']['output'];
  canConnectToast: Scalars['Boolean']['output'];
  canDisconnectPos: Scalars['Boolean']['output'];
  canEnableOrdering: Scalars['Boolean']['output'];
  cloverMerchantId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAcceptOnlinePayments: Scalars['Boolean']['output'];
  isAlternativePaymentMissing: Scalars['Boolean']['output'];
  isAnyToastServiceChargeMissing: Scalars['Boolean']['output'];
  isAttachedPosProvidesPayments: Scalars['Boolean']['output'];
  isAutoAcceptOrders: Scalars['Boolean']['output'];
  isBagFeesDisplayed: Scalars['Boolean']['output'];
  isBagFeesEnabled: Scalars['Boolean']['output'];
  isCloverAppDisconnected: Scalars['Boolean']['output'];
  isCloverOrderTypeDeliveryNotFound: Scalars['Boolean']['output'];
  isCurbsideToggleEnabled: Scalars['Boolean']['output'];
  isDefaultTax: Scalars['Boolean']['output'];
  isDefaultTaxMissing: Scalars['Boolean']['output'];
  isDeliverectChannelReady: Scalars['Boolean']['output'];
  isDeliveryEnableable: Scalars['Boolean']['output'];
  isDineInAutoAcceptToggleEnabled: Scalars['Boolean']['output'];
  isDineInToggleEnabled: Scalars['Boolean']['output'];
  isDoordashAvailable: Scalars['Boolean']['output'];
  isEditCustomFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultTaxEnabled: Scalars['Boolean']['output'];
  isFeesManagedByProvider: Scalars['Boolean']['output'];
  isGiftCardPaymentTypeMissing: Scalars['Boolean']['output'];
  isGoogleApplePayToggleAvailable: Scalars['Boolean']['output'];
  isHeartlandDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isNestingMenusSupported: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceDisabled: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceEnabled: Scalars['Boolean']['output'];
  isPayOnPickupAvailable: Scalars['Boolean']['output'];
  isPosCateringDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosCateringOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isTaxManagedByProvider: Scalars['Boolean']['output'];
  isTaxSettingsAvailable: Scalars['Boolean']['output'];
  isToastDeliveryDiningOptionNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastFeeServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastLocation: Scalars['Boolean']['output'];
  isUberDirectAvailable: Scalars['Boolean']['output'];
  showAlternativePayment: Scalars['Boolean']['output'];
  showOnlyPaymentProcessors: Scalars['Boolean']['output'];
  useAlternativePayment: Scalars['Boolean']['output'];
};

export type UiRestaurantLocationStripe = UiRestaurantLocationInterface & {
  __typename?: 'UiRestaurantLocationStripe';
  canConnectAuthorizeDotNet: Scalars['Boolean']['output'];
  canConnectClover: Scalars['Boolean']['output'];
  canConnectDeliverect: Scalars['Boolean']['output'];
  canConnectHeartland: Scalars['Boolean']['output'];
  canConnectHeartlandPos: Scalars['Boolean']['output'];
  canConnectNcrSilver: Scalars['Boolean']['output'];
  canConnectNmi: Scalars['Boolean']['output'];
  canConnectSpoton: Scalars['Boolean']['output'];
  canConnectSquare: Scalars['Boolean']['output'];
  canConnectStripe: Scalars['Boolean']['output'];
  canConnectToast: Scalars['Boolean']['output'];
  canDisconnectPos: Scalars['Boolean']['output'];
  canEnableOrdering: Scalars['Boolean']['output'];
  cloverMerchantId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAcceptOnlinePayments: Scalars['Boolean']['output'];
  isAlternativePaymentMissing: Scalars['Boolean']['output'];
  isAnyToastServiceChargeMissing: Scalars['Boolean']['output'];
  isAttachedPosProvidesPayments: Scalars['Boolean']['output'];
  isAutoAcceptOrders: Scalars['Boolean']['output'];
  isBagFeesDisplayed: Scalars['Boolean']['output'];
  isBagFeesEnabled: Scalars['Boolean']['output'];
  isCloverAppDisconnected: Scalars['Boolean']['output'];
  isCloverOrderTypeDeliveryNotFound: Scalars['Boolean']['output'];
  isCurbsideToggleEnabled: Scalars['Boolean']['output'];
  isDefaultTax: Scalars['Boolean']['output'];
  isDefaultTaxMissing: Scalars['Boolean']['output'];
  isDeliverectChannelReady: Scalars['Boolean']['output'];
  isDeliveryEnableable: Scalars['Boolean']['output'];
  isDineInAutoAcceptToggleEnabled: Scalars['Boolean']['output'];
  isDineInToggleEnabled: Scalars['Boolean']['output'];
  isDoordashAvailable: Scalars['Boolean']['output'];
  isEditCustomFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultTaxEnabled: Scalars['Boolean']['output'];
  isFeesManagedByProvider: Scalars['Boolean']['output'];
  isGiftCardPaymentTypeMissing: Scalars['Boolean']['output'];
  isGoogleApplePayToggleAvailable: Scalars['Boolean']['output'];
  isHeartlandDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isNestingMenusSupported: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceDisabled: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceEnabled: Scalars['Boolean']['output'];
  isPayOnPickupAvailable: Scalars['Boolean']['output'];
  isPosCateringDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosCateringOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isTaxManagedByProvider: Scalars['Boolean']['output'];
  isTaxSettingsAvailable: Scalars['Boolean']['output'];
  isToastDeliveryDiningOptionNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastFeeServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastLocation: Scalars['Boolean']['output'];
  isUberDirectAvailable: Scalars['Boolean']['output'];
  showAlternativePayment: Scalars['Boolean']['output'];
  showOnlyPaymentProcessors: Scalars['Boolean']['output'];
  useAlternativePayment: Scalars['Boolean']['output'];
};

export type UiRestaurantLocationToast = UiRestaurantLocationInterface & {
  __typename?: 'UiRestaurantLocationToast';
  canConnectAuthorizeDotNet: Scalars['Boolean']['output'];
  canConnectClover: Scalars['Boolean']['output'];
  canConnectDeliverect: Scalars['Boolean']['output'];
  canConnectHeartland: Scalars['Boolean']['output'];
  canConnectHeartlandPos: Scalars['Boolean']['output'];
  canConnectNcrSilver: Scalars['Boolean']['output'];
  canConnectNmi: Scalars['Boolean']['output'];
  canConnectSpoton: Scalars['Boolean']['output'];
  canConnectSquare: Scalars['Boolean']['output'];
  canConnectStripe: Scalars['Boolean']['output'];
  canConnectToast: Scalars['Boolean']['output'];
  canDisconnectPos: Scalars['Boolean']['output'];
  canEnableOrdering: Scalars['Boolean']['output'];
  cloverMerchantId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAcceptOnlinePayments: Scalars['Boolean']['output'];
  isAlternativePaymentMissing: Scalars['Boolean']['output'];
  isAnyToastServiceChargeMissing: Scalars['Boolean']['output'];
  isAttachedPosProvidesPayments: Scalars['Boolean']['output'];
  isAutoAcceptOrders: Scalars['Boolean']['output'];
  isBagFeesDisplayed: Scalars['Boolean']['output'];
  isBagFeesEnabled: Scalars['Boolean']['output'];
  isCloverAppDisconnected: Scalars['Boolean']['output'];
  isCloverOrderTypeDeliveryNotFound: Scalars['Boolean']['output'];
  isCurbsideToggleEnabled: Scalars['Boolean']['output'];
  isDefaultTax: Scalars['Boolean']['output'];
  isDefaultTaxMissing: Scalars['Boolean']['output'];
  isDeliverectChannelReady: Scalars['Boolean']['output'];
  isDeliveryEnableable: Scalars['Boolean']['output'];
  isDineInAutoAcceptToggleEnabled: Scalars['Boolean']['output'];
  isDineInToggleEnabled: Scalars['Boolean']['output'];
  isDoordashAvailable: Scalars['Boolean']['output'];
  isEditCustomFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultFeeTaxesEnabled: Scalars['Boolean']['output'];
  isEditDefaultTaxEnabled: Scalars['Boolean']['output'];
  isFeesManagedByProvider: Scalars['Boolean']['output'];
  isGiftCardPaymentTypeMissing: Scalars['Boolean']['output'];
  isGoogleApplePayToggleAvailable: Scalars['Boolean']['output'];
  isHeartlandDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isNestingMenusSupported: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceDisabled: Scalars['Boolean']['output'];
  isOnlinePaymentToggleForceEnabled: Scalars['Boolean']['output'];
  isPayOnPickupAvailable: Scalars['Boolean']['output'];
  isPosCateringDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosCateringOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosDeliveryOpeningRangesSynced: Scalars['Boolean']['output'];
  isPosOrderingOpeningRangesSynced: Scalars['Boolean']['output'];
  isTaxManagedByProvider: Scalars['Boolean']['output'];
  isTaxSettingsAvailable: Scalars['Boolean']['output'];
  isToastDeliveryDiningOptionNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastDoordashDeliveryServiceChargeTaxable: Scalars['Boolean']['output'];
  isToastFeeServiceChargeNotFound: Scalars['Boolean']['output'];
  isToastLocation: Scalars['Boolean']['output'];
  isUberDirectAvailable: Scalars['Boolean']['output'];
  showAlternativePayment: Scalars['Boolean']['output'];
  showOnlyPaymentProcessors: Scalars['Boolean']['output'];
  useAlternativePayment: Scalars['Boolean']['output'];
};

export type UiSelectedMenuItemBase = UiSelectedMenuItemInterface & {
  __typename?: 'UiSelectedMenuItemBase';
  id: Scalars['Int']['output'];
  isValidItemAndModifiers: Scalars['Boolean']['output'];
};

/** Selected menu item UI precalculated settings */
export type UiSelectedMenuItemInterface = {
  id: Scalars['Int']['output'];
  isValidItemAndModifiers: Scalars['Boolean']['output'];
};

export type UiUploadableBase = UiUploadableInterface & {
  __typename?: 'UiUploadableBase';
  id: Scalars['Int']['output'];
  isMutable: Scalars['Boolean']['output'];
  showCopyOption: Scalars['Boolean']['output'];
  showDeleteOption: Scalars['Boolean']['output'];
  showDownloadOption: Scalars['Boolean']['output'];
  showEditOption: Scalars['Boolean']['output'];
  showMoveOption: Scalars['Boolean']['output'];
};

export type UiUploadableFolderBase = UiUploadableFolderInterface & {
  __typename?: 'UiUploadableFolderBase';
  id: Scalars['Int']['output'];
  isMutable: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
};

/** Uploadable Folder UI precalculated settings */
export type UiUploadableFolderInterface = {
  id: Scalars['Int']['output'];
  isMutable: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
};

export type UiUploadableFolderUploadedPhotoFolder = UiUploadableFolderInterface & {
  __typename?: 'UiUploadableFolderUploadedPhotoFolder';
  id: Scalars['Int']['output'];
  isMutable: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
};

/** Uploadable UI precalculated settings */
export type UiUploadableInterface = {
  id: Scalars['Int']['output'];
  isMutable: Scalars['Boolean']['output'];
  showCopyOption: Scalars['Boolean']['output'];
  showDeleteOption: Scalars['Boolean']['output'];
  showDownloadOption: Scalars['Boolean']['output'];
  showEditOption: Scalars['Boolean']['output'];
  showMoveOption: Scalars['Boolean']['output'];
};

export type UiUploadableUploadedPhoto = UiUploadableInterface & {
  __typename?: 'UiUploadableUploadedPhoto';
  id: Scalars['Int']['output'];
  isMutable: Scalars['Boolean']['output'];
  showCopyOption: Scalars['Boolean']['output'];
  showDeleteOption: Scalars['Boolean']['output'];
  showDownloadOption: Scalars['Boolean']['output'];
  showEditOption: Scalars['Boolean']['output'];
  showMoveOption: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UnsubscribeUsersFromAllMarketing */
export type UnsubscribeUsersFromAllMarketingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userIds: Array<Scalars['Int']['input']>;
};

export type UnsubscribeUsersFromAllMarketingResponse = {
  __typename?: 'UnsubscribeUsersFromAllMarketingResponse';
  followerIds: Array<Scalars['Int']['output']>;
};

/** Autogenerated input type of UpdateAiMarketingContent */
export type UpdateAiMarketingContentInput = {
  aiMarketingContentId: Scalars['Int']['input'];
  aiMarketingContentInput: AiMarketingContentInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateAiMarketingDefaultType */
export type UpdateAiMarketingDefaultTypeInput = {
  aiMarketingDefaultOptionId: Scalars['Int']['input'];
  aiMarketingDefaultOptionInput: AiMarketingDefaultOptionInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  processAutoApproveChange?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of UpdateAiReviewResponseDefaultSetting */
export type UpdateAiReviewResponseDefaultSettingInput = {
  aiReviewResponseDefaultSettingInput: AiReviewResponseDefaultSettingInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdateAimPromptConfig */
export type UpdateAimPromptConfigInput = {
  aimPromptConfigId: Scalars['Int']['input'];
  aimPromptConfigInput: AimPromptConfigUpdateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateAlohaAccount */
export type UpdateAlohaAccountInput = {
  alohaAccountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantIds: Array<Scalars['Int']['input']>;
};

/** Autogenerated input type of UpdateAuthorizeAccount */
export type UpdateAuthorizeAccountInput = {
  authorizeAccountId?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdateBillingEntitlementFeatureFlag */
export type UpdateBillingEntitlementFeatureFlagInput = {
  billingEntitlementFeatureFlagId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  featureManagementInput: BillingEntitlementFeatureFlagInput;
};

/** Autogenerated input type of UpdateBillingProduct */
export type UpdateBillingProductInput = {
  billingProductId: Scalars['Int']['input'];
  billingProductInput: BillingProductInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateBillingProductPrice */
export type UpdateBillingProductPriceInput = {
  billingProductPriceId: Scalars['Int']['input'];
  billingProductPriceInput: BillingProductPriceInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateCampaignItemSchedule */
export type UpdateCampaignItemScheduleInput = {
  campaignItemId: Scalars['Int']['input'];
  campaignItemInput: CampaignItemInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateCloverAccount */
export type UpdateCloverAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cloverAccountId: Scalars['Int']['input'];
  input: CloverAccountInput;
};

export type UpdateContentInput = {
  messageGroupInput?: InputMaybe<MessageGroupInput>;
  socialPostInput?: InputMaybe<SocialPostInput>;
  textMessageGroupInput?: InputMaybe<TextMessageGroupInput>;
};

/** Autogenerated input type of UpdateCustomTaxRate */
export type UpdateCustomTaxRateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customTaxRateId: Scalars['Int']['input'];
  input: CustomTaxRateInput;
};

/** Autogenerated input type of UpdateEverywareAccount */
export type UpdateEverywareAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  everywareAccountId?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdateFacebookCampaign */
export type UpdateFacebookCampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facebookCampaignId: Scalars['Int']['input'];
  facebookCampaignInput: FacebookCampaignInput;
};

/** Autogenerated input type of UpdateFeedback */
export type UpdateFeedbackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  feedbackInput: FeedbackInput;
  locationId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdateFollower */
export type UpdateFollowerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  favoriteLocationId?: InputMaybe<Scalars['Int']['input']>;
  followerId: Scalars['Int']['input'];
  userInput: FollowerUserInput;
};

/** Autogenerated input type of UpdateFollowerSegment */
export type UpdateFollowerSegmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  followerSegmentId: Scalars['Int']['input'];
  followerSegmentInput: RestaurantFollowerSegmentInput;
};

/** Autogenerated input type of UpdateHighlightPositions */
export type UpdateHighlightPositionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  highlightInputs: Array<PositionInput>;
  highlightReelId: Scalars['ID']['input'];
};

/** Autogenerated input type of UpdateItemModifierPositions */
export type UpdateItemModifierPositionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuItemModifierGroupId: Scalars['Int']['input'];
  modifierInputs: Array<MenuItemModifierInput>;
};

/** Autogenerated input type of UpdateLocationToastAlternativePaymentType */
export type UpdateLocationToastAlternativePaymentTypeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  toastAlternativePaymentTypeInput: ToastAlternativePaymentTypeInput;
};

/** Autogenerated input type of UpdateLocationToastDiningOptions */
export type UpdateLocationToastDiningOptionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  toastDiningOptionsInput: ToastDiningOptionsInput;
};

/** Autogenerated input type of UpdateLocationToastRevenueCenters */
export type UpdateLocationToastRevenueCentersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  toastRevenueCentersInput: ToastRevenueCentersInput;
};

/** Autogenerated input type of UpdateLocationVisibility */
export type UpdateLocationVisibilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationNames: Array<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdateMenuItemCartViewedAt */
export type UpdateMenuItemCartViewedAtInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuItemCartId: Scalars['Int']['input'];
  viewedAt: Scalars['DateTime']['input'];
};

/** Autogenerated input type of UpdateMenuItemModGroupsPositions */
export type UpdateMenuItemModGroupsPositionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuItemId: Scalars['Int']['input'];
  modifierGroupInputs: Array<MenuItemModifierGroupInput>;
};

/** Autogenerated input type of UpdateMenuItemModifierGroupModifier */
export type UpdateMenuItemModifierGroupModifierInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modifierGroupId: Scalars['Int']['input'];
  modifierGroupInput: MenuItemModifierGroupInput;
};

/** Autogenerated input type of UpdateMessageCampaignCreateAndAttachOrderingOffer */
export type UpdateMessageCampaignCreateAndAttachOrderingOfferInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageCampaignId: Scalars['Int']['input'];
  messageCampaignInput: MessageCampaignInput;
  orderingOfferInput: OrderingOfferInput;
  restaurantId: Scalars['Int']['input'];
};

export type UpdateMessageCampaignReturn = {
  __typename?: 'UpdateMessageCampaignReturn';
  messageCampaign: MessageCampaign;
};

/** Autogenerated input type of UpdateMessageGroupContent */
export type UpdateMessageGroupContentInput = {
  builderContentInput: BuilderContentInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageGroupContentId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdateMessageGroup */
export type UpdateMessageGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageGroupId: Scalars['Int']['input'];
  messageGroupInput?: InputMaybe<MessageGroupInput>;
  messageGroupPartialInput?: InputMaybe<MessageGroupPartialInput>;
};

/** Autogenerated input type of UpdateMicrosOrg */
export type UpdateMicrosOrgInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  microsOrgId: Scalars['Int']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  restaurantIds: Array<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateModifierGroup */
export type UpdateModifierGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modifierGroupId: Scalars['Int']['input'];
  modifierGroupInput: ModifierGroupInput;
};

/** Autogenerated input type of UpdateModularSignUpProgress */
export type UpdateModularSignUpProgressInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: ModularSignUpUpdateProgressInput;
};

/** Autogenerated input type of UpdateNcrPaymentAccount */
export type UpdateNcrPaymentAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ncrPaymentAccountId: Scalars['Int']['input'];
  ncrPaymentAccountInput: NcrPaymentAccountUpdateInput;
};

/** Autogenerated input type of UpdateNmiAccount */
export type UpdateNmiAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  nmiAccountId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdateOrderingBlackout */
export type UpdateOrderingBlackoutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderingBlackoutId: Scalars['Int']['input'];
  orderingBlackoutInput: OrderingBlackoutUpdateInput;
};

/** Autogenerated input type of UpdateOrderingEvent */
export type UpdateOrderingEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: OrderingEventInput;
  orderingEventId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdateOrderingEventSelectedMenu */
export type UpdateOrderingEventSelectedMenuInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: OrderingEventSelectedMenuInput;
  orderingEventId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdateOrderingOffer */
export type UpdateOrderingOfferInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderingOfferId: Scalars['Int']['input'];
  orderingOfferInput: OrderingOfferInput;
};

/** Autogenerated input type of UpdatePopmenuLoyaltyProgramRule */
export type UpdatePopmenuLoyaltyProgramRuleInput = {
  amount: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  points: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdatePushMessageGroup */
export type UpdatePushMessageGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  pushMessageGroupId: Scalars['Int']['input'];
  pushMessageGroupInput: PushMessageGroupInput;
};

/** Autogenerated input type of UpdatePushNotificationClickedAt */
export type UpdatePushNotificationClickedAtInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  pushSlug: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdateReservationBlackouts */
export type UpdateReservationBlackoutsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  reservationBlackouts: Array<ReservationBlackoutInput>;
};

/** Autogenerated input type of UpdateRestaurantConsentManagerConfig */
export type UpdateRestaurantConsentManagerConfigInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  configInput: ConsentManagerConfigInput;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdateRestaurantCustomScript */
export type UpdateRestaurantCustomScriptInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customScriptId: Scalars['Int']['input'];
  customScriptInput: RestaurantCustomScriptInput;
};

/** Autogenerated input type of UpdateRestaurantCustomTracking */
export type UpdateRestaurantCustomTrackingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customTrackingId: Scalars['Int']['input'];
  customTrackingInput: RestaurantCustomTrackingInput;
};

/** Autogenerated input type of UpdateRestaurantDefaultFulfillmentType */
export type UpdateRestaurantDefaultFulfillmentTypeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  defaultFulfillmentTypeInput: RestaurantDefaultFulfillmentTypeInput;
  restaurantSlug: Scalars['String']['input'];
};

/** Autogenerated input type of UpdateRestaurantGroup */
export type UpdateRestaurantGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  restaurantGroupId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdateRestaurantLegalDocument */
export type UpdateRestaurantLegalDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
  popmenuEmployeeName?: InputMaybe<Scalars['String']['input']>;
  representativeName?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
  source: Scalars['String']['input'];
};

/** Autogenerated input type of UpdateRestaurantLocationAlohaSiteSetting */
export type UpdateRestaurantLocationAlohaSiteSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  siteSettingInput: AlohaSiteSettingInput;
};

/** Autogenerated input type of UpdateRestaurantLocationMicrosSetting */
export type UpdateRestaurantLocationMicrosSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  microsSettingInput: MicrosSettingInput;
};

/** Autogenerated input type of UpdateRestaurantMemberDismissEngagementOffersBanner */
export type UpdateRestaurantMemberDismissEngagementOffersBannerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdateRestaurantMemberDismissEngagementOffers */
export type UpdateRestaurantMemberDismissEngagementOffersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdateRestaurantMemberDismissReviewBanner */
export type UpdateRestaurantMemberDismissReviewBannerInput = {
  /** Type of banner to dismiss (ai_auto_response, ai_review_response_upsell, yext_upsell) */
  bannerType: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdateRestaurantMemberLocationOrderNotifications */
export type UpdateRestaurantMemberLocationOrderNotificationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['Int']['input'];
  memberLocationInput: RestaurantMemberLocationNotificationOptionsInputType;
};

/** Autogenerated input type of UpdateRestaurantMessagePack */
export type UpdateRestaurantMessagePackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  restaurantId: Scalars['Int']['input'];
  rootMessagePackId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdateRestaurantOrderingMobileBrandColor */
export type UpdateRestaurantOrderingMobileBrandColorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderingLogoBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  orderingMobileBrandColor?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdateRestaurantScriptSettings */
export type UpdateRestaurantScriptSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
  scriptSettingsInput: RestaurantScriptSettingsInput;
};

/** Autogenerated input type of UpdateRestaurantSproutSocialGroup */
export type UpdateRestaurantSproutSocialGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['Int']['input'];
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdateRestaurantUserSetting */
export type UpdateRestaurantUserSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: RestaurantUserSettingInput;
  restaurantId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdateRestaurantVipSettings */
export type UpdateRestaurantVipSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
  signUpSettingInput: RestaurantVipSignUpSettingInput;
  vipSettingsInput: RestaurantVipSettingsInput;
};

export type UpdateRoleMemberInput = {
  userSelectedRole: Scalars['String']['input'];
};

/** Autogenerated input type of UpdateRootMessagePackCommunication */
export type UpdateRootMessagePackCommunicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  communicationId: Scalars['Int']['input'];
  communicationInput: RootMessagePackCommunicationInput;
};

/** Autogenerated input type of UpdateRootMessagePack */
export type UpdateRootMessagePackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messagePackInput: RootMessagePackInput;
  rootMessagePackId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdateRootMessagePackMessage */
export type UpdateRootMessagePackMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['ID']['input'];
  messageInput: RootMessagePackMessageInput;
  restaurantId: Scalars['Int']['input'];
  rootMessagePackId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdateRootMessagePackSocialPost */
export type UpdateRootMessagePackSocialPostInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
  rootMessagePackId: Scalars['Int']['input'];
  socialPostId: Scalars['Int']['input'];
  socialPostInput: RootMessagePackSocialPostInput;
};

/** Autogenerated input type of UpdateRootTaskAction */
export type UpdateRootTaskActionInput = {
  actionInput: RootTaskActionInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdateSelectedLocation */
export type UpdateSelectedLocationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  selectedLocationId: Scalars['Int']['input'];
  selectedLocationInput: MessageCampaignSelectedLocationInput;
};

/** Autogenerated input type of UpdateSocialPost */
export type UpdateSocialPostInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  socialPostId: Scalars['Int']['input'];
  socialPostInput: SocialPostInput;
};

/** Autogenerated input type of UpdateSpotonSetting */
export type UpdateSpotonSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  spotonSettingInput: SpotonSettingInput;
};

/** Autogenerated input type of UpdateSquareMenuSectionsAvailability */
export type UpdateSquareMenuSectionsAvailabilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuId: Scalars['Int']['input'];
  menuSectionsInput: Array<MenuSectionInput>;
};

/** Autogenerated input type of UpdateStatusCampaignItem */
export type UpdateStatusCampaignItemInput = {
  campaignItemId: Scalars['Int']['input'];
  campaignItemInput: CampaignItemInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateTextMessageGroup */
export type UpdateTextMessageGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  textMessageGroupId: Scalars['Int']['input'];
  textMessageGroupInput: TextMessageGroupInput;
};

/** Autogenerated input type of UpdateTicketCart */
export type UpdateTicketCartInput = {
  calendarEventId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ticketSelections: Array<CalendarEventTicketSelectionInput>;
};

/** Autogenerated input type of UpdateToastRestaurantServiceCharges */
export type UpdateToastRestaurantServiceChargesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliveryServiceChargeId?: InputMaybe<Scalars['Int']['input']>;
  pickupServiceChargeId?: InputMaybe<Scalars['Int']['input']>;
  toastRestaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdateTwilioPhoneCallIsRead */
export type UpdateTwilioPhoneCallIsReadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  twilioPhoneCallId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdateUnreadFeedback */
export type UpdateUnreadFeedbackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationIds: Array<Scalars['Int']['input']>;
};

/** Autogenerated input type of UpdateUploadFolder */
export type UpdateUploadFolderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  uploadType: Scalars['String']['input'];
};

/** Autogenerated input type of UpdateUpsellCampaign */
export type UpdateUpsellCampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  upsellCampaignId: Scalars['Int']['input'];
  upsellCampaignInput: UpsellCampaignInput;
};

/** Autogenerated input type of UpdateUserFeatureIntroduction */
export type UpdateUserFeatureIntroductionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  featureIntroductionInput: UserFeatureIntroductionInput;
  restaurantId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpdateYextAccount */
export type UpdateYextAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

export type UploadFolderPaginationHandler = {
  __typename?: 'UploadFolderPaginationHandler';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  offset: Scalars['Int']['output'];
  records: Array<UploadableFolder>;
};

export type UploadPaginationHandler = {
  __typename?: 'UploadPaginationHandler';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  offset: Scalars['Int']['output'];
  records: Array<Uploadable>;
};

/** Autogenerated input type of UploadPhotoTypes */
export type UploadPhotoTypesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  photosInput: Array<UploadedPhotoInput>;
};

/** Autogenerated input type of UploadPhotosAimAvailableType */
export type UploadPhotosAimAvailableTypeInput = {
  aimAvailable: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['Int']['input']>;
};

/** All the various upload types */
export type Uploadable = {
  bytes: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  format: Scalars['String']['output'];
  fullUrl?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  originalFilename: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  publicId?: Maybe<Scalars['String']['output']>;
  rawUrl?: Maybe<Scalars['String']['output']>;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  uiUploadable: UiUploadableInterface;
  updatedAt: Scalars['DateTime']['output'];
  uploaded?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

/** All the various upload folder types */
export type UploadableFolder = {
  aimPhotosCount: Scalars['Int']['output'];
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedById?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  folderItemsCount: Scalars['Int']['output'];
  folders: UploadFolderPaginationHandler;
  id: Scalars['Int']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentFolderId?: Maybe<Scalars['Int']['output']>;
  position: Scalars['Int']['output'];
  restaurant: Restaurant;
  uiUploadableFolder: UiUploadableFolderInterface;
  updatedAt: Scalars['DateTime']['output'];
  uploads: UploadPaginationHandler;
};


/** All the various upload folder types */
export type UploadableFolderAimPhotosCountArgs = {
  isArchived: Scalars['Boolean']['input'];
};


/** All the various upload folder types */
export type UploadableFolderFolderItemsCountArgs = {
  isArchived: Scalars['Boolean']['input'];
};


/** All the various upload folder types */
export type UploadableFolderFoldersArgs = {
  isArchived: Scalars['Boolean']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


/** All the various upload folder types */
export type UploadableFolderUploadsArgs = {
  isArchived: Scalars['Boolean']['input'];
  pagination?: InputMaybe<PaginationInput>;
};

export type UploadedAvatar = Uploadable & {
  __typename?: 'UploadedAvatar';
  bytes: Scalars['Int']['output'];
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  format: Scalars['String']['output'];
  fullUrl?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  originalFilename: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  publicId?: Maybe<Scalars['String']['output']>;
  rawUrl?: Maybe<Scalars['String']['output']>;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  uiUploadable: UiUploadableInterface;
  updatedAt: Scalars['DateTime']['output'];
  uploaded?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadedFile = Uploadable & {
  __typename?: 'UploadedFile';
  bytes: Scalars['Int']['output'];
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  format: Scalars['String']['output'];
  fullUrl?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  originalFilename: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  publicId?: Maybe<Scalars['String']['output']>;
  rawUrl?: Maybe<Scalars['String']['output']>;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  uiUploadable: UiUploadableInterface;
  updatedAt: Scalars['DateTime']['output'];
  uploaded?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadedFont = Uploadable & {
  __typename?: 'UploadedFont';
  bytes: Scalars['Int']['output'];
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  format: Scalars['String']['output'];
  fullUrl?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  originalFilename: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  publicId?: Maybe<Scalars['String']['output']>;
  rawUrl?: Maybe<Scalars['String']['output']>;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  uiUploadable: UiUploadableInterface;
  updatedAt: Scalars['DateTime']['output'];
  uploaded?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadedImport = Uploadable & {
  __typename?: 'UploadedImport';
  bytes: Scalars['Int']['output'];
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  format: Scalars['String']['output'];
  fullUrl?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  originalFilename: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  publicId?: Maybe<Scalars['String']['output']>;
  rawUrl?: Maybe<Scalars['String']['output']>;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  uiUploadable: UiUploadableInterface;
  updatedAt: Scalars['DateTime']['output'];
  uploaded?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadedPhoto = Uploadable & {
  __typename?: 'UploadedPhoto';
  aimAvailable: Scalars['Boolean']['output'];
  altText?: Maybe<Scalars['String']['output']>;
  bytes: Scalars['Int']['output'];
  category?: Maybe<Scalars['String']['output']>;
  consumerLocale?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  defaultType?: Maybe<Scalars['String']['output']>;
  folder?: Maybe<UploadedPhotoFolder>;
  folderPath?: Maybe<Scalars['String']['output']>;
  format: Scalars['String']['output'];
  fullUrl: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isOloMenu: Scalars['Boolean']['output'];
  isPosSynced: Scalars['Boolean']['output'];
  mailerUrl: Scalars['String']['output'];
  menuCategoryName?: Maybe<Scalars['String']['output']>;
  onboardingInfo?: Maybe<RestaurantOnboardingInfo>;
  onboardingStatus?: Maybe<Scalars['String']['output']>;
  originalFilename: Scalars['String']['output'];
  previewUrl: Scalars['String']['output'];
  publicId?: Maybe<Scalars['String']['output']>;
  rawUrl: Scalars['String']['output'];
  restaurant?: Maybe<Restaurant>;
  restaurantId?: Maybe<Scalars['Int']['output']>;
  shareUrl: Scalars['String']['output'];
  thumbnailUrl: Scalars['String']['output'];
  tinyUrl: Scalars['String']['output'];
  uiUploadable: UiUploadableInterface;
  updatedAt: Scalars['DateTime']['output'];
  uploaded?: Maybe<Scalars['Boolean']['output']>;
  uploadedFolderId?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadedPhotoFolder = UploadableFolder & {
  __typename?: 'UploadedPhotoFolder';
  aimPhotosCount: Scalars['Int']['output'];
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedById?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  folderItemsCount: Scalars['Int']['output'];
  folders: UploadFolderPaginationHandler;
  id: Scalars['Int']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentFolderId?: Maybe<Scalars['Int']['output']>;
  position: Scalars['Int']['output'];
  restaurant: Restaurant;
  uiUploadableFolder: UiUploadableFolderInterface;
  updatedAt: Scalars['DateTime']['output'];
  uploads: UploadPaginationHandler;
};


export type UploadedPhotoFolderAimPhotosCountArgs = {
  isArchived: Scalars['Boolean']['input'];
};


export type UploadedPhotoFolderFolderItemsCountArgs = {
  isArchived: Scalars['Boolean']['input'];
};


export type UploadedPhotoFolderFoldersArgs = {
  isArchived: Scalars['Boolean']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type UploadedPhotoFolderUploadsArgs = {
  isArchived: Scalars['Boolean']['input'];
  pagination?: InputMaybe<PaginationInput>;
};

export type UploadedPhotoInput = {
  aimAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  altText?: InputMaybe<Scalars['String']['input']>;
  bytes?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  consumerLocale?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  defaultType?: InputMaybe<Scalars['String']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  originalFilename?: InputMaybe<Scalars['String']['input']>;
  previewTime?: InputMaybe<Scalars['Int']['input']>;
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
  s3Key?: InputMaybe<Scalars['String']['input']>;
  uploadedFolderId?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadedVideo = Uploadable & {
  __typename?: 'UploadedVideo';
  baseThumbnailUrl?: Maybe<Scalars['String']['output']>;
  bytes: Scalars['Int']['output'];
  cloudflareId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  format: Scalars['String']['output'];
  fullUrl: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  originalFilename: Scalars['String']['output'];
  previewTime?: Maybe<Scalars['Int']['output']>;
  previewUrl: Scalars['String']['output'];
  publicId?: Maybe<Scalars['String']['output']>;
  rawUrl: Scalars['String']['output'];
  restaurantId?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl: Scalars['String']['output'];
  uiUploadable: UiUploadableInterface;
  updatedAt: Scalars['DateTime']['output'];
  uploaded?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type UpsellCampaign = {
  __typename?: 'UpsellCampaign';
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  restaurantId: Scalars['Int']['output'];
  selectedDishes: Array<Dish>;
  selectedLocations: Array<RestaurantLocation>;
};

export type UpsellCampaignEligibleDishPaginationHandler = {
  __typename?: 'UpsellCampaignEligibleDishPaginationHandler';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  offset: Scalars['Int']['output'];
  records: Array<Dish>;
};

export type UpsellCampaignInput = {
  dishIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpsertDiscoveryNcrRestaurant */
export type UpsertDiscoveryNcrRestaurantInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantDetailsInput: SalesforcePopTriggerInput;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpsertNotificationDevice */
export type UpsertNotificationDeviceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  granted: Scalars['Boolean']['input'];
  notificationDeviceId?: InputMaybe<Scalars['Int']['input']>;
  platform: Scalars['String']['input'];
  pushToken: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpsertRestaurantMemberClientProfileType */
export type UpsertRestaurantMemberClientProfileTypeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: RestaurantMemberClientProfileInput;
  memberId: Scalars['Int']['input'];
};

/** Autogenerated input type of UpsertRestaurantMobileAppAsset */
export type UpsertRestaurantMobileAppAssetInput = {
  assetType: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Base64-encoded file content */
  fileData: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
};

export type User = Eventable & {
  __typename?: 'User';
  adminLocale: Scalars['String']['output'];
  adminPaletteType?: Maybe<Scalars['String']['output']>;
  adminPasswordResetUrl?: Maybe<Scalars['String']['output']>;
  adminRestaurants: Array<Restaurant>;
  authyId?: Maybe<Scalars['String']['output']>;
  authyStatus?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  birthDay?: Maybe<Scalars['Int']['output']>;
  birthMonth?: Maybe<Scalars['Int']['output']>;
  calendarEventPops?: Maybe<Array<CalendarEventPop>>;
  consumerPasswordResetUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentSignInAt?: Maybe<Scalars['DateTime']['output']>;
  directUser?: Maybe<Scalars['Boolean']['output']>;
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  emailUnsubscribedRestaurants: Array<Restaurant>;
  eventableName: Scalars['String']['output'];
  featureIntroductions: Array<UserFeatureIntroduction>;
  firstName?: Maybe<Scalars['String']['output']>;
  followers: Array<Follower>;
  followersCount?: Maybe<Scalars['Int']['output']>;
  friendlyEmail?: Maybe<Scalars['String']['output']>;
  fullDisplayName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  guardedDisplayName?: Maybe<Scalars['String']['output']>;
  hasAcceptedClientTerms: Scalars['Boolean']['output'];
  hasAccessCode?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousOrders?: Maybe<Scalars['Boolean']['output']>;
  hasUnverifiedPhoneFactor: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  identities: Array<UserIdentity>;
  intercomHash?: Maybe<Scalars['String']['output']>;
  intercomRole: Scalars['String']['output'];
  isAuthyRequired: Scalars['Boolean']['output'];
  isMfaRequired: Scalars['Boolean']['output'];
  isMobilePhone?: Maybe<Scalars['Boolean']['output']>;
  isPendingDestroy?: Maybe<Scalars['Boolean']['output']>;
  isPendingPassword?: Maybe<Scalars['Boolean']['output']>;
  isPersonalInformationUpdateRequired: Scalars['Boolean']['output'];
  isRoot: Scalars['Boolean']['output'];
  isRootOpentable: Scalars['Boolean']['output'];
  isRootStaging: Scalars['Boolean']['output'];
  isSmsUnsubscribed?: Maybe<Scalars['Boolean']['output']>;
  isTextValidated: Scalars['Boolean']['output'];
  isUnsubscribed?: Maybe<Scalars['Boolean']['output']>;
  lastFourDigitsPhoneNumber?: Maybe<Scalars['String']['output']>;
  lastLaunchNotesReleaseId?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastSignInIpAddress?: Maybe<Scalars['String']['output']>;
  lastSignInUserAgent?: Maybe<Scalars['String']['output']>;
  lastVisitAt?: Maybe<Scalars['DateTime']['output']>;
  loyaltyAccount?: Maybe<LoyaltyProgramAccount>;
  memberLocations: Array<RestaurantMemberLocation>;
  memberRestaurants: Array<Restaurant>;
  members: Array<RestaurantMember>;
  menuItemCarts: Array<MenuItemCart>;
  mfaFactors: Array<TwilioVerifyMfaFactor>;
  mypopTrialEligibility: Scalars['String']['output'];
  name: Scalars['String']['output'];
  optInInformationalTexts: Scalars['Boolean']['output'];
  optInPromotionalTexts: Scalars['Boolean']['output'];
  orderAudioType?: Maybe<Scalars['String']['output']>;
  orderingOfferCodes?: Maybe<Array<OrderingOfferCode>>;
  pendingEmail?: Maybe<Scalars['String']['output']>;
  pendingInvites: Array<RestaurantMemberInvite>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneSignUp?: Maybe<Scalars['Boolean']['output']>;
  policy: UserPolicy;
  pops: Array<Pop>;
  previousSelectedMenuItems?: Maybe<Array<MenuItemCartSelectedMenuItem>>;
  resetPasswordRestaurantId?: Maybe<Scalars['Int']['output']>;
  reviewUpvotes: Array<ReviewUpvote>;
  reviews: Array<Review>;
  sfdcContactId?: Maybe<Scalars['String']['output']>;
  textValidatedAt?: Maybe<Scalars['DateTime']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  twilioVerifyEntitySid?: Maybe<Scalars['String']['output']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']['output']>;
  userGiftCards?: Maybe<Array<GiftCard>>;
  userReorderHasMoreItems?: Maybe<Scalars['Boolean']['output']>;
  userRole?: Maybe<Scalars['String']['output']>;
  weddingDay?: Maybe<Scalars['Int']['output']>;
  weddingMonth?: Maybe<Scalars['Int']['output']>;
};


export type UserAdminRestaurantsArgs = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type UserDirectUserArgs = {
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
};


export type UserHasPreviousOrdersArgs = {
  cartType: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type UserLoyaltyAccountArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type UserOrderingOfferCodesArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type UserPreviousSelectedMenuItemsArgs = {
  cartType: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
};


export type UserUserGiftCardsArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type UserUserReorderHasMoreItemsArgs = {
  cartType: Scalars['String']['input'];
  restaurantId: Scalars['Int']['input'];
};

export type UserApiToken = {
  __typename?: 'UserApiToken';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  graphiqlUrl: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  popmenuToken: Scalars['String']['output'];
  userDisplayName: Scalars['String']['output'];
};

export type UserApiTokenInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserAvatar = {
  __typename?: 'UserAvatar';
  avatarUrl: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type UserByUnsubscribeTokenReturn = {
  __typename?: 'UserByUnsubscribeTokenReturn';
  id?: Maybe<Scalars['Int']['output']>;
  recipientRemoved: Scalars['Boolean']['output'];
  restaurantId?: Maybe<Scalars['Int']['output']>;
  restaurantName?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type UserDevice = {
  __typename?: 'UserDevice';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deregisteredAt?: Maybe<Scalars['DateTime']['output']>;
  deviceInfo?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  pushToken?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserFeatureIntroduction = {
  __typename?: 'UserFeatureIntroduction';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isAccessibilityFooterIconIntroduced: Scalars['Boolean']['output'];
  isAiAnsweringIntroduced: Scalars['Boolean']['output'];
  isAiMarketingCalendarIntroduced: Scalars['Boolean']['output'];
  isAiMarketingCalendarPerLocationIntroduced: Scalars['Boolean']['output'];
  isAiMarketingLiteIntroduced: Scalars['Boolean']['output'];
  isAiReviewResponseIntroduced: Scalars['Boolean']['output'];
  isApplePayIntroduced: Scalars['Boolean']['output'];
  isAutoRevShareCustomFeesCreationIntroduced: Scalars['Boolean']['output'];
  isBoostAiMarketingCalendarIntroduced: Scalars['Boolean']['output'];
  isChargebeePortalIntroduced: Scalars['Boolean']['output'];
  isClientProfileIntroduced: Scalars['Boolean']['output'];
  isConsumerMobileAppIntroduced: Scalars['Boolean']['output'];
  isCreditCardSurchargeIntroduced: Scalars['Boolean']['output'];
  isCspHeaderIntroduced: Scalars['Boolean']['output'];
  isCurbsideIntroduced: Scalars['Boolean']['output'];
  isCustomCssIntroduced: Scalars['Boolean']['output'];
  isDeveloperApiIntroduced: Scalars['Boolean']['output'];
  isDishCustomHtmlIntroduced: Scalars['Boolean']['output'];
  isDraftsUndoIntroduced: Scalars['Boolean']['output'];
  isEatAppIntroduced: Scalars['Boolean']['output'];
  isEmailOptInIntroduced: Scalars['Boolean']['output'];
  isEnablingDraftsIntroduced: Scalars['Boolean']['output'];
  isFacebookCampaignsIntroduced: Scalars['Boolean']['output'];
  isFeedbackIntroduced: Scalars['Boolean']['output'];
  isFollowerImportIntroduced: Scalars['Boolean']['output'];
  isForceSyncMenusIntroduced: Scalars['Boolean']['output'];
  isGiftCardPurchasingIntroduced: Scalars['Boolean']['output'];
  isGiftCardsIntroduced: Scalars['Boolean']['output'];
  isGlobalGoogleAnalyticsIntroduced: Scalars['Boolean']['output'];
  isInstagramFeedIntroduced: Scalars['Boolean']['output'];
  isInstagramIntroduced: Scalars['Boolean']['output'];
  isItemCardV2Introduced: Scalars['Boolean']['output'];
  isLoyaltyIntroduced: Scalars['Boolean']['output'];
  isMainNavPanelIntroduced: Scalars['Boolean']['output'];
  isMarketingCalendarIntroduced: Scalars['Boolean']['output'];
  isMassMessagesSegmentationIntroduced: Scalars['Boolean']['output'];
  isMediaLibraryIntroduced: Scalars['Boolean']['output'];
  isMenuSyncUiIntroduced: Scalars['Boolean']['output'];
  isMessageDetailsOverviewIntroduced: Scalars['Boolean']['output'];
  isMessageGroupAutosaveIntroduced: Scalars['Boolean']['output'];
  isMessagePacksIntroduced: Scalars['Boolean']['output'];
  isMfaRequiredIntroduced: Scalars['Boolean']['output'];
  isMmsMessageIntroduced: Scalars['Boolean']['output'];
  isMobileOrderDetailsV2Introduced: Scalars['Boolean']['output'];
  isMultiChannelCampaignAiIntroduced: Scalars['Boolean']['output'];
  isMultiLocationOloBillingIntroduced: Scalars['Boolean']['output'];
  isNcrSilverIntroduced: Scalars['Boolean']['output'];
  isNestedModifiersIntroduced: Scalars['Boolean']['output'];
  isOpenTableIntegrationIntroduced: Scalars['Boolean']['output'];
  isOrderingBillingConfigValidationIntroduced: Scalars['Boolean']['output'];
  isOrderingCateringIntroduced: Scalars['Boolean']['output'];
  isOrderingDeliveryIntroduced: Scalars['Boolean']['output'];
  isOrderingDineInIntroduced: Scalars['Boolean']['output'];
  isOrderingDoorDashIntroduced: Scalars['Boolean']['output'];
  isOrderingEventsIntroduced: Scalars['Boolean']['output'];
  isOrderingIntroduced: Scalars['Boolean']['output'];
  isOrderingPaymentIntroduced: Scalars['Boolean']['output'];
  isOrderingRefundsIntroduced: Scalars['Boolean']['output'];
  isOrdernerdIntroduced: Scalars['Boolean']['output'];
  isOtterV2Introduced: Scalars['Boolean']['output'];
  isPopmenuLoyaltyIntroduced: Scalars['Boolean']['output'];
  isPrintCenterIntroduced: Scalars['Boolean']['output'];
  isProfileV2Introduced: Scalars['Boolean']['output'];
  isReservationsIntroduced: Scalars['Boolean']['output'];
  isRoiAlertsIntroduced: Scalars['Boolean']['output'];
  isSelfServeProductCheckoutIntroduced: Scalars['Boolean']['output'];
  isShowGlobalBillingAlertIntroduced: Scalars['Boolean']['output'];
  isShowVipPromptOnHomePageOnlyIntroduced: Scalars['Boolean']['output'];
  isSmsOptInIntroduced: Scalars['Boolean']['output'];
  isSocialPostSuggestionsIntroduced: Scalars['Boolean']['output'];
  isTextBoxExtendedToolbarIntroduced: Scalars['Boolean']['output'];
  isTextChatbotIntroduced: Scalars['Boolean']['output'];
  isTextMessageIntroduced: Scalars['Boolean']['output'];
  isTextMessagesSegmentationIntroduced: Scalars['Boolean']['output'];
  isThirdPartyLoyaltyIntroduced: Scalars['Boolean']['output'];
  isUberDirectIntroduced: Scalars['Boolean']['output'];
  isWaitlistIntroduced: Scalars['Boolean']['output'];
  isWaitlistV2Introduced: Scalars['Boolean']['output'];
  isYextReviewsIntroduced: Scalars['Boolean']['output'];
  restaurantId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type UserFeatureIntroductionInput = {
  aiMarketingCalendarStatus?: InputMaybe<Scalars['String']['input']>;
};

export type UserIdentity = {
  __typename?: 'UserIdentity';
  id: Scalars['Int']['output'];
  providerType: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type UserImpersonationAccess = {
  __typename?: 'UserImpersonationAccess';
  grantedAt?: Maybe<Scalars['DateTime']['output']>;
  grantedByUserId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  user: User;
};

export type UserInput = {
  adminLocale?: InputMaybe<Scalars['String']['input']>;
  adminPaletteType?: InputMaybe<Scalars['String']['input']>;
  anniversaryDay?: InputMaybe<Scalars['Int']['input']>;
  anniversaryMonth?: InputMaybe<Scalars['Int']['input']>;
  birthDay?: InputMaybe<Scalars['Int']['input']>;
  birthMonth?: InputMaybe<Scalars['Int']['input']>;
  createAccount?: InputMaybe<Scalars['Boolean']['input']>;
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  favoriteLocationId?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isMobilePhone?: InputMaybe<Scalars['Boolean']['input']>;
  isPersonalInformationUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  optInInformationalTexts?: InputMaybe<Scalars['Boolean']['input']>;
  optInPromotionalTexts?: InputMaybe<Scalars['Boolean']['input']>;
  orderAudioType?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  passwordConfirmation?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  restaurantId?: InputMaybe<Scalars['Int']['input']>;
  skipPendingEmail?: InputMaybe<Scalars['Boolean']['input']>;
  skipValidation?: InputMaybe<Scalars['Boolean']['input']>;
  userEntryPoint?: InputMaybe<Scalars['Int']['input']>;
  weddingDay?: InputMaybe<Scalars['Int']['input']>;
  weddingMonth?: InputMaybe<Scalars['Int']['input']>;
};

export type UserLocationsSearchResult = {
  __typename?: 'UserLocationsSearchResult';
  followerId?: Maybe<Scalars['Int']['output']>;
  lastMessageAt?: Maybe<Scalars['DateTime']['output']>;
  location?: Maybe<RestaurantLocation>;
  restaurant?: Maybe<Restaurant>;
  user: User;
};

export type UserPaginationHandler = {
  __typename?: 'UserPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<User>;
};

export type UserPolicy = {
  __typename?: 'UserPolicy';
  canAccessHungrrrPayTab: Scalars['Boolean']['output'];
  canAccessMarketingTab: Scalars['Boolean']['output'];
  canAccessMenusTab: Scalars['Boolean']['output'];
  canAccessOnboardingTab: Scalars['Boolean']['output'];
  canAccessOrderingTab: Scalars['Boolean']['output'];
  canAccessReviewsTab: Scalars['Boolean']['output'];
  canAccessSalesforceTab: Scalars['Boolean']['output'];
  canAccessSendgridTab: Scalars['Boolean']['output'];
  canAccessTwilioTab: Scalars['Boolean']['output'];
  canAccessUsersTab: Scalars['Boolean']['output'];
  canUseAddTwilioBannedWordTool: Scalars['Boolean']['output'];
  canUseCartHistoryTool: Scalars['Boolean']['output'];
  canUseClearAllOpenCartsTool: Scalars['Boolean']['output'];
  canUseClearAllUnfulfilledCartsTool: Scalars['Boolean']['output'];
  canUseConnectHungrrrPayTool: Scalars['Boolean']['output'];
  canUseConnectSalesforceAccountTool: Scalars['Boolean']['output'];
  canUseCreateDemoSiteReviewsTool: Scalars['Boolean']['output'];
  canUseCreateMenuFromWorkflowImportTool: Scalars['Boolean']['output'];
  canUseDeleteAllFollowersTool: Scalars['Boolean']['output'];
  canUseDeleteAllImportedFollowersTool: Scalars['Boolean']['output'];
  canUseDeleteDishesTool: Scalars['Boolean']['output'];
  canUseDeleteModifierGroupsTool: Scalars['Boolean']['output'];
  canUseDeleteOrphanDishesTool: Scalars['Boolean']['output'];
  canUseDeleteSelectedEmailFromBounceAndSpamListTool: Scalars['Boolean']['output'];
  canUseDeleteSharedExtraGroupsTool: Scalars['Boolean']['output'];
  canUseDeleteSquareSyncedMenusTool: Scalars['Boolean']['output'];
  canUseDestroyAiMarketingContentTool: Scalars['Boolean']['output'];
  canUseDestroyLargeMenuTool: Scalars['Boolean']['output'];
  canUseDisconnectSalesforceAccountAllLocationsTool: Scalars['Boolean']['output'];
  canUseDisconnectSalesforceAccountTool: Scalars['Boolean']['output'];
  canUseForceSignOutTool: Scalars['Boolean']['output'];
  canUseListTwilioBannedWordsTool: Scalars['Boolean']['output'];
  canUseMenuExporterTool: Scalars['Boolean']['output'];
  canUseReleaseContentAuditTool: Scalars['Boolean']['output'];
  canUseRemoveAllFollowerTagsTool: Scalars['Boolean']['output'];
  canUseResetMfaTool: Scalars['Boolean']['output'];
  canUseRootUserListTool: Scalars['Boolean']['output'];
  canUseSyncYextAccountTool: Scalars['Boolean']['output'];
  canUseSyncYextReviewsTool: Scalars['Boolean']['output'];
  canUseUndoFollowerImportTool: Scalars['Boolean']['output'];
  canUseUndoLastFollowerImportTool: Scalars['Boolean']['output'];
  canUseUnsubscribeUsersFromAllMarketingTool: Scalars['Boolean']['output'];
  canUseUserImpersonationTool: Scalars['Boolean']['output'];
  canUseUserLocationsSearchTool: Scalars['Boolean']['output'];
  createRestaurant: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  manageMobileAppAssets: Scalars['Boolean']['output'];
  showRootSystemTool: Scalars['Boolean']['output'];
  showSupportUtility: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UserResetAuthy */
export type UserResetAuthyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  userIds: Array<Scalars['Int']['input']>;
};

export type Verification = {
  __typename?: 'Verification';
  createTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  verificationMethod?: Maybe<Scalars['String']['output']>;
};

export type VerificationOptions = {
  __typename?: 'VerificationOptions';
  addressData?: Maybe<Address>;
  emailData?: Maybe<Email>;
  id: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  verificationMethod: Scalars['String']['output'];
};

export type VerificationPaginationHandler = {
  __typename?: 'VerificationPaginationHandler';
  count: Scalars['Int']['output'];
  records?: Maybe<Array<Verification>>;
};

export type VerifyLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressInput?: InputMaybe<AddressInput>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  emailInput?: InputMaybe<EmailInput>;
  locationName: Scalars['String']['input'];
  phoneInput?: InputMaybe<PhoneInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
  verificationMethod: Scalars['String']['input'];
};

/** Autogenerated input type of VerifyPhone */
export type VerifyPhoneInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

/** Autogenerated input type of VerifyTwilioVerifyPushChallenge */
export type VerifyTwilioVerifyPushChallengeInput = {
  challengeSid: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of VerifyTwilioVerifyTotp */
export type VerifyTwilioVerifyTotpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  factorSid: Scalars['String']['input'];
};

export type VersionDiff = {
  __typename?: 'VersionDiff';
  attribute: Scalars['String']['output'];
  fromValue?: Maybe<Scalars['String']['output']>;
  toValue?: Maybe<Scalars['String']['output']>;
};

export type VersionPaginationHandler = {
  __typename?: 'VersionPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<Versionable>;
};

/** All the various version types */
export type Versionable = {
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  locationMenuName?: Maybe<Scalars['String']['output']>;
  objectChanges: Array<VersionDiff>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

export type Visit = {
  __typename?: 'Visit';
  id: Scalars['Int']['output'];
  restaurantId?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
  userAvatarUrl: Scalars['String']['output'];
  userDisplayName: Scalars['String']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
  visitable?: Maybe<Eventable>;
  visitableId?: Maybe<Scalars['Int']['output']>;
  visitableName?: Maybe<Scalars['String']['output']>;
  visitableParent?: Maybe<Eventable>;
  visitableType?: Maybe<Scalars['String']['output']>;
  visitedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type VisitMetricsBoostReport = {
  __typename?: 'VisitMetricsBoostReport';
  endDate: Scalars['String']['output'];
  newVisits: Scalars['Int']['output'];
  returningVisits: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  totalVisits: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type WarningCount = {
  __typename?: 'WarningCount';
  count: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type WebhookPaginationHandler = {
  __typename?: 'WebhookPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<RestaurantWebhook>;
};

export enum WebsiteMaxWidth {
  Constrained = 'constrained',
  Full = 'full'
}

export type WebsiteMetrics = {
  __typename?: 'WebsiteMetrics';
  allSessionsCount: Scalars['Int']['output'];
  date?: Maybe<Scalars['String']['output']>;
  day: Scalars['String']['output'];
  organicSessionsCount: Scalars['Int']['output'];
  returningSessionsCount?: Maybe<Scalars['Int']['output']>;
};

export type WebsitePublishRecordPaginationHandler = {
  __typename?: 'WebsitePublishRecordPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<RestaurantWebsitePublishRecord>;
};

export type WoflowImport = {
  __typename?: 'WoflowImport';
  allMenus: Array<Menu>;
  allSources?: Maybe<Array<Scalars['String']['output']>>;
  comments?: Maybe<Scalars['Text']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hasImportMenu: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  instructions?: Maybe<Scalars['Text']['output']>;
  sources: Array<WoflowImportSource>;
  state?: Maybe<Scalars['String']['output']>;
  stateChangedAt?: Maybe<Scalars['DateTime']['output']>;
  stateMessage?: Maybe<Scalars['Text']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
  woflowJobData?: Maybe<Scalars['Text']['output']>;
  woflowJobId?: Maybe<Scalars['String']['output']>;
  woflowMenuData?: Maybe<Scalars['Text']['output']>;
  woflowMenuId?: Maybe<Scalars['String']['output']>;
};

export type WoflowImportMenu = {
  __typename?: 'WoflowImportMenu';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isQaComplete?: Maybe<Scalars['Boolean']['output']>;
  menuId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  woflowImportId: Scalars['Int']['output'];
};

export type WoflowImportPaginationHandler = {
  __typename?: 'WoflowImportPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<WoflowImport>;
};

export type WoflowImportSource = {
  __typename?: 'WoflowImportSource';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  file?: Maybe<CustomFile>;
  id: Scalars['Int']['output'];
  isOloMenu?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<RestaurantOnboardingInfoLink>;
  photo?: Maybe<UploadedPhoto>;
  url?: Maybe<Scalars['String']['output']>;
};

export type YextAccount = {
  __typename?: 'YextAccount';
  id: Scalars['Int']['output'];
  restaurantId: Scalars['Int']['output'];
  reviewsLastSyncedAt: Scalars['DateTime']['output'];
  yextAccountId: Scalars['String']['output'];
  yextSsoAccountId: Scalars['String']['output'];
};

/** Autogenerated input type of YextAccountSyncReviews */
export type YextAccountSyncReviewsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

/** Autogenerated input type of YextAccountSyncSandboxLocations */
export type YextAccountSyncSandboxLocationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['Int']['input'];
};

export type YextCategory = {
  __typename?: 'YextCategory';
  cuisineTypes?: Maybe<Array<CuisineType>>;
  fullName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  yextCategoryId: Scalars['String']['output'];
};

export type YextCategoryPaginationHandler = {
  __typename?: 'YextCategoryPaginationHandler';
  count: Scalars['Int']['output'];
  records: Array<YextCategory>;
};

export type ZohoGroup = {
  __typename?: 'ZohoGroup';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};
